(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("mobx-react"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "mobx-react", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["crm-components"] = factory(require("mobx"), require("mobx-react"), require("react"), require("react-dom"));
	else
		root["crm-components"] = factory(root["mobx"], root["mobx-react"], root["react"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__259__, __WEBPACK_EXTERNAL_MODULE__5264__, __WEBPACK_EXTERNAL_MODULE__8156__, __WEBPACK_EXTERNAL_MODULE__7111__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 1066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "fC": () => (/* binding */ AnalyticsContext),
/* harmony export */   "z$": () => (/* binding */ useAnalytics)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const AnalyticsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
const AnalyticsProvider = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const parentContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(AnalyticsContext);
    const contextValue = Object.assign(Object.assign({}, parentContext), rest);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(AnalyticsContext.Provider, { value: contextValue }, children));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AnalyticsProvider);
const useAnalytics = () => {
    const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(AnalyticsContext);
    return {
        push: (id, elementId, interactionTypeArg, trigger) => {
            if (context.onPush) {
                const event = (trigger === null || trigger === void 0 ? void 0 : trigger.event) || context.event;
                const page = (trigger === null || trigger === void 0 ? void 0 : trigger.page) || context.page;
                const group = (trigger === null || trigger === void 0 ? void 0 : trigger.group) || context.group;
                const elementType = (trigger === null || trigger === void 0 ? void 0 : trigger.elementType) || context.elementType;
                const interactionType = (trigger === null || trigger === void 0 ? void 0 : trigger.interactionType) || context.interactionType || interactionTypeArg;
                const conversion = (trigger === null || trigger === void 0 ? void 0 : trigger.conversion) || context.conversion;
                const conversionType = (trigger === null || trigger === void 0 ? void 0 : trigger.conversionType) || context.conversionType;
                if (event && page && group) {
                    context.onPush({
                        event,
                        page,
                        group,
                        id,
                        elementType,
                        elementId,
                        interactionType,
                        conversion,
                        conversionType,
                    });
                }
            }
        },
    };
};


/***/ }),

/***/ 6341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _analytics_provider_analytics_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1066);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const AnalyticsTrigger = (props) => {
    const { push } = (0,_analytics_provider_analytics_provider__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z$)();
    function enhanceItem(child) {
        if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
            const triggers = Array.isArray(props.trigger) ? props.trigger : [props.trigger];
            const propsWithTriggers = triggers.reduce((prevProps, currentTrigger) => {
                const { id, callback, elementId, interactionType } = currentTrigger, rest = __rest(currentTrigger, ["id", "callback", "elementId", "interactionType"]);
                return Object.assign(Object.assign({}, prevProps), { [callback]: (...args) => {
                        push(typeof id === 'function' ? id(args) : id, typeof elementId === 'function' ? elementId(args) : elementId, typeof interactionType === 'function' ? interactionType(args) : interactionType, rest);
                        if (child.props[callback]) {
                            child.props[callback](...args);
                        }
                    } });
            }, {});
            return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, propsWithTriggers);
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(props.children, enhanceItem)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AnalyticsTrigger);


/***/ }),

/***/ 2230:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ BadgeCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

class BadgeCore extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
    BEM() {
        const classArray = ['badge'];
        if (this.props.purpose) {
            classArray.push('badge--' + this.props.purpose);
        }
        if (this.props.size) {
            classArray.push('badge--' + this.props.size);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getIcon(icon) {
        const { Icon } = this.props.components;
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, { className: "badge__icon", modifiers: icon });
    }
    getText(text) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "badge__text" }, text);
    }
    render() {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: this.BEM(), "aria-hidden": this.props['aria-hidden'] },
            this.props.icon && this.getIcon(this.props.icon),
            this.props.text && this.getText(this.props.text)));
    }
}


/***/ }),

/***/ 1687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ButtonCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7723);
/* harmony import */ var _core_front_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9097);
/* harmony import */ var _core_front_theme_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3286);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const ButtonCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonResponsiveCore, Object.assign({}, rest, { responsive: responsive })) : react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonInnerCore, Object.assign({}, rest));
};
const ButtonResponsiveCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const { breakPoints } = (0,_core_front_theme_provider__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    const responsiveProps = (0,_core_front_helper__WEBPACK_IMPORTED_MODULE_2__/* .useResponsiveProps */ .S)({ breakPoints, responsive });
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonInnerCore, Object.assign({}, rest, responsiveProps));
};
class ButtonInnerCore extends react__WEBPACK_IMPORTED_MODULE_0__.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            if (!this.props.external && this.props.onClick) {
                this.props.onClick(event);
            }
        };
    }
    BEM() {
        const classArray = ['btn'];
        if (this.props.type) {
            classArray.push('btn--' + this.props.type);
        }
        if (this.props.size) {
            classArray.push('btn--' + this.props.size);
        }
        if (this.props.icon) {
            classArray.push('btn--icon-only');
        }
        if (this.props.variant) {
            classArray.push('btn--variant-' + this.props.variant);
        }
        if (this.props.link) {
            classArray.push('btn--link');
            if (this.props.isUnderlined) {
                classArray.push('btn--underlined');
            }
        }
        if (this.props.block) {
            classArray.push('btn--block');
        }
        if (this.props.isActive) {
            classArray.push('is-active');
        }
        if (this.props.isLoading) {
            classArray.push('is-loading');
        }
        if (this.props.verticalAlign) {
            classArray.push('btn--vertical-align-' + this.props.verticalAlign);
        }
        if (this.props.iconRight === '#arrow-right' && !this.props.link) {
            classArray.push('btn--with-arrow-right-icon');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    iconBEM(location) {
        const classArray = ['btn__icon'];
        classArray.push('btn__icon--' + location);
        if (((location === 'left' && this.props.iconLeftSize) || (location === 'right' && this.props.iconRightSize) || (location === 'center' && this.props.iconSize)) && this.props.link) {
            classArray.push('btn__icon--custom-size');
        }
        if (this.props.iconClass) {
            classArray.push(this.props.iconClass);
        }
        return classArray.join(' ');
    }
    iconWrapperBEM(location, size) {
        const classArray = ['btn__icon-wrapper', `btn__icon-wrapper--${location}`];
        if (size) {
            classArray.push(`btn__icon-wrapper--${size}`);
        }
        return classArray.join(' ');
    }
    getIcon(location, modifiers, size) {
        const { Icon } = this.props.components;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: this.iconWrapperBEM(location, size) },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, { modifiers: modifiers, size: size, className: this.iconBEM(location) })));
    }
    renderContent() {
        const { Spinner } = this.props.components;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
            this.props.isLoading &&
                (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { in: this.props.isLoading, timeout: 300, classNames: "fade", unmountOnExit: true },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spinner, { className: "btn__spinner" }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "btn__inner" },
                this.props.iconLeft && this.getIcon('left', this.props.iconLeft, this.props.iconLeftSize),
                this.props.icon && this.getIcon('center', this.props.icon, this.props.iconSize),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "btn__text" }, this.props.text),
                this.props.iconRight && this.getIcon('right', this.props.iconRight, this.props.iconRightSize))));
    }
    isAnchor(props) {
        return 'url' in props;
    }
    isSpan(props) {
        return props.element === 'span';
    }
    renderAnchor(props) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", Object.assign({}, props.attributes, { 
            // common attributes of a, span, button
            className: this.BEM(), id: props.id, ref: props.buttonRef, "aria-label": this.props.ariaLabel, "aria-expanded": this.props['aria-expanded'], "aria-controls": this.props['aria-controls'], onKeyDown: this.props.onKeyDown, 
            // common attributes of a, button
            onClick: this.handleClick, 
            // a specific attributes
            href: props.url, target: props.target }), this.renderContent()));
    }
    renderSpan(props) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({}, props.attributes, { 
            // common attributes of a, span, button
            className: this.BEM(), id: props.id, ref: props.buttonRef, "aria-label": this.props.ariaLabel, "aria-expanded": this.props['aria-expanded'], "aria-controls": this.props['aria-controls'], onKeyDown: this.props.onKeyDown }), this.renderContent()));
    }
    renderButton(props) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", Object.assign({}, props.attributes, { 
            // common attributes of a, span, button
            className: this.BEM(), id: props.id, ref: props.buttonRef, "aria-label": this.props.ariaLabel, "aria-expanded": this.props['aria-expanded'], "aria-controls": this.props['aria-controls'], onKeyDown: this.props.onKeyDown, 
            // common attributes of a, button
            onClick: this.handleClick, 
            // button specific attributes
            type: (props.attributes && props.attributes.type) || 'button', disabled: props.disabled }), this.renderContent()));
    }
    renderSkeleton(props) {
        const { components: { Skeleton, SkeletonItem } } = this.props;
        const { skeleton } = props;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Skeleton, { label: skeleton.label },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(SkeletonItem, { className: this.BEM(), width: skeleton.width })));
    }
    render() {
        if ('skeleton' in this.props) {
            return this.renderSkeleton(this.props);
        }
        if (this.isSpan(this.props)) {
            return this.renderSpan(this.props);
        }
        if (this.isAnchor(this.props)) {
            if (this.props.disabled) {
                // type cast as a hack since we need to allow disabling anchor buttons
                // but that is actually not supported in HTML so ¯\_(ツ)_/¯
                return this.renderButton(this.props);
            }
            return this.renderAnchor(this.props);
        }
        return this.renderButton(this.props);
    }
}



/***/ }),

/***/ 3302:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CardBottomCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const CardBottomCore = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['card__bottom'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: BEM() }, children));
};



/***/ }),

/***/ 2485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CardContentCore)
/* harmony export */ });
/* unused harmony export CardContentResponsiveCore */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_front_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9097);
/* harmony import */ var _core_front_object_fit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5936);
/* harmony import */ var _core_front_theme_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3286);
/* harmony import */ var _card_card_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9336);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





const CardContentCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardContentResponsiveCore, Object.assign({}, rest, { responsive: responsive }))) : (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardContentInnerCore, Object.assign({}, rest)));
};
const CardContentResponsiveCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const { breakPoints } = (0,_core_front_theme_provider__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    const responsiveProps = (0,_core_front_helper__WEBPACK_IMPORTED_MODULE_2__/* .useResponsiveProps */ .S)({ breakPoints, responsive });
    return react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardContentInnerCore, Object.assign({}, rest, responsiveProps));
};
const CardContentInnerCore = (props) => {
    const { padding } = react__WEBPACK_IMPORTED_MODULE_0___default().useContext(_card_card_core__WEBPACK_IMPORTED_MODULE_3__/* .CardContext */ .H0);
    const { children, className, elementRef, backgroundImage, borderRadius, style, tagTop, components: { Tag, Image }, } = props;
    const contentPadding = props.padding || padding;
    const BEM = () => {
        const classArray = ['card__content'];
        const isEqualHorizontally = typeof contentPadding !== 'string' && contentPadding['right'] && contentPadding['right'] === contentPadding['left'];
        const isEqualVertically = typeof contentPadding !== 'string' && contentPadding['top'] && contentPadding['top'] === contentPadding['bottom'];
        const addPaddingClass = (direction, size) => {
            if (size) {
                return classArray.push(`card__content--padding-${direction}-${size}`);
            }
        };
        if (className) {
            classArray.push(className);
        }
        if (typeof contentPadding === 'string') {
            classArray.push(`card__content--padding-${contentPadding}`);
        }
        else {
            classArray.push('card__content--padding-medium');
            if (isEqualHorizontally && isEqualVertically) {
                addPaddingClass('vertical', contentPadding['top']);
                addPaddingClass('horizontal', contentPadding['right']);
            }
            else if (isEqualHorizontally) {
                addPaddingClass('horizontal', contentPadding['right']);
                addPaddingClass('top', contentPadding['top']);
                addPaddingClass('bottom', contentPadding['bottom']);
            }
            else if (isEqualVertically) {
                addPaddingClass('vertical', contentPadding['top']);
                addPaddingClass('right', contentPadding['right']);
                addPaddingClass('left', contentPadding['left']);
            }
            else {
                Object.keys(contentPadding).forEach((key) => {
                    const direction = key;
                    addPaddingClass(direction, contentPadding[direction]);
                });
            }
        }
        if (tagTop) {
            classArray.push('card__content--with-tag');
        }
        if (typeof borderRadius === 'string') {
            classArray.push(`card__content--border-radius-${borderRadius}`);
        }
        else if (borderRadius) {
            Object.keys(borderRadius).forEach((key) => {
                const direction = key;
                classArray.push(`card__content--border-radius-${direction}-${borderRadius[direction]}`);
            });
        }
        if (backgroundImage) {
            classArray.push('card__content--with-background-image');
        }
        return classArray.join(' ');
    };
    const imageBEM = (image) => {
        const classArray = ['card__content-background-image'];
        if (image.className) {
            classArray.push(image.className);
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: BEM(), ref: elementRef, style: style },
        tagTop && (react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: "card__content-tag-wrapper" },
            react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: "card__content-tag-inner" }, typeof tagTop === 'object' && (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Tag, Object.assign({ className: "card__content-tag" }, tagTop, { size: "tiny" })))))),
        backgroundImage && (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_core_front_object_fit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { fit: "cover", positionX: "center", positionY: "center", className: "card__content-object-fit" },
            react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Image, Object.assign({}, backgroundImage, { className: imageBEM(backgroundImage), pictureClassName: "card__content-background-image-picture" })))),
        children));
};



/***/ }),

/***/ 6912:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CardFooterCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _card_card_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9336);


const CardFooterCore = (props) => {
    const { padding } = react__WEBPACK_IMPORTED_MODULE_0___default().useContext(_card_card_core__WEBPACK_IMPORTED_MODULE_1__/* .CardContext */ .H0);
    const { background, children, className, } = props;
    const BEM = () => {
        const classArray = ['card__footer'];
        const addPaddingClass = (direction, size) => {
            if (size) {
                return classArray.push(`card__footer--padding-${direction}-${size}`);
            }
        };
        if (background) {
            classArray.push(`card__footer--${background}`);
        }
        if (className) {
            classArray.push(className);
        }
        if (typeof padding === 'string') {
            classArray.push(`card__footer--padding-${padding}`);
        }
        else {
            classArray.push('card__footer--padding-medium');
            if (padding['right'] === padding['left']) {
                addPaddingClass('horizontal', padding['right']);
            }
            else {
                Object.keys(padding).forEach((key) => {
                    if (key === 'left' || key === 'right') {
                        addPaddingClass(key, padding[key]);
                    }
                });
            }
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: BEM() }, children));
};



/***/ }),

/***/ 5892:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CardHeaderCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _card_card_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9336);


const CardHeaderCore = (props) => {
    const { padding } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_card_card_core__WEBPACK_IMPORTED_MODULE_1__/* .CardContext */ .H0);
    const { background, children, className, } = props;
    const BEM = () => {
        const classArray = ['card__header'];
        const addPaddingClass = (direction, size) => {
            if (size) {
                return classArray.push(`card__header--padding-${direction}-${size}`);
            }
        };
        if (background) {
            classArray.push(`card__header--${background}`);
        }
        if (className) {
            classArray.push(className);
        }
        if (typeof padding === 'string') {
            classArray.push(`card__header--padding-${padding}`);
        }
        else {
            classArray.push('card__header--padding-medium');
            if (padding['right'] === padding['left']) {
                addPaddingClass('horizontal', padding['right']);
            }
            else {
                Object.keys(padding).forEach((key) => {
                    if (key === 'left' || key === 'right') {
                        addPaddingClass(key, padding[key]);
                    }
                });
            }
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: BEM() }, children));
};



/***/ }),

/***/ 7058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CardTopCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const CardTopCore = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['card__top'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: BEM() }, children));
};



/***/ }),

/***/ 9336:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H0": () => (/* binding */ CardContext),
/* harmony export */   "ZP": () => (/* binding */ CardCore),
/* harmony export */   "sT": () => (/* binding */ CardResponsiveCore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_front_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9097);
/* harmony import */ var _core_front_input_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8606);
/* harmony import */ var _core_front_object_fit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5936);
/* harmony import */ var _core_front_theme_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3286);
/* harmony import */ var _core_front_theme_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9210);
/* harmony import */ var _core_front_window__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4358);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const CardContext = react__WEBPACK_IMPORTED_MODULE_0___default().createContext({
    background: 'grey',
    padding: 'medium',
});
const CardCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardResponsiveCore, Object.assign({}, rest, { responsive: responsive }))) : (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardInnerCore, Object.assign({}, rest)));
};
const CardResponsiveCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const { breakPoints } = (0,_core_front_theme_provider__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    const responsiveProps = (0,_core_front_helper__WEBPACK_IMPORTED_MODULE_2__/* .useResponsiveProps */ .S)({ breakPoints, responsive });
    return react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardInnerCore, Object.assign({}, rest, responsiveProps));
};
const CardInnerCore = (props) => {
    const [isLargeScreen, setIsLargeScreen] = react__WEBPACK_IMPORTED_MODULE_0___default().useState(false);
    const [isPlaying, setIsPlaying] = react__WEBPACK_IMPORTED_MODULE_0___default().useState(false);
    const [isDefaultPLaying, setDefaultPLaying] = react__WEBPACK_IMPORTED_MODULE_0___default().useState(false);
    const { breakPoints } = react__WEBPACK_IMPORTED_MODULE_0___default().useContext(_core_front_theme_provider__WEBPACK_IMPORTED_MODULE_3__/* .ThemeContext */ .Ni);
    const { badgeTop, buttonRef, children, className, background, borderRadius = 'medium', elementRef, elevation, onClick = _core_front_window__WEBPACK_IMPORTED_MODULE_4__/* .navigate */ .c, onMouseLeave, onMouseEnter, onTransitionEnd, external = false, target, type, url, isDisabled, style, tag, backgroundVideo, backgroundImage, videoBreakpoint = 'lg', videoOpacity = true, components: { Video, Tag, TagGroup, Badge, Image }, } = props;
    const CardTag = url ? 'a' : 'div';
    const BEM = () => {
        const classArray = ['card', `card--border-radius-${borderRadius}`];
        if (background === 'grey') {
            classArray.push(`card--${background}`);
        }
        if (type) {
            classArray.push(`card--${type}`);
        }
        if (url) {
            classArray.push('card--link');
        }
        if (isDisabled) {
            classArray.push('card--disabled');
        }
        if (backgroundVideo) {
            classArray.push('card--background-video');
        }
        if (backgroundVideo && videoOpacity) {
            classArray.push('card--background-video-opacity');
        }
        if (backgroundImage) {
            classArray.push('card--with-background-image');
        }
        if (elevation) {
            classArray.push(`card--elevation-${elevation}`);
        }
        if (className) {
            classArray.push(className);
        }
        if (badgeTop) {
            classArray.push('card--badge');
        }
        return classArray.join(' ');
    };
    const handleClick = react__WEBPACK_IMPORTED_MODULE_0___default().useCallback((event) => {
        if (!external) {
            onClick(event);
        }
    }, [external, onClick]);
    const cardStateHandler = () => {
        const nextIsLargeScreen = window.matchMedia(`(min-width: ${breakPoints[videoBreakpoint]}px)`).matches;
        setDefaultPLaying(!nextIsLargeScreen);
        setIsPlaying(!nextIsLargeScreen);
        if (isLargeScreen !== nextIsLargeScreen) {
            setIsLargeScreen(nextIsLargeScreen);
        }
    };
    react__WEBPACK_IMPORTED_MODULE_0___default().useEffect(() => {
        window.addEventListener('resize', cardStateHandler);
        return () => {
            window.removeEventListener('resize', cardStateHandler);
        };
    });
    const onMouseEnterVideo = () => {
        setDefaultPLaying(true);
        setIsPlaying(true);
    };
    const onMouseLeaveVideo = () => {
        setIsPlaying(false);
    };
    const videoBEM = (video) => {
        const classArray = ['card__video'];
        if (video.className) {
            classArray.push(video.className);
        }
        return classArray.join(' ');
    };
    const imageBEM = (image) => {
        const classArray = ['card__background-image'];
        if (image.className) {
            classArray.push(image.className);
        }
        return classArray.join(' ');
    };
    const renderTags = (tags) => {
        let content;
        if (Array.isArray(tags)) {
            content = react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TagGroup, { tags: tags, size: "small" });
        }
        else {
            const tagProps = Object.assign({ className: 'card__tag', size: 'small' }, tags);
            content = react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Tag, Object.assign({}, tagProps));
        }
        return (react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: "card__tags" }, content));
    };
    const renderCard = (input) => {
        const addHoverListeners = backgroundVideo && input.input === 'mouse';
        return (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardTag, { className: BEM(), href: url, onClick: url ? handleClick : undefined, target: target, ref: buttonRef || elementRef, onMouseEnter: addHoverListeners ? onMouseEnterVideo : onMouseEnter, onMouseLeave: addHoverListeners ? onMouseLeaveVideo : onMouseLeave, onTransitionEnd: onTransitionEnd, style: style },
            backgroundVideo && (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Video, Object.assign({ onPlay: () => null }, backgroundVideo, { implementation: "html5", className: videoBEM(backgroundVideo), playing: isPlaying, defaultPlaying: isDefaultPLaying, hideOverview: true, hideWithoutConsent: "showPoster", attributes: {
                    controls: false,
                    loop: true,
                } }))),
            backgroundImage && (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_core_front_object_fit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { fit: "cover", positionX: "center", positionY: "center" },
                react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Image, Object.assign({}, backgroundImage, { className: imageBEM(backgroundImage), pictureClassName: "card__background-image-picture" })))),
            tag && renderTags(tag),
            typeof badgeTop === 'object' && (react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", { className: "card__badge-wrapper" },
                react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Badge, Object.assign({ className: "card__badge" }, badgeTop)))),
            children));
    };
    return (react__WEBPACK_IMPORTED_MODULE_0___default().createElement(CardContext.Provider, { value: {
            background: props.background,
            padding: props.padding || 'medium',
        } },
        react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_core_front_input_provider__WEBPACK_IMPORTED_MODULE_6__/* .InputContext.Consumer */ .r.Consumer, null, renderCard)));
};
CardCore.defaultProps = {
    onClick: _core_front_window__WEBPACK_IMPORTED_MODULE_4__/* .navigate */ .c,
};



/***/ }),

/***/ 7869:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ CookieConsentContext),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const defaultConsent = {
    consent: { necessary: false, preferences: false, statistics: false, marketing: false },
    enabled: false,
    hasConsent(needsConsent) {
        return (!this.enabled
            || needsConsent.filter((c) => !this.consent[c]).length === 0);
    },
    getDescription: () => '',
};
const CookieConsentContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultConsent);
const CookieConsentProvider = (props) => {
    const consent = Object.assign(Object.assign({}, defaultConsent.consent), props.consent);
    const contextValue = Object.assign(Object.assign({}, defaultConsent), { consent: consent, enabled: !!props.enabled, content: props.content, getDescription: (needsConsent) => {
            const content = props.content;
            if (!content) {
                return '';
            }
            const missingConsents = needsConsent
                .filter((c) => !consent[c])
                .map((c) => content.categories[c])
                .join(', ');
            return content.description + ' ' + missingConsents;
        } });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(CookieConsentContext.Provider, { value: contextValue }, props.children));
};
CookieConsentProvider.defaultProps = defaultConsent;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CookieConsentProvider);


/***/ }),

/***/ 6537:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ fittext)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-previous.js
var use_previous = __webpack_require__(8357);
;// CONCATENATED MODULE: ./node_modules/@core-front/fittext/esm/helpers.js
function formatPixelsToNumber(pixels) {
    if (!pixels) {
        return 0;
    }
    return Number(pixels.replace('px', ''));
}
function formatNumberToPixels(num) {
    return `${num}px`;
}
function getParentInnerWidth(el) {
    const { width, paddingLeft, paddingRight } = window.getComputedStyle(el);
    if (width) {
        return formatPixelsToNumber(width) - formatPixelsToNumber(paddingLeft) - formatPixelsToNumber(paddingRight);
    }
    return 0;
}
function isElementInline(el) {
    return window.getComputedStyle(el).display === 'inline';
}
function getElementFontSize(el) {
    return formatPixelsToNumber(window.getComputedStyle(el).fontSize || '0px');
}
function getParentElementParameters(el) {
    const parentEl = el.parentElement;
    const currentParentWidth = parentEl ? getParentInnerWidth(parentEl) : 0;
    const parentFontSize = parentEl ? getElementFontSize(parentEl) : 0;
    return { currentParentWidth, parentFontSize };
}


;// CONCATENATED MODULE: ./node_modules/@core-front/fittext/esm/fittext-core.js



const FittextCore = (props) => {
    const { className, children, } = props;
    const container = external_react_.useRef(null);
    const [fontSize, setFontSize] = external_react_.useState(0);
    const [parentWidth, setParentWidth] = external_react_.useState(0);
    const prevChildren = (0,use_previous/* usePrevious */.D)(children);
    const resizeText = external_react_.useCallback(() => {
        if (!container.current) {
            return;
        }
        const el = container.current;
        const elementFontSize = getElementFontSize(el);
        const width = isElementInline(el) ? el.offsetWidth : el.scrollWidth;
        const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
        if (currentParentWidth && elementFontSize && parentFontSize) {
            const isChildGreaterThanParent = width > (currentParentWidth + 1);
            const isResetRequired = parentWidth !== currentParentWidth;
            setParentWidth(currentParentWidth);
            if (isResetRequired) {
                setFontSize(parentFontSize);
            }
            else if (isChildGreaterThanParent && fontSize > 1) {
                setFontSize((f) => f - 1);
            }
        }
    }, [fontSize, parentWidth]);
    external_react_.useLayoutEffect(() => {
        resizeText();
    }, [fontSize, parentWidth, resizeText]);
    external_react_.useEffect(() => {
        const resizeHandler = () => resizeText();
        window.addEventListener('resize', resizeHandler);
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeText]);
    /**
     * Update parentWidth and reset fontSize after children text value changes.
     * Explicitly check if children text value has changed,
     * because other parent element changes shouldn't trigger this hook (e.g. EqualHeight)
     */
    external_react_.useEffect(() => {
        // Check if string as child has changed (React provides children always as array)
        if (prevChildren && children[0] !== prevChildren[0]) {
            const el = container.current;
            if (el) {
                const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
                setParentWidth(currentParentWidth);
                setFontSize(parentFontSize);
            }
        }
    }, [children, prevChildren]);
    const BEM = () => {
        const classArray = ['fittext'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("span", { style: { fontSize: fontSize ? formatNumberToPixels(fontSize) : undefined }, ref: container, className: BEM() }, children));
};
/* harmony default export */ const fittext_core = (FittextCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/fittext/esm/fittext.js


const Fittext = (props) => {
    return (external_react_.createElement(fittext_core, Object.assign({}, props)));
};
/* harmony default export */ const fittext = (Fittext);


/***/ }),

/***/ 8539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ useIsMounted)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsMounted() {
    const [isMounted, setIsMounted] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        setIsMounted(true);
    }, []);
    return isMounted;
}


/***/ }),

/***/ 8357:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ usePrevious)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function usePrevious(value) {
    const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}


/***/ }),

/***/ 9097:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": () => (/* binding */ useResponsiveProps)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
;// CONCATENATED MODULE: ./node_modules/@core-front/helper/esm/hooks/use-current-breakpoint.js

function useCurrentBreakPoint(breakPoints) {
    const [breakPoint, setBreakPoint] = external_react_.useState(null);
    external_react_.useEffect(() => {
        const resizeListener = () => {
            const sortedBreakPoints = Object.keys(breakPoints).sort((x, y) => breakPoints[y] - breakPoints[x]);
            const bp = sortedBreakPoints.find((breakPoint) => window.matchMedia(`(min-width: ${breakPoints[breakPoint]}px)`).matches);
            setBreakPoint(bp || 'xs');
        };
        window.addEventListener('resize', resizeListener);
        resizeListener();
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [breakPoints]);
    return breakPoint;
}

;// CONCATENATED MODULE: ./node_modules/@core-front/helper/esm/hooks/use-responsive-props.js

function useResponsiveProps(props) {
    const { responsive, breakPoints } = props;
    const responsiveBreakPoints = responsive.map((resp) => resp.breakPoint);
    const currentBreakPoint = useCurrentBreakPoint(breakPoints);
    const getActiveBreakPoints = (currentBreakPoint, responsiveBP) => {
        const sortedResponsiveBreakPoints = responsiveBP.sort((x, y) => breakPoints[x] - breakPoints[y]);
        return sortedResponsiveBreakPoints.filter((breakPoint) => {
            return breakPoints[breakPoint] <= breakPoints[currentBreakPoint];
        });
    };
    const getResponsiveProps = (breakPoint) => {
        const responsiveObject = responsive.find((resp) => resp.breakPoint === breakPoint);
        /* istanbul ignore else */
        if (responsiveObject) {
            return responsiveObject.props;
        }
    };
    if (!currentBreakPoint) {
        return {};
    }
    const activeBreakPoints = getActiveBreakPoints(currentBreakPoint, responsiveBreakPoints);
    return activeBreakPoints.reduce((acc, breakPoint) => (Object.assign(Object.assign({}, acc), getResponsiveProps(breakPoint))), {});
}


/***/ }),

/***/ 1858:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ icon)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
;// CONCATENATED MODULE: ./node_modules/@core-front/error-provider/esm/error-provider.js

const defaultContext = {
    log: (message) => console.error(message),
};
const ErrorContext = external_react_.createContext(defaultContext);
const ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const error_provider = ((/* unused pure expression or super */ null && (ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@core-front/error-provider/esm/use-log.js


const useErrorLog = () => {
    return external_react_.useContext(ErrorContext);
};


// EXTERNAL MODULE: ./node_modules/@core-front/theme-provider/esm/use-theme.js
var use_theme = __webpack_require__(3286);
;// CONCATENATED MODULE: ./node_modules/@core-front/icon/esm/icon.js



const deprecationMap = {
    '#clear': '#close-round',
    '#service-it': 'server',
    '#server-email': '#email',
    '#enduser': '#contact',
    '#file-bills': '#file-bill',
    '#service-box': '#parcel-machine',
    '#close-light': '#close',
    '#star-film': '#star',
    '#service': '#repair',
    '#server-settings': '#settings',
    '#update': '#sync',
    '#processes': '#sync',
    '#feedback': '#chat',
    '#sms': '#chat',
    '#talk-bubble': '#chat',
    '#cloud-line': '#cloud',
    '#activity-monitor': '#watch',
    '#digibox': '#device-digibox',
    '#modem': '#device-router',
    '#mobile-devices': '#devices',
    '#help-round': '#help',
    '#help-circle': '#help',
    '#safe': '#security',
    '#security-internet': '#security',
    '#firewall': '#security',
    '#mailware': '#security',
    '#protective-film': '#security',
    '#music-infinity': '#offering',
    '#service-leasing': '#coins',
    '#play-video': '#video',
    '#play-video-2': '#video',
    '#packet-sport': '#sport',
    '#packet-music': '#music',
    '#packet-russian': '#matryoshka',
    '#packet-lifestyle': '#weather',
    '#packet-children': '#teddybear',
    '#channels': '#service-tv-channels',
    '#arrow-large-down': '#arrow-down',
    '#arrow-large-left': '#arrow-left',
    '#arrow-large-right': '#arrow-right',
    '#arrow-large-up': '#arrow-up',
    '#arrow-medium-down': '#arrow-down',
    '#arrow-medium-left': '#arrow-left',
    '#arrow-medium-right': '#arrow-right',
    '#arrow-medium-up': '#arrow-up',
    '#arrow-left-light': '#arrow-left',
    '#arrow-right-light': '#arrow-right',
    '#plus-circle': '#plus-round',
    '#architecture': '#service-internet',
    '#contact-search': '#search',
    '#internet-lock': '#lock',
    '#minus-circle': '#minus-round',
    '#mobile-simple': '#mobile',
    '#play-round': '#play-circle',
    '#service-business': '#briefcase',
    '#service-tv': '#tv',
    '#speed': '#arrow-up-down',
    '#tech-support': '#technician',
    '#people-arrow': '#user-group',
};
const getAliasName = (name, log) => {
    if (Object.prototype.hasOwnProperty.call(deprecationMap, name)) {
        const substitute = deprecationMap[name];
        log(`"${name}" icon is deprecated. Please use "${substitute}" instead.`);
        return substitute;
    }
    return name;
};
const Icon = (props) => {
    const { getIconPath } = (0,use_theme/* useTheme */.F)();
    const { log } = useErrorLog();
    const name = getAliasName(props.modifiers, log);
    const src = getIconPath(name);
    const BEM = () => {
        const classArray = ['icon'];
        if (props.size) {
            classArray.push('icon--' + props.size);
        }
        if (props.align) {
            classArray.push('icon--align-' + props.align);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("svg", { className: BEM(), style: props.style, focusable: "false" },
        external_react_.createElement("use", { xlinkHref: src, href: src })));
};
/* harmony default export */ const icon = (Icon);


/***/ }),

/***/ 1500:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(5670)


/***/ }),

/***/ 7441:
/***/ ((module) => {

/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Ian Caunce - ian@hallnet.co.uk
 */

(function(undefined) {
  'use strict';

  if (typeof window === 'undefined') return; // don't run for server side render

  var autoResize = true,
    base = 10,
    bodyBackground = '',
    bodyMargin = 0,
    bodyMarginStr = '',
    bodyObserver = null,
    bodyPadding = '',
    calculateWidth = false,
    doubleEventList = { resize: 1, click: 1 },
    eventCancelTimer = 128,
    firstRun = true,
    height = 1,
    heightCalcModeDefault = 'bodyOffset',
    heightCalcMode = heightCalcModeDefault,
    initLock = true,
    initMsg = '',
    inPageLinks = {},
    interval = 32,
    intervalTimer = null,
    logging = false,
    msgID = '[iFrameSizer]', //Must match host page msg ID
    msgIdLen = msgID.length,
    myID = '',
    observer = null,
    resetRequiredMethods = {
      max: 1,
      min: 1,
      bodyScroll: 1,
      documentElementScroll: 1
    },
    resizeFrom = 'child',
    sendPermit = true,
    target = window.parent,
    targetOriginDefault = '*',
    tolerance = 0,
    triggerLocked = false,
    triggerLockedTimer = null,
    throttledTimer = 16,
    width = 1,
    widthCalcModeDefault = 'scroll',
    widthCalcMode = widthCalcModeDefault,
    win = window,
    messageCallback = function() {
      warn('MessageCallback function not defined');
    },
    readyCallback = function() {},
    pageInfoCallback = function() {},
    customCalcMethods = {
      height: function() {
        warn('Custom height calculation function not defined');
        return document.documentElement.offsetHeight;
      },
      width: function() {
        warn('Custom width calculation function not defined');
        return document.body.scrollWidth;
      }
    },
    eventHandlersByName = {},
    passiveSupported = false,
    onceSupported = false;

  function noop() {}

  try {
    var options = Object.create(
      {},
      {
        passive: {
          get: function() {
            passiveSupported = true;
          }
        },
        once: {
          get: function() {
            onceSupported = true;
          }
        }
      }
    );
    window.addEventListener('test', noop, options);
    window.removeEventListener('test', noop, options);
  } catch (e) {
    /* */
  }

  function addEventListener(el, evt, func, options) {
    /* istanbul ignore else */ // Not testable in phantomJS
    if ('addEventListener' in window) {
      el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    } else if ('attachEvent' in window) {
      //IE
      el.attachEvent('on' + evt, func);
    }
  }

  function removeEventListener(el, evt, func) {
    /* istanbul ignore else */ // Not testable in phantomJS
    if ('removeEventListener' in window) {
      el.removeEventListener(evt, func, false);
    } else if ('detachEvent' in window) {
      //IE
      el.detachEvent('on' + evt, func);
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  //Based on underscore.js
  function throttle(func) {
    var context,
      args,
      result,
      timeout = null,
      previous = 0,
      later = function() {
        previous = getNow();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) {
          context = args = null;
        }
      };

    return function() {
      var now = getNow();

      if (!previous) {
        previous = now;
      }

      var remaining = throttledTimer - (now - previous);

      context = this;
      args = arguments;

      if (remaining <= 0 || remaining > throttledTimer) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        previous = now;
        result = func.apply(context, args);

        if (!timeout) {
          context = args = null;
        }
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  }

  var getNow =
    Date.now ||
    function() {
      /* istanbul ignore next */ // Not testable in PhantonJS
      return new Date().getTime();
    };

  function formatLogMsg(msg) {
    return msgID + '[' + myID + ']' + ' ' + msg;
  }

  function log(msg) {
    if (logging && 'object' === typeof window.console) {
      console.log(formatLogMsg(msg));
    }
  }

  function warn(msg) {
    if ('object' === typeof window.console) {
      console.warn(formatLogMsg(msg));
    }
  }

  function init() {
    readDataFromParent();
    log('Initialising iFrame (' + location.href + ')');
    readDataFromPage();
    setMargin();
    setBodyStyle('background', bodyBackground);
    setBodyStyle('padding', bodyPadding);
    injectClearFixIntoBodyElement();
    checkHeightMode();
    checkWidthMode();
    stopInfiniteResizingOfIFrame();
    setupPublicMethods();
    startEventListeners();
    inPageLinks = setupInPageLinks();
    sendSize('init', 'Init message from host page');
    readyCallback();
  }

  function readDataFromParent() {
    function strBool(str) {
      return 'true' === str ? true : false;
    }

    var data = initMsg.substr(msgIdLen).split(':');

    myID = data[0];
    bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; //For V1 compatibility
    calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
    logging = undefined !== data[3] ? strBool(data[3]) : logging;
    interval = undefined !== data[4] ? Number(data[4]) : interval;
    autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
    bodyMarginStr = data[7];
    heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
    bodyBackground = data[9];
    bodyPadding = data[10];
    tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
    inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
    resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
    widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
  }

  function readDataFromPage() {
    function readData() {
      var data = window.iFrameResizer;

      log('Reading data from page: ' + JSON.stringify(data));

      messageCallback =
        'messageCallback' in data ? data.messageCallback : messageCallback;
      readyCallback =
        'readyCallback' in data ? data.readyCallback : readyCallback;
      targetOriginDefault =
        'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
      heightCalcMode =
        'heightCalculationMethod' in data
          ? data.heightCalculationMethod
          : heightCalcMode;
      widthCalcMode =
        'widthCalculationMethod' in data
          ? data.widthCalculationMethod
          : widthCalcMode;
    }

    function setupCustomCalcMethods(calcMode, calcFunc) {
      if ('function' === typeof calcMode) {
        log('Setup custom ' + calcFunc + 'CalcMethod');
        customCalcMethods[calcFunc] = calcMode;
        calcMode = 'custom';
      }

      return calcMode;
    }

    if (
      'iFrameResizer' in window &&
      Object === window.iFrameResizer.constructor
    ) {
      readData();
      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
      widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
    }

    log('TargetOrigin for parent set to: ' + targetOriginDefault);
  }

  function chkCSS(attr, value) {
    if (-1 !== value.indexOf('-')) {
      warn('Negative CSS value ignored for ' + attr);
      value = '';
    }
    return value;
  }

  function setBodyStyle(attr, value) {
    if (undefined !== value && '' !== value && 'null' !== value) {
      document.body.style[attr] = value;
      log('Body ' + attr + ' set to "' + value + '"');
    }
  }

  function setMargin() {
    //If called via V1 script, convert bodyMargin from int to str
    if (undefined === bodyMarginStr) {
      bodyMarginStr = bodyMargin + 'px';
    }

    setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
  }

  function stopInfiniteResizingOfIFrame() {
    document.documentElement.style.height = '';
    document.body.style.height = '';
    log('HTML & body height set to "auto"');
  }

  function manageTriggerEvent(options) {
    var listener = {
      add: function(eventName) {
        function handleEvent() {
          sendSize(options.eventName, options.eventType);
        }

        eventHandlersByName[eventName] = handleEvent;

        addEventListener(window, eventName, handleEvent, { passive: true });
      },
      remove: function(eventName) {
        var handleEvent = eventHandlersByName[eventName];
        delete eventHandlersByName[eventName];

        removeEventListener(window, eventName, handleEvent);
      }
    };

    if (options.eventNames && Array.prototype.map) {
      options.eventName = options.eventNames[0];
      options.eventNames.map(listener[options.method]);
    } else {
      listener[options.method](options.eventName);
    }

    log(
      capitalizeFirstLetter(options.method) +
        ' event listener: ' +
        options.eventType
    );
  }

  function manageEventListeners(method) {
    manageTriggerEvent({
      method: method,
      eventType: 'Animation Start',
      eventNames: ['animationstart', 'webkitAnimationStart']
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Animation Iteration',
      eventNames: ['animationiteration', 'webkitAnimationIteration']
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Animation End',
      eventNames: ['animationend', 'webkitAnimationEnd']
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Input',
      eventName: 'input'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Mouse Up',
      eventName: 'mouseup'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Mouse Down',
      eventName: 'mousedown'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Orientation Change',
      eventName: 'orientationchange'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Print',
      eventName: ['afterprint', 'beforeprint']
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Ready State Change',
      eventName: 'readystatechange'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Touch Start',
      eventName: 'touchstart'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Touch End',
      eventName: 'touchend'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Touch Cancel',
      eventName: 'touchcancel'
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Transition Start',
      eventNames: [
        'transitionstart',
        'webkitTransitionStart',
        'MSTransitionStart',
        'oTransitionStart',
        'otransitionstart'
      ]
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Transition Iteration',
      eventNames: [
        'transitioniteration',
        'webkitTransitionIteration',
        'MSTransitionIteration',
        'oTransitionIteration',
        'otransitioniteration'
      ]
    });
    manageTriggerEvent({
      method: method,
      eventType: 'Transition End',
      eventNames: [
        'transitionend',
        'webkitTransitionEnd',
        'MSTransitionEnd',
        'oTransitionEnd',
        'otransitionend'
      ]
    });
    if ('child' === resizeFrom) {
      manageTriggerEvent({
        method: method,
        eventType: 'IFrame Resized',
        eventName: 'resize'
      });
    }
  }

  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
    if (calcModeDefault !== calcMode) {
      if (!(calcMode in modes)) {
        warn(
          calcMode + ' is not a valid option for ' + type + 'CalculationMethod.'
        );
        calcMode = calcModeDefault;
      }
      log(type + ' calculation method set to "' + calcMode + '"');
    }

    return calcMode;
  }

  function checkHeightMode() {
    heightCalcMode = checkCalcMode(
      heightCalcMode,
      heightCalcModeDefault,
      getHeight,
      'height'
    );
  }

  function checkWidthMode() {
    widthCalcMode = checkCalcMode(
      widthCalcMode,
      widthCalcModeDefault,
      getWidth,
      'width'
    );
  }

  function startEventListeners() {
    if (true === autoResize) {
      manageEventListeners('add');
      setupMutationObserver();
    } else {
      log('Auto Resize disabled');
    }
  }

  function stopMsgsToParent() {
    log('Disable outgoing messages');
    sendPermit = false;
  }

  function removeMsgListener() {
    log('Remove event listener: Message');
    removeEventListener(window, 'message', receiver);
  }

  function disconnectMutationObserver() {
    if (null !== bodyObserver) {
      /* istanbul ignore next */ // Not testable in PhantonJS
      bodyObserver.disconnect();
    }
  }

  function stopEventListeners() {
    manageEventListeners('remove');
    disconnectMutationObserver();
    clearInterval(intervalTimer);
  }

  function teardown() {
    stopMsgsToParent();
    removeMsgListener();
    if (true === autoResize) stopEventListeners();
  }

  function injectClearFixIntoBodyElement() {
    var clearFix = document.createElement('div');
    clearFix.style.clear = 'both';
    clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
    document.body.appendChild(clearFix);
  }

  function setupInPageLinks() {
    function getPagePosition() {
      return {
        x:
          window.pageXOffset !== undefined
            ? window.pageXOffset
            : document.documentElement.scrollLeft,
        y:
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : document.documentElement.scrollTop
      };
    }

    function getElementPosition(el) {
      var elPosition = el.getBoundingClientRect(),
        pagePosition = getPagePosition();

      return {
        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
      };
    }

    function findTarget(location) {
      function jumpToTarget(target) {
        var jumpPosition = getElementPosition(target);

        log(
          'Moving to in page link (#' +
            hash +
            ') at x: ' +
            jumpPosition.x +
            ' y: ' +
            jumpPosition.y
        );
        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
      }

      var hash = location.split('#')[1] || location, //Remove # if present
        hashData = decodeURIComponent(hash),
        target =
          document.getElementById(hashData) ||
          document.getElementsByName(hashData)[0];

      if (undefined !== target) {
        jumpToTarget(target);
      } else {
        log(
          'In page link (#' +
            hash +
            ') not found in iFrame, so sending to parent'
        );
        sendMsg(0, 0, 'inPageLink', '#' + hash);
      }
    }

    function checkLocationHash() {
      if ('' !== location.hash && '#' !== location.hash) {
        findTarget(location.href);
      }
    }

    function bindAnchors() {
      function setupLink(el) {
        function linkClicked(e) {
          e.preventDefault();

          /*jshint validthis:true */
          findTarget(this.getAttribute('href'));
        }

        if ('#' !== el.getAttribute('href')) {
          addEventListener(el, 'click', linkClicked);
        }
      }

      Array.prototype.forEach.call(
        document.querySelectorAll('a[href^="#"]'),
        setupLink
      );
    }

    function bindLocationHash() {
      addEventListener(window, 'hashchange', checkLocationHash);
    }

    function initCheck() {
      //check if page loaded with location hash after init resize
      setTimeout(checkLocationHash, eventCancelTimer);
    }

    function enableInPageLinks() {
      /* istanbul ignore else */ // Not testable in phantonJS
      if (Array.prototype.forEach && document.querySelectorAll) {
        log('Setting up location.hash handlers');
        bindAnchors();
        bindLocationHash();
        initCheck();
      } else {
        warn(
          'In page linking not fully supported in this browser! (See README.md for IE8 workaround)'
        );
      }
    }

    if (inPageLinks.enable) {
      enableInPageLinks();
    } else {
      log('In page linking not enabled');
    }

    return {
      findTarget: findTarget
    };
  }

  function setupPublicMethods() {
    log('Enable public methods');

    win.parentIFrame = {
      autoResize: function autoResizeF(resize) {
        if (true === resize && false === autoResize) {
          autoResize = true;
          startEventListeners();
          //sendSize('autoResize','Auto Resize enabled');
        } else if (false === resize && true === autoResize) {
          autoResize = false;
          stopEventListeners();
        }

        return autoResize;
      },

      close: function closeF() {
        sendMsg(0, 0, 'close');
        teardown();
      },

      getId: function getIdF() {
        return myID;
      },

      getPageInfo: function getPageInfoF(callback) {
        if ('function' === typeof callback) {
          pageInfoCallback = callback;
          sendMsg(0, 0, 'pageInfo');
        } else {
          pageInfoCallback = function() {};
          sendMsg(0, 0, 'pageInfoStop');
        }
      },

      moveToAnchor: function moveToAnchorF(hash) {
        inPageLinks.findTarget(hash);
      },

      reset: function resetF() {
        resetIFrame('parentIFrame.reset');
      },

      scrollTo: function scrollToF(x, y) {
        sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
      },

      scrollToOffset: function scrollToF(x, y) {
        sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
      },

      sendMessage: function sendMessageF(msg, targetOrigin) {
        sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
      },

      setHeightCalculationMethod: function setHeightCalculationMethodF(
        heightCalculationMethod
      ) {
        heightCalcMode = heightCalculationMethod;
        checkHeightMode();
      },

      setWidthCalculationMethod: function setWidthCalculationMethodF(
        widthCalculationMethod
      ) {
        widthCalcMode = widthCalculationMethod;
        checkWidthMode();
      },

      setTargetOrigin: function setTargetOriginF(targetOrigin) {
        log('Set targetOrigin: ' + targetOrigin);
        targetOriginDefault = targetOrigin;
      },

      size: function sizeF(customHeight, customWidth) {
        var valString =
          '' +
          (customHeight ? customHeight : '') +
          (customWidth ? ',' + customWidth : '');
        //lockTrigger();
        sendSize(
          'size',
          'parentIFrame.size(' + valString + ')',
          customHeight,
          customWidth
        );
      }
    };
  }

  function initInterval() {
    if (0 !== interval) {
      log('setInterval: ' + interval + 'ms');
      intervalTimer = setInterval(function() {
        sendSize('interval', 'setInterval: ' + interval);
      }, Math.abs(interval));
    }
  } //Not testable in PhantomJS

  /* istanbul ignore next */ function setupBodyMutationObserver() {
    function addImageLoadListners(mutation) {
      function addImageLoadListener(element) {
        if (false === element.complete) {
          log('Attach listeners to ' + element.src);
          element.addEventListener('load', imageLoaded, false);
          element.addEventListener('error', imageError, false);
          elements.push(element);
        }
      }

      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        addImageLoadListener(mutation.target);
      } else if (mutation.type === 'childList') {
        Array.prototype.forEach.call(
          mutation.target.querySelectorAll('img'),
          addImageLoadListener
        );
      }
    }

    function removeFromArray(element) {
      elements.splice(elements.indexOf(element), 1);
    }

    function removeImageLoadListener(element) {
      log('Remove listeners from ' + element.src);
      element.removeEventListener('load', imageLoaded, false);
      element.removeEventListener('error', imageError, false);
      removeFromArray(element);
    }

    function imageEventTriggered(event, type, typeDesc) {
      removeImageLoadListener(event.target);
      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
    }

    function imageLoaded(event) {
      imageEventTriggered(event, 'imageLoad', 'Image loaded');
    }

    function imageError(event) {
      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
    }

    function mutationObserved(mutations) {
      sendSize(
        'mutationObserver',
        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type
      );

      //Deal with WebKit asyncing image loading when tags are injected into the page
      mutations.forEach(addImageLoadListners);
    }

    function createMutationObserver() {
      var target = document.querySelector('body'),
        config = {
          attributes: true,
          attributeOldValue: false,
          characterData: true,
          characterDataOldValue: false,
          childList: true,
          subtree: true
        };

      observer = new MutationObserver(mutationObserved);

      log('Create body MutationObserver');
      observer.observe(target, config);

      return observer;
    }

    var elements = [],
      MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver,
      observer = createMutationObserver();

    return {
      disconnect: function() {
        if ('disconnect' in observer) {
          log('Disconnect body MutationObserver');
          observer.disconnect();
          elements.forEach(removeImageLoadListener);
        }
      }
    };
  }

  function setupMutationObserver() {
    var forceIntervalTimer = 0 > interval; // Not testable in PhantomJS

    /* istanbul ignore if */ if (
      window.MutationObserver ||
      window.WebKitMutationObserver
    ) {
      if (forceIntervalTimer) {
        initInterval();
      } else {
        bodyObserver = setupBodyMutationObserver();
      }
    } else {
      log('MutationObserver not supported in this browser!');
      initInterval();
    }
  }

  // document.documentElement.offsetHeight is not reliable, so
  // we have to jump through hoops to get a better value.
  function getComputedStyle(prop, el) {
    /* istanbul ignore next */ //Not testable in PhantomJS
    function convertUnitsToPxForIE8(value) {
      var PIXEL = /^\d+(px)?$/i;

      if (PIXEL.test(value)) {
        return parseInt(value, base);
      }

      var style = el.style.left,
        runtimeStyle = el.runtimeStyle.left;

      el.runtimeStyle.left = el.currentStyle.left;
      el.style.left = value || 0;
      value = el.style.pixelLeft;
      el.style.left = style;
      el.runtimeStyle.left = runtimeStyle;

      return value;
    }

    var retVal = 0;
    el = el || document.body; // Not testable in phantonJS

    /* istanbul ignore else */ if (
      'defaultView' in document &&
      'getComputedStyle' in document.defaultView
    ) {
      retVal = document.defaultView.getComputedStyle(el, null);
      retVal = null !== retVal ? retVal[prop] : 0;
    } else {
      //IE8
      retVal = convertUnitsToPxForIE8(el.currentStyle[prop]);
    }

    return parseInt(retVal, base);
  }

  function chkEventThottle(timer) {
    if (timer > throttledTimer / 2) {
      throttledTimer = 2 * timer;
      log('Event throttle increased to ' + throttledTimer + 'ms');
    }
  }

  //Idea from https://github.com/guardian/iframe-messenger
  function getMaxElement(side, elements) {
    var elementsLength = elements.length,
      elVal = 0,
      maxVal = 0,
      Side = capitalizeFirstLetter(side),
      timer = getNow();

    for (var i = 0; i < elementsLength; i++) {
      elVal =
        elements[i].getBoundingClientRect()[side] +
        getComputedStyle('margin' + Side, elements[i]);
      if (elVal > maxVal) {
        maxVal = elVal;
      }
    }

    timer = getNow() - timer;

    log('Parsed ' + elementsLength + ' HTML elements');
    log('Element position calculated in ' + timer + 'ms');

    chkEventThottle(timer);

    return maxVal;
  }

  function getAllMeasurements(dimention) {
    return [
      dimention.bodyOffset(),
      dimention.bodyScroll(),
      dimention.documentElementOffset(),
      dimention.documentElementScroll()
    ];
  }

  function getTaggedElements(side, tag) {
    function noTaggedElementsFound() {
      warn('No tagged elements (' + tag + ') found on page');
      return document.querySelectorAll('body *');
    }

    var elements = document.querySelectorAll('[' + tag + ']');

    if (0 === elements.length) noTaggedElementsFound();

    return getMaxElement(side, elements);
  }

  function getAllElements() {
    return document.querySelectorAll('body *');
  }

  var getHeight = {
      bodyOffset: function getBodyOffsetHeight() {
        return (
          document.body.offsetHeight +
          getComputedStyle('marginTop') +
          getComputedStyle('marginBottom')
        );
      },

      offset: function() {
        return getHeight.bodyOffset(); //Backwards compatability
      },

      bodyScroll: function getBodyScrollHeight() {
        return document.body.scrollHeight;
      },

      custom: function getCustomWidth() {
        return customCalcMethods.height();
      },

      documentElementOffset: function getDEOffsetHeight() {
        return document.documentElement.offsetHeight;
      },

      documentElementScroll: function getDEScrollHeight() {
        return document.documentElement.scrollHeight;
      },

      max: function getMaxHeight() {
        return Math.max.apply(null, getAllMeasurements(getHeight));
      },

      min: function getMinHeight() {
        return Math.min.apply(null, getAllMeasurements(getHeight));
      },

      grow: function growHeight() {
        return getHeight.max(); //Run max without the forced downsizing
      },

      lowestElement: function getBestHeight() {
        return Math.max(
          getHeight.bodyOffset() || getHeight.documentElementOffset(),
          getMaxElement('bottom', getAllElements())
        );
      },

      taggedElement: function getTaggedElementsHeight() {
        return getTaggedElements('bottom', 'data-iframe-height');
      }
    },
    getWidth = {
      bodyScroll: function getBodyScrollWidth() {
        return document.body.scrollWidth;
      },

      bodyOffset: function getBodyOffsetWidth() {
        return document.body.offsetWidth;
      },

      custom: function getCustomWidth() {
        return customCalcMethods.width();
      },

      documentElementScroll: function getDEScrollWidth() {
        return document.documentElement.scrollWidth;
      },

      documentElementOffset: function getDEOffsetWidth() {
        return document.documentElement.offsetWidth;
      },

      scroll: function getMaxWidth() {
        return Math.max(
          getWidth.bodyScroll(),
          getWidth.documentElementScroll()
        );
      },

      max: function getMaxWidth() {
        return Math.max.apply(null, getAllMeasurements(getWidth));
      },

      min: function getMinWidth() {
        return Math.min.apply(null, getAllMeasurements(getWidth));
      },

      rightMostElement: function rightMostElement() {
        return getMaxElement('right', getAllElements());
      },

      taggedElement: function getTaggedElementsWidth() {
        return getTaggedElements('right', 'data-iframe-width');
      }
    };

  function sizeIFrame(
    triggerEvent,
    triggerEventDesc,
    customHeight,
    customWidth
  ) {
    function resizeIFrame() {
      height = currentHeight;
      width = currentWidth;

      sendMsg(height, width, triggerEvent);
    }

    function isSizeChangeDetected() {
      function checkTolarance(a, b) {
        var retVal = Math.abs(a - b) <= tolerance;
        return !retVal;
      }

      currentHeight =
        undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
      currentWidth =
        undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();

      return (
        checkTolarance(height, currentHeight) ||
        (calculateWidth && checkTolarance(width, currentWidth))
      );
    }

    function isForceResizableEvent() {
      return !(triggerEvent in { init: 1, interval: 1, size: 1 });
    }

    function isForceResizableCalcMode() {
      return (
        heightCalcMode in resetRequiredMethods ||
        (calculateWidth && widthCalcMode in resetRequiredMethods)
      );
    }

    function logIgnored() {
      log('No change in size detected');
    }

    function checkDownSizing() {
      if (isForceResizableEvent() && isForceResizableCalcMode()) {
        resetIFrame(triggerEventDesc);
      } else if (!(triggerEvent in { interval: 1 })) {
        logIgnored();
      }
    }

    var currentHeight, currentWidth;

    if (isSizeChangeDetected() || 'init' === triggerEvent) {
      lockTrigger();
      resizeIFrame();
    } else {
      checkDownSizing();
    }
  }

  var sizeIFrameThrottled = throttle(sizeIFrame);

  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
    function recordTrigger() {
      if (!(triggerEvent in { reset: 1, resetPage: 1, init: 1 })) {
        log('Trigger event: ' + triggerEventDesc);
      }
    }

    function isDoubleFiredEvent() {
      return triggerLocked && triggerEvent in doubleEventList;
    }

    if (!isDoubleFiredEvent()) {
      recordTrigger();
      if (triggerEvent === 'init') {
        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
      } else {
        sizeIFrameThrottled(
          triggerEvent,
          triggerEventDesc,
          customHeight,
          customWidth
        );
      }
    } else {
      log('Trigger event cancelled: ' + triggerEvent);
    }
  }

  function lockTrigger() {
    if (!triggerLocked) {
      triggerLocked = true;
      log('Trigger event lock on');
    }
    clearTimeout(triggerLockedTimer);
    triggerLockedTimer = setTimeout(function() {
      triggerLocked = false;
      log('Trigger event lock off');
      log('--');
    }, eventCancelTimer);
  }

  function triggerReset(triggerEvent) {
    height = getHeight[heightCalcMode]();
    width = getWidth[widthCalcMode]();

    sendMsg(height, width, triggerEvent);
  }

  function resetIFrame(triggerEventDesc) {
    var hcm = heightCalcMode;
    heightCalcMode = heightCalcModeDefault;

    log('Reset trigger event: ' + triggerEventDesc);
    lockTrigger();
    triggerReset('reset');

    heightCalcMode = hcm;
  }

  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
    function setTargetOrigin() {
      if (undefined === targetOrigin) {
        targetOrigin = targetOriginDefault;
      } else {
        log('Message targetOrigin: ' + targetOrigin);
      }
    }

    function sendToParent() {
      var size = height + ':' + width,
        message =
          myID +
          ':' +
          size +
          ':' +
          triggerEvent +
          (undefined !== msg ? ':' + msg : '');

      log('Sending message to host page (' + message + ')');
      target.postMessage(msgID + message, targetOrigin);
    }

    if (true === sendPermit) {
      setTargetOrigin();
      sendToParent();
    }
  }

  function receiver(event) {
    var processRequestFromParent = {
      init: function initFromParent() {
        initMsg = event.data;
        target = event.source;

        init();
        firstRun = false;
        setTimeout(function() {
          initLock = false;
        }, eventCancelTimer);
      },

      reset: function resetFromParent() {
        if (!initLock) {
          log('Page size reset by host page');
          triggerReset('resetPage');
        } else {
          log('Page reset ignored by init');
        }
      },

      resize: function resizeFromParent() {
        sendSize('resizeParent', 'Parent window requested size check');
      },

      moveToAnchor: function moveToAnchorF() {
        inPageLinks.findTarget(getData());
      },
      inPageLink: function inPageLinkF() {
        this.moveToAnchor();
      }, //Backward compatability

      pageInfo: function pageInfoFromParent() {
        var msgBody = getData();
        log('PageInfoFromParent called from parent: ' + msgBody);
        pageInfoCallback(JSON.parse(msgBody));
        log(' --');
      },

      message: function messageFromParent() {
        var msgBody = getData();

        log('MessageCallback called from parent: ' + msgBody);
        messageCallback(JSON.parse(msgBody));
        log(' --');
      }
    };

    function isMessageForUs() {
      return msgID === ('' + event.data).substr(0, msgIdLen); //''+ Protects against non-string messages
    }

    function getMessageType() {
      return event.data.split(']')[1].split(':')[0];
    }

    function getData() {
      return event.data.substr(event.data.indexOf(':') + 1);
    }

    function isMiddleTier() {
      return (
        (!( true && module.exports) &&
          'iFrameResize' in window) ||
        ('jQuery' in window && 'iFrameResize' in window.jQuery.prototype)
      );
    }

    function isInitMsg() {
      //Test if this message is from a child below us. This is an ugly test, however, updating
      //the message format would break backwards compatibity.
      return event.data.split(':')[2] in { true: 1, false: 1 };
    }

    function callFromParent() {
      var messageType = getMessageType();

      if (messageType in processRequestFromParent) {
        processRequestFromParent[messageType]();
      } else if (!isMiddleTier() && !isInitMsg()) {
        warn('Unexpected message (' + event.data + ')');
      }
    }

    function processMessage() {
      if (false === firstRun) {
        callFromParent();
      } else if (isInitMsg()) {
        processRequestFromParent.init();
      } else {
        log(
          'Ignored message of type "' +
            getMessageType() +
            '". Received before initialization.'
        );
      }
    }

    if (isMessageForUs()) {
      processMessage();
    }
  }

  //Normally the parent kicks things off when it detects the iFrame has loaded.
  //If this script is async-loaded, then tell parent page to retry init.
  function chkLateLoaded() {
    if ('loading' !== document.readyState) {
      window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
  }

  addEventListener(window, 'message', receiver);
  addEventListener(window, 'readystatechange', chkLateLoaded);
  chkLateLoaded();

  
})();


/***/ }),

/***/ 1197:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */

(function(undefined) {
  'use strict';

  if (typeof window === 'undefined') return; // don't run for server side render

  var count = 0,
    logEnabled = false,
    hiddenCheckEnabled = false,
    msgHeader = 'message',
    msgHeaderLen = msgHeader.length,
    msgId = '[iFrameSizer]', //Must match iframe msg ID
    msgIdLen = msgId.length,
    pagePosition = null,
    requestAnimationFrame = window.requestAnimationFrame,
    resetRequiredMethods = {
      max: 1,
      scroll: 1,
      bodyScroll: 1,
      documentElementScroll: 1
    },
    settings = {},
    timer = null,
    logId = 'Host Page',
    defaults = {
      autoResize: true,
      bodyBackground: null,
      bodyMargin: null,
      bodyMarginV1: 8,
      bodyPadding: null,
      checkOrigin: true,
      inPageLinks: false,
      enablePublicMethods: true,
      heightCalculationMethod: 'bodyOffset',
      id: 'iFrameResizer',
      interval: 32,
      log: false,
      maxHeight: Infinity,
      maxWidth: Infinity,
      minHeight: 0,
      minWidth: 0,
      resizeFrom: 'parent',
      scrolling: false,
      sizeHeight: true,
      sizeWidth: false,
      warningTimeout: 5000,
      tolerance: 0,
      widthCalculationMethod: 'scroll',
      closedCallback: function() {},
      initCallback: function() {},
      messageCallback: function() {
        warn('MessageCallback function not defined');
      },
      resizedCallback: function() {},
      scrollCallback: function() {
        return true;
      }
    };

  function getMutationObserver() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  }

  function addEventListener(obj, evt, func) {
    /* istanbul ignore else */ // Not testable in PhantonJS
    if ('addEventListener' in window) {
      obj.addEventListener(evt, func, false);
    } else if ('attachEvent' in window) {
      //IE
      obj.attachEvent('on' + evt, func);
    }
  }

  function removeEventListener(el, evt, func) {
    /* istanbul ignore else */ // Not testable in phantonJS
    if ('removeEventListener' in window) {
      el.removeEventListener(evt, func, false);
    } else if ('detachEvent' in window) {
      //IE
      el.detachEvent('on' + evt, func);
    }
  }

  function setupRequestAnimationFrame() {
    var vendors = ['moz', 'webkit', 'o', 'ms'],
      x;

    // Remove vendor prefixing if prefixed and break early if not
    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    }

    if (!requestAnimationFrame) {
      log('setup', 'RequestAnimationFrame not supported');
    }
  }

  function getMyID(iframeId) {
    var retStr = 'Host page: ' + iframeId;

    if (window.top !== window.self) {
      if (window.parentIFrame && window.parentIFrame.getId) {
        retStr = window.parentIFrame.getId() + ': ' + iframeId;
      } else {
        retStr = 'Nested host page: ' + iframeId;
      }
    }

    return retStr;
  }

  function formatLogHeader(iframeId) {
    return msgId + '[' + getMyID(iframeId) + ']';
  }

  function isLogEnabled(iframeId) {
    return settings[iframeId] ? settings[iframeId].log : logEnabled;
  }

  function log(iframeId, msg) {
    output('log', iframeId, msg, isLogEnabled(iframeId));
  }

  function info(iframeId, msg) {
    output('info', iframeId, msg, isLogEnabled(iframeId));
  }

  function warn(iframeId, msg) {
    output('warn', iframeId, msg, true);
  }

  function output(type, iframeId, msg, enabled) {
    if (true === enabled && 'object' === typeof window.console) {
      console[type](formatLogHeader(iframeId), msg);
    }
  }

  function iFrameListener(event) {
    function resizeIFrame() {
      function resize() {
        setSize(messageData);
        setPagePosition(iframeId);
        callback('resizedCallback', messageData);
      }

      ensureInRange('Height');
      ensureInRange('Width');

      syncResize(resize, messageData, 'init');
    }

    function processMsg() {
      var data = msg.substr(msgIdLen).split(':');

      return {
        iframe: settings[data[0]] && settings[data[0]].iframe,
        id: data[0],
        height: data[1],
        width: data[2],
        type: data[3]
      };
    }

    function ensureInRange(Dimension) {
      var max = Number(settings[iframeId]['max' + Dimension]),
        min = Number(settings[iframeId]['min' + Dimension]),
        dimension = Dimension.toLowerCase(),
        size = Number(messageData[dimension]);

      log(
        iframeId,
        'Checking ' + dimension + ' is in range ' + min + '-' + max
      );

      if (size < min) {
        size = min;
        log(iframeId, 'Set ' + dimension + ' to min value');
      }

      if (size > max) {
        size = max;
        log(iframeId, 'Set ' + dimension + ' to max value');
      }

      messageData[dimension] = '' + size;
    }

    function isMessageFromIFrame() {
      function checkAllowedOrigin() {
        function checkList() {
          var i = 0,
            retCode = false;

          log(
            iframeId,
            'Checking connection is from allowed list of origins: ' +
              checkOrigin
          );

          for (; i < checkOrigin.length; i++) {
            if (checkOrigin[i] === origin) {
              retCode = true;
              break;
            }
          }
          return retCode;
        }

        function checkSingle() {
          var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
          log(iframeId, 'Checking connection is from: ' + remoteHost);
          return origin === remoteHost;
        }

        return checkOrigin.constructor === Array ? checkList() : checkSingle();
      }

      var origin = event.origin,
        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;

      if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) {
        throw new Error(
          'Unexpected message received from: ' +
            origin +
            ' for ' +
            messageData.iframe.id +
            '. Message was: ' +
            event.data +
            '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
        );
      }

      return true;
    }

    function isMessageForUs() {
      return (
        msgId === ('' + msg).substr(0, msgIdLen) &&
        msg.substr(msgIdLen).split(':')[0] in settings
      ); //''+Protects against non-string msg
    }

    function isMessageFromMetaParent() {
      //Test if this message is from a parent above us. This is an ugly test, however, updating
      //the message format would break backwards compatibity.
      var retCode = messageData.type in { true: 1, false: 1, undefined: 1 };

      if (retCode) {
        log(iframeId, 'Ignoring init message from meta parent page');
      }

      return retCode;
    }

    function getMsgBody(offset) {
      return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
    }

    function forwardMsgFromIFrame(msgBody) {
      log(
        iframeId,
        'MessageCallback passed: {iframe: ' +
          messageData.iframe.id +
          ', message: ' +
          msgBody +
          '}'
      );
      callback('messageCallback', {
        iframe: messageData.iframe,
        message: JSON.parse(msgBody)
      });
      log(iframeId, '--');
    }

    function getPageInfo() {
      var bodyPosition = document.body.getBoundingClientRect(),
        iFramePosition = messageData.iframe.getBoundingClientRect();

      return JSON.stringify({
        iframeHeight: iFramePosition.height,
        iframeWidth: iFramePosition.width,
        clientHeight: Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        ),
        clientWidth: Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        ),
        offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
        offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
        scrollTop: window.pageYOffset,
        scrollLeft: window.pageXOffset
      });
    }

    function sendPageInfoToIframe(iframe, iframeId) {
      function debouncedTrigger() {
        trigger(
          'Send Page Info',
          'pageInfo:' + getPageInfo(),
          iframe,
          iframeId
        );
      }
      debounceFrameEvents(debouncedTrigger, 32, iframeId);
    }

    function startPageInfoMonitor() {
      function setListener(type, func) {
        function sendPageInfo() {
          if (settings[id]) {
            sendPageInfoToIframe(settings[id].iframe, id);
          } else {
            stop();
          }
        }

        ['scroll', 'resize'].forEach(function(evt) {
          log(id, type + evt + ' listener for sendPageInfo');
          func(window, evt, sendPageInfo);
        });
      }

      function stop() {
        setListener('Remove ', removeEventListener);
      }

      function start() {
        setListener('Add ', addEventListener);
      }

      var id = iframeId; //Create locally scoped copy of iFrame ID

      start();

      if (settings[id]) {
        settings[id].stopPageInfo = stop;
      }
    }

    function stopPageInfoMonitor() {
      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
        settings[iframeId].stopPageInfo();
        delete settings[iframeId].stopPageInfo;
      }
    }

    function checkIFrameExists() {
      var retBool = true;

      if (null === messageData.iframe) {
        warn(iframeId, 'IFrame (' + messageData.id + ') not found');
        retBool = false;
      }
      return retBool;
    }

    function getElementPosition(target) {
      var iFramePosition = target.getBoundingClientRect();

      getPagePosition(iframeId);

      return {
        x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
        y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
      };
    }

    function scrollRequestFromChild(addOffset) {
      /* istanbul ignore next */ //Not testable in Karma
      function reposition() {
        pagePosition = newPosition;
        scrollTo();
        log(iframeId, '--');
      }

      function calcOffset() {
        return {
          x: Number(messageData.width) + offset.x,
          y: Number(messageData.height) + offset.y
        };
      }

      function scrollParent() {
        if (window.parentIFrame) {
          window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
            newPosition.x,
            newPosition.y
          );
        } else {
          warn(
            iframeId,
            'Unable to scroll to requested position, window.parentIFrame not found'
          );
        }
      }

      var offset = addOffset
          ? getElementPosition(messageData.iframe)
          : { x: 0, y: 0 },
        newPosition = calcOffset();

      log(
        iframeId,
        'Reposition requested from iFrame (offset x:' +
          offset.x +
          ' y:' +
          offset.y +
          ')'
      );

      if (window.top !== window.self) {
        scrollParent();
      } else {
        reposition();
      }
    }

    function scrollTo() {
      if (false !== callback('scrollCallback', pagePosition)) {
        setPagePosition(iframeId);
      } else {
        unsetPagePosition();
      }
    }

    function findTarget(location) {
      function jumpToTarget() {
        var jumpPosition = getElementPosition(target);

        log(
          iframeId,
          'Moving to in page link (#' +
            hash +
            ') at x: ' +
            jumpPosition.x +
            ' y: ' +
            jumpPosition.y
        );
        pagePosition = {
          x: jumpPosition.x,
          y: jumpPosition.y
        };

        scrollTo();
        log(iframeId, '--');
      }

      function jumpToParent() {
        if (window.parentIFrame) {
          window.parentIFrame.moveToAnchor(hash);
        } else {
          log(
            iframeId,
            'In page link #' +
              hash +
              ' not found and window.parentIFrame not found'
          );
        }
      }

      var hash = location.split('#')[1] || '',
        hashData = decodeURIComponent(hash),
        target =
          document.getElementById(hashData) ||
          document.getElementsByName(hashData)[0];

      if (target) {
        jumpToTarget();
      } else if (window.top !== window.self) {
        jumpToParent();
      } else {
        log(iframeId, 'In page link #' + hash + ' not found');
      }
    }

    function callback(funcName, val) {
      return chkCallback(iframeId, funcName, val);
    }

    function actionMsg() {
      if (settings[iframeId] && settings[iframeId].firstRun) firstRun();

      switch (messageData.type) {
        case 'close':
          if (settings[iframeId].closeRequestCallback)
            chkCallback(
              iframeId,
              'closeRequestCallback',
              settings[iframeId].iframe
            );
          else closeIFrame(messageData.iframe);
          break;
        case 'message':
          forwardMsgFromIFrame(getMsgBody(6));
          break;
        case 'scrollTo':
          scrollRequestFromChild(false);
          break;
        case 'scrollToOffset':
          scrollRequestFromChild(true);
          break;
        case 'pageInfo':
          sendPageInfoToIframe(
            settings[iframeId] && settings[iframeId].iframe,
            iframeId
          );
          startPageInfoMonitor();
          break;
        case 'pageInfoStop':
          stopPageInfoMonitor();
          break;
        case 'inPageLink':
          findTarget(getMsgBody(9));
          break;
        case 'reset':
          resetIFrame(messageData);
          break;
        case 'init':
          resizeIFrame();
          callback('initCallback', messageData.iframe);
          break;
        default:
          resizeIFrame();
      }
    }

    function hasSettings(iframeId) {
      var retBool = true;

      if (!settings[iframeId]) {
        retBool = false;
        warn(
          messageData.type +
            ' No settings for ' +
            iframeId +
            '. Message was: ' +
            msg
        );
      }

      return retBool;
    }

    function iFrameReadyMsgReceived() {
      for (var iframeId in settings) {
        trigger(
          'iFrame requested init',
          createOutgoingMsg(iframeId),
          document.getElementById(iframeId),
          iframeId
        );
      }
    }

    function firstRun() {
      if (settings[iframeId]) {
        settings[iframeId].firstRun = false;
      }
    }

    function clearWarningTimeout() {
      if (settings[iframeId]) {
        clearTimeout(settings[iframeId].msgTimeout);
        settings[iframeId].warningTimeout = 0;
      }
    }

    var msg = event.data,
      messageData = {},
      iframeId = null;

    if ('[iFrameResizerChild]Ready' === msg) {
      iFrameReadyMsgReceived();
    } else if (isMessageForUs()) {
      messageData = processMsg();
      iframeId = logId = messageData.id;
      if (settings[iframeId]) {
        settings[iframeId].loaded = true;
      }

      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
        log(iframeId, 'Received: ' + msg);

        if (checkIFrameExists() && isMessageFromIFrame()) {
          actionMsg();
        }
      }
    } else {
      info(iframeId, 'Ignored: ' + msg);
    }
  }

  function chkCallback(iframeId, funcName, val) {
    var func = null,
      retVal = null;

    if (settings[iframeId]) {
      func = settings[iframeId][funcName];

      if ('function' === typeof func) {
        retVal = func(val);
      } else {
        throw new TypeError(
          funcName + ' on iFrame[' + iframeId + '] is not a function'
        );
      }
    }

    return retVal;
  }

  function removeIframeListeners(iframe) {
    var iframeId = iframe.id;
    delete settings[iframeId];
  }

  function closeIFrame(iframe) {
    var iframeId = iframe.id;
    log(iframeId, 'Removing iFrame: ' + iframeId);

    try {
      // Catch race condition error with React
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    } catch (e) {}

    chkCallback(iframeId, 'closedCallback', iframeId);
    log(iframeId, '--');
    removeIframeListeners(iframe);
  }

  function getPagePosition(iframeId) {
    if (null === pagePosition) {
      pagePosition = {
        x:
          window.pageXOffset !== undefined
            ? window.pageXOffset
            : document.documentElement.scrollLeft,
        y:
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : document.documentElement.scrollTop
      };
      log(
        iframeId,
        'Get page position: ' + pagePosition.x + ',' + pagePosition.y
      );
    }
  }

  function setPagePosition(iframeId) {
    if (null !== pagePosition) {
      window.scrollTo(pagePosition.x, pagePosition.y);
      log(
        iframeId,
        'Set page position: ' + pagePosition.x + ',' + pagePosition.y
      );
      unsetPagePosition();
    }
  }

  function unsetPagePosition() {
    pagePosition = null;
  }

  function resetIFrame(messageData) {
    function reset() {
      setSize(messageData);
      trigger('reset', 'reset', messageData.iframe, messageData.id);
    }

    log(
      messageData.id,
      'Size reset requested by ' +
        ('init' === messageData.type ? 'host page' : 'iFrame')
    );
    getPagePosition(messageData.id);
    syncResize(reset, messageData, 'reset');
  }

  function setSize(messageData) {
    function setDimension(dimension) {
      if (!messageData.id) {
        log('undefined', 'messageData id not set');
        return;
      }
      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
      log(
        messageData.id,
        'IFrame (' +
          iframeId +
          ') ' +
          dimension +
          ' set to ' +
          messageData[dimension] +
          'px'
      );
    }

    function chkZero(dimension) {
      //FireFox sets dimension of hidden iFrames to zero.
      //So if we detect that set up an event to check for
      //when iFrame becomes visible.

      /* istanbul ignore next */ //Not testable in PhantomJS
      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
        hiddenCheckEnabled = true;
        log(iframeId, 'Hidden iFrame detected, creating visibility listener');
        fixHiddenIFrames();
      }
    }

    function processDimension(dimension) {
      setDimension(dimension);
      chkZero(dimension);
    }

    var iframeId = messageData.iframe.id;

    if (settings[iframeId]) {
      if (settings[iframeId].sizeHeight) {
        processDimension('height');
      }
      if (settings[iframeId].sizeWidth) {
        processDimension('width');
      }
    }
  }

  function syncResize(func, messageData, doNotSync) {
    /* istanbul ignore if */ //Not testable in PhantomJS
    if (doNotSync !== messageData.type && requestAnimationFrame) {
      log(messageData.id, 'Requesting animation frame');
      requestAnimationFrame(func);
    } else {
      func();
    }
  }

  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
    function postMessageToIFrame() {
      var target = settings[id] && settings[id].targetOrigin;
      log(
        id,
        '[' +
          calleeMsg +
          '] Sending msg to iframe[' +
          id +
          '] (' +
          msg +
          ') targetOrigin: ' +
          target
      );
      iframe.contentWindow.postMessage(msgId + msg, target);
    }

    function iFrameNotFound() {
      warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
    }

    function chkAndSend() {
      if (
        iframe &&
        'contentWindow' in iframe &&
        null !== iframe.contentWindow
      ) {
        //Null test for PhantomJS
        postMessageToIFrame();
      } else {
        iFrameNotFound();
      }
    }

    function warnOnNoResponse() {
      function warning() {
        if (settings[id] && !settings[id].loaded && !errorShown) {
          errorShown = true;
          warn(
            id,
            'IFrame has not responded within ' +
              settings[id].warningTimeout / 1000 +
              ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.'
          );
        }
      }

      if (
        !!noResponseWarning &&
        settings[id] &&
        !!settings[id].warningTimeout
      ) {
        settings[id].msgTimeout = setTimeout(
          warning,
          settings[id].warningTimeout
        );
      }
    }

    var errorShown = false;

    id = id || iframe.id;

    if (settings[id]) {
      chkAndSend();
      warnOnNoResponse();
    }
  }

  function createOutgoingMsg(iframeId) {
    return (
      iframeId +
      ':' +
      settings[iframeId].bodyMarginV1 +
      ':' +
      settings[iframeId].sizeWidth +
      ':' +
      settings[iframeId].log +
      ':' +
      settings[iframeId].interval +
      ':' +
      settings[iframeId].enablePublicMethods +
      ':' +
      settings[iframeId].autoResize +
      ':' +
      settings[iframeId].bodyMargin +
      ':' +
      settings[iframeId].heightCalculationMethod +
      ':' +
      settings[iframeId].bodyBackground +
      ':' +
      settings[iframeId].bodyPadding +
      ':' +
      settings[iframeId].tolerance +
      ':' +
      settings[iframeId].inPageLinks +
      ':' +
      settings[iframeId].resizeFrom +
      ':' +
      settings[iframeId].widthCalculationMethod
    );
  }

  function setupIFrame(iframe, options) {
    function setLimits() {
      function addStyle(style) {
        if (
          Infinity !== settings[iframeId][style] &&
          0 !== settings[iframeId][style]
        ) {
          iframe.style[style] = settings[iframeId][style] + 'px';
          log(
            iframeId,
            'Set ' + style + ' = ' + settings[iframeId][style] + 'px'
          );
        }
      }

      function chkMinMax(dimension) {
        if (
          settings[iframeId]['min' + dimension] >
          settings[iframeId]['max' + dimension]
        ) {
          throw new Error(
            'Value for min' +
              dimension +
              ' can not be greater than max' +
              dimension
          );
        }
      }

      chkMinMax('Height');
      chkMinMax('Width');

      addStyle('maxHeight');
      addStyle('minHeight');
      addStyle('maxWidth');
      addStyle('minWidth');
    }

    function newId() {
      var id = (options && options.id) || defaults.id + count++;
      if (null !== document.getElementById(id)) {
        id = id + count++;
      }
      return id;
    }

    function ensureHasId(iframeId) {
      logId = iframeId;
      if ('' === iframeId) {
        iframe.id = iframeId = newId();
        logEnabled = (options || {}).log;
        logId = iframeId;
        log(
          iframeId,
          'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')'
        );
      }

      return iframeId;
    }

    function setScrolling() {
      log(
        iframeId,
        'IFrame scrolling ' +
          (settings[iframeId] && settings[iframeId].scrolling
            ? 'enabled'
            : 'disabled') +
          ' for ' +
          iframeId
      );
      iframe.style.overflow =
        false === (settings[iframeId] && settings[iframeId].scrolling)
          ? 'hidden'
          : 'auto';
      switch (settings[iframeId] && settings[iframeId].scrolling) {
        case 'omit':
          break;
        case true:
          iframe.scrolling = 'yes';
          break;
        case false:
          iframe.scrolling = 'no';
          break;
        default:
          iframe.scrolling = settings[iframeId]
            ? settings[iframeId].scrolling
            : 'no';
      }
    }

    //The V1 iFrame script expects an int, where as in V2 expects a CSS
    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
    //and then convert V2 to a string PX value.
    function setupBodyMarginValues() {
      if (
        'number' ===
          typeof (settings[iframeId] && settings[iframeId].bodyMargin) ||
        '0' === (settings[iframeId] && settings[iframeId].bodyMargin)
      ) {
        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
        settings[iframeId].bodyMargin =
          '' + settings[iframeId].bodyMargin + 'px';
      }
    }

    function checkReset() {
      // Reduce scope of firstRun to function, because IE8's JS execution
      // context stack is borked and this value gets externally
      // changed midway through running this function!!!
      var firstRun = settings[iframeId] && settings[iframeId].firstRun,
        resetRequertMethod =
          settings[iframeId] &&
          settings[iframeId].heightCalculationMethod in resetRequiredMethods;

      if (!firstRun && resetRequertMethod) {
        resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' });
      }
    }

    function setupIFrameObject() {
      if (Function.prototype.bind && settings[iframeId]) {
        //Ignore unpolyfilled IE8.
        settings[iframeId].iframe.iFrameResizer = {
          close: closeIFrame.bind(null, settings[iframeId].iframe),

          removeListeners: removeIframeListeners.bind(
            null,
            settings[iframeId].iframe
          ),

          resize: trigger.bind(
            null,
            'Window resize',
            'resize',
            settings[iframeId].iframe
          ),

          moveToAnchor: function(anchor) {
            trigger(
              'Move to anchor',
              'moveToAnchor:' + anchor,
              settings[iframeId].iframe,
              iframeId
            );
          },

          sendMessage: function(message) {
            message = JSON.stringify(message);
            trigger(
              'Send Message',
              'message:' + message,
              settings[iframeId].iframe,
              iframeId
            );
          }
        };
      }
    }

    //We have to call trigger twice, as we can not be sure if all
    //iframes have completed loading when this code runs. The
    //event listener also catches the page changing in the iFrame.
    function init(msg) {
      function iFrameLoaded() {
        trigger('iFrame.onload', msg, iframe, undefined, true);
        checkReset();
      }

      function createDestroyObserver(MutationObserver) {
        if (!iframe.parentNode) {
          return;
        }

        var destroyObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            var removedNodes = Array.prototype.slice.call(mutation.removedNodes); // Transform NodeList into an Array
            removedNodes.forEach(function (removedNode) {
              if (removedNode === iframe) {
                closeIFrame(iframe);
              }
            });
          });
        });
        destroyObserver.observe(iframe.parentNode, {
          childList: true
        });
      }

      var MutationObserver = getMutationObserver();
      if (MutationObserver) {
        createDestroyObserver(MutationObserver);
      }

      addEventListener(iframe, 'load', iFrameLoaded);
      trigger('init', msg, iframe, undefined, true);
    }

    function checkOptions(options) {
      if ('object' !== typeof options) {
        throw new TypeError('Options is not an object');
      }
    }

    function copyOptions(options) {
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option)) {
          settings[iframeId][option] = options.hasOwnProperty(option)
            ? options[option]
            : defaults[option];
        }
      }
    }

    function getTargetOrigin(remoteHost) {
      return '' === remoteHost || 'file://' === remoteHost ? '*' : remoteHost;
    }

    function processOptions(options) {
      options = options || {};
      settings[iframeId] = {
        firstRun: true,
        iframe: iframe,
        remoteHost: iframe.src
          .split('/')
          .slice(0, 3)
          .join('/')
      };

      checkOptions(options);
      copyOptions(options);

      if (settings[iframeId]) {
        settings[iframeId].targetOrigin =
          true === settings[iframeId].checkOrigin
            ? getTargetOrigin(settings[iframeId].remoteHost)
            : '*';
      }
    }

    function beenHere() {
      return iframeId in settings && 'iFrameResizer' in iframe;
    }

    var iframeId = ensureHasId(iframe.id);

    if (!beenHere()) {
      processOptions(options);
      setScrolling();
      setLimits();
      setupBodyMarginValues();
      init(createOutgoingMsg(iframeId));
      setupIFrameObject();
    } else {
      warn(iframeId, 'Ignored iFrame, already setup.');
    }
  }

  function debouce(fn, time) {
    if (null === timer) {
      timer = setTimeout(function() {
        timer = null;
        fn();
      }, time);
    }
  }

  var frameTimer = {};
  function debounceFrameEvents(fn, time, frameId) {
    if (!frameTimer[frameId]) {
      frameTimer[frameId] = setTimeout(function() {
        frameTimer[frameId] = null;
        fn();
      }, time);
    }
  } //Not testable in PhantomJS

  /* istanbul ignore next */ function fixHiddenIFrames() {
    function checkIFrames() {
      function checkIFrame(settingId) {
        function chkDimension(dimension) {
          return (
            '0px' ===
            (settings[settingId] && settings[settingId].iframe.style[dimension])
          );
        }

        function isVisible(el) {
          return null !== el.offsetParent;
        }

        if (
          settings[settingId] &&
          isVisible(settings[settingId].iframe) &&
          (chkDimension('height') || chkDimension('width'))
        ) {
          trigger(
            'Visibility change',
            'resize',
            settings[settingId].iframe,
            settingId
          );
        }
      }

      for (var settingId in settings) {
        checkIFrame(settingId);
      }
    }

    function mutationObserved(mutations) {
      log(
        'window',
        'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type
      );
      debouce(checkIFrames, 16);
    }

    function createMutationObserver() {
      var target = document.querySelector('body'),
        config = {
          attributes: true,
          attributeOldValue: false,
          characterData: true,
          characterDataOldValue: false,
          childList: true,
          subtree: true
        },
        observer = new MutationObserver(mutationObserved);

      observer.observe(target, config);
    }

    var MutationObserver = getMutationObserver();
    if (MutationObserver) {
      createMutationObserver();
    }
  }

  function resizeIFrames(event) {
    function resize() {
      sendTriggerMsg('Window ' + event, 'resize');
    }

    log('window', 'Trigger event: ' + event);
    debouce(resize, 16);
  } //Not testable in PhantomJS

  /* istanbul ignore next */ function tabVisible() {
    function resize() {
      sendTriggerMsg('Tab Visable', 'resize');
    }

    if ('hidden' !== document.visibilityState) {
      log('document', 'Trigger event: Visiblity change');
      debouce(resize, 16);
    }
  }

  function sendTriggerMsg(eventName, event) {
    function isIFrameResizeEnabled(iframeId) {
      return (
        settings[iframeId] &&
        'parent' === settings[iframeId].resizeFrom &&
        settings[iframeId].autoResize &&
        !settings[iframeId].firstRun
      );
    }

    for (var iframeId in settings) {
      if (isIFrameResizeEnabled(iframeId)) {
        trigger(eventName, event, document.getElementById(iframeId), iframeId);
      }
    }
  }

  function setupEventListeners() {
    addEventListener(window, 'message', iFrameListener);

    addEventListener(window, 'resize', function() {
      resizeIFrames('resize');
    });

    addEventListener(document, 'visibilitychange', tabVisible);
    addEventListener(document, '-webkit-visibilitychange', tabVisible); //Andriod 4.4
    addEventListener(window, 'focusin', function() {
      resizeIFrames('focus');
    }); //IE8-9
    addEventListener(window, 'focus', function() {
      resizeIFrames('focus');
    });
  }

  function factory() {
    function init(options, element) {
      function chkType() {
        if (!element.tagName) {
          throw new TypeError('Object is not a valid DOM element');
        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
          throw new TypeError(
            'Expected <IFRAME> tag, found <' + element.tagName + '>'
          );
        }
      }

      if (element) {
        chkType();
        setupIFrame(element, options);
        iFrames.push(element);
      }
    }

    function warnDeprecatedOptions(options) {
      if (options && options.enablePublicMethods) {
        warn(
          'enablePublicMethods option has been removed, public methods are now always available in the iFrame'
        );
      }
    }

    var iFrames;

    setupRequestAnimationFrame();
    setupEventListeners();

    return function iFrameResizeF(options, target) {
      iFrames = []; //Only return iFrames past in on this call

      warnDeprecatedOptions(options);

      switch (typeof target) {
        case 'undefined':
        case 'string':
          Array.prototype.forEach.call(
            document.querySelectorAll(target || 'iframe'),
            init.bind(undefined, options)
          );
          break;
        case 'object':
          init(options, target);
          break;
        default:
          throw new TypeError('Unexpected data type (' + typeof target + ')');
      }

      return iFrames;
    };
  }

  function createJQueryPublicMethod($) {
    if (!$.fn) {
      info('', 'Unable to bind to jQuery, it is not fully loaded.');
    } else if (!$.fn.iFrameResize) {
      $.fn.iFrameResize = function $iFrameResizeF(options) {
        function init(index, element) {
          setupIFrame(element, options);
        }

        return this.filter('iframe')
          .each(init)
          .end();
      };
    }
  }

  if (window.jQuery) {
    createJQueryPublicMethod(window.jQuery);
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
  window.iFrameResize = window.iFrameResize || factory();
})();


/***/ }),

/***/ 5670:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

exports.iframeResizer = __webpack_require__(1197);
/* unused reexport */ __webpack_require__(7441);


/***/ }),

/***/ 2429:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ esm_image)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
;// CONCATENATED MODULE: ./node_modules/@core-front/image/node_modules/@core-front/error-provider/esm/error-provider.js

const defaultContext = {
    log: (message) => console.error(message),
};
const ErrorContext = external_react_.createContext(defaultContext);
const ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const error_provider = ((/* unused pure expression or super */ null && (ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@core-front/image/node_modules/@core-front/error-provider/esm/use-log.js


const useErrorLog = () => {
    return external_react_.useContext(ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@core-front/image/esm/image.js


const getPlaceholder = (aspectRatio) => {
    if (aspectRatio) {
        return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${aspectRatio.width} ${aspectRatio.height}"%3E%3C/svg%3E`;
    }
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
};
const ImageImg = (props) => {
    const BEM = () => {
        const classArray = ['image', 'lazyload'];
        if (props.shape) {
            classArray.push('image--' + props.shape);
        }
        if (props.align) {
            classArray.push('image--' + props.align);
        }
        if (props.isInactive) {
            classArray.push('image--inactive');
        }
        if (props.noFade) {
            classArray.push('image--no-fade');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("img", { key: props.src || props.srcset, src: getPlaceholder(props.aspectRatio), "data-src": props.src, "data-srcset": props.srcset, "data-sizes": props.srcset ? 'auto' : undefined, className: BEM(), alt: props.role === 'presentation' ? '' : props.alt, width: props.width, onError: props.onError, onLoad: props.onLoad, style: props.style, ref: props.imageRef }));
};
const ImagePicture = (props) => {
    return (external_react_.createElement("picture", { className: props.pictureClassName },
        props.sources.map((item, index) => {
            return (external_react_.createElement("source", { key: index, srcSet: item.aspectRatio && getPlaceholder(item.aspectRatio), "data-srcset": item.srcset, media: `(min-width: ${item.minWidth})` }));
        }),
        external_react_.createElement(ImageImg, Object.assign({}, props))));
};
const Image = (props) => {
    const { role, alt, src, sources, srcset } = props;
    const { log } = useErrorLog();
    external_react_.useEffect(() => {
        if (role !== 'presentation' && !alt) {
            const srcIndentifier = src ? `src: ${src}` : undefined;
            const srcSetIndentifier = srcset ? `srcset: ${srcset}` : undefined;
            log(`react-front: image is missing required alt prop (${srcSetIndentifier || srcIndentifier})`);
        }
    }, [role, alt, src, srcset, log]);
    return sources ? external_react_.createElement(ImagePicture, Object.assign({}, props, { sources: sources })) : external_react_.createElement(ImageImg, Object.assign({}, props));
};
/* harmony default export */ const esm_image = (Image);


/***/ }),

/***/ 8606:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ InputProvider),
/* harmony export */   "r": () => (/* binding */ InputContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8388);
/* harmony import */ var what_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);
/* harmony import */ var what_input__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(what_input__WEBPACK_IMPORTED_MODULE_1__);



const InputContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    input: 'initial',
});
const InputProvider = (props) => {
    const [input, setInput] = react__WEBPACK_IMPORTED_MODULE_0__.useState('initial');
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        what_input__WEBPACK_IMPORTED_MODULE_1___default().registerOnChange(/* istanbul ignore next */ (nextInput) => {
            setInput((prevInput) => {
                if (prevInput === 'keyboard' && nextInput === 'mouse' &&
                    (document.activeElement && (0,tabbable__WEBPACK_IMPORTED_MODULE_2__/* .isTabbable */ .Wq)(document.activeElement))) {
                    /**
                     * Some screen readers, like NVDA, trigger a mouse click when tabbable elements are activated via Space/Enter.
                     * This causes what-input to trigger a change event.
                     * In components that depend on "automatic dynamic trigger", e.g. where mouse input always has hover listeners and keyboard input has click listeners (for example: Tooltip, HeaderNav), this results as the toggleable element not opening at all when using NVDA.
                     */
                    return prevInput;
                }
                return nextInput;
            });
        }, 'intent');
        setInput(what_input__WEBPACK_IMPORTED_MODULE_1___default().ask('intent'));
        return () => what_input__WEBPACK_IMPORTED_MODULE_1___default().unRegisterOnChange(setInput);
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContext.Provider, { value: { input } }, props.children));
};



/***/ }),

/***/ 3571:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Accordion": () => (/* reexport */ accordion),
  "AccordionArrow": () => (/* reexport */ AccordionArrow),
  "AccordionArrowCore": () => (/* reexport */ AccordionArrowCore),
  "AccordionContent": () => (/* reexport */ AccordionContent),
  "AccordionContext": () => (/* reexport */ AccordionContext),
  "AccordionCore": () => (/* reexport */ accordion_core),
  "AccordionHeader": () => (/* reexport */ AccordionHeader),
  "AccordionHeaderCore": () => (/* reexport */ AccordionHeaderCore),
  "AccordionItem": () => (/* reexport */ AccordionItem),
  "AccordionItemContext": () => (/* reexport */ AccordionItemContext),
  "AccordionItemCore": () => (/* reexport */ accordion_item_core),
  "AccordionItemInner": () => (/* reexport */ AccordionItemInner),
  "AccordionMeta": () => (/* reexport */ AccordionMeta),
  "AccordionTitle": () => (/* reexport */ AccordionTitle),
  "AccordionTitleCore": () => (/* reexport */ AccordionTitleCore),
  "Affix": () => (/* reexport */ Affix),
  "AnalyticsContext": () => (/* reexport */ analytics_provider/* AnalyticsContext */.fC),
  "AnalyticsProvider": () => (/* reexport */ analytics_provider/* default */.ZP),
  "AnalyticsTrigger": () => (/* reexport */ analytics_trigger/* default */.Z),
  "Anchor": () => (/* reexport */ esm_anchor),
  "AnchorCore": () => (/* reexport */ anchor_core),
  "Badge": () => (/* reexport */ Badge),
  "BadgeCore": () => (/* reexport */ BadgeCore),
  "BodyScroll": () => (/* reexport */ body_scroll),
  "Breadcrumbs": () => (/* reexport */ Breadcrumbs),
  "BreadcrumbsCore": () => (/* reexport */ BreadcrumbsCore),
  "BreadcrumbsItemCore": () => (/* reexport */ BreadcrumbsItemCore),
  "Button": () => (/* reexport */ Button),
  "ButtonCore": () => (/* reexport */ ButtonCore),
  "Card": () => (/* reexport */ Card),
  "CardBottom": () => (/* reexport */ CardBottom),
  "CardBottomCore": () => (/* reexport */ card_bottom_core/* default */.Z),
  "CardContent": () => (/* reexport */ CardContent),
  "CardContentCore": () => (/* reexport */ card_content_core/* default */.Z),
  "CardContext": () => (/* reexport */ card_core/* CardContext */.H0),
  "CardCore": () => (/* reexport */ card_core/* default */.ZP),
  "CardFooter": () => (/* reexport */ CardFooter),
  "CardFooterCore": () => (/* reexport */ card_footer_core/* default */.Z),
  "CardHeader": () => (/* reexport */ CardHeader),
  "CardHeaderCore": () => (/* reexport */ card_header_core/* default */.Z),
  "CardOld": () => (/* reexport */ CardOld),
  "CardOldBottom": () => (/* reexport */ CardOldBottom),
  "CardOldBottomCore": () => (/* reexport */ CardOldBottomCore),
  "CardOldContent": () => (/* reexport */ CardOldContent),
  "CardOldContentCore": () => (/* reexport */ CardOldContentCore),
  "CardOldContext": () => (/* reexport */ CardOldContext),
  "CardOldCore": () => (/* reexport */ CardOldCore),
  "CardOldFooter": () => (/* reexport */ CardOldFooter),
  "CardOldFooterCore": () => (/* reexport */ CardOldFooterCore),
  "CardOldHeader": () => (/* reexport */ CardOldHeader),
  "CardOldHeaderCore": () => (/* reexport */ CardOldHeaderCore),
  "CardOldTop": () => (/* reexport */ card_old_top_CardTop),
  "CardOldTopCore": () => (/* reexport */ CardOldTopCore),
  "CardResponsiveCore": () => (/* reexport */ card_core/* CardResponsiveCore */.sT),
  "CardTop": () => (/* reexport */ CardTop),
  "CardTopCore": () => (/* reexport */ card_top_core/* default */.Z),
  "Carousel": () => (/* reexport */ Carousel),
  "CarouselCore": () => (/* reexport */ carousel_core),
  "CarouselItem": () => (/* reexport */ CarouselItem),
  "CarouselItemCore": () => (/* reexport */ CarouselItemCore),
  "ChartLegend": () => (/* reexport */ ChartLegend),
  "ChartPie": () => (/* reexport */ ChartPie),
  "ChartPieCore": () => (/* reexport */ ChartPieCore),
  "Check": () => (/* reexport */ check),
  "CheckCore": () => (/* reexport */ check_core),
  "Chip": () => (/* reexport */ Chip),
  "ChipCore": () => (/* reexport */ ChipCore),
  "ChoiceGroup": () => (/* reexport */ ChoiceGroup),
  "ChoiceGroupCore": () => (/* reexport */ ChoiceGroupCore),
  "ClearButton": () => (/* reexport */ ClearButton),
  "ClearButtonCore": () => (/* reexport */ ClearButtonCore),
  "CloseButton": () => (/* reexport */ CloseButton),
  "CloseButtonCore": () => (/* reexport */ CloseButtonCore),
  "Collapse": () => (/* reexport */ collapse),
  "CollapseContext": () => (/* reexport */ CollapseContext),
  "CollapseCore": () => (/* reexport */ collapse_core),
  "CollapseProvider": () => (/* reexport */ collapse_provider),
  "CollapseProviderCore": () => (/* reexport */ collapse_provider_core),
  "CollapseToggle": () => (/* reexport */ CollapseToggle),
  "CollapseToggleCore": () => (/* reexport */ CollapseToggleCore),
  "CollapseTrigger": () => (/* reexport */ CollapseTrigger),
  "Container": () => (/* reexport */ Container),
  "CookieConsentContext": () => (/* reexport */ cookie_consent_provider/* CookieConsentContext */.Q),
  "CookieConsentProvider": () => (/* reexport */ cookie_consent_provider/* default */.Z),
  "CookieNotice": () => (/* reexport */ CookieNotice),
  "CookieNoticeCore": () => (/* reexport */ CookieNoticeCore),
  "Datepicker": () => (/* reexport */ Datepicker),
  "DatepickerColumn": () => (/* reexport */ datepicker_column_DatepickerColumn),
  "DatepickerColumnCore": () => (/* reexport */ DatepickerColumn),
  "DatepickerCore": () => (/* reexport */ DatepickerCore),
  "DatepickerInnerCore": () => (/* reexport */ DatepickerInnerCore),
  "DatepickerOption": () => (/* reexport */ DatePickerOption),
  "Dropdown": () => (/* reexport */ dropdown),
  "DropdownCore": () => (/* reexport */ dropdown_core),
  "EqualHeight": () => (/* reexport */ equal_height),
  "EqualHeightContext": () => (/* reexport */ EqualHeightContext),
  "EqualHeightCore": () => (/* reexport */ EqualHeight),
  "EqualHeightProvider": () => (/* reexport */ equal_height_provider),
  "EqualHeightProviderCore": () => (/* reexport */ equal_height_provider_core),
  "ErrorContext": () => (/* reexport */ error_provider_ErrorContext),
  "ErrorProvider": () => (/* reexport */ esm_error_provider),
  "EuIcon": () => (/* reexport */ EuIcon),
  "EuIconCore": () => (/* reexport */ EuIconCore),
  "FeatureList": () => (/* reexport */ FeatureList),
  "FeatureListCore": () => (/* reexport */ feature_list_core),
  "FeatureListItem": () => (/* reexport */ feature_list_item),
  "FeatureListItemCore": () => (/* reexport */ feature_list_item_core),
  "FileField": () => (/* reexport */ filefield),
  "FileFieldCore": () => (/* reexport */ filefield_core),
  "Fittext": () => (/* reexport */ esm_fittext),
  "FittextCore": () => (/* reexport */ fittext_core),
  "FormHelper": () => (/* reexport */ FormHelper),
  "FormHelperCore": () => (/* reexport */ FormHelperCore),
  "Grid": () => (/* reexport */ grid),
  "GridColumn": () => (/* reexport */ grid_column),
  "HashTrigger": () => (/* reexport */ HashTrigger),
  "HeaderContext": () => (/* reexport */ HeaderContext),
  "HeaderProvider": () => (/* reexport */ HeaderProvider),
  "Heading": () => (/* reexport */ Heading),
  "HorizontalProgress": () => (/* reexport */ HorizontalProgress),
  "HorizontalProgressCore": () => (/* reexport */ HorizontalProgressCore),
  "HorizontalProgressItem": () => (/* reexport */ HorizontalProgressItem),
  "HorizontalProgressItemCore": () => (/* reexport */ HorizontalProgressItemCore),
  "Icon": () => (/* reexport */ esm_icon),
  "Iframe": () => (/* reexport */ iframe),
  "IframeCore": () => (/* reexport */ IframeCore),
  "Image": () => (/* reexport */ esm_image/* default */.Z),
  "InputContext": () => (/* reexport */ input_provider/* InputContext */.r),
  "InputProvider": () => (/* reexport */ input_provider/* default */.Z),
  "LabelContext": () => (/* reexport */ LabelContext),
  "LabelProvider": () => (/* reexport */ label_provider),
  "Languages": () => (/* reexport */ languages),
  "LanguagesCore": () => (/* reexport */ languages_core),
  "List": () => (/* reexport */ List),
  "ListContext": () => (/* reexport */ ListContext),
  "ListItem": () => (/* reexport */ ListItem),
  "ListItemCore": () => (/* reexport */ ListItemCore),
  "Logo": () => (/* reexport */ Logo),
  "LogoCore": () => (/* reexport */ LogoCore),
  "Main": () => (/* reexport */ Main),
  "MainContent": () => (/* reexport */ MainContent),
  "MainContext": () => (/* reexport */ MainContext),
  "MainCore": () => (/* reexport */ MainCore),
  "MainFooter": () => (/* reexport */ MainFooter),
  "MainHeader": () => (/* reexport */ MainHeader),
  "MainPage": () => (/* reexport */ MainPage),
  "MiniForm": () => (/* reexport */ mini_form),
  "MiniFormCore": () => (/* reexport */ mini_form_core),
  "MiniHeader": () => (/* reexport */ mini_header),
  "MiniHeaderCore": () => (/* reexport */ mini_header_core),
  "Modal": () => (/* reexport */ modal),
  "ModalCloser": () => (/* reexport */ modal_closer),
  "ModalContent": () => (/* reexport */ modal_content),
  "ModalContext": () => (/* reexport */ ModalContext),
  "ModalCore": () => (/* reexport */ ModalCore),
  "ModalCover": () => (/* reexport */ ModalCover),
  "ModalCoverCore": () => (/* reexport */ modal_cover_core),
  "ModalFooter": () => (/* reexport */ modal_footer),
  "ModalProvider": () => (/* reexport */ modal_provider),
  "ModalProviderCore": () => (/* reexport */ modal_provider_core),
  "ModalTrigger": () => (/* reexport */ modal_trigger),
  "Notice": () => (/* reexport */ Notice),
  "NoticeCore": () => (/* reexport */ notice_core),
  "Number": () => (/* reexport */ number_Number),
  "NumberCore": () => (/* reexport */ NumberCore),
  "ObjectFit": () => (/* reexport */ object_fit/* default */.Z),
  "ObjectFitCore": () => (/* reexport */ object_fit_core/* default */.Z),
  "OptionCard": () => (/* reexport */ OptionCard),
  "OptionCardContent": () => (/* reexport */ option_card_content),
  "OptionCardContentCore": () => (/* reexport */ option_card_content_core),
  "OptionCardCore": () => (/* reexport */ OptionCardCore),
  "OptionCardFooter": () => (/* reexport */ option_card_footer),
  "OptionCardFooterCore": () => (/* reexport */ option_card_footer_core),
  "OptionCardGroup": () => (/* reexport */ OptionCardGroup),
  "OptionCardGroupCore": () => (/* reexport */ option_card_group_core),
  "OptionCardOld": () => (/* reexport */ option_card_old),
  "OptionCardOldContent": () => (/* reexport */ OptionCardOldContent),
  "OptionCardOldCore": () => (/* reexport */ option_card_old_core),
  "OptionCardOldFooter": () => (/* reexport */ option_card_old_footer),
  "OptionCardOldGroup": () => (/* reexport */ option_card_old_group),
  "OptionCardOldGroupCore": () => (/* reexport */ option_card_old_group_core),
  "Overlay": () => (/* reexport */ Overlay),
  "OverlayCore": () => (/* reexport */ OverlayCore),
  "PageAccess": () => (/* reexport */ page_access),
  "PageHeading": () => (/* reexport */ page_heading),
  "PageHeadingCore": () => (/* reexport */ page_heading_core),
  "PassField": () => (/* reexport */ passfield),
  "PassFieldCore": () => (/* reexport */ passfield_core),
  "PropsChecker": () => (/* reexport */ props_checker),
  "Radio": () => (/* reexport */ esm_radio),
  "RadioCore": () => (/* reexport */ radio_core),
  "ScrollFade": () => (/* reexport */ ScrollFade),
  "ScrollFadeCore": () => (/* reexport */ ScrollFadeCore),
  "Search": () => (/* reexport */ Search),
  "SearchCore": () => (/* reexport */ SearchCore),
  "Select": () => (/* reexport */ select_Select),
  "SelectCore": () => (/* reexport */ SelectCore),
  "Selector": () => (/* reexport */ esm_selector),
  "SelectorCore": () => (/* reexport */ selector_core),
  "Separator": () => (/* reexport */ Separator),
  "SeparatorCore": () => (/* reexport */ SeparatorCore),
  "Signature": () => (/* reexport */ signature),
  "SignatureCore": () => (/* reexport */ signature_core),
  "Skeleton": () => (/* reexport */ skeleton),
  "SkeletonItem": () => (/* reexport */ skeleton_item),
  "SkipLinks": () => (/* reexport */ skip_links),
  "SkipLinksCore": () => (/* reexport */ skip_links_core),
  "Spinner": () => (/* reexport */ Spinner),
  "StopPropagation": () => (/* reexport */ StopPropagation),
  "Suggestion": () => (/* reexport */ suggestion),
  "SuggestionCore": () => (/* reexport */ SuggestionCore),
  "SuggestionField": () => (/* reexport */ suggestionfield),
  "SuggestionFieldCore": () => (/* reexport */ suggestionfield_core),
  "TabCordion": () => (/* reexport */ TabCordion),
  "TabCordionCore": () => (/* reexport */ tab_cordion_core),
  "TabCordionInner": () => (/* reexport */ TabCordionInner),
  "Tabs": () => (/* reexport */ Tabs),
  "TabsCore": () => (/* reexport */ TabsCore),
  "TabsItem": () => (/* reexport */ TabsItem),
  "TabsItemCore": () => (/* reexport */ TabsItemCore),
  "TabsNavCore": () => (/* reexport */ TabsNavCore),
  "TabsNavItemCore": () => (/* reexport */ TabsNavItemCore),
  "Tag": () => (/* reexport */ tag),
  "TagCore": () => (/* reexport */ tag_core),
  "TagGroup": () => (/* reexport */ tag_group),
  "TagGroupCore": () => (/* reexport */ tag_group_core),
  "Text": () => (/* reexport */ esm_text),
  "TextArea": () => (/* reexport */ esm_textarea),
  "TextAreaCore": () => (/* reexport */ TextAreaCore),
  "TextField": () => (/* reexport */ TextField),
  "TextFieldCore": () => (/* reexport */ textfield_core),
  "ThemeContext": () => (/* reexport */ theme_provider_core_ThemeContext),
  "ThemeProvider": () => (/* reexport */ theme_provider_ThemeProvider),
  "ThemeProviderCore": () => (/* reexport */ theme_provider_core),
  "Toggle": () => (/* reexport */ toggle_Toggle),
  "ToggleCore": () => (/* reexport */ Toggle),
  "Tooltip": () => (/* reexport */ tooltip),
  "TooltipColors": () => (/* reexport */ TooltipColors),
  "TooltipCore": () => (/* reexport */ tooltip_core),
  "TooltipInner": () => (/* reexport */ TooltipInner),
  "TooltipToggle": () => (/* reexport */ TooltipToggle),
  "TooltipToggleCore": () => (/* reexport */ TooltipToggleCore),
  "Video": () => (/* reexport */ video),
  "VideoCore": () => (/* reexport */ video_core),
  "VideoCoreInner": () => (/* reexport */ VideoCoreInner),
  "VisibilityContext": () => (/* reexport */ VisibilityContext),
  "VisibilityProvider": () => (/* reexport */ VisibilityProvider),
  "breakPoints": () => (/* reexport */ breakPoints),
  "debounce": () => (/* reexport */ debounce.debounce),
  "defaultContext": () => (/* reexport */ theme_provider_core_defaultContext),
  "disableBodyScroll": () => (/* reexport */ lib_node_modules_core_front_helper_esm_disableBodyScroll),
  "disablePageAccess": () => (/* reexport */ lib_node_modules_core_front_helper_esm_disablePageAccess),
  "doScrolling": () => (/* reexport */ lib_node_modules_core_front_helper_esm_doScrolling),
  "enableBodyScroll": () => (/* reexport */ lib_node_modules_core_front_helper_esm_enableBodyScroll),
  "enablePageAccess": () => (/* reexport */ lib_node_modules_core_front_helper_esm_enablePageAccess),
  "getClosestDateInRange": () => (/* reexport */ getClosestDateInRange),
  "getDate": () => (/* reexport */ getDate),
  "getDefaultPageTopOffset": () => (/* reexport */ lib_node_modules_core_front_helper_esm_getDefaultPageTopOffset),
  "getDefaultViewDate": () => (/* reexport */ getDefaultViewDate),
  "getHashArray": () => (/* reexport */ lib_node_modules_core_front_helper_esm_getHashArray),
  "getOffsetFromParent": () => (/* reexport */ lib_node_modules_core_front_helper_esm_getOffsetFromParent),
  "getParameterByName": () => (/* reexport */ lib_node_modules_core_front_helper_esm_getParameterByName),
  "getParentsUntil": () => (/* reexport */ lib_node_modules_core_front_helper_esm_getParentsUntil),
  "getRange": () => (/* reexport */ getRange),
  "getRangesFromTimes": () => (/* reexport */ getRangesFromTimes),
  "getSelectedTimeIndex": () => (/* reexport */ getSelectedTimeIndex),
  "getValueFromInputValue": () => (/* reexport */ getValueFromInputValue),
  "isDateInDateRange": () => (/* reexport */ isDateInDateRange),
  "isDateRange": () => (/* reexport */ isDateRange),
  "isEqualRange": () => (/* reexport */ isEqualRange),
  "isEqualValue": () => (/* reexport */ isEqualValue),
  "isHeaderOpen": () => (/* reexport */ lib_node_modules_core_front_helper_esm_isHeaderOpen),
  "isOnScreen": () => (/* reexport */ lib_node_modules_core_front_helper_esm_isOnScreen),
  "isSame": () => (/* reexport */ isSame),
  "isScrollDisabled": () => (/* reexport */ lib_node_modules_core_front_helper_esm_isScrollDisabled),
  "isSuggestionGroup": () => (/* reexport */ isSuggestionGroup),
  "numToString": () => (/* reexport */ lib_node_modules_core_front_helper_esm_numToString),
  "offset": () => (/* reexport */ lib_node_modules_core_front_helper_esm_offset),
  "replaceParams": () => (/* reexport */ replaceParams),
  "scrollToElement": () => (/* reexport */ lib_node_modules_core_front_helper_esm_scrollToElement),
  "setDocumentScrollTop": () => (/* reexport */ lib_node_modules_core_front_helper_esm_setDocumentScrollTop),
  "stringToNum": () => (/* reexport */ lib_node_modules_core_front_helper_esm_stringToNum),
  "swingTo": () => (/* reexport */ lib_node_modules_core_front_helper_esm_swingTo),
  "throwIfInvalidRange": () => (/* reexport */ throwIfInvalidRange),
  "useAnalytics": () => (/* reexport */ analytics_provider/* useAnalytics */.z$),
  "useCurrentBreakPoint": () => (/* reexport */ useCurrentBreakPoint),
  "useErrorLog": () => (/* reexport */ use_log_useErrorLog),
  "useFormat": () => (/* reexport */ useFormat),
  "useIsMounted": () => (/* reexport */ useIsMounted),
  "useLabels": () => (/* reexport */ useLabels),
  "usePrevious": () => (/* reexport */ usePrevious),
  "useResponsiveProps": () => (/* reexport */ useResponsiveProps),
  "useTheme": () => (/* reexport */ useTheme)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(7111);
// EXTERNAL MODULE: ./node_modules/@react-front/polyfill/index.js
var polyfill = __webpack_require__(6155);
// EXTERNAL MODULE: ./node_modules/@core-front/analytics/esm/analytics-trigger/analytics-trigger.js
var analytics_trigger = __webpack_require__(6341);
;// CONCATENATED MODULE: ./node_modules/@core-front/props-checker/node_modules/@core-front/error-provider/esm/error-provider.js

const defaultContext = {
    log: (message) => console.error(message),
};
const ErrorContext = external_react_.createContext(defaultContext);
const ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const error_provider = ((/* unused pure expression or super */ null && (ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@core-front/props-checker/node_modules/@core-front/error-provider/esm/use-log.js


const useErrorLog = () => {
    return external_react_.useContext(ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@core-front/props-checker/esm/props-checker.js


const PropsChecker = (props) => {
    const { componentName, componentProps, defaultValueName, valueName, onChangeNames, onChangeAltNames, isComponentDisabled, children, } = props;
    const { log } = useErrorLog();
    const isInitial = external_react_.useRef(true);
    const didWarnControlledToUncontrolled = external_react_.useRef(false);
    const didWarnUncontrolledToControlled = external_react_.useRef(false);
    const checkHasOnChange = () => {
        const onChangeNamesArray = Array.isArray(onChangeNames) ? onChangeNames : [onChangeNames];
        const onChangeAltNamesArray = Array.isArray(onChangeAltNames) ? onChangeAltNames : (onChangeAltNames ? [onChangeAltNames] : []);
        return onChangeNamesArray.every((onChangeName) => !!componentProps[onChangeName])
            || onChangeAltNamesArray && onChangeAltNamesArray.length > 0 && onChangeAltNamesArray.every((onChangeName) => !!componentProps[onChangeName]);
    };
    const hasOnChange = checkHasOnChange();
    const checkIsControlled = () => {
        const isDefined = typeof componentProps[valueName] !== 'undefined';
        if (isComponentDisabled) {
            return isDefined;
        }
        return hasOnChange && isDefined;
    };
    const newIsControlled = checkIsControlled();
    const isControlledRef = external_react_.useRef(newIsControlled);
    external_react_.useEffect(() => {
        function hasValuePropWithoutOnChangeProp() {
            return typeof componentProps[valueName] !== 'undefined' && !hasOnChange;
        }
        function formattedNames(names) {
            if (Array.isArray(names)) {
                return names.join(', ');
            }
            return names;
        }
        if (isInitial.current && hasValuePropWithoutOnChangeProp() && !isComponentDisabled) {
            log(`You provided a "${valueName}" prop without an "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} handler in "${componentName}" component. ` +
                `If the state is handled outside component, set "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} prop. Otherwise use "${defaultValueName}" prop.`);
            isInitial.current = false;
        }
    }, [componentName, componentProps, defaultValueName, hasOnChange, isComponentDisabled, onChangeAltNames, onChangeNames, valueName, log]);
    external_react_.useEffect(() => {
        if (!isControlledRef.current && newIsControlled && !didWarnUncontrolledToControlled.current) {
            log(`The "${componentName}" component is changing from uncontrolled to be controlled. ` +
                `This is likely caused by the "${valueName}" changing from undefined to ` +
                'a defined value, which should not happen.');
            didWarnUncontrolledToControlled.current = true;
        }
        if (isControlledRef.current && !newIsControlled && !didWarnControlledToUncontrolled.current) {
            log(`The "${componentName}" component is changing from controlled to be uncontrolled. ` +
                `This is likely caused by the "${valueName}" changing from a defined to ` +
                'undefined value, which should not happen.');
            didWarnControlledToUncontrolled.current = true;
        }
        isControlledRef.current = newIsControlled;
    }, [componentProps, componentName, didWarnUncontrolledToControlled, didWarnControlledToUncontrolled, newIsControlled, valueName, log]);
    return (external_react_.createElement(external_react_.Fragment, null, children));
};
/* harmony default export */ const props_checker = (PropsChecker);

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion/accordion-core.js




const AccordionCore = (props) => {
    const getContent = () => {
        if (props.disableAnalyticsTrigger) {
            return external_react_.createElement(AccordionCoreInner, Object.assign({}, props));
        }
        return (external_react_.createElement(analytics_trigger/* default */.Z, { trigger: [
                {
                    callback: 'onOpen',
                    id: ([id]) => {
                        return `Accordion - ${id}`;
                    },
                    elementId: ([id]) => {
                        return `${id}`;
                    },
                    elementType: 'accordion',
                    interactionType: 'open',
                },
                {
                    callback: 'onClose',
                    id: ([id]) => {
                        return `Accordion - ${id}`;
                    },
                    elementId: ([id]) => {
                        return `${id}`;
                    },
                    elementType: 'accordion',
                    interactionType: 'close',
                },
            ] },
            external_react_.createElement(AccordionCoreInner, Object.assign({}, props))));
    };
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "Accordion", defaultValueName: "defaultOpenItem", valueName: "openItem", onChangeNames: "onToggle" }, getContent()));
};
class AccordionCoreInner extends external_react_.Component {
    static getOpenItems(items) {
        return (Array.isArray(items) ? items : (items ? [items] : []));
    }
    constructor(props) {
        super(props);
        this.setOpenItems = (id, isOpen) => {
            const openItems = this.getNewOpenItems(id, isOpen);
            if (!this.isControlled) {
                this.setState({ openItems });
            }
            if (this.props.onToggle && !this.props.multiple) {
                this.props.onToggle(openItems.length ? openItems[0] : null);
            }
            else if (this.props.onToggle && this.props.multiple) {
                this.props.onToggle(openItems);
            }
            if (isOpen && this.props.onOpen) {
                this.props.onOpen(id);
            }
            else if (this.props.onClose) {
                this.props.onClose(id);
            }
        };
        this.state = {
            openItems: AccordionCoreInner.getOpenItems(props.defaultOpenItem),
        };
    }
    get isControlled() {
        return typeof this.props.openItem !== 'undefined';
    }
    get openItems() {
        return this.isControlled ? AccordionCoreInner.getOpenItems(this.props.openItem) : this.state.openItems;
    }
    BEM() {
        const classArray = ['accordion'];
        if (this.props.size) {
            classArray.push('accordion--' + this.props.size);
        }
        if (this.props.bordered) {
            classArray.push('accordion--bordered');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getNewOpenItems(id, isOpen) {
        const openItems = this.openItems;
        if (!isOpen) {
            return openItems.filter((i) => i !== id);
        }
        else if (isOpen && this.props.multiple) {
            return [...openItems, id];
        }
        else if (isOpen) {
            return [id];
        }
        return [];
    }
    render() {
        const accordionContextValue = {
            openItems: this.openItems,
            setOpenItems: this.setOpenItems,
        };
        return (external_react_.createElement(AccordionContext.Provider, { value: accordionContextValue },
            external_react_.createElement("div", { className: this.BEM() }, this.props.children)));
    }
}
AccordionCoreInner.defaultProps = {
    bordered: true,
};
/* harmony default export */ const accordion_core = (AccordionCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion/accordion.js


const AccordionContext = external_react_.createContext({
    openItems: [],
    setOpenItems: /* istanbul ignore next */ () => null,
});
const Accordion = (props) => {
    return (external_react_.createElement(accordion_core, Object.assign({}, props)));
};
/* harmony default export */ const accordion = (Accordion);

// EXTERNAL MODULE: ./node_modules/@core-front/icon/esm/icon.js + 2 modules
var icon = __webpack_require__(1858);
;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-item/accordion-item-context.js

const AccordionItemContext = external_react_.createContext({
    accordionRef: /* istanbul ignore next */ () => null,
    id: 'id-0',
    onClick: /* istanbul ignore next */ () => null,
    onMouseEnter: /* istanbul ignore next */ () => null,
    onMouseLeave: /* istanbul ignore next */ () => null,
});

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-arrow/accordion-arrow-core.js


class AccordionArrowCore extends external_react_.Component {
    BEM() {
        const classArray = ['accordion__arrow'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const { Icon } = this.props.components;
        return (external_react_.createElement("a", { className: this.BEM(), href: '#' + this.props.id, onClick: this.props.onClick, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, "aria-hidden": true, tabIndex: -1 },
            external_react_.createElement(Icon, { className: "accordion__arrow-icon", modifiers: "#arrow-down" })));
    }
}
AccordionArrowCore.contextType = AccordionItemContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-arrow/accordion-arrow.js



class AccordionArrow extends external_react_.Component {
    render() {
        return (external_react_.createElement(AccordionArrowCore, Object.assign({}, this.props, { components: {
                Icon: icon/* default */.Z,
            } })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-content/accordion-content.js


class AccordionContent extends external_react_.Component {
    render() {
        return (external_react_.createElement("div", { className: "accordion__body", style: this.context.collapseStyle, ref: this.context.accordionRef },
            external_react_.createElement("div", { className: "accordion__content", id: this.context.id }, this.props.children)));
    }
}
AccordionContent.contextType = AccordionItemContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-header/accordion-header-core.js


class AccordionHeaderCore extends external_react_.Component {
    getArrow() {
        const { AccordionArrow } = this.props.components;
        return (external_react_.createElement(AccordionArrow, { id: this.context.id, onClick: this.context.onClick, onMouseEnter: this.context.onMouseEnter, onMouseLeave: this.context.onMouseLeave }));
    }
    render() {
        return (external_react_.createElement("div", { className: "accordion__header", id: `${this.context.id}-header`, ref: this.props.headerRef },
            external_react_.createElement("div", { className: "accordion__header-inner" },
                this.props.asideContent,
                this.props.children,
                this.props.arrowLocation === 'inner' && this.getArrow()),
            this.props.arrowLocation === 'header' && this.getArrow()));
    }
}
AccordionHeaderCore.contextType = AccordionItemContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-header/accordion-header.js



class AccordionHeader extends external_react_.Component {
    render() {
        return (external_react_.createElement(AccordionHeaderCore, Object.assign({}, this.props, { components: {
                AccordionArrow: AccordionArrow,
            }, arrowLocation: "inner" })));
    }
}

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var esm_Transition = __webpack_require__(660);
// EXTERNAL MODULE: ./node_modules/tabbable/dist/index.esm.js
var index_esm = __webpack_require__(8388);
// EXTERNAL MODULE: ./node_modules/debounce/index.js
var debounce = __webpack_require__(296);
;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/node_modules/@core-front/helper/esm/index.js


let scrollAnimationFrame = 0;
const isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = swingTo(p);
        if (p < 1) {
            scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!(0,index_esm/* isFocusable */.EB)(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-item/accordion-item-core.js





const AccordionItemCore = (props) => {
    const { openItems, setOpenItems } = external_react_.useContext(AccordionContext);
    return (external_react_.createElement(AccordionItemInner, Object.assign({}, props, { isOpen: (openItems && openItems.indexOf(props.id) > -1) || false, onToggle: (isOpen) => setOpenItems(props.id, isOpen) })));
};
/* harmony default export */ const accordion_item_core = (AccordionItemCore);
class AccordionItemInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.accordion = null;
        this.handleTransitionEnd = (event) => {
            const { isOpen } = this.props;
            if (event.target === this.accordion && event.propertyName === 'height') {
                if (isOpen) {
                    this.setExpanded();
                }
                else {
                    this.setCollapsed();
                }
                this.scroll();
                this.setState({
                    isAnimating: false,
                });
            }
        };
        this.onMouseEnter = () => {
            if (!this.state.titleHovered) {
                this.setState({
                    titleHovered: true,
                });
            }
        };
        this.onMouseLeave = () => {
            if (this.state.titleHovered) {
                this.setState({
                    titleHovered: false,
                });
            }
        };
        this.handleMatch = () => {
            this.props.onToggle(true);
        };
        this.handleClick = this.handleClick.bind(this);
        this.isInitial = true;
        this.state = {
            collapseStyle: {
                height: '0px',
                overflow: 'hidden',
                visibility: 'hidden',
            },
            isAnimating: false,
            titleHovered: false,
        };
    }
    componentDidMount() {
        if (this.props.isOpen) {
            this.setExpanded();
        }
    }
    UNSAFE_componentWillReceiveProps() {
        this.isInitial = false;
    }
    componentDidUpdate(prevProps) {
        if (!this.accordion) {
            return;
        }
        if (this.props.isOpen !== prevProps.isOpen && !this.state.isAnimating) {
            this.setState({
                isAnimating: true,
            });
        }
        // expand
        if (this.props.isOpen && !prevProps.isOpen) {
            // have the element transition to the height of its inner content
            this.setContentStyleProperty('height', `${this.accordion.scrollHeight}px`);
            this.setContentStyleProperty('visibility', 'visible');
        }
        else if (!this.props.isOpen && prevProps.isOpen) {
            // collapse
            // explicitly set the element's height to its current pixel height, so we
            // aren't transitioning out of 'auto'
            this.setContentStyleProperty('height', `${this.accordion.scrollHeight}px`);
            requestAnimationFrame(() => {
                // "pausing" the JavaScript execution to let the rendering threads catch up
                // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
                setTimeout(() => {
                    this.setContentStyleProperty('height', '0px');
                    this.setContentStyleProperty('overflow', 'hidden');
                }, 0);
            });
        }
    }
    BEM() {
        const classArray = ['accordion__item'];
        if (this.props.isOpen) {
            classArray.push('is-open');
        }
        if (this.props.isInactive) {
            classArray.push('is-inactive');
        }
        if (this.props.type) {
            classArray.push('accordion__item--' + this.props.type);
            if (!this.props.backgroundColorClass) {
                classArray.push(`accordion__item--${this.props.type}-bg`);
            }
        }
        if (this.props.backgroundColorClass) {
            classArray.push(this.props.backgroundColorClass);
        }
        if (this.props.icon) {
            classArray.push('accordion__item--icon');
        }
        if (this.props.noContent) {
            classArray.push('accordion__item--no-content');
        }
        if (this.state.isAnimating) {
            classArray.push('is-animating');
        }
        if (this.state.titleHovered) {
            classArray.push('is-hovered');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    handleClick(event) {
        event.preventDefault();
        this.props.onToggle(!this.props.isOpen);
    }
    scroll() {
        if (!this.isInitial && this.context.openItems.indexOf(this.props.id) > -1 && !isOnScreen(this.props.id)) {
            scrollToElement(`${this.props.id}-header`);
        }
    }
    getArrow() {
        const { AccordionArrow } = this.props.components;
        return (external_react_.createElement(AccordionArrow, { id: this.props.id, onClick: this.handleClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave }));
    }
    setContentStyleProperty(property, value) {
        this.setState((prevState) => {
            const newStyle = {
                [property]: value,
            };
            return {
                collapseStyle: Object.assign(Object.assign({}, prevState.collapseStyle), newStyle),
            };
        });
    }
    setCollapsed() {
        this.setContentStyleProperty('visibility', 'hidden');
    }
    setExpanded() {
        this.setContentStyleProperty('height', 'auto');
        this.setContentStyleProperty('overflow', 'visible');
        this.setContentStyleProperty('visibility', 'visible');
    }
    render() {
        const accordionItemContextValue = {
            accordionRef: (el) => this.accordion = el,
            collapseStyle: this.state.collapseStyle,
            icon: this.props.icon,
            id: this.props.id,
            isOpen: this.props.isOpen,
            noContent: this.props.noContent,
            onClick: this.handleClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
        };
        const { VisibilityProvider, HashTrigger } = this.props.components;
        return (external_react_.createElement(AccordionItemContext.Provider, { value: accordionItemContextValue },
            external_react_.createElement(VisibilityProvider, { isVisible: this.props.isOpen && !this.state.isAnimating },
                external_react_.createElement(esm_Transition/* default */.ZP, { in: this.props.isOpen, timeout: { enter: 0, exit: 0 } },
                    external_react_.createElement(HashTrigger, { id: this.props.id, onMatch: this.handleMatch, renderWrapper: false },
                        external_react_.createElement("div", { className: this.BEM(), style: this.state.isAnimating ? this.props.style : undefined, onTransitionEnd: this.handleTransitionEnd },
                            external_react_.createElement("div", { className: "accordion__item-inner" }, this.props.children),
                            this.props.shouldRenderArrow && this.getArrow()))))));
    }
}
AccordionItemInner.contextType = AccordionContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/hash-trigger/node_modules/@core-front/helper/esm/index.js


let esm_scrollAnimationFrame = 0;
const esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = esm_swingTo(p);
        if (p < 1) {
            esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!(0,index_esm/* isFocusable */.EB)(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/hash-trigger/esm/hash-trigger.js


const HashTrigger = (props) => {
    const { renderWrapper = true, scrollOnMatch = true, onMatch, id, children, } = props;
    const isInitial = external_react_.useRef(true);
    external_react_.useEffect(() => {
        const handleHashChange = (event) => {
            const hashes = esm_getHashArray();
            if (hashes && hashes.indexOf(id) !== -1) {
                const cb = () => {
                    // trigger scroll only if event was not from autoscroll
                    if (!(event && event.detail && event.detail.fromAutoscroll) && scrollOnMatch) {
                        esm_scrollToElement(id, undefined, undefined, true);
                    }
                };
                if (onMatch) {
                    onMatch(id, true, cb);
                }
                else {
                    cb();
                }
            }
        };
        if (isInitial.current) {
            isInitial.current = false;
            handleHashChange();
        }
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [id, onMatch, scrollOnMatch, isInitial]);
    return renderWrapper ? (external_react_.createElement("div", { id: id }, children)) : (external_react_.createElement(external_react_.Fragment, null, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/visibility-provider/esm/visibility-provider.js

const VisibilityContext = external_react_.createContext({
    isVisible: true,
});
class VisibilityProvider extends external_react_.Component {
    render() {
        return (external_react_.createElement(VisibilityContext.Provider, { value: this.props }, this.props.children));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-item/accordion-item.js





class AccordionItem extends external_react_.Component {
    render() {
        return (external_react_.createElement(accordion_item_core, Object.assign({}, this.props, { components: {
                AccordionArrow: AccordionArrow,
                HashTrigger: HashTrigger,
                VisibilityProvider: VisibilityProvider,
            } })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-meta/accordion-meta.js

class AccordionMeta extends external_react_.Component {
    render() {
        return (external_react_.createElement("div", { className: "accordion__meta" }, this.props.children));
    }
}

// EXTERNAL MODULE: ./node_modules/@core-front/image/esm/image.js + 2 modules
var esm_image = __webpack_require__(2429);
;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-title/accordion-title-core.js


class AccordionTitleCore extends external_react_.Component {
    getIcon() {
        const { Icon, Image } = this.props.components;
        if (!this.context.icon) {
            return null;
        }
        if (typeof this.context.icon === 'string') {
            return (external_react_.createElement("div", { className: "accordion__icon-wrapper" },
                external_react_.createElement(Icon, { className: "accordion__icon", modifiers: this.context.icon })));
        }
        else {
            return (external_react_.createElement("div", { className: "accordion__image-wrapper" },
                external_react_.createElement(Image, Object.assign({}, this.context.icon, { className: "accordion__image" }))));
        }
    }
    getContent() {
        return (external_react_.createElement(external_react_.Fragment, null,
            this.getIcon(),
            external_react_.createElement("div", { className: "accordion__label" }, this.props.children)));
    }
    render() {
        if (this.context.noContent) {
            return (external_react_.createElement("div", { className: "accordion__title" }, this.getContent()));
        }
        return (external_react_.createElement("a", { className: "accordion__title", href: '#' + this.context.id, onClick: this.context.onClick, onMouseEnter: this.context.onMouseEnter, onMouseLeave: this.context.onMouseLeave }, this.getContent()));
    }
}
AccordionTitleCore.contextType = AccordionItemContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/accordion-title/accordion-title.js




class AccordionTitle extends external_react_.Component {
    render() {
        return (external_react_.createElement(AccordionTitleCore, Object.assign({}, this.props, { components: {
                Icon: icon/* default */.Z,
                Image: esm_image/* default */.Z,
            } })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/accordion/esm/index.js














;// CONCATENATED MODULE: ./node_modules/@core-front/header-provider/esm/header-provider.js

const HeaderContext = external_react_.createContext({
    headerBottomHeight: 0,
    headerHeight: 0,
    isHeaderHidden: false,
    setHeaderBottomHeight: /* istanbul ignore next */ () => null,
    setHeaderHeight: /* istanbul ignore next */ () => null,
    toggleHeaderHidden: /* istanbul ignore next */ () => null,
});
const HeaderProvider = (props) => {
    const [headerBottomHeight, setHeaderBottomHeight] = external_react_.useState(0);
    const [headerHeight, setHeaderHeight] = external_react_.useState(0);
    const [isHeaderHidden, toggleHeaderHidden] = external_react_.useState(false);
    return (external_react_.createElement(HeaderContext.Provider, { value: {
            headerBottomHeight,
            headerHeight,
            isHeaderHidden,
            setHeaderBottomHeight,
            setHeaderHeight,
            toggleHeaderHidden,
        } }, props.children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/affix/esm/affix.js


const Affix = (props) => {
    const { className, children, } = props;
    const referenceElement = external_react_.useRef(null);
    const [affixHeight, setAffixHeight] = external_react_.useState(0);
    const [windowsHeight, setWindowsHeight] = external_react_.useState(0);
    const { headerHeight, isHeaderHidden, headerBottomHeight } = external_react_.useContext(HeaderContext);
    external_react_.useEffect(() => {
        setAffixHeight(referenceElement.current && /* istanbul ignore next */ referenceElement.current.clientHeight || 0);
    }, [referenceElement]);
    external_react_.useEffect(() => {
        const resizeListener = () => {
            setWindowsHeight(window.innerHeight - headerHeight - (isHeaderHidden ? headerBottomHeight : 0));
        };
        window.addEventListener('resize', resizeListener);
        resizeListener();
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [headerHeight, isHeaderHidden, headerBottomHeight]);
    const BEM = () => {
        const classArray = ['affix'];
        if (className) {
            classArray.push(className);
        }
        if (affixHeight > windowsHeight) {
            classArray.push('affix--static');
        }
        return classArray.join(' ');
    };
    const getStyle = () => {
        const inModal = referenceElement.current && /* istanbul ignore next */ referenceElement.current.closest('.modal') !== null;
        return {
            top: inModal ? 0 : headerHeight - (isHeaderHidden ? headerBottomHeight : 0),
        };
    };
    return (external_react_.createElement("div", { ref: referenceElement, className: BEM(), style: getStyle(), "aria-hidden": props['aria-hidden'] }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/affix/esm/index.js


// EXTERNAL MODULE: ./node_modules/@core-front/analytics/esm/analytics-provider/analytics-provider.js
var analytics_provider = __webpack_require__(1066);
;// CONCATENATED MODULE: ./node_modules/@core-front/analytics/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/window/esm/index.js
const esm_navigate = (event) => {
    if (window.core && window.core.navigate) {
        window.core.navigate(event);
    }
};

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/anchor/esm/anchor-core.js

const AnchorCore = (props) => {
    const { external = false, } = props;
    const BEM = () => {
        const classArray = ['anchor'];
        if (props.color) {
            classArray.push('anchor--' + props.color);
        }
        if (props.isTextColor) {
            classArray.push('is-text-color');
        }
        if (props.isUnderlined) {
            classArray.push('is-underlined');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const handleClick = (event) => {
        if (!external && props.onClick) {
            props.onClick(event);
        }
    };
    return (external_react_.createElement("a", Object.assign({}, props.attributes, { href: props.url, className: BEM(), onClick: handleClick, id: props.id, target: props.target, ref: props.elementRef, "aria-label": props['aria-label'], "aria-controls": props['aria-controls'], "aria-selected": props['aria-selected'], tabIndex: props.tabIndex, role: props.role }), props.children));
};
/* harmony default export */ const anchor_core = (AnchorCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/anchor/esm/anchor.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const Anchor = (props) => {
    const { isUnderlined = true } = props, rest = __rest(props, ["isUnderlined"]);
    return (external_react_.createElement(anchor_core, Object.assign({ isUnderlined: isUnderlined }, rest)));
};
// defaultProps is used for when a component clones Anchor as it's child,
// child.props.onClick would be defined. For example, AnalyticsTrigger.
// React does not fill child.props from ES6 default values.
Anchor.defaultProps = {
    onClick: esm_navigate,
};
/* harmony default export */ const esm_anchor = (Anchor);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/anchor/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/error-provider/esm/error-provider.js

const error_provider_defaultContext = {
    log: (message) => console.error(message),
};
const error_provider_ErrorContext = external_react_.createContext(error_provider_defaultContext);
const error_provider_ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (external_react_.createElement(error_provider_ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const esm_error_provider = (error_provider_ErrorProvider);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/error-provider/esm/use-log.js


const use_log_useErrorLog = () => {
    return external_react_.useContext(error_provider_ErrorContext);
};


// EXTERNAL MODULE: ./node_modules/@frctl/react/components/index.js
var components = __webpack_require__(3252);
;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/theme-provider/esm/theme-provider-core.js
var theme_provider_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const theme_provider_core_defaultContext = {
    getIconPath: (name) => name,
    breakPoints: {
        xs: 320,
        sm: 600,
        md: 800,
        lg: 1000,
        xl: 1200,
    },
    locale: undefined,
};
const theme_provider_core_ThemeContext = external_react_.createContext(theme_provider_core_defaultContext);
const ThemeProviderCore = (props) => {
    const { children, getIconPath } = props, rest = theme_provider_core_rest(props, ["children", "getIconPath"]);
    const path = (0,components.usePath)();
    return (external_react_.createElement(theme_provider_core_ThemeContext.Provider, { value: Object.assign(Object.assign({}, rest), { getIconPath: (iconPath) => path.get(getIconPath(iconPath)) }) }, children));
};
/* harmony default export */ const theme_provider_core = (ThemeProviderCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/theme-provider/esm/use-theme.js


const useTheme = () => {
    const theme = external_react_.useContext(theme_provider_core_ThemeContext);
    return theme;
};


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/icon/esm/icon.js



const deprecationMap = {
    '#clear': '#close-round',
    '#service-it': 'server',
    '#server-email': '#email',
    '#enduser': '#contact',
    '#file-bills': '#file-bill',
    '#service-box': '#parcel-machine',
    '#close-light': '#close',
    '#star-film': '#star',
    '#service': '#repair',
    '#server-settings': '#settings',
    '#update': '#sync',
    '#processes': '#sync',
    '#feedback': '#chat',
    '#sms': '#chat',
    '#talk-bubble': '#chat',
    '#cloud-line': '#cloud',
    '#activity-monitor': '#watch',
    '#digibox': '#device-digibox',
    '#modem': '#device-router',
    '#mobile-devices': '#devices',
    '#help-round': '#help',
    '#help-circle': '#help',
    '#safe': '#security',
    '#security-internet': '#security',
    '#firewall': '#security',
    '#mailware': '#security',
    '#protective-film': '#security',
    '#music-infinity': '#offering',
    '#service-leasing': '#coins',
    '#play-video': '#video',
    '#play-video-2': '#video',
    '#packet-sport': '#sport',
    '#packet-music': '#music',
    '#packet-russian': '#matryoshka',
    '#packet-lifestyle': '#weather',
    '#packet-children': '#teddybear',
    '#channels': '#service-tv-channels',
    '#arrow-large-down': '#arrow-down',
    '#arrow-large-left': '#arrow-left',
    '#arrow-large-right': '#arrow-right',
    '#arrow-large-up': '#arrow-up',
    '#arrow-medium-down': '#arrow-down',
    '#arrow-medium-left': '#arrow-left',
    '#arrow-medium-right': '#arrow-right',
    '#arrow-medium-up': '#arrow-up',
    '#arrow-left-light': '#arrow-left',
    '#arrow-right-light': '#arrow-right',
    '#plus-circle': '#plus-round',
    '#architecture': '#service-internet',
    '#contact-search': '#search',
    '#internet-lock': '#lock',
    '#minus-circle': '#minus-round',
    '#mobile-simple': '#mobile',
    '#play-round': '#play-circle',
    '#service-business': '#briefcase',
    '#service-tv': '#tv',
    '#speed': '#arrow-up-down',
    '#tech-support': '#technician',
    '#people-arrow': '#user-group',
};
const getAliasName = (name, log) => {
    if (Object.prototype.hasOwnProperty.call(deprecationMap, name)) {
        const substitute = deprecationMap[name];
        log(`"${name}" icon is deprecated. Please use "${substitute}" instead.`);
        return substitute;
    }
    return name;
};
const Icon = (props) => {
    const { getIconPath } = useTheme();
    const { log } = use_log_useErrorLog();
    const name = getAliasName(props.modifiers, log);
    const src = getIconPath(name);
    const BEM = () => {
        const classArray = ['icon'];
        if (props.size) {
            classArray.push('icon--' + props.size);
        }
        if (props.align) {
            classArray.push('icon--align-' + props.align);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("svg", { className: BEM(), style: props.style, focusable: "false" },
        external_react_.createElement("use", { xlinkHref: src, href: src })));
};
/* harmony default export */ const esm_icon = (Icon);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/badge/esm/badge-core.js

const BadgeCore = (props) => {
    const { className, components, icon, purpose, size, text, } = props;
    const BEM = () => {
        const classArray = ['badge'];
        if (purpose) {
            classArray.push('badge--' + purpose);
        }
        if (size) {
            classArray.push('badge--' + size);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getIcon = (icon) => {
        const { Icon } = components;
        return external_react_.createElement(Icon, { className: "badge__icon", modifiers: icon });
    };
    const getText = (text) => {
        return external_react_.createElement("span", { className: "badge__text" }, text);
    };
    return (external_react_.createElement("span", { className: BEM(), "aria-hidden": props['aria-hidden'] },
        icon && getIcon(icon),
        text && getText(text)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/badge/esm/badge.js



const Badge = (props) => {
    return (external_react_.createElement(BadgeCore, Object.assign({}, props, { components: {
            Icon: esm_icon,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/badge/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/breadcrumbs/esm/breadcrumbs-core.js

const BreadcrumbsCore = (props) => {
    const { className, items, components } = props;
    const { BreadcrumbsItem } = components;
    const BEM = () => {
        const classArray = ['breadcrumbs'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("nav", { "aria-label": props['aria-label'], className: BEM() },
        external_react_.createElement("ol", { className: "breadcrumbs__list" }, items.map((item, index) => (external_react_.createElement(BreadcrumbsItem, Object.assign({ key: index }, item)))))));
};


// EXTERNAL MODULE: ./node_modules/@core-front/window/esm/index.js
var esm = __webpack_require__(4358);
;// CONCATENATED MODULE: ./node_modules/@core-front/anchor/esm/anchor-core.js

const anchor_core_AnchorCore = (props) => {
    const { external = false, } = props;
    const BEM = () => {
        const classArray = ['anchor'];
        if (props.color) {
            classArray.push('anchor--' + props.color);
        }
        if (props.isTextColor) {
            classArray.push('is-text-color');
        }
        if (props.isUnderlined) {
            classArray.push('is-underlined');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const handleClick = (event) => {
        if (!external && props.onClick) {
            props.onClick(event);
        }
    };
    return (external_react_.createElement("a", Object.assign({}, props.attributes, { href: props.url, className: BEM(), onClick: handleClick, id: props.id, target: props.target, ref: props.elementRef, "aria-label": props['aria-label'], "aria-controls": props['aria-controls'], "aria-selected": props['aria-selected'], tabIndex: props.tabIndex, role: props.role }), props.children));
};
/* harmony default export */ const esm_anchor_core = (anchor_core_AnchorCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/anchor/esm/anchor.js
var anchor_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const anchor_Anchor = (props) => {
    const { isUnderlined = true } = props, rest = anchor_rest(props, ["isUnderlined"]);
    return (external_react_.createElement(esm_anchor_core, Object.assign({ isUnderlined: isUnderlined }, rest)));
};
// defaultProps is used for when a component clones Anchor as it's child,
// child.props.onClick would be defined. For example, AnalyticsTrigger.
// React does not fill child.props from ES6 default values.
anchor_Anchor.defaultProps = {
    onClick: esm/* navigate */.c,
};
/* harmony default export */ const anchor_esm_anchor = (anchor_Anchor);

;// CONCATENATED MODULE: ./node_modules/@core-front/breadcrumbs/esm/breadcrumbs-item-core.js
var breadcrumbs_item_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const BreadcrumbsItemCore = (props) => {
    const { label, current, components } = props, rest = breadcrumbs_item_core_rest(props, ["label", "current", "components"]);
    const { Anchor, Icon } = components;
    const BEM = () => {
        const classArray = ['breadcrumbs__item'];
        if (current) {
            classArray.push('is-current');
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("li", { className: BEM() },
        external_react_.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: "breadcrumbs__link", attributes: {
                'aria-current': current ? 'page' : undefined,
            } }), label),
        external_react_.createElement(Icon, { modifiers: "#arrow-right", className: "breadcrumbs__icon" })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/breadcrumbs/esm/breadcrumbs-item.js




const BreadcrumbsItem = (props) => {
    return (external_react_.createElement(BreadcrumbsItemCore, Object.assign({}, props, { components: {
            Anchor: anchor_esm_anchor,
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/breadcrumbs/esm/breadcrumbs.js



const Breadcrumbs = (props) => {
    return (external_react_.createElement(BreadcrumbsCore, Object.assign({}, props, { components: {
            BreadcrumbsItem: BreadcrumbsItem,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/breadcrumbs/esm/index.js




// EXTERNAL MODULE: ./node_modules/react-side-effect/lib/index.js
var lib = __webpack_require__(3524);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/@core-front/body-scroll/node_modules/@core-front/helper/esm/index.js


let helper_esm_scrollAnimationFrame = 0;
const helper_esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const helper_esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !helper_esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const helper_esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && helper_esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const helper_esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const helper_esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const helper_esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(helper_esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = helper_esm_swingTo(p);
        if (p < 1) {
            helper_esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const helper_esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || helper_esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!isFocusable(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        helper_esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const helper_esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= helper_esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const helper_esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const helper_esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return helper_esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const helper_esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const helper_esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const helper_esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const helper_esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const helper_esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const helper_esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const helper_esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    helper_esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const helper_esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const helper_esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/body-scroll/esm/body-scroll.js



const BodyScroll = (props) => {
    return external_react_.createElement(external_react_.Fragment, null, props.children);
};
function reducePropsToState(propsList) {
    return propsList.some((props) => props.isDisabled);
}
function handleStateChangeOnClient(isBodyScrollDisabled) {
    if (isBodyScrollDisabled) {
        helper_esm_disableBodyScroll();
    }
    else {
        helper_esm_enableBodyScroll();
    }
}
/* harmony default export */ const body_scroll = (lib_default()(reducePropsToState, handleStateChangeOnClient)(BodyScroll));

;// CONCATENATED MODULE: ./node_modules/@core-front/body-scroll/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/skeleton/esm/skeleton/skeleton.js

const Skeleton = (props) => {
    const { label, className, children } = props;
    const BEM = () => {
        const classArray = ['skeleton'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() },
        external_react_.createElement("div", { className: "skeleton__content", "aria-hidden": true }, children),
        external_react_.createElement("span", { className: "sr-only" }, label)));
};
/* harmony default export */ const skeleton = (Skeleton);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/skeleton/esm/skeleton-item/skeleton-item.js

const SkeletonItem = (props) => {
    const { className, width, height } = props;
    const BEM = () => {
        const classArray = ['skeleton__item'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("span", { className: BEM(), style: { width, height } }, "\u200C"));
};
/* harmony default export */ const skeleton_item = (SkeletonItem);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/spinner/esm/spinner.js

const Spinner = (props) => {
    const { className, text } = props;
    const BEM = () => {
        const classArray = ['spinner'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("span", { className: BEM() },
        external_react_.createElement("svg", { className: "spinner__circle", viewBox: "25 25 50 50", focusable: "false" },
            external_react_.createElement("circle", { className: "spinner__path", cx: "50", cy: "50", r: "22", fill: "none" })),
        text && external_react_.createElement("span", { className: "spinner__text" }, text)));
};


// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(7723);
;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/helper/esm/hooks/use-current-breakpoint.js

function useCurrentBreakPoint(breakPoints) {
    const [breakPoint, setBreakPoint] = external_react_.useState(null);
    external_react_.useEffect(() => {
        const resizeListener = () => {
            const sortedBreakPoints = Object.keys(breakPoints).sort((x, y) => breakPoints[y] - breakPoints[x]);
            const bp = sortedBreakPoints.find((breakPoint) => window.matchMedia(`(min-width: ${breakPoints[breakPoint]}px)`).matches);
            setBreakPoint(bp || 'xs');
        };
        window.addEventListener('resize', resizeListener);
        resizeListener();
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [breakPoints]);
    return breakPoint;
}

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/helper/esm/hooks/use-responsive-props.js

function useResponsiveProps(props) {
    const { responsive, breakPoints } = props;
    const responsiveBreakPoints = responsive.map((resp) => resp.breakPoint);
    const currentBreakPoint = useCurrentBreakPoint(breakPoints);
    const getActiveBreakPoints = (currentBreakPoint, responsiveBP) => {
        const sortedResponsiveBreakPoints = responsiveBP.sort((x, y) => breakPoints[x] - breakPoints[y]);
        return sortedResponsiveBreakPoints.filter((breakPoint) => {
            return breakPoints[breakPoint] <= breakPoints[currentBreakPoint];
        });
    };
    const getResponsiveProps = (breakPoint) => {
        const responsiveObject = responsive.find((resp) => resp.breakPoint === breakPoint);
        /* istanbul ignore else */
        if (responsiveObject) {
            return responsiveObject.props;
        }
    };
    if (!currentBreakPoint) {
        return {};
    }
    const activeBreakPoints = getActiveBreakPoints(currentBreakPoint, responsiveBreakPoints);
    return activeBreakPoints.reduce((acc, breakPoint) => (Object.assign(Object.assign({}, acc), getResponsiveProps(breakPoint))), {});
}

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/button/esm/button-core.js
var button_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const ButtonCore = (props) => {
    const { responsive } = props, rest = button_core_rest(props, ["responsive"]);
    return responsive ? external_react_.createElement(ButtonResponsiveCore, Object.assign({}, rest, { responsive: responsive })) : external_react_.createElement(ButtonInnerCore, Object.assign({}, rest));
};
const ButtonResponsiveCore = (props) => {
    const { responsive } = props, rest = button_core_rest(props, ["responsive"]);
    const { breakPoints } = useTheme();
    const responsiveProps = useResponsiveProps({ breakPoints, responsive });
    return external_react_.createElement(ButtonInnerCore, Object.assign({}, rest, responsiveProps));
};
class ButtonInnerCore extends external_react_.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            if (!this.props.external && this.props.onClick) {
                this.props.onClick(event);
            }
        };
    }
    BEM() {
        const classArray = ['btn'];
        if (this.props.type) {
            classArray.push('btn--' + this.props.type);
        }
        if (this.props.size) {
            classArray.push('btn--' + this.props.size);
        }
        if (this.props.icon) {
            classArray.push('btn--icon-only');
        }
        if (this.props.variant) {
            classArray.push('btn--variant-' + this.props.variant);
        }
        if (this.props.link) {
            classArray.push('btn--link');
            if (this.props.isUnderlined) {
                classArray.push('btn--underlined');
            }
        }
        if (this.props.block) {
            classArray.push('btn--block');
        }
        if (this.props.isActive) {
            classArray.push('is-active');
        }
        if (this.props.isLoading) {
            classArray.push('is-loading');
        }
        if (this.props.verticalAlign) {
            classArray.push('btn--vertical-align-' + this.props.verticalAlign);
        }
        if (this.props.iconRight === '#arrow-right' && !this.props.link) {
            classArray.push('btn--with-arrow-right-icon');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    iconBEM(location) {
        const classArray = ['btn__icon'];
        classArray.push('btn__icon--' + location);
        if (((location === 'left' && this.props.iconLeftSize) || (location === 'right' && this.props.iconRightSize) || (location === 'center' && this.props.iconSize)) && this.props.link) {
            classArray.push('btn__icon--custom-size');
        }
        if (this.props.iconClass) {
            classArray.push(this.props.iconClass);
        }
        return classArray.join(' ');
    }
    iconWrapperBEM(location, size) {
        const classArray = ['btn__icon-wrapper', `btn__icon-wrapper--${location}`];
        if (size) {
            classArray.push(`btn__icon-wrapper--${size}`);
        }
        return classArray.join(' ');
    }
    getIcon(location, modifiers, size) {
        const { Icon } = this.props.components;
        return (external_react_.createElement("span", { className: this.iconWrapperBEM(location, size) },
            external_react_.createElement(Icon, { modifiers: modifiers, size: size, className: this.iconBEM(location) })));
    }
    renderContent() {
        const { Spinner } = this.props.components;
        return (external_react_.createElement(external_react_.Fragment, null,
            this.props.isLoading &&
                (external_react_.createElement(CSSTransition/* default */.Z, { in: this.props.isLoading, timeout: 300, classNames: "fade", unmountOnExit: true },
                    external_react_.createElement(Spinner, { className: "btn__spinner" }))),
            external_react_.createElement("span", { className: "btn__inner" },
                this.props.iconLeft && this.getIcon('left', this.props.iconLeft, this.props.iconLeftSize),
                this.props.icon && this.getIcon('center', this.props.icon, this.props.iconSize),
                external_react_.createElement("span", { className: "btn__text" }, this.props.text),
                this.props.iconRight && this.getIcon('right', this.props.iconRight, this.props.iconRightSize))));
    }
    isAnchor(props) {
        return 'url' in props;
    }
    isSpan(props) {
        return props.element === 'span';
    }
    renderAnchor(props) {
        return (external_react_.createElement("a", Object.assign({}, props.attributes, { 
            // common attributes of a, span, button
            className: this.BEM(), id: props.id, ref: props.buttonRef, "aria-label": this.props.ariaLabel, "aria-expanded": this.props['aria-expanded'], "aria-controls": this.props['aria-controls'], onKeyDown: this.props.onKeyDown, 
            // common attributes of a, button
            onClick: this.handleClick, 
            // a specific attributes
            href: props.url, target: props.target }), this.renderContent()));
    }
    renderSpan(props) {
        return (external_react_.createElement("span", Object.assign({}, props.attributes, { 
            // common attributes of a, span, button
            className: this.BEM(), id: props.id, ref: props.buttonRef, "aria-label": this.props.ariaLabel, "aria-expanded": this.props['aria-expanded'], "aria-controls": this.props['aria-controls'], onKeyDown: this.props.onKeyDown }), this.renderContent()));
    }
    renderButton(props) {
        return (external_react_.createElement("button", Object.assign({}, props.attributes, { 
            // common attributes of a, span, button
            className: this.BEM(), id: props.id, ref: props.buttonRef, "aria-label": this.props.ariaLabel, "aria-expanded": this.props['aria-expanded'], "aria-controls": this.props['aria-controls'], onKeyDown: this.props.onKeyDown, 
            // common attributes of a, button
            onClick: this.handleClick, 
            // button specific attributes
            type: (props.attributes && props.attributes.type) || 'button', disabled: props.disabled }), this.renderContent()));
    }
    renderSkeleton(props) {
        const { components: { Skeleton, SkeletonItem } } = this.props;
        const { skeleton } = props;
        return (external_react_.createElement(Skeleton, { label: skeleton.label },
            external_react_.createElement(SkeletonItem, { className: this.BEM(), width: skeleton.width })));
    }
    render() {
        if ('skeleton' in this.props) {
            return this.renderSkeleton(this.props);
        }
        if (this.isSpan(this.props)) {
            return this.renderSpan(this.props);
        }
        if (this.isAnchor(this.props)) {
            if (this.props.disabled) {
                // type cast as a hack since we need to allow disabling anchor buttons
                // but that is actually not supported in HTML so ¯\_(ツ)_/¯
                return this.renderButton(this.props);
            }
            return this.renderAnchor(this.props);
        }
        return this.renderButton(this.props);
    }
}


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/button/esm/button.js
var button_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const Button = (props) => {
    const { isUnderlined = true } = props, rest = button_rest(props, ["isUnderlined"]);
    return (external_react_.createElement(ButtonCore, Object.assign({}, rest, { isUnderlined: isUnderlined, components: {
            Icon: esm_icon,
            Skeleton: skeleton,
            SkeletonItem: skeleton_item,
            Spinner: Spinner,
        } })));
};
// defaultProps is used for when a component clones Button as it's child,
// child.props.onClick would be defined. For example, AnalyticsTrigger.
// React does not fill child.props from ES6 default values.
Button.defaultProps = {
    onClick: esm_navigate,
};


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/button/esm/index.js



// EXTERNAL MODULE: ./node_modules/@core-front/skeleton/esm/skeleton/skeleton.js
var skeleton_skeleton = __webpack_require__(1127);
// EXTERNAL MODULE: ./node_modules/@core-front/skeleton/esm/skeleton-item/skeleton-item.js
var skeleton_item_skeleton_item = __webpack_require__(4490);
// EXTERNAL MODULE: ./node_modules/@core-front/spinner/esm/spinner.js
var spinner = __webpack_require__(420);
// EXTERNAL MODULE: ./node_modules/@core-front/button/esm/button-core.js
var button_core = __webpack_require__(1687);
;// CONCATENATED MODULE: ./node_modules/@core-front/button/esm/button.js
var esm_button_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const button_Button = (props) => {
    const { isUnderlined = true } = props, rest = esm_button_rest(props, ["isUnderlined"]);
    return (external_react_.createElement(button_core/* default */.Z, Object.assign({}, rest, { isUnderlined: isUnderlined, components: {
            Icon: icon/* default */.Z,
            Skeleton: skeleton_skeleton/* default */.Z,
            SkeletonItem: skeleton_item_skeleton_item/* default */.Z,
            Spinner: spinner/* default */.Z,
        } })));
};
// defaultProps is used for when a component clones Button as it's child,
// child.props.onClick would be defined. For example, AnalyticsTrigger.
// React does not fill child.props from ES6 default values.
button_Button.defaultProps = {
    onClick: esm/* navigate */.c,
};


;// CONCATENATED MODULE: ./node_modules/@core-front/container/esm/container.js

function BEM(props) {
    const classArray = ['container'];
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const Container = (props) => {
    return (external_react_.createElement("div", { className: BEM(props) }, props.children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/grid/esm/grid/grid.js

const GridContext = external_react_.createContext({
    element: 'div',
});
const Grid = (props) => {
    const { align, borderColor, borderWeight, children, className, equalHeight, element: Element = 'div', gridRef, gutter = 'default', horizontalGutter, id, noWrap, onTransitionEnd, reverse, style, verticalGutter, wrap, } = props;
    const BEM = () => {
        const classArray = ['grid', `grid--gutter-${gutter}`];
        if (equalHeight) {
            classArray.push('grid--equalheight');
        }
        if (reverse) {
            for (const i of reverse) {
                classArray.push(`grid--reverse-${i}`);
            }
        }
        if (align) {
            for (const i of align) {
                classArray.push(`grid--${i}`);
            }
        }
        if (horizontalGutter) {
            classArray.push(`grid--horizontal-gutter-${horizontalGutter}`);
        }
        if (verticalGutter) {
            classArray.push(`grid--vertical-gutter-${verticalGutter}`);
        }
        if (noWrap) {
            if (Array.isArray(noWrap)) {
                for (const i of noWrap) {
                    classArray.push(`grid--no-wrap-${i}`);
                }
            }
            else {
                classArray.push('grid--no-wrap-xs');
            }
        }
        if (wrap) {
            for (const i of wrap) {
                classArray.push(`grid--wrap-${i}`);
            }
        }
        if (borderWeight) {
            classArray.push(`grid--border-${borderWeight}`);
        }
        if (borderColor) {
            classArray.push(`grid--border-${borderColor}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const content = (external_react_.createElement(GridContext.Provider, { value: { element: Element } }, children));
    if (Element === 'ul') {
        return (external_react_.createElement(Element, { id: id, className: BEM(), style: style, onTransitionEnd: onTransitionEnd, ref: gridRef }, content));
    }
    if (Element === 'ol') {
        return (external_react_.createElement(Element, { id: id, className: BEM(), style: style, onTransitionEnd: onTransitionEnd, ref: gridRef }, content));
    }
    return (external_react_.createElement(Element, { id: id, className: BEM(), style: style, onTransitionEnd: onTransitionEnd, ref: gridRef }, content));
};
/* harmony default export */ const grid = (Grid);

;// CONCATENATED MODULE: ./node_modules/@core-front/carousel/esm/carousel-item/carousel-item-core.js

class CarouselItemCore extends external_react_.Component {
    static BEM(props) {
        const classArray = ['carousel__item'];
        if (props.className) {
            classArray.push(props.className);
        }
        if (props.verticalPadding) {
            classArray.push(`carousel__item--vertical-padding-${props.verticalPadding}`);
        }
        if (props.width) {
            classArray.push(`carousel__item--width-${props.width}`);
        }
        return classArray.join(' ');
    }
    render() {
        return (external_react_.createElement("div", { className: CarouselItemCore.BEM(this.props), "aria-roledescription": "slide" }, this.props.children));
    }
}
CarouselItemCore.defaultProps = {
    verticalPadding: 'default',
};

;// CONCATENATED MODULE: ./node_modules/@core-front/carousel/esm/carousel-item/carousel-item.js


const CarouselItem = (props) => {
    return (external_react_default().createElement(CarouselItemCore, Object.assign({}, props)));
};


// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
var react_responsive_default = /*#__PURE__*/__webpack_require__.n(react_responsive);
// EXTERNAL MODULE: ./node_modules/telia-react-slick/lib/index.js
var telia_react_slick_lib = __webpack_require__(7892);
;// CONCATENATED MODULE: ./node_modules/@core-front/grid/esm/grid-column/grid-column.js


const GridColumn = (props) => {
    const { align, border, children, className, elementRef, id, noGutter, offset, order, width, } = props;
    const { element: rootElement } = external_react_.useContext(GridContext);
    let Element;
    switch (rootElement) {
        case ('ol'):
        case ('ul'):
            Element = 'li';
            break;
        case ('span'):
            Element = 'span';
            break;
        default:
            Element = 'div';
    }
    const BEM = () => {
        const classArray = ['grid__col'];
        if (width) {
            for (const i of width) {
                classArray.push(`grid__col--${i}`);
            }
        }
        else {
            classArray.push('grid__col--xs-12');
        }
        if (offset) {
            for (const i of offset) {
                classArray.push(`grid__col--offset-${i}`);
            }
        }
        if (order) {
            for (const i of order) {
                classArray.push(`grid__col--${i}`);
            }
        }
        if (align) {
            for (const i of align) {
                classArray.push(`grid__col--${i}`);
            }
        }
        if (border) {
            for (const i of border) {
                classArray.push(`grid__col--border-${i}`);
            }
        }
        if (noGutter) {
            classArray.push('grid__col--no-vertical-gutter');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    if (Element === 'li') {
        return (external_react_.createElement(Element, { id: id, className: BEM(), "aria-hidden": props['aria-hidden'], ref: elementRef }, children));
    }
    return (external_react_.createElement(Element, { id: id, className: BEM(), "aria-hidden": props['aria-hidden'], ref: elementRef }, children));
};
/* harmony default export */ const grid_column = (GridColumn);

// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-responsive-props.js + 1 modules
var use_responsive_props = __webpack_require__(9097);
// EXTERNAL MODULE: ./node_modules/@core-front/theme-provider/esm/use-theme.js
var use_theme = __webpack_require__(3286);
// EXTERNAL MODULE: ./node_modules/@core-front/theme-provider/esm/theme-provider-core.js
var esm_theme_provider_core = __webpack_require__(9210);
;// CONCATENATED MODULE: ./node_modules/@core-front/carousel/esm/carousel/carousel-core.js
var carousel_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const CarouselCore = (props) => {
    const { responsive } = props, rest = carousel_core_rest(props, ["responsive"]);
    if (responsive) {
        return (external_react_.createElement(CarouselResponsive, Object.assign({}, rest, { responsive: responsive })));
    }
    return external_react_.createElement(CarouselInner, Object.assign({}, rest));
};
/* harmony default export */ const carousel_core = (CarouselCore);
const CarouselResponsive = (props) => {
    const { responsive } = props, rest = carousel_core_rest(props, ["responsive"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsiveProps = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive });
    return external_react_.createElement(CarouselInner, Object.assign({}, rest, responsiveProps));
};
class CarouselInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.CarouselNavButton = (props) => {
            const { onArrowClick, className, arrowType, innerClassName } = props;
            const isDisabled = className === null || className === void 0 ? void 0 : className.includes('slick-disabled');
            const { Button } = this.props.components;
            const BEM = () => {
                const classArray = ['carousel__nav', `carousel__nav--${arrowType}`];
                if (innerClassName) {
                    classArray.push(innerClassName);
                }
                if (className) {
                    classArray.push(className);
                }
                return classArray.join(' ');
            };
            return (external_react_.createElement(Button, Object.assign({}, props, { disabled: isDisabled, icon: arrowType === 'next' ? '#arrow-right' : '#arrow-left', className: BEM(), onClick: (e) => {
                    e.persist();
                    onArrowClick(() => {
                        if (props.onClick) {
                            props.onClick(e);
                        }
                    });
                } })));
        };
        this.toggleShowMoreOpen = (event) => {
            event.preventDefault();
            this.setState((prevState) => ({
                showMoreOpen: !prevState.showMoreOpen,
            }));
        };
        this.setCurrentCenterPadding = () => {
            if (this.props.centerMode) {
                const windowWidth = window.innerWidth;
                let centerPadding;
                if (windowWidth < this.context.breakPoints.sm) {
                    centerPadding = '40px';
                }
                else if (windowWidth < this.context.breakPoints.lg) {
                    centerPadding = '60px';
                }
                else {
                    centerPadding = '100px';
                }
                this.setState((prevState) => {
                    if (prevState.centerPadding !== centerPadding) {
                        return { centerPadding };
                    }
                    else {
                        return null;
                    }
                });
            }
        };
        this.renderShowMoreButton = (props) => {
            const { Button } = this.props.components;
            return (external_react_.createElement(grid_column, { width: ['xs'], className: "carousel__show-more" },
                external_react_.createElement(Button, Object.assign({}, props, { onClick: this.toggleShowMoreOpen }))));
        };
        this.state = {
            centerPadding: '100px',
            isMounted: false,
            showMoreOpen: false,
            autoplay: !!props.autoplay,
        };
    }
    get propsWithDefaults() {
        return this.props;
    }
    componentDidMount() {
        this.setCurrentCenterPadding();
        this.setState({
            isMounted: true,
        });
        window.addEventListener('resize', this.setCurrentCenterPadding);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setCurrentCenterPadding);
    }
    BEM() {
        var _a;
        const classArray = ['carousel'];
        if (this.props.arrows) {
            classArray.push('carousel--with-arrows');
        }
        if (((_a = this.props.arrowStyle) === null || _a === void 0 ? void 0 : _a.size) === 'small') {
            classArray.push('carousel--with-small-arrows');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.hasContainer) {
            classArray.push('carousel--has-container');
        }
        if (this.props.fade) {
            classArray.push('carousel--fade');
        }
        if (this.props.fullWidth) {
            classArray.push('carousel--full-width');
        }
        if (this.props.inverse) {
            classArray.push('carousel--inverse');
        }
        return classArray.join(' ');
    }
    getSliderOptions() {
        var _a, _b;
        const CarouselNavButton = this.CarouselNavButton;
        return {
            arrows: this.props.arrows,
            autoplay: this.state.autoplay,
            autoplaySpeed: this.props.autoplaySpeed,
            centerMode: this.props.centerMode,
            centerPadding: this.state.centerPadding,
            dots: this.props.dots || false,
            dotsClass: 'carousel__dots',
            easing: 'ease-out',
            infinite: this.props.infinite,
            initialSlide: this.props.initialSlide,
            nextArrow: (external_react_.createElement(CarouselNavButton, Object.assign({ text: this.props.nextArrowText }, this.props.arrowStyle, { onArrowClick: (fn) => this.clickHandler(fn), arrowType: "next", innerClassName: (_a = this.props.arrowStyle) === null || _a === void 0 ? void 0 : _a.className }))),
            prevArrow: (external_react_.createElement(CarouselNavButton, Object.assign({ text: this.props.prevArrowText }, this.props.arrowStyle, { onArrowClick: (fn) => this.clickHandler(fn), arrowType: "prev", innerClassName: (_b = this.props.arrowStyle) === null || _b === void 0 ? void 0 : _b.className }))),
            slidesToScroll: this.props.slidesToScroll,
            slidesToShow: this.props.slidesToShow,
            variableWidth: this.props.variableWidth,
            pauseOnFocus: true,
            pauseOnHover: true,
            beforeChange: (old, active) => {
                if (this.props.autoplay === 'once' && active === 0 && old !== 0) {
                    this.setState({ autoplay: false });
                }
            },
        };
    }
    clickHandler(fn) {
        if (this.state.autoplay) {
            this.setState({ autoplay: false }, () => fn());
        }
        else {
            fn();
        }
    }
    renderChildren() {
        const { CarouselItem } = this.props.components;
        return external_react_.Children.toArray(this.props.children).filter((child) => {
            return external_react_.isValidElement(child) && child.type === CarouselItem;
        });
    }
    getBreakpoint(breakPoint) {
        const { breakPoints } = this.context;
        return breakPoints[breakPoint];
    }
    getSlider() {
        const { isMounted } = this.state;
        const CarouselTag = isMounted ? telia_react_slick_lib/* default */.Z : 'div';
        return (external_react_.createElement(CarouselTag, Object.assign({ className: "carousel__slider", ref: this.props.sliderRef }, (isMounted && this.getSliderOptions()), { "aria-roledescription": "carousel", role: "group" }), this.renderChildren()));
    }
    renderGrid(isInitialRender) {
        const { slidesToShow } = this.propsWithDefaults;
        const { showMoreOpen } = this.state;
        const hasOneItem = external_react_.Children.count(this.props.children) === 1;
        const { showMoreButton, components: { Grid } } = this.props;
        const colWidth = this.props.gridAlignment === 'center' ? ['lg'] : [`lg-${12 / slidesToShow}`];
        const colBorder = ['bottom-xs', 'bottom-none-lg'];
        const children = external_react_.Children.map(this.renderChildren(), (child, index) => {
            if (external_react_.isValidElement(child)) {
                // Show only 3 items if in mobile and hidden.
                if (!showMoreOpen && showMoreButton && index > 2) {
                    return null;
                }
                if (isInitialRender) {
                    if (index < slidesToShow) {
                        return (external_react_.createElement(grid_column, Object.assign({ width: colWidth }, child.props, { className: CarouselItemCore.BEM(Object.assign(Object.assign({}, child.props), { width: this.props.gridAlignment === 'center' ? 'min' : undefined })), border: colBorder })));
                    }
                }
                else {
                    return (external_react_.createElement(grid_column, Object.assign({ width: colWidth }, child.props, { className: CarouselItemCore.BEM(Object.assign(Object.assign({}, child.props), { width: this.props.gridAlignment === 'center' ? 'min' : undefined })), border: colBorder })));
                }
            }
        });
        return (external_react_.createElement(Grid, { align: !hasOneItem ? ['center-xs'] : undefined, equalHeight: true, borderWeight: "thin" },
            children,
            !showMoreOpen && showMoreButton && this.renderShowMoreButton(showMoreButton)));
    }
    renderCarousel() {
        if (this.props.breakPoint === null) {
            return this.getSlider();
        }
        return (external_react_.createElement((react_responsive_default()), { minWidth: this.getBreakpoint(this.props.breakPoint || 'lg') }, (matches) => matches ? this.getSlider() : this.renderGrid()));
    }
    shouldUseContainer(items, hasContainer) {
        const { Container } = this.props.components;
        if (hasContainer) {
            return (external_react_.createElement(Container, null, items));
        }
        return items;
    }
    render() {
        const { slidesToShow } = this.propsWithDefaults;
        const shouldUseSlick = this.state.isMounted && (this.props.breakPoint === null || slidesToShow < external_react_.Children.count(this.props.children));
        const carouselItems = shouldUseSlick ? this.renderCarousel() : this.renderGrid(true);
        return (external_react_.createElement("div", { className: this.BEM() }, this.shouldUseContainer(carouselItems, this.props.hasContainer)));
    }
}
CarouselInner.contextType = esm_theme_provider_core/* ThemeContext */.Ni;
CarouselInner.defaultProps = {
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    breakPoint: 'lg',
    centerMode: false,
    dots: false,
    fade: true,
    hasContainer: false,
    infinite: false,
    initialSlide: 0,
    slidesToScroll: 1,
    slidesToShow: 4,
};

;// CONCATENATED MODULE: ./node_modules/@core-front/carousel/esm/carousel/carousel.js






const Carousel = (props) => {
    return (external_react_default().createElement(carousel_core, Object.assign({}, props, { components: {
            Button: button_Button,
            Container: Container,
            Grid: grid,
            CarouselItem: CarouselItem,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/carousel/esm/index.js





// EXTERNAL MODULE: ./node_modules/@core-front/badge/esm/badge-core.js
var badge_core = __webpack_require__(2230);
;// CONCATENATED MODULE: ./node_modules/@core-front/badge/esm/badge.js



class badge_Badge extends external_react_.PureComponent {
    render() {
        return (external_react_.createElement(badge_core/* default */.Z, Object.assign({}, this.props, { components: {
                Icon: icon/* default */.Z,
            } })));
    }
}

// EXTERNAL MODULE: ./node_modules/@core-front/fittext/esm/fittext.js + 2 modules
var fittext = __webpack_require__(6537);
;// CONCATENATED MODULE: ./node_modules/@core-front/label-provider/node_modules/@core-front/error-provider/esm/error-provider.js

const esm_error_provider_defaultContext = {
    log: (message) => console.error(message),
};
const esm_error_provider_ErrorContext = external_react_.createContext(esm_error_provider_defaultContext);
const esm_error_provider_ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(esm_error_provider_ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const error_provider_esm_error_provider = ((/* unused pure expression or super */ null && (esm_error_provider_ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@core-front/label-provider/node_modules/@core-front/error-provider/esm/use-log.js


const esm_use_log_useErrorLog = () => {
    return external_react_.useContext(esm_error_provider_ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@core-front/label-provider/esm/label-provider.js


const label_provider_defaultContext = {
    get: (key) => {
        if (typeof process === 'undefined' ||  true && process.env.STYLEGUIDE === 'false') {
            console.error('LabelProvider missing! Application must be wrapped with <LabelProvider>');
        }
        return key;
    },
};
const LabelContext = external_react_.createContext(label_provider_defaultContext);
const replaceParams = (label, params) => {
    return Object.keys(params).reduce((text, key) => text.replace(`$\{${key}}`, params[key]), label);
};
const LabelProvider = (props) => {
    const { labels, children, } = props;
    const { log } = esm_use_log_useErrorLog();
    const get = (key, params) => {
        const label = labels[key];
        if (!label) {
            log(`Label missing for key "${key}".`);
            return key;
        }
        if (params) {
            return replaceParams(label, params);
        }
        return label;
    };
    return (external_react_.createElement(LabelContext.Provider, { value: { get } }, children));
};
/* harmony default export */ const label_provider = (LabelProvider);

;// CONCATENATED MODULE: ./node_modules/@core-front/label-provider/esm/use-labels.js


const useLabels = () => {
    return external_react_.useContext(LabelContext);
};


;// CONCATENATED MODULE: ./node_modules/@core-front/close-button/esm/close-button-core.js


const CloseButtonCore = (props) => {
    const labels = useLabels();
    const { className, components: { Icon }, label, onClick, } = props;
    const BEM = () => {
        const classArray = ['close-button'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("button", { className: BEM(), onClick: onClick, type: "button" },
        external_react_.createElement("span", { className: "close-button__inner" },
            external_react_.createElement(Icon, { modifiers: "#close", className: "close-button__icon" }),
            external_react_.createElement("span", { className: "sr-only" }, label || labels.get('close')))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/close-button/esm/close-button.js



const CloseButton = (props) => {
    return (external_react_.createElement(CloseButtonCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/page-access/node_modules/@core-front/helper/esm/index.js


let _core_front_helper_esm_scrollAnimationFrame = 0;
const _core_front_helper_esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const _core_front_helper_esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !_core_front_helper_esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const _core_front_helper_esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && _core_front_helper_esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const _core_front_helper_esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const _core_front_helper_esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const _core_front_helper_esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(_core_front_helper_esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = _core_front_helper_esm_swingTo(p);
        if (p < 1) {
            _core_front_helper_esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const _core_front_helper_esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || _core_front_helper_esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!isFocusable(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        _core_front_helper_esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const _core_front_helper_esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= _core_front_helper_esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const _core_front_helper_esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const _core_front_helper_esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return _core_front_helper_esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const _core_front_helper_esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const _core_front_helper_esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const _core_front_helper_esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const _core_front_helper_esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const _core_front_helper_esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const _core_front_helper_esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const _core_front_helper_esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    _core_front_helper_esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const _core_front_helper_esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const _core_front_helper_esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/page-access/esm/page-access.js



const PageAccess = (props) => {
    return external_react_.createElement(external_react_.Fragment, null, props.children);
};
function page_access_reducePropsToState(propsList) {
    return propsList.some((props) => props.isInert);
}
function page_access_handleStateChangeOnClient(isInert) {
    if (isInert) {
        _core_front_helper_esm_disablePageAccess();
    }
    else {
        _core_front_helper_esm_enablePageAccess();
    }
}
/* harmony default export */ const page_access = (lib_default()(page_access_reducePropsToState, page_access_handleStateChangeOnClient)(PageAccess));

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/popper.js + 53 modules
var popper = __webpack_require__(4511);
// EXTERNAL MODULE: ./node_modules/@core-front/input-provider/esm/input-provider.js
var input_provider = __webpack_require__(8606);
;// CONCATENATED MODULE: ./node_modules/@core-front/tooltip/esm/tooltip-core.js








const TooltipCore = (props) => {
    const { input } = external_react_.useContext(input_provider/* InputContext */.r);
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "Tooltip", defaultValueName: "defaultIsShown", valueName: "isShown", onChangeNames: "onToggle", onChangeAltNames: ['onShow', 'onHide'] },
        external_react_.createElement(TooltipInner, Object.assign({}, props, { inputIntent: input }))));
};
/* harmony default export */ const tooltip_core = (TooltipCore);
class TooltipInner extends external_react_.PureComponent {
    constructor(props) {
        super(props);
        this.tooltip = null;
        this.referenceElement = null;
        this.popper = null;
        this.focusTimeout = 0;
        this.destroyPopper = () => {
            if (this.popper) {
                this.popper.destroy();
                this.popper = null;
            }
        };
        this.hideToolTipReferenceElement = () => {
            if (!this.tooltip) {
                this.hideTooltip();
                return;
            }
            if (this.geInputIntent(this.props.inputIntent) && !this.tooltip.matches(':hover')) {
                this.hideTooltip();
            }
        };
        this.hideToolTipElement = () => {
            if (!this.referenceElement) {
                this.hideTooltip();
                return;
            }
            if (this.geInputIntent(this.props.inputIntent) && !this.referenceElement.matches(':hover')) {
                this.hideTooltip();
            }
        };
        this.showTooltip = () => {
            if (!this.isShown) {
                if (!this.state.isShown && typeof this.props.isShown === 'undefined') {
                    this.setState({
                        isShown: true,
                    });
                }
                if (this.props.onShow) {
                    this.props.onShow();
                }
                if (this.props.onToggle) {
                    this.props.onToggle(true);
                }
            }
        };
        this.hideTooltip = () => {
            if (this.isShown) {
                if (this.state.isShown && typeof this.props.isShown === 'undefined') {
                    this.setState({
                        isShown: false,
                    });
                }
                if (this.props.onHide) {
                    this.props.onHide();
                }
                if (this.props.onToggle) {
                    this.props.onToggle(false);
                }
            }
        };
        this.toggleTooltip = () => {
            if (this.isShown) {
                this.hideTooltip();
            }
            else {
                this.showTooltip();
            }
        };
        this.onClickOutside = (event) => {
            if (event.target instanceof Element) {
                this.hideIfOutside(event.target);
            }
        };
        this.handleCloseClick = (event) => {
            event.preventDefault();
            this.hideTooltip();
        };
        this.setRef = (element) => {
            this.tooltip = element;
            if (this.props.elementRef) {
                this.props.elementRef(element);
            }
        };
        this.onEntered = () => {
            this.focusFirstElement();
        };
        this.onExited = () => {
            var _a;
            if (this.props.inputIntent !== 'mouse') {
                (_a = this.referenceElement) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        this.onKeyDown = (event) => {
            switch (event.key) {
                // Invoke this.props.onClose when user hits ESC key.
                case 'Escape':
                case 'Esc':
                    this.hideTooltip();
                    break;
                case 'Tab':
                    /* istanbul ignore else */
                    if (this.tooltip) {
                        const tabbableElements = (0,index_esm/* tabbable */.ht)(this.tooltip);
                        if (tabbableElements.length) {
                            const firstTabbableElement = tabbableElements[0];
                            const lastTabbableElement = tabbableElements[tabbableElements.length - 1];
                            if (event.shiftKey) {
                                if (document.activeElement === firstTabbableElement) {
                                    event.preventDefault();
                                    lastTabbableElement.focus();
                                }
                            }
                            else {
                                if (document.activeElement === lastTabbableElement) {
                                    event.preventDefault();
                                    firstTabbableElement.focus();
                                }
                            }
                        }
                        else {
                            event.preventDefault();
                        }
                    }
            }
        };
        this.state = {
            isMounted: false,
            isReady: false,
            isShown: props.defaultIsShown || false,
        };
    }
    componentDidMount() {
        this.setReferenceElement();
        this.setState({ isMounted: true }, () => {
            if (this.isShown) {
                this.initPopper();
                this.focusFirstElement();
            }
            if (this.props.inputIntent !== 'initial') {
                this.bindEventListeners(this.geInputIntent(this.props.inputIntent));
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if ((this.geInputIntent(prevProps.inputIntent) !== this.geInputIntent(this.props.inputIntent)) && prevProps.inputIntent !== 'initial' && this.isShown) {
            this.hideTooltip();
        }
        if (this.geInputIntent(prevProps.inputIntent) !== this.geInputIntent(this.props.inputIntent)) {
            this.bindEventListeners(this.geInputIntent(this.props.inputIntent));
        }
        if ((this.state.isShown !== prevState.isShown) || (this.props.isShown !== prevProps.isShown)) {
            if (this.isShown) {
                this.initPopper();
                if (this.tooltip && this.geInputIntent(this.props.inputIntent) === 'mouse' && this.props.trigger !== 'none') {
                    this.tooltip.addEventListener('mouseenter', this.showTooltip);
                    this.tooltip.addEventListener('mouseleave', this.hideToolTipElement);
                }
            }
            else if (!this.isShown) {
                this.destroyPopper();
            }
        }
    }
    componentWillUnmount() {
        this.unbindAllEventListeners();
        this.destroyPopper();
        window.clearTimeout(this.focusTimeout);
    }
    get isShown() {
        return (this.props.onToggle || (this.props.onHide && this.props.onShow)) && typeof this.props.isShown !== 'undefined' ? this.props.isShown : this.state.isShown;
    }
    isSpecColor(color) {
        return color ? color in TooltipColors : false;
    }
    geInputIntent(input) {
        if (this.props.trigger === 'click') {
            return 'touch';
        }
        return input;
    }
    setReferenceElement() {
        if (typeof this.props.referenceElement === 'string') {
            this.referenceElement = document.querySelector(this.props.referenceElement);
        }
        else if (this.props.referenceElement instanceof SVGElement ||
            this.props.referenceElement instanceof HTMLElement) {
            this.referenceElement = this.props.referenceElement;
        }
        else {
            this.referenceElement = this.tooltip && this.tooltip.parentElement;
        }
    }
    focusFirstElement() {
        this.focusTimeout = window.setTimeout(() => {
            /* istanbul ignore else */
            if (this.tooltip && this.props.inputIntent !== 'mouse') {
                const firstTabbableElement = (0,index_esm/* tabbable */.ht)(this.tooltip)[0];
                if (firstTabbableElement) {
                    firstTabbableElement.focus();
                    return;
                }
                this.tooltip.focus();
            }
        });
    }
    /**
     * Initialize popper.js to automagically position the tooltip according to available space.
     */
    initPopper() {
        if (!this.tooltip || !this.referenceElement) {
            return;
        }
        this.popper = (0,popper/* createPopper */.fi)(this.referenceElement, this.tooltip, {
            modifiers: [
                { name: 'applyStyles', enabled: false },
                {
                    name: 'updateState',
                    enabled: true,
                    phase: 'write',
                    requires: ['computeStyles'],
                    fn: ({ state }) => this.updatePopperState(state),
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'bottom', 'right', 'left'],
                        padding: { top: 137, right: 17, bottom: 17, left: 17 },
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 15,
                    },
                },
            ],
            onFirstUpdate: () => {
                if (this.popper) {
                    this.popper.update().then(() => {
                        this.setState({
                            isReady: true,
                        });
                    });
                }
            },
            placement: this.props.placement,
        });
    }
    updatePopperState(state) {
        const popperStyle = Object.assign({}, state.styles.popper);
        const popperAttributes = Object.assign({}, state.attributes.popper);
        const popperArrowStyle = Object.assign({}, state.styles.arrow);
        if (!this.isSpecColor(this.props.color)) {
            popperArrowStyle.color = this.props.color;
        }
        this.setState({
            popperStyle,
            popperAttributes,
            popperArrowStyle,
        });
    }
    bindEventListeners(type) {
        if (this.props.trigger === 'none') {
            return;
        }
        this.unbindAllEventListeners();
        if (this.props.hideWithIntent && this.props.hideWithIntent.includes(this.geInputIntent(this.props.inputIntent))) {
            return;
        }
        switch (type) {
            case 'mouse':
                return this.bindHoverEventListeners();
            case 'keyboard':
            default:
                return this.bindClickEventListeners();
        }
    }
    bindClickEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.addEventListener('click', this.toggleTooltip);
        }
        document.addEventListener('click', this.onClickOutside);
    }
    unbindClickEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.removeEventListener('click', this.toggleTooltip);
        }
        document.removeEventListener('click', this.onClickOutside);
    }
    bindHoverEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.addEventListener('mouseenter', this.showTooltip);
            this.referenceElement.addEventListener('mouseleave', this.hideToolTipReferenceElement);
        }
    }
    unbindHoverEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.removeEventListener('mouseenter', this.showTooltip);
            this.referenceElement.removeEventListener('mouseleave', this.hideToolTipReferenceElement);
        }
        if (this.tooltip) {
            this.tooltip.removeEventListener('mouseenter', this.showTooltip);
            this.tooltip.removeEventListener('mouseleave', this.hideToolTipElement);
        }
    }
    unbindAllEventListeners() {
        this.unbindClickEventListeners();
        this.unbindHoverEventListeners();
    }
    // calls this.hideTooltip if target is not a descendant of the tooltip nor the reference element.
    hideIfOutside(target) {
        if (this.isShown) {
            while (target !== null) {
                if (target === this.tooltip || target === this.referenceElement || (this.props.outsideClickCloseFilter && this.props.outsideClickCloseFilter(target))) {
                    return;
                }
                target = target.parentElement;
            }
            this.hideTooltip();
        }
    }
    isCloseButtonShown() {
        const { isCloseButtonVisible, inputIntent } = this.props;
        return !!(isCloseButtonVisible && ['initial', 'pointer', 'touch', 'keyboard'].indexOf(this.geInputIntent(inputIntent)) > -1);
    }
    BEM(state) {
        const classArray = ['tooltip', `tooltip--trigger-${this.geInputIntent(this.props.inputIntent)}`];
        if (state) {
            classArray.push(`is-${state}`);
        }
        if (this.isShown) {
            classArray.push('is-shown');
        }
        if (this.state.isReady) {
            classArray.push('is-ready');
        }
        if (this.isSpecColor(this.props.color)) {
            classArray.push('tooltip--' + this.props.color);
        }
        if (this.isCloseButtonShown()) {
            classArray.push('tooltip--has-close-button');
        }
        if (this.props.fixedWidth) {
            classArray.push('tooltip--fixed-width');
        }
        if (this.props.noPadding) {
            classArray.push('tooltip--no-padding');
        }
        if (this.props.size) {
            classArray.push('tooltip--' + this.props.size);
        }
        if (this.props.onHeader) {
            classArray.push('tooltip--on-header');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    renderTooltip() {
        const { CloseButton, PageAccess } = this.props.components;
        const content = (state) => (external_react_.createElement("div", Object.assign({}, this.state.popperAttributes, { className: this.BEM(state), style: this.state.popperStyle, ref: this.setRef, tabIndex: -1, onKeyDown: this.onKeyDown, role: "dialog", "aria-modal": true, "aria-labelledby": this.props['aria-labelledby'] }),
            external_react_.createElement("div", { className: "tooltip__arrow", "data-popper-arrow": true, style: this.state.popperArrowStyle }),
            external_react_.createElement("div", { className: "tooltip__content", style: !this.isSpecColor(this.props.color) ? { borderColor: this.props.color } : undefined },
                this.isCloseButtonShown() && (external_react_.createElement(CloseButton, { className: "tooltip__close", onClick: this.handleCloseClick })),
                this.props.children)));
        if (!this.state.isMounted) {
            return content();
        }
        return (external_react_.createElement(PageAccess, { isInert: this.props.inputIntent !== 'mouse' && this.isShown },
            external_react_.createElement(esm_Transition/* default */.ZP, { in: this.isShown, timeout: { enter: 0, exit: 100 }, mountOnEnter: true, unmountOnExit: true, onEntered: this.onEntered, onExited: this.onExited }, content)));
    }
    render() {
        return this.state.isMounted ? external_react_dom_.createPortal(this.renderTooltip(), document.body) : this.renderTooltip();
    }
}
TooltipInner.defaultProps = {
    fixedWidth: true,
    noPadding: false,
    placement: 'top',
    isCloseButtonVisible: true,
};

;// CONCATENATED MODULE: ./node_modules/@core-front/tooltip/esm/tooltip.js




var TooltipColors;
(function (TooltipColors) {
    TooltipColors["info"] = "info";
    TooltipColors["success"] = "success";
    TooltipColors["error"] = "error";
    TooltipColors["employee"] = "employee";
})(TooltipColors || (TooltipColors = {}));
const Tooltip = (props) => {
    return (external_react_.createElement(tooltip_core, Object.assign({}, props, { components: {
            CloseButton: CloseButton,
            PageAccess: page_access,
        } })));
};
/* harmony default export */ const tooltip = (Tooltip);

;// CONCATENATED MODULE: ./node_modules/@core-front/tag/esm/tag-core.js
var tag_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const TagCore = (props) => {
    const { responsive } = props, rest = tag_core_rest(props, ["responsive"]);
    return responsive ? external_react_.createElement(TagResponsiveCore, Object.assign({}, rest, { responsive: responsive })) : external_react_.createElement(TagInnerCore, Object.assign({}, rest));
};
const TagResponsiveCore = (props) => {
    const { responsive } = props, rest = tag_core_rest(props, ["responsive"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsiveProps = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive });
    return external_react_.createElement(TagInnerCore, Object.assign({}, rest, responsiveProps));
};
const tagSizeFontSize = {
    tiny: 'small',
    small: 'large',
    medium: 'extra-large',
    large: 'small',
};
class TagInnerCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.fadeDuration = 300;
        this.interval = 0;
        /**
         * Called after every animationDuration
         * Sets animationState and animated content index
         */
        this.updateState = () => {
            if (!this.props.content) {
                return;
            }
            this.setState({
                animationState: 'fade-out',
            }, () => setTimeout(() => {
                let nextIndex = this.state.currentIndex + 1;
                if (this.props.content && nextIndex === this.props.content.length) {
                    nextIndex = 0;
                }
                this.setState({
                    animationState: 'fade-in',
                    currentIndex: nextIndex,
                }, () => setTimeout(() => {
                    this.setState({
                        animationState: 'faded-in',
                    });
                }, this.fadeDuration));
            }, this.fadeDuration));
        };
        this.state = {
            animationState: 'faded-in',
            currentIndex: 0,
        };
    }
    componentDidMount() {
        if (this.props.content && this.props.content.length > 1 && this.props.size !== 'tiny') {
            this.interval = window.setInterval(this.updateState, (this.props.animationDuration || 3000) - this.fadeDuration);
        }
    }
    componentWillUnmount() {
        if (this.props.content) {
            window.clearInterval(this.interval);
        }
    }
    BEM() {
        const { size } = this.props;
        const classArray = ['tag', `tag--${size}`];
        if (this.props.purpose) {
            classArray.push(`tag--${this.props.purpose}`);
        }
        if (this.props.icon && !this.props.content) {
            classArray.push('tag--icon');
        }
        if (this.props.image && !this.props.content) {
            classArray.push('tag--image');
        }
        if (this.props.content) {
            classArray.push('tag--animating');
        }
        if (this.props.isDisabled) {
            classArray.push('tag--disabled');
        }
        if (this.props.tooltip) {
            classArray.push('tag--tooltip');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    contentBEM(item) {
        const classArray = ['tag__content'];
        if (this.props.content && this.props.size !== 'tiny') {
            const index = this.props.content.findIndex((i) => item === i);
            if (this.state.currentIndex === index) {
                classArray.push(`tag__content--${this.state.animationState}`);
            }
        }
        return classArray.join(' ');
    }
    renderIcon(icon) {
        const { Icon } = this.props.components;
        return external_react_.createElement(Icon, { className: "tag__icon", modifiers: icon });
    }
    renderText(item) {
        const { Fittext } = this.props.components;
        const classArray = ['tag__text'];
        const { size } = this.props;
        if (item.image || (item.icon && this.props.size !== 'large' && this.props.size !== 'tiny')) {
            classArray.push('tag__text--hidden');
        }
        if (item.fontSize) {
            classArray.push('tag__text--' + item.fontSize);
        }
        else if (this.props.tagSizeFontSizeProp) {
            classArray.push('tag__text--' + this.props.tagSizeFontSizeProp[size]);
        }
        else if (tagSizeFontSize[size]) {
            classArray.push('tag__text--' + tagSizeFontSize[size]);
        }
        let tagTextContent;
        if (typeof item.text === 'string') {
            tagTextContent = external_react_.createElement(Fittext, null, item.text);
        }
        else {
            tagTextContent = item.text;
        }
        return (external_react_.createElement("span", { className: classArray.join(' ') }, this.props.renderContent ? this.props.renderContent : tagTextContent));
    }
    renderImage(image) {
        const { Image } = this.props.components;
        return (external_react_.createElement(Image, Object.assign({}, image, { className: "tag__image" })));
    }
    renderContent(item, key) {
        const ContentElement = this.props.tooltip ? 'span' : 'div';
        return (external_react_.createElement(ContentElement, { className: this.contentBEM(item), key: key },
            item.icon && this.props.size !== 'tiny' && this.renderIcon(item.icon),
            item.text && !this.props.renderContent && this.renderText(item),
            item.image && this.renderImage(item.image),
            this.props.text && this.props.renderContent && this.renderText(item)));
    }
    renderMultipleContent(content) {
        return content.map((item, key) => this.renderContent(item, key));
    }
    renderToolTipWrapper(defaultItem, tooltip) {
        const { id } = tooltip, tooltipProps = tag_core_rest(tooltip, ["id"]);
        const { Tooltip } = this.props.components;
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement("button", { type: "button", id: id, className: this.BEM() }, this.props.content ? this.renderMultipleContent(this.props.content) : this.renderContent(defaultItem)),
            external_react_.createElement(Tooltip, Object.assign({ referenceElement: `#${id}` }, tooltipProps))));
    }
    renderDefaultWrapper(defaultItem) {
        return (external_react_.createElement("div", { className: this.BEM() }, this.props.content ? this.renderMultipleContent(this.props.content) : this.renderContent(defaultItem)));
    }
    render() {
        const defaultItem = {
            fontSize: this.props.fontSize,
            icon: this.props.icon,
            image: this.props.image,
            text: this.props.text,
        };
        const { tooltip } = this.props;
        return tooltip ? this.renderToolTipWrapper(defaultItem, tooltip) : this.renderDefaultWrapper(defaultItem);
    }
}
TagInnerCore.defaultProps = {
    animationDuration: 3000,
    size: 'large',
};
/* harmony default export */ const tag_core = (TagCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/tag/esm/tag.js






const Tag = (props) => {
    return (external_react_.createElement(tag_core, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            Tooltip: tooltip,
            Image: esm_image/* default */.Z,
            Fittext: fittext/* default */.Z,
        } })));
};
/* harmony default export */ const tag = (Tag);

;// CONCATENATED MODULE: ./node_modules/@core-front/tag-group/esm/tag-group-core.js

const TagGroup = (props) => {
    const { Tag } = props.components;
    const BEM = () => {
        const classArray = ['tag-group'];
        const { align = 'vertical' } = props;
        classArray.push(`tag-group--align-${align}`);
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const tagBEM = (className) => {
        const classArray = ['tag-group__tag'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, props.tags.map((tag, index) => (external_react_.createElement(Tag, Object.assign({}, tag, { key: index, size: props.size, className: tagBEM(tag.className) }))))));
};
/* harmony default export */ const tag_group_core = (TagGroup);

;// CONCATENATED MODULE: ./node_modules/@core-front/tag-group/esm/tag-group.js



const tag_group_TagGroup = (props) => {
    return (external_react_.createElement(tag_group_core, Object.assign({}, props, { components: {
            Tag: tag,
        } })));
};
/* harmony default export */ const tag_group = (tag_group_TagGroup);

// EXTERNAL MODULE: ./node_modules/@core-front/cookie-consent-provider/esm/cookie-consent-provider.js
var cookie_consent_provider = __webpack_require__(7869);
;// CONCATENATED MODULE: ./node_modules/@core-front/video/esm/video-core.js




const VideoCore = (props) => {
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "Video", defaultValueName: "defaultPlaying", valueName: "playing", onChangeNames: "onPlay" },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: {
                callback: 'onPlay',
                id: `Video - ${props.title}`,
                elementType: 'video',
                elementId: props.title,
                interactionType: 'play',
            } },
            external_react_.createElement(VideoCoreInner, Object.assign({}, props)))));
};
class VideoCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.video = external_react_.createRef();
        this.handleClick = (event) => {
            event.preventDefault();
            this.play();
        };
        this.play = () => {
            if (typeof this.props.playing === 'undefined') {
                this.setState({
                    playing: true,
                });
            }
            if (this.props.onPlay) {
                this.props.onPlay();
            }
        };
        this.pause = () => {
            if (typeof this.props.playing === 'undefined') {
                this.setState({
                    playing: false,
                });
            }
            if (this.props.onPause) {
                this.props.onPause();
            }
        };
        this.getUrl = (props) => {
            let url = props.url + '?autoplay=1';
            if (this.props.defaultPlaying) {
                url += '&muted=1';
            }
            return url;
        };
        this.state = {
            playing: props.defaultPlaying || false,
            hideOverview: props.hideOverview || false,
            isMounted: false,
        };
    }
    componentDidMount() {
        this.hideOverview();
        this.setState({
            isMounted: true,
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.isHtml5(this.props) && this.props.sources) {
            const prevPlaying = prevProps.onPlay && typeof prevProps.playing !== 'undefined' ? prevProps.playing : prevState.playing;
            if (prevPlaying !== this.playing && this.video && this.video.current) {
                if (this.playing) {
                    this.video.current.play();
                }
                else {
                    this.video.current.pause();
                }
            }
        }
        this.hideOverview();
    }
    get playing() {
        const { needsConsent } = this.props;
        // if without consent, we are not allowed to load the video
        if (!this.context.hasConsent(needsConsent)) {
            return false;
        }
        return this.props.onPlay && typeof this.props.playing !== 'undefined' ? this.props.playing : this.state.playing;
    }
    hideOverview() {
        if (!this.state.hideOverview && this.playing) {
            this.setState({
                hideOverview: true,
            });
        }
    }
    isHtml5(props) {
        return props.implementation === 'html5';
    }
    BEM(modifier) {
        const { needsConsent, position, className } = this.props;
        const classArray = ['video'];
        if (this.props.placeholderText) {
            classArray.push('video--text');
        }
        if (this.state.hideOverview) {
            classArray.push('hide-overview');
        }
        if (position) {
            classArray.push('video--' + position);
        }
        if (!this.context.hasConsent(needsConsent)) {
            classArray.push('video--needs-consent');
        }
        if (className) {
            classArray.push(className);
        }
        if (modifier) {
            classArray.push(modifier);
        }
        return classArray.join(' ');
    }
    renderHtml5(props) {
        const { sources, url, attributes, defaultPlaying } = props;
        const sourceElements = sources ? sources.map((source, key) => (external_react_.createElement("source", Object.assign({}, source, { key: key })))) : null;
        const linkHref = sources ? sources[0].src : url;
        const isHTML5Supported = this.state.isMounted && (typeof (document.createElement('video').canPlayType) !== 'undefined');
        const video = (external_react_.createElement("video", Object.assign({ ref: this.video, preload: "metadata", playsInline: true, controls: true, muted: defaultPlaying ? true : undefined }, attributes, { autoPlay: this.playing, onPause: this.pause, onPlay: this.play, className: "video__html5 lazyload", src: url }), sourceElements));
        return this.renderVideoWrapper(this.BEM('video--html5'), isHTML5Supported ? video : null, linkHref);
    }
    renderIframe(props) {
        const iframe = (external_react_.createElement("iframe", { title: props.title, className: "video__iframe lazyload", "data-src": this.playing ? this.getUrl(props) : undefined, width: "640", height: "360", allowFullScreen: true, onLoad: props.onLoad }));
        return this.renderVideoWrapper(this.BEM(), iframe, props.url);
    }
    renderPosterImage() {
        const { Image } = this.props.components;
        return external_react_.createElement(Image, Object.assign({ className: "video__image" }, this.props.poster));
    }
    renderVideoWrapper(className, children, linkHref) {
        const { Icon } = this.props.components;
        const { needsConsent } = this.props;
        const showOnlyImage = this.props.hideWithoutConsent === 'showPoster' && !this.context.hasConsent(needsConsent);
        const video = (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement("a", { href: linkHref, className: "video__btn", target: "_blank", rel: "noopener noreferrer", onClick: this.context.hasConsent(needsConsent) ? this.handleClick : undefined, ref: this.props.elementRef },
                this.renderPosterImage(),
                external_react_.createElement("div", { className: "video__content" },
                    external_react_.createElement("div", { className: "video__icon-wrapper" },
                        external_react_.createElement(Icon, { modifiers: "#play", className: "video__icon" })),
                    this.props.placeholderText && external_react_.createElement("div", { className: "h3 video__placeholder-text" }, this.props.placeholderText))),
            external_react_.createElement("div", { className: "video__holder" }, children)));
        return (external_react_.createElement("figure", { className: className },
            external_react_.createElement("div", { className: "video__inner" }, showOnlyImage ? this.renderPosterImage() : video)));
    }
    render() {
        const { needsConsent, hideWithoutConsent } = this.props;
        if (!this.context.hasConsent(needsConsent) && typeof hideWithoutConsent === 'boolean' && hideWithoutConsent) {
            return null;
        }
        if (this.isHtml5(this.props)) {
            return this.renderHtml5(this.props);
        }
        return this.renderIframe(this.props);
    }
}
VideoCoreInner.defaultProps = {
    needsConsent: ['statistics', 'marketing'],
    implementation: 'iframe',
};
VideoCoreInner.contextType = cookie_consent_provider/* CookieConsentContext */.Q;
/* harmony default export */ const video_core = (VideoCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/video/esm/video.js




const Video = (props) => {
    return (external_react_.createElement(video_core, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            Image: esm_image/* default */.Z,
        } })));
};
/* harmony default export */ const video = (Video);

// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card/card-core.js
var card_core = __webpack_require__(9336);
;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/card/card.js
var card_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const Card = (props) => {
    const { children } = props, rest = card_rest(props, ["children"]);
    return (external_react_default().createElement(card_core/* default */.ZP, Object.assign({}, rest, { components: {
            Video: video,
            Image: esm_image/* default */.Z,
            Badge: (props) => external_react_default().createElement(badge_Badge, Object.assign({}, props)),
            Tag: tag,
            TagGroup: tag_group,
        } }), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-bottom/card-bottom-core.js
var card_bottom_core = __webpack_require__(3302);
;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/card-bottom/card-bottom.js
var card_bottom_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardBottom = (props) => {
    const { children } = props, rest = card_bottom_rest(props, ["children"]);
    return (external_react_.createElement(card_bottom_core/* default */.Z, Object.assign({}, rest), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-content/card-content-core.js
var card_content_core = __webpack_require__(2485);
;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/card-content/card-content.js
var card_content_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const CardContent = (props) => {
    const { children } = props, rest = card_content_rest(props, ["children"]);
    return (external_react_.createElement(card_content_core/* default */.Z, Object.assign({}, rest, { components: {
            Tag: (props) => external_react_.createElement(tag, Object.assign({}, props)),
            Image: esm_image/* default */.Z,
        } }), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-footer/card-footer-core.js
var card_footer_core = __webpack_require__(6912);
;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/card-footer/card-footer.js
var card_footer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardFooter = (props) => {
    const { children } = props, rest = card_footer_rest(props, ["children"]);
    return (external_react_.createElement(card_footer_core/* default */.Z, Object.assign({}, rest), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-header/card-header-core.js
var card_header_core = __webpack_require__(5892);
;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/card-header/card-header.js
var card_header_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardHeader = (props) => {
    const { children } = props, rest = card_header_rest(props, ["children"]);
    return (external_react_.createElement(card_header_core/* default */.Z, Object.assign({}, rest), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-top/card-top-core.js
var card_top_core = __webpack_require__(7058);
;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/card-top/card-top.js
var card_top_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardTop = (props) => {
    const { children } = props, rest = card_top_rest(props, ["children"]);
    return (external_react_.createElement(card_top_core/* default */.Z, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card/esm/index.js













;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old/card-old-core.js


const CardOldContext = external_react_default().createContext({
    color: 'grey',
});
const CardOldCore = (props) => {
    const { children, className, color, elementRef, onClick = esm/* navigate */.c, onMouseLeave, onMouseEnter, onTransitionEnd, shape, external = false, target, url, isDisabled, style, } = props;
    const CardTag = url ? 'a' : 'div';
    const BEM = () => {
        const classArray = ['card-old'];
        if (color) {
            classArray.push(`card-old--${color}`);
        }
        if (shape) {
            classArray.push(`card-old--shape-${shape}`);
        }
        if (url) {
            classArray.push('card-old--link');
        }
        if (isDisabled) {
            classArray.push('card-old--disabled');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const handleClick = external_react_default().useCallback((event) => {
        if (!external) {
            onClick(event);
        }
    }, [external, onClick]);
    return (external_react_default().createElement(CardOldContext.Provider, { value: {
            color: props.color,
        } },
        external_react_default().createElement(CardTag, { className: BEM(), href: url, onClick: url ? handleClick : undefined, target: target, ref: elementRef, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, onTransitionEnd: onTransitionEnd, style: style }, children)));
};
CardOldCore.defaultProps = {
    onClick: esm/* navigate */.c,
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old/card-old.js
var card_old_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardOld = (props) => {
    const { children } = props, rest = card_old_rest(props, ["children"]);
    return (external_react_default().createElement(CardOldCore, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-bottom/card-old-bottom-core.js

const CardOldBottomCore = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['card-old__bottom'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-bottom/card-old-bottom.js
var card_old_bottom_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardOldBottom = (props) => {
    const { children } = props, rest = card_old_bottom_rest(props, ["children"]);
    return (external_react_.createElement(CardOldBottomCore, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-content/card-old-content-core.js

const CardOldContentCore = (props) => {
    const { children, className, elementRef, } = props;
    const BEM = () => {
        const classArray = ['card-old__content'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement("div", { className: BEM(), ref: elementRef }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-content/card-old-content.js
var card_old_content_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardOldContent = (props) => {
    const { children } = props, rest = card_old_content_rest(props, ["children"]);
    return (external_react_.createElement(CardOldContentCore, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-footer/card-old-footer-core.js

const CardOldFooterCore = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['card-old__footer'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement("div", { className: BEM() }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-footer/card-old-footer.js
var card_old_footer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardOldFooter = (props) => {
    const { children } = props, rest = card_old_footer_rest(props, ["children"]);
    return (external_react_.createElement(CardOldFooterCore, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-header/card-old-header-core.js

const CardOldHeaderCore = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['card-old__header'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-header/card-old-header.js
var card_old_header_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardOldHeader = (props) => {
    const { children } = props, rest = card_old_header_rest(props, ["children"]);
    return (external_react_.createElement(CardOldHeaderCore, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-top/card-old-top-core.js

const CardOldTopCore = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['card-old__top'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement("div", { className: BEM() }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/card-old-top/card-old-top.js
var card_old_top_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const card_old_top_CardTop = (props) => {
    const { children } = props, rest = card_old_top_rest(props, ["children"]);
    return (external_react_.createElement(CardOldTopCore, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/card-old/esm/index.js













;// CONCATENATED MODULE: ./node_modules/@core-front/chart-legend/esm/chart-legend.js

class ChartLegend extends external_react_.Component {
    BEM() {
        const classArray = ['chart-legend'];
        if (this.props.stacked) {
            classArray.push('chart-legend--stacked');
        }
        if (this.props.size) {
            classArray.push('chart-legend--' + this.props.size);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getLegendItem(item) {
        return (external_react_.createElement("li", { className: "chart-legend__item", key: item.key },
            external_react_.createElement("span", { className: "chart-legend__color", style: { background: item.color } }),
            external_react_.createElement("span", { className: "chart-legend__text" }, this.getLegendText(item))));
    }
    getLegendText(item) {
        if (this.props.format) {
            return this.props.format(item.key, item.text, item.val, item.valFormatted);
        }
        return item.text;
    }
    render() {
        return (external_react_.createElement("ul", { className: this.BEM() }, this.props.items.map((item) => this.getLegendItem(item))));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/chart-legend/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/heading/node_modules/@core-front/error-provider/esm/error-provider.js

const error_provider_esm_error_provider_defaultContext = {
    log: (message) => console.error(message),
};
const error_provider_esm_error_provider_ErrorContext = external_react_.createContext(error_provider_esm_error_provider_defaultContext);
const error_provider_esm_error_provider_ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(error_provider_esm_error_provider_ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const _core_front_error_provider_esm_error_provider = ((/* unused pure expression or super */ null && (error_provider_esm_error_provider_ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@core-front/heading/node_modules/@core-front/error-provider/esm/use-log.js


const error_provider_esm_use_log_useErrorLog = () => {
    return external_react_.useContext(error_provider_esm_error_provider_ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@core-front/heading/esm/heading.js


const Heading = (props) => {
    const { element = 'h1', level, children, className, id, } = props;
    const { log } = error_provider_esm_use_log_useErrorLog();
    const isLevelValid = (l) => {
        if (!l) {
            return false;
        }
        if (l > 6 || l < 1) {
            log(`Level ${l} passed to Heading, which is incorrect. Rendering Heading with level 1 instead.`);
            return false;
        }
        return true;
    };
    const HeadingTag = isLevelValid(level) ? `h${level}` : element;
    const BEM = () => {
        const classArray = ['heading'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(HeadingTag, { className: BEM(), id: id }, children));
};


;// CONCATENATED MODULE: ./node_modules/d3/dist/package.js
var package_name = "d3";
var version = "6.7.0";
var description = "Data-Driven Documents";
var keywords = (/* unused pure expression or super */ null && (["dom","visualization","svg","animation","canvas"]));
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "dist/d3.node.js";
var unpkg = "dist/d3.min.js";
var jsdelivr = "dist/d3.min.js";
var package_module = "index.js";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var files = (/* unused pure expression or super */ null && (["dist/**/*.js","index.js"]));
var scripts = {"pretest":"rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c","test":"tape 'test/**/*-test.js'","prepublishOnly":"yarn test","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"};
var devDependencies = {"json2module":"0.0","rimraf":"3","rollup":"2","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"5","rollup-plugin-terser":"7","tape":"4","tape-await":"0.1"};
var dependencies = {"d3-array":"2","d3-axis":"2","d3-brush":"2","d3-chord":"2","d3-color":"2","d3-contour":"2","d3-delaunay":"5","d3-dispatch":"2","d3-drag":"2","d3-dsv":"2","d3-ease":"2","d3-fetch":"2","d3-force":"2","d3-format":"2","d3-geo":"2","d3-hierarchy":"2","d3-interpolate":"2","d3-path":"2","d3-polygon":"2","d3-quadtree":"2","d3-random":"2","d3-scale":"3","d3-scale-chromatic":"2","d3-selection":"2","d3-shape":"2","d3-time":"2","d3-time-format":"3","d3-timer":"2","d3-transition":"2","d3-zoom":"2"};

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selector.js
function none() {}

/* harmony default export */ function selector(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/select.js



/* harmony default export */ function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/array.js
/* harmony default export */ function array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selectorAll.js
function empty() {
  return [];
}

/* harmony default export */ function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectAll.js




function arrayAll(select) {
  return function() {
    var group = select.apply(this, arguments);
    return group == null ? [] : array(group);
  };
}

/* harmony default export */ function selectAll(select) {
  if (typeof select === "function") select = arrayAll(select);
  else select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/matcher.js
/* harmony default export */ function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}


;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectChild.js


var find = Array.prototype.find;

function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

/* harmony default export */ function selectChild(match) {
  return this.select(match == null ? childFirst
      : childFind(typeof match === "function" ? match : childMatcher(match)));
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectChildren.js


var filter = Array.prototype.filter;

function children() {
  return this.children;
}

function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}

/* harmony default export */ function selectChildren(match) {
  return this.selectAll(match == null ? children
      : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/filter.js



/* harmony default export */ function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sparse.js
/* harmony default export */ function sparse(update) {
  return new Array(update.length);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/enter.js



/* harmony default export */ function enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/constant.js
/* harmony default export */ function src_constant(x) {
  return function() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/data.js





function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = new Map,
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue.get(keyValues[i]) === node)) {
      exit[i] = node;
    }
  }
}

function datum(node) {
  return node.__data__;
}

/* harmony default export */ function data(value, key) {
  if (!arguments.length) return Array.from(this, datum);

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = src_constant(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = array(value.call(parent, parent && parent.__data__, j, parents)),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/exit.js



/* harmony default export */ function exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/join.js
/* harmony default export */ function join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/merge.js


/* harmony default export */ function merge(selection) {
  if (!(selection instanceof Selection)) throw new Error("invalid merge");

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/order.js
/* harmony default export */ function order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sort.js


/* harmony default export */ function sort(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
}

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/call.js
/* harmony default export */ function call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/nodes.js
/* harmony default export */ function nodes() {
  return Array.from(this);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/node.js
/* harmony default export */ function node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/size.js
/* harmony default export */ function size() {
  let size = 0;
  for (const node of this) ++size; // eslint-disable-line no-unused-vars
  return size;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/empty.js
/* harmony default export */ function selection_empty() {
  return !this.node();
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/each.js
/* harmony default export */ function each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/namespaces.js
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ const namespaces = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/namespace.js


/* harmony default export */ function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name; // eslint-disable-line no-prototype-builtins
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/attr.js


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ function attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/window.js
/* harmony default export */ function src_window(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/style.js


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ function style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || src_window(node).getComputedStyle(node, null).getPropertyValue(name);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/property.js
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ function property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/classed.js
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ function classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/text.js
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/html.js
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ function html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/raise.js
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ function selection_raise() {
  return this.each(raise);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/lower.js
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ function selection_lower() {
  return this.each(lower);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/creator.js



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/append.js


/* harmony default export */ function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/insert.js



function constantNull() {
  return null;
}

/* harmony default export */ function insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/remove.js
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ function selection_remove() {
  return this.each(remove);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/clone.js
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

/* harmony default export */ function clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/datum.js
/* harmony default export */ function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/on.js
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, options: options};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ function on(typename, value, options) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options));
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/dispatch.js


function dispatchEvent(node, type, params) {
  var window = src_window(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/iterator.js
/* harmony default export */ function* iterator() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) yield node;
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/index.js



































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

function selection_selection() {
  return this;
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selectAll,
  selectChild: selectChild,
  selectChildren: selectChildren,
  filter: selection_filter,
  data: data,
  enter: enter,
  exit: exit,
  join: join,
  merge: merge,
  selection: selection_selection,
  order: order,
  sort: sort,
  call: call,
  nodes: nodes,
  node: node,
  size: size,
  empty: selection_empty,
  each: each,
  attr: attr,
  style: style,
  property: property,
  classed: classed,
  text: selection_text,
  html: html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: insert,
  remove: selection_remove,
  clone: clone,
  datum: selection_datum,
  on: on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: iterator
};

/* harmony default export */ const src_selection = (selection);

;// CONCATENATED MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var noop = {value: () => {}};

function dispatch_dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function dispatch_parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch_dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = dispatch_parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ const src_dispatch = (dispatch_dispatch);

;// CONCATENATED MODULE: ./node_modules/d3-timer/src/timer.js
var timer_frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --timer_frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  timer_frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    timer_frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (timer_frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    timer_frame = 1, setFrame(wake);
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-timer/src/timeout.js


/* harmony default export */ function src_timeout(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(elapsed => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/schedule.js



var emptyOn = src_dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var schedule_SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = schedule_get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function schedule_set(node, id) {
  var schedule = schedule_get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function schedule_get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = schedule_SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== schedule_SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return src_timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    src_timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/interrupt.js


/* harmony default export */ function src_interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/interrupt.js


/* harmony default export */ function selection_interrupt(name) {
  return this.each(function() {
    src_interrupt(this, name);
  });
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/number.js
/* harmony default export */ function number(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/decompose.js
var degrees = 180 / Math.PI;

var decompose_identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/parse.js


var svgNode;

/* eslint-disable no-undef */
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? decompose_identity : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}

function parseSvg(value) {
  if (value == null) return decompose_identity;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return decompose_identity;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/index.js



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/tween.js


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ function tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = schedule_get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = schedule_set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return schedule_get(node, id).value[name];
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-color/src/define.js
/* harmony default export */ function src_define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

;// CONCATENATED MODULE: ./node_modules/d3-color/src/color.js


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

src_define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function color_rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

src_define(Rgb, color_rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

src_define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basis.js
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ function src_basis(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basisClosed.js


/* harmony default export */ function basisClosed(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/constant.js
/* harmony default export */ const d3_interpolate_src_constant = (x => () => x);

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/color.js


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : d3_interpolate_src_constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : d3_interpolate_src_constant(isNaN(a) ? b : a);
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/rgb.js





/* harmony default export */ const rgb = ((function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = color_rgb(start)).r, (end = color_rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = color_rgb(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(src_basis);
var rgbBasisClosed = rgbSpline(basisClosed);

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/string.js


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: number(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/interpolate.js



/* harmony default export */ function transition_interpolate(a, b) {
  var c;
  return (typeof b === "number" ? number
      : b instanceof color ? rgb
      : (c = color(b)) ? (b = c, rgb)
      : string)(a, b);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attr.js





function attr_attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attr_attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attr_attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attr_attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attr_attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attr_attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

/* harmony default export */ function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : transition_interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attr_attrFunctionNS : attr_attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attr_attrRemoveNS : attr_attrRemove)(fullname)
      : (fullname.local ? attr_attrConstantNS : attr_attrConstant)(fullname, i, value));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attrTween.js


function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/delay.js


function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

/* harmony default export */ function delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : schedule_get(this.node(), id).delay;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/duration.js


function durationFunction(id, value) {
  return function() {
    schedule_set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    schedule_set(this, id).duration = value;
  };
}

/* harmony default export */ function duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : schedule_get(this.node(), id).duration;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/ease.js


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    schedule_set(this, id).ease = value;
  };
}

/* harmony default export */ function ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : schedule_get(this.node(), id).ease;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/easeVarying.js


function easeVarying(id, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error;
    schedule_set(this, id).ease = v;
  };
}

/* harmony default export */ function transition_easeVarying(value) {
  if (typeof value !== "function") throw new Error;
  return this.each(easeVarying(this._id, value));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/filter.js



/* harmony default export */ function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new transition_Transition(subgroups, this._parents, this._name, this._id);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/merge.js


/* harmony default export */ function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new transition_Transition(merges, this._parents, this._name, this._id);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/on.js


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : schedule_set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? schedule_get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/remove.js
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/select.js




/* harmony default export */ function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, schedule_get(node, id));
      }
    }
  }

  return new transition_Transition(subgroups, this._parents, name, id);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selectAll.js




/* harmony default export */ function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = schedule_get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new transition_Transition(subgroups, parents, name, id);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selection.js


var selection_Selection = src_selection.prototype.constructor;

/* harmony default export */ function transition_selection() {
  return new selection_Selection(this._groups, this._parents);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/style.js






function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function style_styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function style_styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function style_styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = schedule_set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = style_styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

/* harmony default export */ function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : transition_interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, style_styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, style_styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, style_styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/styleTween.js
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/text.js


function text_textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function text_textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? text_textFunction(tweenValue(this, "text", value))
      : text_textConstant(value == null ? "" : value + ""));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/textTween.js
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/transition.js



/* harmony default export */ function transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = schedule_get(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new transition_Transition(groups, this._parents, name, id1);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/end.js


/* harmony default export */ function end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = schedule_set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });

    // The selection was empty, resolve end immediately
    if (size === 0) resolve();
  });
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/index.js






















var id = 0;

function transition_Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition_transition(name) {
  return src_selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = src_selection.prototype;

transition_Transition.prototype = transition_transition.prototype = {
  constructor: transition_Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: tween,
  delay: delay,
  duration: duration,
  ease: ease,
  easeVarying: transition_easeVarying,
  end: end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/cubic.js
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/transition.js





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id} not found`);
    }
  }
  return timing;
}

/* harmony default export */ function selection_transition(name) {
  var id,
      timing;

  if (name instanceof transition_Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new transition_Transition(groups, this._parents, name, id);
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/index.js




src_selection.prototype.interrupt = selection_interrupt;
src_selection.prototype.transition = selection_transition;

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/active.js



var active_root = (/* unused pure expression or super */ null && ([null]));

/* harmony default export */ function active(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], active_root, name, +i);
      }
    }
  }

  return null;
}

;// CONCATENATED MODULE: ./node_modules/d3-transition/src/index.js





;// CONCATENATED MODULE: ./node_modules/d3-brush/src/brush.js









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

const {abs, max, min} = Math;

function number1(e) {
  return [+e[0], +e[1]];
}

function number2(e) {
  return [number1(e[0]), number1(e[1])];
}

var X = {
  name: "x",
  handles: ["w", "e"].map(type),
  input: function(x, e) { return x == null ? null : [[+x[0], e[0][1]], [+x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y == null ? null : [[e[0][0], +y[0]], [e[1][0], +y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type),
  input: function(xy) { return xy == null ? null : number2(xy); },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
  return !event.ctrlKey && !event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  if (svg.hasAttribute("viewBox")) {
    svg = svg.viewBox.baseVal;
    return [[svg.x, svg.y], [svg.x + svg.width, svg.y + svg.height]];
  }
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

function defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function brush_empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush_brush(X);
}

function brushY() {
  return brush_brush(Y);
}

/* harmony default export */ function brush() {
  return brush_brush(XY);
}

function brush_brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      touchable = defaultTouchable,
      keys = true,
      listeners = dispatch("start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          select(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .on("mousedown.brush", started)
      .filter(touchable)
        .on("touchstart.brush", started)
        .on("touchmove.brush", touchmoved)
        .on("touchend.brush touchcancel.brush", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  brush.move = function(group, selection) {
    if (group.tween) {
      group
          .on("start.brush", function(event) { emitter(this, arguments).beforestart().start(event); })
          .on("interrupt.brush end.brush", function(event) { emitter(this, arguments).end(event); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = interpolate(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && selection1 === null ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 !== null && selection1 !== null ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            interrupt(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  brush.clear = function(group) {
    brush.move(group, null);
  };

  function redraw() {
    var group = select(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args, clean) {
    var emit = that.__brush.emitter;
    return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
  }

  function Emitter(that, args, clean) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
    this.clean = clean;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function(event, mode) {
      if (this.starting) this.starting = false, this.emit("start", event, mode);
      else this.emit("brush", event);
      return this;
    },
    brush: function(event, mode) {
      this.emit("brush", event, mode);
      return this;
    },
    end: function(event, mode) {
      if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
      return this;
    },
    emit: function(type, event, mode) {
      var d = select(this.that).datum();
      listeners.call(
        type,
        this.that,
        new BrushEvent(type, {
          sourceEvent: event,
          target: brush,
          selection: dim.output(this.state.selection),
          mode,
          dispatch: listeners
        }),
        d
      );
    }
  };

  function started(event) {
    if (touchending && !event.touches) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = event.target.__data__.type,
        mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (keys && event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx = 0,
        dy = 0,
        moving,
        shifting = signX && signY && keys && event.shiftKey,
        lockX,
        lockY,
        points = Array.from(event.touches || [event], t => {
          const i = t.identifier;
          t = pointer(t, that);
          t.point0 = t.slice();
          t.identifier = i;
          return t;
        });

    if (type === "overlay") {
      if (selection) moving = true;
      const pts = [points[0], points[1] || points[0]];
      state.selection = selection = [[
          w0 = dim === Y ? W : min(pts[0][0], pts[1][0]),
          n0 = dim === X ? N : min(pts[0][1], pts[1][1])
        ], [
          e0 = dim === Y ? E : max(pts[0][0], pts[1][0]),
          s0 = dim === X ? S : max(pts[0][1], pts[1][1])
        ]];
      if (points.length > 1) move();
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = select(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    interrupt(that);
    var emit = emitter(that, arguments, true).beforestart();

    if (event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = select(event.view)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);
      if (keys) view
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)

      dragDisable(event.view);
    }

    redraw.call(that);
    emit.start(event, mode.name);

    function moved(event) {
      for (const p of event.changedTouches || [event]) {
        for (const d of points)
          if (d.identifier === p.identifier) d.cur = pointer(p, that);
      }
      if (shifting && !lockX && !lockY && points.length === 1) {
        const point = points[0];
        if (abs(point.cur[0] - point[0]) > abs(point.cur[1] - point[1]))
          lockY = true;
        else
          lockX = true;
      }
      for (const point of points)
        if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
      moving = true;
      noevent(event);
      move(event);
    }

    function move(event) {
      const point = points[0], point0 = point.point0;
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = max(W - w0, min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (points[1]) {
            if (signX) w1 = max(W, min(E, points[0][0])), e1 = max(W, min(E, points[1][0])), signX = 1;
            if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
          } else {
            if (signX < 0) dx = max(W - w0, min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
            else if (signX > 0) dx = max(W - e0, min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
            else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          }
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = max(W, min(E, w0 - dx * signX)), e1 = max(W, min(E, e0 + dx * signX));
          if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush(event, mode.name);
      }
    }

    function ended(event) {
      nopropagation(event);
      if (event.touches) {
        if (event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
      } else {
        dragEnable(event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (brush_empty(selection)) state.selection = null, redraw.call(that);
      emit.end(event, mode.name);
    }

    function keydowned(event) {
      switch (event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent(event);
    }

    function keyupped(event) {
      switch (event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent(event);
    }
  }

  function touchmoved(event) {
    emitter(this, arguments).moved(event);
  }

  function touchended(event) {
    emitter(this, arguments).ended(event);
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = number2(extent.apply(this, arguments));
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant(number2(_)), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), brush) : filter;
  };

  brush.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), brush) : touchable;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.keyModifiers = function(_) {
    return arguments.length ? (keys = !!_, brush) : keys;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

;// CONCATENATED MODULE: ./node_modules/d3-brush/src/index.js


;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/array.js



/* harmony default export */ function src_array(a, b) {
  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/date.js
/* harmony default export */ function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/object.js


/* harmony default export */ function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = value(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/numberArray.js
/* harmony default export */ function src_numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function numberArray_isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/value.js










/* harmony default export */ function value(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? d3_interpolate_src_constant(b)
      : (t === "number" ? number
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : string)
      : b instanceof color ? rgb
      : b instanceof Date ? date
      : numberArray_isNumberArray(b) ? src_numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : number)(a, b);
}

;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/index.js






















;// CONCATENATED MODULE: ./node_modules/d3-scale/src/init.js
function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-scale/src/ordinal.js


const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

;// CONCATENATED MODULE: ./node_modules/d3-scale/src/index.js


































;// CONCATENATED MODULE: ./node_modules/d3-selection/src/select.js


/* harmony default export */ function src_select(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
}

;// CONCATENATED MODULE: ./node_modules/d3-selection/src/index.js
















;// CONCATENATED MODULE: ./node_modules/d3-path/src/path.js
const pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ const src_path = (path);

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/constant.js
/* harmony default export */ function d3_shape_src_constant(x) {
  return function constant() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/math.js
var math_abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var math_max = Math.max;
var math_min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var math_epsilon = 1e-12;
var math_pi = Math.PI;
var halfPi = math_pi / 2;
var math_tau = 2 * math_pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? math_pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/arc.js




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < math_epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(math_max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = d3_shape_src_constant(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = math_abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = src_path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > math_epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > math_tau - math_epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > math_epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > math_epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = math_min(math_abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > math_epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > math_epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > math_epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > math_epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < math_pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = math_min(rc, (r0 - lc) / (kc - 1));
          rc1 = math_min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > math_epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > math_epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > math_epsilon) || !(da0 > math_epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > math_epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - math_pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/array.js
var slice = Array.prototype.slice;

/* harmony default export */ function d3_shape_src_array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/descending.js
/* harmony default export */ function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/identity.js
/* harmony default export */ function src_identity(d) {
  return d;
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/pie.js






/* harmony default export */ function pie() {
  var value = src_identity,
      sortValues = descending,
      sort = null,
      startAngle = d3_shape_src_constant(0),
      endAngle = d3_shape_src_constant(math_tau),
      padAngle = d3_shape_src_constant(0);

  function pie(data) {
    var i,
        n = (data = d3_shape_src_array(data)).length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(math_tau, Math.max(-math_tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : padAngle;
  };

  return pie;
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/index.js




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!










































;// CONCATENATED MODULE: ./node_modules/d3-zoom/src/transform.js
function transform_Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

transform_Transform.prototype = {
  constructor: transform_Transform,
  scale: function(k) {
    return k === 1 ? this : new transform_Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new transform_Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var transform_identity = new transform_Transform(1, 0, 0);

transform.prototype = transform_Transform.prototype;

function transform(node) {
  while (!node.__zoom) if (!(node = node.parentNode)) return transform_identity;
  return node.__zoom;
}

;// CONCATENATED MODULE: ./node_modules/d3-zoom/src/zoom.js










// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function zoom_defaultFilter(event) {
  return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}

function zoom_defaultExtent() {
  var e = this;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    if (e.hasAttribute("viewBox")) {
      e = e.viewBox.baseVal;
      return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
    }
    return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
  }
  return [[0, 0], [e.clientWidth, e.clientHeight]];
}

function defaultTransform() {
  return this.__zoom || identity;
}

function defaultWheelDelta(event) {
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}

function zoom_defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* harmony default export */ function zoom() {
  var filter = zoom_defaultFilter,
      extent = zoom_defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = zoom_defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = interpolateZoom,
      listeners = dispatch("start", "zoom", "end"),
      touchstarting,
      touchfirst,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0,
      tapDistance = 10;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform, point, event) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform, point, event);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
          .event(event)
          .start()
          .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
          .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k, p, event) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    }, p, event);
  };

  zoom.scaleTo = function(selection, k, p, event) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p,
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    }, p, event);
  };

  zoom.translateBy = function(selection, x, y, event) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    }, null, event);
  };

  zoom.translateTo = function(selection, x, y, p, event) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
      return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    }, p, event);
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, point, event) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).event(event).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).event(event).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args).event(event),
              e = extent.apply(that, args),
              p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point,
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args, clean) {
    return (!clean && that.__zooming) || new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.sourceEvent = null;
    this.extent = extent.apply(that, args);
    this.taps = 0;
  }

  Gesture.prototype = {
    event: function(event) {
      if (event) this.sourceEvent = event;
      return this;
    },
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      var d = select(this.that).datum();
      listeners.call(
        type,
        this.that,
        new ZoomEvent(type, {
          sourceEvent: this.sourceEvent,
          target: zoom,
          type,
          transform: this.that.__zoom,
          dispatch: listeners
        }),
        d
      );
    }
  };

  function wheeled(event, ...args) {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, args).event(event),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = pointer(event);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }

    noevent(event);
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned(event, ...args) {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, args, true).event(event),
        v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = pointer(event, currentTarget),
        currentTarget = event.currentTarget,
        x0 = event.clientX,
        y0 = event.clientY;

    dragDisable(event.view);
    nopropagation(event);
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();

    function mousemoved(event) {
      noevent(event);
      if (!g.moved) {
        var dx = event.clientX - x0, dy = event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.event(event)
       .zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped(event) {
      v.on("mousemove.zoom mouseup.zoom", null);
      dragEnable(event.view, g.moved);
      noevent(event);
      g.event(event).end();
    }
  }

  function dblclicked(event, ...args) {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = pointer(event.changedTouches ? event.changedTouches[0] : event, this),
        p1 = t0.invert(p0),
        k1 = t0.k * (event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);

    noevent(event);
    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0, event);
    else select(this).call(zoom.transform, t1, p0, event);
  }

  function touchstarted(event, ...args) {
    if (!filter.apply(this, arguments)) return;
    var touches = event.touches,
        n = touches.length,
        g = gesture(this, args, event.changedTouches.length === n).event(event),
        started, i, t, p;

    nopropagation(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer(t, this);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
      else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
    }

    if (touchstarting) touchstarting = clearTimeout(touchstarting);

    if (started) {
      if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      interrupt(this);
      g.start();
    }
  }

  function touchmoved(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event),
        touches = event.changedTouches,
        n = touches.length, i, t, p, l;

    noevent(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer(t, this);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;

    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event),
        touches = event.changedTouches,
        n = touches.length, i, t;

    nopropagation(event);
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else {
      g.end();
      // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
      if (g.taps === 2) {
        t = pointer(t, this);
        if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
          var p = select(this).on("dblclick.zoom");
          if (p) p.apply(this, arguments);
        }
      }
    }
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  zoom.tapDistance = function(_) {
    return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
  };

  return zoom;
}

;// CONCATENATED MODULE: ./node_modules/d3-zoom/src/index.js



;// CONCATENATED MODULE: ./node_modules/d3/index.js
































;// CONCATENATED MODULE: ./node_modules/@core-front/chart-pie/esm/chart-pie-core.js
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-this-alias */


class ChartPieCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.containerWidth = 0;
        this.innerRadius = 0;
        this.outerRadius = 0;
        this.unusedInnerRadius = 0;
        this.unusedOuterRadius = 0;
        this.mounted = false;
        this.graphCreated = false;
        this.resize = () => {
            this.updateGraph();
        };
        /* Tooltip */
        this.setTooltipData = (data) => {
            this.setState({
                tooltip: data,
            });
        };
        this.resetTooltipData = () => {
            this.setState({
                tooltip: null,
            });
        };
        this.state = {
            colors: null,
            tooltip: null,
        };
    }
    componentDidMount() {
        this.mounted = true;
        const colors = ordinal(this.props.colors);
        this.setState({ colors }, () => {
            this.createGraph();
            window.addEventListener('resize', this.resize);
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('resize', this.resize);
    }
    componentDidUpdate(prevProps) {
        if (!this.compareData(prevProps.data, this.props.data) && this.mounted && this.graphCreated) {
            this.updateGraph();
        }
    }
    BEM() {
        const classArray = ['chart-pie'];
        classArray.push('chart-pie--align-' + this.props.align);
        if (this.props.legend) {
            classArray.push('chart-pie--legend');
            if (this.props.legend.aside) {
                classArray.push('chart-pie--legend-aside');
            }
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    /* Graph */
    createGraph() {
        this.transition = transition_transition().duration(800).ease(this.easeOutQuint);
        this.svgEl = src_select(this.containerEl).append('svg').attr('class', 'chart-pie__graph-svg');
        this.unusedGroupEl = this.svgEl.append('g').attr('class', 'chart-pie__unused');
        this.graphGroupEl = this.svgEl.append('g').attr('class', 'chart-pie__graph');
        this.tooltipGroupEl = this.svgEl.append('g').attr('class', 'chart-pie__tooltip');
        this.unusedGroupEl.append('path').attr('class', 'chart-pie__unused-path');
        this.graphCreated = true;
        this.updateGraph();
    }
    updateGraph() {
        const data = this.props.disabled ? [] : this.props.data.json;
        this.containerWidth = this.containerEl.clientWidth;
        this.svgEl.attr('width', this.containerWidth).attr('height', this.containerWidth);
        this.unusedGroupEl.attr('transform', this.alignCenter());
        this.graphGroupEl.attr('transform', this.alignCenter());
        this.tooltipGroupEl.attr('transform', this.alignCenter());
        this.innerRadius = this.containerWidth / 2 - this.props.arcWidth;
        this.outerRadius = this.containerWidth / 2;
        this.unusedInnerRadius = (this.containerWidth - this.props.arcUnusedWidth - this.props.arcWidth) / 2;
        this.unusedOuterRadius = (this.containerWidth + this.props.arcUnusedWidth - this.props.arcWidth) / 2;
        this.updateGraphUnusedPath();
        this.updateGraphClipPath(data);
        this.updateGraphArcPath(data);
        this.updateGraphTooltipArc(data);
    }
    updateGraphUnusedPath() {
        const unusedArc = arc().innerRadius(this.unusedInnerRadius).outerRadius(this.unusedOuterRadius).startAngle(0).endAngle(Math.PI * 2);
        this.unusedGroupEl
            .select('.chart-pie__unused-path')
            .attr('d', unusedArc);
    }
    updateGraphClipPath(data) {
        const totalUsed = this.getTotal(data);
        const totalUnused = this.getTotalUnused(data);
        const clipArc = arc().innerRadius(this.innerRadius).outerRadius(this.outerRadius).cornerRadius(this.props.arcWidth / 2);
        const clipData = pie().sort(null)([totalUsed, totalUnused]);
        const clipPath = this.graphGroupEl
            .selectAll('.chart-pie__clip')
            .data(clipData);
        clipPath
            .exit()
            .remove();
        clipPath
            .select('.chart-pie__clip-path')
            .interrupt()
            .transition()
            .attr('d', clipArc);
        clipPath
            .enter()
            .append('clipPath')
            .attr('class', 'chart-pie__clip')
            .attr('id', ({}, i) => this.props.id + '-' + i)
            .append('path')
            .attr('class', 'chart-pie__clip-path')
            .transition()
            .delay(320)
            .attrTween('d', (d) => this.arcTween(d, clipArc));
    }
    updateGraphArcPath(data) {
        const self = this;
        const arcDatum = arc().innerRadius(this.innerRadius).outerRadius(this.outerRadius);
        const arcData = pie().sort(null).value(({ val }) => val)(data);
        function onMouseover(event, d) {
            if (self.props.tooltip && self.props.tooltip.show && !self.props.tooltip.grouped) {
                self.setTooltipData({
                    data: [d.data],
                    ref: event.currentTarget,
                });
            }
        }
        function onMouseout() {
            if (self.props.tooltip && self.props.tooltip.show && !self.props.tooltip.grouped) {
                self.resetTooltipData();
            }
        }
        const arcPath = this.graphGroupEl
            .selectAll('.chart-pie__arc')
            .data(arcData);
        arcPath
            .exit()
            .remove();
        arcPath
            .interrupt()
            .transition()
            .attr('d', arcDatum);
        arcPath
            .enter()
            .append('path')
            .attr('class', 'chart-pie__arc')
            .attr('clip-path', () => ('url(#' + this.props.id + '-0)')) // Rounded corners
            .on('mouseover', onMouseover)
            .on('touchstart', onMouseover)
            .on('mouseout', onMouseout)
            .style('fill', (d) => this.getColor(d.data.key))
            .style('visibility', (d) => (d.data.key === this.props.data.unused) ? 'hidden' : 'visible')
            .transition()
            .delay(320)
            .attrTween('d', (d) => this.arcTween(d, arcDatum));
    }
    updateGraphTooltipArc(data) {
        // Hidden area for grouped tooltip feature
        const self = this;
        const total = this.props.tooltip && this.props.tooltip.grouped ? [this.getTotal(data, true)] : [];
        const tooltipArc = arc().innerRadius(0).outerRadius(this.outerRadius);
        const tooltipArcData = pie().sort(null)(total);
        function onMouseover(event) {
            if (self.props.tooltip && self.props.tooltip.show && self.props.tooltip.grouped) {
                self.setTooltipData({
                    data,
                    ref: event.currentTarget,
                });
            }
        }
        function onMouseout() {
            if (self.props.tooltip && self.props.tooltip.show && self.props.tooltip.grouped) {
                self.resetTooltipData();
            }
        }
        const tooltipArcPath = this.tooltipGroupEl
            .selectAll('.chart-pie__tooltip-arc')
            .data(tooltipArcData);
        tooltipArcPath
            .exit()
            .remove();
        tooltipArcPath
            .attr('d', tooltipArc);
        tooltipArcPath
            .enter()
            .append('path')
            .attr('class', 'chart-pie__tooltip-arc')
            .attr('d', tooltipArc)
            .on('mouseover', onMouseover)
            .on('touchstart', onMouseover)
            .on('mouseout', onMouseout)
            .style('fill', () => 'transparent')
            .attr('d', tooltipArc);
    }
    compareData(o1, o2) {
        if (typeof o1 === 'undefined' || o1 === null || typeof o2 === 'undefined' || o2 === null) {
            return o1 === o2;
        }
        return typeof o1 === 'object' && Object.keys(o1).length > 0
            ? Object.keys(o1).length === Object.keys(o2).length
                && Object.keys(o1).every((p) => this.compareData(o1[p], o2[p]))
            : o1 === o2;
    }
    /* Title */
    getTitle() {
        const { Heading } = this.props.components;
        return (external_react_.createElement("div", { className: "chart-pie__title" },
            external_react_.createElement(Heading, { level: this.props.headingLevel, className: "h3 chart-pie__title-text" }, this.props.title)));
    }
    /* Legend */
    getLegend() {
        if (!this.props.legend) {
            return null;
        }
        const items = this.props.data.json.map((item) => {
            const keyFormatted = this.getFormattedKey(item.key);
            const valFormatted = this.getFormattedVal(item.val);
            return {
                color: this.getColor(item.key),
                key: item.key,
                text: keyFormatted,
                val: item.val,
                valFormatted,
            };
        });
        const { ChartLegend } = this.props.components;
        return (external_react_.createElement("div", { className: "chart-pie__legend" },
            external_react_.createElement(ChartLegend, { items: items, format: this.props.format.legend, stacked: this.props.legend.stacked, size: this.props.legend.size })));
    }
    getTooltip() {
        if (!this.props.tooltip) {
            return null;
        }
        if (!this.props.tooltip.show) {
            return null;
        }
        if (!this.state.tooltip) {
            return null;
        }
        const tooltipProps = this.getTooltipSettings();
        const { Tooltip } = this.props.components;
        return (external_react_.createElement(Tooltip, Object.assign({}, tooltipProps), this.getTooltipItems(this.state.tooltip.data)));
    }
    getTooltipItems(data) {
        return (external_react_.createElement("ul", { className: "chart-pie__tooltip-list" }, data.map((item) => this.getTooltipItem(item))));
    }
    getTooltipItem(item) {
        const keyFormatted = this.getFormattedKey(item === null || item === void 0 ? void 0 : item.key);
        const valFormatted = this.getFormattedVal(item === null || item === void 0 ? void 0 : item.val);
        const keyColor = this.getColor(item === null || item === void 0 ? void 0 : item.key);
        if (this.props.format && this.props.format.tooltip) {
            return (external_react_.createElement("li", { key: item.key, className: "chart-pie__tooltip-list-item" },
                external_react_.createElement("span", { className: "chart-pie__tooltip-color", style: { background: keyColor } }),
                external_react_.createElement("span", null, this.props.format.tooltip(item === null || item === void 0 ? void 0 : item.key, keyFormatted, item === null || item === void 0 ? void 0 : item.val, valFormatted, keyColor))));
        }
        return (external_react_.createElement("li", { key: item === null || item === void 0 ? void 0 : item.key, className: "chart-pie__tooltip-list-item" },
            external_react_.createElement("span", { className: "chart-pie__tooltip-color", style: { background: keyColor } }),
            external_react_.createElement("span", null,
                external_react_.createElement("strong", null, valFormatted),
                "\u00A0",
                external_react_.createElement("span", null, keyFormatted))));
    }
    getTooltipSettings() {
        var _a, _b;
        if (!this.props.tooltip) {
            return null;
        }
        if (!this.state.tooltip) {
            return null;
        }
        let color = 'info';
        const placement = 'right';
        const customSettings = this.props.tooltip.settings ? this.props.tooltip.settings : {};
        if (!this.props.tooltip.grouped) {
            color = ((_b = (_a = this.state.tooltip) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.key) ? this.getColor(this.state.tooltip.data[0].key) : this.props.colors[0];
        }
        return (Object.assign(Object.assign({ color,
            placement, referenceElement: this.state.tooltip.ref }, customSettings), { onHide: this.resetTooltipData }));
    }
    /* D3 helpers */
    arcTween(d, arc) {
        const interpolateFn = value({ endAngle: 0, startAngle: 0 }, d);
        return (t) => arc(interpolateFn(t)) || '';
    }
    getColor(key) {
        return (key === this.props.data.unused) ? '#e4e4e4' : this.state.colors(key);
    }
    getTotal(arr, withUnused = false) {
        return arr
            .filter((item) => withUnused || item.key !== this.props.data.unused)
            .map((item) => item.val)
            .reduce((a, b) => a + b, 0);
    }
    getTotalUnused(arr) {
        if (!this.props.data.unused) {
            return 0;
        }
        return arr
            .filter((item) => item.key === this.props.data.unused)
            .map((item) => item.val)[0] || 0;
    }
    /* CSS helpers */
    alignCenter() {
        return 'translate(' + this.containerWidth / 2 + ',' + this.containerWidth / 2 + ')';
    }
    /* Format */
    getFormattedKey(key) {
        return this.getFormatted(this.props.format.key, key);
    }
    getFormattedVal(val) {
        return this.getFormatted(this.props.format.val, val);
    }
    getFormatted(format, val) {
        if (format) {
            if (typeof format === 'object' && !(format instanceof Array)) {
                return format[val];
            }
            if (typeof format === 'function' && !(format instanceof Array)) {
                return format(val);
            }
            return `${val} ${format}`;
        }
        return val.toString();
    }
    /* Transitions */
    easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
    }
    /* Render */
    render() {
        return (external_react_.createElement("div", { className: this.BEM() },
            external_react_.createElement("div", { className: "chart-pie__inner" },
                this.props.title && this.getTitle(),
                external_react_.createElement("div", { className: "chart-pie__main" },
                    external_react_.createElement("div", { className: "chart-pie__graph-container", ref: (containerEl) => (this.containerEl = containerEl), style: { maxWidth: this.props.maxWidth } },
                        external_react_.createElement("div", { style: { width: this.props.maxWidth } }),
                        external_react_.createElement("div", { className: "chart-pie__graph-content", style: { padding: this.props.arcWidth + this.props.contentPadding } },
                            external_react_.createElement("div", { className: "chart-pie__graph-content-inner" }, this.props.children))),
                    this.state.colors && this.getLegend(),
                    this.getTooltip()))));
    }
}
ChartPieCore.defaultProps = {
    align: 'left',
    arcUnusedWidth: 6,
    arcWidth: 6,
    children: [],
    colors: ['#000000', '#8a8a8a', '#f2f2f2', '#e4e4e4', '#ffffff'],
    contentPadding: 10,
    data: {
        json: [],
        unused: null,
    },
    format: {
        key: undefined,
        legend: undefined,
        tooltip: undefined,
        val: undefined,
    },
    id: 'uid',
    maxWidth: 240,
    headingLevel: 3,
};

;// CONCATENATED MODULE: ./node_modules/@core-front/chart-pie/esm/chart-pie.js





class ChartPie extends external_react_.Component {
    render() {
        return (external_react_.createElement(ChartPieCore, Object.assign({}, this.props, { components: {
                Tooltip: tooltip,
                ChartLegend: ChartLegend,
                Heading: Heading,
            } })));
    }
}
ChartPie.defaultProps = {
    colors: ['#000000', '#8a8a8a', '#f2f2f2', '#e4e4e4', '#ffffff'],
};

;// CONCATENATED MODULE: ./node_modules/@core-front/chart-pie/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/check/esm/check-core.js



const CheckCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "Check", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onChange',
                id: ([checked]) => `Checkbox - ${checked ? 'Check' : 'Uncheck'} - ${props.id}`,
                elementType: 'checkbox',
                elementId: props.id,
                interactionType: ([checked]) => `${checked ? 'check' : 'uncheck'}` } },
            external_react_.createElement(CheckCoreInner, Object.assign({}, props)))));
};
const CheckCoreInner = (props) => {
    const { components: { Icon, Skeleton, SkeletonItem }, input, checked, defaultChecked, onChange, disabled, value, id, labelText, children, extraContent, size, employee, employeeBackground, direction, indicatorAlign, hideLabel, className, fullWidthContent, } = props;
    const [innerChecked, setInnerChecked] = external_react_.useState(defaultChecked || false);
    const isChecked = onChange && typeof checked !== 'undefined' ? checked : innerChecked;
    const handleChange = () => {
        const nextChecked = !isChecked;
        if (disabled) {
            return;
        }
        if (typeof checked === 'undefined') {
            setInnerChecked(nextChecked);
        }
        if (onChange) {
            onChange(nextChecked);
        }
    };
    const BEM = () => {
        const classArray = ['check'];
        if (size) {
            classArray.push(`check--${size}`);
        }
        if (employee) {
            classArray.push('check--employee');
        }
        if (employee && employeeBackground) {
            classArray.push('check--employee-background');
        }
        if (direction) {
            classArray.push(`check--${direction}`);
        }
        if (indicatorAlign) {
            classArray.push('check--indicator-' + indicatorAlign);
        }
        if (hideLabel) {
            classArray.push('check--hide-label');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getInputClass = () => {
        const classArray = ['check__input'];
        if (input && input.className) {
            classArray.push(input.className);
        }
        return classArray.join(' ');
    };
    const checkInnerBEM = () => {
        const classArray = ['check__inner'];
        if (fullWidthContent) {
            classArray.push('check__inner--full-width');
        }
        return classArray.join(' ');
    };
    if ('skeleton' in props) {
        const { skeleton } = props;
        const { lineCount = 1, lineHeight, lineWidth } = skeleton;
        return (external_react_.createElement(Skeleton, { className: BEM(), label: skeleton.label },
            external_react_.createElement("div", { className: checkInnerBEM() },
                external_react_.createElement(SkeletonItem, { className: "check__indicator" }),
                external_react_.createElement("div", { className: "check__content" }, [...Array(lineCount).keys()].map((_line, index) => (external_react_.createElement(SkeletonItem, { key: index, height: lineHeight, width: lineWidth })))))));
    }
    return (external_react_.createElement("div", { className: BEM() },
        external_react_.createElement("input", Object.assign({}, input, { type: "checkbox", checked: isChecked, defaultChecked: undefined, disabled: disabled, value: value, onChange: handleChange, id: id, className: getInputClass(), "aria-invalid": props['aria-invalid'], "aria-describedby": props['aria-describedby'] })),
        external_react_.createElement("label", { htmlFor: id, className: "check__label" }, labelText),
        external_react_.createElement("div", { className: checkInnerBEM(), onClick: handleChange },
            external_react_.createElement("span", { className: "check__indicator" },
                external_react_.createElement(Icon, { modifiers: "#check", className: "check__icon" })),
            external_react_.createElement("div", { className: "check__content", "aria-hidden": !children }, children || labelText)),
        extraContent && external_react_.createElement("div", { className: "check__extra" }, extraContent)));
};
/* harmony default export */ const check_core = (CheckCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/check/esm/check.js
var check_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const Check = (props) => {
    const { employeeBackground = true, size = 'large' } = props, rest = check_rest(props, ["employeeBackground", "size"]);
    return (external_react_.createElement(check_core, Object.assign({}, rest, { size: size, employeeBackground: employeeBackground, components: {
            Icon: icon/* default */.Z,
            Skeleton: skeleton_skeleton/* default */.Z,
            SkeletonItem: skeleton_item_skeleton_item/* default */.Z,
        } })));
};
/* harmony default export */ const check = (Check);

;// CONCATENATED MODULE: ./node_modules/@core-front/check/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/chip/esm/chip-core.js


const ChipCore = (props) => {
    const labels = useLabels();
    const { components: { Icon, }, children, className, disabled, onRemove, removeButtonLabel, } = props;
    const BEM = () => {
        const classArray = ['chip'];
        if (disabled) {
            classArray.push('is-disabled');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const onRemoveClick = (event) => {
        event.preventDefault();
        if (onRemove) {
            onRemove(event);
        }
    };
    return (external_react_default().createElement("div", { className: BEM() },
        children,
        onRemove && (external_react_default().createElement("button", { type: "button", className: "chip__remove", onClick: onRemoveClick, disabled: disabled },
            external_react_default().createElement(Icon, { modifiers: "#close-round", size: "xxs", className: "chip__remove-icon" }),
            external_react_default().createElement("span", { className: "sr-only" }, removeButtonLabel || labels.get('remove'))))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/chip/esm/chip.js



const Chip = (props) => {
    return (external_react_default().createElement(ChipCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/chip/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/form-helper/esm/form-helper-core.js

const FormHelperCore = (props) => {
    const { id, type, text, className, components: { Icon, Spinner, }, } = props;
    const BEM = () => {
        const classArray = ['form-helper'];
        if (type) {
            classArray.push('form-helper--' + type);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getModifier = () => {
        switch (type) {
            case 'error':
                return '#alert';
            default:
                return '#info-round';
        }
    };
    const getIcon = () => {
        if (type === 'valid') {
            return (external_react_.createElement("svg", { preserveAspectRatio: "xMidYMid", width: "16", height: "16", viewBox: "0 0 16 16", focusable: "false" },
                external_react_.createElement("circle", { className: "form-helper__check-circle", fill: "transparent", stroke: "#00CC66", cx: "8", cy: "8", r: "7" }),
                external_react_.createElement("polyline", { className: "form-helper__check-check", stroke: "#FFFFFF", strokeLinecap: "round", strokeLinejoin: "round", points: "5.3125 8.5625 7.4375 10.5 10.6875 5.285", fill: "transparent" })));
        }
        else if (type === 'loading') {
            return external_react_.createElement(Spinner, { className: "form-helper__spinner" });
        }
        return external_react_.createElement(Icon, { modifiers: getModifier() });
    };
    return (external_react_.createElement("div", { className: BEM(), id: id },
        external_react_.createElement("span", { className: "form-helper__icon" }, getIcon()),
        external_react_.createElement("span", { className: "form-helper__content" }, text)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/form-helper/esm/form-helper.js




const FormHelper = (props) => {
    return (external_react_.createElement(FormHelperCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            Spinner: spinner/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/radio/esm/radio-core.js



const RadioCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "Radio", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onChange',
                id: `Radio - Check - ${props.id}`,
                elementId: props.id,
                elementType: 'radio',
                interactionType: 'check' } },
            external_react_.createElement(RadioInner, Object.assign({}, props)))));
};
const RadioInner = (props) => {
    const { input, checked, defaultChecked, onChange, value, disabled, id = 'id-0', labelText, children, extraContent, size = 'large', direction, indicatorAlign, hideLabel, employee, employeeBackground = true, className, components: { Skeleton, SkeletonItem }, } = props;
    const [innerChecked, setInnerChecked] = external_react_.useState(defaultChecked || false);
    const isChecked = onChange && typeof checked !== 'undefined' ? checked : innerChecked;
    const handleChange = () => {
        if (props.disabled || isChecked) {
            return;
        }
        if (typeof props.checked === 'undefined') {
            setInnerChecked(true);
        }
        if (onChange) {
            onChange(true);
        }
    };
    const BEM = () => {
        const classArray = ['radio'];
        if (size) {
            classArray.push('radio--' + size);
        }
        if (direction) {
            classArray.push('radio--' + direction);
        }
        if (indicatorAlign) {
            classArray.push('radio--indicator-' + indicatorAlign);
        }
        if (hideLabel) {
            classArray.push('radio--hide-label');
        }
        if (employee) {
            classArray.push('radio--employee');
        }
        if (employee && employeeBackground) {
            classArray.push('radio--employee-background');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getInputClass = () => {
        const classArray = ['radio__input'];
        if (input && input.className) {
            classArray.push(input.className);
        }
        return classArray.join(' ');
    };
    if ('skeleton' in props) {
        const { skeleton } = props;
        const { lineCount = 1, lineHeight, lineWidth } = skeleton;
        return (external_react_.createElement(Skeleton, { className: BEM(), label: skeleton.label },
            external_react_.createElement("div", { className: "radio__inner" },
                external_react_.createElement(SkeletonItem, { className: "radio__indicator" }),
                external_react_.createElement("div", { className: "radio__content" }, [...Array(lineCount).keys()].map((_line, index) => (external_react_.createElement(SkeletonItem, { key: index, height: lineHeight, width: lineWidth })))))));
    }
    return (external_react_.createElement("div", { className: BEM() },
        external_react_.createElement("input", Object.assign({}, input, { type: "radio", checked: isChecked, defaultChecked: undefined, value: value, onChange: handleChange, disabled: disabled, id: id, className: getInputClass(), "aria-invalid": props['aria-invalid'], "aria-describedby": props['aria-describedby'] })),
        external_react_.createElement("label", { htmlFor: id, className: "radio__label" }, labelText),
        external_react_.createElement("div", { className: "radio__inner", onClick: handleChange },
            external_react_.createElement("span", { className: "radio__indicator" }),
            external_react_.createElement("div", { className: "radio__content", "aria-hidden": !children }, children || labelText)),
        extraContent && external_react_.createElement("div", { className: "radio__extra" }, extraContent)));
};
/* harmony default export */ const radio_core = (RadioCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/radio/esm/radio.js



const Radio = (props) => {
    return (external_react_.createElement(radio_core, Object.assign({}, props, { components: {
            Skeleton: skeleton_skeleton/* default */.Z,
            SkeletonItem: skeleton_item_skeleton_item/* default */.Z,
        } })));
};
/* harmony default export */ const esm_radio = (Radio);

;// CONCATENATED MODULE: ./node_modules/@core-front/choice-group/esm/choice-group-core.js


function getInitialValue(type, defaultValue) {
    if (defaultValue) {
        return defaultValue;
    }
    else if (type === 'check') {
        return [];
    }
    else {
        return null;
    }
}
function choice_group_core_BEM(props) {
    const { display, align, hideLabel, purpose, isInvalid, className } = props;
    const classArray = ['choice-group'];
    if (display) {
        classArray.push('choice-group--' + display);
    }
    if (align) {
        classArray.push('choice-group--' + align);
    }
    if (hideLabel) {
        classArray.push(hideLabel === true ? 'choice-group--no-label-no-break' : 'choice-group--no-label-' + hideLabel);
    }
    if (purpose) {
        classArray.push('choice-group--purpose-' + purpose);
    }
    if (isInvalid) {
        classArray.push('is-invalid');
    }
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
}
function labelBEM(props) {
    const { labelClass } = props;
    const classArray = ['choice-group__label'];
    if (labelClass) {
        classArray.push(labelClass);
    }
    return classArray.join(' ');
}
function innerBEM(props) {
    const { innerColorClass } = props;
    const classArray = ['choice-group__inner'];
    if (innerColorClass) {
        classArray.push(innerColorClass);
    }
    else {
        classArray.push('choice-group__inner--default-background');
    }
    return classArray.join(' ');
}
const ChoiceGroupCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "ChoiceGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        external_react_.createElement(ChoiceGroupCoreInner, Object.assign({}, props))));
};
const ChoiceGroupCoreInner = (props) => {
    const { Check, FormHelper, Radio } = props.components;
    const [innerValue, setInnerValue] = external_react_.useState(getInitialValue(props.type, props.defaultValue));
    const currentValue = props.onChange && typeof props.value !== 'undefined' ? props.value : innerValue;
    const isInvalid = props.isInvalid || !!props.helper && props.helper.type === 'error';
    function getNextValue(value, checked) {
        if (props.type === 'check' && Array.isArray(currentValue)) {
            if (checked) {
                return [...currentValue, value];
            }
            else {
                return currentValue.filter((item) => item !== value);
            }
        }
        else {
            return value;
        }
    }
    function onChange(value, checked, onChange) {
        if (typeof props.value === 'undefined') {
            setInnerValue(getNextValue(value, checked));
        }
        if (props.onChange) {
            props.onChange(getNextValue(value, checked));
        }
        if (onChange) {
            onChange(checked);
        }
    }
    function isChecked(value) {
        if (currentValue === null) {
            return false;
        }
        if (props.type === 'check') {
            return value === currentValue || currentValue.indexOf(value) !== -1;
        }
        else {
            return value === currentValue;
        }
    }
    function getChildren() {
        if (props.children) {
            // since Radio and Check can have children, ChoiceGroup must allow children as well.
            return external_react_.Children.toArray(props.children).filter((child) => {
                return external_react_.isValidElement(child) && (child.type === Check || child.type === Radio);
            }).map((child) => {
                const { props: childProps } = child;
                /* istanbul ignore if */
                if ('skeleton' in childProps) {
                    return child;
                }
                return external_react_.cloneElement(child, {
                    'key': childProps.id,
                    'checked': isChecked(childProps.value),
                    'className': ['choice-group__item', childProps.className].join(' '),
                    'onChange': (checked) => onChange(childProps.value, checked, childProps.onChange),
                    'aria-invalid': isInvalid,
                    'aria-describedby': props.helper ? (props.helper.id || `${props.id}-helper`) : undefined,
                });
            });
        }
        if (!props.options) {
            return [];
        }
        return props.options.map((item) => {
            const ariaDescribedBy = props.helper ? (props.helper.id || `${props.id}-helper`) : undefined;
            if (props.type === 'check') {
                /* istanbul ignore if */
                if ('skeleton' in item) {
                    return (external_react_.createElement(Check, Object.assign({}, item, { key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
                }
                return (external_react_.createElement(Check, Object.assign({}, item, { checked: isChecked(item.value), onChange: (checked) => onChange(item.value, checked, item.onChange), key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
            }
            /* istanbul ignore if */
            if ('skeleton' in item) {
                return (external_react_.createElement(Radio, Object.assign({}, item, { key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
            }
            return (external_react_.createElement(Radio, Object.assign({}, item, { checked: isChecked(item.value), onChange: (checked) => onChange(item.value, checked, item.onChange), key: item.id, className: "choice-group__item", "aria-invalid": isInvalid, "aria-describedby": ariaDescribedBy })));
        });
    }
    return (external_react_.createElement("fieldset", { className: choice_group_core_BEM(props), id: props.id },
        external_react_.createElement("legend", { className: labelBEM(props) }, props.label),
        external_react_.createElement("div", { className: innerBEM(props) }, getChildren()),
        props.helper && (external_react_.createElement(FormHelper, Object.assign({}, props.helper, { className: "choice-group__form-helper", id: props.helper.id || `${props.id}-helper` })))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/choice-group/esm/choice-group.js





const ChoiceGroup = (props) => {
    return (external_react_.createElement(ChoiceGroupCore, Object.assign({}, props, { components: {
            Radio: esm_radio,
            FormHelper: FormHelper,
            Check: check,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/choice-group/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/clear-button/esm/clear-button-core.js


const ClearButtonCore = (props) => {
    const labels = useLabels();
    const { className, components: { Icon }, label, onClick, buttonRef, } = props;
    const BEM = () => {
        const classArray = ['clear-btn'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("button", { className: BEM(), onClick: onClick, type: "button", ref: buttonRef },
        external_react_.createElement(Icon, { modifiers: "#close-round", className: "clear-btn__icon" }),
        external_react_.createElement("span", { className: "sr-only" }, label || labels.get('clear'))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/clear-button/esm/clear-button.js



const ClearButton = (props) => {
    return (external_react_.createElement(ClearButtonCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/clear-button/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/close-button/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/node_modules/@core-front/helper/esm/index.js


let node_modules_core_front_helper_esm_scrollAnimationFrame = 0;
const node_modules_core_front_helper_esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const node_modules_core_front_helper_esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !node_modules_core_front_helper_esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const node_modules_core_front_helper_esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && node_modules_core_front_helper_esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const node_modules_core_front_helper_esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const node_modules_core_front_helper_esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const node_modules_core_front_helper_esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(node_modules_core_front_helper_esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = node_modules_core_front_helper_esm_swingTo(p);
        if (p < 1) {
            node_modules_core_front_helper_esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const node_modules_core_front_helper_esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || node_modules_core_front_helper_esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!(0,index_esm/* isFocusable */.EB)(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        node_modules_core_front_helper_esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const node_modules_core_front_helper_esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= node_modules_core_front_helper_esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const node_modules_core_front_helper_esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const node_modules_core_front_helper_esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return node_modules_core_front_helper_esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const node_modules_core_front_helper_esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const node_modules_core_front_helper_esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const node_modules_core_front_helper_esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const node_modules_core_front_helper_esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const node_modules_core_front_helper_esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const node_modules_core_front_helper_esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const node_modules_core_front_helper_esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    node_modules_core_front_helper_esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const node_modules_core_front_helper_esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const node_modules_core_front_helper_esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/esm/collapse-provider/collapse-provider-core.js




const CollapseProviderCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "CollapseProvider", componentProps: props, defaultValueName: "defaultIsVisible", valueName: "isVisible", onChangeNames: "onToggle" },
        external_react_.createElement(CollapseProviderCoreInner, Object.assign({}, props))));
};
/* harmony default export */ const collapse_provider_core = (CollapseProviderCore);
class CollapseProviderCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.handleRest = () => {
            if (this.isVisible && !node_modules_core_front_helper_esm_isOnScreen(this.props.id)) {
                node_modules_core_front_helper_esm_scrollToElement(this.props.id);
            }
        };
        this.toggle = () => {
            this.setVisible(!this.isVisible);
        };
        this.open = () => {
            this.setVisible(true);
        };
        this.close = () => {
            this.setVisible(false);
        };
        this.setTrigger = (trigger) => {
            if (this.props.triggerRef) {
                this.props.triggerRef(trigger);
            }
            this.setState({
                trigger,
            });
        };
        this.state = {
            isVisible: props.defaultIsVisible || false,
            trigger: null,
        };
    }
    get stateType() {
        if (this.props.isVisible !== undefined && !!this.props.onToggle) {
            return 'external';
        }
        return 'internal';
    }
    get isVisible() {
        if (this.stateType === 'external') {
            return !!this.props.isVisible;
        }
        return this.state.isVisible;
    }
    setVisible(isVisible) {
        if (this.stateType === 'internal') {
            this.setState({
                isVisible: isVisible,
            });
        }
        if (this.props.onToggle) {
            this.props.onToggle(isVisible);
        }
    }
    render() {
        const collapseContextValue = {
            id: this.props.id,
            isVisible: this.isVisible,
            onClose: this.close,
            onOpen: this.open,
            onRest: this.handleRest,
            onToggle: this.toggle,
            portal: this.props.portal,
            trigger: this.state.trigger,
            triggerRef: this.setTrigger,
        };
        return (external_react_.createElement(CollapseContext.Provider, { value: collapseContextValue }, this.props.children));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/esm/collapse-provider/collapse-provider.js


const CollapseContext = external_react_.createContext({
    id: 'id-0',
    isVisible: false,
    onClose: () => null,
    onOpen: () => null,
    onRest: () => null,
    onToggle: () => null,
    triggerRef: () => null,
});
const CollapseProvider = (props) => {
    return (external_react_.createElement(collapse_provider_core, Object.assign({}, props)));
};
/* harmony default export */ const collapse_provider = (CollapseProvider);

;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/esm/collapse/collapse-core.js






const CollapseCore = (props) => {
    const { isVisible, id, portal, trigger, onClose, onOpen, onRest, } = external_react_.useContext(CollapseContext);
    const labels = useLabels();
    return (external_react_.createElement(CollapseInner, Object.assign({}, props, { isVisible: isVisible, id: id, portal: portal, trigger: trigger, onClose: onClose, onOpen: onOpen, onRest: onRest, labels: labels })));
};
/* harmony default export */ const collapse_core = (CollapseCore);
class CollapseInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.collapseElement = null;
        this.expandTimeout = 0;
        this.handleTransitionEnd = (event) => {
            if (event.target === this.collapseElement && event.propertyName === 'height') {
                if (this.props.isVisible) {
                    this.setExpanded();
                }
                else {
                    this.setCollapsed();
                }
                this.props.onRest();
            }
        };
        this.handleCloseClick = (event) => {
            event.preventDefault();
            this.props.onClose();
            if (this.props.onCloseClick) {
                this.props.onCloseClick();
            }
        };
        this.handleHashMatch = () => {
            // safeguard to not trigger open multiple times when hash match event fires twice for some reason
            if (!this.props.isVisible) {
                this.props.onOpen();
            }
        };
        this.renderContent = (state) => {
            const { HashTrigger } = this.props.components;
            return (external_react_.createElement(HashTrigger, { id: this.props.id, onMatch: this.handleHashMatch, renderWrapper: false },
                external_react_.createElement("div", { className: this.BEM(state), ref: (el) => this.collapseElement = el, style: this.state.collapseStyle, onTransitionEnd: this.handleTransitionEnd },
                    this.renderArrow(),
                    external_react_.createElement("div", { className: "collapse__inner", id: this.props.id },
                        this.renderCloseButton(),
                        this.props.children))));
        };
        const closedCollapseStyle = {
            height: '0px',
            overflow: 'hidden',
            visibility: 'hidden',
        };
        const fadedCollapseStyle = {
            height: `${props.initialVisibleHeight}px`,
            overflow: 'hidden',
            visibility: 'visible',
        };
        this.state = {
            arrowStyle: {},
            collapseStyle: props.initialVisibleHeight ? fadedCollapseStyle : closedCollapseStyle,
            isAnimating: false,
            isMounted: false,
        };
        this.debouncedResizeHandler = (0,debounce.debounce)(this.setArrowPosition.bind(this), 100);
    }
    componentDidMount() {
        this.setState({
            isMounted: true,
        }, () => {
            if (this.collapseElement && this.props.isVisible) {
                this.setExpanded();
                this.setArrowPosition();
            }
        });
        window.addEventListener('resize', this.debouncedResizeHandler);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.collapseStyle !== prevState.collapseStyle) {
            this.setArrowPosition();
        }
        if (this.props.isVisible && !prevProps.isVisible) {
            this.expand();
        }
        else if (!this.props.isVisible && prevProps.isVisible) {
            this.collapse();
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedResizeHandler);
        this.debouncedResizeHandler.clear();
        if (this.expandTimeout) {
            window.clearTimeout(this.expandTimeout);
        }
    }
    expand() {
        this.setState({
            isAnimating: true,
        });
        window.clearTimeout(this.expandTimeout);
        this.expandTimeout = window.setTimeout(() => {
            if (!this.collapseElement) {
                return;
            }
            // have the element transition to the height of its inner content
            this.setContentStyleProperty('height', `${this.collapseElement.scrollHeight}px`);
            this.setContentStyleProperty('visibility', 'visible');
        }, 0);
    }
    collapse() {
        if (!this.collapseElement) {
            return;
        }
        this.setState({
            isAnimating: true,
        });
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        this.setContentStyleProperty('height', `${this.collapseElement.scrollHeight}px`);
        requestAnimationFrame(() => {
            // "pausing" the JavaScript execution to let the rendering threads catch up
            // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
            setTimeout(() => {
                this.setContentStyleProperty('height', this.props.initialVisibleHeight ? `${this.props.initialVisibleHeight}px` : '0px');
                this.setContentStyleProperty('overflow', 'hidden');
            }, 0);
        });
    }
    BEM(state) {
        const classArray = ['collapse', 'is-' + state];
        if (this.props.color) {
            classArray.push('collapse--' + this.props.color);
        }
        if (this.props.noShadow) {
            classArray.push('collapse--no-shadow');
        }
        if (this.props.noArrow) {
            classArray.push('collapse--no-arrow');
        }
        if (this.props.noContainer) {
            classArray.push('collapse--no-container');
        }
        if (this.props.noClose) {
            classArray.push('collapse--no-close');
        }
        if (this.props.initialVisibleHeight) {
            classArray.push('collapse--fade');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    setContentStyleProperty(property, value) {
        this.setState((prevState) => {
            return {
                collapseStyle: Object.assign(Object.assign({}, prevState.collapseStyle), { [property]: value }),
            };
        });
    }
    setCollapsed() {
        this.setContentStyleProperty('visibility', this.props.initialVisibleHeight ? 'visible' : 'hidden');
        this.setState({
            isAnimating: false,
        });
    }
    setExpanded() {
        window.clearTimeout(this.expandTimeout);
        this.setContentStyleProperty('height', 'auto');
        this.setContentStyleProperty('overflow', 'visible');
        this.setContentStyleProperty('visibility', 'visible');
        this.setArrowPosition();
        this.setState({
            isAnimating: false,
        });
    }
    setArrowPosition() {
        if (this.props.isVisible && this.props.trigger && this.collapseElement) {
            const buttonRect = this.props.trigger.getBoundingClientRect();
            const collapseRect = this.collapseElement.getBoundingClientRect();
            const arrowPosition = buttonRect.left - collapseRect.left + (buttonRect.width / 2) - 8;
            this.setState({
                arrowStyle: {
                    left: arrowPosition + 'px',
                },
            });
        }
    }
    hasArrow() {
        return !this.props.noArrow && !this.props.noContainer;
    }
    renderArrow() {
        if (this.hasArrow()) {
            return external_react_.createElement("div", { className: "collapse__arrow", style: this.state.arrowStyle });
        }
        return null;
    }
    renderCloseButton() {
        const { closeButtonLabel, components: { Icon }, labels, noClose, noContainer, isVisible, } = this.props;
        if (noClose || noContainer || !isVisible) {
            return null;
        }
        return (external_react_.createElement("button", { type: "button", className: "collapse__close", onClick: this.handleCloseClick },
            external_react_.createElement(Icon, { modifiers: "#close-round", className: "collapse__close-icon" }),
            external_react_.createElement("span", { className: "sr-only" }, closeButtonLabel || labels.get('close'))));
    }
    renderCollapse() {
        const { VisibilityProvider } = this.props.components;
        return (external_react_.createElement(VisibilityProvider, { isVisible: (this.props.isVisible && !this.state.isAnimating) || false },
            external_react_.createElement(esm_Transition/* default */.ZP, { in: this.props.isVisible, timeout: { enter: 300, exit: 300 } }, this.renderContent)));
    }
    render() {
        if (this.state.isMounted && this.props.portal) {
            return external_react_dom_.createPortal(this.renderCollapse(), this.props.portal);
        }
        return this.renderCollapse();
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/esm/collapse/collapse.js





const Collapse = (props) => {
    return (external_react_.createElement(collapse_core, Object.assign({}, props, { components: {
            HashTrigger: HashTrigger,
            Icon: icon/* default */.Z,
            VisibilityProvider: VisibilityProvider,
        } })));
};
/* harmony default export */ const collapse = (Collapse);

;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/esm/collapse-trigger/collapse-trigger.js


class CollapseTrigger extends external_react_.Component {
    constructor() {
        super(...arguments);
        this.enhanceItem = (child) => {
            if (external_react_.isValidElement(child)) {
                return external_react_.cloneElement(child, {
                    buttonRef: this.context.triggerRef,
                    elementRef: this.context.triggerRef,
                    isActive: this.context.isVisible,
                    onClick: (event) => {
                        event.preventDefault();
                        if (this.context.onToggle) {
                            this.context.onToggle();
                        }
                    },
                    url: '#' + this.context.id,
                });
            }
        };
    }
    render() {
        const children = external_react_.Children.map(this.props.children, this.enhanceItem);
        const child = children && children.length ? children[0] : null;
        return child ? external_react_.Children.only(child) : null;
    }
}
CollapseTrigger.contextType = CollapseContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/collapse/esm/index.js






;// CONCATENATED MODULE: ./node_modules/@core-front/collapse-toggle/esm/collapse-toggle-core.js
var collapse_toggle_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const CollapseToggleCore = (props) => {
    const { components: { Button, }, rotateDegree = 180, rotateDirection = 'clockwise', activeText, text, isActive, className } = props, rest = collapse_toggle_core_rest(props, ["components", "rotateDegree", "rotateDirection", "activeText", "text", "isActive", "className"]);
    const BEM = () => {
        const classArray = [
            'collapse-toggle',
            `collapse-toggle--rotate-degree-${rotateDegree}`,
            `collapse-toggle--rotate-direction-${rotateDirection}`,
        ];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(Button, Object.assign({}, rest, { isActive: isActive, className: BEM(), text: isActive && activeText || text, iconClass: "collapse-toggle__icon" })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/collapse-toggle/esm/collapse-toggle.js



const CollapseToggle = (props) => {
    return (external_react_.createElement(CollapseToggleCore, Object.assign({}, props, { components: {
            Button: button_Button,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/collapse-toggle/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/container/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/cookie-consent-provider/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/cookie-notice/esm/cookie-notice-core.js

class CookieNoticeCore extends external_react_.PureComponent {
    BEM() {
        const classArray = ['cookie-notice'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const { Button, Icon } = this.props.components;
        return (external_react_.createElement("div", { className: this.BEM() },
            external_react_.createElement("div", { className: "cookie-notice__main" },
                external_react_.createElement(Icon, { modifiers: "#info-round", className: "cookie-notice__icon" }),
                external_react_.createElement("div", { className: "cookie-notice__content" }, this.props.content)),
            external_react_.createElement(Button, { text: this.props.buttonText, className: "cookie-notice__button", onClick: this.props.onButtonClick, size: "small", variant: "secondary" })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/cookie-notice/esm/cookie-notice.js




class CookieNotice extends external_react_.PureComponent {
    render() {
        return (external_react_.createElement(CookieNoticeCore, Object.assign({}, this.props, { components: {
                Button: button_Button,
                Icon: icon/* default */.Z,
            } })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/cookie-notice/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/scroll-fade/esm/scroll-fade-core.js


class ScrollFadeCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.element = null;
        this.handleFadeBeginning = () => {
            const { scrollLeft } = this.getElementSizes();
            if (this.element) {
                if (scrollLeft === 0 && this.state.fadeBeginning) {
                    this.setState({
                        fadeBeginning: false,
                    });
                    if (this.props.onScrollToLeft) {
                        this.props.onScrollToLeft();
                    }
                }
                else if (scrollLeft !== 0 && !this.state.fadeBeginning) {
                    this.setState({
                        fadeBeginning: true,
                    });
                }
            }
        };
        this.handleFadeTop = () => {
            const { scrollTop } = this.getElementSizes();
            if (this.element) {
                if (scrollTop > 0 && !this.state.fadeTop) {
                    this.setState({
                        fadeTop: true,
                    });
                }
                else if (scrollTop === 0 && this.state.fadeTop) {
                    this.setState({
                        fadeTop: false,
                    });
                    if (this.props.onScrollToTop) {
                        this.props.onScrollToTop();
                    }
                }
            }
        };
        this.handleFadeBottom = () => {
            const { scrollHeight, scrollTop, clientHeight } = this.getElementSizes();
            if (this.element) {
                if ((scrollHeight - scrollTop === clientHeight) && this.state.fadeBottom) {
                    this.setState({
                        fadeBottom: false,
                    });
                    if (this.props.onScrollToBottom) {
                        this.props.onScrollToBottom();
                    }
                }
                else if (clientHeight && (scrollHeight - scrollTop !== clientHeight) && !this.state.fadeBottom) {
                    this.setState({
                        fadeBottom: true,
                    });
                }
            }
        };
        this.getElementSizes = () => {
            if (this.element) {
                // values are rounded because ScrollHeight is occasionally decimal places greater than scrollTop (sms-chat example)
                return {
                    scrollHeight: Math.round(this.element.scrollHeight),
                    scrollWidth: Math.round(this.element.scrollWidth),
                    scrollLeft: Math.round(this.element.scrollLeft),
                    scrollTop: Math.round(this.element.scrollTop),
                    clientHeight: this.element.clientHeight,
                    clientWidth: this.element.clientWidth,
                };
            }
            return {
                scrollHeight: 0,
                scrollWidth: 0,
                scrollLeft: 0,
                scrollTop: 0,
                clientHeight: 0,
                clientWidth: 0,
            };
        };
        this.setElementRef = (el) => {
            this.element = el;
            if (this.props.elementRef) {
                this.props.elementRef(el);
            }
        };
        this.onScroll = this.onScroll.bind(this);
        this.debouncedResizeHandler = (0,debounce.debounce)(this.onScroll, 50);
        this.state = {
            fadeBeginning: false,
            fadeBottom: false,
            fadeEnd: false,
            fadeTop: false,
        };
    }
    componentDidMount() {
        // Check if is scrolled after mount.
        this.onScroll();
        window.addEventListener('resize', this.debouncedResizeHandler);
    }
    componentDidUpdate() {
        // check scrolls after update - if children update, for example
        this.onScroll();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedResizeHandler);
        this.debouncedResizeHandler.clear();
    }
    BEM() {
        const classArray = ['scroll-fade'];
        if (this.state.fadeBeginning) {
            classArray.push('has-scrolled-to-right');
        }
        if (this.state.fadeBottom) {
            classArray.push('has-scrolled-to-top');
        }
        if (this.state.fadeEnd) {
            classArray.push('has-scrolled-to-left');
        }
        if (this.state.fadeTop) {
            classArray.push('has-scrolled-to-bottom');
        }
        if (this.props.variant) {
            classArray.push('scroll-fade--' + this.props.variant);
        }
        if (this.props.hasArrows) {
            classArray.push('scroll-fade--has-arrows');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    buttonBEM(direction) {
        const { fadeBeginning, fadeEnd, fadeTop, fadeBottom } = this.state;
        const classArray = ['scroll-fade__button'];
        let shouldAnimate;
        switch (direction) {
            case 'right':
                shouldAnimate = !(fadeBeginning || fadeTop || fadeBottom);
                break;
            case 'left':
                shouldAnimate = !(fadeTop || fadeEnd || fadeBottom);
                break;
            default:
                shouldAnimate = false;
        }
        if (shouldAnimate) {
            classArray.push('scroll-fade__button--animate');
        }
        classArray.push('scroll-fade__button-' + direction);
        return classArray.join(' ');
    }
    onArrowClick(direction, event) {
        if (this.props.onArrowClick) {
            this.props.onArrowClick(event, direction);
        }
    }
    getArrowButton(direction) {
        const { Icon } = this.props.components;
        return (external_react_.createElement("button", { className: this.buttonBEM(direction), onClick: this.onArrowClick.bind(this, direction) },
            external_react_.createElement(Icon, { modifiers: `#arrow-${direction}`, size: "xs" })));
    }
    onScroll() {
        this.handleFadeBeginning();
        this.handleFadeEnd();
        this.handleFadeTop();
        this.handleFadeBottom();
    }
    handleFadeEnd() {
        const { scrollWidth, scrollLeft, clientWidth } = this.getElementSizes();
        if (this.element) {
            const scrolledWidth = scrollWidth - scrollLeft;
            if (scrolledWidth === clientWidth && this.state.fadeEnd) {
                this.setState({
                    fadeEnd: false,
                });
                if (this.props.onScrollToRight) {
                    this.props.onScrollToRight();
                }
            }
            else if (clientWidth && scrolledWidth !== clientWidth && !this.state.fadeEnd) {
                this.setState({
                    fadeEnd: true,
                });
            }
        }
    }
    render() {
        const { fadeBeginning, fadeEnd, fadeTop, fadeBottom } = this.state;
        const { hasArrows } = this.props;
        return (external_react_.createElement("div", { className: this.BEM() },
            (fadeBeginning && hasArrows) && this.getArrowButton('left'),
            (fadeTop && hasArrows) && this.getArrowButton('up'),
            external_react_.createElement("div", { className: "scroll-fade__inner", ref: this.setElementRef, onScroll: this.onScroll },
                external_react_.createElement("div", { className: "scroll-fade__content", ref: this.props.contentRef }, this.props.children)),
            (fadeBottom && hasArrows) && this.getArrowButton('down'),
            (fadeEnd && hasArrows) && this.getArrowButton('right')));
    }
}
ScrollFadeCore.defaultProps = {
    variant: 'white',
};


;// CONCATENATED MODULE: ./node_modules/@core-front/scroll-fade/esm/scroll-fade.js



const ScrollFade = (props) => {
    return (external_react_.createElement(ScrollFadeCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/datepicker-column/datepicker-column-core.js

class DatepickerColumn extends external_react_.PureComponent {
    constructor(props) {
        super(props);
        this.scrollable = external_react_.createRef();
        this.scrollablePaddingTop = 0;
        this.scrollablePaddingBottom = 0;
        this.element = null;
        this.scrollColumnToSelectedOrCurrent = () => {
            const optionToCenter = this.scrollable.current && (this.scrollable.current.querySelector('.is-selected:not(.disabled)') ||
                this.scrollable.current.querySelector('.is-current:not(.disabled)') ||
                this.scrollable.current.querySelector('.datepicker__option:not(.disabled)'));
            /* istanbul ignore else */
            if (this.scrollable.current && this.scrollable.current.parentElement && optionToCenter) {
                const { top, height } = this.scrollable.current.parentElement.getBoundingClientRect();
                this.scrollable.current.parentElement.scrollTop = optionToCenter.getBoundingClientRect().top - top - (height / 2) + this.scrollablePaddingTop;
            }
        };
        this.state = {
            width: 0,
        };
    }
    componentDidMount() {
        /* istanbul ignore else */
        if (this.scrollable.current) {
            const { paddingTop, paddingBottom } = window.getComputedStyle(this.scrollable.current);
            this.scrollablePaddingTop = parseFloat(paddingTop);
            this.scrollablePaddingBottom = parseFloat(paddingBottom);
        }
        this.scrollColumnToSelectedOrCurrent();
        this.setColumnWidth();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isCollapsed && !this.props.isCollapsed) {
            requestAnimationFrame(this.scrollColumnToSelectedOrCurrent);
        }
        else if (!prevProps.isCollapsed && this.props.isCollapsed && this.scrollable.current) {
            this.scrollable.current.scrollTop = 0;
        }
    }
    BEM() {
        const classNames = ['datepicker__column', 'datepicker__column--' + this.props.type];
        if (!this.props.isCollapsed) {
            classNames.push('is-open');
        }
        return classNames.join(' ');
    }
    getColumnWidth() {
        return this.state.width <= 100 ? 100 : this.state.width + 8;
    }
    setColumnWidth() {
        this.setState({
            width: this.element ? this.element.clientWidth : 0,
        });
    }
    render() {
        const { Icon, ScrollFade } = this.props.components;
        return (external_react_.createElement("div", { className: this.BEM(), style: { minWidth: this.getColumnWidth() }, ref: (el) => this.element = el },
            external_react_.createElement("div", { key: "toggle-value", className: "datepicker__value", onClick: this.props.onToggleCollapsed }, this.props.collapsedLabel),
            external_react_.createElement("div", { key: "toggle-icons", className: "datepicker__toggle", onClick: this.props.onToggleCollapsed },
                external_react_.createElement(Icon, { modifiers: "#arrow-down", className: "datepicker__toggle-icon datepicker__toggle-icon--expand" }),
                external_react_.createElement(Icon, { modifiers: "#close", className: "datepicker__toggle-icon datepicker__toggle-icon--close" })),
            external_react_.createElement("div", { className: "datepicker__options" },
                external_react_.createElement("div", { className: "datepicker__options-inner" },
                    external_react_.createElement(ScrollFade, { contentRef: this.scrollable }, this.props.children)))));
    }
}
DatepickerColumn.defaultProps = {
    isCollapsed: true,
};

;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/datepicker-column/datepicker-column.js




const datepicker_column_DatepickerColumn = (props) => {
    return (external_react_.createElement(DatepickerColumn, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            ScrollFade: ScrollFade,
        } })));
};


// EXTERNAL MODULE: ./node_modules/date-fns/esm/set/index.js
var esm_set = __webpack_require__(2311);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js
var getDaysInMonth = __webpack_require__(890);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js
var sub = __webpack_require__(734);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getISODay/index.js
var getISODay = __webpack_require__(4500);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(3703);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(9160);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMinute/index.js
var isSameMinute = __webpack_require__(9952);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameWeek/index.js
var isSameWeek = __webpack_require__(3725);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameYear/index.js
var isSameYear = __webpack_require__(792);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setISOWeek/index.js
var setISOWeek = __webpack_require__(4515);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(9422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js
var startOfISOWeek = __webpack_require__(6573);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfYear/index.js
var startOfYear = __webpack_require__(8148);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setISODay/index.js
var setISODay = __webpack_require__(927);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(2699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(5570);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isLeapYear/index.js
var isLeapYear = __webpack_require__(6491);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(2300);
;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 2 modules
var esm_format = __webpack_require__(5639);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isEqual/index.js
var esm_isEqual = __webpack_require__(6843);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(2274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(1593);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(1699);
;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/datepicker-helpers.js


const useFormat = (defaultLocale) => {
    const { locale } = (0,use_theme/* useTheme */.F)();
    function format(date, formatStr = 'PP') {
        return (0,esm_format/* default */.Z)(date, formatStr, {
            locale: defaultLocale || locale,
        });
    }
    return { format };
};
function isSame(x, y, precision) {
    switch (precision) {
        case 'year':
            return (0,isSameYear/* default */.Z)(x, y);
        case 'month':
            return (0,isSameMonth/* default */.Z)(x, y);
        case 'week':
            return (0,isSameWeek/* default */.Z)(x, y);
        case 'day':
            return (0,isSameDay/* default */.Z)(x, y);
        case 'minute':
            return (0,isSameMinute/* default */.Z)(x, y);
        default:
            return (0,esm_isEqual/* default */.Z)(x, y);
    }
}
function getValueFromInputValue(inputValue, isTimeIncluded) {
    let value;
    if (isDateRange(inputValue)) {
        value = {
            from: getDate(inputValue.from, isTimeIncluded),
        };
        if (inputValue.to) {
            value.to = getDate(inputValue.to, isTimeIncluded);
        }
    }
    else {
        value = getDate(inputValue, isTimeIncluded);
    }
    return value;
}
function getDate(date, isTimeIncluded = true) {
    let newDate = date ? date : new Date();
    if (typeof newDate === 'string') {
        newDate = (0,parseISO/* default */.Z)(newDate);
    }
    if (!(0,isValid/* default */.Z)(newDate)) {
        throw new Error(`Invalid input date. Expecting a native javascript date object, but got: ${{}.toString.call(date)}.`);
    }
    newDate = (0,esm_set/* default */.Z)(newDate, { seconds: 0, milliseconds: 0 });
    if (!isTimeIncluded) {
        newDate = (0,esm_set/* default */.Z)(newDate, { hours: 0, minutes: 0 });
    }
    return newDate;
}
function getRangesFromTimes(times, isTimeIncluded) {
    return times.map((time) => {
        const from = getDate(time.from, isTimeIncluded);
        const to = time.to && getDate(time.to, isTimeIncluded);
        throwIfInvalidRange(from, to, false);
        return to && !(0,esm_isEqual/* default */.Z)(from, to)
            ? { from, to }
            : { from };
    });
}
function getSelectedTimeIndex(times, value) {
    if (times && value && isDateRange(value)) {
        const index = times.findIndex((time) => isEqualRange(time, value));
        return index > -1 ? index : undefined;
    }
}
/**
 * Returns a Date range (an object in the shape: { from: <Date instance>, to <Date instance> })
 * based on given `range` and `times` prop or falls back on defaults.
 */
function getRange(props, times, currentDate, isTimeIncluded) {
    let from;
    let to;
    /**
     * Get the earliest `from` and latest `to` from the `range` and/or `times` props.
     * If both `range` and `times` props are provided then
     * an intersection of both is formed so that `from` will be either `range.from` or
     * the earliest `from` in `times` whichever is later and `to` will be either
     * `range.to` or the latest `to` in `times` whichever is earlier.
     */
    if (props.range) {
        from = getDate(props.range.from, isTimeIncluded);
        to = getDate(props.range.to, isTimeIncluded);
    }
    if (times) {
        const earliestTimeFrom = times.reduce((earliest, time) => earliest && (0,isBefore/* default */.Z)(earliest, time.from) ? earliest : time.from, undefined);
        let latestTimeTo = times.reduce((latest, time) => latest && (0,isAfter/* default */.Z)(latest, time.to || time.from) ? latest : (time.to || time.from), undefined);
        // In case `latestTimeTo` is undefined (since `to` is optional on a time ranges) assign the latest `from` value instead.
        if (!latestTimeTo) {
            latestTimeTo = times.reduce((latest, time) => latest && (0,isAfter/* default */.Z)(latest, time.from) ? latest : time.from, undefined);
        }
        if (!from || (earliestTimeFrom && (0,isAfter/* default */.Z)(earliestTimeFrom, from))) {
            from = earliestTimeFrom;
        }
        if (!to || (latestTimeTo && (0,isBefore/* default */.Z)(latestTimeTo, to))) {
            to = latestTimeTo;
        }
    }
    /**
     * Default overall range in case neither props.range nor props.times was provided.
     */
    if (!from) {
        from = currentDate;
    }
    if (!to) {
        to = (0,addYears/* default */.Z)(currentDate, 6); // +6 years because 7 items fill the options column without a scrollbar
    }
    from = (0,esm_set/* default */.Z)(from, { seconds: 0, milliseconds: 0 });
    to = (0,esm_set/* default */.Z)(to, { seconds: 0, milliseconds: 0 });
    if (!isTimeIncluded) {
        from = (0,esm_set/* default */.Z)(from, { hours: 0, minutes: 0 });
        to = (0,esm_set/* default */.Z)(to, { hours: 0, minutes: 0 });
    }
    throwIfInvalidRange(from, to);
    return { from, to };
}
/**
 * Throw if any provided range prop has an invalid `from` or `to` property.
 */
function throwIfInvalidRange(from, to, mustHaveLength = true) {
    if (!(0,isValid/* default */.Z)(from)) {
        throw new Error(`Invalid date/time range "from" value: "${from}". Expected a javascript Date object.`);
    }
    if (to && !(0,isValid/* default */.Z)(to)) {
        throw new Error(`Invalid date/time range "to" value: "${to}". Expected a javascript Date object.`);
    }
    if (mustHaveLength && (0,isValid/* default */.Z)(from) && (0,isValid/* default */.Z)(to) && to && (0,isAfter/* default */.Z)(from, to)) {
        throw new Error(`Invalid date range values. "From": "${from}" must be before "to": "${to}".`);
    }
}
/**
 * Accepts a Date instance and returns a clone of the same instance if it falls in `props.range`
 * (and `props.times` if provided) otherwise returns the closest Date instance
 * that is in range.
 */
function getClosestDateInRange(date, range, times, inFuture = false) {
    if (times) {
        let closestDate;
        let latestDate;
        let lastDiff = Infinity;
        /**
         * We need to check if date is in provided props.times and if not then return the closest provided time.
         */
        for (const { from, to } of times) {
            const fromDiff = Math.abs((0,differenceInSeconds/* default */.Z)(date, from));
            const toDiff = to && Math.abs((0,differenceInSeconds/* default */.Z)(date, to));
            if (fromDiff === 0 || (fromDiff > 0 && toDiff && toDiff <= 0)) {
                return date;
            }
            const diff = Math.abs(fromDiff < 0 ? fromDiff : to && toDiff || fromDiff);
            if (diff < lastDiff && (!inFuture || isSame(from, date) || (0,isAfter/* default */.Z)(from, date))) {
                closestDate = from;
                lastDiff = diff;
            }
            if (!latestDate || (0,isAfter/* default */.Z)(from, latestDate)) {
                latestDate = from;
            }
        }
        if (closestDate) {
            return closestDate;
        }
        else if (latestDate) {
            return latestDate;
        }
    }
    else {
        if ((0,isBefore/* default */.Z)(date, range.from)) {
            return range.from;
        }
        if (range.to && (0,isAfter/* default */.Z)(date, range.to)) {
            return range.to;
        }
    }
    return date;
}
function getDefaultViewDate(value, range, times, currentDate) {
    const date = value
        ? (isDateRange(value) ? value.from : value)
        : currentDate;
    return getClosestDateInRange(date, range, times, true);
}
function isDateRange(obj) {
    if (obj === null || obj instanceof Date) {
        return false;
    }
    const keys = Object.keys(obj);
    const keysMatch = (keys.length === 1 && keys.includes('from') ||
        keys.length === 2 && keys.includes('from') && keys.includes('to'));
    return keysMatch && Object.values(obj).every((value) => value instanceof Date);
}
function isDateInDateRange(date, dateRange, precision) {
    if (dateRange.to) {
        return (isSame(date, dateRange.from, precision) || (0,isAfter/* default */.Z)(date, dateRange.from))
            && (isSame(date, dateRange.to, precision) || (0,isBefore/* default */.Z)(date, dateRange.to));
    }
    return isSame(date, dateRange.from, precision);
}
function isEqualRange(a, b) {
    return (0,esm_isEqual/* default */.Z)(a.from, b.from) && (!a.to && !b.to ||
        !!a.to && !!b.to && (0,esm_isEqual/* default */.Z)(a.to, b.to));
}
function isEqualValue(a, b, isTimeIncluded = true) {
    if (!a || !b) {
        return !a && !b;
    }
    const aDateValue = getValueFromInputValue(a, isTimeIncluded);
    const bDateValue = getValueFromInputValue(b, isTimeIncluded);
    if (isDateRange(aDateValue) && !(isDateRange(bDateValue)) ||
        isDateRange(bDateValue) && !(isDateRange(aDateValue))) {
        return false;
    }
    if (isDateRange(aDateValue) && isDateRange(bDateValue)) {
        return isEqualRange(aDateValue, bDateValue);
    }
    else {
        return isSame(aDateValue, bDateValue);
    }
}


;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/datepicker-core.js





const DatepickerCore = (props) => {
    const { format } = useFormat(props.locale);
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "Datepicker", defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        external_react_.createElement(DatepickerInnerCore, Object.assign({}, props, { formatFn: format }))));
};
class DatepickerInnerCore extends external_react_.PureComponent {
    static getInitialState(props) {
        const value = props.defaultValue ? getValueFromInputValue(props.defaultValue, DatepickerInnerCore.isTimeIncludedFromProps(props)) : null;
        const isCollapsed = {
            calendar: true,
            day: true,
            month: true,
            time: true,
            week: true,
            year: true,
        };
        return {
            isCollapsed,
            value,
        };
    }
    get viewState() {
        return this.cachedViewState(this.propsWithDefaults, this.state, this.componentCreationDate);
    }
    static getViewStateFromPropsAndState(props, state, componentCreationDate) {
        let viewDate = getDefaultViewDate(DatepickerInnerCore.getValueFromPropsAndState(props, state), DatepickerInnerCore.getRangesFromProps(props, componentCreationDate), DatepickerInnerCore.getTimesFromProps(props), componentCreationDate);
        viewDate = (0,esm_set/* default */.Z)(viewDate, { seconds: 0, milliseconds: 0 });
        if (!DatepickerInnerCore.isTimeIncludedFromProps(props)) {
            viewDate = (0,esm_set/* default */.Z)(viewDate, { hours: 0, minutes: 0 });
        }
        return DatepickerInnerCore.getViewState(viewDate);
    }
    get currentDate() {
        return this.cachedCurrentDate(this.propsWithDefaults, this.componentCreationDate);
    }
    static getCurrentDateFromProps(props, componentCreationDate) {
        const currentDate = componentCreationDate;
        if (!DatepickerInnerCore.isTimeIncludedFromProps(props)) {
            (0,esm_set/* default */.Z)(currentDate, { hours: 0, minutes: 0 });
        }
        (0,esm_set/* default */.Z)(currentDate, { seconds: 0, milliseconds: 0 });
        return currentDate;
    }
    get isShown() {
        return this.cachedIsShown(this.propsWithDefaults, this.componentCreationDate);
    }
    static getIsShownFromProps(props, componentCreationDate) {
        return DatepickerInnerCore.getColumnsVisibilityState(props, DatepickerInnerCore.getRangesFromProps(props, componentCreationDate));
    }
    get range() {
        return this.cachedRange(this.propsWithDefaults, this.componentCreationDate);
    }
    static getRangesFromProps(props, componentCreationDate) {
        return getRange(props, DatepickerInnerCore.getTimesFromProps(props), componentCreationDate, DatepickerInnerCore.isTimeIncludedFromProps(props));
    }
    get value() {
        return this.cachedValue(this.propsWithDefaults, this.state);
    }
    static getValueFromPropsAndState(props, state) {
        if (DatepickerInnerCore.getStateTypeFromProps(props) === 'internal') {
            return state.value;
        }
        else {
            return DatepickerInnerCore.getValueFromProps(props);
        }
    }
    static getValueFromProps(props) {
        return props.value ? getValueFromInputValue(props.value, DatepickerInnerCore.isTimeIncludedFromProps(props)) : null;
    }
    static getStateTypeFromProps(props) {
        if (props.value !== undefined && props.onChange !== undefined) {
            return 'external';
        }
        return 'internal';
    }
    get stateType() {
        return DatepickerInnerCore.getStateTypeFromProps(this.propsWithDefaults);
    }
    get selectedTimeIndex() {
        return this.cachedSelectedTimeIndex(this.propsWithDefaults, this.state);
    }
    static getSelectedTimeIndexFromPropsAndState(props, state) {
        return getSelectedTimeIndex(DatepickerInnerCore.getTimesFromProps(props), DatepickerInnerCore.getValueFromPropsAndState(props, state));
    }
    get times() {
        return this.cachedTimes(this.propsWithDefaults);
    }
    static getTimesFromProps(props) {
        return props.times && getRangesFromTimes(props.times, DatepickerInnerCore.isTimeIncludedFromProps(props));
    }
    static isTimeIncludedFromProps(props) {
        return props.columns.includes('time');
    }
    get propsWithDefaults() {
        return this.props;
    }
    static getViewState(viewDate) {
        return {
            numDaysInPrecedingMonth: (0,getDaysInMonth/* default */.Z)((0,sub/* default */.Z)(viewDate, { months: 1 })),
            numDaysInViewMonth: (0,getDaysInMonth/* default */.Z)(viewDate),
            numDaysOfPrecedingMonthVisibleInCalendar: (0,getISODay/* default */.Z)((0,startOfMonth/* default */.Z)(viewDate)) - 1,
            viewDate,
        };
    }
    static getColumnsVisibilityState(props, dateRange) {
        const isSingleDay = !!dateRange.to && (0,isSameDay/* default */.Z)(dateRange.from, dateRange.to);
        const isShownCalendar = props.columns.indexOf('calendar') > -1 && !!dateRange.to && !(0,isSameDay/* default */.Z)(dateRange.from, dateRange.to);
        const isShownMonth = props.columns.indexOf('month') > -1 && !!dateRange.to && !(0,isSameMonth/* default */.Z)(dateRange.from, dateRange.to);
        const isShownTime = props.columns.indexOf('time') > -1 && !!dateRange.to && !(0,isSameMinute/* default */.Z)(dateRange.from, dateRange.to) && !!props.times && !!props.times.length;
        const isShownWeek = props.columns.indexOf('week') > -1 && !!dateRange.to && !(0,isSameWeek/* default */.Z)(dateRange.from, dateRange.to);
        const isShownYear = props.columns.indexOf('year') > -1 && !!dateRange.to && !(0,isSameYear/* default */.Z)(dateRange.from, dateRange.to);
        const isShownDay = props.columns.indexOf('day') > -1 && (!!dateRange.to && !(0,isSameDay/* default */.Z)(dateRange.from, dateRange.to) || isShownTime); // Show Day column when Time column is shown, and day column only has 1 day
        if (isSingleDay) {
            if (props.columns === DatepickerInnerCore.defaultProps.columns) {
                // Return only calendar if props.columns is default columns.
                return {
                    calendar: true,
                    day: false,
                    month: false,
                    time: false,
                    week: false,
                    year: false,
                };
            }
            return {
                calendar: props.columns.indexOf('calendar') > -1,
                day: props.columns.indexOf('day') > -1,
                month: props.columns.indexOf('month') > -1 && !isShownTime,
                time: props.columns.indexOf('time') > -1,
                week: props.columns.indexOf('week') > -1,
                year: props.columns.indexOf('year') > -1,
            };
        }
        else {
            return {
                calendar: isShownCalendar,
                day: isShownDay,
                month: isShownMonth,
                time: isShownTime,
                week: isShownWeek,
                year: isShownYear,
            };
        }
    }
    constructor(props) {
        super(props);
        this.cachedViewState = memoizeOne(DatepickerInnerCore.getViewStateFromPropsAndState);
        this.cachedCurrentDate = memoizeOne(DatepickerInnerCore.getCurrentDateFromProps);
        this.cachedIsShown = memoizeOne(DatepickerInnerCore.getIsShownFromProps);
        this.cachedRange = memoizeOne(DatepickerInnerCore.getRangesFromProps);
        this.cachedValue = memoizeOne(DatepickerInnerCore.getValueFromPropsAndState);
        this.cachedSelectedTimeIndex = memoizeOne(DatepickerInnerCore.getSelectedTimeIndexFromPropsAndState);
        this.cachedTimes = memoizeOne(DatepickerInnerCore.getTimesFromProps);
        this.monthIndexes = Array.from(Array(12).keys());
        this.weekIndexes = Array.from(Array(52).keys());
        this.weekDayIndexes = Array.from(Array(7).keys());
        this.calendarCellIndexes = Array.from(Array(6 * 7).keys());
        this.componentCreationDate = new Date();
        this.onClear = () => {
            if (this.stateType === 'internal') {
                this.setState({ value: null });
            }
            if (this.props.onClear) {
                this.props.onClear();
            }
        };
        this.onSubmit = () => {
            if (this.props.onSubmit) {
                this.props.onSubmit(this.toOutputValue(this.value));
            }
        };
        this.toggleYearPicker = () => this.toggleCollapsed('year');
        this.toggleMonthPicker = () => this.toggleCollapsed('month');
        this.toggleWeekPicker = () => this.toggleCollapsed('week');
        this.toggleDayPicker = () => this.toggleCollapsed('day');
        this.toggleTimePicker = () => this.toggleCollapsed('time');
        this.renderYear = (year) => {
            const { DatepickerOption } = this.props.components;
            const yearDate = (0,esm_set/* default */.Z)(this.viewState.viewDate, { year });
            const onClick = () => {
                this.onSelect(yearDate);
                if (!this.state.isCollapsed.year) {
                    this.toggleYearPicker();
                }
            };
            return (external_react_.createElement(DatepickerOption, { key: year, isCurrent: (0,isSameYear/* default */.Z)(yearDate, this.currentDate), isSelected: this.isSelected(yearDate, 'year'), onClick: onClick, children: year }));
        };
        this.renderMonth = (monthIndex) => {
            const { components: { DatepickerOption }, formatFn } = this.props;
            const monthDate = (0,esm_set/* default */.Z)(this.viewState.viewDate, { month: monthIndex });
            const isDisabled = !this.isInRange(monthDate, 'month');
            const onClick = isDisabled ? undefined : () => {
                this.onSelect(monthDate);
                if (!this.state.isCollapsed.month) {
                    this.toggleMonthPicker();
                }
            };
            return (external_react_.createElement(DatepickerOption, { key: monthIndex, isCurrent: isSame(monthDate, this.currentDate, 'month'), isSelected: this.isSelected(monthDate, 'month'), isDisabled: isDisabled, onClick: onClick, children: formatFn((0,esm_set/* default */.Z)(new Date(), { month: monthIndex }), 'MMMM') }));
        };
        this.renderWeek = (weekIndex) => {
            const { components: { DatepickerOption }, formatFn } = this.props;
            const weekDate = (0,setISOWeek/* default */.Z)(this.viewState.viewDate, weekIndex + 1);
            const isDisabled = !this.isInRange(weekDate, 'week');
            const onClick = isDisabled ? undefined : () => {
                this.onSelect(weekDate);
                if (!this.state.isCollapsed.week) {
                    this.toggleWeekPicker();
                }
            };
            return (external_react_.createElement(DatepickerOption, { key: weekIndex, isCurrent: isSame(weekDate, this.currentDate, 'week'), isSelected: this.isSelected(weekDate, 'week'), isDisabled: isDisabled, onClick: onClick, children: formatFn(weekDate, this.props.weekColumnFormat) }));
        };
        this.renderDay = (dayIndex) => {
            const { DatepickerOption } = this.props.components;
            let date;
            switch (true) {
                case this.isShown.week:
                    date = (0,add/* default */.Z)((0,startOfISOWeek/* default */.Z)(this.viewState.viewDate), { days: dayIndex });
                    break;
                case this.isShown.month:
                    date = (0,add/* default */.Z)((0,startOfMonth/* default */.Z)(this.viewState.viewDate), { days: dayIndex });
                    break;
                case this.isShown.year:
                    date = (0,add/* default */.Z)((0,startOfYear/* default */.Z)(this.viewState.viewDate), { days: dayIndex });
                    break;
                default:
                    date = (0,add/* default */.Z)(this.range.from, { days: dayIndex });
            }
            const isDisabled = !this.isInRange(date, 'day');
            const onClick = isDisabled ? undefined : () => {
                this.onSelect(date);
                if (!this.state.isCollapsed.day) {
                    this.toggleDayPicker();
                }
            };
            return (external_react_.createElement(DatepickerOption, { key: dayIndex, isCurrent: isSame(date, this.currentDate, 'day'), isSelected: this.isSelected(date, 'day'), isDisabled: isDisabled, onClick: onClick, children: this.formatDay(date) }));
        };
        this.renderCalendarDayName = (weekDayIndex) => {
            const { formatFn } = this.props;
            return (external_react_.createElement("div", { key: weekDayIndex, className: "datepicker__day-name" },
                external_react_.createElement("span", { className: "datepicker__day-name-inner" }, formatFn((0,setISODay/* default */.Z)(new Date(), weekDayIndex + 1), 'EEEEEE'))));
        };
        this.renderCalendarDay = (cellIndex) => {
            const isInPrecedingMonth = cellIndex < this.viewState.numDaysOfPrecedingMonthVisibleInCalendar;
            const isInFollowingMonth = cellIndex >= this.viewState.numDaysOfPrecedingMonthVisibleInCalendar + this.viewState.numDaysInViewMonth;
            let dayNumber = cellIndex + 1 - this.viewState.numDaysOfPrecedingMonthVisibleInCalendar;
            let dayDate = this.viewState.viewDate;
            if (isInPrecedingMonth) {
                dayNumber += this.viewState.numDaysInPrecedingMonth;
                dayDate = (0,esm_set/* default */.Z)((0,sub/* default */.Z)(dayDate, { months: 1 }), { date: dayNumber });
            }
            else if (isInFollowingMonth) {
                dayNumber -= this.viewState.numDaysInViewMonth;
                dayDate = (0,esm_set/* default */.Z)((0,add/* default */.Z)(dayDate, { months: 1 }), { date: dayNumber });
            }
            else {
                dayDate = (0,esm_set/* default */.Z)(dayDate, { date: dayNumber });
            }
            const isDisabled = !this.isInRange(dayDate, 'day') || isInPrecedingMonth || isInFollowingMonth;
            const onClick = isDisabled ? undefined : () => this.onSelect(dayDate);
            const { DatepickerOption } = this.props.components;
            return (external_react_.createElement(DatepickerOption, { key: cellIndex, className: "datepicker__day", classNameInner: "datepicker__day-inner", isCurrent: isSame(dayDate, this.currentDate, 'day'), isSelected: this.isSelected(dayDate, 'day'), isDisabled: isDisabled, onClick: onClick, children: dayNumber }));
        };
        this.renderTime = (timeRange) => {
            const { components: { DatepickerOption }, formatFn, } = this.props;
            const { from, to } = timeRange;
            if (!isSame(from, this.viewState.viewDate, 'day')) {
                return null;
            }
            let timeString = formatFn(from, 'HH:mm');
            if (to) {
                timeString += ' - ' + formatFn(to, 'HH:mm');
            }
            const isCurrent = isSame(this.viewState.viewDate, this.currentDate, 'day');
            const onClick = () => {
                this.onSelect(timeRange);
                if (!this.state.isCollapsed.time) {
                    this.toggleTimePicker();
                }
            };
            return (external_react_.createElement(DatepickerOption, { key: `${from.valueOf()}-${to && to.valueOf()}`, isCurrent: isCurrent, isSelected: this.isSelected(timeRange, 'minute'), onClick: onClick, children: timeString }));
        };
        this.state = DatepickerInnerCore.getInitialState(props);
        this.toggleCollapsed = this.toggleCollapsed.bind(this);
        this.toggleYearPicker = this.toggleYearPicker.bind(this);
        this.toggleMonthPicker = this.toggleMonthPicker.bind(this);
        this.toggleWeekPicker = this.toggleWeekPicker.bind(this);
        this.toggleDayPicker = this.toggleDayPicker.bind(this);
        this.toggleTimePicker = this.toggleTimePicker.bind(this);
    }
    isInRange(date, precision) {
        if (this.times) {
            for (let index = 0; index < this.times.length; index++) {
                const time = this.times[index];
                const previousTime = this.times[index - 1];
                switch (index) {
                    case 0:
                        if ((0,isBefore/* default */.Z)(date, time.from) && !isSame(date, time.from, precision)) {
                            return false;
                        }
                        break;
                    case this.times.length - 1:
                        if ((0,isAfter/* default */.Z)(date, time.to || time.from) && !isSame(date, time.to || time.from, precision)) {
                            return false;
                        }
                        break;
                    default:
                        if (((0,isBefore/* default */.Z)(date, time.from) && !isSame(date, time.from, precision)) &&
                            ((0,isAfter/* default */.Z)(date, previousTime.to || previousTime.from) && !isSame(date, previousTime.to || previousTime.from, precision))) {
                            return false;
                        }
                }
            }
        }
        return ((0,isAfter/* default */.Z)(date, this.range.from) || isSame(date, this.range.from, precision))
            && (0,isBefore/* default */.Z)(date, this.range.to) || isSame(date, this.range.to, precision);
    }
    isSelected(date, precision) {
        if (!this.value) {
            return false;
        }
        else if (isDateRange(this.value)) {
            return isDateRange(date)
                ? isEqualRange(date, this.value)
                : isDateInDateRange(date, this.value, precision);
        }
        else {
            return isDateRange(date)
                ? isDateInDateRange(this.value, date, precision)
                : isSame(date, this.value, precision);
        }
    }
    onSelect(value) {
        if (!this.isShown.time) {
            // Asserting value as Date because hidden time column implies that value can only be of type "Date".
            return this.select(getClosestDateInRange(value, this.range, this.times));
        }
        if (isDateRange(value)) {
            const existingValueIsDifferent = isDateRange(this.value) && !isEqualRange(value, this.value);
            if (!this.value || existingValueIsDifferent) {
                this.select(value);
            }
        }
        else {
            const existingValueIsDifferent = isDateRange(this.value) && !isSame(this.value.from, value);
            if (!this.value || existingValueIsDifferent) {
                let matchingTimeDate = this.getMatchingTimeDate(value);
                if (!matchingTimeDate) {
                    const closestValue = getClosestDateInRange(value, this.range, this.times);
                    matchingTimeDate = this.getMatchingTimeDate(closestValue);
                }
                if (matchingTimeDate) {
                    this.select(matchingTimeDate[1]);
                }
            }
        }
    }
    select(value) {
        if (this.stateType === 'internal') {
            this.setState({ value });
        }
        if (this.props.onChange) {
            this.props.onChange(this.toOutputValue(value));
        }
    }
    toOutputValue(value) {
        if (isDateRange(value)) {
            const selectedTimeIndex = getSelectedTimeIndex(this.times, value);
            if (this.props.times && typeof selectedTimeIndex === 'number') {
                return this.props.times[selectedTimeIndex];
            }
            else {
                return null;
            }
        }
        return value;
    }
    getMatchingTimeDate(value) {
        /* istanbul ignore else */
        if (this.times) {
            for (const [index, time] of this.times.entries()) {
                if (isSame(time.from, value, 'day')) {
                    return [index, time];
                }
            }
        }
    }
    toggleCollapsed(type) {
        this.setState({
            isCollapsed: Object.assign(Object.assign({}, this.state.isCollapsed), { [type]: !this.state.isCollapsed[type] }),
        });
    }
    renderYearPicker() {
        const { DatepickerColumn } = this.props.components;
        const firstYear = (0,getYear/* default */.Z)(this.range.from);
        const lastYear = (0,getYear/* default */.Z)(this.range.to);
        const years = [];
        for (let year = firstYear; year <= lastYear; year++) {
            years.push(year);
        }
        return (external_react_.createElement(DatepickerColumn, { type: "year", isCollapsed: this.state.isCollapsed.year, collapsedLabel: (0,getYear/* default */.Z)(this.viewState.viewDate), onToggleCollapsed: this.toggleYearPicker, children: years.map(this.renderYear) }));
    }
    renderMonthPicker() {
        const { components: { DatepickerColumn }, formatFn } = this.props;
        return (external_react_.createElement(DatepickerColumn, { type: "month", isCollapsed: this.state.isCollapsed.month, collapsedLabel: formatFn(this.viewState.viewDate, 'MMMM'), onToggleCollapsed: this.toggleMonthPicker, children: this.monthIndexes.map(this.renderMonth) }));
    }
    renderWeekPicker() {
        const { components: { DatepickerColumn }, formatFn } = this.props;
        return (external_react_.createElement(DatepickerColumn, { type: "week", isCollapsed: this.state.isCollapsed.week, collapsedLabel: formatFn(this.viewState.viewDate, this.props.weekColumnFormat), onToggleCollapsed: this.toggleWeekPicker, children: this.weekIndexes.map(this.renderWeek) }));
    }
    renderDayPicker() {
        const { DatepickerColumn } = this.props.components;
        let numDays;
        switch (true) {
            case this.isShown.week:
                numDays = 7;
                break;
            case this.isShown.month:
                numDays = (0,getDaysInMonth/* default */.Z)(this.viewState.viewDate);
                break;
            case this.isShown.year:
                numDays = 365 + Number((0,isLeapYear/* default */.Z)(this.viewState.viewDate));
                break;
            default:
                numDays = (0,differenceInCalendarDays/* default */.Z)(this.range.to, this.range.from) + 1;
        }
        return (external_react_.createElement(DatepickerColumn, { type: "day", isCollapsed: this.state.isCollapsed.day, collapsedLabel: this.formatDay(this.viewState.viewDate), onToggleCollapsed: this.toggleDayPicker, children: Array.from(Array(numDays).keys()).map(this.renderDay) }));
    }
    formatDay(date) {
        const { formatFn } = this.props;
        let formatType;
        switch (true) {
            case this.isShown.week:
                formatType = this.props.dayColumnFormat || 'EEEEEE d. MMMM';
                break;
            case this.isShown.month:
                formatType = this.props.dayColumnFormat || 'd';
                break;
            case this.isShown.year:
                formatType = this.props.dayColumnFormat || 'EEEEEE d. MMMM';
                break;
            default:
                formatType = this.props.dayColumnFormat || 'EEEEEE d. MMMM, Y';
        }
        return formatFn(date, formatType);
    }
    renderCalendarPicker() {
        return (external_react_.createElement("div", { className: "datepicker__column datepicker__column--calendar" },
            external_react_.createElement("div", { className: "datepicker__calendar" },
                external_react_.createElement("div", { className: "datepicker__day-names" }, this.weekDayIndexes.map(this.renderCalendarDayName)),
                external_react_.createElement("div", { className: "datepicker__days" }, this.calendarCellIndexes.map(this.renderCalendarDay)))));
    }
    renderTimePicker() {
        var _a;
        const { components: { DatepickerColumn }, formatFn } = this.props;
        return (external_react_.createElement(DatepickerColumn, { type: "time", isCollapsed: this.state.isCollapsed.time, collapsedLabel: formatFn(this.viewState.viewDate, 'HH:mm'), onToggleCollapsed: this.toggleTimePicker, children: (_a = this.times) === null || _a === void 0 ? void 0 : _a.map(this.renderTime) }));
    }
    renderClearButton() {
        const { clearButtonLabel } = this.props;
        const { Button } = this.props.components;
        return (external_react_.createElement(Button, { size: "small", variant: "secondary", className: "datepicker__button", onClick: this.onClear, text: clearButtonLabel }));
    }
    renderSubmitButton() {
        const { submitButtonLabel } = this.props;
        const { Button } = this.props.components;
        return (external_react_.createElement(Button, { size: "small", className: "datepicker__button", onClick: this.onSubmit, text: submitButtonLabel }));
    }
    BEM() {
        const classArray = ['datepicker'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (external_react_.createElement("div", { className: this.BEM() },
            external_react_.createElement("div", { className: "datepicker__content" },
                this.isShown.year && this.renderYearPicker(),
                this.isShown.month && this.renderMonthPicker(),
                this.isShown.week && this.renderWeekPicker(),
                this.isShown.day && this.renderDayPicker(),
                this.isShown.calendar && this.renderCalendarPicker(),
                this.isShown.time && this.renderTimePicker()),
            external_react_.createElement("div", { className: "datepicker__buttons" },
                this.renderSubmitButton(),
                this.renderClearButton())));
    }
}
DatepickerInnerCore.defaultProps = {
    clearButtonLabel: 'Clear',
    columns: ['year', 'month', 'calendar'],
    submitButtonLabel: 'Done',
    weekColumnFormat: '\'week\' I',
};


;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/datepicker-option/datepicker-option.js

function datepicker_option_BEM(props) {
    const { className = 'datepicker__option' } = props;
    const classNames = [className];
    if (props.isCurrent) {
        classNames.push('is-current');
    }
    if (props.isSelected) {
        classNames.push('is-selected');
    }
    if (props.isDisabled) {
        classNames.push('is-disabled');
    }
    return classNames.join(' ');
}
const DatePickerOption = (props) => {
    const { classNameInner = 'datepicker__option-inner' } = props;
    return (external_react_.createElement("div", { className: datepicker_option_BEM(props), onClick: props.onClick },
        external_react_.createElement("div", { className: classNameInner }, props.children)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/datepicker.js





const Datepicker = (props) => {
    return (external_react_.createElement(DatepickerCore, Object.assign({}, props, { components: {
            Button: button_Button,
            DatepickerColumn: datepicker_column_DatepickerColumn,
            DatepickerOption: DatePickerOption,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/datepicker/esm/index.js







;// CONCATENATED MODULE: ./node_modules/@core-front/suggestion/esm/suggestion-core.js
var suggestion_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function isSuggestionGroup(item) {
    return Object.prototype.hasOwnProperty.call(item, 'items');
}
class SuggestionCore extends external_react_.PureComponent {
    BEM() {
        const classArray = ['suggestion'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    itemBEM(item) {
        const classArray = ['suggestion__item'];
        if (isSuggestionGroup(item)) {
            classArray.push('suggestion__item--grouped');
        }
        else {
            if (item.isActive) {
                classArray.push('is-active');
            }
            if (item.isFocused) {
                classArray.push('is-focused');
            }
            if (item.color) {
                classArray.push('suggestion__item--' + item.color);
            }
            if (item.className) {
                classArray.push(item.className);
            }
        }
        return classArray.join(' ');
    }
    // Don't remove spans, they are needed if the page is translated with Google Translate
    getMarkedContent(label) {
        return (external_react_.createElement("mark", { className: "suggestion__label-mark" },
            external_react_.createElement("span", null, label)));
    }
    // Don't remove spans, they are needed if the page is translated with Google Translate
    generateLabel(item) {
        const { label, subLabel } = item;
        const { highlightedValue } = this.props;
        const getSubLabel = subLabel && external_react_.createElement("span", { className: "suggestion__sub-label" }, subLabel);
        if (highlightedValue) {
            const highlightedValueIndex = label.toLowerCase().indexOf(highlightedValue.toLowerCase());
            const highlightedText = label.slice(highlightedValueIndex, highlightedValueIndex + highlightedValue.length);
            if (label.toLowerCase().includes(highlightedValue.toLowerCase())) {
                const markedLabel = label.split(highlightedText).map((part, index) => {
                    return (external_react_.createElement(external_react_.Fragment, { key: index },
                        external_react_.createElement("span", null, part.split(highlightedText)[0]),
                        (label.split(highlightedText).length !== index + 1) && this.getMarkedContent(highlightedText)));
                });
                return (external_react_.createElement("span", { className: "suggestion__label" },
                    external_react_.createElement("span", null, markedLabel),
                    external_react_.createElement("span", null, getSubLabel)));
            }
        }
        return (external_react_.createElement("span", { className: "suggestion__label" },
            external_react_.createElement("span", null, label),
            external_react_.createElement("span", null, getSubLabel)));
    }
    getItem(item, index) {
        const { Anchor, Icon, Image } = this.props.components;
        const { label, subLabel, isActive, itemRef, icon, image, id, role, 'aria-selected': ariaSelected } = item, rest = suggestion_core_rest(item, ["label", "subLabel", "isActive", "itemRef", "icon", "image", "id", "role", 'aria-selected']);
        return (external_react_.createElement("li", { className: this.itemBEM(item), ref: itemRef, key: id || index, role: role, "aria-selected": ariaSelected, id: id },
            external_react_.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: "suggestion__link", tabIndex: 0 }),
                icon && external_react_.createElement(Icon, { modifiers: icon, className: "suggestion__icon" }),
                image && external_react_.createElement(Image, Object.assign({}, image, { className: "suggestion__image" })),
                this.generateLabel(item))));
    }
    getItems(items) {
        return items.map((item, index) => {
            if (isSuggestionGroup(item)) {
                return (external_react_.createElement("li", { className: this.itemBEM(item), key: index },
                    external_react_.createElement("div", { className: "suggestion__group-label" }, item.label),
                    external_react_.createElement("ul", { className: "suggestion__group-list" }, item.items.map((groupListItem, i) => {
                        return this.getItem(groupListItem, i);
                    }))));
            }
            else {
                return this.getItem(item, index);
            }
        });
    }
    getAdditionalContent(additionalContent) {
        return (external_react_.createElement("li", { className: "suggestion__item suggestion__item--additional-content" }, additionalContent));
    }
    getSpinner() {
        const { Spinner } = this.props.components;
        return (external_react_.createElement("li", { className: "suggestion__item" },
            external_react_.createElement(Spinner, { className: "suggestion__spinner" })));
    }
    render() {
        const _a = this.props, { items, listRef, isLoading, highlightedValue, additionalContent, components } = _a, rest = suggestion_core_rest(_a, ["items", "listRef", "isLoading", "highlightedValue", "additionalContent", "components"]);
        return (external_react_.createElement("ul", Object.assign({}, rest, { ref: listRef, className: this.BEM() }),
            this.getItems(items),
            isLoading && this.getSpinner(),
            additionalContent && this.getAdditionalContent(additionalContent)));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/suggestion/esm/suggestion.js






const Suggestion = (props) => {
    return (external_react_.createElement(SuggestionCore, Object.assign({}, props, { components: {
            Anchor: anchor_esm_anchor,
            Icon: icon/* default */.Z,
            Image: esm_image/* default */.Z,
            Spinner: spinner/* default */.Z,
        } })));
};
/* harmony default export */ const suggestion = (Suggestion);

;// CONCATENATED MODULE: ./node_modules/@core-front/dropdown/esm/dropdown-core.js
var dropdown_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const DropdownCore = (props) => {
    const innerComponent = props.button.responsive ? external_react_.createElement(DropdownResponsiveCore, Object.assign({}, props, { buttonResponsive: props.button.responsive })) : external_react_.createElement(DropdownCoreInner, Object.assign({}, props));
    return (external_react_.createElement(props_checker, { componentName: "Dropdown", componentProps: props, defaultValueName: "defaultIsOpen", valueName: "isOpen", onChangeNames: "onToggle" }, innerComponent));
};
/* harmony default export */ const dropdown_core = (DropdownCore);
const DropdownResponsiveCore = (props) => {
    const { buttonResponsive: responsive, button } = props, rest = dropdown_core_rest(props, ["buttonResponsive", "button"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsiveProps = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive });
    return external_react_.createElement(DropdownCoreInner, Object.assign({}, rest, { button: Object.assign(Object.assign({}, button), responsiveProps) }));
};
class DropdownCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.popper = null;
        this.button = null;
        this.element = null;
        this.itemLinks = [];
        this.getZIndex = () => {
            /* istanbul ignore else */
            if (this.button) {
                const inHeader = this.button.closest('.header') !== null;
                const inModal = this.button.closest('.modal') !== null;
                if (inHeader || inModal) {
                    return 30;
                }
            }
            return 19;
        };
        this.enablePopper = () => {
            this.initPopper();
        };
        this.handleClose = () => {
            this.disablePopper();
        };
        this.handleButtonClick = (event) => {
            event.preventDefault();
            if (!this.isOpenControlled()) {
                this.setState((prevState) => {
                    return {
                        isOpen: !prevState.isOpen,
                    };
                });
            }
            if (this.props.onToggle) {
                this.props.onToggle(!this.isOpen);
            }
            if (this.props.onClose && this.isOpen) {
                this.props.onClose();
            }
        };
        this.onKeyDown = (event) => {
            var _a;
            switch (event.key) {
                case 'Escape':
                case 'Esc':
                    if (this.isOpen) {
                        event.preventDefault();
                        this.close();
                        (_a = this.button) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    return;
                case 'Tab': {
                    const prevFocusedItemIndex = this.itemLinks.findIndex((item) => item === document.activeElement);
                    if (event.shiftKey) {
                        if (prevFocusedItemIndex === 0) {
                            this.setState({ focusedElementIndex: -1 });
                        }
                        if (prevFocusedItemIndex > -1) {
                            this.setState({ focusedElementIndex: prevFocusedItemIndex - 1 });
                        }
                    }
                    else {
                        if (document.activeElement === this.button) {
                            this.setState({ focusedElementIndex: 0 });
                        }
                        if (prevFocusedItemIndex > -1) {
                            if (prevFocusedItemIndex === this.itemLinks.length - 1) {
                                this.close();
                            }
                            else {
                                this.setState({ focusedElementIndex: prevFocusedItemIndex + 1 });
                            }
                        }
                    }
                }
            }
        };
        this.buttonRef = (el) => {
            this.button = el;
            if (this.props.button.buttonRef) {
                this.props.button.buttonRef(el);
            }
        };
        this.handleOpen = this.handleOpen.bind(this);
        this.onClickOutside = this.onClickOutside.bind(this);
        this.disablePopper = this.disablePopper.bind(this);
        this.state = {
            isMounted: false,
            isOpen: props.defaultIsOpen || false,
            focusedElementIndex: -1,
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutside);
        this.setState({
            isMounted: true,
        }, this.enablePopper);
    }
    componentWillUnmount() {
        this.disablePopper();
        document.removeEventListener('mousedown', this.onClickOutside);
    }
    componentDidUpdate(prevProps, prevState) {
        if ((this.props.isOpen && !prevProps.isOpen) || (this.state.isOpen && !prevState.isOpen)) {
            this.handleOpen();
        }
        else if ((!this.props.isOpen && prevProps.isOpen) || (!this.state.isOpen && prevState.isOpen)) {
            this.handleClose();
        }
    }
    isOpenControlled(isOpen = this.props.isOpen) {
        return !!this.props.onToggle && typeof isOpen !== 'undefined';
    }
    get isOpen() {
        return this.isOpenControlled(this.props.isOpen) ? this.props.isOpen : this.state.isOpen;
    }
    disablePopper() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    }
    initPopper() {
        if (this.isOpen && this.props.items && this.element && this.button && !this.popper) {
            this.popper = (0,popper/* createPopper */.fi)(this.button, this.element, {
                modifiers: [
                    { name: 'applyStyles', enabled: false },
                    { name: 'flip', enabled: false },
                    {
                        name: 'updateState',
                        enabled: true,
                        phase: 'write',
                        requires: ['computeStyles'],
                        fn: ({ state }) => {
                            this.setState({
                                popperStyle: Object.assign(Object.assign({}, state.styles.popper), { zIndex: this.getZIndex() }),
                            });
                        },
                    },
                ],
                placement: this.props.align === 'end' ? 'bottom-end' : 'bottom-start',
            });
        }
    }
    close() {
        if (this.props.onClose && this.isOpen) {
            this.props.onClose();
        }
        if (this.props.onToggle && this.isOpen) {
            this.props.onToggle(false);
        }
        if (!this.isOpenControlled()) {
            this.setState({
                isOpen: false,
            });
        }
        this.setState({ focusedElementIndex: -1 });
    }
    onClickOutside(event) {
        const { outsideClickCloseFilter } = this.props;
        const clickedOnTrigger = this.button && event.target instanceof Element && this.button.contains(event.target);
        const clickedOnDropdown = this.element && event.target instanceof Node && this.element.contains(event.target);
        const clickedOnOutsideTrigger = event.target instanceof Element && outsideClickCloseFilter && outsideClickCloseFilter(event.target);
        if (clickedOnTrigger || clickedOnOutsideTrigger || clickedOnDropdown) {
            return;
        }
        this.close();
    }
    BEM(state) {
        const classArray = ['dropdown', `is-${state}`, `dropdown--width-${this.props.width}`];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    handleOpen() {
        this.enablePopper();
    }
    get items() {
        const items = this.props.items || [];
        let globalIndex = 0;
        return items.map((item) => {
            globalIndex++;
            const currentIndex = globalIndex - 1;
            return Object.assign(Object.assign({}, item), { isFocused: this.state.focusedElementIndex === currentIndex, tabIndex: -1 });
        });
    }
    get hiddenItems() {
        const items = this.props.items || [];
        let globalIndex = 0;
        return items.map((item) => {
            globalIndex++;
            const currentIndex = globalIndex - 1;
            return Object.assign(Object.assign({}, item), { id: item.id ? `${item.id}-hidden` : undefined, elementRef: (el) => el && (this.itemLinks[currentIndex] = el), tabIndex: this.isOpen ? undefined : -1 });
        });
    }
    renderDropdown() {
        const { Suggestion } = this.props.components;
        const content = (state) => (external_react_.createElement("div", { ref: (el) => this.element = el, className: this.BEM(state), style: this.state.popperStyle, "aria-hidden": true },
            external_react_.createElement(Suggestion, { items: this.items, className: "dropdown__suggestion" })));
        return (external_react_.createElement(esm_Transition/* default */.ZP, { in: this.isOpen, timeout: { enter: 10, exit: 100 }, mountOnEnter: true, unmountOnExit: true, onExited: this.disablePopper }, content));
    }
    renderHiddenDropdown() {
        const { Suggestion } = this.props.components;
        return (external_react_.createElement("div", { className: "dropdown is-hidden", onKeyDown: this.onKeyDown, "aria-hidden": !this.isOpen },
            external_react_.createElement(Suggestion, { id: this.props.id, items: this.hiddenItems })));
    }
    renderButtonOrCollapseToggle(button) {
        const { Button, CollapseToggle } = this.props.components;
        if (button.iconRight && button.iconRight === '#arrow-down') {
            return (external_react_.createElement(CollapseToggle, Object.assign({}, button, { onClick: this.handleButtonClick, buttonRef: this.buttonRef, isActive: this.isOpen, "aria-expanded": this.isOpen, "aria-controls": this.props.id, onKeyDown: this.onKeyDown })));
        }
        return (external_react_.createElement(Button, Object.assign({}, button, { onClick: this.handleButtonClick, buttonRef: this.buttonRef, isActive: this.isOpen, "aria-expanded": this.isOpen, "aria-controls": this.props.id, onKeyDown: this.onKeyDown })));
    }
    render() {
        return (external_react_.createElement(external_react_.Fragment, null,
            this.renderButtonOrCollapseToggle(this.props.button),
            this.renderHiddenDropdown(),
            this.state.isMounted ? external_react_dom_.createPortal(this.renderDropdown(), this.props.portalContainer || document.body) : this.renderDropdown()));
    }
}
DropdownCoreInner.defaultProps = {
    align: 'start',
    width: 'default',
};

;// CONCATENATED MODULE: ./node_modules/@core-front/dropdown/esm/dropdown.js





const Dropdown = (props) => {
    return (external_react_.createElement(dropdown_core, Object.assign({}, props, { components: {
            Button: button_Button,
            CollapseToggle: CollapseToggle,
            Suggestion: suggestion,
        } })));
};
/* harmony default export */ const dropdown = (Dropdown);

;// CONCATENATED MODULE: ./node_modules/@core-front/dropdown/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/eu-icon/esm/eu-icon-core.js

const getIconModifier = (lang, hasText) => {
    if (hasText) {
        switch (lang) {
            case 'russian':
                return '#eu-sliced-ru';
            case 'estonian':
                return '#eu-sliced-et';
            case 'english':
            default:
                return '#eu-sliced';
        }
    }
    switch (lang) {
        case 'russian':
            return '#eu-ru';
        case 'estonian':
            return '#eu-et';
        case 'english':
        default:
            return '#eu';
    }
};
const EuIconCore = (props) => {
    const { className, components, lang = 'english', size = 'lg', text, } = props;
    const { Icon } = components;
    const BEM = () => {
        const classArray = ['eu-icon'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() },
        external_react_.createElement(Icon, { size: size, modifiers: getIconModifier(lang, !!text), className: "eu-icon__svg" }),
        text && external_react_.createElement("div", { className: "eu-icon__text" }, text)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/eu-icon/esm/eu-icon.js



const EuIcon = (props) => {
    return (external_react_.createElement(EuIconCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/eu-icon/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/equal-height/node_modules/@core-front/helper/esm/index.js


let equal_height_node_modules_core_front_helper_esm_scrollAnimationFrame = 0;
const equal_height_node_modules_core_front_helper_esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const equal_height_node_modules_core_front_helper_esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !equal_height_node_modules_core_front_helper_esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const equal_height_node_modules_core_front_helper_esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && equal_height_node_modules_core_front_helper_esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const equal_height_node_modules_core_front_helper_esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const equal_height_node_modules_core_front_helper_esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const equal_height_node_modules_core_front_helper_esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(equal_height_node_modules_core_front_helper_esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = equal_height_node_modules_core_front_helper_esm_swingTo(p);
        if (p < 1) {
            equal_height_node_modules_core_front_helper_esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const equal_height_node_modules_core_front_helper_esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || equal_height_node_modules_core_front_helper_esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!isFocusable(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        equal_height_node_modules_core_front_helper_esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const equal_height_node_modules_core_front_helper_esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= equal_height_node_modules_core_front_helper_esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const equal_height_node_modules_core_front_helper_esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const equal_height_node_modules_core_front_helper_esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return equal_height_node_modules_core_front_helper_esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const equal_height_node_modules_core_front_helper_esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const equal_height_node_modules_core_front_helper_esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const equal_height_node_modules_core_front_helper_esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const equal_height_node_modules_core_front_helper_esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const equal_height_node_modules_core_front_helper_esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const equal_height_node_modules_core_front_helper_esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const equal_height_node_modules_core_front_helper_esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    equal_height_node_modules_core_front_helper_esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const equal_height_node_modules_core_front_helper_esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const equal_height_node_modules_core_front_helper_esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/equal-height/esm/equal-height-provider/equal-height-provider-core.js


const EqualHeightContext = external_react_.createContext({
    addElementToGroup: () => null,
    groupHeights: {},
    triggerUpdate: () => null,
});
const EqualHeightProviderCore = (props) => {
    const { children, groups, offSet = 3, imageComponent, onGroupHeightsChange, } = props;
    const firstUpdate = external_react_.useRef(true);
    const elementGroups = external_react_.useRef({});
    const [groupHeights, setGroupHeights] = external_react_.useState({});
    // Reset all GroupHeigts to empty object to reinitialize them
    const setAllGroupHeights = external_react_.useCallback(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        setGroupHeights({});
    }, []);
    const handleResize = external_react_.useCallback(() => {
        setAllGroupHeights();
    }, [setAllGroupHeights]);
    const debouncedResizeHandler = external_react_.useMemo(() => (0,debounce.debounce)(handleResize, 100), [handleResize]);
    external_react_.useEffect(() => {
        setAllGroupHeights();
    }, [setAllGroupHeights]);
    external_react_.useEffect(() => {
        window.addEventListener('resize', debouncedResizeHandler);
        return () => {
            window.removeEventListener('resize', debouncedResizeHandler);
            debouncedResizeHandler.clear();
        };
    }, [debouncedResizeHandler]);
    const setGroupHeight = external_react_.useCallback((groupKeys) => {
        // clone array since we're going to mutate it.
        const keys = [...groupKeys];
        // get first element from array and remove it
        const group = keys.shift();
        if (group) {
            if (!elementGroups.current[group]) {
                elementGroups.current[group] = [];
            }
            const elementGroup = elementGroups.current[group];
            // split elements in group by top offset
            const elementOffsetGroup = splitElementsByOffset(elementGroup, offSet);
            const heightsByElements = [];
            // assign every element to a group with it's height and offset
            for (const key of Object.keys(elementOffsetGroup)) {
                heightsByElements.push({
                    elements: elementOffsetGroup[key],
                    height: findTallestChildHeight(elementOffsetGroup[key]),
                    offsetTop: Number(key),
                });
            }
            // set group heights to state
            setGroupHeights((prevState) => (Object.assign(Object.assign({}, prevState), { [group]: heightsByElements })));
            // continue with next group
            setTimeout(() => {
                setGroupHeight(keys);
            });
            // Call onGroupHeightsChange after last groupHeight change
            if (keys.length === 0 && onGroupHeightsChange) {
                onGroupHeightsChange();
            }
        }
    }, [offSet, onGroupHeightsChange]);
    // If GroupHeights have been reset, set Heights again to all groups.
    external_react_.useEffect(() => {
        if (Object.keys(groupHeights).length === 0) {
            setGroupHeight(groups);
        }
    }, [groupHeights, groups, setGroupHeight]);
    const addElementToGroup = external_react_.useCallback((group, element) => {
        if (!elementGroups.current[group]) {
            elementGroups.current[group] = [];
        }
        elementGroups.current[group].push(element);
    }, [elementGroups]);
    return (external_react_.createElement(EqualHeightContext.Provider, { value: {
            addElementToGroup,
            groupHeights,
            imageComponent,
            triggerUpdate: debouncedResizeHandler,
        } }, children));
};
const findTallestChildHeight = (elements) => {
    return elements.reduce((accumulator, element) => {
        return element.scrollHeight > accumulator ? element.scrollHeight : accumulator;
    }, 0);
};
const getElementGroup = (elementGroups, elementOffSet, offSet) => {
    const keys = Object.keys(elementGroups);
    // Default check if there is already group that's within +/-3px offset.
    // When page is zoomed offsets can have little differences
    return Number(keys.find((key) => {
        return (Number(key) >= elementOffSet - offSet && Number(key) <= elementOffSet + offSet);
    }));
};
const splitElementsByOffset = (elements, offSet) => {
    const elementGroups = {};
    elements.forEach((element) => {
        if (element !== null) {
            const offsetTop = equal_height_node_modules_core_front_helper_esm_offset(element).top;
            const elementGroup = getElementGroup(elementGroups, offsetTop, offSet) || offsetTop;
            if (!elementGroups[elementGroup]) {
                elementGroups[elementGroup] = [];
            }
            elementGroups[elementGroup].push(element);
        }
    });
    return elementGroups;
};
/* harmony default export */ const equal_height_provider_core = (EqualHeightProviderCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/equal-height/esm/equal-height/equal-height-core.js


const EqualHeight = (props) => {
    const context = external_react_.useContext(EqualHeightContext);
    const element = external_react_.useRef(null);
    const { elementRef } = props;
    const getHeightByElement = external_react_.useCallback((element, elementGroup) => {
        const groupKey = Object.keys(context.groupHeights).find((key) => key === elementGroup);
        if (groupKey) {
            const elGroup = context.groupHeights[groupKey].find((group) => group.elements.includes(element));
            return elGroup ? elGroup.height : 0;
        }
        return 0;
    }, [context.groupHeights]);
    const setElement = external_react_.useCallback((e) => {
        element.current = e;
        if (elementRef && e) {
            elementRef(e);
        }
    }, [elementRef]);
    return (external_react_.createElement(EqualHeightInner, Object.assign({}, props, context, { height: element.current ? getHeightByElement(element.current, props.group) : 0, elementRef: setElement, contextImageComponent: context.imageComponent, imageComponent: props.imageComponent })));
};
const EqualHeightInner = (props) => {
    const { align, className, elementRef, addElementToGroup, group, groupHeights, height, children, imageComponent, contextImageComponent, triggerUpdate, onHeightChange, } = props;
    const element = external_react_.useRef(null);
    const firstHeightChange = external_react_.useRef(true);
    external_react_.useEffect(() => {
        triggerUpdate();
    }, [children, triggerUpdate]);
    external_react_.useEffect(() => {
        if (firstHeightChange.current) {
            firstHeightChange.current = false;
            return;
        }
        if (onHeightChange) {
            onHeightChange();
        }
    }, [height, onHeightChange]);
    const BEM = () => {
        const classArray = ['equal-height'];
        if (align) {
            classArray.push('equal-height--' + align);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    external_react_.useEffect(() => {
        if (element.current !== null) {
            if (elementRef) {
                elementRef(element.current);
            }
            addElementToGroup(group, element.current);
        }
    }, [addElementToGroup, elementRef, group]);
    const getStyle = () => {
        if (element.current) {
            if (!groupHeights || Object.keys(groupHeights).length === 0) {
                return undefined;
            }
            return {
                minHeight: height + 'px',
            };
        }
    };
    const renderChildren = (children) => {
        return external_react_.Children.map(children, (child) => {
            if (!external_react_.isValidElement(child)) {
                return child;
            }
            // only provide props to EqualHeight that has same group name as provider.
            if (child.type === imageComponent || child.type === contextImageComponent) {
                return external_react_.cloneElement(child, {
                    onLoad: (event) => {
                        triggerUpdate();
                        if (child.props.onLoad) {
                            child.props.onLoad(event);
                        }
                    },
                });
            }
            else if (child.props.children) {
                return external_react_.cloneElement(child, {
                    children: renderChildren(child.props.children),
                });
            }
            return child;
        });
    };
    return (external_react_.createElement("div", { className: BEM(), ref: element, style: getStyle() },
        external_react_.createElement("div", { className: "equal-height__inner" }, renderChildren(children))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/equal-height/esm/equal-height/equal-height.js



const equal_height_EqualHeight = (props) => (external_react_.createElement(EqualHeight, Object.assign({}, props, { imageComponent: esm_image/* default */.Z })));
/* harmony default export */ const equal_height = (equal_height_EqualHeight);

;// CONCATENATED MODULE: ./node_modules/@core-front/equal-height/esm/equal-height-provider/equal-height-provider.js


const EqualHeightProvider = (props) => (external_react_.createElement(equal_height_provider_core, Object.assign({}, props)));
/* harmony default export */ const equal_height_provider = (EqualHeightProvider);

;// CONCATENATED MODULE: ./node_modules/@core-front/equal-height/esm/index.js





;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/error-provider/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/feature-list/esm/feature-list/feature-list-core.js

const FeatureListCore = (props) => {
    const { AnalyticsProvider } = props.components;
    const { className, children, analyticsGroup = 'Features', } = props;
    const BEM = () => {
        const classArray = ['feature-list'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(AnalyticsProvider, { group: analyticsGroup },
        external_react_.createElement("div", { className: BEM() },
            external_react_.createElement("ul", { className: "feature-list__inner" }, children))));
};
/* harmony default export */ const feature_list_core = (FeatureListCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/feature-list/esm/feature-list/feature-list.js



const FeatureList = (props) => {
    return (external_react_.createElement(feature_list_core, Object.assign({}, props, { components: {
            AnalyticsProvider: analytics_provider/* default */.ZP,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/feature-list/esm/feature-list-item/feature-list-item-core.js

const FeatureListItemCore = (props) => {
    const { className, components: { Grid, GridColumn, Icon, Image, }, icon, grid, children, } = props;
    const BEM = () => {
        const classArray = ['feature-list__item'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const renderIcon = () => {
        if (typeof icon === 'string') {
            return (external_react_.createElement(Icon, { className: "feature-list__item-icon", modifiers: icon, align: "none" }));
        }
        return (external_react_.createElement(Image, Object.assign({}, icon, { className: "feature-list__item-image" })));
    };
    return (external_react_.createElement("li", { className: BEM() },
        external_react_.createElement("div", { className: "feature-list__item-inner" },
            external_react_.createElement(Grid, Object.assign({ noWrap: true, align: ['middle-xs'] }, grid),
                external_react_.createElement(GridColumn, { width: ['min'], className: "feature-list__item-icon-col" }, renderIcon()),
                external_react_.createElement(GridColumn, { width: ['max'] },
                    external_react_.createElement("div", { className: "feature-list__item-content" }, children))))));
};
/* harmony default export */ const feature_list_item_core = (FeatureListItemCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/feature-list/esm/feature-list-item/feature-list-item.js





const FeatureListItem = (props) => {
    return (external_react_.createElement(feature_list_item_core, Object.assign({}, props, { components: {
            Grid: grid,
            GridColumn: grid_column,
            Icon: icon/* default */.Z,
            Image: esm_image/* default */.Z,
        } })));
};
/* harmony default export */ const feature_list_item = (FeatureListItem);

;// CONCATENATED MODULE: ./node_modules/@core-front/feature-list/esm/index.js





;// CONCATENATED MODULE: ./node_modules/@core-front/list/esm/list/list.js

const ListContext = external_react_.createContext({
    iconSize: 'xs',
});
class List extends external_react_.Component {
    BEM() {
        const classArray = ['list'];
        if (this.props.type) {
            classArray.push('list--' + this.props.type);
        }
        if (this.props.type === 'icon') {
            classArray.push('list--icon-position-' + this.props.iconPosition);
        }
        if (this.props.size) {
            classArray.push('list--' + this.props.size);
        }
        if (this.props.iconSize) {
            classArray.push('list--icon-size-' + this.props.iconSize);
        }
        if (this.props.align) {
            classArray.push('text-' + this.props.align);
        }
        if (this.props.direction) {
            classArray.push('list--direction-' + this.props.direction);
        }
        if (this.props.bordered) {
            classArray.push('list--bordered');
            if (this.props.outerBordered) {
                classArray.push('list--outer-bordered');
            }
        }
        if (this.props.fullWidth) {
            classArray.push('list--full-width');
        }
        if (this.props.noGutter) {
            if (this.props.noGutter === 'all') {
                classArray.push('list--no-gutter');
            }
            else {
                classArray.push(`list--no-${this.props.noGutter}-gutter`);
            }
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const ListElement = this.props.type === 'ordered' ? 'ol' : 'ul';
        const listContextValue = {
            icon: this.props.icon,
            iconSize: this.props.iconSize || 'xs',
            iconClassName: this.props.iconClassName,
        };
        return (external_react_.createElement(ListContext.Provider, { value: listContextValue },
            external_react_.createElement("div", { className: this.BEM() },
                external_react_.createElement(ListElement, { className: "list__inner" }, this.props.children))));
    }
}
List.defaultProps = {
    outerBordered: true,
    iconPosition: 'top',
};

;// CONCATENATED MODULE: ./node_modules/@core-front/list/esm/list-item/list-item-core.js


class ListItemCore extends external_react_.Component {
    get iconClassName() {
        var _a;
        return (_a = this.props.iconClassName) !== null && _a !== void 0 ? _a : this.context.iconClassName;
    }
    BEM() {
        const classArray = ['list__item'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    iconBEM(icon) {
        const classArray = ['list__icon'];
        if (icon === '#check') {
            classArray.push('list__icon--check');
        }
        if (this.iconClassName) {
            classArray.push(this.iconClassName);
        }
        return classArray.join(' ');
    }
    getIcon(icon) {
        const { Icon } = this.props.components;
        return (external_react_.createElement(Icon, { modifiers: icon, size: this.context.iconSize, className: this.iconBEM(icon) }));
    }
    render() {
        const icon = this.props.icon || this.context.icon;
        return (external_react_.createElement("li", { className: this.BEM() },
            external_react_.createElement("div", { className: "list__item-inner" },
                icon && this.getIcon(icon),
                external_react_.createElement("div", { className: "list__content" }, this.props.children))));
    }
}
ListItemCore.contextType = ListContext;

;// CONCATENATED MODULE: ./node_modules/@core-front/list/esm/list-item/list-item.js



class ListItem extends external_react_.Component {
    render() {
        return (external_react_.createElement(ListItemCore, Object.assign({}, this.props, { components: {
                Icon: icon/* default */.Z,
            } })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/filefield/esm/filefield-core.js



const FileFieldCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "FileField", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange", isComponentDisabled: props.isDisabled },
        external_react_.createElement(props_checker, { componentName: "FileField", componentProps: props, defaultValueName: "defaultIsFocused", valueName: "isFocused", onChangeNames: ['onFocus', 'onBlur'] },
            external_react_.createElement(analytics_trigger/* default */.Z, { trigger: [
                    {
                        callback: 'onBrowse',
                        id: `Field - Browse - ${props.id}`,
                        elementId: props.id,
                        elementType: 'browse',
                        interactionType: 'open',
                    },
                    {
                        callback: 'onChange',
                        id: `Field - Select - ${props.id}`,
                        elementId: props.id,
                        elementType: 'browse',
                        interactionType: 'select',
                    },
                ] },
                external_react_.createElement(FileFieldCoreInner, Object.assign({}, props))))));
};
/* harmony default export */ const filefield_core = (FileFieldCore);
class FileFieldCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.input = null;
        this.onChange = (event) => {
            const files = this.getFileList(event);
            if (!this.isFilesControlled()) {
                this.setState({
                    files,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(event, files);
            }
        };
        this.onRemove = (file) => {
            if (this.props.onRemove) {
                this.props.onRemove(file);
            }
        };
        this.onAdd = this.onAdd.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.state = {
            files: props.defaultFiles || {},
            isFocused: props.defaultIsFocused || false,
            isFocusedLabel: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        const hasFocusChanged = this.isFocused() !== this.isFocused(prevProps.isFocused, prevState.isFocused);
        if (hasFocusChanged && this.isFocused()) {
            this.setState({
                isFocusedLabel: true,
            });
        }
        else if (hasFocusChanged && !this.isFocused()) {
            this.setState({
                isFocusedLabel: false,
            });
        }
    }
    get files() {
        return this.isFilesControlled(this.props.files) ? this.props.files : this.state.files;
    }
    isFilesControlled(value = this.props.files) {
        const isDefined = typeof value !== 'undefined';
        if (this.props.isDisabled) {
            return isDefined;
        }
        return !!this.props.onChange && isDefined;
    }
    isFocused(prop = this.props.isFocused, state = this.state.isFocused) {
        return this.isFocusControlled(prop) ? prop : state;
    }
    isFocusControlled(value = this.props.isFocused) {
        return !!this.props.onFocus && !!this.props.onBlur && typeof value !== 'undefined';
    }
    isInvalid() {
        return this.props.isInvalid || !!this.props.helper && this.props.helper.type === 'error';
    }
    BEM() {
        const classArray = ['filefield', 'filefield--floating-label'];
        if (Object.keys(this.files).length) {
            classArray.push('is-dirty');
        }
        if (this.props.isDisabled) {
            classArray.push('is-disabled');
        }
        if (this.props.isInvalid) {
            classArray.push('is-invalid');
        }
        if (this.isFocused()) {
            classArray.push('is-focused');
        }
        if (this.props.hideLabel) {
            classArray.push('filefield--no-label-' + this.props.hideLabel);
        }
        if (this.props.color) {
            classArray.push('filefield--' + this.props.color);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    onAdd() {
        if (this.input) {
            this.input.click();
        }
    }
    onFocus() {
        if (!this.isFocusControlled()) {
            this.setState({
                isFocused: true,
            });
        }
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    }
    onBlur() {
        if (!this.isFocusControlled()) {
            this.setState({
                isFocused: false,
            });
        }
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    }
    getLabel() {
        if (this.state.isFocusedLabel) {
            return this.props.focusLabel ? this.props.focusLabel : this.props.label;
        }
        return this.props.label;
    }
    renderFormHelper(helper) {
        const { FormHelper } = this.props.components;
        return (external_react_.createElement(FormHelper, Object.assign({}, helper, { className: "select__form-helper", id: helper.id || `${this.props.id}-helper` })));
    }
    renderFiles() {
        const { List } = this.props.components;
        const fileEntities = this.files;
        const files = Object.keys(fileEntities).map((name, i) => {
            return this.renderFile(fileEntities[name], i);
        });
        return (external_react_.createElement(List, { type: "unstyled", direction: "inline", noGutter: "all", className: "filefield__files" }, files));
    }
    renderFile(file, index) {
        const { Chip, ListItem } = this.props.components;
        return (external_react_.createElement(ListItem, { key: index, className: "filefield__file" },
            external_react_.createElement(Chip, { onRemove: file.removable ? this.onRemove.bind(this, file) : undefined, removeButtonLabel: this.props.removeButtonLabel, disabled: this.props.isDisabled }, this.renderFileName(file))));
    }
    renderFileName(file) {
        const { Anchor } = this.props.components;
        if (!file.anchor) {
            return file.name;
        }
        return (external_react_.createElement(Anchor, Object.assign({}, file.anchor, { color: this.props.employee ? 'employee' : undefined }), file.name));
    }
    getFileList(event) {
        let fileList = null;
        const fileEntities = {};
        if (event.dataTransfer) {
            const dt = event.dataTransfer;
            if (dt.files && dt.files.length) {
                fileList = dt.files;
            }
            else if (dt.items && dt.items.length) {
                fileList = dt.items;
            }
        }
        else if (event.target && event.target.files) {
            fileList = event.target.files;
        }
        Array.prototype.slice
            .call(fileList)
            .map(({ name }) => {
            fileEntities[name] = { name };
        });
        return fileEntities;
    }
    renderUploadButton() {
        const { Button } = this.props.components;
        return (external_react_.createElement(Button, { className: "filefield__add-btn", iconLeft: "#upload", type: this.props.employee ? 'employee' : undefined, text: this.props.addText, size: "small", onClick: this.onAdd }));
    }
    render() {
        return (external_react_.createElement("div", { className: this.BEM() },
            external_react_.createElement("div", { className: "filefield__inner" },
                external_react_.createElement("label", { className: "filefield__label", htmlFor: this.props.id }, this.getLabel()),
                external_react_.createElement("div", { className: "filefield__input" },
                    external_react_.createElement("div", { className: "filefield__input-content" },
                        external_react_.createElement("input", Object.assign({ ref: (input) => { this.input = input; } }, this.props.input, { id: this.props.id, className: "filefield__input-field", type: "file", disabled: this.props.isDisabled, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onClick: this.props.onBrowse, "aria-invalid": this.isInvalid(), "aria-describedby": this.props.helper ? (this.props.helper.id || `${this.props.id}-helper`) : undefined })),
                        this.renderFiles(),
                        external_react_.createElement("div", { className: "filefield__add" }, this.renderUploadButton())))),
            !!this.props.helper && this.renderFormHelper(this.props.helper)));
    }
}
FileFieldCoreInner.defaultProps = {
    input: {
        multiple: true,
    },
};

;// CONCATENATED MODULE: ./node_modules/@core-front/filefield/esm/filefield.js







const FileField = (props) => {
    return (external_react_default().createElement(filefield_core, Object.assign({}, props, { components: {
            Anchor: anchor_esm_anchor,
            Button: button_Button,
            Chip: Chip,
            FormHelper: FormHelper,
            List: List,
            ListItem: ListItem,
        } })));
};
/* harmony default export */ const filefield = (FileField);

;// CONCATENATED MODULE: ./node_modules/@core-front/filefield/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/helper/esm/hooks/use-previous.js

function usePrevious(value) {
    const ref = external_react_.useRef();
    external_react_.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/fittext/esm/helpers.js
function formatPixelsToNumber(pixels) {
    if (!pixels) {
        return 0;
    }
    return Number(pixels.replace('px', ''));
}
function formatNumberToPixels(num) {
    return `${num}px`;
}
function getParentInnerWidth(el) {
    const { width, paddingLeft, paddingRight } = window.getComputedStyle(el);
    if (width) {
        return formatPixelsToNumber(width) - formatPixelsToNumber(paddingLeft) - formatPixelsToNumber(paddingRight);
    }
    return 0;
}
function isElementInline(el) {
    return window.getComputedStyle(el).display === 'inline';
}
function getElementFontSize(el) {
    return formatPixelsToNumber(window.getComputedStyle(el).fontSize || '0px');
}
function getParentElementParameters(el) {
    const parentEl = el.parentElement;
    const currentParentWidth = parentEl ? getParentInnerWidth(parentEl) : 0;
    const parentFontSize = parentEl ? getElementFontSize(parentEl) : 0;
    return { currentParentWidth, parentFontSize };
}


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/fittext/esm/fittext-core.js



const FittextCore = (props) => {
    const { className, children, } = props;
    const container = external_react_.useRef(null);
    const [fontSize, setFontSize] = external_react_.useState(0);
    const [parentWidth, setParentWidth] = external_react_.useState(0);
    const prevChildren = usePrevious(children);
    const resizeText = external_react_.useCallback(() => {
        if (!container.current) {
            return;
        }
        const el = container.current;
        const elementFontSize = getElementFontSize(el);
        const width = isElementInline(el) ? el.offsetWidth : el.scrollWidth;
        const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
        if (currentParentWidth && elementFontSize && parentFontSize) {
            const isChildGreaterThanParent = width > (currentParentWidth + 1);
            const isResetRequired = parentWidth !== currentParentWidth;
            setParentWidth(currentParentWidth);
            if (isResetRequired) {
                setFontSize(parentFontSize);
            }
            else if (isChildGreaterThanParent && fontSize > 1) {
                setFontSize((f) => f - 1);
            }
        }
    }, [fontSize, parentWidth]);
    external_react_.useLayoutEffect(() => {
        resizeText();
    }, [fontSize, parentWidth, resizeText]);
    external_react_.useEffect(() => {
        const resizeHandler = () => resizeText();
        window.addEventListener('resize', resizeHandler);
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeText]);
    /**
     * Update parentWidth and reset fontSize after children text value changes.
     * Explicitly check if children text value has changed,
     * because other parent element changes shouldn't trigger this hook (e.g. EqualHeight)
     */
    external_react_.useEffect(() => {
        // Check if string as child has changed (React provides children always as array)
        if (prevChildren && children[0] !== prevChildren[0]) {
            const el = container.current;
            if (el) {
                const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
                setParentWidth(currentParentWidth);
                setFontSize(parentFontSize);
            }
        }
    }, [children, prevChildren]);
    const BEM = () => {
        const classArray = ['fittext'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("span", { style: { fontSize: fontSize ? formatNumberToPixels(fontSize) : undefined }, ref: container, className: BEM() }, children));
};
/* harmony default export */ const fittext_core = (FittextCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/fittext/esm/fittext.js


const Fittext = (props) => {
    return (external_react_.createElement(fittext_core, Object.assign({}, props)));
};
/* harmony default export */ const esm_fittext = (Fittext);

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/fittext/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/form-helper/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/grid/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/hash-trigger/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/header-provider/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/heading/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/helper/esm/hooks/use-is-mounted.js

function useIsMounted() {
    const [isMounted, setIsMounted] = external_react_.useState(false);
    external_react_.useEffect(() => {
        setIsMounted(true);
    }, []);
    return isMounted;
}

;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/helper/esm/index.js


let lib_node_modules_core_front_helper_esm_scrollAnimationFrame = 0;
const lib_node_modules_core_front_helper_esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const lib_node_modules_core_front_helper_esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !lib_node_modules_core_front_helper_esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const lib_node_modules_core_front_helper_esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && lib_node_modules_core_front_helper_esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const lib_node_modules_core_front_helper_esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const lib_node_modules_core_front_helper_esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const lib_node_modules_core_front_helper_esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(lib_node_modules_core_front_helper_esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = lib_node_modules_core_front_helper_esm_swingTo(p);
        if (p < 1) {
            lib_node_modules_core_front_helper_esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const lib_node_modules_core_front_helper_esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || lib_node_modules_core_front_helper_esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!(0,index_esm/* isFocusable */.EB)(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        lib_node_modules_core_front_helper_esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const lib_node_modules_core_front_helper_esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= lib_node_modules_core_front_helper_esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const lib_node_modules_core_front_helper_esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const lib_node_modules_core_front_helper_esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return lib_node_modules_core_front_helper_esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const lib_node_modules_core_front_helper_esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const lib_node_modules_core_front_helper_esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const lib_node_modules_core_front_helper_esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const lib_node_modules_core_front_helper_esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const lib_node_modules_core_front_helper_esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const lib_node_modules_core_front_helper_esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const lib_node_modules_core_front_helper_esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    lib_node_modules_core_front_helper_esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const lib_node_modules_core_front_helper_esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const lib_node_modules_core_front_helper_esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/horizontal-progress/esm/horizontal-progress/horizontal-progress-core.js



class HorizontalProgressCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
        };
    }
    componentDidMount() {
        this.setState({
            isMounted: true,
        });
    }
    BEM(stateClass) {
        const classArray = ['horizontal-progress', stateClass];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    renderUl() {
        const { EqualHeightProvider } = this.props.components;
        return (external_react_.createElement(EqualHeightProvider, { groups: ['horizontal-progress-item-title'] },
            external_react_.createElement("ol", { className: "horizontal-progress__steps" }, this.props.children)));
    }
    render() {
        if (this.state.isMounted) {
            const { breakPoints } = this.context;
            return (external_react_.createElement((react_responsive_default()), { minWidth: breakPoints[this.props.break] }, (matches) => (external_react_.createElement("div", { className: this.BEM(matches ? 'is-horizontal' : 'is-vertical') }, this.renderUl()))));
        }
        return (external_react_.createElement("div", { className: this.BEM('is-vertical') }, this.renderUl()));
    }
}
HorizontalProgressCore.contextType = esm_theme_provider_core/* ThemeContext */.Ni;
HorizontalProgressCore.defaultProps = {
    break: 'lg',
};


;// CONCATENATED MODULE: ./node_modules/@core-front/horizontal-progress/esm/horizontal-progress/horizontal-progress.js



const HorizontalProgress = (props) => {
    return (external_react_.createElement(HorizontalProgressCore, Object.assign({}, props, { components: {
            EqualHeightProvider: equal_height_provider,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/horizontal-progress/esm/horizontal-progress-item/horizontal-progress-item-core.js

const HorizontalProgressItemCore = (props) => {
    const { components: { EqualHeight, Heading, Badge, }, headingLevel = 2, } = props;
    const BEM = () => {
        const classArray = ['horizontal-progress__item'];
        if (props.state) {
            classArray.push('is-' + props.state);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const getIcon = () => {
        if (props.state === 'done') {
            return '#check';
        }
        // Empty string, because CSS adds content
        return '';
    };
    const getPurpose = () => {
        if (props.state === 'done') {
            return 'success';
        }
        else if (props.state === 'current') {
            return 'selected';
        }
        else {
            return 'inactive';
        }
    };
    const ButtonTag = props.onTitleClick ? 'button' : 'span';
    return (external_react_.createElement("li", { className: BEM() },
        external_react_.createElement("div", { className: "horizontal-progress__header" },
            external_react_.createElement(Badge, { icon: getIcon(), size: "large", className: "horizontal-progress__counter", purpose: getPurpose() }),
            external_react_.createElement("div", { className: "horizontal-progress__header-inner" },
                external_react_.createElement("div", { className: "horizontal-progress__header-title-section" },
                    external_react_.createElement(EqualHeight, { group: "horizontal-progress-item-title", align: "bottom" },
                        external_react_.createElement(Heading, { level: headingLevel, className: "horizontal-progress__title h4" },
                            external_react_.createElement(ButtonTag, { type: props.onTitleClick ? 'button' : undefined, className: "horizontal-progress__button", onClick: props.onTitleClick, disabled: !(props.state === 'current' || props.state === 'done') }, props.title)))))),
        external_react_.createElement("div", { className: "horizontal-progress__content" }, props.children)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/horizontal-progress/esm/horizontal-progress-item/horizontal-progress-item.js





const HorizontalProgressItem = (props) => {
    return (external_react_.createElement(HorizontalProgressItemCore, Object.assign({}, props, { components: {
            EqualHeight: equal_height,
            Heading: Heading,
            Badge: badge_Badge,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/horizontal-progress/esm/index.js





;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/icon/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/notice/esm/notice-core.js
var notice_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const NoticeCore = (props) => {
    const { type = 'info' } = props, rest = notice_core_rest(props, ["type"]);
    const labels = useLabels();
    return (external_react_.createElement(NoticeCoreInner, Object.assign({}, rest, { type: type, labels: labels })));
};
/* harmony default export */ const notice_core = (NoticeCore);
class NoticeCoreInner extends external_react_.Component {
    constructor() {
        super(...arguments);
        this.element = external_react_.createRef();
    }
    BEM() {
        const classArray = ['notice'];
        if (this.props.type) {
            classArray.push('notice--' + this.props.type);
        }
        if (this.props.size) {
            classArray.push('notice--' + this.props.size);
        }
        if (this.props.align) {
            classArray.push('notice--' + this.props.align);
        }
        if (this.props.direction) {
            classArray.push('notice--' + this.props.direction);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getIcon() {
        if (this.props.icon) {
            return this.props.icon;
        }
        switch (this.props.type) {
            case 'error':
                return '#alert';
            case 'success':
                return '#check-round';
            default:
                return '#info-round';
        }
    }
    render() {
        const { children, closeButtonLabel, components: { Icon }, id, labels, onCloseClick, isCloseButtonHidden, } = this.props;
        const buttonProps = isCloseButtonHidden ? {
            'aria-hidden': true,
            'tabIndex': -1,
        } : {};
        return (external_react_.createElement("div", { className: this.BEM(), id: id, ref: this.element },
            external_react_.createElement("div", { className: "notice__icon-cell" },
                external_react_.createElement(Icon, { modifiers: this.getIcon(), className: "notice__icon" })),
            external_react_.createElement("div", { className: "notice__content" },
                external_react_.createElement("div", { className: "notice__inner-wrapper" },
                    external_react_.createElement("div", { className: "notice__inner" }, children)),
                onCloseClick && (external_react_.createElement("button", Object.assign({ type: "button", className: "notice__close", onClick: onCloseClick }, buttonProps),
                    external_react_.createElement(Icon, { modifiers: "#close-round", className: "notice__close-icon" }),
                    !isCloseButtonHidden && external_react_.createElement("span", { className: "sr-only" }, closeButtonLabel || labels.get('close')))))));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/notice/esm/notice.js



const Notice = (props) => {
    return (external_react_.createElement(notice_core, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } }), props.children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/overlay/esm/overlay-core.js

const OverlayCore = (props) => {
    const { className, color, components, spinner, } = props;
    const { Spinner } = components;
    const BEM = () => {
        const classArray = ['overlay'];
        if (color) {
            classArray.push('overlay--' + color);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getSpinner = () => {
        if (typeof spinner === 'object' && spinner !== null) {
            const spinnerBEM = () => {
                const classArray = ['overlay__spinner'];
                if (spinner.className) {
                    classArray.push(spinner.className);
                }
                return classArray.join(' ');
            };
            return (external_react_.createElement(Spinner, Object.assign({}, spinner, { className: spinnerBEM() })));
        }
        else if (spinner) {
            return external_react_.createElement(Spinner, { className: "overlay__spinner" });
        }
    };
    return (external_react_.createElement("div", { className: BEM() }, getSpinner()));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/overlay/esm/overlay.js



const Overlay = (props) => {
    return (external_react_.createElement(OverlayCore, Object.assign({}, props, { components: {
            Spinner: spinner/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/text/esm/text.js

const Text = (props) => {
    const { children, className, element: Element = 'div', spacing, whiteSpace, } = props;
    const BEM = () => {
        const classArray = ['text'];
        if (className) {
            classArray.push(className);
        }
        if (spacing) {
            classArray.push(`text--${spacing}`);
        }
        if (whiteSpace) {
            classArray.push(`text--${whiteSpace}`);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(Element, { className: BEM() }, children));
};
/* harmony default export */ const esm_text = (Text);

// EXTERNAL MODULE: ./node_modules/@core-front/iframe/node_modules/iframe-resizer/index.js
var iframe_resizer = __webpack_require__(1500);
;// CONCATENATED MODULE: ./node_modules/@core-front/iframe/esm/iframe-core.js
/* eslint-disable @typescript-eslint/ban-ts-comment */



class IframeCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.iframe = null;
        this.handleResize = (data) => {
            // sometimes the load event does not fire
            // but if the iframeResizer lib fires it's resize callback,
            // the iframe has really loaded already
            if (!this.state.hasLoaded) {
                this.setState({
                    hasLoaded: true,
                });
            }
            if (this.props.onResize) {
                this.props.onResize(data);
            }
        };
        this.handleLoad = (event) => {
            if (!this.state.hasLoaded) {
                this.setState({
                    hasLoaded: true,
                });
            }
            if (this.props.onLoad) {
                this.props.onLoad(event);
            }
        };
        this.handleError = (event) => {
            if (this.props.onError) {
                this.props.onError(event);
            }
        };
        this.state = {
            hasLoaded: false,
        };
    }
    componentDidMount() {
        this.initResizer();
    }
    componentDidUpdate() {
        this.initResizer();
    }
    componentWillUnmount() {
        if (this.iframe && this.iframe.iFrameResizer) {
            this.iframe.iFrameResizer
                // removeListeners method does not exist in iframe-resizer typings, so disabling typechecking
                // @ts-ignore
                .removeListeners();
        }
    }
    BEM() {
        const classArray = ['iframe'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    initResizer() {
        const options = {
            checkOrigin: false,
            log: false,
            // onResize method does not exist in iframe-resizer typings, so disabling typechecking
            // @ts-ignore
            onResized: this.handleResize,
        };
        if (this.iframe && !this.iframe.iFrameResizer) {
            (0,iframe_resizer.iframeResizer)(options, this.iframe);
        }
    }
    renderContent() {
        const { Button, Heading, Notice, Overlay, Text } = this.props.components;
        const { needsConsent, consentHeadingLevel } = this.props;
        if (!this.context.hasConsent(needsConsent)) {
            if (this.context.content) {
                return (external_react_.createElement("div", { className: "iframe__consent" },
                    external_react_.createElement("div", { className: "iframe__consent-inner" },
                        external_react_.createElement(Notice, { direction: "vertical" },
                            external_react_.createElement(Text, null,
                                external_react_.createElement(Heading, { level: consentHeadingLevel, className: "h2" }, this.context.content.title),
                                external_react_.createElement("p", { className: "text__margin-double" }, this.context.getDescription(needsConsent)),
                                external_react_.createElement("p", { className: "text__margin-double" },
                                    external_react_.createElement(Button, Object.assign({}, this.context.content.button, { variant: "secondary", iconRight: "#arrow-right" }))))))));
            }
            return null;
        }
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement("iframe", { ref: (element) => this.iframe = element, key: this.props.url, src: this.props.url, title: this.props.title, allow: this.props.allow, className: "iframe__content", onLoad: this.handleLoad, onError: this.handleError, style: { minHeight: this.props.minHeight } }),
            !this.state.hasLoaded && external_react_.createElement(Overlay, { spinner: true })));
    }
    render() {
        return (external_react_.createElement("div", { className: this.BEM() }, this.renderContent()));
    }
}
IframeCore.contextType = cookie_consent_provider/* CookieConsentContext */.Q;
IframeCore.defaultProps = {
    needsConsent: ['necessary'],
    consentHeadingLevel: 1,
};

;// CONCATENATED MODULE: ./node_modules/@core-front/iframe/esm/iframe.js







const Iframe = (props) => {
    return (external_react_.createElement(IframeCore, Object.assign({}, props, { components: {
            Button: button_Button,
            Heading: Heading,
            Notice: Notice,
            Overlay: Overlay,
            Text: esm_text,
        } })));
};
/* harmony default export */ const iframe = (Iframe);

;// CONCATENATED MODULE: ./node_modules/@core-front/iframe/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/image/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/input-provider/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/label-provider/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/languages/esm/languages-core.js

const LanguagesCore = (props) => {
    const { Anchor, List, ListItem } = props.components;
    function renderLanguage(language, index) {
        return (external_react_.createElement(ListItem, { key: index, className: "text-small" },
            external_react_.createElement(Anchor, Object.assign({ isTextColor: true, isUnderlined: false }, language, { className: "text-weight-normal" }), language.label)));
    }
    return (external_react_.createElement(List, { type: "unstyled", direction: "inline", bordered: true, className: props.className }, props.languages.map((language, key) => renderLanguage(language, key))));
};
/* harmony default export */ const languages_core = (LanguagesCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/languages/esm/languages.js




const Languages = (props) => {
    return (external_react_.createElement(languages_core, Object.assign({}, props, { components: {
            Anchor: anchor_esm_anchor,
            List: List,
            ListItem: ListItem,
        } })));
};
/* harmony default export */ const languages = (Languages);

;// CONCATENATED MODULE: ./node_modules/@core-front/languages/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/list/esm/index.js




;// CONCATENATED MODULE: ./node_modules/@core-front/logo/esm/logo-core.js

const LogoCore = (props) => {
    const { className, components: { Anchor }, onClick, size, text, url, } = props;
    const BEM = () => {
        const classArray = ['logo'];
        if (size) {
            classArray.push(`logo--${size}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, url ? (external_react_.createElement(Anchor, { url: url, className: "logo__img", onClick: onClick },
        external_react_.createElement("span", { className: "logo__text" }, text))) : (external_react_.createElement("span", { className: "logo__img" },
        external_react_.createElement("span", { className: "logo__text" }, text)))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/logo/esm/logo.js



const Logo = (props) => {
    return (external_react_.createElement(LogoCore, Object.assign({}, props, { components: {
            Anchor: anchor_esm_anchor,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/logo/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/main/main-core.js

const MainCore = (props) => {
    const { children, className, components: { InputProvider, CookieConsentProvider, HeaderProvider, }, consent, consentEnabled, consentContent, } = props;
    const BEM = () => {
        const classArray = ['main'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(CookieConsentProvider, { consent: consent, enabled: consentEnabled, content: consentContent },
        external_react_.createElement(InputProvider, null,
            external_react_.createElement(HeaderProvider, null,
                external_react_.createElement("div", { className: BEM() },
                    external_react_.createElement("div", { className: "main__inner" }, children))))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/main/main.js





const Main = (props) => {
    return (external_react_.createElement(MainCore, Object.assign({}, props, { components: {
            InputProvider: input_provider/* default */.Z,
            CookieConsentProvider: cookie_consent_provider/* default */.Z,
            HeaderProvider: HeaderProvider,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/main-page/main-page.js

const MainContext = external_react_.createContext({
    hasMainPageComponent: false,
});
const MainPage = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['main__page'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("main", { className: BEM(), id: "main-content", tabIndex: -1 },
        external_react_.createElement(MainContext.Provider, { value: { hasMainPageComponent: true } }, children)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/main-content/main-content.js


const MainContent = (props) => {
    const { hasMainPageComponent } = external_react_.useContext(MainContext);
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['main__content'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    if (hasMainPageComponent) {
        return (external_react_.createElement("div", { className: BEM() }, children));
    }
    return (external_react_.createElement("main", { className: BEM(), id: "main-content", tabIndex: -1 }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/main-footer/main-footer.js

const MainFooter = (props) => {
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['main__footer'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/main-header/main-header.js


const MainHeader = (props) => {
    const { headerHeight } = external_react_.useContext(HeaderContext);
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['main__header'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getStyle = () => {
        return {
            paddingTop: headerHeight,
        };
    };
    return (external_react_.createElement("div", { className: BEM(), style: headerHeight ? getStyle() : undefined }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/main/esm/index.js







;// CONCATENATED MODULE: ./node_modules/@core-front/textfield/esm/textfield-core.js



const TextFieldCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "TextField", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange", isComponentDisabled: props.isDisabled || props.isReadOnly },
        external_react_.createElement(props_checker, { componentName: "TextField", componentProps: props, defaultValueName: "defaultIsFocused", valueName: "isFocused", onChangeNames: ['onFocus', 'onBlur'] },
            external_react_.createElement(analytics_trigger/* default */.Z, { trigger: [
                    {
                        callback: 'onFocus',
                        id: `Field - Focus - ${props.id}`,
                        elementId: `${props.id}`,
                        elementType: 'field',
                        interactionType: 'focus',
                    },
                    {
                        callback: 'onManualChange',
                        id: `Field - Filled - ${props.id}`,
                        elementId: `${props.id}`,
                        elementType: 'field',
                        interactionType: 'fill',
                    },
                    {
                        callback: 'onClear',
                        id: `Field - Clear - ${props.id}`,
                        elementId: `${props.id}`,
                        elementType: 'field',
                        interactionType: 'clear',
                    },
                ] },
                external_react_.createElement(TextFieldCoreInner, Object.assign({}, props))))));
};
/* harmony default export */ const textfield_core = (TextFieldCore);
class TextFieldCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.focusedLabelTimeout = 0;
        this.input = null;
        this.clearButton = null;
        this.onChange = (event) => {
            const value = event.currentTarget.value;
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            /* istanbul ignore else */
            if (this.props.onManualChange && !this.state.isChanged) {
                this.props.onManualChange();
            }
            this.setState({
                isChanged: true,
            });
        };
        this.onFocus = () => {
            const done = () => {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            };
            if (this.props.isReadOnly || this.props.isStatic) {
                return done();
            }
            if (typeof this.props.isFocused === 'undefined') {
                this.setState({
                    isFocused: true,
                });
            }
            this.setState({
                isFocusedLabel: true,
            });
            done();
        };
        this.onBlur = (event) => {
            const clickedOnCloseButton = event && this.clearButton && event.relatedTarget instanceof Element && this.clearButton.contains(event.relatedTarget);
            if (clickedOnCloseButton) {
                return;
            }
            if (typeof this.props.isFocused === 'undefined') {
                this.setState({
                    isFocused: false,
                });
            }
            window.clearTimeout(this.focusedLabelTimeout);
            this.focusedLabelTimeout = window.setTimeout(() => this.setState({
                isFocusedLabel: false,
            }), 100);
            if (this.props.onBlur) {
                this.props.onBlur(event);
            }
        };
        this.clear = (event) => {
            event.preventDefault();
            const value = '';
            const prevValue = this.value;
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            if (this.props.onClear) {
                this.props.onClear(event);
            }
            /* istanbul ignore else */
            if (this.input && prevValue) {
                this.input.focus();
            }
        };
        this.setInputRef = (element) => {
            this.input = element;
            if (element && this.props.inputRef) {
                this.props.inputRef(element);
            }
        };
        this.state = {
            isFocused: props.defaultIsFocused || false,
            isFocusedLabel: false,
            value: props.defaultValue || '',
            isChanged: false,
        };
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusedLabelTimeout);
    }
    get value() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
        }
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    get isFocused() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.isFocused !== 'undefined' ? this.props.isFocused : this.state.isFocused;
        }
        return this.props.onBlur && this.props.onFocus && typeof this.props.isFocused !== 'undefined' ? this.props.isFocused : this.state.isFocused;
    }
    get isInvalid() {
        return this.props.isInvalid || !!this.props.helper && this.props.helper.type === 'error';
    }
    BEM() {
        const classArray = ['textfield'];
        if (this.value) {
            classArray.push('is-dirty');
        }
        if (this.props.isDisabled) {
            classArray.push('is-disabled');
        }
        if (this.props.isInvalid) {
            classArray.push('is-invalid');
        }
        if (!this.props.isStatic) {
            classArray.push('textfield--floating-label');
        }
        else {
            classArray.push('is-static');
        }
        if (this.isFocused) {
            classArray.push('is-focused');
        }
        if (this.props.size) {
            classArray.push('textfield--' + this.props.size);
        }
        if (this.props.align) {
            classArray.push('textfield--' + this.props.align);
        }
        if (this.props.hideLabel) {
            classArray.push('textfield--no-label-' + this.props.hideLabel);
        }
        if (this.props.icon || this.props.isClearable) {
            classArray.push('textfield--with-icon');
        }
        if (this.props.employee) {
            classArray.push('textfield--employee');
        }
        if (this.shouldRenderImage(this.props.image)) {
            classArray.push('textfield--image');
        }
        if (this.props.placeholderLabel && this.props.hideLabel !== 'no-break') {
            classArray.push('textfield--no-label-no-break');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    inputBEM() {
        const classArray = ['textfield__input'];
        if (this.props.inputClass) {
            classArray.push(this.props.inputClass);
        }
        return classArray.join(' ');
    }
    renderFormHelper(helper) {
        const { FormHelper } = this.props.components;
        return (external_react_.createElement(FormHelper, Object.assign({}, helper, { className: "textfield__form-helper", id: helper.id || `${this.props.id}-helper` })));
    }
    getIcon() {
        const { Icon } = this.props.components;
        if (this.props.icon) {
            return external_react_.createElement(Icon, { modifiers: this.props.icon, className: "textfield__icon" });
        }
        else {
            return null;
        }
    }
    getLabel() {
        if (this.state.isFocusedLabel) {
            return this.props.focusLabel ? this.props.focusLabel : this.props.label;
        }
        return this.props.label;
    }
    getContent() {
        if (this.props.contentRenderer) {
            return this.props.contentRenderer();
        }
        return null;
    }
    getClearButton() {
        const { ClearButton } = this.props.components;
        if (this.value && this.value.length > 0 || this.props.isClearable === 'always') {
            return (external_react_.createElement(ClearButton, { className: "textfield__clear-btn", onClick: this.clear, label: this.props.clearButtonLabel, buttonRef: (el) => this.clearButton = el }));
        }
        return null;
    }
    shouldRenderImage(image) {
        return !!image && (this.value !== '');
    }
    getPlaceholder() {
        if (this.props.placeholderLabel) {
            return this.props.label;
        }
    }
    getAriaDescribedBy() {
        const arr = [];
        if (this.props['aria-describedby']) {
            arr.push(this.props['aria-describedby']);
        }
        if (this.props.helper) {
            arr.push((this.props.helper.id || `${this.props.id}-helper`));
        }
        return arr.join(' ');
    }
    render() {
        const InputElement = this.props.isTextarea ? 'textarea' : 'input';
        const { Image } = this.props.components;
        return (external_react_.createElement("div", { className: this.BEM() },
            external_react_.createElement("div", Object.assign({ className: "textfield__inner" }, this.props.innerAttributes),
                this.getIcon(),
                this.shouldRenderImage(this.props.image) && external_react_.createElement(Image, Object.assign({}, this.props.image, { className: "textfield__image" })),
                external_react_.createElement("label", { className: "textfield__label", htmlFor: this.props.id, id: `${this.props.id}-label` },
                    external_react_.createElement("span", { className: "textfield__label-text" }, this.getLabel())),
                external_react_.createElement(InputElement, Object.assign({}, this.props.input, { id: this.props.id, readOnly: this.props.isReadOnly || this.props.isStatic, className: this.inputBEM(), onChange: this.onChange, onFocus: this.onFocus, onBlur: (event) => this.onBlur(event), onKeyDown: this.props.onKeyDown, value: this.value, disabled: this.props.isDisabled, placeholder: this.getPlaceholder(), ref: this.setInputRef, style: this.props.inputStyle, type: !this.props.isTextarea ? this.props.type : undefined, "aria-invalid": this.isInvalid, "aria-describedby": this.getAriaDescribedBy() })),
                this.getContent(),
                this.props.isClearable && this.getClearButton()),
            !!this.props.helper && this.renderFormHelper(this.props.helper)));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/textfield/esm/textfield.js






class TextField extends external_react_.Component {
    render() {
        return (external_react_.createElement(textfield_core, Object.assign({}, this.props, { components: {
                ClearButton: ClearButton,
                FormHelper: FormHelper,
                Icon: icon/* default */.Z,
                Image: esm_image/* default */.Z,
            } })));
    }
}
TextField.defaultProps = {
    id: 'id-0',
    type: 'text',
};

;// CONCATENATED MODULE: ./node_modules/@core-front/mini-form/esm/mini-form-core.js

function mini_form_core_BEM(props) {
    const classArray = ['mini-form'];
    if (props.field.hideLabel) {
        classArray.push('mini-form--no-label-' + props.field.hideLabel);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const MiniFormCore = (props) => {
    const { onSubmit, field, button } = props;
    const { Button, TextField } = props.components;
    return (external_react_.createElement("form", { className: mini_form_core_BEM(props), onSubmit: onSubmit },
        external_react_.createElement(TextField, Object.assign({}, field, { className: "mini-form__field", inputClass: "mini-form__input" })),
        external_react_.createElement(Button, Object.assign({}, button, { className: "mini-form__button", size: "small", attributes: {
                type: 'submit',
            } }))));
};
/* harmony default export */ const mini_form_core = (MiniFormCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/mini-form/esm/mini-form.js




const MiniForm = (props) => {
    return (external_react_.createElement(mini_form_core, Object.assign({}, props, { components: {
            Button: button_Button,
            TextField: TextField,
        } })));
};
/* harmony default export */ const mini_form = (MiniForm);

;// CONCATENATED MODULE: ./node_modules/@core-front/mini-form/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/skip-links/esm/skip-links-core.js
var skip_links_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const SkipLinksCore = (props) => {
    const { Anchor, Container, List, ListItem } = props.components;
    const renderItems = (links) => {
        return links.map((link, key) => {
            const { label } = link, rest = skip_links_core_rest(link, ["label"]);
            return (external_react_.createElement(ListItem, { key: key },
                external_react_.createElement(Anchor, Object.assign({}, rest, { isTextColor: true, isUnderlined: false, className: "skip-links__anchor", attributes: {
                        onFocus: props.setHeaderHeight,
                        onBlur: props.setHeaderHeight,
                    } }), label)));
        });
    };
    return (external_react_.createElement("div", { className: "skip-links" },
        external_react_.createElement(Container, null,
            external_react_.createElement(List, { bordered: true, direction: "inline", type: "unstyled", className: "skip-links__list" }, renderItems(props.links)))));
};
/* harmony default export */ const skip_links_core = (SkipLinksCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/skip-links/esm/skip-links.js





const SkipLinks = (props) => {
    return (external_react_.createElement(skip_links_core, Object.assign({}, props, { components: {
            Anchor: anchor_esm_anchor,
            Container: Container,
            List: List,
            ListItem: ListItem,
        } })));
};
/* harmony default export */ const skip_links = (SkipLinks);

;// CONCATENATED MODULE: ./node_modules/@core-front/mini-header/esm/mini-header-core.js



const MiniHeaderCore = (props) => {
    const { Languages, Logo, Container, SkipLinks } = props.components;
    const { languages, logo, className } = props;
    const headerContext = external_react_.useContext(HeaderContext);
    const element = external_react_.createRef();
    const debouncedResizeHandler = (0,debounce.debounce)(setHeaderHeight, 100);
    external_react_.useEffect(() => {
        setHeaderHeight();
        window.addEventListener('resize', debouncedResizeHandler);
        return () => {
            window.removeEventListener('resize', debouncedResizeHandler);
            debouncedResizeHandler.clear();
        };
    });
    function BEM() {
        const classArray = ['mini-header'];
        if (!props.logo && props.languages) {
            classArray.push('mini-header--no-logo');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    function setHeaderHeight() {
        if (element.current) {
            headerContext.setHeaderHeight(element.current.clientHeight);
        }
    }
    return (external_react_.createElement("header", { className: BEM(), ref: element },
        props.skipLinks && props.skipLinks.length > 0 && external_react_.createElement(SkipLinks, { links: props.skipLinks }),
        (logo || languages) && (external_react_.createElement(Container, { className: "mini-header__inner" },
            logo && external_react_.createElement(Logo, Object.assign({ size: "small" }, logo)),
            languages && external_react_.createElement(Languages, { languages: languages })))));
};
/* harmony default export */ const mini_header_core = (MiniHeaderCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/mini-header/esm/mini-header.js






const MiniHeader = (props) => {
    return (external_react_.createElement(mini_header_core, Object.assign({}, props, { components: {
            Container: Container,
            Languages: languages,
            Logo: Logo,
            SkipLinks: skip_links,
        } })));
};
/* harmony default export */ const mini_header = (MiniHeader);

;// CONCATENATED MODULE: ./node_modules/@core-front/mini-header/esm/index.js



// EXTERNAL MODULE: ./node_modules/@core-front/object-fit/esm/object-fit.js
var object_fit = __webpack_require__(5936);
;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-cover/modal-cover-core.js

const ModalCoverCore = (props) => {
    const BEM = () => {
        const classArray = ['modal__cover'];
        if (props.fillImage) {
            classArray.push('modal__cover--fill');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const CSS = () => {
        let styleEntities = {};
        if (props.minHeight) {
            styleEntities = {
                minHeight: `${props.minHeight}px`,
            };
        }
        styleEntities.backgroundColor = props.backgroundColor;
        return styleEntities;
    };
    const iconCSS = () => {
        let styleEntities = {};
        if (props.iconMaxWidth) {
            styleEntities = {
                maxWidth: `${props.iconMaxWidth}px`,
            };
        }
        styleEntities.color = props.iconColor;
        return styleEntities;
    };
    const getIcon = (icon) => {
        const { Icon } = props.components;
        return (external_react_.createElement(Icon, Object.assign({}, icon, { className: "modal__cover-icon", style: iconCSS() })));
    };
    const getImage = (image) => {
        const { Image, ObjectFit } = props.components;
        if (props.fillImage) {
            return (external_react_.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center" },
                external_react_.createElement(Image, Object.assign({ className: "modal__cover-image" }, image))));
        }
        return (external_react_.createElement(Image, Object.assign({ className: "modal__cover-image" }, image)));
    };
    return (external_react_.createElement("div", { className: BEM(), style: CSS() },
        props.icon && getIcon(props.icon),
        props.image && getImage(props.image)));
};
/* harmony default export */ const modal_cover_core = (ModalCoverCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-cover/modal-cover.js





const ModalCover = (props) => (external_react_.createElement(modal_cover_core, Object.assign({}, props, { components: {
        Icon: icon/* default */.Z,
        Image: esm_image/* default */.Z,
        ObjectFit: object_fit/* default */.Z,
    } })));


// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(8539);
;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-content/modal-content.js

const ModalContent = (props) => {
    const { children, className } = props;
    const BEM = () => {
        const classArray = ['modal__body'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, children));
};
/* harmony default export */ const modal_content = (ModalContent);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-footer/modal-footer.js

const ModalFooter = (props) => {
    const { children, isSticky, className } = props;
    const BEM = () => {
        const classArray = ['modal__footer'];
        if (isSticky) {
            classArray.push('modal__footer--sticky');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, children));
};
/* harmony default export */ const modal_footer = (ModalFooter);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-provider/modal-provider-core.js


const ModalContext = external_react_.createContext({
    isClosable: true,
    isOpen: false,
    open: /* istanbul ignore next */ () => null,
    close: () => null,
    triggerRef: /* istanbul ignore next */ () => null,
});
const ModalProviderCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "ModalProvider", componentProps: props, defaultValueName: "defaultIsOpen", valueName: "isOpen", onChangeNames: "onToggle", onChangeAltNames: ['onOpen', 'onClose'] },
        external_react_.createElement(ModalProviderCoreInner, Object.assign({}, props))));
};
/* harmony default export */ const modal_provider_core = (ModalProviderCore);
class ModalProviderCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.openModal = () => {
            if (typeof this.props.isOpen === 'undefined') {
                this.setState({
                    isOpen: true,
                });
            }
            if (this.props.onToggle) {
                this.props.onToggle(true);
            }
            if (this.props.onOpen) {
                this.props.onOpen();
            }
        };
        this.closeModal = (event, childOnClick) => {
            if (typeof this.props.isOpen === 'undefined') {
                this.setState({
                    isOpen: false,
                });
            }
            if (this.props.onToggle) {
                this.props.onToggle(false);
            }
            if (this.props.onClose) {
                this.props.onClose();
            }
            if (childOnClick) {
                childOnClick(event);
            }
            setTimeout(() => {
                var _a;
                (_a = this.state.trigger) === null || _a === void 0 ? void 0 : _a.focus();
            }, 200);
        };
        this.setTrigger = (trigger) => {
            this.setState({
                trigger,
            });
        };
        this.state = {
            isOpen: this.props.defaultIsOpen || false,
            trigger: null,
        };
    }
    get isOpen() {
        return (this.props.onToggle || (this.props.onOpen && this.props.onClose)) && typeof this.props.isOpen !== 'undefined'
            ? this.props.isOpen
            : this.state.isOpen;
    }
    renderContent() {
        const { HashTrigger } = this.props.components;
        return this.props.id ? (external_react_.createElement(HashTrigger, { id: this.props.id, onMatch: this.openModal, scrollOnMatch: false, renderWrapper: false }, this.props.children)) : (external_react_.createElement(external_react_.Fragment, null, this.props.children));
    }
    render() {
        const modalContextValue = {
            close: this.closeModal,
            id: this.props.id,
            isClosable: this.props.isClosable,
            isOpen: this.isOpen,
            open: this.openModal,
            triggerRef: this.setTrigger,
        };
        return (external_react_.createElement(ModalContext.Provider, { value: modalContextValue }, this.renderContent()));
    }
}
ModalProviderCoreInner.defaultProps = {
    isClosable: true,
};

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal/modal-core.js
var modal_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};










const ModalCore = (props) => {
    const labels = useLabels();
    const context = external_react_.useContext(ModalContext);
    const { responsive } = props, rest = modal_core_rest(props, ["responsive"]);
    return responsive ? (external_react_.createElement(ModalResponsiveCore, Object.assign({}, rest, { responsive: responsive, labels: labels, context: context }))) : (external_react_.createElement(ModalInnerCore, Object.assign({}, rest, { labels: labels, context: context })));
};
const ModalResponsiveCore = (props) => {
    const { responsive } = props, rest = modal_core_rest(props, ["responsive"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsiveProps = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive });
    return external_react_.createElement(ModalInnerCore, Object.assign({}, rest, responsiveProps));
};
const ModalInnerCore = (props) => {
    const { isClosable = true, isOpen, initialFocusedElementId, onClose, size, verticalAlign, className, sidebar, isFullHeight, isFullScreen, children, headerType, closeButtonLabel, components: { Icon }, labels, asideContent, hasContentComponent, } = props;
    const context = external_react_.useContext(ModalContext);
    let modal = null;
    const [disablePageInteraction, setDisablePageInteraction] = external_react_.useState(false);
    const isMounted = (0,use_is_mounted/* useIsMounted */.t)();
    const isModalOpen = external_react_.useCallback(() => {
        return typeof isOpen !== 'undefined' ? isOpen : context.isOpen;
    }, [context.isOpen, isOpen]);
    const hijackScrollAndPageAccess = external_react_.useCallback(() => {
        if (!disablePageInteraction) {
            setDisablePageInteraction(true);
        }
    }, [disablePageInteraction]);
    external_react_.useEffect(() => {
        if (disablePageInteraction && modal) {
            if (initialFocusedElementId) {
                const initialFocusedElement = modal.querySelector(`#${initialFocusedElementId}`);
                if (initialFocusedElement) {
                    initialFocusedElement.focus();
                    return;
                }
            }
            const firstTabbableElement = (0,index_esm/* tabbable */.ht)(modal)[0];
            if (firstTabbableElement) {
                firstTabbableElement.focus();
                return;
            }
            modal.focus();
        }
    }, [disablePageInteraction, initialFocusedElementId, modal]);
    const close = (event) => {
        event.preventDefault();
        if (onClose) {
            onClose(event);
        }
        context.close(event);
    };
    external_react_.useEffect(() => {
        if (isMounted && isModalOpen()) {
            hijackScrollAndPageAccess();
        }
    }, [hijackScrollAndPageAccess, isModalOpen, isMounted, disablePageInteraction]);
    const onKeyDown = (event) => {
        switch (event.key) {
            // Invoke onClose when user hits ESC key.
            case 'Escape':
            case 'Esc':
                close(event);
                break;
            case 'Tab':
                /* istanbul ignore else */
                if (modal) {
                    const tabbableModalElements = (0,index_esm/* tabbable */.ht)(modal);
                    if (tabbableModalElements.length) {
                        const firstTabbableElement = tabbableModalElements[0];
                        const lastTabbableElement = tabbableModalElements[tabbableModalElements.length - 1];
                        if (event.shiftKey) {
                            if (document.activeElement === firstTabbableElement) {
                                event.preventDefault();
                                lastTabbableElement.focus();
                            }
                        }
                        else {
                            if (document.activeElement === lastTabbableElement) {
                                event.preventDefault();
                                firstTabbableElement.focus();
                            }
                        }
                    }
                    else {
                        event.preventDefault();
                    }
                }
        }
    };
    const onClickBackdrop = (event) => {
        if (event.target === event.currentTarget) {
            close(event);
        }
    };
    const onEntering = () => {
        hijackScrollAndPageAccess();
    };
    const onExited = () => {
        if (disablePageInteraction) {
            setDisablePageInteraction(false);
        }
    };
    const BEM = (state) => {
        const classArray = ['modal', `is-${state}`];
        const modalSize = size ? size : sidebar ? '4-col' : undefined;
        if (size || sidebar) {
            classArray.push(`modal--${modalSize}`);
        }
        if (verticalAlign) {
            classArray.push(`modal--vertical-align-${verticalAlign}`);
        }
        if (isFullHeight) {
            classArray.push('modal--full-height');
        }
        if (isFullScreen) {
            classArray.push('modal--full-screen');
        }
        if (className) {
            classArray.push(className);
        }
        if (sidebar) {
            classArray.push(`modal--with-sidebar-${sidebar === true ? 'right' : sidebar}`);
        }
        return classArray.join(' ');
    };
    const renderHeaderOrFooter = (type) => {
        let element = null;
        external_react_.Children.forEach(children, (child) => {
            if (external_react_.isValidElement(child) && child.type === type) {
                element = child;
            }
        });
        return element;
    };
    const renderBody = () => {
        const bodyChildren = external_react_.Children.toArray(children).filter((child) => {
            return external_react_.isValidElement(child) && child.type !== headerType && child.type !== modal_footer;
        });
        return (external_react_.createElement(modal_content, null, bodyChildren));
    };
    const shouldBeClosable = () => {
        return !!(isClosable && context.isClosable);
    };
    const isBackdropCloseEnabled = () => {
        return shouldBeClosable() && isClosable !== 'close-button' && context.isClosable !== 'close-button';
    };
    const renderCloseButton = () => {
        const { isClosable, } = props;
        if (isClosable !== 'backdrop') {
            return (external_react_.createElement("div", { className: "modal__close-wrapper" },
                external_react_.createElement("button", { className: "modal__close", onClick: close, type: "button" },
                    external_react_.createElement(Icon, { modifiers: "#close-round", className: "modal__close-icon" }),
                    external_react_.createElement("span", { className: "sr-only" }, closeButtonLabel || labels.get('close')))));
        }
    };
    const renderModal = () => {
        const content = (state) => {
            return (external_react_.createElement("div", { className: BEM(state), id: context.id, onKeyDown: onKeyDown, tabIndex: -1, ref: (element) => modal = element, role: "dialog", "aria-modal": true, "aria-labelledby": props['aria-labelledby'], "aria-describedby": props['aria-describedby'] },
                external_react_.createElement("div", { className: "modal__backdrop", onClick: isBackdropCloseEnabled() ? onClickBackdrop : undefined }),
                external_react_.createElement("div", { className: "modal__inner" },
                    external_react_.createElement("div", { className: "modal__box" },
                        asideContent,
                        external_react_.createElement("div", { className: "modal__box-inner" },
                            shouldBeClosable() && renderCloseButton(),
                            !hasContentComponent && renderHeaderOrFooter(headerType),
                            !hasContentComponent && renderBody(),
                            !hasContentComponent && renderHeaderOrFooter(modal_footer),
                            hasContentComponent && children)))));
        };
        const { BodyScroll, VisibilityProvider, PageAccess } = props.components;
        return (external_react_.createElement(VisibilityProvider, { isVisible: isModalOpen() },
            external_react_.createElement(PageAccess, { isInert: disablePageInteraction },
                external_react_.createElement(BodyScroll, { isDisabled: disablePageInteraction },
                    external_react_.createElement(esm_Transition/* default */.ZP, { in: isModalOpen(), timeout: { enter: 300, exit: 300 }, mountOnEnter: true, unmountOnExit: true, onEntering: onEntering, onExited: onExited }, content)))));
    };
    return isMounted
        ? external_react_dom_.createPortal(renderModal(), document.body)
        : renderModal();
};


;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal/modal.js
var modal_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const Modal = (props) => {
    const { cover, className } = props, rest = modal_rest(props, ["cover", "className"]);
    const BEM = () => {
        const classArray = [];
        if (cover) {
            classArray.push('modal--cover');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const renderCover = (cover) => {
        if (!cover) {
            return;
        }
        return (external_react_.createElement(ModalCover, Object.assign({}, cover)));
    };
    return (external_react_.createElement(ModalCore, Object.assign({}, props, rest, { asideContent: renderCover(cover), className: BEM(), components: {
            BodyScroll: body_scroll,
            Icon: icon/* default */.Z,
            PageAccess: page_access,
            VisibilityProvider: VisibilityProvider,
        } })));
};
/* harmony default export */ const modal = (Modal);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-provider/modal-provider.js



const ModalProvider = (props) => {
    return (external_react_.createElement(modal_provider_core, Object.assign({}, props, { components: {
            HashTrigger: HashTrigger,
        } })));
};
/* harmony default export */ const modal_provider = (ModalProvider);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-closer/modal-closer.js


const ModalCloser = (props) => {
    const { children } = props;
    const { close } = external_react_.useContext(ModalContext);
    return (external_react_.createElement(external_react_.Fragment, null, external_react_.Children.map(children, (child) => {
        if (!external_react_.isValidElement(child)) {
            return child;
        }
        return external_react_.cloneElement(child, {
            onClick: (event) => {
                event.preventDefault();
                close(event, child.props.onClick);
            },
        });
    })));
};
/* harmony default export */ const modal_closer = (ModalCloser);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/modal-trigger/modal-trigger.js


const ModalTrigger = (props) => {
    const { children } = props;
    const { id = '', triggerRef, open } = external_react_.useContext(ModalContext);
    return (external_react_.createElement(external_react_.Fragment, null, external_react_.Children.map(children, (child) => {
        if (!external_react_.isValidElement(child)) {
            return child;
        }
        return external_react_.cloneElement(child, {
            buttonRef: triggerRef,
            elementRef: triggerRef,
            onClick: (event) => {
                event.preventDefault();
                open();
                if (child.props.onClick) {
                    child.props.onClick(event);
                }
            },
            url: `#${id}`,
        });
    })));
};
/* harmony default export */ const modal_trigger = (ModalTrigger);

;// CONCATENATED MODULE: ./node_modules/@core-front/modal/esm/index.js











;// CONCATENATED MODULE: ./node_modules/@core-front/notice/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/number/esm/number-core.js



const NumberCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "Number", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange", isComponentDisabled: props.disabled || !!(props.input && props.input.disabled) },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: [
                {
                    callback: 'onIncrease',
                    id: `Number - Increase - ${props.id}`,
                    elementId: props.id,
                    elementType: 'number',
                    interactionType: 'increase',
                },
                {
                    callback: 'onDecrease',
                    id: `Number - Decrease - ${props.id}`,
                    elementId: props.id,
                    elementType: 'number',
                    interactionType: 'decrease',
                },
                {
                    callback: 'onManualChange',
                    id: `Number - Filled - ${props.id}`,
                    elementId: props.id,
                    elementType: 'number',
                    interactionType: 'fill',
                },
            ] },
            external_react_.createElement(NumberCoreInner, Object.assign({}, props)))));
};
const NumberCoreInner = (props) => {
    const { max = 999, min = 0, step = 1, variant = 'secondary', defaultValue = 0, value, isInvalid, disabled, size, align, hideLabel, className, id, label, decreaseButtonText, increaseButtonText, input, name, helper, } = props;
    const { Button, FormHelper } = props.components;
    const [innerValue, setInnerValue] = external_react_.useState(defaultValue);
    const currentValue = isValueControlled(value) ? value : innerValue;
    const isDisabled = disabled || !!(input && input.disabled);
    const isAriaInvalid = isInvalid || !!helper && helper.type === 'error';
    function isValueControlled(outerValue = value) {
        return !!props.onChange && typeof outerValue !== 'undefined';
    }
    function onDecrease(event) {
        event.preventDefault();
        setValue(currentValue - step, 'decrease');
    }
    function onIncrease(event) {
        event.preventDefault();
        setValue(currentValue + step, 'increase');
    }
    function onChange(event) {
        const newValue = Number(event.currentTarget.value);
        if (props.onManualChange) {
            props.onManualChange();
        }
        setValue(newValue, 'manual');
    }
    function setValue(newValue, change) {
        let actualNewValue = newValue;
        // if the value is not an integer,
        if (!(newValue % 1 === 0)) {
            // if step is defined and not an integer (= floating)
            if (step && !Number.isInteger(step)) {
                if (change !== 'manual') {
                    actualNewValue = parseFloat(newValue.toFixed(10));
                }
            }
            else {
                // set the value to the minimum value
                actualNewValue = min;
            }
        }
        // if the value is smaller than minimum value,
        // reset the value to the minimum value
        if (newValue < min) {
            actualNewValue = min;
        }
        // if the value is greater than maximum value,
        // reset the value to the maximum value
        if (newValue > max) {
            actualNewValue = max;
        }
        if (!isValueControlled()) {
            setInnerValue(actualNewValue);
        }
        if (props.onChange) {
            props.onChange(actualNewValue);
        }
        if (props.onDecrease && change === 'decrease') {
            props.onDecrease(actualNewValue);
        }
        if (props.onIncrease && change === 'increase') {
            props.onIncrease(actualNewValue);
        }
    }
    function BEM() {
        const classArray = ['number'];
        if (disabled) {
            classArray.push('is-disabled');
        }
        if (isInvalid) {
            classArray.push('is-invalid');
        }
        if (hideLabel) {
            classArray.push('number--hide-label');
        }
        if (size) {
            classArray.push('number--' + size);
        }
        if (align) {
            classArray.push('number--align-' + align);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (external_react_.createElement("div", { className: BEM() },
        external_react_.createElement("label", { htmlFor: id, className: "number__label" }, label),
        external_react_.createElement("div", { className: "number__inner" },
            external_react_.createElement(Button, { disabled: isDisabled || currentValue === min, onClick: onDecrease, variant: variant, icon: "#minus", size: "small", text: decreaseButtonText }),
            external_react_.createElement("input", Object.assign({}, input, { className: "number__input", type: "number", id: id, name: name, value: currentValue, disabled: isDisabled, onChange: onChange, "aria-invalid": isAriaInvalid, "aria-describedby": helper ? (helper.id || `${id}-helper`) : undefined })),
            external_react_.createElement(Button, { disabled: isDisabled || currentValue === max, onClick: onIncrease, variant: variant, icon: "#plus", size: "small", text: increaseButtonText })),
        helper && (external_react_.createElement(FormHelper, Object.assign({}, helper, { className: "number__form-helper", id: helper.id || `${id}-helper` })))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/number/esm/number.js




const number_Number = (props) => {
    return (external_react_.createElement(NumberCore, Object.assign({}, props, { components: {
            Button: button_Button,
            FormHelper: FormHelper,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/number/esm/index.js



// EXTERNAL MODULE: ./node_modules/@core-front/object-fit/esm/object-fit-core.js
var object_fit_core = __webpack_require__(1418);
;// CONCATENATED MODULE: ./node_modules/@core-front/object-fit/esm/index.js



// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-previous.js
var use_previous = __webpack_require__(8357);
;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/option-card/option-card-core.js




const ANIMATION_WAVE_DELAY = 100;
const ANIMATION_IN_DURATION = 300;
const ANIMATION_OUT_DURATION = 400;
const OptionCardCore = (props) => {
    const { background, borderRadius, className, checked, children, components, defaultChecked, disabled, elevation, id, index, input, inputType, isInvalid, labelText, padding, responsive, style, type, value = 'on', } = props;
    const [animationActive, setAnimationActive] = external_react_.useState(false);
    const [animationDirection, setAnimationDirection] = external_react_.useState('in');
    const [isCardChecked, setIsCardChecked] = external_react_.useState(defaultChecked || false);
    const [directionTimeout, setDirectionTimeout] = external_react_.useState(0);
    const onClick = () => onChange();
    const { Icon, Card } = components;
    const inputRef = external_react_.createRef();
    let waveTimeout = 0;
    const prevIsInvalid = (0,use_previous/* usePrevious */.D)(isInvalid);
    external_react_.useEffect(() => {
        if (!prevIsInvalid && isInvalid) {
            startWaveAnimation();
        }
        else if (prevIsInvalid && !isInvalid) {
            endAnimation();
            clearTimeouts();
        }
        return () => {
            clearTimeouts();
        };
    });
    const clearTimeouts = () => {
        if (directionTimeout) {
            window.clearTimeout(directionTimeout);
        }
        if (waveTimeout) {
            window.clearTimeout(waveTimeout);
        }
    };
    const onChange = () => {
        if (inputRef.current) {
            const isChecked = inputRef.current.checked;
            const nextChecked = inputType === 'radio' ? true : !isChecked;
            if (disabled || inputType === 'radio' && isChecked) {
                return;
            }
            if (typeof checked === 'undefined') {
                setIsCardChecked(nextChecked);
            }
            if (props.onChange) {
                props.onChange(nextChecked);
            }
        }
    };
    const isChecked = () => {
        return props.onChange && typeof checked !== 'undefined' ? checked : isCardChecked;
    };
    const BEM = () => {
        const classArray = ['option-card', `option-card--input-${inputType}`];
        if (background) {
            classArray.push('option-card--' + background);
        }
        if (type) {
            classArray.push('option-card--' + type);
        }
        if (className) {
            classArray.push(className);
        }
        if (isInvalid) {
            classArray.push('option-card--error');
        }
        if (animationActive) {
            classArray.push('is-animating');
        }
        if (animationDirection) {
            classArray.push('option-card--animate-' + animationDirection);
        }
        if (isChecked()) {
            classArray.push('is-checked');
        }
        return classArray.join(' ');
    };
    const startWaveAnimation = () => {
        if (isInvalid && typeof index !== 'undefined') {
            waveTimeout = window.setTimeout(() => {
                startAnimation();
            }, index * ANIMATION_WAVE_DELAY);
        }
    };
    const startAnimation = () => {
        setAnimationActive(true);
        setAnimationDirection('in');
        triggerFadeIn();
    };
    const endAnimation = () => {
        setAnimationActive(false);
        setAnimationDirection('idle');
    };
    const triggerFadeIn = () => {
        setDirectionTimeout(window.setTimeout(() => {
            setAnimationDirection('out');
            triggerFadeOut();
        }, ANIMATION_IN_DURATION));
    };
    const triggerFadeOut = () => {
        setDirectionTimeout(window.setTimeout(() => {
            endAnimation();
        }, ANIMATION_OUT_DURATION));
    };
    const renderIndicator = () => {
        if (!isCardChecked && disabled) {
            return;
        }
        return (external_react_.createElement("span", { className: "option-card__indicator" }, inputType === 'checkbox' && (external_react_.createElement(Icon, { modifiers: "#check", className: "option-card__indicator-icon" }))));
    };
    return (external_react_.createElement(props_checker, { componentName: "OptionCard", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: disabled },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: {
                callback: 'onClick',
                id: `Option - ${id}`,
                elementId: id,
                elementType: 'option',
            } },
            external_react_.createElement("div", { className: BEM(), onClick: onClick },
                external_react_.createElement("input", Object.assign({}, input, { value: value, type: inputType, ref: inputRef, onChange: onChange, checked: isChecked(), defaultChecked: undefined, disabled: disabled, id: id, className: "option-card__input", "aria-invalid": isInvalid })),
                external_react_.createElement("label", { htmlFor: id, className: "option-card__label" }, labelText),
                external_react_.createElement(Card, { className: "option-card__body", responsive: responsive, padding: padding, borderRadius: borderRadius, style: style, elevation: disabled ? undefined : elevation },
                    external_react_.createElement("div", { className: "option-card__elements" },
                        renderIndicator(),
                        children))))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/option-card/option-card.js




const OptionCard = (props) => {
    return (external_react_.createElement(OptionCardCore, Object.assign({}, props, { components: {
            Card: Card,
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/option-card-content/option-card-content-core.js

const OptionCardContentCore = (props) => {
    const { CardContent } = props.components;
    const BEM = () => {
        const classArray = ['option-card__content'];
        if (props.color) {
            classArray.push(`option-card__content--${props.color}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(CardContent, Object.assign({}, props, { className: BEM() }), props.children));
};
/* harmony default export */ const option_card_content_core = (OptionCardContentCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/option-card-content/option-card-content.js
var option_card_content_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const OptionCardContent = (props) => {
    const { children, tagTop = true } = props, rest = option_card_content_rest(props, ["children", "tagTop"]);
    return (external_react_.createElement(option_card_content_core, Object.assign({}, rest, { components: {
            CardContent: (props) => external_react_.createElement(CardContent, Object.assign({}, props, { tagTop: tagTop })),
        } }), children));
};
/* harmony default export */ const option_card_content = (OptionCardContent);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/option-card-footer/option-card-footer-core.js

const OptionCardFooterCore = (props) => {
    const { CardFooter } = props.components;
    return (external_react_.createElement(CardFooter, { className: "option-card__footer" }, props.children));
};
/* harmony default export */ const option_card_footer_core = (OptionCardFooterCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/option-card-footer/option-card-footer.js



const OptionCardFooter = (props) => (external_react_.createElement(option_card_footer_core, { components: {
        CardFooter: (props) => external_react_.createElement(CardFooter, Object.assign({}, props)),
    } }, props.children));
/* harmony default export */ const option_card_footer = (OptionCardFooter);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card/esm/index.js







;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old/esm/option-card-old/option-card-old-core.js



const option_card_old_core_ANIMATION_WAVE_DELAY = 100;
const option_card_old_core_ANIMATION_IN_DURATION = 300;
const option_card_old_core_ANIMATION_OUT_DURATION = 400;
const OptionCardOldCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "OptionCard", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onChange', id: `Option - ${props.id}` } },
            external_react_.createElement(OptionCardCoreInner, Object.assign({}, props)))));
};
class OptionCardCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.inputRef = external_react_.createRef();
        this.directionTimeout = 0;
        this.waveTimeout = 0;
        this.onChange = () => {
            if (this.inputRef.current) {
                const isChecked = this.inputRef.current.checked;
                const nextChecked = this.props.inputType === 'radio' ? true : !isChecked;
                if (this.props.disabled || this.props.inputType === 'radio' && isChecked) {
                    return;
                }
                if (typeof this.props.checked === 'undefined') {
                    this.setState({
                        checked: nextChecked,
                    });
                }
                if (this.props.onChange) {
                    this.props.onChange(nextChecked);
                }
            }
        };
        this.state = {
            animationActive: false,
            animationDirection: 'in',
            checked: props.defaultChecked || false,
        };
    }
    componentDidMount() {
        if (this.props.isInvalid && typeof this.props.index !== 'undefined') {
            this.startWaveAnimation();
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isInvalid && this.props.isInvalid) {
            this.startWaveAnimation();
        }
        else if (prevProps.isInvalid && !this.props.isInvalid) {
            this.endAnimation();
            this.clearTimeouts();
        }
    }
    componentWillUnmount() {
        this.clearTimeouts();
    }
    clearTimeouts() {
        if (this.directionTimeout) {
            window.clearTimeout(this.directionTimeout);
        }
        if (this.waveTimeout) {
            window.clearTimeout(this.waveTimeout);
        }
    }
    get isChecked() {
        return this.props.onChange && typeof this.props.checked !== 'undefined' ? this.props.checked : this.state.checked;
    }
    BEM() {
        const classArray = ['option-card-old', `option-card-old--input-${this.props.inputType}`];
        if (this.props.color) {
            classArray.push('option-card-old--' + this.props.color);
        }
        if (this.props.type) {
            classArray.push('option-card-old--' + this.props.type);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.badgeTop || this.props.type === 'recommended') {
            classArray.push('option-card-old--badge-top');
        }
        if (this.props.isInvalid) {
            classArray.push('option-card-old--error');
        }
        if (this.state.animationActive) {
            classArray.push('is-animating');
        }
        if (this.state.animationDirection) {
            classArray.push('option-card-old--animate-' + this.state.animationDirection);
        }
        return classArray.join(' ');
    }
    renderBadgeTop() {
        const isRecommendedType = this.props.type === 'recommended';
        const Badge = this.props.components.BadgeTop || this.props.components.Badge;
        if ((typeof this.props.badgeTop === 'boolean' || !this.props.badgeTop) && !isRecommendedType) {
            return;
        }
        let badgeProps = {
            icon: isRecommendedType ? '#star' : '',
            purpose: isRecommendedType && 'recommended' || undefined,
            text: this.props.recommendedLabel || undefined,
        };
        if (typeof this.props.badgeTop !== 'boolean' && this.props.badgeTop) {
            badgeProps = Object.assign(Object.assign({}, badgeProps), this.props.badgeTop);
        }
        return (external_react_.createElement("div", { className: "option-card-old__badge-top-wrapper" },
            external_react_.createElement(Badge, Object.assign({}, badgeProps))));
    }
    renderCheckedBadge() {
        const { Badge } = this.props.components;
        return (external_react_.createElement("div", { className: "option-card-old__checked-badge-wrapper" },
            external_react_.createElement("div", { className: "option-card-old__checked-badge-inner" },
                external_react_.createElement(Badge, { className: "option-card-old__checked-badge", icon: "#check", purpose: "selected", text: this.props.checkedLabel }))));
    }
    startWaveAnimation() {
        if (this.props.isInvalid && typeof this.props.index !== 'undefined') {
            this.waveTimeout = window.setTimeout(() => {
                this.startAnimation();
            }, this.props.index * option_card_old_core_ANIMATION_WAVE_DELAY);
        }
    }
    startAnimation() {
        this.setState({
            animationActive: true,
            animationDirection: 'in',
        }, () => {
            this.triggerFadeIn();
        });
    }
    endAnimation() {
        this.setState({
            animationActive: false,
            animationDirection: 'idle',
        });
    }
    triggerFadeIn() {
        this.directionTimeout = window.setTimeout(() => {
            this.setState({
                animationDirection: 'out',
            }, () => {
                this.triggerFadeOut();
            });
        }, option_card_old_core_ANIMATION_IN_DURATION);
    }
    triggerFadeOut() {
        this.directionTimeout = window.setTimeout(() => {
            this.endAnimation();
        }, option_card_old_core_ANIMATION_OUT_DURATION);
    }
    render() {
        const onClick = () => this.onChange();
        const { Icon } = this.props.components;
        return (external_react_.createElement("div", { className: this.BEM() },
            external_react_.createElement("input", Object.assign({}, this.props.input, { value: this.props.value, type: this.props.inputType, ref: this.inputRef, onChange: this.onChange, checked: this.isChecked, defaultChecked: undefined, disabled: this.props.disabled, id: this.props.id, className: "option-card-old__input", "aria-invalid": this.props.isInvalid })),
            external_react_.createElement("label", { htmlFor: this.props.id, className: "option-card-old__label" }, this.props.labelText),
            external_react_.createElement("div", { className: "option-card-old__body", onClick: onClick },
                this.props.tagTopContent && this.props.tagTopContent,
                this.renderBadgeTop(),
                external_react_.createElement("div", { className: "option-card-old__elements" },
                    this.props.showIndicator && (external_react_.createElement("span", { className: "option-card-old__indicator" }, this.props.inputType === 'checkbox' && (external_react_.createElement(Icon, { modifiers: "#check", className: "option-card-old__indicator-icon" })))),
                    this.props.children),
                this.renderCheckedBadge())));
    }
}
OptionCardCoreInner.defaultProps = {
    value: 'on',
};
/* harmony default export */ const option_card_old_core = (OptionCardOldCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old/esm/option-card-old/option-card-old.js




const OptionCardOld = (props) => {
    return (external_react_.createElement(option_card_old_core, Object.assign({}, props, { components: {
            Badge: badge_Badge,
            Icon: icon/* default */.Z,
        } })));
};
/* harmony default export */ const option_card_old = (OptionCardOld);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old/esm/option-card-old-content/option-card-old-content.js

class OptionCardOldContent extends external_react_.PureComponent {
    BEM() {
        const classArray = ['option-card-old__content'];
        if (this.props.color) {
            classArray.push(`option-card-old__content--${this.props.color}`);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (external_react_.createElement("div", { className: this.BEM() }, this.props.children));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old/esm/option-card-old-footer/option-card-old-footer.js

const OptionCardOldFooter = (props) => {
    return (external_react_.createElement("div", { className: "option-card-old__footer" }, props.children));
};
/* harmony default export */ const option_card_old_footer = (OptionCardOldFooter);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old/esm/index.js





;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-group/esm/option-card-group/option-card-group-core.js


const OptionCardGroupCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "OptionCardGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        external_react_.createElement(OptionCardGroupCoreInner, Object.assign({}, props))));
};
/* harmony default export */ const option_card_group_core = (OptionCardGroupCore);
class OptionCardGroupCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.onChange = (value, checked, onChange) => {
            let newValue = this.value;
            if (this.props.inputType === 'checkbox') {
                newValue = newValue || [];
                if (Array.isArray(newValue)) {
                    if (checked) {
                        newValue.push(value);
                    }
                    else {
                        newValue = newValue.filter((item) => item !== value);
                    }
                }
            }
            else {
                newValue = value;
            }
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value: newValue,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(newValue);
            }
            if (onChange) {
                onChange(checked);
            }
        };
        this.state = {
            value: props.defaultValue || null,
        };
    }
    get value() {
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    isChecked(value) {
        const currentValue = this.value;
        if (this.props.inputType === 'checkbox' && currentValue) {
            return value === currentValue || currentValue.indexOf(value) !== -1;
        }
        else {
            return value === currentValue;
        }
    }
    get isInvalid() {
        if (this.props.isHelperExternallyHandled) {
            return !!this.props.isInvalid;
        }
        else if (this.props.helper) {
            return this.props.helper.type === 'error';
        }
        return !!this.props.isInvalid;
    }
    get optionCardProps() {
        const { background, type } = this.props;
        return {
            background,
            type,
        };
    }
    getOptionInput(option) {
        if (this.props.inputType === 'radio') {
            return Object.assign(Object.assign({}, option.input), { name: this.props.name });
        }
        else {
            return Object.assign({}, option.input);
        }
    }
    renderOptionCard(child, key) {
        const props = child.props;
        const value = props.value || 'on';
        const onChange = (checked) => this.onChange(value, checked, props.onChange);
        const { OptionCard } = this.props.components;
        return (external_react_.createElement(OptionCard, Object.assign({}, this.optionCardProps, props, { checked: this.isChecked(value), index: key, input: this.getOptionInput(props), inputType: this.props.inputType, onChange: onChange, isInvalid: this.isInvalid })));
    }
    renderNotice() {
        const { components: { Notice }, helper, isHelperExternallyHandled } = this.props;
        if (isHelperExternallyHandled) {
            return (external_react_.createElement(Notice, { className: "text-bold", align: "center", size: "small", children: true }));
        }
        else if (helper) {
            return (external_react_.createElement(Notice, Object.assign({ className: "text-bold", align: "center", size: "small" }, helper), helper.children));
        }
    }
    getChildren() {
        const { GridColumn, OptionCard } = this.props.components;
        return external_react_.Children.toArray(this.props.children).filter((child) => {
            return external_react_.isValidElement(child);
        }).map((child, key) => {
            const isOptionCard = this.props.isOptionCard ? this.props.isOptionCard(child) : child && child.type === OptionCard;
            return (external_react_.createElement(GridColumn, Object.assign({}, this.props.gridColumn, { key: key }), isOptionCard ? this.renderOptionCard(child, key) : child));
        });
    }
    BEM() {
        var _a;
        const classArray = [];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if ((_a = this.props.grid) === null || _a === void 0 ? void 0 : _a.className) {
            classArray.push(this.props.grid.className);
        }
        return classArray.join(' ');
    }
    render() {
        const { grid, isInvalid } = this.props;
        const { Grid } = this.props.components;
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement(Grid, Object.assign({ equalHeight: true }, grid, { className: this.BEM() }), this.getChildren()),
            isInvalid && this.renderNotice()));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-group/esm/option-card-group/option-card-group.js





const OptionCardGroup = (props) => {
    return (external_react_.createElement(option_card_group_core, Object.assign({}, props, { components: {
            Grid: grid,
            GridColumn: grid_column,
            Notice: Notice,
            OptionCard: OptionCard,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-group/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old-group/esm/option-card-old-group/option-card-old-group-core.js


const OptionCardOldGroupCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "OptionCardOldGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        external_react_.createElement(OptionCardOldGroupCoreInner, Object.assign({}, props))));
};
/* harmony default export */ const option_card_old_group_core = (OptionCardOldGroupCore);
class OptionCardOldGroupCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.onChange = (value, checked, onChange) => {
            let newValue = this.value;
            if (this.props.inputType === 'checkbox') {
                newValue = newValue || [];
                if (Array.isArray(newValue)) {
                    if (checked) {
                        newValue.push(value);
                    }
                    else {
                        newValue = newValue.filter((item) => item !== value);
                    }
                }
            }
            else {
                newValue = value;
            }
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value: newValue,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(newValue);
            }
            if (onChange) {
                onChange(checked);
            }
        };
        this.state = {
            value: props.defaultValue || null,
        };
    }
    get value() {
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    isChecked(value) {
        const currentValue = this.value;
        if (this.props.inputType === 'checkbox' && currentValue) {
            return value === currentValue || currentValue.indexOf(value) !== -1;
        }
        else {
            return value === currentValue;
        }
    }
    get isInvalid() {
        if (this.props.isHelperExternallyHandled) {
            return !!this.props.isInvalid;
        }
        else if (this.props.helper) {
            return this.props.helper.type === 'error';
        }
        return !!this.props.isInvalid;
    }
    get OptionCardOldProps() {
        const { checkedLabel, recommendedLabel, color, type, badgeTop } = this.props;
        return {
            badgeTop,
            checkedLabel,
            color,
            recommendedLabel,
            type,
        };
    }
    getOptionInput(option) {
        if (this.props.inputType === 'radio') {
            return Object.assign(Object.assign({}, option.input), { name: this.props.name });
        }
        else {
            return Object.assign({}, option.input);
        }
    }
    renderOptionCardOld(child, key) {
        const props = child.props;
        const value = props.value || 'on';
        const onChange = (checked) => this.onChange(value, checked, props.onChange);
        const { OptionCardOld } = this.props.components;
        return (external_react_.createElement(OptionCardOld, Object.assign({}, this.OptionCardOldProps, props, { checked: this.isChecked(value), index: key, input: this.getOptionInput(props), inputType: this.props.inputType, onChange: onChange, isInvalid: this.isInvalid })));
    }
    renderNotice() {
        const { components: { Notice }, helper, isHelperExternallyHandled } = this.props;
        if (isHelperExternallyHandled) {
            return (external_react_.createElement(Notice, { className: "text-bold", align: "center", size: "small", children: true }));
        }
        else if (helper) {
            return (external_react_.createElement(Notice, Object.assign({ className: "text-bold", align: "center", size: "small" }, helper), helper.children));
        }
    }
    getChildren() {
        const { GridColumn, OptionCardOld } = this.props.components;
        return external_react_.Children.toArray(this.props.children).filter((child) => {
            return external_react_.isValidElement(child);
        }).map((child, key) => {
            const isOptionCardOld = this.props.isOptionCardOld ? this.props.isOptionCardOld(child) : child && child.type === OptionCardOld;
            return (external_react_.createElement(GridColumn, Object.assign({}, this.props.gridColumn, { key: key }), isOptionCardOld ? this.renderOptionCardOld(child, key) : child));
        });
    }
    BEM() {
        var _a;
        const classArray = [];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if ((_a = this.props.grid) === null || _a === void 0 ? void 0 : _a.className) {
            classArray.push(this.props.grid.className);
        }
        return classArray.join(' ');
    }
    render() {
        const { grid, isInvalid } = this.props;
        const { Grid } = this.props.components;
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement(Grid, Object.assign({ equalHeight: true }, grid, { className: this.BEM() }), this.getChildren()),
            isInvalid && this.renderNotice()));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old-group/esm/option-card-old-group/option-card-old-group.js





const OptionCardOldGroup = (props) => {
    return (external_react_.createElement(option_card_old_group_core, Object.assign({}, props, { components: {
            Grid: grid,
            GridColumn: grid_column,
            Notice: Notice,
            OptionCardOld: option_card_old,
        } })));
};
/* harmony default export */ const option_card_old_group = (OptionCardOldGroup);

;// CONCATENATED MODULE: ./node_modules/@core-front/option-card-old-group/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/overlay/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/page-heading/esm/page-heading-core.js
var page_heading_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const PageHeadingCore = (props) => {
    const { Button, Heading, Grid, GridColumn } = props.components;
    const { backButton, hideButton } = props, rest = page_heading_core_rest(props, ["backButton", "hideButton"]);
    function buttonBEM(isHidden = false) {
        const classArray = ['page-heading__button'];
        if (hideButton && Array.isArray(hideButton)) {
            for (const i of hideButton) {
                classArray.push('hidden-' + i);
            }
        }
        if (isHidden) {
            classArray.push('heading__button--hidden');
        }
        if (backButton && backButton.className) {
            classArray.push(backButton.className);
        }
        return classArray.join(' ');
    }
    /**
     * Hidden button is needed to center text
     */
    function renderButton(isHidden = false) {
        const buttonProps = Object.assign({ size: 'small', responsive: [{ breakPoint: 'sm', props: { size: 'default' } }], icon: '#arrow-left' }, backButton);
        const hiddenButtonProps = Object.assign(Object.assign({}, buttonProps), { id: undefined, attributes: {
                'tabIndex': -1,
                'aria-hidden': true,
            } });
        return (external_react_.createElement(GridColumn, { width: ['min'], className: buttonBEM(isHidden), align: ['middle-xs'] }, isHidden ? external_react_.createElement(Button, Object.assign({}, hiddenButtonProps)) : external_react_.createElement(Button, Object.assign({}, buttonProps))));
    }
    return (external_react_.createElement(Grid, { noWrap: true, verticalGutter: "none" },
        renderButton(),
        external_react_.createElement(GridColumn, { width: ['max'], align: ['middle-xs'] },
            external_react_.createElement(Heading, Object.assign({ className: "h3 text-center text-left-sm" }, rest))),
        renderButton(true)));
};
/* harmony default export */ const page_heading_core = (PageHeadingCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/page-heading/esm/page-heading.js





const PageHeading = (props) => {
    return (external_react_.createElement(page_heading_core, Object.assign({}, props, { components: {
            Button: button_Button,
            Heading: Heading,
            Grid: grid,
            GridColumn: grid_column,
        } })));
};
/* harmony default export */ const page_heading = (PageHeading);

;// CONCATENATED MODULE: ./node_modules/@core-front/page-heading/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/page-access/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/passfield/esm/passfield-core.js



const PassFieldCore = (props) => {
    const labels = useLabels();
    return (external_react_.createElement(analytics_trigger/* default */.Z, { trigger: {
            callback: 'onToggle',
            id: `Field - Passfield - Show/Hide - ${props.id}`,
            elementId: `${props.id}`,
            elementType: 'field',
            interactionType: 'toggle',
        } },
        external_react_.createElement(PassFieldCoreInner, Object.assign({}, props, { labels: labels }))));
};
/* harmony default export */ const passfield_core = (PassFieldCore);
class PassFieldCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.onChange = (value) => {
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        };
        this.onButtonClick = (event) => {
            event.preventDefault();
            const nextIsVisible = !this.state.isVisible;
            this.setState({
                isVisible: nextIsVisible,
            });
            if (this.props.onToggle) {
                this.props.onToggle(nextIsVisible);
            }
        };
        this.getButton = () => {
            const { components: { Icon }, labels, toggleButtonLabel, } = this.props;
            return (external_react_.createElement("button", { className: "passfield__button", onClick: this.onButtonClick, type: "button", "aria-pressed": this.state.isVisible ? 'true' : 'false' },
                external_react_.createElement(Icon, { modifiers: this.getButtonIcon(), className: "passfield__button-icon" }),
                external_react_.createElement("span", { className: "sr-only" }, toggleButtonLabel || labels.get('passField.showPassword'))));
        };
        this.state = {
            isVisible: false,
            value: props.defaultValue || '',
        };
    }
    get value() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
        }
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    BEM() {
        const classArray = ['passfield'];
        if (this.state.isVisible) {
            classArray.push('is-visible');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getInputType() {
        return this.state.isVisible ? 'text' : 'password';
    }
    getButtonIcon() {
        return this.state.isVisible ? '#password-hide' : '#password-show';
    }
    render() {
        const { TextField } = this.props.components;
        return (external_react_.createElement(TextField, Object.assign({}, this.props, { className: this.BEM(), inputClass: "passfield__input", type: this.getInputType(), onChange: this.onChange, value: this.value, contentRenderer: this.getButton })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/passfield/esm/passfield.js




const PassField = (props) => {
    return (external_react_.createElement(passfield_core, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            TextField: TextField,
        } })));
};
/* harmony default export */ const passfield = (PassField);

;// CONCATENATED MODULE: ./node_modules/@core-front/passfield/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/props-checker/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/radio/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/scroll-fade/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/suggestionfield/node_modules/@core-front/helper/esm/index.js


let suggestionfield_node_modules_core_front_helper_esm_scrollAnimationFrame = 0;
const suggestionfield_node_modules_core_front_helper_esm_isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const suggestionfield_node_modules_core_front_helper_esm_disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !suggestionfield_node_modules_core_front_helper_esm_isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const suggestionfield_node_modules_core_front_helper_esm_enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && suggestionfield_node_modules_core_front_helper_esm_isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const suggestionfield_node_modules_core_front_helper_esm_getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const suggestionfield_node_modules_core_front_helper_esm_swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const suggestionfield_node_modules_core_front_helper_esm_doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(suggestionfield_node_modules_core_front_helper_esm_scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = suggestionfield_node_modules_core_front_helper_esm_swingTo(p);
        if (p < 1) {
            suggestionfield_node_modules_core_front_helper_esm_scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const suggestionfield_node_modules_core_front_helper_esm_scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || suggestionfield_node_modules_core_front_helper_esm_getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!isFocusable(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        suggestionfield_node_modules_core_front_helper_esm_doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const suggestionfield_node_modules_core_front_helper_esm_isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= suggestionfield_node_modules_core_front_helper_esm_getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const suggestionfield_node_modules_core_front_helper_esm_isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const suggestionfield_node_modules_core_front_helper_esm_getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return suggestionfield_node_modules_core_front_helper_esm_isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const suggestionfield_node_modules_core_front_helper_esm_stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const suggestionfield_node_modules_core_front_helper_esm_numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const suggestionfield_node_modules_core_front_helper_esm_offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const suggestionfield_node_modules_core_front_helper_esm_setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const suggestionfield_node_modules_core_front_helper_esm_getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const suggestionfield_node_modules_core_front_helper_esm_getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const suggestionfield_node_modules_core_front_helper_esm_getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    suggestionfield_node_modules_core_front_helper_esm_getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const suggestionfield_node_modules_core_front_helper_esm_disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const suggestionfield_node_modules_core_front_helper_esm_enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@core-front/suggestionfield/esm/suggestionfield-core.js
var suggestionfield_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const SuggestionFieldCore = (props) => {
    const labels = useLabels();
    return (external_react_.createElement(analytics_trigger/* default */.Z, { trigger: [
            {
                callback: 'onSelect',
                id: `Suggestion - Choose - ${props.id}`,
                elementId: `${props.id}`,
                elementType: 'suggestion',
                interactionType: 'select',
            },
            {
                callback: 'onShow',
                id: `Suggestion - Open - ${props.id}`,
                elementId: `${props.id}`,
                elementType: 'suggestion',
                interactionType: 'open',
            },
        ] },
        external_react_.createElement(SuggestionFieldCoreInner, Object.assign({}, props, { labels: labels }))));
};
/* harmony default export */ const suggestionfield_core = (SuggestionFieldCore);
class SuggestionFieldCoreInner extends external_react_.PureComponent {
    constructor(props) {
        super(props);
        this.referenceElement = null;
        this.suggestion = null;
        this.itemElements = [];
        this.popper = null;
        this.blurTimeout = 0;
        this.getZIndex = () => {
            /* istanbul ignore else */
            if (this.referenceElement) {
                const inHeader = this.referenceElement.closest('.header') !== null;
                const inModal = this.referenceElement.closest('.modal') !== null;
                if (inHeader || inModal) {
                    return 30;
                }
            }
            return 19;
        };
        this.disablePopper = () => {
            if (this.popper) {
                this.popper.destroy();
                this.popper = null;
            }
        };
        this.onFocus = () => {
            if (this.value || this.props.showSuggestionsOnFocus) {
                setTimeout(() => this.show(), 150);
            }
            if (this.props.onFocus) {
                this.props.onFocus();
            }
        };
        this.hideOnBlur = () => {
            // hide suggestions on blur after timeout to ensure if user clicks suggestion with mouse it will not hide suggestions before click goes through
            window.clearTimeout(this.blurTimeout);
            this.blurTimeout = window.setTimeout(() => {
                if (this.suggestion && !this.suggestion.contains(document.activeElement)) {
                    this.hide();
                }
                else if (this.state.isVisible) {
                    // recursive if user clicks for a long time :)
                    this.hideOnBlur();
                }
            }, 100);
        };
        this.onBlur = (event) => {
            this.hideOnBlur();
            if (this.props.onBlur) {
                this.props.onBlur(event);
            }
        };
        this.onKeyDown = (event) => {
            const { currentIndex, isVisible } = this.state;
            switch (event.key) {
                case 'ArrowDown':
                    if (isVisible) {
                        // select first or next element in suggestions list if suggestions list is visible
                        event.preventDefault();
                        this.selectValue(currentIndex + 1);
                    }
                    return;
                case 'ArrowUp':
                    if (isVisible) {
                        // select last or prev element in suggestions list if suggestions list is visible
                        event.preventDefault();
                        this.selectValue(currentIndex - 1);
                    }
                    return;
                case 'Enter':
                    if (this.inSuggestion) {
                        // if visual focus is in suggestions list:
                        // select focused element from suggestions list
                        // hide suggestions list
                        // prevent default so this would not submit form automatically
                        event.preventDefault();
                        const currentItem = this.cleanItems[currentIndex];
                        this.onChange(currentItem.label);
                        /* istanbul ignore else */
                        if (this.props.onSelect) {
                            this.props.onSelect(currentItem);
                        }
                        this.hide();
                    }
                    return;
                case 'Tab':
                    // hide suggestions list when user tabs out of field
                    this.hide();
                    return;
                case 'Escape':
                case 'Esc':
                    // clear field when esc key is pressed
                    // this will also hide the suggestions list
                    this.onChange('');
                    return;
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'Home':
                case 'End':
                    // reset active descendant value in listbox if user moves cursor in field
                    this.resetValue();
                    return;
            }
            /* istanbul ignore else */
            if (this.props.onKeyDown) {
                this.props.onKeyDown(event);
            }
        };
        this.onClick = (event, clickedItem) => {
            event.preventDefault();
            this.onChange(clickedItem.label);
            /* istanbul ignore else */
            if (this.props.onSelect) {
                this.props.onSelect(clickedItem);
            }
            this.hide();
        };
        this.onChange = (value) => {
            if (!this.isValueControlled()) {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            if (value || this.props.showSuggestionsOnFocus) {
                this.show();
            }
            else {
                this.hide();
            }
            this.resetValue();
        };
        this.onScroll = () => {
            const elem = this.suggestion;
            if (this.props.onScrollToEnd && elem && elem.scrollHeight - elem.scrollTop <= elem.offsetHeight) {
                this.props.onScrollToEnd();
            }
        };
        this.renderAssistiveText = () => {
            const { isVisible } = this.state;
            return (external_react_.createElement("span", { "aria-live": "polite", role: "status", className: "sr-only suggestionfield__assistive-text" }, isVisible && this.getAssistiveText(this.cleanItems.length)));
        };
        this.onClickOutside = this.onClickOutside.bind(this);
        this.state = {
            currentIndex: -1,
            isMounted: false,
            isVisible: false,
            value: props.defaultValue || '',
            popperStyle: {},
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutside);
        this.setState({
            isMounted: true,
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.isLoading === false && this.props.isLoading === true) {
            this.scrollToEnd();
        }
        const haveItemsSurfaced = (!prevProps.items || (prevProps.items && prevProps.items.length === 0)) && this.props.items && this.props.items.length > 0;
        const haveItemsDisappeared = (!prevProps.items || (prevProps.items && prevProps.items.length > 0)) && this.props.items && this.props.items.length === 0;
        if ((this.state.isVisible && !prevState.isVisible) || (this.state.isVisible && haveItemsSurfaced)) {
            this.initPopper();
        }
        else if (!this.state.isVisible && prevState.isVisible || haveItemsDisappeared) {
            this.disablePopper();
        }
    }
    componentWillUnmount() {
        if (this.popper) {
            this.popper.destroy();
        }
        document.removeEventListener('mousedown', this.onClickOutside);
        window.clearTimeout(this.blurTimeout);
    }
    get value() {
        return this.isValueControlled(this.props.value) ? this.props.value : this.state.value;
    }
    isValueControlled(value = this.props.value) {
        const isDefined = typeof value !== 'undefined';
        if (this.props.isReadOnly || this.props.isDisabled) {
            return isDefined;
        }
        return !!this.props.onChange && isDefined;
    }
    scrollToEnd() {
        /* istanbul ignore else */
        if (this.suggestion) {
            const scrollHeight = this.suggestion.scrollHeight;
            const height = this.suggestion.clientHeight;
            const maxScrollTop = scrollHeight - height;
            this.suggestion.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
    }
    get items() {
        const items = this.props.items || [];
        let globalIndex = 0;
        return items.map((item) => {
            if (isSuggestionGroup(item)) {
                return Object.assign(Object.assign({}, item), { items: item.items.map((groupItem) => {
                        globalIndex++;
                        const currentIndex = globalIndex - 1;
                        return Object.assign(Object.assign({}, groupItem), { 'id': groupItem.id || this.getSuggestionItemId(currentIndex), 'isActive': this.state.currentIndex === currentIndex, 'itemRef': (el) => el && (this.itemElements[currentIndex] = el), 'onClick': (event) => {
                                this.onClick(event, groupItem);
                                if (groupItem.onClick) {
                                    groupItem.onClick(event);
                                }
                            }, 'role': 'option', 'aria-selected': this.state.currentIndex === currentIndex });
                    }) });
            }
            else {
                globalIndex++;
                const currentIndex = globalIndex - 1;
                return Object.assign(Object.assign({}, item), { 'id': item.id || this.getSuggestionItemId(currentIndex), 'isActive': this.state.currentIndex === currentIndex, 'itemRef': (el) => el && (this.itemElements[currentIndex] = el), 'onClick': (event) => {
                        this.onClick(event, item);
                        if (item.onClick) {
                            item.onClick(event);
                        }
                    }, 'role': 'option', 'aria-selected': this.state.currentIndex === currentIndex });
            }
        });
    }
    get cleanItems() {
        const items = this.props.items || [];
        return items.reduce((accumulator, item) => {
            if (isSuggestionGroup(item)) {
                return [
                    ...accumulator,
                    ...item.items,
                ];
            }
            else {
                return [
                    ...accumulator,
                    item,
                ];
            }
        }, []);
    }
    get listBoxId() {
        return `${this.props.id}-suggestion`;
    }
    get activeDescendant() {
        var _a;
        const { currentIndex } = this.state;
        return this.inSuggestion ? (((_a = this.cleanItems[currentIndex]) === null || _a === void 0 ? void 0 : _a.id) || this.getSuggestionItemId(currentIndex)) : undefined;
    }
    get inSuggestion() {
        return this.state.isVisible && this.state.currentIndex >= 0;
    }
    getSuggestionItemId(index) {
        return `${this.listBoxId}-item-${index}`;
    }
    initPopper() {
        const { offsetY } = this.props;
        if (this.suggestion && this.referenceElement && !this.popper) {
            this.popper = (0,popper/* createPopper */.fi)(this.referenceElement, this.suggestion, {
                modifiers: [
                    { name: 'applyStyles', enabled: false },
                    { name: 'flip', enabled: false },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, offsetY ? offsetY : -1],
                        },
                    },
                    {
                        name: 'updateState',
                        enabled: true,
                        phase: 'write',
                        requires: ['computeStyles'],
                        fn: ({ state }) => this.updatePopperStyle(state),
                        effect: ({ state }) => this.updatePopperStyle(state),
                    },
                ],
                placement: 'bottom-start',
            });
        }
    }
    updatePopperStyle(state) {
        const popperStyle = Object.assign(Object.assign({}, state.styles.popper), { zIndex: this.getZIndex() });
        if (this.referenceElement && !this.props.fullWidth) {
            popperStyle.width = this.referenceElement.offsetWidth;
        }
        this.setState({ popperStyle });
    }
    onClickOutside(event) {
        if (!(event.target instanceof Node) || (this.referenceElement && this.referenceElement.contains(event.target))) {
            return;
        }
        if ((this.suggestion && !this.suggestion.contains(event.target)) || (!this.suggestion && this.state.isVisible === true)) {
            this.hide();
        }
    }
    show() {
        if (!this.state.isVisible) {
            this.setState({
                isVisible: true,
            });
            if (this.props.onShow) {
                this.props.onShow();
            }
        }
    }
    hide() {
        if (this.state.isVisible) {
            this.setState({
                isVisible: false,
            });
        }
        this.resetValue();
    }
    selectValue(nextIndex) {
        const itemCount = this.cleanItems.length;
        let actualNextIndex = nextIndex;
        if (nextIndex > itemCount - 1) {
            actualNextIndex = 0;
        }
        else if (nextIndex < 0) {
            actualNextIndex = itemCount - 1;
        }
        this.setState({
            currentIndex: actualNextIndex,
        });
        this.scrollToElement(actualNextIndex);
    }
    resetValue() {
        this.setState({
            currentIndex: -1,
        });
    }
    scrollToElement(elementIndex) {
        if (!this.suggestion) {
            return;
        }
        const selectedElement = this.itemElements[elementIndex];
        const offset = suggestionfield_node_modules_core_front_helper_esm_getOffsetFromParent(selectedElement, this.suggestion);
        if (selectedElement && this.suggestion) {
            const containerOffsetTop = this.suggestion.scrollTop;
            const elementTopEdgeYPos = offset.top;
            const elementBottomEdgeYPos = elementTopEdgeYPos - this.suggestion.offsetHeight + selectedElement.offsetHeight;
            if (elementBottomEdgeYPos > containerOffsetTop) {
                this.suggestion.scrollTop = elementBottomEdgeYPos;
            }
            else if (elementTopEdgeYPos < containerOffsetTop) {
                this.suggestion.scrollTop = elementTopEdgeYPos;
            }
        }
    }
    getAssistiveText(count) {
        const { labels } = this.props;
        switch (count) {
            case 0:
                return labels.get('suggestionField.noResultsFound');
            case 1:
                return labels.get('suggestionField.oneResultFound');
            default:
                return labels.get('suggestionField.resultsFound', { count: count.toString() });
        }
    }
    renderSuggestion() {
        if (!this.state.isVisible || (this.items.length === 0 && !this.props.isLoading)) {
            return null;
        }
        const { Suggestion } = this.props.components;
        const listRef = (el) => this.suggestion = el;
        return (external_react_.createElement(Suggestion, { className: this.props.suggestionClassName, style: this.state.popperStyle, listRef: listRef, items: this.items, highlightedValue: this.value, isLoading: this.props.isLoading, additionalContent: this.props.suggestionContent, onScroll: this.onScroll, role: "listbox", "aria-labelledby": `${this.props.id}-label` }));
    }
    render() {
        const _a = this.props, { components: { TextField, }, items, onSelect, onScrollToEnd, onShow, isLoading, suggestionClassName, fullWidth, offsetY, suggestionContent, portalContainer, inputRef, input } = _a, rest = suggestionfield_core_rest(_a, ["components", "items", "onSelect", "onScrollToEnd", "onShow", "isLoading", "suggestionClassName", "fullWidth", "offsetY", "suggestionContent", "portalContainer", "inputRef", "input"]);
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement(TextField, Object.assign({}, rest, { value: this.value, inputRef: (el) => {
                    this.referenceElement = el;
                    if (inputRef) {
                        inputRef(el);
                    }
                }, onKeyDown: this.onKeyDown, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, input: Object.assign(Object.assign({ 'autoComplete': 'off' }, input), { 'aria-autocomplete': 'list', 'aria-controls': this.state.isVisible ? this.listBoxId : undefined, 'aria-activedescendant': this.activeDescendant }), innerAttributes: {
                    'role': 'combobox',
                    'aria-expanded': this.state.isVisible ? 'true' : 'false',
                    'aria-owns': this.state.isVisible ? this.listBoxId : undefined,
                    'aria-haspopup': 'listbox',
                }, contentRenderer: this.renderAssistiveText })),
            this.state.isMounted ? external_react_dom_.createPortal(this.renderSuggestion(), portalContainer || document.body) : this.renderSuggestion()));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/suggestionfield/esm/suggestionfield.js




const SuggestionField = (props) => {
    return (external_react_.createElement(suggestionfield_core, Object.assign({}, props, { components: {
            Suggestion: suggestion,
            TextField: TextField,
        } })));
};
/* harmony default export */ const suggestionfield = (SuggestionField);

;// CONCATENATED MODULE: ./node_modules/@core-front/search/esm/search-core.js
var search_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const isSuggestionField = (props) => {
    return Object.prototype.hasOwnProperty.call(props, 'items');
};
const search_core_BEM = (props) => {
    const classArray = ['search'];
    if (props.hideLabel) {
        classArray.push('search--no-label-' + props.hideLabel);
    }
    if (props.size) {
        classArray.push('search--' + props.size);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
};
const SearchCore = (props) => {
    return (external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onSubmit',
            id: `Search - Submit - ${props.id}`,
            elementType: 'search',
            interactionType: 'submit',
            elementId: props.id } },
        external_react_.createElement(SearchCoreInner, Object.assign({}, props))));
};
const SearchCoreInner = (props) => {
    const { components, formAttributes, searchRef, onSubmit, isDisabled, placeholder, label, inputRef, isClearable = true, focusOnMount, submitButtonText } = props, rest = search_core_rest(props, ["components", "formAttributes", "searchRef", "onSubmit", "isDisabled", "placeholder", "label", "inputRef", "isClearable", "focusOnMount", "submitButtonText"]);
    const { Icon, SuggestionField, TextField } = components;
    const input = external_react_.useRef(null);
    const labels = useLabels();
    const setInputRef = (el) => {
        input.current = el;
        if (inputRef) {
            inputRef(el);
        }
    };
    const renderInput = () => {
        const inputProps = Object.assign(Object.assign({}, rest), { className: 'search__textfield', inputClass: 'search__input', inputRef: setInputRef, isClearable, label: placeholder || label, isDisabled });
        return isSuggestionField(props) ? external_react_.createElement(SuggestionField, Object.assign({}, inputProps)) : external_react_.createElement(TextField, Object.assign({}, inputProps));
    };
    external_react_.useEffect(() => {
        if (focusOnMount && input.current) {
            input.current.focus();
        }
    }, [focusOnMount]);
    return (external_react_.createElement("form", Object.assign({}, formAttributes, { className: search_core_BEM(props), ref: searchRef, onSubmit: onSubmit }),
        renderInput(),
        external_react_.createElement("button", { className: "search__action", type: "submit", disabled: isDisabled },
            external_react_.createElement("span", { className: "sr-only" }, submitButtonText || labels.get('search.submit')),
            external_react_.createElement(Icon, { modifiers: "#search", className: "search__action-icon" }))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/search/esm/search.js





const Search = (props) => {
    return (external_react_.createElement(SearchCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            SuggestionField: suggestionfield,
            TextField: TextField,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/search/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function objectSpread2_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var Utility_abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function Tokenizer_node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(Tokenizer_node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Tokenizer_slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(Tokenizer_slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return Tokenizer_slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + Tokenizer_slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return Tokenizer_slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function Middleware_namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = Utility_abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return Tokenizer_node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return Tokenizer_node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return Tokenizer_node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return Tokenizer_slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var emotion_cache_browser_esm_createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ const emotion_cache_browser_esm = (emotion_cache_browser_esm_createCache);

;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function emotion_utils_browser_esm_getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var emotion_utils_browser_esm_registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var emotion_utils_browser_esm_insertStyles = function insertStyles(cache, serialized, isStringTag) {
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ const emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ const emotion_unitless_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ const emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var emotion_serialize_browser_esm_serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = external_react_['useInsertion' + 'Effect'] ? external_react_['useInsertion' + 'Effect'] : false;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectWithLayoutFallback = useInsertionEffect || external_react_.useLayoutEffect;



;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js









var emotion_element_6a883da9_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,external_react_.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */emotion_cache_browser_esm({
  key: 'css'
}) : null);

if (false) {}

var emotion_element_6a883da9_browser_esm_CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var emotion_element_6a883da9_browser_esm_withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,external_react_.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,external_react_.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var emotion_element_6a883da9_browser_esm_ThemeContext = /* #__PURE__ */(0,external_react_.createContext)({});

if (false) {}

var emotion_element_6a883da9_browser_esm_useTheme = function useTheme() {
  return useContext(emotion_element_6a883da9_browser_esm_ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(emotion_element_6a883da9_browser_esm_ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(emotion_element_6a883da9_browser_esm_ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(emotion_element_6a883da9_browser_esm_ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var rules = emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback(function () {
    return emotion_utils_browser_esm_insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */emotion_element_6a883da9_browser_esm_withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = emotion_utils_browser_esm_getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = emotion_serialize_browser_esm_serializeStyles(registeredStyles, undefined, (0,external_react_.useContext)(emotion_element_6a883da9_browser_esm_ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/(0,external_react_.createElement)(external_react_.Fragment, null, /*#__PURE__*/(0,external_react_.createElement)(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/(0,external_react_.createElement)(WrappedComponent, newProps));
});

if (false) {}



// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.10.6",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.6",
		"@emotion/cache": "^11.10.5",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.6",
		"@emotion/css-prettifier": "1.1.1",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.6",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return external_react_.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return external_react_.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return emotion_serialize_browser_esm_serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function emotion_react_browser_esm_merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var emotion_react_browser_esm_Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return emotion_react_browser_esm_merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(emotion_react_browser_esm_Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, emotion_react_browser_esm_isBrowser; }



;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,objectWithoutPropertiesLoose/* default */.Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t){return t.split("-")[1]}function floating_ui_core_browser_min_e(t){return"y"===t?"height":"width"}function n(t){return t.split("-")[0]}function o(t){return["top","bottom"].includes(n(t))?"x":"y"}function i(i,r,a){let{reference:l,floating:s}=i;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,m=o(r),u=floating_ui_core_browser_min_e(m),g=l[u]/2-s[u]/2,d="x"===m;let p;switch(n(r)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(t(r)){case"start":p[m]-=g*(a&&d?-1:1);break;case"end":p[m]+=g*(a&&d?-1:1)}return p}const r=async(t,e,n)=>{const{placement:o="bottom",strategy:r="absolute",middleware:a=[],platform:l}=n,s=a.filter(Boolean),c=await(null==l.isRTL?void 0:l.isRTL(e));let f=await l.getElementRects({reference:t,floating:e,strategy:r}),{x:m,y:u}=i(f,o,c),g=o,d={},p=0;for(let n=0;n<s.length;n++){const{name:a,fn:h}=s[n],{x:y,y:x,data:w,reset:v}=await h({x:m,y:u,initialPlacement:o,placement:g,strategy:r,middlewareData:d,rects:f,platform:l,elements:{reference:t,floating:e}});m=null!=y?y:m,u=null!=x?x:u,d={...d,[a]:{...d[a],...w}},v&&p<=50&&(p++,"object"==typeof v&&(v.placement&&(g=v.placement),v.rects&&(f=!0===v.rects?await l.getElementRects({reference:t,floating:e,strategy:r}):v.rects),({x:m,y:u}=i(f,g,c))),n=-1)}return{x:m,y:u,placement:g,strategy:r,middlewareData:d}};function a(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function floating_ui_core_browser_min_l(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function s(t,e){var n;void 0===e&&(e={});const{x:o,y:i,platform:r,rects:s,elements:c,strategy:f}=t,{boundary:m="clippingAncestors",rootBoundary:u="viewport",elementContext:g="floating",altBoundary:d=!1,padding:p=0}=e,h=a(p),y=c[d?"floating"===g?"reference":"floating":g],x=floating_ui_core_browser_min_l(await r.getClippingRect({element:null==(n=await(null==r.isElement?void 0:r.isElement(y)))||n?y:y.contextElement||await(null==r.getDocumentElement?void 0:r.getDocumentElement(c.floating)),boundary:m,rootBoundary:u,strategy:f})),w="floating"===g?{...s.floating,x:o,y:i}:s.reference,v=await(null==r.getOffsetParent?void 0:r.getOffsetParent(c.floating)),b=await(null==r.isElement?void 0:r.isElement(v))&&await(null==r.getScale?void 0:r.getScale(v))||{x:1,y:1},A=floating_ui_core_browser_min_l(r.convertOffsetParentRelativeRectToViewportRelativeRect?await r.convertOffsetParentRelativeRectToViewportRelativeRect({rect:w,offsetParent:v,strategy:f}):w);return{top:(x.top-A.top+h.top)/b.y,bottom:(A.bottom-x.bottom+h.bottom)/b.y,left:(x.left-A.left+h.left)/b.x,right:(A.right-x.right+h.right)/b.x}}const c=Math.min,f=Math.max;function m(t,e,n){return f(t,c(e,n))}const u=n=>({name:"arrow",options:n,async fn(i){const{element:r,padding:l=0}=n||{},{x:s,y:c,placement:f,rects:u,platform:g,elements:d}=i;if(null==r)return{};const p=a(l),h={x:s,y:c},y=o(f),x=floating_ui_core_browser_min_e(y),w=await g.getDimensions(r),v="y"===y,b=v?"top":"left",A=v?"bottom":"right",R=v?"clientHeight":"clientWidth",P=u.reference[x]+u.reference[y]-h[y]-u.floating[x],E=h[y]-u.reference[y],T=await(null==g.getOffsetParent?void 0:g.getOffsetParent(r));let D=T?T[R]:0;D&&await(null==g.isElement?void 0:g.isElement(T))||(D=d.floating[R]||u.floating[x]);const L=P/2-E/2,k=p[b],O=D-w[x]-p[A],B=D/2-w[x]/2+L,C=m(k,B,O),H=null!=t(f)&&B!=C&&u.reference[x]/2-(B<k?p[b]:p[A])-w[x]/2<0;return{[y]:h[y]-(H?B<k?k-B:O-B:0),data:{[y]:C,centerOffset:B-C}}}}),g=["top","right","bottom","left"],d=g.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]),p={left:"right",right:"left",bottom:"top",top:"bottom"};function h(t){return t.replace(/left|right|bottom|top/g,(t=>p[t]))}function y(n,i,r){void 0===r&&(r=!1);const a=t(n),l=o(n),s=floating_ui_core_browser_min_e(l);let c="x"===l?a===(r?"end":"start")?"right":"left":"start"===a?"bottom":"top";return i.reference[s]>i.floating[s]&&(c=h(c)),{main:c,cross:h(c)}}const x={start:"end",end:"start"};function w(t){return t.replace(/start|end/g,(t=>x[t]))}const v=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(o){var i,r,a;const{rects:l,middlewareData:c,placement:f,platform:m,elements:u}=o,{crossAxis:g=!1,alignment:p,allowedPlacements:h=d,autoAlignment:x=!0,...v}=e,b=void 0!==p||h===d?function(e,o,i){return(e?[...i.filter((n=>t(n)===e)),...i.filter((n=>t(n)!==e))]:i.filter((t=>n(t)===t))).filter((n=>!e||t(n)===e||!!o&&w(n)!==n))}(p||null,x,h):h,A=await s(o,v),R=(null==(i=c.autoPlacement)?void 0:i.index)||0,P=b[R];if(null==P)return{};const{main:E,cross:T}=y(P,l,await(null==m.isRTL?void 0:m.isRTL(u.floating)));if(f!==P)return{reset:{placement:b[0]}};const D=[A[n(P)],A[E],A[T]],L=[...(null==(r=c.autoPlacement)?void 0:r.overflows)||[],{placement:P,overflows:D}],k=b[R+1];if(k)return{data:{index:R+1,overflows:L},reset:{placement:k}};const O=L.map((e=>{const n=t(e.placement);return[e.placement,n&&g?e.overflows.slice(0,2).reduce(((t,e)=>t+e),0):e.overflows[0],e.overflows]})).sort(((t,e)=>t[1]-e[1])),B=(null==(a=O.filter((e=>e[2].slice(0,t(e[0])?2:3).every((t=>t<=0))))[0])?void 0:a[0])||O[0][0];return B!==f?{data:{index:R+1,overflows:L},reset:{placement:B}}:{}}}};const b=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(o){var i;const{placement:r,middlewareData:a,rects:l,initialPlacement:c,platform:f,elements:m}=o,{mainAxis:u=!0,crossAxis:g=!0,fallbackPlacements:d,fallbackStrategy:p="bestFit",fallbackAxisSideDirection:x="none",flipAlignment:v=!0,...b}=e,A=n(r),R=n(c)===c,P=await(null==f.isRTL?void 0:f.isRTL(m.floating)),E=d||(R||!v?[h(c)]:function(t){const e=h(t);return[w(t),e,w(e)]}(c));d||"none"===x||E.push(...function(e,o,i,r){const a=t(e);let l=function(t,e,n){const o=["left","right"],i=["right","left"],r=["top","bottom"],a=["bottom","top"];switch(t){case"top":case"bottom":return n?e?i:o:e?o:i;case"left":case"right":return e?r:a;default:return[]}}(n(e),"start"===i,r);return a&&(l=l.map((t=>t+"-"+a)),o&&(l=l.concat(l.map(w)))),l}(c,v,x,P));const T=[c,...E],D=await s(o,b),L=[];let k=(null==(i=a.flip)?void 0:i.overflows)||[];if(u&&L.push(D[A]),g){const{main:t,cross:e}=y(r,l,P);L.push(D[t],D[e])}if(k=[...k,{placement:r,overflows:L}],!L.every((t=>t<=0))){var O,B;const t=((null==(O=a.flip)?void 0:O.index)||0)+1,e=T[t];if(e)return{data:{index:t,overflows:k},reset:{placement:e}};let n=null==(B=k.filter((t=>t.overflows[0]<=0)).sort(((t,e)=>t.overflows[1]-e.overflows[1]))[0])?void 0:B.placement;if(!n)switch(p){case"bestFit":{var C;const t=null==(C=k.map((t=>[t.placement,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:C[0];t&&(n=t);break}case"initialPlacement":n=c}if(r!==n)return{reset:{placement:n}}}return{}}}};function A(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function R(t){return g.some((e=>t[e]>=0))}const P=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{strategy:n="referenceHidden",...o}=t,{rects:i}=e;switch(n){case"referenceHidden":{const t=A(await s(e,{...o,elementContext:"reference"}),i.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:R(t)}}}case"escaped":{const t=A(await s(e,{...o,altBoundary:!0}),i.floating);return{data:{escapedOffsets:t,escaped:R(t)}}}default:return{}}}}};function E(t){const e=c(...t.map((t=>t.left))),n=c(...t.map((t=>t.top)));return{x:e,y:n,width:f(...t.map((t=>t.right)))-e,height:f(...t.map((t=>t.bottom)))-n}}const T=function(t){return void 0===t&&(t={}),{name:"inline",options:t,async fn(e){const{placement:i,elements:r,rects:s,platform:m,strategy:u}=e,{padding:g=2,x:d,y:p}=t,h=Array.from(await(null==m.getClientRects?void 0:m.getClientRects(r.reference))||[]),y=function(t){const e=t.slice().sort(((t,e)=>t.y-e.y)),n=[];let o=null;for(let t=0;t<e.length;t++){const i=e[t];!o||i.y-o.y>o.height/2?n.push([i]):n[n.length-1].push(i),o=i}return n.map((t=>floating_ui_core_browser_min_l(E(t))))}(h),x=floating_ui_core_browser_min_l(E(h)),w=a(g);const v=await m.getElementRects({reference:{getBoundingClientRect:function(){if(2===y.length&&y[0].left>y[1].right&&null!=d&&null!=p)return y.find((t=>d>t.left-w.left&&d<t.right+w.right&&p>t.top-w.top&&p<t.bottom+w.bottom))||x;if(y.length>=2){if("x"===o(i)){const t=y[0],e=y[y.length-1],o="top"===n(i),r=t.top,a=e.bottom,l=o?t.left:e.left,s=o?t.right:e.right;return{top:r,bottom:a,left:l,right:s,width:s-l,height:a-r,x:l,y:r}}const t="left"===n(i),e=f(...y.map((t=>t.right))),r=c(...y.map((t=>t.left))),a=y.filter((n=>t?n.left===r:n.right===e)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:r,right:e,width:e-r,height:s-l,x:r,y:l}}return x}},floating:r.floating,strategy:u});return s.reference.x!==v.reference.x||s.reference.y!==v.reference.y||s.reference.width!==v.reference.width||s.reference.height!==v.reference.height?{reset:{rects:v}}:{}}}};const D=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(i){const{x:r,y:a}=i,l=await async function(e,i){const{placement:r,platform:a,elements:l}=e,s=await(null==a.isRTL?void 0:a.isRTL(l.floating)),c=n(r),f=t(r),m="x"===o(r),u=["left","top"].includes(c)?-1:1,g=s&&m?-1:1,d="function"==typeof i?i(e):i;let{mainAxis:p,crossAxis:h,alignmentAxis:y}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return f&&"number"==typeof y&&(h="end"===f?-1*y:y),m?{x:h*g,y:p*u}:{x:p*u,y:h*g}}(i,e);return{x:r+l.x,y:a+l.y,data:l}}}};function L(t){return"x"===t?"y":"x"}const k=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:i,y:r,placement:a}=e,{mainAxis:l=!0,crossAxis:c=!1,limiter:f={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...u}=t,g={x:i,y:r},d=await s(e,u),p=o(n(a)),h=L(p);let y=g[p],x=g[h];if(l){const t="y"===p?"bottom":"right";y=m(y+d["y"===p?"top":"left"],y,y-d[t])}if(c){const t="y"===h?"bottom":"right";x=m(x+d["y"===h?"top":"left"],x,x-d[t])}const w=f.fn({...e,[p]:y,[h]:x});return{...w,data:{x:w.x-i,y:w.y-r}}}}},O=function(t){return void 0===t&&(t={}),{options:t,fn(e){const{x:i,y:r,placement:a,rects:l,middlewareData:s}=e,{offset:c=0,mainAxis:f=!0,crossAxis:m=!0}=t,u={x:i,y:r},g=o(a),d=L(g);let p=u[g],h=u[d];const y="function"==typeof c?c(e):c,x="number"==typeof y?{mainAxis:y,crossAxis:0}:{mainAxis:0,crossAxis:0,...y};if(f){const t="y"===g?"height":"width",e=l.reference[g]-l.floating[t]+x.mainAxis,n=l.reference[g]+l.reference[t]-x.mainAxis;p<e?p=e:p>n&&(p=n)}if(m){var w,v;const t="y"===g?"width":"height",e=["top","left"].includes(n(a)),o=l.reference[d]-l.floating[t]+(e&&(null==(w=s.offset)?void 0:w[d])||0)+(e?0:x.crossAxis),i=l.reference[d]+l.reference[t]+(e?0:(null==(v=s.offset)?void 0:v[d])||0)-(e?x.crossAxis:0);h<o?h=o:h>i&&(h=i)}return{[g]:p,[d]:h}}}},B=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(i){const{placement:r,rects:a,platform:l,elements:m}=i,{apply:u=(()=>{}),...g}=e,d=await s(i,g),p=n(r),h=t(r),y="x"===o(r),{width:x,height:w}=a.floating;let v,b;"top"===p||"bottom"===p?(v=p,b=h===(await(null==l.isRTL?void 0:l.isRTL(m.floating))?"start":"end")?"left":"right"):(b=p,v="end"===h?"top":"bottom");const A=w-d[v],R=x-d[b];let P=A,E=R;if(y?E=c(x-d.right-d.left,R):P=c(w-d.bottom-d.top,A),!i.middlewareData.shift&&!h){const t=f(d.left,0),e=f(d.right,0),n=f(d.top,0),o=f(d.bottom,0);y?E=x-2*(0!==t||0!==e?t+e:f(d.left,d.right)):P=w-2*(0!==n||0!==o?n+o:f(d.top,d.bottom))}await u({...i,availableWidth:E,availableHeight:P});const T=await l.getDimensions(m.floating);return x!==T.width||w!==T.height?{reset:{rects:!0}}:{}}}};

;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function floating_ui_dom_browser_min_n(t){var e;return(null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function floating_ui_dom_browser_min_o(t){return floating_ui_dom_browser_min_n(t).getComputedStyle(t)}function floating_ui_dom_browser_min_i(t){return t instanceof floating_ui_dom_browser_min_n(t).Node}function floating_ui_dom_browser_min_r(t){return floating_ui_dom_browser_min_i(t)?(t.nodeName||"").toLowerCase():""}let l;function floating_ui_dom_browser_min_c(){if(l)return l;const t=navigator.userAgentData;return t&&Array.isArray(t.brands)?(l=t.brands.map((t=>t.brand+"/"+t.version)).join(" "),l):navigator.userAgent}function floating_ui_dom_browser_min_s(t){return t instanceof floating_ui_dom_browser_min_n(t).HTMLElement}function floating_ui_dom_browser_min_f(t){return t instanceof floating_ui_dom_browser_min_n(t).Element}function floating_ui_dom_browser_min_u(t){if("undefined"==typeof ShadowRoot)return!1;return t instanceof floating_ui_dom_browser_min_n(t).ShadowRoot||t instanceof ShadowRoot}function floating_ui_dom_browser_min_a(t){const{overflow:e,overflowX:n,overflowY:i,display:r}=floating_ui_dom_browser_min_o(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+n)&&!["inline","contents"].includes(r)}function floating_ui_dom_browser_min_d(t){return["table","td","th"].includes(floating_ui_dom_browser_min_r(t))}function floating_ui_dom_browser_min_h(t){const e=/firefox/i.test(floating_ui_dom_browser_min_c()),n=floating_ui_dom_browser_min_o(t),i=n.backdropFilter||n.WebkitBackdropFilter;return"none"!==n.transform||"none"!==n.perspective||!!i&&"none"!==i||e&&"filter"===n.willChange||e&&!!n.filter&&"none"!==n.filter||["transform","perspective"].some((t=>n.willChange.includes(t)))||["paint","layout","strict","content"].some((t=>{const e=n.contain;return null!=e&&e.includes(t)}))}function floating_ui_dom_browser_min_p(){return/^((?!chrome|android).)*safari/i.test(floating_ui_dom_browser_min_c())}function floating_ui_dom_browser_min_g(t){return["html","body","#document"].includes(floating_ui_dom_browser_min_r(t))}const floating_ui_dom_browser_min_m=Math.min,floating_ui_dom_browser_min_y=Math.max,floating_ui_dom_browser_min_x=Math.round;function floating_ui_dom_browser_min_w(t){const e=floating_ui_dom_browser_min_o(t);let n=parseFloat(e.width),i=parseFloat(e.height);const r=floating_ui_dom_browser_min_s(t),l=r?t.offsetWidth:n,c=r?t.offsetHeight:i,f=floating_ui_dom_browser_min_x(n)!==l||floating_ui_dom_browser_min_x(i)!==c;return f&&(n=l,i=c),{width:n,height:i,fallback:f}}function floating_ui_dom_browser_min_v(t){return floating_ui_dom_browser_min_f(t)?t:t.contextElement}const floating_ui_dom_browser_min_b={x:1,y:1};function floating_ui_dom_browser_min_L(t){const e=floating_ui_dom_browser_min_v(t);if(!floating_ui_dom_browser_min_s(e))return floating_ui_dom_browser_min_b;const n=e.getBoundingClientRect(),{width:o,height:i,fallback:r}=floating_ui_dom_browser_min_w(e);let l=(r?floating_ui_dom_browser_min_x(n.width):n.width)/o,c=(r?floating_ui_dom_browser_min_x(n.height):n.height)/i;return l&&Number.isFinite(l)||(l=1),c&&Number.isFinite(c)||(c=1),{x:l,y:c}}function floating_ui_dom_browser_min_E(e,o,i,r){var l,c;void 0===o&&(o=!1),void 0===i&&(i=!1);const s=e.getBoundingClientRect(),u=floating_ui_dom_browser_min_v(e);let a=floating_ui_dom_browser_min_b;o&&(r?floating_ui_dom_browser_min_f(r)&&(a=floating_ui_dom_browser_min_L(r)):a=floating_ui_dom_browser_min_L(e));const d=u?floating_ui_dom_browser_min_n(u):window,h=floating_ui_dom_browser_min_p()&&i;let g=(s.left+(h&&(null==(l=d.visualViewport)?void 0:l.offsetLeft)||0))/a.x,m=(s.top+(h&&(null==(c=d.visualViewport)?void 0:c.offsetTop)||0))/a.y,y=s.width/a.x,x=s.height/a.y;if(u){const t=floating_ui_dom_browser_min_n(u),e=r&&floating_ui_dom_browser_min_f(r)?floating_ui_dom_browser_min_n(r):r;let o=t.frameElement;for(;o&&r&&e!==t;){const t=floating_ui_dom_browser_min_L(o),e=o.getBoundingClientRect(),i=getComputedStyle(o);e.x+=(o.clientLeft+parseFloat(i.paddingLeft))*t.x,e.y+=(o.clientTop+parseFloat(i.paddingTop))*t.y,g*=t.x,m*=t.y,y*=t.x,x*=t.y,g+=e.x,m+=e.y,o=floating_ui_dom_browser_min_n(o).frameElement}}return floating_ui_core_browser_min_l({width:y,height:x,x:g,y:m})}function floating_ui_dom_browser_min_T(t){return((floating_ui_dom_browser_min_i(t)?t.ownerDocument:t.document)||window.document).documentElement}function floating_ui_dom_browser_min_R(t){return floating_ui_dom_browser_min_f(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function C(t){return floating_ui_dom_browser_min_E(floating_ui_dom_browser_min_T(t)).left+floating_ui_dom_browser_min_R(t).scrollLeft}function F(t){if("html"===floating_ui_dom_browser_min_r(t))return t;const e=t.assignedSlot||t.parentNode||floating_ui_dom_browser_min_u(t)&&t.host||floating_ui_dom_browser_min_T(t);return floating_ui_dom_browser_min_u(e)?e.host:e}function W(t){const e=F(t);return floating_ui_dom_browser_min_g(e)?e.ownerDocument.body:floating_ui_dom_browser_min_s(e)&&floating_ui_dom_browser_min_a(e)?e:W(e)}function floating_ui_dom_browser_min_D(t,e){var o;void 0===e&&(e=[]);const i=W(t),r=i===(null==(o=t.ownerDocument)?void 0:o.body),l=floating_ui_dom_browser_min_n(i);return r?e.concat(l,l.visualViewport||[],floating_ui_dom_browser_min_a(i)?i:[]):e.concat(i,floating_ui_dom_browser_min_D(i))}function S(e,i,r){let l;if("viewport"===i)l=function(t,e){const o=floating_ui_dom_browser_min_n(t),i=floating_ui_dom_browser_min_T(t),r=o.visualViewport;let l=i.clientWidth,c=i.clientHeight,s=0,f=0;if(r){l=r.width,c=r.height;const t=floating_ui_dom_browser_min_p();(!t||t&&"fixed"===e)&&(s=r.offsetLeft,f=r.offsetTop)}return{width:l,height:c,x:s,y:f}}(e,r);else if("document"===i)l=function(t){const e=floating_ui_dom_browser_min_T(t),n=floating_ui_dom_browser_min_R(t),i=t.ownerDocument.body,r=floating_ui_dom_browser_min_y(e.scrollWidth,e.clientWidth,i.scrollWidth,i.clientWidth),l=floating_ui_dom_browser_min_y(e.scrollHeight,e.clientHeight,i.scrollHeight,i.clientHeight);let c=-n.scrollLeft+C(t);const s=-n.scrollTop;return"rtl"===floating_ui_dom_browser_min_o(i).direction&&(c+=floating_ui_dom_browser_min_y(e.clientWidth,i.clientWidth)-r),{width:r,height:l,x:c,y:s}}(floating_ui_dom_browser_min_T(e));else if(floating_ui_dom_browser_min_f(i))l=function(t,e){const n=floating_ui_dom_browser_min_E(t,!0,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=floating_ui_dom_browser_min_s(t)?floating_ui_dom_browser_min_L(t):{x:1,y:1};return{width:t.clientWidth*r.x,height:t.clientHeight*r.y,x:i*r.x,y:o*r.y}}(i,r);else{const t={...i};if(floating_ui_dom_browser_min_p()){var c,u;const o=floating_ui_dom_browser_min_n(e);t.x-=(null==(c=o.visualViewport)?void 0:c.offsetLeft)||0,t.y-=(null==(u=o.visualViewport)?void 0:u.offsetTop)||0}l=t}return floating_ui_core_browser_min_l(l)}function floating_ui_dom_browser_min_A(t,e){return floating_ui_dom_browser_min_s(t)&&"fixed"!==floating_ui_dom_browser_min_o(t).position?e?e(t):t.offsetParent:null}function H(t,e){const i=floating_ui_dom_browser_min_n(t);if(!floating_ui_dom_browser_min_s(t))return i;let l=floating_ui_dom_browser_min_A(t,e);for(;l&&floating_ui_dom_browser_min_d(l)&&"static"===floating_ui_dom_browser_min_o(l).position;)l=floating_ui_dom_browser_min_A(l,e);return l&&("html"===floating_ui_dom_browser_min_r(l)||"body"===floating_ui_dom_browser_min_r(l)&&"static"===floating_ui_dom_browser_min_o(l).position&&!floating_ui_dom_browser_min_h(l))?i:l||function(t){let e=F(t);for(;floating_ui_dom_browser_min_s(e)&&!floating_ui_dom_browser_min_g(e);){if(floating_ui_dom_browser_min_h(e))return e;e=F(e)}return null}(t)||i}function V(t,e,n){const o=floating_ui_dom_browser_min_s(e),i=floating_ui_dom_browser_min_T(e),l=floating_ui_dom_browser_min_E(t,!0,"fixed"===n,e);let c={scrollLeft:0,scrollTop:0};const f={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==floating_ui_dom_browser_min_r(e)||floating_ui_dom_browser_min_a(i))&&(c=floating_ui_dom_browser_min_R(e)),floating_ui_dom_browser_min_s(e)){const t=floating_ui_dom_browser_min_E(e,!0);f.x=t.x+e.clientLeft,f.y=t.y+e.clientTop}else i&&(f.x=C(i));return{x:l.left+c.scrollLeft-f.x,y:l.top+c.scrollTop-f.y,width:l.width,height:l.height}}const floating_ui_dom_browser_min_O={getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:i,strategy:l}=t;const c="clippingAncestors"===n?function(t,e){const n=e.get(t);if(n)return n;let i=floating_ui_dom_browser_min_D(t).filter((t=>floating_ui_dom_browser_min_f(t)&&"body"!==floating_ui_dom_browser_min_r(t))),l=null;const c="fixed"===floating_ui_dom_browser_min_o(t).position;let s=c?F(t):t;for(;floating_ui_dom_browser_min_f(s)&&!floating_ui_dom_browser_min_g(s);){const t=floating_ui_dom_browser_min_o(s),e=floating_ui_dom_browser_min_h(s);"fixed"===t.position?l=null:(c?e||l:e||"static"!==t.position||!l||!["absolute","fixed"].includes(l.position))?l=t:i=i.filter((t=>t!==s)),s=F(s)}return e.set(t,i),i}(e,this._c):[].concat(n),s=[...c,i],u=s[0],a=s.reduce(((t,n)=>{const o=S(e,n,l);return t.top=floating_ui_dom_browser_min_y(o.top,t.top),t.right=floating_ui_dom_browser_min_m(o.right,t.right),t.bottom=floating_ui_dom_browser_min_m(o.bottom,t.bottom),t.left=floating_ui_dom_browser_min_y(o.left,t.left),t}),S(e,u,l));return{width:a.right-a.left,height:a.bottom-a.top,x:a.left,y:a.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const i=floating_ui_dom_browser_min_s(n),l=floating_ui_dom_browser_min_T(n);if(n===l)return e;let c={scrollLeft:0,scrollTop:0},f={x:1,y:1};const u={x:0,y:0};if((i||!i&&"fixed"!==o)&&(("body"!==floating_ui_dom_browser_min_r(n)||floating_ui_dom_browser_min_a(l))&&(c=floating_ui_dom_browser_min_R(n)),floating_ui_dom_browser_min_s(n))){const t=floating_ui_dom_browser_min_E(n);f=floating_ui_dom_browser_min_L(n),u.x=t.x+n.clientLeft,u.y=t.y+n.clientTop}return{width:e.width*f.x,height:e.height*f.y,x:e.x*f.x-c.scrollLeft*f.x+u.x,y:e.y*f.y-c.scrollTop*f.y+u.y}},isElement:floating_ui_dom_browser_min_f,getDimensions:function(t){return floating_ui_dom_browser_min_w(t)},getOffsetParent:H,getDocumentElement:floating_ui_dom_browser_min_T,getScale:floating_ui_dom_browser_min_L,async getElementRects(t){let{reference:e,floating:n,strategy:o}=t;const i=this.getOffsetParent||H,r=this.getDimensions;return{reference:V(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}},getClientRects:t=>Array.from(t.getClientRects()),isRTL:t=>"rtl"===floating_ui_dom_browser_min_o(t).direction};function floating_ui_dom_browser_min_P(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:l=!0,animationFrame:c=!1}=o,s=i&&!c,u=s||r?[...floating_ui_dom_browser_min_f(t)?floating_ui_dom_browser_min_D(t):t.contextElement?floating_ui_dom_browser_min_D(t.contextElement):[],...floating_ui_dom_browser_min_D(e)]:[];u.forEach((t=>{s&&t.addEventListener("scroll",n,{passive:!0}),r&&t.addEventListener("resize",n)}));let a,d=null;l&&(d=new ResizeObserver((()=>{n()})),floating_ui_dom_browser_min_f(t)&&!c&&d.observe(t),floating_ui_dom_browser_min_f(t)||!t.contextElement||c||d.observe(t.contextElement),d.observe(e));let h=c?floating_ui_dom_browser_min_E(t):null;return c&&function e(){const o=floating_ui_dom_browser_min_E(t);!h||o.x===h.x&&o.y===h.y&&o.width===h.width&&o.height===h.height||n();h=o,a=requestAnimationFrame(e)}(),n(),()=>{var t;u.forEach((t=>{s&&t.removeEventListener("scroll",n),r&&t.removeEventListener("resize",n)})),null==(t=d)||t.disconnect(),d=null,c&&cancelAnimationFrame(a)}}const z=(t,n,o)=>{const i=new Map,r={platform:floating_ui_dom_browser_min_O,...o},l={...r.platform,_c:i};return e(t,n,{...r,platform:l})};

;// CONCATENATED MODULE: ./node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js


var index =  external_react_.useLayoutEffect ;

/* harmony default export */ const use_isomorphic_layout_effect_browser_esm = (index);

;// CONCATENATED MODULE: ./node_modules/react-select/dist/index-a86253bb.esm.js













var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var index_a86253bb_esm_noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = _objectWithoutProperties(props, _excluded$3);
  return objectSpread2_objectSpread2({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : index_a86253bb_esm_noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var index_a86253bb_esm_w = typeof window !== 'undefined' ? window : {};
if (index_a86253bb_esm_w.addEventListener && index_a86253bb_esm_w.removeEventListener) {
  index_a86253bb_esm_w.addEventListener('p', index_a86253bb_esm_noop, options);
  index_a86253bb_esm_w.removeEventListener('p', index_a86253bb_esm_noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return objectSpread2_objectSpread2((_objectSpread2 = {
    label: 'menu'
  }, _defineProperty(_objectSpread2, alignToControl(placement), '100%'), _defineProperty(_objectSpread2, "position", 'absolute'), _defineProperty(_objectSpread2, "width", '100%'), _defineProperty(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/(0,external_react_.createContext)(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = (0,external_react_.useContext)(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = (0,external_react_.useRef)(null);
  var _useState = (0,external_react_.useState)(maxMenuHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = (0,external_react_.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  use_isomorphic_layout_effect_browser_esm(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return objectSpread2_objectSpread2({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return objectSpread2_objectSpread2({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
    offset = _ref6.offset,
    position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = (0,external_react_.useRef)(null);
  var cleanupRef = (0,external_react_.useRef)(null);
  var _useState5 = (0,external_react_.useState)(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = (0,external_react_.useMemo)(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = (0,external_react_.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = (0,external_react_.useCallback)(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  use_isomorphic_layout_effect_browser_esm(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = (0,external_react_.useCallback)(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = floating_ui_dom_browser_min_P(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  use_isomorphic_layout_effect_browser_esm(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = (0,external_react_.useCallback)(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = jsx("div", (0,esm_extends/* default */.Z)({
    ref: setMenuPortalElement
  }, getStyleProps(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/(0,external_react_dom_.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return objectSpread2_objectSpread2({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};

var _templateObject;
var _excluded$2 = ["size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || jsx(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return jsx("span", (0,esm_extends/* default */.Z)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return objectSpread2_objectSpread2({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};
var LoadingIndicator = function LoadingIndicator(props) {
  var innerProps = props.innerProps,
    isRtl = props.isRtl;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return objectSpread2_objectSpread2({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps), children);
};

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), jsx(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return objectSpread2_objectSpread2({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1);
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};

var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': objectSpread2_objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return objectSpread2_objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded);
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), jsx("input", (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return objectSpread2_objectSpread2({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return objectSpread2_objectSpread2({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(Container, {
    data: data,
    innerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, jsx(Label, {
    data: data,
    innerProps: objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data,
    innerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};

var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};

var index_a86253bb_esm_css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};

var index_a86253bb_esm_components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, index_a86253bb_esm_components), props.components);
};



;// CONCATENATED MODULE: ./node_modules/react-select/dist/useStateManager-7e1e8489.esm.js





var useStateManager_7e1e8489_esm_excluded = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties(_ref, useStateManager_7e1e8489_esm_excluded);
  var _useState = (0,external_react_.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = (0,external_react_.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = (0,external_react_.useState)(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = (0,external_react_.useCallback)(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = (0,external_react_.useCallback)(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = (0,external_react_.useCallback)(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = (0,external_react_.useCallback)(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}



;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(9611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ./node_modules/react-select/dist/Select-457c486b.esm.js














function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : 0;
var A11yText = function A11yText(props) {
  return jsx("span", (0,esm_extends/* default */.Z)({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      isDisabled = props.isDisabled,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = (0,external_react_.useMemo)(function () {
    return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = (0,external_react_.useMemo)(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = objectSpread2_objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = (0,external_react_.useMemo)(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue]);
  var ariaResults = (0,external_react_.useMemo)(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = (0,external_react_.useMemo)(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(external_react_.Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return jsx(external_react_.Fragment, null, jsx(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var Select_457c486b_esm_i = 0; Select_457c486b_esm_i < diacritics.length; Select_457c486b_esm_i++) {
  var diacritic = diacritics[Select_457c486b_esm_i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = objectSpread2_objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var Select_457c486b_esm_excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, Select_457c486b_esm_excluded);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    },  true ? "" : 0,  true ? "" : 0)
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = (0,external_react_.useRef)(false);
  var isTop = (0,external_react_.useRef)(false);
  var touchStart = (0,external_react_.useRef)(0);
  var scrollTarget = (0,external_react_.useRef)(null);
  var handleEventDelta = (0,external_react_.useCallback)(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = (0,external_react_.useCallback)(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = (0,external_react_.useCallback)(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = (0,external_react_.useCallback)(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = (0,external_react_.useCallback)(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = (0,external_react_.useCallback)(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  (0,external_react_.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = (0,external_react_.useRef)({});
  var scrollTarget = (0,external_react_.useRef)(null);
  var addScrollLock = (0,external_react_.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = (0,external_react_.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  (0,external_react_.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2$1 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : 0;
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(external_react_.Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

function Select_457c486b_esm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Select_457c486b_esm_ref2 =  true ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : 0;
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return jsx("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus,
    css: Select_457c486b_esm_ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,
    value: "",
    onChange: function onChange() {}
  });
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: index_a86253bb_esm_css,
  valueContainer: valueContainerCSS
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // initialize with source styles
  var styles = _objectSpread({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (keyAsString) {
    var key = keyAsString;
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return Select_457c486b_esm_isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return Select_457c486b_esm_isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function Select_457c486b_esm_isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: objectSpread2_objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption: focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);

    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusedOption = focusableOptions[optionIndex];
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getClassNames = this.getClassNames,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox'
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/external_react_.createElement(DummyInput, (0,esm_extends/* default */.Z)({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: index_a86253bb_esm_noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/external_react_.createElement(Input, (0,esm_extends/* default */.Z)({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/external_react_.createElement(Placeholder, (0,esm_extends/* default */.Z)({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/external_react_.createElement(MultiValue, (0,esm_extends/* default */.Z)({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/external_react_.createElement(SingleValue, (0,esm_extends/* default */.Z)({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/external_react_.createElement(ClearIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/external_react_.createElement(LoadingIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/external_react_.createElement(IndicatorSeparator, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/external_react_.createElement(DropdownIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/external_react_.createElement(Option, (0,esm_extends/* default */.Z)({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/external_react_.createElement(Group, (0,esm_extends/* default */.Z)({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/external_react_.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/external_react_.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/external_react_.createElement(MenuPlacer, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/external_react_.createElement(Menu, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/external_react_.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/external_react_.createElement(MenuList, (0,esm_extends/* default */.Z)({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/external_react_.createElement(MenuPortal, (0,esm_extends/* default */.Z)({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /*#__PURE__*/external_react_.createElement(RequiredInput, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/external_react_.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/external_react_.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/external_react_.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/external_react_.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/external_react_.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/external_react_.createElement(LiveRegion, (0,esm_extends/* default */.Z)({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/external_react_.createElement(SelectContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/external_react_.createElement(Control, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/external_react_.createElement(ValueContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/external_react_.createElement(IndicatorsContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(external_react_.Component);
Select.defaultProps = defaultProps;



;// CONCATENATED MODULE: ./node_modules/react-select/dist/react-select.esm.js


























var StateManagedSelect = /*#__PURE__*/(0,external_react_.forwardRef)(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/external_react_.createElement(Select, (0,esm_extends/* default */.Z)({
    ref: ref
  }, baseSelectProps));
});

var NonceProvider = (function (_ref) {
  var nonce = _ref.nonce,
    children = _ref.children,
    cacheKey = _ref.cacheKey;
  var emotionCache = useMemo(function () {
    return createCache({
      key: cacheKey,
      nonce: nonce
    });
  }, [cacheKey, nonce]);
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: emotionCache
  }, children);
});

/* harmony default export */ const react_select_esm = (StateManagedSelect);


;// CONCATENATED MODULE: ./node_modules/@core-front/select/node_modules/@core-front/helper/esm/hooks/use-is-mounted.js

function use_is_mounted_useIsMounted() {
    const [isMounted, setIsMounted] = external_react_.useState(false);
    external_react_.useEffect(() => {
        setIsMounted(true);
    }, []);
    return isMounted;
}

;// CONCATENATED MODULE: ./node_modules/@core-front/select/node_modules/@core-front/helper/esm/hooks/use-previous.js

function use_previous_usePrevious(value) {
    const ref = external_react_.useRef();
    external_react_.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

;// CONCATENATED MODULE: ./node_modules/@core-front/select/esm/select-core.js






const SelectCore = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "Select", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: [
                { callback: 'onShow', id: `Select - Open - ${props.id}`, elementId: `${props.id}`, elementType: 'select', interactionType: 'open' },
                { callback: 'onHide', id: `Select - Close - ${props.id}`, elementId: `${props.id}`, elementType: 'select', interactionType: 'close' },
                { callback: 'onChange', id: `Select - Choose - ${props.id}`, elementId: `${props.id}`, elementType: 'select', interactionType: 'select' },
            ] },
            external_react_.createElement(SelectCoreInner, Object.assign({}, props)))));
};
const SelectCoreInner = (props) => {
    const { className, components: { Check, FormHelper, Icon, Image, }, defaultValue, disabled, elementRef, employee, helper, hideLabel, id, isInvalid, label, live, multiple, name, noResultsText, onChange, onHide, onShow, options, placeholder, portalTarget, simpleValue, size, style, value, } = props;
    const isValueArray = (value) => {
        return Array.isArray(value);
    };
    let menuList = null;
    const [isOpen, setIsOpen] = external_react_.useState(false);
    const isMounted = use_is_mounted_useIsMounted();
    const [scrollPosition, setScrollPosition] = external_react_.useState(0);
    external_react_.useEffect(() => {
        if (menuList && multiple) {
            menuList.removeEventListener('scroll', menuListScrollHandler);
        }
        menuListScrollHandler.clear();
    });
    external_react_.useEffect(() => {
        const hasStateChanged = typeof value === 'undefined' && prevState !== values;
        const hasPropsChanged = typeof value !== 'undefined' && prevProps !== value;
        if (hasStateChanged || hasPropsChanged) {
            if (menuList && isOpen && multiple) {
                menuList.scrollTop = scrollPosition;
            }
        }
    });
    const getValue = () => {
        return typeof value !== 'undefined' ? findValueFromOptions(value, options) : values;
    };
    const findSimpleValueFromOptions = (value, options) => {
        if (Array.isArray(value)) {
            return options.filter((object) => value.find((option) => option === object.value));
        }
        else {
            return options.find((option) => option.value === value) || null;
        }
    };
    const findDefaultValueFromOptions = (value, options) => {
        if (!value) {
            return null;
        }
        if (isValueArray(value)) {
            return options.filter((object) => value.find((option) => option.value === object.value));
        }
        else {
            return options.find((option) => option.value === value.value) || null;
        }
    };
    const findValueFromOptions = (value, options) => {
        if (simpleValue && typeof value === 'string' || (Array.isArray(value) && typeof value[0] === 'string')) {
            return findSimpleValueFromOptions(value, options);
        }
        else {
            return findDefaultValueFromOptions(value, options);
        }
    };
    const [values, setValues] = external_react_.useState(findValueFromOptions(defaultValue, options));
    const prevState = use_previous_usePrevious(values);
    const prevProps = use_previous_usePrevious(values);
    const nativeSelectValue = () => {
        if (!values) {
            return undefined;
        }
        if (multiple) {
            if (Array.isArray(values)) {
                values.map((values) => values.value);
            }
            else {
                return [values.value];
            }
        }
        if (Array.isArray(values)) {
            values.map((values) => values.value);
        }
        return values.value;
    };
    const getSimpleValue = (value) => {
        if (!value) {
            return null;
        }
        if (isValueArray(value)) {
            return value.map((value) => value.value);
        }
        else {
            return value.value;
        }
    };
    const handleChange = (values) => {
        if (!values || typeof values === 'undefined') {
            return;
        }
        if (typeof value === 'undefined') {
            setValues(values);
        }
        if (onChange && !simpleValue) {
            onChange(values);
        }
        if (onChange && simpleValue) {
            onChange(getSimpleValue(values));
        }
    };
    const BEM = () => {
        const classArray = ['select'];
        if (disabled) {
            classArray.push('is-disabled');
        }
        if (isInvalid) {
            classArray.push('is-invalid');
        }
        if (isOpen) {
            classArray.push('is-open');
        }
        if (size) {
            classArray.push(`select--${size}`);
        }
        if (style) {
            classArray.push(`select--${style}`);
        }
        if (employee) {
            classArray.push('select--employee');
        }
        if (live) {
            classArray.push('select--searchable');
        }
        if (hideLabel) {
            classArray.push(`select--no-label-${hideLabel}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const menuContainerBEM = (props, transitionState) => {
        const classArray = ['select-menu-outer'];
        if (props.size) {
            classArray.push('select-menu-outer--' + props.size);
        }
        if (props.employee) {
            classArray.push('select-menu-outer--employee');
        }
        if (transitionState) {
            classArray.push(transitionState);
        }
        return classArray.join(' ');
    };
    const onMenuOpen = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
        if (onShow) {
            onShow();
        }
    };
    const onMenuClose = () => {
        if (isOpen) {
            setIsOpen(false);
            setScrollPosition(0);
            if (onHide) {
                onHide();
            }
        }
    };
    const onMenuScroll = () => {
        if (menuList) {
            setScrollPosition(menuList.scrollTop);
        }
    };
    const menuListScrollHandler = (0,debounce.debounce)(onMenuScroll, 100);
    const getNoResultsText = () => {
        if (!noResultsText) {
            return null;
        }
        return noResultsText;
    };
    const getDropDownIndicator = () => {
        if (live) {
            return (external_react_.createElement(external_react_.Fragment, null,
                external_react_.createElement(Icon, { modifiers: "#search", className: "select__icon-search" }),
                external_react_.createElement(Icon, { modifiers: "#arrow-down", className: "select__icon" })));
        }
        return external_react_.createElement(Icon, { modifiers: "#arrow-down", className: "select__icon" });
    };
    const getMenu = (props, isOpen, selectProps) => {
        const content = (state) => (external_react_.createElement(index_a86253bb_esm_components.Menu, Object.assign({}, props, { className: menuContainerBEM(selectProps, state) }), props.children));
        return (external_react_.createElement(esm_Transition/* default */.ZP, { in: isOpen, timeout: { enter: 10, exit: 100 }, mountOnEnter: true, unmountOnExit: true }, content));
    };
    const getMenuList = (props) => {
        const setInnerRef = (el) => {
            menuList = el;
            if (menuList && multiple) {
                menuList.addEventListener('scroll', menuListScrollHandler);
            }
        };
        return (external_react_.createElement(index_a86253bb_esm_components.MenuList, Object.assign({}, props, { innerRef: setInnerRef }), props.children));
    };
    const getAsterisk = () => {
        return (external_react_.createElement("div", { className: "select__asterisk-wrapper" },
            external_react_.createElement(Icon, { modifiers: "#star", className: "select__asterisk" })));
    };
    const getIcon = (icon) => {
        return (external_react_.createElement("div", { className: "select__option-icon-wrapper" },
            external_react_.createElement(Icon, { modifiers: icon, className: "select__option-icon" })));
    };
    const getImage = (image) => {
        return (external_react_.createElement("div", { className: "select__image-wrapper" },
            external_react_.createElement(Image, Object.assign({ src: image.src }, image, { className: "select__image" }))));
    };
    const getSubLabel = (subLabel) => {
        return (external_react_.createElement("div", { className: "select__sub-label" }, subLabel));
    };
    const getImageOptionContent = (props) => {
        const option = props.data;
        return (external_react_.createElement(external_react_.Fragment, null,
            option.image && getImage(option.image),
            external_react_.createElement("div", { className: "select__image-option" },
                getOptionDisplayedLabel(option),
                option.showAsterisk && getAsterisk())));
    };
    const getIconOptionContent = (props) => {
        const option = props.data;
        return (external_react_.createElement(external_react_.Fragment, null,
            option.icon && getIcon(option.icon),
            external_react_.createElement("div", { className: "select__option-icon-label" },
                getOptionDisplayedLabel(option),
                option.showAsterisk && getAsterisk())));
    };
    const getDefaultOptionContent = (props) => {
        const option = props.data;
        return (external_react_.createElement(external_react_.Fragment, null,
            getOptionDisplayedLabel(option),
            option.showAsterisk && getAsterisk()));
    };
    const getOptionDisplayedLabel = ({ children, label }) => {
        if (children) {
            return external_react_.createElement("div", { className: "select__option-children" }, children);
        }
        return label;
    };
    const getOptionContent = (props) => {
        const option = props.data;
        if (option.image) {
            return getImageOptionContent(props);
        }
        else if (option.icon) {
            return getIconOptionContent(props);
        }
        else {
            return getDefaultOptionContent(props);
        }
    };
    const getMultipleOptionContent = (props) => {
        const option = props.data;
        return (external_react_.createElement("div", null,
            getOptionContent(props),
            option.subLabel && getSubLabel(option.subLabel)));
    };
    const getOption = (props, checkProps) => {
        const option = props.data;
        if (multiple) {
            return (external_react_.createElement(index_a86253bb_esm_components.Option, Object.assign({}, props),
                external_react_.createElement(Check, Object.assign({}, checkProps, { defaultChecked: props.isSelected, disabled: props.isDisabled }), getMultipleOptionContent(props))));
        }
        return (external_react_.createElement(index_a86253bb_esm_components.Option, Object.assign({}, props),
            getOptionContent(props),
            option.subLabel && getSubLabel(option.subLabel)));
    };
    const getSingleValue = (props) => {
        const value = props.data;
        return (external_react_.createElement(index_a86253bb_esm_components.SingleValue, Object.assign({}, props),
            value.icon && getIcon(value.icon),
            value.image && getImage(value.image),
            external_react_.createElement("div", { className: "select__text-wrapper" }, value.children || value.label),
            value.showAsterisk && getAsterisk()));
    };
    const getMultiValue = (props) => {
        const value = props.data;
        return (external_react_.createElement(index_a86253bb_esm_components.MultiValue, Object.assign({}, props),
            value.icon && getIcon(value.icon),
            value.image && getImage(value.image),
            props.children,
            value.showAsterisk && getAsterisk()));
    };
    const renderReactSelect = () => {
        const customComponents = {
            ClearIndicator: () => null,
            DropdownIndicator: getDropDownIndicator,
            IndicatorSeparator: () => null,
            Menu: (menuProps) => getMenu(menuProps, isOpen, props),
            MenuList: (menuProps) => getMenuList(menuProps),
            MultiValue: getMultiValue,
            MultiValueLabel: (menuProps) => external_react_.createElement(external_react_.Fragment, null, menuProps.children),
            MultiValueRemove: () => null,
            Option: getOption,
            SingleValue: getSingleValue,
        };
        const styles = {
            container: () => ({}),
            control: () => ({}),
            indicatorsContainer: () => ({}),
            input: () => ({}),
            menu: () => ({}),
            menuList: () => ({}),
            menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 31 })),
            multiValue: () => ({}),
            multiValueLabel: () => ({}),
            multiValueRemove: () => ({}),
            noOptionsMessage: () => ({}),
            option: () => ({}),
            placeholder: () => ({}),
            singleValue: () => ({}),
            valueContainer: () => ({}),
        };
        return (external_react_.createElement(react_select_esm, { id: id, instanceId: id, "aria-labelledby": `${id}-label`, className: "select__wrapper", name: name, options: options, value: getValue(), onChange: handleChange, classNamePrefix: "select", components: customComponents, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, menuIsOpen: isOpen, styles: styles, isMulti: multiple, closeMenuOnSelect: !multiple, hideSelectedOptions: false, isDisabled: disabled, placeholder: placeholder ? placeholder : '', menuPortalTarget: typeof portalTarget !== 'undefined' ? portalTarget : (typeof window !== 'undefined' ? document.body : undefined), isClearable: false, noOptionsMessage: getNoResultsText, backspaceRemovesValue: true, menuShouldScrollIntoView: true, isSearchable: live }));
    };
    const renderNativeSelect = () => {
        return (external_react_.createElement("div", { className: "select__wrapper" },
            external_react_.createElement("div", { className: "select__control" },
                external_react_.createElement("div", { className: "select__value-container" },
                    external_react_.createElement("select", { id: id, name: name, className: "select__native-select", disabled: disabled, multiple: multiple, placeholder: placeholder ? placeholder : '', defaultValue: nativeSelectValue() }, options.map((option, index) => {
                        return (external_react_.createElement("option", { key: index, value: option.value }, option.label));
                    }))))));
    };
    return (external_react_.createElement("div", { className: BEM(), ref: elementRef },
        external_react_.createElement("div", { className: "select__inner" },
            external_react_.createElement("label", { className: "select__label", id: `${id}-label`, htmlFor: id, "aria-hidden": isMounted }, label),
            isMounted ? renderReactSelect() : renderNativeSelect()),
        helper && (external_react_.createElement(FormHelper, Object.assign({}, helper, { className: "select__form-helper" })))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/select/esm/select.js
var select_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const select_Select = (props) => {
    const { live = false, placeholder = '' } = props, rest = select_rest(props, ["live", "placeholder"]);
    return (external_react_.createElement(SelectCore, Object.assign({}, rest, { live: live, placeholder: placeholder, components: {
            Check: check,
            FormHelper: FormHelper,
            Icon: icon/* default */.Z,
            Image: esm_image/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/select/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/selector/esm/selector-core.js
var selector_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const SelectorCore = (props) => {
    const { responsive } = props, rest = selector_core_rest(props, ["responsive"]);
    return (external_react_.createElement(props_checker, { componentName: "Selector", componentProps: rest, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" },
        external_react_.createElement(input_provider/* InputContext.Consumer */.r.Consumer, null, (value) => (external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onItemChange', id: ([itemId]) => `Selector - ${itemId}`, elementType: 'selector', elementId: ([itemId]) => `${itemId}` } }, responsive ? (external_react_.createElement(SelectorResponsiveCore, Object.assign({}, rest, { responsive: responsive, inputIntent: value.input }))) : (external_react_.createElement(SelectorInner, Object.assign({}, rest, { inputIntent: value.input }))))))));
};
const SelectorResponsiveCore = (props) => {
    const { responsive } = props, rest = selector_core_rest(props, ["responsive"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsiveProps = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive });
    return (external_react_.createElement(SelectorInner, Object.assign({}, rest, responsiveProps)));
};
class SelectorInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.setHoveredItemToState = (item) => {
            this.setState({
                hoveredItemValue: item.value,
            });
        };
        this.removeHoveredItemFromState = () => {
            this.setState({
                hoveredItemValue: undefined,
            });
        };
        this.onChange = (value, checked) => {
            let nextValue = this.value;
            if (this.props.inputType === 'checkbox' && Array.isArray(nextValue)) {
                if (checked) {
                    nextValue.push(value);
                }
                else {
                    nextValue = nextValue.filter((item) => item !== value);
                }
            }
            else {
                nextValue = value;
            }
            if (!this.isValueControlled()) {
                this.setState({
                    value: nextValue,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(nextValue);
            }
        };
        this.state = {
            value: this.getInitialValue(props.defaultValue),
            hoveredItemValue: undefined,
        };
    }
    get value() {
        return this.isValueControlled(this.props.value) ? this.props.value : this.state.value;
    }
    isValueControlled(value = this.props.value) {
        return !!this.props.onChange && typeof value !== 'undefined';
    }
    isInvalid() {
        return !!this.props.helper && this.props.helper.type === 'error';
    }
    getInitialValue(value) {
        if (value) {
            return value;
        }
        else if (this.props.inputType === 'checkbox') {
            return [];
        }
        else {
            return '';
        }
    }
    BEM() {
        const classArray = ['selector'];
        if (this.props.size) {
            classArray.push('selector--' + this.props.size);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.hideLabel) {
            classArray.push('selector--hide-label');
        }
        if (this.props.align) {
            classArray.push('selector--' + this.props.align);
        }
        return classArray.join(' ');
    }
    getCheckedStatus(value) {
        if (this.props.inputType === 'checkbox') {
            return value === this.value || this.value.indexOf(value) !== -1;
        }
        else {
            return value === this.value;
        }
    }
    renderFormHelper(helper) {
        if (!this.props.helper) {
            return null;
        }
        const { FormHelper } = this.props.components;
        return (external_react_.createElement(FormHelper, Object.assign({}, helper, { className: "selector__form-helper", id: helper.id || `${this.props.id}-helper` })));
    }
    renderLabel(item) {
        const label = external_react_.createElement("span", { className: "selector__item-label" }, item.label);
        if (item.isInactive && !item.disabled) {
            return external_react_.createElement("del", { className: "selector__item-label-strikethrough" }, label);
        }
        return label;
    }
    mapItems() {
        const items = this.props.items.map((item, i) => {
            const itemStyles = {
                background: item.customColor,
            };
            const checked = this.getCheckedStatus(item.value);
            const onChange = (event) => {
                this.onChange(item.value, event.target.checked);
                if (item.onChange) {
                    item.onChange(event.target.checked);
                }
                if (this.props.onItemChange) {
                    this.props.onItemChange(item.id);
                }
            };
            const classArray = ['selector__item'];
            const { GridColumn } = this.props.components;
            const shouldAddEventListeners = this.props.inputIntent === 'mouse' && this.props.showItemLabelNextToLabel;
            if (item.type) {
                classArray.push('selector__item--' + item.type);
            }
            if (item.customColor) {
                classArray.push('selector__item--custom-color');
            }
            if (item.isInactive) {
                classArray.push('selector__item--inactive');
            }
            if (item.className) {
                classArray.push(item.className);
            }
            return (external_react_.createElement(GridColumn, { width: item.itemWidth || this.props.itemWidth, key: i, className: classArray.join(' ') },
                external_react_.createElement("input", { id: item.id, value: item.value, name: item.name, disabled: item.disabled, checked: checked, type: this.props.inputType, onChange: onChange, className: "selector__input", "aria-label": item.ariaLabel, "aria-invalid": this.isInvalid(), "aria-describedby": this.props.helper ? (this.props.helper.id || `${this.props.id}-helper`) : undefined }),
                external_react_.createElement("label", { htmlFor: item.id, className: "selector__indicator" },
                    external_react_.createElement("span", { className: "selector__indicator-inner", style: item.customColor ? itemStyles : undefined, onMouseEnter: shouldAddEventListeners ? () => this.setHoveredItemToState(item) : undefined, onMouseLeave: shouldAddEventListeners ? () => this.removeHoveredItemFromState() : undefined }, this.renderLabel(item)))));
        });
        return items;
    }
    getGridProps() {
        let align = [];
        let gutter = this.props.size === 'large' ? 'small' : 'xsmall';
        if (this.props.align === 'center') {
            align = ['center-xs'];
        }
        else if (this.props.align === 'right') {
            align = ['end-xs'];
        }
        if (this.props.gutter) {
            gutter = this.props.gutter;
        }
        return {
            className: 'selector__list',
            gutter,
            align,
        };
    }
    getItemLabel() {
        const itemValue = this.state.hoveredItemValue || this.value;
        if (itemValue) {
            const selectedItem = this.props.items.find((item) => item.value === itemValue);
            return selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label;
        }
    }
    render() {
        const { Grid } = this.props.components;
        return (external_react_.createElement("fieldset", { className: this.BEM(), id: this.props.id },
            external_react_.createElement("legend", { className: "selector__label" },
                this.props.label,
                this.props.showItemLabelNextToLabel ? (external_react_.createElement("span", { className: "text-bold" },
                    "\u00A0",
                    this.getItemLabel())) : undefined),
            external_react_.createElement(Grid, Object.assign({}, this.getGridProps()), this.mapItems()),
            this.props.helper && this.renderFormHelper(this.props.helper)));
    }
}
SelectorInner.defaultProps = {
    inputType: 'radio',
    itemWidth: ['xs'],
};
/* harmony default export */ const selector_core = (SelectorCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/selector/esm/selector.js




const Selector = (props) => {
    return (external_react_.createElement(selector_core, Object.assign({}, props, { components: {
            FormHelper: FormHelper,
            Grid: grid,
            GridColumn: grid_column,
        } })));
};
/* harmony default export */ const esm_selector = (Selector);

;// CONCATENATED MODULE: ./node_modules/@core-front/selector/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/separator/esm/separator-core.js

const SeparatorCore = (props) => {
    const { color, weight, spacing, align, fullWidth, children, className, content, element: Element = 'div', } = props;
    const BEM = () => {
        const classArray = ['separator'];
        if (color) {
            classArray.push(`separator--color-${color}`);
        }
        if (weight) {
            classArray.push(`separator--${weight}`);
        }
        if (spacing) {
            classArray.push(`separator--${spacing}`);
        }
        if (align) {
            classArray.push(`separator--${align}`);
        }
        if (fullWidth) {
            classArray.push('separator--full-width');
        }
        if (children) {
            classArray.push('separator--content');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const TopElement = Element === 'span' ? 'span' : 'div';
    if (children) {
        return (external_react_.createElement(TopElement, { className: BEM() },
            Element === 'hr' && external_react_.createElement(Element, { className: "sr-only" }),
            external_react_.createElement(TopElement, { className: "separator__content" }, children)));
    }
    if (content) {
        return (external_react_.createElement(TopElement, { className: BEM() },
            Element === 'hr' && external_react_.createElement(Element, { className: "sr-only" }),
            content));
    }
    return (external_react_.createElement(Element, { className: BEM() }));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/separator/esm/separator.js


const Separator = (props) => {
    return (external_react_.createElement(SeparatorCore, Object.assign({}, props)));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/separator/esm/index.js



// EXTERNAL MODULE: ./node_modules/react-signature-canvas/build/index.js
var build = __webpack_require__(8877);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
;// CONCATENATED MODULE: ./node_modules/@core-front/signature/esm/signature-core.js


function signature_core_BEM(props) {
    const { variant = 'dark', disabled, employee, isInvalid, className } = props;
    const classArray = ['signature', `signature--${variant}`];
    if (disabled) {
        classArray.push('signature--disabled');
    }
    if (employee) {
        classArray.push('signature--employee');
    }
    if (isInvalid) {
        classArray.push('signature--invalid');
    }
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
}
const SignatureCore = (props) => {
    const signatureRef = external_react_.useRef(null);
    const { components, isFocusable = true, helper, label, clearButton, onClear, onEnd, onBegin, elementRef, disabled, children, employee, } = props;
    const { FormHelper, Grid, GridColumn, Button } = components;
    function getClearButton(btn) {
        return (external_react_.createElement(GridColumn, { width: ['xs'] },
            external_react_.createElement(Button, Object.assign({ size: "small", iconLeft: "#close", variant: "secondary", type: employee ? 'employee' : undefined, disabled: disabled }, btn, { onClick: onClear }))));
    }
    function getCanvas() {
        if (disabled) {
            return null;
        }
        return (external_react_.createElement((build_default()), { canvasProps: {
                className: 'signature__canvas-inner',
            }, onBegin: onBegin, onEnd: onEnd, ref: elementRef }));
    }
    return (external_react_.createElement("div", { className: signature_core_BEM(props) },
        external_react_.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
            external_react_.createElement(GridColumn, { width: ['xs'], className: "signature__label" },
                external_react_.createElement("span", { className: disabled ? 'text-light' : undefined }, label)),
            clearButton && getClearButton(clearButton)),
        external_react_.createElement("div", { className: "signature__canvas", ref: signatureRef, tabIndex: isFocusable ? 0 : undefined }, children ? children : getCanvas()),
        helper && external_react_.createElement(FormHelper, Object.assign({ className: "signature__form-helper" }, helper))));
};
/* harmony default export */ const signature_core = (SignatureCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/signature/esm/signature.js





const Signature = (props) => {
    return (external_react_.createElement(signature_core, Object.assign({}, props, { components: {
            Button: button_Button,
            FormHelper: FormHelper,
            Grid: grid,
            GridColumn: grid_column,
        } })));
};
/* harmony default export */ const signature = (Signature);

;// CONCATENATED MODULE: ./node_modules/@core-front/signature/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/skeleton/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/skip-links/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/spinner/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/stop-propagation/esm/stop-propagation.js

const StopPropagation = (props) => {
    const { children, element: Element = 'div', } = props;
    const stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };
    return (external_react_.createElement(Element, { onClick: stopPropagation }, children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/stop-propagation/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/suggestion/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/suggestionfield/esm/index.js



;// CONCATENATED MODULE: ./node_modules/react-animate-height/dist/esm/index.js

// ------------------ Helpers
function isNumber(n) {
    const number = parseFloat(n);
    return !isNaN(number) && isFinite(number);
}
function isPercentage(height) {
    // Percentage height
    return (typeof height === 'string' &&
        height[height.length - 1] === '%' &&
        isNumber(height.substring(0, height.length - 1)));
}
function hideContent(element, height) {
    // Check for element?.style is added cause this would fail in tests (react-test-renderer)
    // Read more here: https://github.com/Stanko/react-animate-height/issues/17
    if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) {
        element.style.display = 'none';
    }
}
function showContent(element, height) {
    // Check for element?.style is added cause this would fail in tests (react-test-renderer)
    // Read more here: https://github.com/Stanko/react-animate-height/issues/17
    if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) {
        element.style.display = '';
    }
}
const ANIMATION_STATE_CLASSES = {
    animating: 'rah-animating',
    animatingUp: 'rah-animating--up',
    animatingDown: 'rah-animating--down',
    animatingToHeightZero: 'rah-animating--to-height-zero',
    animatingToHeightAuto: 'rah-animating--to-height-auto',
    animatingToHeightSpecific: 'rah-animating--to-height-specific',
    static: 'rah-static',
    staticHeightZero: 'rah-static--height-zero',
    staticHeightAuto: 'rah-static--height-auto',
    staticHeightSpecific: 'rah-static--height-specific',
};
function getStaticStateClasses(animationStateClasses, height) {
    return [
        animationStateClasses.static,
        height === 0 && animationStateClasses.staticHeightZero,
        height > 0 && animationStateClasses.staticHeightSpecific,
        height === 'auto' && animationStateClasses.staticHeightAuto,
    ]
        .filter((v) => v)
        .join(' ');
}
// ------------------ Component
const propsToOmitFromDiv = [
    'animateOpacity',
    'animationStateClasses',
    'applyInlineTransitions',
    'children',
    'className',
    'contentClassName',
    'delay',
    'duration',
    'easing',
    'height',
    'onHeightAnimationEnd',
    'onHeightAnimationStart',
    'style',
];
const AnimateHeight = (componentProps) => {
    const { animateOpacity = false, animationStateClasses = {}, applyInlineTransitions = true, children, className = '', contentClassName, delay: userDelay = 0, duration: userDuration = 500, easing = 'ease', height, onHeightAnimationEnd, onHeightAnimationStart, style, } = componentProps;
    const divProps = Object.assign({}, componentProps);
    propsToOmitFromDiv.forEach((propKey) => {
        delete divProps[propKey];
    });
    // ------------------ Initialization
    const prevHeight = (0,external_react_.useRef)(height);
    const contentElement = (0,external_react_.useRef)(null);
    const animationClassesTimeoutID = (0,external_react_.useRef)();
    const timeoutID = (0,external_react_.useRef)();
    const stateClasses = (0,external_react_.useRef)(Object.assign(Object.assign({}, ANIMATION_STATE_CLASSES), animationStateClasses));
    const isBrowser = typeof window !== 'undefined';
    const prefersReducedMotion = (0,external_react_.useRef)(isBrowser && window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion)').matches
        : false);
    const delay = prefersReducedMotion.current ? 0 : userDelay;
    const duration = prefersReducedMotion.current ? 0 : userDuration;
    let initHeight = height;
    let initOverflow = 'visible';
    if (typeof initHeight === 'number') {
        // Reset negative height to 0
        initHeight = height < 0 ? 0 : height;
        initOverflow = 'hidden';
    }
    else if (isPercentage(initHeight)) {
        // If value is string "0%" make sure we convert it to number 0
        initHeight = height === '0%' ? 0 : height;
        initOverflow = 'hidden';
    }
    const [currentHeight, setCurrentHeight] = (0,external_react_.useState)(initHeight);
    const [overflow, setOverflow] = (0,external_react_.useState)(initOverflow);
    const [useTransitions, setUseTransitions] = (0,external_react_.useState)(false);
    const [animationStateClassNames, setAnimationStateClassNames] = (0,external_react_.useState)(getStaticStateClasses(stateClasses.current, height));
    // ------------------ Did mount
    (0,external_react_.useEffect)(() => {
        // Hide content if height is 0 (to prevent tabbing into it)
        hideContent(contentElement.current, currentHeight);
        // This should be explicitly run only on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // ------------------ Height update
    (0,external_react_.useEffect)(() => {
        if (height !== prevHeight.current && contentElement.current) {
            showContent(contentElement.current, prevHeight.current);
            // Cache content height
            contentElement.current.style.overflow = 'hidden';
            const contentHeight = contentElement.current.offsetHeight;
            contentElement.current.style.overflow = '';
            // set total animation time
            const totalDuration = duration + delay;
            let newHeight;
            let timeoutHeight;
            let timeoutOverflow = 'hidden';
            let timeoutUseTransitions;
            const isCurrentHeightAuto = prevHeight.current === 'auto';
            if (typeof height === 'number') {
                // Reset negative height to 0
                newHeight = height < 0 ? 0 : height;
                timeoutHeight = newHeight;
            }
            else if (isPercentage(height)) {
                // If value is string "0%" make sure we convert it to number 0
                newHeight = height === '0%' ? 0 : height;
                timeoutHeight = newHeight;
            }
            else {
                // If not, animate to content height
                // and then reset to auto
                newHeight = contentHeight; // TODO solve contentHeight = 0
                timeoutHeight = 'auto';
                timeoutOverflow = undefined;
            }
            if (isCurrentHeightAuto) {
                // This is the height to be animated to
                timeoutHeight = newHeight;
                // If previous height was 'auto'
                // set starting height explicitly to be able to use transition
                newHeight = contentHeight;
            }
            // Animation classes
            const newAnimationStateClassNames = [
                stateClasses.current.animating,
                (prevHeight.current === 'auto' || height < prevHeight.current) &&
                    stateClasses.current.animatingUp,
                (height === 'auto' || height > prevHeight.current) &&
                    stateClasses.current.animatingDown,
                timeoutHeight === 0 && stateClasses.current.animatingToHeightZero,
                timeoutHeight === 'auto' && stateClasses.current.animatingToHeightAuto,
                timeoutHeight > 0 && stateClasses.current.animatingToHeightSpecific,
            ]
                .filter((v) => v)
                .join(' ');
            // Animation classes to be put after animation is complete
            const timeoutAnimationStateClasses = getStaticStateClasses(stateClasses.current, timeoutHeight);
            // Set starting height and animating classes
            // When animating from 'auto' we first need to set fixed height
            // that change should be animated
            setCurrentHeight(newHeight);
            setOverflow('hidden');
            setUseTransitions(!isCurrentHeightAuto);
            setAnimationStateClassNames(newAnimationStateClassNames);
            // Clear timeouts
            clearTimeout(timeoutID.current);
            clearTimeout(animationClassesTimeoutID.current);
            if (isCurrentHeightAuto) {
                // When animating from 'auto' we use a short timeout to start animation
                // after setting fixed height above
                timeoutUseTransitions = true;
                // Short timeout to allow rendering of the initial animation state first
                timeoutID.current = setTimeout(() => {
                    setCurrentHeight(timeoutHeight);
                    setOverflow(timeoutOverflow);
                    setUseTransitions(timeoutUseTransitions);
                    // ANIMATION STARTS, run a callback if it exists
                    onHeightAnimationStart === null || onHeightAnimationStart === void 0 ? void 0 : onHeightAnimationStart(timeoutHeight);
                }, 50);
                // Set static classes and remove transitions when animation ends
                animationClassesTimeoutID.current = setTimeout(() => {
                    setUseTransitions(false);
                    setAnimationStateClassNames(timeoutAnimationStateClasses);
                    // ANIMATION ENDS
                    // Hide content if height is 0 (to prevent tabbing into it)
                    hideContent(contentElement.current, timeoutHeight);
                    // Run a callback if it exists
                    onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 ? void 0 : onHeightAnimationEnd(timeoutHeight);
                }, totalDuration);
            }
            else {
                // ANIMATION STARTS, run a callback if it exists
                onHeightAnimationStart === null || onHeightAnimationStart === void 0 ? void 0 : onHeightAnimationStart(newHeight);
                // Set end height, classes and remove transitions when animation is complete
                timeoutID.current = setTimeout(() => {
                    setCurrentHeight(timeoutHeight);
                    setOverflow(timeoutOverflow);
                    setUseTransitions(false);
                    setAnimationStateClassNames(timeoutAnimationStateClasses);
                    // ANIMATION ENDS
                    // If height is auto, don't hide the content
                    // (case when element is empty, therefore height is 0)
                    if (height !== 'auto') {
                        // Hide content if height is 0 (to prevent tabbing into it)
                        hideContent(contentElement.current, newHeight); // TODO solve newHeight = 0
                    }
                    // Run a callback if it exists
                    onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 ? void 0 : onHeightAnimationEnd(newHeight);
                }, totalDuration);
            }
        }
        prevHeight.current = height;
        return () => {
            clearTimeout(timeoutID.current);
            clearTimeout(animationClassesTimeoutID.current);
        };
        // This should be explicitly run only on height change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [height]);
    // ------------------ Render
    const componentStyle = Object.assign(Object.assign({}, style), { height: currentHeight, overflow: overflow || (style === null || style === void 0 ? void 0 : style.overflow) });
    if (useTransitions && applyInlineTransitions) {
        componentStyle.transition = `height ${duration}ms ${easing} ${delay}ms`;
        // Include transition passed through styles
        if (style === null || style === void 0 ? void 0 : style.transition) {
            componentStyle.transition = `${style.transition}, ${componentStyle.transition}`;
        }
        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
    }
    const contentStyle = {};
    if (animateOpacity) {
        contentStyle.transition = `opacity ${duration}ms ${easing} ${delay}ms`;
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;
        if (currentHeight === 0) {
            contentStyle.opacity = 0;
        }
    }
    // Check if user passed aria-hidden prop
    const hasAriaHiddenProp = typeof divProps['aria-hidden'] !== 'undefined';
    const ariaHidden = hasAriaHiddenProp ? divProps['aria-hidden'] : height === 0;
    return (external_react_.createElement("div", Object.assign({}, divProps, { "aria-hidden": ariaHidden, className: `${animationStateClassNames} ${className}`, style: componentStyle }),
        external_react_.createElement("div", { className: contentClassName, style: contentStyle, ref: contentElement }, children)));
};
/* harmony default export */ const dist_esm = (AnimateHeight);

;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/tabs-core.js
var tabs_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const TabsContext = external_react_.createContext({
    currentTab: '',
    setCurrentTab: /* istanbul ignore next */ () => null,
});
function tabs_core_BEM(props) {
    const classArray = ['tabs'];
    if (props.align) {
        classArray.push('tabs--' + props.align);
    }
    if (props.border) {
        classArray.push('tabs--border-' + props.border);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const TabsCore = (props) => {
    const getContent = () => {
        if (props.disableAnalyticsTrigger) {
            return external_react_.createElement(TabsCoreInner, Object.assign({}, props));
        }
        return (external_react_.createElement(analytics_trigger/* default */.Z, { trigger: {
                callback: 'onTabChange',
                id: ([, nextTab]) => `Tabs - ${nextTab}`,
                elementId: ([, nextTab]) => `${nextTab}`,
                elementType: 'tab',
                interactionType: 'open',
            } },
            external_react_.createElement(TabsCoreInner, Object.assign({}, props))));
    };
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "Tabs", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" }, getContent()));
};
const TabsCoreInner = (props) => {
    const { TabsItem, TabsNav } = props.components;
    const [innerCurrentTab, setInnerCurrentTab] = external_react_.useState(props.defaultCurrentTab || '');
    const [height, setHeight] = external_react_.useState('auto');
    const [heightOnAnimationEnd, setHeightOnAnimationEnd] = external_react_.useState(0);
    const isCurrentTabControlled = (tab = props.currentTab) => {
        return !!props.onTabChange && typeof tab !== 'undefined';
    };
    const currentTab = isCurrentTabControlled(props.currentTab) ? props.currentTab : innerCurrentTab;
    const setCurrentTab = (id) => {
        if (id === currentTab) {
            return;
        }
        Promise.resolve()
            .then(() => setHeight(heightOnAnimationEnd))
            .then(() => {
            if (currentTab !== id) {
                if (!isCurrentTabControlled()) {
                    setInnerCurrentTab(id);
                }
                if (props.onTabChange) {
                    props.onTabChange(currentTab, id);
                }
                setHeight('auto');
            }
        });
    };
    const getNavItems = () => {
        return external_react_.Children.toArray(props.children).filter((child) => {
            return external_react_.isValidElement(child) && (child.type === TabsItem || child.type === props.itemComponent);
        }).map((item) => {
            const _a = item.props, { children, label, id } = _a, rest = tabs_core_rest(_a, ["children", "label", "id"]);
            return Object.assign(Object.assign({}, rest), { 'id': `${id}-nav-item`, 'current': currentTab === id, 'onClick': () => setCurrentTab(id), 'text': label, 'url': `#${id}`, 'aria-controls': id, 'aria-label': label });
        });
    };
    return (external_react_.createElement(TabsContext.Provider, { value: {
            currentTab,
            setCurrentTab,
        } },
        external_react_.createElement("div", { className: tabs_core_BEM(props) },
            external_react_.createElement(TabsNav, { items: getNavItems(), "aria-labelledby": props['aria-labelledby'] }),
            external_react_.createElement(dist_esm, { className: "tabs__content", height: height, duration: 300, onHeightAnimationEnd: (newHeight) => setHeightOnAnimationEnd(newHeight), applyInlineTransitions: false, style: { transition: 'height 300ms cubic-bezier(0.22, 0.61, 0.35, 1)' } }, props.children))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs-item/tabs-item-core.js



const TabsItemCore = (props) => {
    const { components, className, id, children } = props;
    const { HashTrigger, VisibilityProvider } = components;
    const { currentTab, setCurrentTab } = external_react_.useContext(TabsContext);
    const isCurrent = id === currentTab;
    function BEM() {
        const classArray = ['tabs__item'];
        if (isCurrent) {
            classArray.push('is-current');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (external_react_.createElement(VisibilityProvider, { isVisible: isCurrent },
        external_react_.createElement(HashTrigger, { id: id, onMatch: () => setCurrentTab(id), renderWrapper: false },
            external_react_.createElement(CSSTransition/* default */.Z, { in: isCurrent, timeout: 300, classNames: "fade" },
                external_react_.createElement("div", { className: BEM(), id: id, tabIndex: 0, role: "tabpanel", "aria-labelledby": `${id}-nav-item` }, isCurrent && children)))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs-item/tabs-item.js




const TabsItem = (props) => {
    return (external_react_.createElement(TabsItemCore, Object.assign({}, props, { components: {
            HashTrigger: HashTrigger,
            VisibilityProvider: VisibilityProvider,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/use-overflow-items.js


const useOverflowItems = (props) => {
    const { disabled, element, items, } = props;
    const [overflowItemsCount, setOverflowItemsCount] = external_react_.useState(0);
    const itemLabels = items.map((i) => i.text).join(' ');
    const updateLeftoverItemsCount = external_react_.useCallback(() => {
        const el = element.current;
        /* istanbul ignore else */
        if (el) {
            const { scrollWidth, clientWidth } = el;
            if (scrollWidth > (clientWidth + 1)) {
                // querySelectorAll is not very React-y, but a lot simpler than having to maintain all children refs etc.
                const listItems = el.querySelectorAll('li.tabs__nav-item:not(.sr-only)');
                // do not hide last item
                if (listItems.length > 1) {
                    let width = 0;
                    let count = 0;
                    listItems.forEach((item, index) => {
                        if (scrollWidth - clientWidth > width && index < listItems.length) {
                            width += item.clientWidth;
                            count++;
                        }
                    });
                    setOverflowItemsCount((prevCount) => Math.min(prevCount + count, items.length));
                }
            }
        }
    }, [element, items.length]);
    external_react_.useEffect(() => {
        const handleResize = (0,debounce.debounce)(() => {
            // if count is > 0, the last useEffect hook will take care of updating
            // if count is 0, setting it to 0 does not trigger update so the last hook will not fire
            setOverflowItemsCount((prevCount) => {
                if (prevCount === 0) {
                    updateLeftoverItemsCount();
                }
                return 0;
            });
        }, 100);
        /* istanbul ignore else */
        if (!disabled) {
            window.addEventListener('resize', handleResize);
        }
        return () => {
            window.removeEventListener('resize', handleResize);
            handleResize.clear();
        };
    }, [disabled, updateLeftoverItemsCount]);
    external_react_.useEffect(() => {
        /* istanbul ignore else */
        if (!disabled) {
            setOverflowItemsCount((prevCount) => {
                if (prevCount === 0) {
                    updateLeftoverItemsCount();
                }
                return 0;
            });
        }
    }, [disabled, itemLabels, updateLeftoverItemsCount]);
    external_react_.useEffect(() => {
        /* istanbul ignore else */
        if (!disabled) {
            window.setTimeout(() => {
                updateLeftoverItemsCount();
            });
        }
    }, [updateLeftoverItemsCount, disabled, overflowItemsCount]);
    const orderedItems = external_react_.useMemo(() => {
        if (!disabled && overflowItemsCount) {
            // move current item out of dropdown so user can see current tab
            const currentIndex = items.findIndex((i) => i.current);
            const visibleItemsCount = items.length - overflowItemsCount;
            if (currentIndex >= visibleItemsCount) {
                const currentItem = items[currentIndex];
                const otherItems = items.filter((i) => !i.current);
                const beforeItems = visibleItemsCount === 0 ? [] : otherItems.slice(0, visibleItemsCount - 1);
                const afterItems = visibleItemsCount === 0 ? otherItems : otherItems.slice(visibleItemsCount - 1, items.length);
                return [
                    ...beforeItems,
                    currentItem,
                    ...afterItems,
                ];
            }
        }
        return items;
    }, [items, disabled, overflowItemsCount]);
    return {
        items: orderedItems,
        overflowItems: overflowItemsCount > 0 ? orderedItems.slice(1).slice(overflowItemsCount * -1) : [],
    };
};

;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/tabs-nav-core.js



const TabsNavCore = (props) => {
    const { Dropdown, TabsNavItem } = props.components;
    const innerElement = external_react_.useRef(null);
    const activeElement = external_react_.useRef(null);
    const underline = external_react_.useRef();
    const [isDropdownOpen, setIsDropdownOpen] = external_react_.useState(false);
    const [focusedElementIndex, setFocusedElementIndex] = external_react_.useState(-1);
    const [animatingUnderline, setAnimatingUnderline] = external_react_.useState(false);
    const timeout = 0;
    let activeItem = null;
    const { items, overflowItems } = useOverflowItems({
        element: innerElement,
        disabled: !!props.disableDropdown,
        items: props.items,
    });
    const visibleItemsCount = items.length - overflowItems.length;
    const { widthFormatter, leftFormatter, } = props;
    const BEM = () => {
        const classArray = ['tabs__nav'];
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const underlineBEM = () => {
        const classArray = ['tabs__nav-underline'];
        if (underline.current && underline.current.type) {
            classArray.push('tabs__nav-underline--type-' + underline.current.type);
        }
        if (animatingUnderline) {
            classArray.push('is-animating');
        }
        return classArray.join(' ');
    };
    const getUnderlineStyle = () => {
        return {
            maxWidth: (underline.current && !Number.isNaN(underline.current.width)) ? underline.current.width : 0,
            left: underline.current && underline.current.left,
        };
    };
    const updateUnderline = external_react_.useCallback((item, isResizing = false) => {
        var _a;
        if (activeElement.current) {
            const style = getComputedStyle(activeElement.current);
            const newUnderlineProps = {
                width: widthFormatter ? widthFormatter(activeElement) : parseFloat(style.width) - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight),
                left: leftFormatter ? leftFormatter(activeElement, innerElement) : activeElement.current.offsetLeft,
                type: item ? item.type : (_a = underline.current) === null || _a === void 0 ? void 0 : _a.type,
            };
            if (underline.current !== newUnderlineProps) {
                underline.current = newUnderlineProps;
                if (!isResizing) {
                    setAnimatingUnderline(true);
                    window.clearTimeout(timeout);
                    window.setTimeout(() => {
                        setAnimatingUnderline(false);
                    }, 300);
                }
            }
        }
    }, [widthFormatter, leftFormatter]);
    const setActiveElement = (element, item) => {
        if (element && activeElement.current !== element && item.current) {
            activeElement.current = element;
            activeItem = item;
            if (innerElement.current) {
                updateUnderline(activeItem);
            }
        }
    };
    const resizeHandler = (isResizing) => {
        updateUnderline(undefined, isResizing);
    };
    const debouncedResizeHandler = (0,debounce.debounce)(resizeHandler.bind(undefined, true), 100);
    external_react_.useEffect(() => {
        window.addEventListener('resize', debouncedResizeHandler);
        return () => {
            window.removeEventListener('resize', debouncedResizeHandler);
            debouncedResizeHandler.clear();
        };
    });
    const handleClick = (item, event) => {
        event.preventDefault();
        setIsDropdownOpen(false);
        if (item.onClick) {
            item.onClick(event);
        }
    };
    const handleKeyUp = (event) => {
        event.preventDefault();
        event.stopPropagation();
        let tabs = [];
        if (innerElement.current instanceof Element) {
            tabs = Array.from(innerElement.current.querySelectorAll('[role="tab"]'));
        }
        const focusPosition = document.activeElement ? tabs.indexOf(document.activeElement) : 0;
        switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                if (focusPosition > 0) {
                    focusTab(focusPosition - 1, tabs);
                }
                else {
                    focusTab(tabs.length - 1, tabs);
                }
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                if (focusPosition < tabs.length - 1) {
                    focusTab(focusPosition + 1, tabs);
                }
                else {
                    focusTab(0, tabs);
                }
                break;
            case 'Home':
                focusTab(0, tabs);
                break;
            case 'End':
                focusTab(tabs.length - 1, tabs);
                break;
            case ' ':
            case 'Enter': {
                if (event.target instanceof HTMLElement) {
                    const tab = event.target;
                    tab.click();
                    setFocusedElementIndex(tabs.indexOf(tab));
                }
                break;
            }
        }
    };
    const focusTab = (index, tabs) => {
        const element = tabs[index];
        element.focus();
        setFocusedElementIndex(index);
    };
    const handleKeyDown = (event) => {
        switch (event.key) {
            case 'Tab':
                if (isDropdownOpen) {
                    setIsDropdownOpen(false);
                }
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
            case 'ArrowRight':
            case 'ArrowDown':
                // prevent document scroll when navigating with arrow keys
                event.preventDefault();
                break;
        }
        if (props.onKeyDown) {
            props.onKeyDown(event);
        }
    };
    external_react_.useEffect(() => {
        if (focusedElementIndex >= visibleItemsCount) {
            setIsDropdownOpen(true);
        }
        else {
            setIsDropdownOpen(false);
        }
    }, [props.disableDropdown, focusedElementIndex, visibleItemsCount]);
    external_react_.useEffect(() => {
        var _a;
        if ((_a = props.elementRef) === null || _a === void 0 ? void 0 : _a.current) {
            innerElement.current = props.elementRef.current;
        }
    }, [props.elementRef]);
    external_react_.useEffect(() => {
        if (activeElement.current && innerElement.current && activeItem) {
            updateUnderline(activeItem);
        }
    }, [activeElement, innerElement, activeItem, updateUnderline]);
    return (external_react_.createElement("div", { className: BEM(), onKeyUp: handleKeyUp, onKeyDown: handleKeyDown },
        underline && visibleItemsCount - 1 >= focusedElementIndex && (external_react_.createElement("span", { className: underlineBEM(), style: getUnderlineStyle() })),
        !!items.length && (external_react_.createElement("ul", { className: "tabs__nav-inner", ref: innerElement, role: "tablist", "aria-labelledby": props['aria-labelledby'] }, items.map((item, index) => (external_react_.createElement(TabsNavItem, Object.assign({}, item, { onClick: (event) => handleClick(item, event), key: item.id || index, tabIndex: item.current ? 0 : -1, onlyChild: index === 0 && visibleItemsCount === 1, "aria-selected": item.current, className: index > (visibleItemsCount - 1) ? 'sr-only' : undefined, elementRef: (element) => setActiveElement(element, item) })))))),
        !props.disableDropdown && overflowItems.length > 0 && (external_react_.createElement(Dropdown, { id: `${props['aria-labelledby']}-dropdown`, button: {
                icon: '#more-vertical',
                // empty string is OK here because the element is hidden from screen readers with aria-hidden
                text: '',
                size: 'small',
                variant: 'secondary',
                className: 'tabs__nav-dropdown-button',
                attributes: {
                    'tabIndex': -1,
                    'aria-hidden': true,
                },
            }, isOpen: isDropdownOpen, onToggle: setIsDropdownOpen, width: "auto", align: "end", items: overflowItems.map((item, index) => {
                return Object.assign(Object.assign({}, item), { label: item.text, url: item.url, onClick: (event) => handleClick(item, event), isActive: focusedElementIndex === (visibleItemsCount + index), icon: item.icon, tabIndex: -1, id: `${item.id}-dropdown`, color: item.type, elementRef: (element) => setActiveElement(element, item) });
            }) })),
        props.children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/tabs-nav-item-core.js
var tabs_nav_item_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const TabsNavItemCore = (props) => {
    const { children, components, className, current, text, type, icon, id, onlyChild } = props, rest = tabs_nav_item_core_rest(props, ["children", "components", "className", "current", "text", "type", "icon", "id", "onlyChild"]);
    const { Anchor, Icon } = components;
    function BEM() {
        const classArray = ['tabs__nav-item'];
        if (current) {
            classArray.push('is-current');
        }
        if (onlyChild) {
            classArray.push('tabs__nav-item--only-child');
        }
        if (type) {
            classArray.push('tabs__nav-item--' + type);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (external_react_.createElement("li", { className: BEM(), id: props.id, role: "presentation" },
        external_react_.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: "tabs__nav-link", role: "tab" }),
            icon && (external_react_.createElement(Icon, { modifiers: icon, align: "middle", className: "tabs__nav-item-icon" })),
            external_react_.createElement("div", { className: "tabs__nav-link-inner" }, children || text))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/tabs-nav-item.js




const TabsNavItem = (props) => {
    const { current = false } = props;
    return (external_react_.createElement(TabsNavItemCore, Object.assign({}, props, { current: current, components: {
            Anchor: anchor_esm_anchor,
            Icon: icon/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/tabs-nav.js




const TabsNav = (props) => {
    return (external_react_.createElement(TabsNavCore, Object.assign({}, props, { components: {
            Dropdown: dropdown,
            TabsNavItem: TabsNavItem,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/tabs/tabs.js
var tabs_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const Tabs = (props) => {
    const rest = tabs_rest(props, []);
    return (external_react_.createElement(TabsCore, Object.assign({}, rest, { components: {
            TabsItem: TabsItem,
            TabsNav: TabsNav,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tab-cordion/esm/tab-cordion/tab-cordion-core.js




const TabCordionCore = (props) => {
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "TabCordion", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" },
        external_react_.createElement(TabCordionInner, Object.assign({}, props))));
};
class TabCordionInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.onTabChange = (prevTab, nextTab) => {
            if (this.currentTab !== nextTab) {
                if (!this.isCurrentTabControlled()) {
                    this.setState({
                        currentTab: nextTab,
                    });
                }
            }
            /* istanbul ignore else */
            if (this.props.onTabChange) {
                this.props.onTabChange(prevTab, nextTab);
            }
        };
        this.onAccordionChange = (nextOpenId) => {
            if (!this.isCurrentTabControlled()) {
                this.setState({
                    currentTab: nextOpenId,
                });
            }
            /* istanbul ignore else */
            if (this.props.onTabChange) {
                this.props.onTabChange(this.currentTab, nextOpenId);
            }
        };
        this.renderAccordionItem = (props) => {
            const { AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, } = this.props.components;
            return (external_react_.createElement(AccordionItem, { className: props.className, type: props.type, icon: props.icon, id: props.id },
                external_react_.createElement(AccordionHeader, null,
                    external_react_.createElement(AccordionTitle, null, props.label)),
                external_react_.createElement(AccordionContent, null, props.children)));
        };
        this.state = {
            currentTab: props.defaultCurrentTab,
            isMounted: false,
        };
    }
    componentDidMount() {
        const { breakPoints } = this.context;
        const { breakPoint } = this.props;
        this.setState({
            isMounted: true,
        });
        if (window.matchMedia(`(max-width: ${breakPoints[breakPoint] - 1}px)`).matches) {
            this.onTabChange(this.currentTab, null);
        }
    }
    get currentTab() {
        return this.isCurrentTabControlled(this.props.currentTab) ? this.props.currentTab || this.props.defaultCurrentTab : this.state.currentTab || this.props.defaultCurrentTab;
    }
    get currentAccordion() {
        return this.isCurrentTabControlled(this.props.currentTab) ? this.props.currentTab : this.state.currentTab;
    }
    isCurrentTabControlled(currentTab = this.props.currentTab) {
        return !!this.props.onTabChange && typeof currentTab !== 'undefined';
    }
    BEM() {
        const classArray = ['tab-cordion'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    mapChildren(isAccordion = false) {
        const { TabsItem, } = this.props.components;
        return external_react_.Children.toArray(this.props.children).filter((child) => {
            return external_react_.isValidElement(child) && child.type === TabsItem;
        }).map((child) => {
            if (isAccordion) {
                const AccordionItem = this.props.accordionItemRenderer || this.renderAccordionItem;
                const props = Object.assign(Object.assign({}, child.props), { className: 'tab-cordion__item' });
                return (external_react_.createElement(AccordionItem, Object.assign({}, props, { key: child.props.id })));
            }
            else {
                return external_react_.cloneElement(child, {
                    icon: !this.props.hideIconsOnTabs ? child.props.icon : undefined,
                });
            }
        });
    }
    renderTabs() {
        const { Tabs } = this.props.components;
        return (external_react_.createElement(Tabs, Object.assign({}, this.props, { currentTab: this.currentTab, onTabChange: this.onTabChange }), this.mapChildren()));
    }
    renderAccordion() {
        const { Accordion } = this.props.components;
        return (external_react_.createElement(Accordion, { openItem: this.currentAccordion, onToggle: this.onAccordionChange, className: this.BEM(), bordered: false }, this.mapChildren(true)));
    }
    renderTabCordion() {
        const { breakPoints } = this.context;
        const { breakPoint } = this.props;
        return (external_react_.createElement((react_responsive_default()), { maxWidth: breakPoints[breakPoint] - 1 }, (matches) => matches ? this.renderAccordion() : this.renderTabs()));
    }
    render() {
        return this.state.isMounted ? this.renderTabCordion() : this.renderTabs();
    }
}
TabCordionInner.contextType = esm_theme_provider_core/* ThemeContext */.Ni;
TabCordionInner.defaultProps = {
    breakPoint: 'sm',
};
/* harmony default export */ const tab_cordion_core = (TabCordionCore);

;// CONCATENATED MODULE: ./node_modules/@core-front/tab-cordion/esm/tab-cordion/tab-cordion.js




class TabCordion extends external_react_.Component {
    render() {
        return (external_react_.createElement(tab_cordion_core, Object.assign({}, this.props, { components: {
                Accordion: accordion,
                AccordionContent: AccordionContent,
                AccordionHeader: AccordionHeader,
                AccordionItem: AccordionItem,
                AccordionTitle: AccordionTitle,
                Tabs: Tabs,
                TabsItem: TabsItem,
            } })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/tab-cordion/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/tabs/esm/index.js







;// CONCATENATED MODULE: ./node_modules/@core-front/tag/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/tag-group/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/text/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/textarea/esm/textarea-core.js

class TextAreaCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.textarea = null;
        this.hiddenTextarea = null;
        this.onChange = (value) => {
            if (typeof this.props.value === 'undefined') {
                this.setState({
                    value,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        };
        this.renderHiddenTextArea = () => {
            const hiddenInputRef = (el) => this.hiddenTextarea = el;
            return (external_react_.createElement(external_react_.Fragment, null,
                external_react_.createElement("label", { className: "textarea__label--hidden", htmlFor: `${this.props.id}-hidden` }, this.props.label),
                external_react_.createElement("textarea", { id: `${this.props.id}-hidden`, className: "textfield__input textarea__input textarea__input--hidden", value: this.value, ref: hiddenInputRef, readOnly: true, disabled: true })));
        };
        this.resizeHeight = this.resizeHeight.bind(this);
        this.state = {
            minHeight: 0,
            value: props.defaultValue || '',
        };
    }
    componentDidMount() {
        this.resizeHeight();
        window.addEventListener('resize', this.resizeHeight);
    }
    componentDidUpdate(prevProps, prevState) {
        const hasStateChanged = typeof this.props.value === 'undefined' && prevState.value !== this.state.value;
        const hasPropsChanged = typeof this.props.value !== 'undefined' && prevProps.value !== this.props.value;
        if (hasStateChanged || hasPropsChanged) {
            this.resizeHeight();
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeHeight);
    }
    get value() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
        }
        return this.props.onChange && typeof this.props.value !== 'undefined' ? this.props.value : this.state.value;
    }
    resizeHeight() {
        if (this.hiddenTextarea && this.textarea) {
            const textarea = window.getComputedStyle(this.textarea);
            const padding = parseInt(textarea.paddingBottom, 10) + parseInt(textarea.paddingTop, 10);
            const border = parseInt(textarea.borderBottomWidth, 10) + parseInt(textarea.borderTopWidth, 10);
            const lineHeight = parseInt(textarea.lineHeight, 10);
            const maxHeight = this.props.maxLines && (padding + border + (lineHeight * this.props.maxLines));
            const normalHeight = this.hiddenTextarea.scrollHeight + 1;
            const newHeight = this.props.maxLines ? Math.min(maxHeight || 0, normalHeight) : normalHeight;
            this.setState({
                minHeight: newHeight || 0,
            });
        }
    }
    BEM() {
        const classArray = ['textarea'];
        if (typeof this.props.maxLines !== 'undefined') {
            classArray.push('textarea--max-lines');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getStyle() {
        return { minHeight: this.state.minHeight };
    }
    render() {
        const inputRef = (el) => this.textarea = el;
        const { TextField } = this.props.components;
        return (external_react_.createElement(TextField, Object.assign({}, this.props, { inputRef: inputRef, isTextarea: true, className: this.BEM(), inputClass: "textarea__input", value: this.value, onChange: this.onChange, inputStyle: this.getStyle(), contentRenderer: this.renderHiddenTextArea })));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/textarea/esm/textarea.js



const TextArea = (props) => {
    return (external_react_.createElement(TextAreaCore, Object.assign({}, props, { components: {
            TextField: TextField,
        } })));
};
/* harmony default export */ const esm_textarea = (TextArea);

;// CONCATENATED MODULE: ./node_modules/@core-front/textarea/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/textfield/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/theme-provider/esm/theme-provider.js


const breakPoints = {
    xs: 320,
    sm: 600,
    md: 800,
    lg: 1000,
    xl: 1300,
};
const theme_provider_ThemeProvider = (props) => {
    return (external_react_.createElement(theme_provider_core, Object.assign({}, props, { breakPoints: breakPoints })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/lib/node_modules/@core-front/theme-provider/esm/index.js




;// CONCATENATED MODULE: ./node_modules/@core-front/toggle/esm/toggle-core.js




const Toggle = (props) => {
    return (external_react_.createElement(props_checker, { componentName: "Toggle", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled || props.loading },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onChange',
                id: ([checked]) => `Toggle - ${checked ? 'ON' : 'OFF'} - ${props.id}`,
                elementType: 'toggle',
                elementId: props.id,
                interactionType: ([checked]) => `${checked ? 'select' : 'deselect'}` } },
            external_react_.createElement(ToggleInner, Object.assign({}, props)))));
};
const ToggleInner = (props) => {
    const { label, onLabel, input, id, labelPosition = 'right', className, size, onChange, checked, defaultChecked, disabled, children, components, loading, loadingLabel, } = props;
    const labels = useLabels();
    const [innerChecked, setInnerChecked] = external_react_.useState(defaultChecked || false);
    const isChecked = onChange && typeof checked !== 'undefined' ? checked : innerChecked;
    const handleChange = () => {
        const nextChecked = !isChecked;
        if (disabled || loading) {
            return;
        }
        if (typeof checked === 'undefined') {
            setInnerChecked(nextChecked);
        }
        if (onChange) {
            onChange(nextChecked);
        }
    };
    const getLabels = (positions) => {
        const isCurrent = positions.includes(labelPosition);
        const { Spinner } = components;
        if (!isCurrent) {
            return null;
        }
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement("span", { className: "toggle__text toggle__text--off", "aria-hidden": !children }, children || label),
            onLabel && external_react_.createElement("span", { className: "toggle__text toggle__text--on", "aria-hidden": !children }, children || onLabel),
            loading && external_react_.createElement(Spinner, { className: "toggle__text toggle__text--loading" })));
    };
    const getSRLabel = () => {
        if (loading) {
            return loadingLabel || labels.get('loading');
        }
        return isChecked && onLabel ? onLabel : label;
    };
    function BEM() {
        const classArray = ['toggle'];
        if (size) {
            classArray.push('toggle--' + size);
        }
        if (onLabel) {
            classArray.push('toggle--with-on-label');
        }
        if (loading) {
            classArray.push('toggle--loading');
        }
        classArray.push(`toggle--with-label-${labelPosition}`);
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    function inputBEM() {
        const classArray = ['toggle__input'];
        if (input && input.className) {
            classArray.push(input.className);
        }
        return classArray.join(' ');
    }
    return (external_react_.createElement("div", { className: BEM() },
        external_react_.createElement("input", Object.assign({}, input, { type: "checkbox", id: id, className: inputBEM(), onChange: handleChange, checked: isChecked, defaultChecked: undefined, disabled: disabled || loading })),
        external_react_.createElement("label", { htmlFor: id, className: "toggle__label" }, getSRLabel()),
        external_react_.createElement("span", { className: "toggle__inner", onClick: handleChange },
            external_react_.createElement("span", { className: "toggle__indicator" }, getLabels(['inside'])),
            external_react_.createElement("span", { className: "toggle__label-wrapper" }, getLabels(['right', 'left'])))));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/toggle/esm/toggle.js



const toggle_Toggle = (props) => {
    return (external_react_.createElement(Toggle, Object.assign({}, props, { components: {
            Spinner: spinner/* default */.Z,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/toggle/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/tooltip/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/tooltip-toggle/esm/tooltip-toggle-core.js

class TooltipToggleCore extends external_react_.Component {
    BEM() {
        const classArray = ['tooltip-toggle'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.icon) {
            classArray.push('tooltip-toggle--icon');
        }
        if (this.props.color) {
            classArray.push(`tooltip-toggle--${this.props.color}`);
        }
        return classArray.join(' ');
    }
    render() {
        const { Icon } = this.props.components;
        return (external_react_.createElement("button", { className: this.BEM(), type: "button", id: this.props.id },
            external_react_.createElement("span", { className: "tooltip-toggle__inner" },
                external_react_.createElement("span", { className: "tooltip-toggle__text" }, this.props.children),
                this.props.icon && (external_react_.createElement(Icon, { modifiers: "#help", className: "tooltip-toggle__icon", size: "xs" })))));
    }
}

;// CONCATENATED MODULE: ./node_modules/@core-front/tooltip-toggle/esm/tooltip-toggle.js



const TooltipToggle = (props) => {
    return (external_react_.createElement(TooltipToggleCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } }), props.children));
};


;// CONCATENATED MODULE: ./node_modules/@core-front/tooltip-toggle/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/visibility-provider/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@core-front/video/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@core-front/lib/esm/index.js


/**
 * Polyfills
 */

/**
 * Components
 */
























































































//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_front_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(296);
/* harmony import */ var _core_front_helper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_core_front_helper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core_front_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8357);



const ObjectFitCore = (props) => {
    let imageRef;
    const [browserSupport, setBrowserSupport] = react__WEBPACK_IMPORTED_MODULE_0__.useState(true);
    const [imageHeight, setImageHeight] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
    const [imageWidth, setImageWidth] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
    const [style, setObject] = react__WEBPACK_IMPORTED_MODULE_0__.useState({});
    const prevWidth = (0,_core_front_helper__WEBPACK_IMPORTED_MODULE_1__/* .usePrevious */ .D)(imageWidth);
    const prevHeight = (0,_core_front_helper__WEBPACK_IMPORTED_MODULE_1__/* .usePrevious */ .D)(imageHeight);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (prevWidth !== imageWidth || prevHeight !== imageHeight) {
            setObjectFitStyles();
        }
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!('objectFit' in document.body.style) && browserSupport) {
            setBrowserSupport(false);
        }
    }, [browserSupport]);
    const BEM = (className) => {
        const classArray = ['object-fit'];
        const singlePositionAxis = props.positionX && props.positionX || props.positionY && props.positionY || undefined;
        if (props.fit) {
            classArray.push(`object-fit--${props.fit}`);
        }
        if (props.positionX && props.positionY) {
            classArray.push(`object-position--${props.positionY}-${props.positionX}`);
        }
        else if (singlePositionAxis) {
            classArray.push(`object-position--${singlePositionAxis}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const setContentStyleProperty = (property, value) => {
        const newStyle = {
            [property]: value,
        };
        setObject((prevState) => (Object.assign(Object.assign({}, prevState), newStyle)));
    };
    const onLoad = (event) => {
        const target = event.target;
        if (target instanceof HTMLImageElement && imageHeight !== target.naturalHeight) {
            setImageHeight(target.naturalHeight);
        }
        if (target instanceof HTMLImageElement && imageWidth !== target.naturalWidth) {
            setImageWidth(target.naturalWidth);
        }
    };
    const setObjectPosition = (posX, posY) => {
        if (posX && posY) {
            return posX.concat(' ' + posY);
        }
        return posX || posY;
    };
    const setObjectFitStyles = () => {
        if (browserSupport) {
            return;
        }
        const { fit, positionX, positionY } = props;
        const position = setObjectPosition(positionX, positionY);
        if (imageRef && imageRef.parentElement && !browserSupport) {
            const parentClientWidth = imageRef.parentElement.clientWidth;
            const parentClientHeight = imageRef.parentElement.clientHeight;
            const fitImageWidth = (imageWidth / imageHeight) * parentClientHeight;
            const fitImageHeight = (imageHeight / imageWidth) * parentClientWidth;
            // Reset any pre-set CSS
            setContentStyleProperty('position', 'absolute');
            setContentStyleProperty('width', 'auto');
            setContentStyleProperty('height', 'auto');
            if (fit === 'fill') {
                setContentStyleProperty('width', '100%');
                setContentStyleProperty('height', '100%');
                if (position) {
                    setPosition(parentClientWidth, 'x', position);
                    setPosition(parentClientHeight, 'y', position);
                }
                return;
            }
            else if ((fit === 'cover' && fitImageWidth >= parentClientWidth) || (fit === 'contain' && fitImageWidth < parentClientWidth)) {
                setContentStyleProperty('top', '0');
                setContentStyleProperty('marginTop', '0');
                setContentStyleProperty('maxWidth', 'none');
                setContentStyleProperty('width', fitImageWidth + 'px');
                setContentStyleProperty('height', parentClientHeight + 'px');
                if (position) {
                    setPosition(fitImageWidth, 'x', position);
                }
            }
            else {
                setContentStyleProperty('width', '100%');
                setContentStyleProperty('height', 'auto');
                setContentStyleProperty('left', '0');
                setContentStyleProperty('marginLeft', '0');
                if (position) {
                    setPosition(fitImageHeight, 'y', position);
                }
            }
        }
    };
    const debouncedResizeHandler = (0,_core_front_helper__WEBPACK_IMPORTED_MODULE_2__.debounce)(setObjectFitStyles, 50);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        window.addEventListener('resize', debouncedResizeHandler);
        return () => {
            window.removeEventListener('resize', debouncedResizeHandler);
            debouncedResizeHandler.clear();
        };
    }, [debouncedResizeHandler]);
    const setPosition = (imageSide, axis, objectPosition) => {
        let position;
        let other;
        let start;
        let end;
        let side;
        const objectPos = objectPosition.split(' ');
        if (objectPos.length < 2) {
            objectPos[1] = objectPos[0];
        }
        if (axis === 'x') {
            position = objectPos[0];
            other = objectPos[1];
            start = 'left';
            end = 'right';
            side = imageSide;
        }
        else if (axis === 'y') {
            position = objectPos[1];
            other = objectPos[0];
            start = 'top';
            end = 'bottom';
            side = imageSide;
        }
        else {
            return;
        }
        if (position === start || other === start) {
            setContentStyleProperty(start, '0');
            return;
        }
        if (position === end || other === end) {
            setContentStyleProperty(end, '0');
            return;
        }
        if (position === 'center' || position === '50%' || other === 'center' || other === '50%') {
            setContentStyleProperty(start, '50%');
            setContentStyleProperty('margin' + start.charAt(0).toUpperCase() + start.substring(1), (side / -2) + 'px');
            return;
        }
        // Percentage values
        if (position.indexOf('%') >= 0) {
            // tslint:disable-next-line:radix
            position = parseInt(position);
            if (position < 50) {
                setContentStyleProperty(end, position + '%');
                setContentStyleProperty('margin' + start.charAt(0).toUpperCase() + start.substring(1), (position / -100) + 'px');
            }
            else {
                position = 100 - position;
                setContentStyleProperty(end, position + '%');
                setContentStyleProperty('margin' + end.charAt(0).toUpperCase() + end.substring(1), (position / -100) + 'px');
            }
        }
        else {
            // length-based values
            setContentStyleProperty(start, position);
        }
    };
    const mapChildren = () => {
        const { Image } = props.components;
        return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(props.children).filter((child) => {
            return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === Image;
        }).map((child) => {
            return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
                className: BEM(child.props.className),
                imageRef: (el) => imageRef = el,
                onLoad: (e) => onLoad(e),
                style: !browserSupport ? style : undefined,
            });
        });
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, mapChildren()));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ObjectFitCore);


/***/ }),

/***/ 5936:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ObjectFit)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_front_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2429);
/* harmony import */ var _object_fit_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1418);



const ObjectFit = (props) => {
    const { children, } = props;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_object_fit_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({}, props, { components: {
            Image: _core_front_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        } }), children));
};



/***/ }),

/***/ 4490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const SkeletonItem = (props) => {
    const { className, width, height } = props;
    const BEM = () => {
        const classArray = ['skeleton__item'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: BEM(), style: { width, height } }, "\u200C"));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SkeletonItem);


/***/ }),

/***/ 1127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const Skeleton = (props) => {
    const { label, className, children } = props;
    const BEM = () => {
        const classArray = ['skeleton'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: BEM() },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "skeleton__content", "aria-hidden": true }, children),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "sr-only" }, label)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Skeleton);


/***/ }),

/***/ 420:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ Spinner)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const Spinner = (props) => {
    const { className, text } = props;
    const BEM = () => {
        const classArray = ['spinner'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: BEM() },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { className: "spinner__circle", viewBox: "25 25 50 50", focusable: "false" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { className: "spinner__path", cx: "50", cy: "50", r: "22", fill: "none" })),
        text && react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: "spinner__text" }, text)));
};



/***/ }),

/***/ 9210:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ni": () => (/* binding */ ThemeContext)
/* harmony export */ });
/* unused harmony export defaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frctl_react_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3252);
/* harmony import */ var _frctl_react_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_frctl_react_components__WEBPACK_IMPORTED_MODULE_1__);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const defaultContext = {
    getIconPath: (name) => name,
    breakPoints: {
        xs: 320,
        sm: 600,
        md: 800,
        lg: 1000,
        xl: 1200,
    },
    locale: undefined,
};
const ThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultContext);
const ThemeProviderCore = (props) => {
    const { children, getIconPath } = props, rest = __rest(props, ["children", "getIconPath"]);
    const path = usePath();
    return (React.createElement(ThemeContext.Provider, { value: Object.assign(Object.assign({}, rest), { getIconPath: (iconPath) => path.get(getIconPath(iconPath)) }) }, children));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProviderCore)));


/***/ }),

/***/ 3286:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ useTheme)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _theme_provider_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9210);


const useTheme = () => {
    const theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_theme_provider_core__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .Ni);
    return theme;
};



/***/ }),

/***/ 4358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ navigate)
/* harmony export */ });
const navigate = (event) => {
    if (window.core && window.core.navigate) {
        window.core.navigate(event);
    }
};


/***/ }),

/***/ 3252:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const PathProvider = __webpack_require__(7992);

module.exports = {
    PathProvider: PathProvider,
    PathContext: PathProvider.PathContext,
    usePath: PathProvider.usePath,
};


/***/ }),

/***/ 7992:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const React = __webpack_require__(8156);
const PropTypes = __webpack_require__(5697);

const PathContext = React.createContext({
    get: (path) => path,
});

const PathProvider = (props) => {
    const { children, ...rest } = props;

    return React.createElement(PathContext.Provider, { value: rest }, children);
};

PathProvider.propTypes = {
    children: PropTypes.node,
    get: PropTypes.func,
};

const usePath = () => {
    return React.useContext(PathContext);
};

module.exports = PathProvider;
module.exports.PathContext = PathContext;
module.exports.usePath = usePath;


/***/ }),

/***/ 4511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fi": () => (/* binding */ popper_createPopper)
});

// UNUSED EXPORTS: applyStyles, arrow, computeStyles, createPopperLite, defaultModifiers, detectOverflow, eventListeners, flip, hide, offset, popperGenerator, popperOffsets, preventOverflow

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ 6155:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Polyfills
 */
__webpack_require__(2445);
__webpack_require__(6337);
__webpack_require__(7090);
(__webpack_require__(523).polyfill)();


/***/ }),

/***/ 2599:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": () => (/* binding */ json),
/* harmony export */   "Ep": () => (/* binding */ createPath),
/* harmony export */   "Gn": () => (/* binding */ generatePath),
/* harmony export */   "LX": () => (/* binding */ matchPath),
/* harmony export */   "PP": () => (/* binding */ createMemoryHistory),
/* harmony export */   "PQ": () => (/* binding */ defer),
/* harmony export */   "RQ": () => (/* binding */ joinPaths),
/* harmony export */   "WK": () => (/* binding */ isRouteErrorResponse),
/* harmony export */   "X3": () => (/* binding */ AbortedDeferredError),
/* harmony export */   "Zn": () => (/* binding */ stripBasename),
/* harmony export */   "aU": () => (/* binding */ Action),
/* harmony export */   "cP": () => (/* binding */ parsePath),
/* harmony export */   "fp": () => (/* binding */ matchRoutes),
/* harmony export */   "i3": () => (/* binding */ resolvePath),
/* harmony export */   "kG": () => (/* binding */ invariant),
/* harmony export */   "lX": () => (/* binding */ createBrowserHistory),
/* harmony export */   "p7": () => (/* binding */ createRouter),
/* harmony export */   "pC": () => (/* binding */ resolveTo),
/* harmony export */   "q_": () => (/* binding */ createHashHistory),
/* harmony export */   "uX": () => (/* binding */ redirect)
/* harmony export */ });
/* unused harmony exports ErrorResponse, IDLE_FETCHER, IDLE_NAVIGATION, UNSAFE_convertRoutesToDataRoutes, getStaticContextFromError, getToPathname, normalizePathname, unstable_createStaticHandler, warning */
/**
 * @remix-run/router v1.0.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////

/**
 * Actions represent the type of change to a location value.
 */
var Action;

(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */

  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */

  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));

const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */

function createMemoryHistory(options) {
  if (options === void 0) {
    options = {};
  }

  let {
    initialEntries = ["/"],
    initialIndex,
    v5Compat = false
  } = options;
  let entries; // Declare so we can access from createMemoryLocation

  entries = initialEntries.map((entry, index) => createMemoryLocation(entry, null, index === 0 ? "default" : undefined));
  let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
  let action = Action.Pop;
  let listener = null;

  function clampIndex(n) {
    return Math.min(Math.max(n, 0), entries.length - 1);
  }

  function getCurrentLocation() {
    return entries[index];
  }

  function createMemoryLocation(to, state, key) {
    if (state === void 0) {
      state = null;
    }

    let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
    warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
    return location;
  }

  let history = {
    get index() {
      return index;
    },

    get action() {
      return action;
    },

    get location() {
      return getCurrentLocation();
    },

    createHref(to) {
      return typeof to === "string" ? to : createPath(to);
    },

    push(to, state) {
      action = Action.Push;
      let nextLocation = createMemoryLocation(to, state);
      index += 1;
      entries.splice(index, entries.length, nextLocation);

      if (v5Compat && listener) {
        listener({
          action,
          location: nextLocation
        });
      }
    },

    replace(to, state) {
      action = Action.Replace;
      let nextLocation = createMemoryLocation(to, state);
      entries[index] = nextLocation;

      if (v5Compat && listener) {
        listener({
          action,
          location: nextLocation
        });
      }
    },

    go(delta) {
      action = Action.Pop;
      index = clampIndex(index + delta);

      if (listener) {
        listener({
          action,
          location: getCurrentLocation()
        });
      }
    },

    listen(fn) {
      listener = fn;
      return () => {
        listener = null;
      };
    }

  };
  return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */

function createBrowserHistory(options) {
  if (options === void 0) {
    options = {};
  }

  function createBrowserLocation(window, globalHistory) {
    var _globalHistory$state, _globalHistory$state2;

    let {
      pathname,
      search,
      hash
    } = window.location;
    return createLocation("", {
      pathname,
      search,
      hash
    }, // state defaults to `null` because `window.history.state` does
    ((_globalHistory$state = globalHistory.state) == null ? void 0 : _globalHistory$state.usr) || null, ((_globalHistory$state2 = globalHistory.state) == null ? void 0 : _globalHistory$state2.key) || "default");
  }

  function createBrowserHref(window, to) {
    return typeof to === "string" ? to : createPath(to);
  }

  return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */

function createHashHistory(options) {
  if (options === void 0) {
    options = {};
  }

  function createHashLocation(window, globalHistory) {
    var _globalHistory$state3, _globalHistory$state4;

    let {
      pathname = "/",
      search = "",
      hash = ""
    } = parsePath(window.location.hash.substr(1));
    return createLocation("", {
      pathname,
      search,
      hash
    }, // state defaults to `null` because `window.history.state` does
    ((_globalHistory$state3 = globalHistory.state) == null ? void 0 : _globalHistory$state3.usr) || null, ((_globalHistory$state4 = globalHistory.state) == null ? void 0 : _globalHistory$state4.key) || "default");
  }

  function createHashHref(window, to) {
    let base = window.document.querySelector("base");
    let href = "";

    if (base && base.getAttribute("href")) {
      let url = window.location.href;
      let hashIndex = url.indexOf("#");
      href = hashIndex === -1 ? url : url.slice(0, hashIndex);
    }

    return href + "#" + (typeof to === "string" ? to : createPath(to));
  }

  function validateHashLocation(location, to) {
    warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
  }

  return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region UTILS
////////////////////////////////////////////////////////////////////////////////

function warning$1(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);

    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}

function createKey() {
  return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */


function getHistoryState(location) {
  return {
    usr: location.state,
    key: location.key
  };
}
/**
 * Creates a Location object with a unique key from the given Path
 */


function createLocation(current, to, state, key) {
  if (state === void 0) {
    state = null;
  }

  let location = _extends({
    pathname: typeof current === "string" ? current : current.pathname,
    search: "",
    hash: ""
  }, typeof to === "string" ? parsePath(to) : to, {
    state,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: (to == null ? void 0 : to.key) || key || createKey()
  });

  return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */

function createPath(_ref) {
  let {
    pathname = "/",
    search = "",
    hash = ""
  } = _ref;
  if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
  if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
  return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */

function parsePath(path) {
  let parsedPath = {};

  if (path) {
    let hashIndex = path.indexOf("#");

    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }

    let searchIndex = path.indexOf("?");

    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }

    if (path) {
      parsedPath.pathname = path;
    }
  }

  return parsedPath;
}

function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
  if (options === void 0) {
    options = {};
  }

  let {
    window = document.defaultView,
    v5Compat = false
  } = options;
  let globalHistory = window.history;
  let action = Action.Pop;
  let listener = null;

  function handlePop() {
    action = Action.Pop;

    if (listener) {
      listener({
        action,
        location: history.location
      });
    }
  }

  function push(to, state) {
    action = Action.Push;
    let location = createLocation(history.location, to, state);
    validateLocation == null ? void 0 : validateLocation(location, to);
    let historyState = getHistoryState(location);
    let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/

    try {
      globalHistory.pushState(historyState, "", url);
    } catch (error) {
      // They are going to lose state here, but there is no real
      // way to warn them about it since the page will refresh...
      window.location.assign(url);
    }

    if (v5Compat && listener) {
      listener({
        action,
        location
      });
    }
  }

  function replace(to, state) {
    action = Action.Replace;
    let location = createLocation(history.location, to, state);
    validateLocation == null ? void 0 : validateLocation(location, to);
    let historyState = getHistoryState(location);
    let url = history.createHref(location);
    globalHistory.replaceState(historyState, "", url);

    if (v5Compat && listener) {
      listener({
        action,
        location: location
      });
    }
  }

  let history = {
    get action() {
      return action;
    },

    get location() {
      return getLocation(window, globalHistory);
    },

    listen(fn) {
      if (listener) {
        throw new Error("A history only accepts one active listener");
      }

      window.addEventListener(PopStateEventType, handlePop);
      listener = fn;
      return () => {
        window.removeEventListener(PopStateEventType, handlePop);
        listener = null;
      };
    },

    createHref(to) {
      return createHref(window, to);
    },

    push,
    replace,

    go(n) {
      return globalHistory.go(n);
    }

  };
  return history;
} //#endregion

var ResultType;

(function (ResultType) {
  ResultType["data"] = "data";
  ResultType["deferred"] = "deferred";
  ResultType["redirect"] = "redirect";
  ResultType["error"] = "error";
})(ResultType || (ResultType = {})); // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router


function convertRoutesToDataRoutes(routes, parentPath, allIds) {
  if (parentPath === void 0) {
    parentPath = [];
  }

  if (allIds === void 0) {
    allIds = new Set();
  }

  return routes.map((route, index) => {
    let treePath = [...parentPath, index];
    let id = typeof route.id === "string" ? route.id : treePath.join("-");
    invariant(!allIds.has(id), "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
    allIds.add(id);

    let dataRoute = _extends({}, route, {
      id,
      children: route.children ? convertRoutesToDataRoutes(route.children, treePath, allIds) : undefined
    });

    return dataRoute;
  });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/match-routes
 */

function matchRoutes(routes, locationArg, basename) {
  if (basename === void 0) {
    basename = "/";
  }

  let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
  let pathname = stripBasename(location.pathname || "/", basename);

  if (pathname == null) {
    return null;
  }

  let branches = flattenRoutes(routes);
  rankRouteBranches(branches);
  let matches = null;

  for (let i = 0; matches == null && i < branches.length; ++i) {
    matches = matchRouteBranch(branches[i], pathname);
  }

  return matches;
}

function flattenRoutes(routes, branches, parentsMeta, parentPath) {
  if (branches === void 0) {
    branches = [];
  }

  if (parentsMeta === void 0) {
    parentsMeta = [];
  }

  if (parentPath === void 0) {
    parentPath = "";
  }

  routes.forEach((route, index) => {
    let meta = {
      relativePath: route.path || "",
      caseSensitive: route.caseSensitive === true,
      childrenIndex: index,
      route
    };

    if (meta.relativePath.startsWith("/")) {
      invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
      meta.relativePath = meta.relativePath.slice(parentPath.length);
    }

    let path = joinPaths([parentPath, meta.relativePath]);
    let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
    // route tree depth-first and child routes appear before their parents in
    // the "flattened" version.

    if (route.children && route.children.length > 0) {
      invariant(route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
      flattenRoutes(route.children, branches, routesMeta, path);
    } // Routes without a path shouldn't ever match by themselves unless they are
    // index routes, so don't add them to the list of possible branches.


    if (route.path == null && !route.index) {
      return;
    }

    branches.push({
      path,
      score: computeScore(path, route.index),
      routesMeta
    });
  });
  return branches;
}

function rankRouteBranches(branches) {
  branches.sort((a, b) => a.score !== b.score ? b.score - a.score // Higher score first
  : compareIndexes(a.routesMeta.map(meta => meta.childrenIndex), b.routesMeta.map(meta => meta.childrenIndex)));
}

const paramRe = /^:\w+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;

const isSplat = s => s === "*";

function computeScore(path, index) {
  let segments = path.split("/");
  let initialScore = segments.length;

  if (segments.some(isSplat)) {
    initialScore += splatPenalty;
  }

  if (index) {
    initialScore += indexRouteValue;
  }

  return segments.filter(s => !isSplat(s)).reduce((score, segment) => score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}

function compareIndexes(a, b) {
  let siblings = a.length === b.length && a.slice(0, -1).every((n, i) => n === b[i]);
  return siblings ? // If two routes are siblings, we should try to match the earlier sibling
  // first. This allows people to have fine-grained control over the matching
  // behavior by simply putting routes with identical paths in the order they
  // want them tried.
  a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
  // so they sort equally.
  0;
}

function matchRouteBranch(branch, pathname) {
  let {
    routesMeta
  } = branch;
  let matchedParams = {};
  let matchedPathname = "/";
  let matches = [];

  for (let i = 0; i < routesMeta.length; ++i) {
    let meta = routesMeta[i];
    let end = i === routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    let match = matchPath({
      path: meta.relativePath,
      caseSensitive: meta.caseSensitive,
      end
    }, remainingPathname);
    if (!match) return null;
    Object.assign(matchedParams, match.params);
    let route = meta.route;
    matches.push({
      // TODO: Can this as be avoided?
      params: matchedParams,
      pathname: joinPaths([matchedPathname, match.pathname]),
      pathnameBase: normalizePathname(joinPaths([matchedPathname, match.pathnameBase])),
      route
    });

    if (match.pathnameBase !== "/") {
      matchedPathname = joinPaths([matchedPathname, match.pathnameBase]);
    }
  }

  return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/generate-path
 */


function generatePath(path, params) {
  if (params === void 0) {
    params = {};
  }

  return path.replace(/:(\w+)/g, (_, key) => {
    invariant(params[key] != null, "Missing \":" + key + "\" param");
    return params[key];
  }).replace(/(\/?)\*/, (_, prefix, __, str) => {
    const star = "*";

    if (params[star] == null) {
      // If no splat was provided, trim the trailing slash _unless_ it's
      // the entire path
      return str === "/*" ? "/" : "";
    } // Apply the splat


    return "" + prefix + params[star];
  });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/match-path
 */

function matchPath(pattern, pathname) {
  if (typeof pattern === "string") {
    pattern = {
      path: pattern,
      caseSensitive: false,
      end: true
    };
  }

  let [matcher, paramNames] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
  let match = pathname.match(matcher);
  if (!match) return null;
  let matchedPathname = match[0];
  let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
  let captureGroups = match.slice(1);
  let params = paramNames.reduce((memo, paramName, index) => {
    // We need to compute the pathnameBase here using the raw splat value
    // instead of using params["*"] later because it will be decoded then
    if (paramName === "*") {
      let splatValue = captureGroups[index] || "";
      pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
    }

    memo[paramName] = safelyDecodeURIComponent(captureGroups[index] || "", paramName);
    return memo;
  }, {});
  return {
    params,
    pathname: matchedPathname,
    pathnameBase,
    pattern
  };
}

function compilePath(path, caseSensitive, end) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }

  if (end === void 0) {
    end = true;
  }

  warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
  let paramNames = [];
  let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
  .replace(/^\/*/, "/") // Make sure it has a leading /
  .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
  .replace(/:(\w+)/g, (_, paramName) => {
    paramNames.push(paramName);
    return "([^\\/]+)";
  });

  if (path.endsWith("*")) {
    paramNames.push("*");
    regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
    : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
  } else {
    regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
    : // Otherwise, match a word boundary or a proceeding /. The word boundary restricts
    // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[@.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
  }

  let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
  return [matcher, paramNames];
}

function safelyDecodeURIComponent(value, paramName) {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    warning(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
    return value;
  }
}
/**
 * @private
 */


function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;

  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  } // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it


  let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
  let nextChar = pathname.charAt(startIndex);

  if (nextChar && nextChar !== "/") {
    // pathname does not start with basename/
    return null;
  }

  return pathname.slice(startIndex) || "/";
}
function invariant(value, message) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}
/**
 * @private
 */

function warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);

    try {
      // Welcome to debugging React Router!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/resolve-path
 */

function resolvePath(to, fromPathname) {
  if (fromPathname === void 0) {
    fromPathname = "/";
  }

  let {
    pathname: toPathname,
    search = "",
    hash = ""
  } = typeof to === "string" ? parsePath(to) : to;
  let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
  return {
    pathname,
    search: normalizeSearch(search),
    hash: normalizeHash(hash)
  };
}

function resolvePathname(relativePath, fromPathname) {
  let segments = fromPathname.replace(/\/+$/, "").split("/");
  let relativeSegments = relativePath.split("/");
  relativeSegments.forEach(segment => {
    if (segment === "..") {
      // Keep the root "" segment so the pathname starts at /
      if (segments.length > 1) segments.pop();
    } else if (segment !== ".") {
      segments.push(segment);
    }
  });
  return segments.length > 1 ? segments.join("/") : "/";
}
/**
 * @private
 */


function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
  if (isPathRelative === void 0) {
    isPathRelative = false;
  }

  let to = typeof toArg === "string" ? parsePath(toArg) : _extends({}, toArg);
  let isEmptyPath = toArg === "" || to.pathname === "";
  let toPathname = isEmptyPath ? "/" : to.pathname;
  let from; // Routing is relative to the current pathname if explicitly requested.
  //
  // If a pathname is explicitly provided in `to`, it should be relative to the
  // route context. This is explained in `Note on `<Link to>` values` in our
  // migration guide from v5 as a means of disambiguation between `to` values
  // that begin with `/` and those that do not. However, this is problematic for
  // `to` values that do not provide a pathname. `to` can simply be a search or
  // hash string, in which case we should assume that the navigation is relative
  // to the current location's pathname and *not* the route pathname.

  if (isPathRelative || toPathname == null) {
    from = locationPathname;
  } else {
    let routePathnameIndex = routePathnames.length - 1;

    if (toPathname.startsWith("..")) {
      let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
      // URL segment".  This is a key difference from how <a href> works and a
      // major reason we call this a "to" value instead of a "href".

      while (toSegments[0] === "..") {
        toSegments.shift();
        routePathnameIndex -= 1;
      }

      to.pathname = toSegments.join("/");
    } // If there are more ".." segments than parent routes, resolve relative to
    // the root / URL.


    from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
  }

  let path = resolvePath(to, from); // Ensure the pathname has a trailing slash if the original "to" had one

  let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash

  let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");

  if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) {
    path.pathname += "/";
  }

  return path;
}
/**
 * @private
 */

function getToPathname(to) {
  // Empty strings should be treated the same as / paths
  return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */

const joinPaths = paths => paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */

const normalizePathname = pathname => pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */

const normalizeSearch = search => !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */

const normalizeHash = hash => !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */

const json = function json(data, init) {
  if (init === void 0) {
    init = {};
  }

  let responseInit = typeof init === "number" ? {
    status: init
  } : init;
  let headers = new Headers(responseInit.headers);

  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json; charset=utf-8");
  }

  return new Response(JSON.stringify(data), _extends({}, responseInit, {
    headers
  }));
};
class AbortedDeferredError extends Error {}
class DeferredData {
  constructor(data) {
    this.pendingKeys = new Set();
    this.subscriber = undefined;
    invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
    // cancellation

    let reject;
    this.abortPromise = new Promise((_, r) => reject = r);
    this.controller = new AbortController();

    let onAbort = () => reject(new AbortedDeferredError("Deferred data aborted"));

    this.unlistenAbortSignal = () => this.controller.signal.removeEventListener("abort", onAbort);

    this.controller.signal.addEventListener("abort", onAbort);
    this.data = Object.entries(data).reduce((acc, _ref) => {
      let [key, value] = _ref;
      return Object.assign(acc, {
        [key]: this.trackPromise(key, value)
      });
    }, {});
  }

  trackPromise(key, value) {
    if (!(value instanceof Promise)) {
      return value;
    }

    this.pendingKeys.add(key); // We store a little wrapper promise that will be extended with
    // _data/_error props upon resolve/reject

    let promise = Promise.race([value, this.abortPromise]).then(data => this.onSettle(promise, key, null, data), error => this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
    // errors or aborted deferred values

    promise.catch(() => {});
    Object.defineProperty(promise, "_tracked", {
      get: () => true
    });
    return promise;
  }

  onSettle(promise, key, error, data) {
    var _this$subscriber2;

    if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
      this.unlistenAbortSignal();
      Object.defineProperty(promise, "_error", {
        get: () => error
      });
      return Promise.reject(error);
    }

    this.pendingKeys.delete(key);

    if (this.done) {
      // Nothing left to abort!
      this.unlistenAbortSignal();
    }

    if (error) {
      var _this$subscriber;

      Object.defineProperty(promise, "_error", {
        get: () => error
      });
      (_this$subscriber = this.subscriber) == null ? void 0 : _this$subscriber.call(this, false);
      return Promise.reject(error);
    }

    Object.defineProperty(promise, "_data", {
      get: () => data
    });
    (_this$subscriber2 = this.subscriber) == null ? void 0 : _this$subscriber2.call(this, false);
    return data;
  }

  subscribe(fn) {
    this.subscriber = fn;
  }

  cancel() {
    var _this$subscriber3;

    this.controller.abort();
    this.pendingKeys.forEach((v, k) => this.pendingKeys.delete(k));
    (_this$subscriber3 = this.subscriber) == null ? void 0 : _this$subscriber3.call(this, true);
  }

  async resolveData(signal) {
    let aborted = false;

    if (!this.done) {
      let onAbort = () => this.cancel();

      signal.addEventListener("abort", onAbort);
      aborted = await new Promise(resolve => {
        this.subscribe(aborted => {
          signal.removeEventListener("abort", onAbort);

          if (aborted || this.done) {
            resolve(aborted);
          }
        });
      });
    }

    return aborted;
  }

  get done() {
    return this.pendingKeys.size === 0;
  }

  get unwrappedData() {
    invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
    return Object.entries(this.data).reduce((acc, _ref2) => {
      let [key, value] = _ref2;
      return Object.assign(acc, {
        [key]: unwrapTrackedPromise(value)
      });
    }, {});
  }

}

function isTrackedPromise(value) {
  return value instanceof Promise && value._tracked === true;
}

function unwrapTrackedPromise(value) {
  if (!isTrackedPromise(value)) {
    return value;
  }

  if (value._error) {
    throw value._error;
  }

  return value._data;
}

function defer(data) {
  return new DeferredData(data);
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */

const redirect = function redirect(url, init) {
  if (init === void 0) {
    init = 302;
  }

  let responseInit = init;

  if (typeof responseInit === "number") {
    responseInit = {
      status: responseInit
    };
  } else if (typeof responseInit.status === "undefined") {
    responseInit.status = 302;
  }

  let headers = new Headers(responseInit.headers);
  headers.set("Location", url);
  return new Response(null, _extends({}, responseInit, {
    headers
  }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */

class ErrorResponse {
  constructor(status, statusText, data) {
    this.status = status;
    this.statusText = statusText || "";
    this.data = data;
  }

}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */

function isRouteErrorResponse(e) {
  return e instanceof ErrorResponse;
}

const IDLE_NAVIGATION = {
  state: "idle",
  location: undefined,
  formMethod: undefined,
  formAction: undefined,
  formEncType: undefined,
  formData: undefined
};
const IDLE_FETCHER = {
  state: "idle",
  data: undefined,
  formMethod: undefined,
  formAction: undefined,
  formEncType: undefined,
  formData: undefined
}; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////

/**
 * Create a router and listen to history POP navigations
 */

function createRouter(init) {
  var _init$hydrationData, _init$hydrationData2, _init$hydrationData3;

  invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
  let dataRoutes = convertRoutesToDataRoutes(init.routes); // Cleanup function for history

  let unlistenHistory = null; // Externally-provided functions to call on all state changes

  let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing

  let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys

  let getScrollRestorationKey = null; // Externally-provided function to get current scroll position

  let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
  // we don't get the saved positions from <ScrollRestoration /> until _after_
  // the initial render, we need to manually trigger a separate updateState to
  // send along the restoreScrollPosition

  let initialScrollRestored = false;
  let initialMatches = matchRoutes(dataRoutes, init.history.location, init.basename);
  let initialErrors = null;

  if (initialMatches == null) {
    // If we do not match a user-provided-route, fall back to the root
    // to allow the error boundary to take over
    let {
      matches,
      route,
      error
    } = getNotFoundMatches(dataRoutes);
    initialMatches = matches;
    initialErrors = {
      [route.id]: error
    };
  }

  let initialized = !initialMatches.some(m => m.route.loader) || init.hydrationData != null;
  let router;
  let state = {
    historyAction: init.history.action,
    location: init.history.location,
    matches: initialMatches,
    initialized,
    navigation: IDLE_NAVIGATION,
    restoreScrollPosition: null,
    preventScrollReset: false,
    revalidation: "idle",
    loaderData: ((_init$hydrationData = init.hydrationData) == null ? void 0 : _init$hydrationData.loaderData) || {},
    actionData: ((_init$hydrationData2 = init.hydrationData) == null ? void 0 : _init$hydrationData2.actionData) || null,
    errors: ((_init$hydrationData3 = init.hydrationData) == null ? void 0 : _init$hydrationData3.errors) || initialErrors,
    fetchers: new Map()
  }; // -- Stateful internal variables to manage navigations --
  // Current navigation in progress (to be committed in completeNavigation)

  let pendingAction = Action.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
  // be restored?

  let pendingPreventScrollReset = false; // AbortController for the active navigation

  let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
  // revalidation is entirely uninterrupted

  let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
  //  - submissions (completed or interrupted)
  //  - useRevalidate()
  //  - X-Remix-Revalidate (from redirect)

  let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
  // to a cancelled deferred on action submission

  let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
  // action navigation and require revalidation

  let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers

  let fetchControllers = new Map(); // Track loads based on the order in which they started

  let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
  // the globally incrementing load when a fetcher load lands after a completed
  // navigation

  let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions

  let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions

  let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers

  let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
  // route loader returns defer() we stick one in here.  Then, when a nested
  // promise resolves we update loaderData.  If a new navigation starts we
  // cancel active deferreds for eliminated routes.

  let activeDeferreds = new Map(); // Initialize the router, all side effects should be kicked off from here.
  // Implemented as a Fluent API for ease of:
  //   let router = createRouter(init).initialize();

  function initialize() {
    // If history informs us of a POP navigation, start the navigation but do not update
    // state.  We'll update our own state once the navigation completes
    unlistenHistory = init.history.listen(_ref => {
      let {
        action: historyAction,
        location
      } = _ref;
      return startNavigation(historyAction, location);
    }); // Kick off initial data load if needed.  Use Pop to avoid modifying history

    if (!state.initialized) {
      startNavigation(Action.Pop, state.location);
    }

    return router;
  } // Clean up a router and it's side effects


  function dispose() {
    var _pendingNavigationCon;

    if (unlistenHistory) {
      unlistenHistory();
    }

    subscribers.clear();
    (_pendingNavigationCon = pendingNavigationController) == null ? void 0 : _pendingNavigationCon.abort();
    state.fetchers.forEach((_, key) => deleteFetcher(key));
  } // Subscribe to state updates for the router


  function subscribe(fn) {
    subscribers.add(fn);
    return () => subscribers.delete(fn);
  } // Update our state and notify the calling context of the change


  function updateState(newState) {
    state = _extends({}, state, newState);
    subscribers.forEach(subscriber => subscriber(state));
  } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
  // and setting state.[historyAction/location/matches] to the new route.
  // - Location is a required param
  // - Navigation will always be set to IDLE_NAVIGATION
  // - Can pass any other state in newState


  function completeNavigation(location, newState) {
    // Deduce if we're in a loading/actionReload state:
    // - We have committed actionData in the store
    // - The current navigation was a submission
    // - We're past the submitting state and into the loading state
    // - This should not be susceptible to false positives for
    //   loading/submissionRedirect since there would not be actionData in the
    //   state since the prior action would have returned a redirect response
    //   and short circuited
    let isActionReload = state.actionData != null && state.navigation.formMethod != null && state.navigation.state === "loading"; // Always preserve any existing loaderData from re-used routes

    let newLoaderData = newState.loaderData ? {
      loaderData: mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [])
    } : {};
    updateState(_extends({}, isActionReload ? {} : {
      actionData: null
    }, newState, newLoaderData, {
      historyAction: pendingAction,
      location,
      initialized: true,
      navigation: IDLE_NAVIGATION,
      revalidation: "idle",
      // Don't restore on submission navigations
      restoreScrollPosition: state.navigation.formData ? false : getSavedScrollPosition(location, newState.matches || state.matches),
      preventScrollReset: pendingPreventScrollReset
    }));

    if (isUninterruptedRevalidation) ; else if (pendingAction === Action.Pop) ; else if (pendingAction === Action.Push) {
      init.history.push(location, location.state);
    } else if (pendingAction === Action.Replace) {
      init.history.replace(location, location.state);
    } // Reset stateful navigation vars


    pendingAction = Action.Pop;
    pendingPreventScrollReset = false;
    isUninterruptedRevalidation = false;
    isRevalidationRequired = false;
    cancelledDeferredRoutes = [];
    cancelledFetcherLoads = [];
  } // Trigger a navigation event, which can either be a numerical POP or a PUSH
  // replace with an optional submission


  async function navigate(to, opts) {
    if (typeof to === "number") {
      init.history.go(to);
      return;
    }

    let {
      path,
      submission,
      error
    } = normalizeNavigateOptions(to, opts);
    let location = createLocation(state.location, path, opts == null ? void 0 : opts.state);
    let historyAction = (opts == null ? void 0 : opts.replace) === true || submission != null ? Action.Replace : Action.Push;
    let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
    return await startNavigation(historyAction, location, {
      submission,
      // Send through the formData serialization error if we have one so we can
      // render at the right error boundary after we match routes
      pendingError: error,
      preventScrollReset,
      replace: opts == null ? void 0 : opts.replace
    });
  } // Revalidate all current loaders.  If a navigation is in progress or if this
  // is interrupted by a navigation, allow this to "succeed" by calling all
  // loaders during the next loader round


  function revalidate() {
    interruptActiveLoads();
    updateState({
      revalidation: "loading"
    }); // If we're currently submitting an action, we don't need to start a new
    // navigation, we'll just let the follow up loader execution call all loaders

    if (state.navigation.state === "submitting") {
      return;
    } // If we're currently in an idle state, start a new navigation for the current
    // action/location and mark it as uninterrupted, which will skip the history
    // update in completeNavigation


    if (state.navigation.state === "idle") {
      startNavigation(state.historyAction, state.location, {
        startUninterruptedRevalidation: true
      });
      return;
    } // Otherwise, if we're currently in a loading state, just start a new
    // navigation to the navigation.location but do not trigger an uninterrupted
    // revalidation so that history correctly updates once the navigation completes


    startNavigation(pendingAction || state.historyAction, state.navigation.location, {
      overrideNavigation: state.navigation
    });
  } // Start a navigation to the given action/location.  Can optionally provide a
  // overrideNavigation which will override the normalLoad in the case of a redirect
  // navigation


  async function startNavigation(historyAction, location, opts) {
    var _pendingNavigationCon2;

    // Abort any in-progress navigations and start a new one. Unset any ongoing
    // uninterrupted revalidations unless told otherwise, since we want this
    // new navigation to update history normally
    (_pendingNavigationCon2 = pendingNavigationController) == null ? void 0 : _pendingNavigationCon2.abort();
    pendingNavigationController = null;
    pendingAction = historyAction;
    isUninterruptedRevalidation = (opts == null ? void 0 : opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
    // and track whether we should reset scroll on completion

    saveScrollPosition(state.location, state.matches);
    pendingPreventScrollReset = (opts == null ? void 0 : opts.preventScrollReset) === true;
    let loadingNavigation = opts == null ? void 0 : opts.overrideNavigation;
    let matches = matchRoutes(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing

    if (!matches) {
      let {
        matches: notFoundMatches,
        route,
        error
      } = getNotFoundMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes

      cancelActiveDeferreds();
      completeNavigation(location, {
        matches: notFoundMatches,
        loaderData: {},
        errors: {
          [route.id]: error
        }
      });
      return;
    } // Short circuit if it's only a hash change


    if (isHashChangeOnly(state.location, location)) {
      completeNavigation(location, {
        matches
      });
      return;
    } // Create a controller/Request for this navigation


    pendingNavigationController = new AbortController();
    let request = createRequest(location, pendingNavigationController.signal, opts == null ? void 0 : opts.submission);
    let pendingActionData;
    let pendingError;

    if (opts != null && opts.pendingError) {
      // If we have a pendingError, it means the user attempted a GET submission
      // with binary FormData so assign here and skip to handleLoaders.  That
      // way we handle calling loaders above the boundary etc.  It's not really
      // different from an actionError in that sense.
      pendingError = {
        [findNearestBoundary(matches).route.id]: opts.pendingError
      };
    } else if (opts != null && opts.submission) {
      // Call action if we received an action submission
      let actionOutput = await handleAction(request, location, opts.submission, matches, {
        replace: opts.replace
      });

      if (actionOutput.shortCircuited) {
        return;
      }

      pendingActionData = actionOutput.pendingActionData;
      pendingError = actionOutput.pendingActionError;

      let navigation = _extends({
        state: "loading",
        location
      }, opts.submission);

      loadingNavigation = navigation;
    } // Call loaders


    let {
      shortCircuited,
      loaderData,
      errors
    } = await handleLoaders(request, location, matches, loadingNavigation, opts == null ? void 0 : opts.submission, opts == null ? void 0 : opts.replace, pendingActionData, pendingError);

    if (shortCircuited) {
      return;
    } // Clean up now that the action/loaders have completed.  Don't clean up if
    // we short circuited because pendingNavigationController will have already
    // been assigned to a new controller for the next navigation


    pendingNavigationController = null;
    completeNavigation(location, {
      matches,
      loaderData,
      errors
    });
  } // Call the action matched by the leaf route for this navigation and handle
  // redirects/errors


  async function handleAction(request, location, submission, matches, opts) {
    interruptActiveLoads(); // Put us in a submitting state

    let navigation = _extends({
      state: "submitting",
      location
    }, submission);

    updateState({
      navigation
    }); // Call our action and get the result

    let result;
    let actionMatch = getTargetMatch(matches, location);

    if (!actionMatch.route.action) {
      result = getMethodNotAllowedResult(location);
    } else {
      result = await callLoaderOrAction("action", request, actionMatch);

      if (request.signal.aborted) {
        return {
          shortCircuited: true
        };
      }
    }

    if (isRedirectResult(result)) {
      let redirectNavigation = _extends({
        state: "loading",
        location: createLocation(state.location, result.location)
      }, submission);

      await startRedirectNavigation(result, redirectNavigation, opts == null ? void 0 : opts.replace);
      return {
        shortCircuited: true
      };
    }

    if (isErrorResult(result)) {
      // Store off the pending error - we use it to determine which loaders
      // to call and will commit it when we complete the navigation
      let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
      // action threw an error that'll be rendered in an errorElement, we fall
      // back to PUSH so that the user can use the back button to get back to
      // the pre-submission form location to try again

      if ((opts == null ? void 0 : opts.replace) !== true) {
        pendingAction = Action.Push;
      }

      return {
        pendingActionError: {
          [boundaryMatch.route.id]: result.error
        }
      };
    }

    if (isDeferredResult(result)) {
      throw new Error("defer() is not supported in actions");
    }

    return {
      pendingActionData: {
        [actionMatch.route.id]: result.data
      }
    };
  } // Call all applicable loaders for the given matches, handling redirects,
  // errors, etc.


  async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
    // Figure out the right navigation we want to use for data loading
    let loadingNavigation = overrideNavigation;

    if (!loadingNavigation) {
      let navigation = {
        state: "loading",
        location,
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined
      };
      loadingNavigation = navigation;
    }

    let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
    // about to reload.  Note that if this is an action reload we would have
    // already cancelled all pending deferreds so this would be a no-op

    cancelActiveDeferreds(routeId => !(matches != null && matches.some(m => m.route.id === routeId)) || (matchesToLoad == null ? void 0 : matchesToLoad.some(m => m.route.id === routeId))); // Short circuit if we have no loaders to run

    if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
      completeNavigation(location, {
        matches,
        loaderData: mergeLoaderData(state.loaderData, {}, matches),
        // Commit pending error if we're short circuiting
        errors: pendingError || null,
        actionData: pendingActionData || null
      });
      return {
        shortCircuited: true
      };
    } // If this is an uninterrupted revalidation, we remain in our current idle
    // state.  If not, we need to switch to our loading state and load data,
    // preserving any new action data or existing action data (in the case of
    // a revalidation interrupting an actionReload)


    if (!isUninterruptedRevalidation) {
      revalidatingFetchers.forEach(_ref2 => {
        var _state$fetchers$get;

        let [key] = _ref2;
        let revalidatingFetcher = {
          state: "loading",
          data: (_state$fetchers$get = state.fetchers.get(key)) == null ? void 0 : _state$fetchers$get.data,
          formMethod: undefined,
          formAction: undefined,
          formEncType: undefined,
          formData: undefined
        };
        state.fetchers.set(key, revalidatingFetcher);
      });
      updateState(_extends({
        navigation: loadingNavigation,
        actionData: pendingActionData || state.actionData || null
      }, revalidatingFetchers.length > 0 ? {
        fetchers: new Map(state.fetchers)
      } : {}));
    }

    pendingNavigationLoadId = ++incrementingLoadId;
    revalidatingFetchers.forEach(_ref3 => {
      let [key] = _ref3;
      return fetchControllers.set(key, pendingNavigationController);
    });
    let {
      results,
      loaderResults,
      fetcherResults
    } = await callLoadersAndMaybeResolveData(state.matches, matchesToLoad, revalidatingFetchers, request);

    if (request.signal.aborted) {
      return {
        shortCircuited: true
      };
    } // Clean up _after_ loaders have completed.  Don't clean up if we short
    // circuited because fetchControllers would have been aborted and
    // reassigned to new controllers for the next navigation


    revalidatingFetchers.forEach(_ref4 => {
      let [key] = _ref4;
      return fetchControllers.delete(key);
    }); // If any loaders returned a redirect Response, start a new REPLACE navigation

    let redirect = findRedirect(results);

    if (redirect) {
      let redirectNavigation = getLoaderRedirect(state, redirect);
      await startRedirectNavigation(redirect, redirectNavigation, replace);
      return {
        shortCircuited: true
      };
    } // Process and commit output from loaders


    let {
      loaderData,
      errors
    } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle

    activeDeferreds.forEach((deferredData, routeId) => {
      deferredData.subscribe(aborted => {
        // Note: No need to updateState here since the TrackedPromise on
        // loaderData is stable across resolve/reject
        // Remove this instance if we were aborted or if promises have settled
        if (aborted || deferredData.done) {
          activeDeferreds.delete(routeId);
        }
      });
    });
    markFetchRedirectsDone();
    let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
    return _extends({
      loaderData,
      errors
    }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
      fetchers: new Map(state.fetchers)
    } : {});
  }

  function getFetcher(key) {
    return state.fetchers.get(key) || IDLE_FETCHER;
  } // Trigger a fetcher load/submit for the given fetcher key


  function fetch(key, routeId, href, opts) {
    if (typeof AbortController === "undefined") {
      throw new Error("router.fetch() was called during the server render, but it shouldn't be. " + "You are likely calling a useFetcher() method in the body of your component. " + "Try moving it to a useEffect or a callback.");
    }

    if (fetchControllers.has(key)) abortFetcher(key);
    let matches = matchRoutes(dataRoutes, href, init.basename);

    if (!matches) {
      setFetcherError(key, routeId, new ErrorResponse(404, "Not Found", null));
      return;
    }

    let {
      path,
      submission
    } = normalizeNavigateOptions(href, opts);
    let match = getTargetMatch(matches, path);

    if (submission) {
      handleFetcherAction(key, routeId, path, match, submission);
      return;
    } // Store off the match so we can call it's shouldRevalidate on subsequent
    // revalidations


    fetchLoadMatches.set(key, [path, match]);
    handleFetcherLoader(key, routeId, path, match);
  } // Call the action for the matched fetcher.submit(), and then handle redirects,
  // errors, and revalidation


  async function handleFetcherAction(key, routeId, path, match, submission) {
    var _state$fetchers$get2;

    interruptActiveLoads();
    fetchLoadMatches.delete(key);

    if (!match.route.action) {
      let {
        error
      } = getMethodNotAllowedResult(path);
      setFetcherError(key, routeId, error);
      return;
    } // Put this fetcher into it's submitting state


    let fetcher = _extends({
      state: "submitting"
    }, submission, {
      data: ((_state$fetchers$get2 = state.fetchers.get(key)) == null ? void 0 : _state$fetchers$get2.data) || undefined
    });

    state.fetchers.set(key, fetcher);
    updateState({
      fetchers: new Map(state.fetchers)
    }); // Call the action for the fetcher

    let abortController = new AbortController();
    let fetchRequest = createRequest(path, abortController.signal, submission);
    fetchControllers.set(key, abortController);
    let actionResult = await callLoaderOrAction("action", fetchRequest, match);

    if (fetchRequest.signal.aborted) {
      // We can delete this so long as we weren't aborted by ou our own fetcher
      // re-submit which would have put _new_ controller is in fetchControllers
      if (fetchControllers.get(key) === abortController) {
        fetchControllers.delete(key);
      }

      return;
    }

    if (isRedirectResult(actionResult)) {
      fetchControllers.delete(key);
      fetchRedirectIds.add(key);

      let loadingFetcher = _extends({
        state: "loading"
      }, submission, {
        data: undefined
      });

      state.fetchers.set(key, loadingFetcher);
      updateState({
        fetchers: new Map(state.fetchers)
      });

      let redirectNavigation = _extends({
        state: "loading",
        location: createLocation(state.location, actionResult.location)
      }, submission);

      await startRedirectNavigation(actionResult, redirectNavigation);
      return;
    } // Process any non-redirect errors thrown


    if (isErrorResult(actionResult)) {
      setFetcherError(key, routeId, actionResult.error);
      return;
    }

    if (isDeferredResult(actionResult)) {
      invariant(false, "defer() is not supported in actions");
    } // Start the data load for current matches, or the next location if we're
    // in the middle of a navigation


    let nextLocation = state.navigation.location || state.location;
    let revalidationRequest = createRequest(nextLocation, abortController.signal);
    let matches = state.navigation.state !== "idle" ? matchRoutes(dataRoutes, state.navigation.location, init.basename) : state.matches;
    invariant(matches, "Didn't find any matches after fetcher action");
    let loadId = ++incrementingLoadId;
    fetchReloadIds.set(key, loadId);

    let loadFetcher = _extends({
      state: "loading",
      data: actionResult.data
    }, submission);

    state.fetchers.set(key, loadFetcher);
    let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
      [match.route.id]: actionResult.data
    }, undefined, // No need to send through errors since we short circuit above
    fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
    // current fetcher which we want to keep in it's current loading state which
    // contains it's action submission info + action data

    revalidatingFetchers.filter(_ref5 => {
      let [staleKey] = _ref5;
      return staleKey !== key;
    }).forEach(_ref6 => {
      var _state$fetchers$get3;

      let [staleKey] = _ref6;
      let revalidatingFetcher = {
        state: "loading",
        data: (_state$fetchers$get3 = state.fetchers.get(staleKey)) == null ? void 0 : _state$fetchers$get3.data,
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined
      };
      state.fetchers.set(staleKey, revalidatingFetcher);
      fetchControllers.set(staleKey, abortController);
    });
    updateState({
      fetchers: new Map(state.fetchers)
    });
    let {
      results,
      loaderResults,
      fetcherResults
    } = await callLoadersAndMaybeResolveData(state.matches, matchesToLoad, revalidatingFetchers, revalidationRequest);

    if (abortController.signal.aborted) {
      return;
    }

    fetchReloadIds.delete(key);
    fetchControllers.delete(key);
    revalidatingFetchers.forEach(_ref7 => {
      let [staleKey] = _ref7;
      return fetchControllers.delete(staleKey);
    });
    let redirect = findRedirect(results);

    if (redirect) {
      let redirectNavigation = getLoaderRedirect(state, redirect);
      await startRedirectNavigation(redirect, redirectNavigation);
      return;
    } // Process and commit output from loaders


    let {
      loaderData,
      errors
    } = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
    let doneFetcher = {
      state: "idle",
      data: actionResult.data,
      formMethod: undefined,
      formAction: undefined,
      formEncType: undefined,
      formData: undefined
    };
    state.fetchers.set(key, doneFetcher);
    let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
    // more recent than the navigation, we want the newer data so abort the
    // navigation and complete it with the fetcher data

    if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
      var _pendingNavigationCon3;

      invariant(pendingAction, "Expected pending action");
      (_pendingNavigationCon3 = pendingNavigationController) == null ? void 0 : _pendingNavigationCon3.abort();
      completeNavigation(state.navigation.location, {
        matches,
        loaderData,
        errors,
        fetchers: new Map(state.fetchers)
      });
    } else {
      // otherwise just update with the fetcher data, preserving any existing
      // loaderData for loaders that did not need to reload.  We have to
      // manually merge here since we aren't going through completeNavigation
      updateState(_extends({
        errors,
        loaderData: mergeLoaderData(state.loaderData, loaderData, matches)
      }, didAbortFetchLoads ? {
        fetchers: new Map(state.fetchers)
      } : {}));
      isRevalidationRequired = false;
    }
  } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.


  async function handleFetcherLoader(key, routeId, path, match) {
    var _state$fetchers$get4;

    // Put this fetcher into it's loading state
    let loadingFetcher = {
      state: "loading",
      formMethod: undefined,
      formAction: undefined,
      formEncType: undefined,
      formData: undefined,
      data: ((_state$fetchers$get4 = state.fetchers.get(key)) == null ? void 0 : _state$fetchers$get4.data) || undefined
    };
    state.fetchers.set(key, loadingFetcher);
    updateState({
      fetchers: new Map(state.fetchers)
    }); // Call the loader for this fetcher route match

    let abortController = new AbortController();
    let fetchRequest = createRequest(path, abortController.signal);
    fetchControllers.set(key, abortController);
    let result = await callLoaderOrAction("loader", fetchRequest, match); // Deferred isn't supported or fetcher loads, await everything and treat it
    // as a normal load.  resolveDeferredData will return undefined if this
    // fetcher gets aborted, so we just leave result untouched and short circuit
    // below if that happens

    if (isDeferredResult(result)) {
      result = (await resolveDeferredData(result, fetchRequest.signal, true)) || result;
    } // We can delete this so long as we weren't aborted by ou our own fetcher
    // re-load which would have put _new_ controller is in fetchControllers


    if (fetchControllers.get(key) === abortController) {
      fetchControllers.delete(key);
    }

    if (fetchRequest.signal.aborted) {
      return;
    } // If the loader threw a redirect Response, start a new REPLACE navigation


    if (isRedirectResult(result)) {
      let redirectNavigation = getLoaderRedirect(state, result);
      await startRedirectNavigation(result, redirectNavigation);
      return;
    } // Process any non-redirect errors thrown


    if (isErrorResult(result)) {
      let boundaryMatch = findNearestBoundary(state.matches, routeId);
      state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
      // do we need to behave any differently with our non-redirect errors?
      // What if it was a non-redirect Response?

      updateState({
        fetchers: new Map(state.fetchers),
        errors: {
          [boundaryMatch.route.id]: result.error
        }
      });
      return;
    }

    invariant(!isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state

    let doneFetcher = {
      state: "idle",
      data: result.data,
      formMethod: undefined,
      formAction: undefined,
      formEncType: undefined,
      formData: undefined
    };
    state.fetchers.set(key, doneFetcher);
    updateState({
      fetchers: new Map(state.fetchers)
    });
  }
  /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */


  async function startRedirectNavigation(redirect, navigation, replace) {
    if (redirect.revalidate) {
      isRevalidationRequired = true;
    }

    invariant(navigation.location, "Expected a location on the redirect navigation"); // There's no need to abort on redirects, since we don't detect the
    // redirect until the action/loaders have settled

    pendingNavigationController = null;
    let redirectHistoryAction = replace === true ? Action.Replace : Action.Push;
    await startNavigation(redirectHistoryAction, navigation.location, {
      overrideNavigation: navigation
    });
  }

  async function callLoadersAndMaybeResolveData(currentMatches, matchesToLoad, fetchersToLoad, request) {
    // Call all navigation loaders and revalidating fetcher loaders in parallel,
    // then slice off the results into separate arrays so we can handle them
    // accordingly
    let results = await Promise.all([...matchesToLoad.map(m => callLoaderOrAction("loader", request, m)), ...fetchersToLoad.map(_ref8 => {
      let [, href, match] = _ref8;
      return callLoaderOrAction("loader", createRequest(href, request.signal), match);
    })]);
    let loaderResults = results.slice(0, matchesToLoad.length);
    let fetcherResults = results.slice(matchesToLoad.length);
    await Promise.all([resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData), resolveDeferredResults(currentMatches, fetchersToLoad.map(_ref9 => {
      let [,, match] = _ref9;
      return match;
    }), fetcherResults, request.signal, true)]);
    return {
      results,
      loaderResults,
      fetcherResults
    };
  }

  function interruptActiveLoads() {
    // Every interruption triggers a revalidation
    isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
    // revalidation

    cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads

    fetchLoadMatches.forEach((_, key) => {
      if (fetchControllers.has(key)) {
        cancelledFetcherLoads.push(key);
        abortFetcher(key);
      }
    });
  }

  function setFetcherError(key, routeId, error) {
    let boundaryMatch = findNearestBoundary(state.matches, routeId);
    deleteFetcher(key);
    updateState({
      errors: {
        [boundaryMatch.route.id]: error
      },
      fetchers: new Map(state.fetchers)
    });
  }

  function deleteFetcher(key) {
    if (fetchControllers.has(key)) abortFetcher(key);
    fetchLoadMatches.delete(key);
    fetchReloadIds.delete(key);
    fetchRedirectIds.delete(key);
    state.fetchers.delete(key);
  }

  function abortFetcher(key) {
    let controller = fetchControllers.get(key);
    invariant(controller, "Expected fetch controller: " + key);
    controller.abort();
    fetchControllers.delete(key);
  }

  function markFetchersDone(keys) {
    for (let key of keys) {
      let fetcher = getFetcher(key);
      let doneFetcher = {
        state: "idle",
        data: fetcher.data,
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined
      };
      state.fetchers.set(key, doneFetcher);
    }
  }

  function markFetchRedirectsDone() {
    let doneKeys = [];

    for (let key of fetchRedirectIds) {
      let fetcher = state.fetchers.get(key);
      invariant(fetcher, "Expected fetcher: " + key);

      if (fetcher.state === "loading") {
        fetchRedirectIds.delete(key);
        doneKeys.push(key);
      }
    }

    markFetchersDone(doneKeys);
  }

  function abortStaleFetchLoads(landedId) {
    let yeetedKeys = [];

    for (let [key, id] of fetchReloadIds) {
      if (id < landedId) {
        let fetcher = state.fetchers.get(key);
        invariant(fetcher, "Expected fetcher: " + key);

        if (fetcher.state === "loading") {
          abortFetcher(key);
          fetchReloadIds.delete(key);
          yeetedKeys.push(key);
        }
      }
    }

    markFetchersDone(yeetedKeys);
    return yeetedKeys.length > 0;
  }

  function cancelActiveDeferreds(predicate) {
    let cancelledRouteIds = [];
    activeDeferreds.forEach((dfd, routeId) => {
      if (!predicate || predicate(routeId)) {
        // Cancel the deferred - but do not remove from activeDeferreds here -
        // we rely on the subscribers to do that so our tests can assert proper
        // cleanup via _internalActiveDeferreds
        dfd.cancel();
        cancelledRouteIds.push(routeId);
        activeDeferreds.delete(routeId);
      }
    });
    return cancelledRouteIds;
  } // Opt in to capturing and reporting scroll positions during navigations,
  // used by the <ScrollRestoration> component


  function enableScrollRestoration(positions, getPosition, getKey) {
    savedScrollPositions = positions;
    getScrollPosition = getPosition;

    getScrollRestorationKey = getKey || (location => location.key); // Perform initial hydration scroll restoration, since we miss the boat on
    // the initial updateState() because we've not yet rendered <ScrollRestoration/>
    // and therefore have no savedScrollPositions available


    if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
      initialScrollRestored = true;
      let y = getSavedScrollPosition(state.location, state.matches);

      if (y != null) {
        updateState({
          restoreScrollPosition: y
        });
      }
    }

    return () => {
      savedScrollPositions = null;
      getScrollPosition = null;
      getScrollRestorationKey = null;
    };
  }

  function saveScrollPosition(location, matches) {
    if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
      let userMatches = matches.map(m => createUseMatchesMatch(m, state.loaderData));
      let key = getScrollRestorationKey(location, userMatches) || location.key;
      savedScrollPositions[key] = getScrollPosition();
    }
  }

  function getSavedScrollPosition(location, matches) {
    if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
      let userMatches = matches.map(m => createUseMatchesMatch(m, state.loaderData));
      let key = getScrollRestorationKey(location, userMatches) || location.key;
      let y = savedScrollPositions[key];

      if (typeof y === "number") {
        return y;
      }
    }

    return null;
  }

  router = {
    get basename() {
      return init.basename;
    },

    get state() {
      return state;
    },

    get routes() {
      return dataRoutes;
    },

    initialize,
    subscribe,
    enableScrollRestoration,
    navigate,
    fetch,
    revalidate,
    createHref,
    getFetcher,
    deleteFetcher,
    dispose,
    _internalFetchControllers: fetchControllers,
    _internalActiveDeferreds: activeDeferreds
  };
  return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////

function unstable_createStaticHandler(routes) {
  invariant(routes.length > 0, "You must provide a non-empty routes array to unstable_createStaticHandler");
  let dataRoutes = convertRoutesToDataRoutes(routes);

  async function query(request) {
    let {
      location,
      result
    } = await queryImpl(request);

    if (result instanceof Response) {
      return result;
    } // When returning StaticHandlerContext, we patch back in the location here
    // since we need it for React Context.  But this helps keep our submit and
    // loadRouteData operating on a Request instead of a Location


    return _extends({
      location
    }, result);
  }

  async function queryRoute(request, routeId) {
    let {
      result
    } = await queryImpl(request, routeId);

    if (result instanceof Response) {
      return result;
    } // Pick off the right state value to return


    let routeData = [result.errors, result.actionData, result.loaderData].find(v => v);
    let value = Object.values(routeData || {})[0];

    if (isRouteErrorResponse(value)) {
      return new Response(value.data, {
        status: value.status,
        statusText: value.statusText
      });
    }

    return value;
  }

  async function queryImpl(request, routeId) {
    invariant(request.method !== "HEAD", "query()/queryRoute() do not support HEAD requests");
    invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
    let {
      location,
      matches,
      shortCircuitState
    } = matchRequest(request, routeId);

    try {
      if (shortCircuitState) {
        return {
          location,
          result: shortCircuitState
        };
      }

      if (request.method !== "GET") {
        let result = await submit(request, matches, getTargetMatch(matches, location), routeId != null);
        return {
          location,
          result
        };
      }

      let result = await loadRouteData(request, matches, routeId != null);
      return {
        location,
        result: _extends({}, result, {
          actionData: null,
          actionHeaders: {}
        })
      };
    } catch (e) {
      if (e instanceof Response) {
        return {
          location,
          result: e
        };
      }

      throw e;
    }
  }

  async function submit(request, matches, actionMatch, isRouteRequest) {
    let result;

    if (!actionMatch.route.action) {
      let href = createHref(new URL(request.url));
      result = getMethodNotAllowedResult(href);
    } else {
      result = await callLoaderOrAction("action", request, actionMatch, true, isRouteRequest);

      if (request.signal.aborted) {
        let method = isRouteRequest ? "queryRoute" : "query";
        throw new Error(method + "() call aborted");
      }
    }

    if (isRedirectResult(result)) {
      // Uhhhh - this should never happen, we should always throw these from
      // calLoaderOrAction, but the type narrowing here keeps TS happy and we
      // can get back on the "throw all redirect responses" train here should
      // this ever happen :/
      throw new Response(null, {
        status: result.status,
        headers: {
          Location: result.location
        }
      });
    }

    if (isDeferredResult(result)) {
      throw new Error("defer() is not supported in actions");
    }

    if (isRouteRequest) {
      if (isErrorResult(result)) {
        let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
        return {
          matches: [actionMatch],
          loaderData: {},
          actionData: null,
          errors: {
            [boundaryMatch.route.id]: result.error
          },
          // Note: statusCode + headers are unused here since queryRoute will
          // return the raw Response or value
          statusCode: 500,
          loaderHeaders: {},
          actionHeaders: {}
        };
      }

      return {
        matches: [actionMatch],
        loaderData: {},
        actionData: {
          [actionMatch.route.id]: result.data
        },
        errors: null,
        // Note: statusCode + headers are unused here since queryRoute will
        // return the raw Response or value
        statusCode: 200,
        loaderHeaders: {},
        actionHeaders: {}
      };
    }

    if (isErrorResult(result)) {
      // Store off the pending error - we use it to determine which loaders
      // to call and will commit it when we complete the navigation
      let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
      let context = await loadRouteData(request, matches, isRouteRequest, {
        [boundaryMatch.route.id]: result.error
      }); // action status codes take precedence over loader status codes

      return _extends({}, context, {
        statusCode: isRouteErrorResponse(result.error) ? result.error.status : 500,
        actionData: null,
        actionHeaders: _extends({}, result.headers ? {
          [actionMatch.route.id]: result.headers
        } : {})
      });
    }

    let context = await loadRouteData(request, matches, isRouteRequest);
    return _extends({}, context, result.statusCode ? {
      statusCode: result.statusCode
    } : {}, {
      actionData: {
        [actionMatch.route.id]: result.data
      },
      actionHeaders: _extends({}, result.headers ? {
        [actionMatch.route.id]: result.headers
      } : {})
    });
  }

  async function loadRouteData(request, matches, isRouteRequest, pendingActionError) {
    let matchesToLoad = getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]).filter(m => m.route.loader); // Short circuit if we have no loaders to run

    if (matchesToLoad.length === 0) {
      return {
        matches,
        loaderData: {},
        errors: pendingActionError || null,
        statusCode: 200,
        loaderHeaders: {}
      };
    }

    let results = await Promise.all([...matchesToLoad.map(m => callLoaderOrAction("loader", request, m, true, isRouteRequest))]);

    if (request.signal.aborted) {
      let method = isRouteRequest ? "queryRoute" : "query";
      throw new Error(method + "() call aborted");
    } // Can't do anything with these without the Remix side of things, so just
    // cancel them for now


    results.forEach(result => {
      if (isDeferredResult(result)) {
        result.deferredData.cancel();
      }
    }); // Process and commit output from loaders

    let context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionError);
    return _extends({}, context, {
      matches
    });
  }

  function matchRequest(req, routeId) {
    let url = new URL(req.url);
    let location = createLocation("", createPath(url), null, "default");
    let matches = matchRoutes(dataRoutes, location);

    if (matches && routeId) {
      matches = matches.filter(m => m.route.id === routeId);
    } // Short circuit with a 404 if we match nothing


    if (!matches) {
      let {
        matches: notFoundMatches,
        route,
        error
      } = getNotFoundMatches(dataRoutes);
      return {
        location,
        matches: notFoundMatches,
        shortCircuitState: {
          matches: notFoundMatches,
          loaderData: {},
          actionData: null,
          errors: {
            [route.id]: error
          },
          statusCode: 404,
          loaderHeaders: {},
          actionHeaders: {}
        }
      };
    }

    return {
      location,
      matches
    };
  }

  return {
    dataRoutes,
    query,
    queryRoute
  };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////

/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */

function getStaticContextFromError(routes, context, error) {
  let newContext = _extends({}, context, {
    statusCode: 500,
    errors: {
      [context._deepestRenderedBoundaryId || routes[0].id]: error
    }
  });

  return newContext;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params

function normalizeNavigateOptions(to, opts) {
  let path = typeof to === "string" ? to : createPath(to); // Return location verbatim on non-submission navigations

  if (!opts || !("formMethod" in opts) && !("formData" in opts)) {
    return {
      path
    };
  } // Create a Submission on non-GET navigations


  if (opts.formMethod != null && opts.formMethod !== "get") {
    return {
      path,
      submission: {
        formMethod: opts.formMethod,
        formAction: createHref(parsePath(path)),
        formEncType: (opts == null ? void 0 : opts.formEncType) || "application/x-www-form-urlencoded",
        formData: opts.formData
      }
    };
  } // No formData to flatten for GET submission


  if (!opts.formData) {
    return {
      path
    };
  } // Flatten submission onto URLSearchParams for GET submissions


  let parsedPath = parsePath(path);

  try {
    let searchParams = convertFormDataToSearchParams(opts.formData);
    parsedPath.search = "?" + searchParams;
  } catch (e) {
    return {
      path,
      error: new ErrorResponse(400, "Bad Request", "Cannot submit binary form data using GET")
    };
  }

  return {
    path: createPath(parsedPath)
  };
}

function getLoaderRedirect(state, redirect) {
  let {
    formMethod,
    formAction,
    formEncType,
    formData
  } = state.navigation;
  let navigation = {
    state: "loading",
    location: createLocation(state.location, redirect.location),
    formMethod: formMethod || undefined,
    formAction: formAction || undefined,
    formEncType: formEncType || undefined,
    formData: formData || undefined
  };
  return navigation;
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them


function getLoaderMatchesUntilBoundary(matches, boundaryId) {
  let boundaryMatches = matches;

  if (boundaryId) {
    let index = matches.findIndex(m => m.route.id === boundaryId);

    if (index >= 0) {
      boundaryMatches = matches.slice(0, index);
    }
  }

  return boundaryMatches;
}

function getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
  let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : null; // Pick navigation matches that are net-new or qualify for revalidation

  let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
  let boundaryMatches = getLoaderMatchesUntilBoundary(matches, boundaryId);
  let navigationMatches = boundaryMatches.filter((match, index) => match.route.loader != null && (isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
  cancelledDeferredRoutes.some(id => id === match.route.id) || shouldRevalidateLoader(state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated

  let revalidatingFetchers = [];
  fetchLoadMatches == null ? void 0 : fetchLoadMatches.forEach((_ref10, key) => {
    let [href, match] = _ref10;

    // This fetcher was cancelled from a prior action submission - force reload
    if (cancelledFetcherLoads.includes(key)) {
      revalidatingFetchers.push([key, href, match]);
    } else if (isRevalidationRequired) {
      let shouldRevalidate = shouldRevalidateLoader(href, match, submission, href, match, isRevalidationRequired, actionResult);

      if (shouldRevalidate) {
        revalidatingFetchers.push([key, href, match]);
      }
    }
  });
  return [navigationMatches, revalidatingFetchers];
}

function isNewLoader(currentLoaderData, currentMatch, match) {
  let isNew = // [a] -> [a, b]
  !currentMatch || // [a, b] -> [a, c]
  match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
  // from a prior error or from a cancelled pending deferred

  let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data

  return isNew || isMissingData;
}

function isNewRouteInstance(currentMatch, match) {
  var _currentMatch$route$p;

  return (// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    ((_currentMatch$route$p = currentMatch.route.path) == null ? void 0 : _currentMatch$route$p.endsWith("*")) && currentMatch.params["*"] !== match.params["*"]
  );
}

function shouldRevalidateLoader(currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
  let currentUrl = createURL(currentLocation);
  let currentParams = currentMatch.params;
  let nextUrl = createURL(location);
  let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
  // provides it's own implementation, then we give them full control but
  // provide this value so they can leverage it if needed after they check
  // their own specific use cases
  // Note that fetchers always provide the same current/next locations so the
  // URL-based checks here don't apply to fetcher shouldRevalidate calls

  let defaultShouldRevalidate = isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
  currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
  currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
  isRevalidationRequired;

  if (match.route.shouldRevalidate) {
    let routeChoice = match.route.shouldRevalidate(_extends({
      currentUrl,
      currentParams,
      nextUrl,
      nextParams
    }, submission, {
      actionResult,
      defaultShouldRevalidate
    }));

    if (typeof routeChoice === "boolean") {
      return routeChoice;
    }
  }

  return defaultShouldRevalidate;
}

async function callLoaderOrAction(type, request, match, skipRedirects, isRouteRequest) {
  if (skipRedirects === void 0) {
    skipRedirects = false;
  }

  if (isRouteRequest === void 0) {
    isRouteRequest = false;
  }

  let resultType;
  let result; // Setup a promise we can race against so that abort signals short circuit

  let reject;
  let abortPromise = new Promise((_, r) => reject = r);

  let onReject = () => reject();

  request.signal.addEventListener("abort", onReject);

  try {
    let handler = match.route[type];
    invariant(handler, "Could not find the " + type + " to run on the \"" + match.route.id + "\" route");
    result = await Promise.race([handler({
      request,
      params: match.params
    }), abortPromise]);
  } catch (e) {
    resultType = ResultType.error;
    result = e;
  } finally {
    request.signal.removeEventListener("abort", onReject);
  }

  if (result instanceof Response) {
    var _result$headers$get;

    // Process redirects
    let status = result.status;
    let location = result.headers.get("Location"); // For SSR single-route requests, we want to hand Responses back directly
    // without unwrapping

    if (isRouteRequest) {
      throw result;
    }

    if (status >= 300 && status <= 399 && location != null) {
      // Don't process redirects in the router during SSR document requests.
      // Instead, throw the Response and let the server handle it with an HTTP
      // redirect
      if (skipRedirects) {
        throw result;
      }

      return {
        type: ResultType.redirect,
        status,
        location,
        revalidate: result.headers.get("X-Remix-Revalidate") !== null
      };
    }

    let data;

    if ((_result$headers$get = result.headers.get("Content-Type")) != null && _result$headers$get.startsWith("application/json")) {
      data = await result.json();
    } else {
      data = await result.text();
    }

    if (resultType === ResultType.error) {
      return {
        type: resultType,
        error: new ErrorResponse(status, result.statusText, data),
        headers: result.headers
      };
    }

    return {
      type: ResultType.data,
      data,
      statusCode: result.status,
      headers: result.headers
    };
  }

  if (resultType === ResultType.error) {
    return {
      type: resultType,
      error: result
    };
  }

  if (result instanceof DeferredData) {
    return {
      type: ResultType.deferred,
      deferredData: result
    };
  }

  return {
    type: ResultType.data,
    data: result
  };
}

function createRequest(location, signal, submission) {
  let url = createURL(location).toString();
  let init = {
    signal
  };

  if (submission) {
    let {
      formMethod,
      formEncType,
      formData
    } = submission;
    init.method = formMethod.toUpperCase();
    init.body = formEncType === "application/x-www-form-urlencoded" ? convertFormDataToSearchParams(formData) : formData;
  } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)


  return new Request(url, init);
}

function convertFormDataToSearchParams(formData) {
  let searchParams = new URLSearchParams();

  for (let [key, value] of formData.entries()) {
    invariant(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", ' + 'please use "multipart/form-data" instead.');
    searchParams.append(key, value);
  }

  return searchParams;
}

function processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
  // Fill in loaderData/errors from our loaders
  let loaderData = {};
  let errors = null;
  let statusCode;
  let foundError = false;
  let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors

  results.forEach((result, index) => {
    let id = matchesToLoad[index].route.id;
    invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");

    if (isErrorResult(result)) {
      // Look upwards from the matched route for the closest ancestor
      // error boundary, defaulting to the root match
      let boundaryMatch = findNearestBoundary(matches, id);
      let error = result.error; // If we have a pending action error, we report it at the highest-route
      // that throws a loader error, and then clear it out to indicate that
      // it was consumed

      if (pendingError) {
        error = Object.values(pendingError)[0];
        pendingError = undefined;
      }

      errors = Object.assign(errors || {}, {
        [boundaryMatch.route.id]: error
      }); // Once we find our first (highest) error, we set the status code and
      // prevent deeper status codes from overriding

      if (!foundError) {
        foundError = true;
        statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
      }

      if (result.headers) {
        loaderHeaders[id] = result.headers;
      }
    } else if (isDeferredResult(result)) {
      activeDeferreds == null ? void 0 : activeDeferreds.set(id, result.deferredData);
      loaderData[id] = result.deferredData.data; // TODO: Add statusCode/headers once we wire up streaming in Remix
    } else {
      loaderData[id] = result.data; // Error status codes always override success status codes, but if all
      // loaders are successful we take the deepest status code.

      if (result.statusCode !== 200 && !foundError) {
        statusCode = result.statusCode;
      }

      if (result.headers) {
        loaderHeaders[id] = result.headers;
      }
    }
  }); // If we didn't consume the pending action error (i.e., all loaders
  // resolved), then consume it here

  if (pendingError) {
    errors = pendingError;
  }

  return {
    loaderData,
    errors,
    statusCode: statusCode || 200,
    loaderHeaders
  };
}

function processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
  let {
    loaderData,
    errors
  } = processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers

  for (let index = 0; index < revalidatingFetchers.length; index++) {
    let [key,, match] = revalidatingFetchers[index];
    invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
    let result = fetcherResults[index]; // Process fetcher non-redirect errors

    if (isErrorResult(result)) {
      var _errors;

      let boundaryMatch = findNearestBoundary(state.matches, match.route.id);

      if (!((_errors = errors) != null && _errors[boundaryMatch.route.id])) {
        errors = _extends({}, errors, {
          [boundaryMatch.route.id]: result.error
        });
      }

      state.fetchers.delete(key);
    } else if (isRedirectResult(result)) {
      // Should never get here, redirects should get processed above, but we
      // keep this to type narrow to a success result in the else
      throw new Error("Unhandled fetcher revalidation redirect");
    } else if (isDeferredResult(result)) {
      // Should never get here, deferred data should be awaited for fetchers
      // in resolveDeferredResults
      throw new Error("Unhandled fetcher deferred data");
    } else {
      let doneFetcher = {
        state: "idle",
        data: result.data,
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined
      };
      state.fetchers.set(key, doneFetcher);
    }
  }

  return {
    loaderData,
    errors
  };
}

function mergeLoaderData(loaderData, newLoaderData, matches) {
  let mergedLoaderData = _extends({}, newLoaderData);

  matches.forEach(match => {
    let id = match.route.id;

    if (newLoaderData[id] === undefined && loaderData[id] !== undefined) {
      mergedLoaderData[id] = loaderData[id];
    }
  });
  return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match


function findNearestBoundary(matches, routeId) {
  let eligibleMatches = routeId ? matches.slice(0, matches.findIndex(m => m.route.id === routeId) + 1) : [...matches];
  return eligibleMatches.reverse().find(m => m.route.hasErrorBoundary === true) || matches[0];
}

function getNotFoundMatches(routes) {
  // Prefer a root layout route if present, otherwise shim in a route object
  let route = routes.find(r => r.index || r.path === "" || r.path === "/") || {
    id: "__shim-404-route__"
  };
  return {
    matches: [{
      params: {},
      pathname: "",
      pathnameBase: "",
      route
    }],
    route,
    error: new ErrorResponse(404, "Not Found", null)
  };
}

function getMethodNotAllowedResult(path) {
  let href = typeof path === "string" ? path : createHref(path);
  console.warn("You're trying to submit to a route that does not have an action.  To " + "fix this, please add an `action` function to the route for " + ("[" + href + "]"));
  return {
    type: ResultType.error,
    error: new ErrorResponse(405, "Method Not Allowed", "No action found for [" + href + "]")
  };
} // Find any returned redirect errors, starting from the lowest match


function findRedirect(results) {
  for (let i = results.length - 1; i >= 0; i--) {
    let result = results[i];

    if (isRedirectResult(result)) {
      return result;
    }
  }
} // Create an href to represent a "server" URL without the hash


function createHref(location) {
  return (location.pathname || "") + (location.search || "");
}

function isHashChangeOnly(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}

function isDeferredResult(result) {
  return result.type === ResultType.deferred;
}

function isErrorResult(result) {
  return result.type === ResultType.error;
}

function isRedirectResult(result) {
  return (result == null ? void 0 : result.type) === ResultType.redirect;
}

async function resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
  for (let index = 0; index < results.length; index++) {
    let result = results[index];
    let match = matchesToLoad[index];
    let currentMatch = currentMatches.find(m => m.route.id === match.route.id);
    let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData == null ? void 0 : currentLoaderData[match.route.id]) !== undefined;

    if (isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
      // Note: we do not have to touch activeDeferreds here since we race them
      // against the signal in resolveDeferredData and they'll get aborted
      // there if needed
      await resolveDeferredData(result, signal, isFetcher).then(result => {
        if (result) {
          results[index] = result || results[index];
        }
      });
    }
  }
}

async function resolveDeferredData(result, signal, unwrap) {
  if (unwrap === void 0) {
    unwrap = false;
  }

  let aborted = await result.deferredData.resolveData(signal);

  if (aborted) {
    return;
  }

  if (unwrap) {
    try {
      return {
        type: ResultType.data,
        data: result.deferredData.unwrappedData
      };
    } catch (e) {
      // Handle any TrackedPromise._error values encountered while unwrapping
      return {
        type: ResultType.error,
        error: e
      };
    }
  }

  return {
    type: ResultType.data,
    data: result.deferredData.data
  };
}

function hasNakedIndexQuery(search) {
  return new URLSearchParams(search).getAll("index").some(v => v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up


function createUseMatchesMatch(match, loaderData) {
  let {
    route,
    pathname,
    params
  } = match;
  return {
    id: route.id,
    pathname,
    params,
    data: loaderData[route.id],
    handle: route.handle
  };
}

function getTargetMatch(matches, location) {
  let search = typeof location === "string" ? parsePath(location).search : location.search;

  if (matches[matches.length - 1].route.index && !hasNakedIndexQuery(search || "")) {
    return matches.slice(-2)[0];
  }

  return matches.slice(-1)[0];
}

function createURL(location) {
  let base = typeof window !== "undefined" && typeof window.location !== "undefined" ? window.location.origin : "unknown://unknown";
  let href = typeof location === "string" ? location : createHref(location);
  return new URL(href, base);
} //#endregion


//# sourceMappingURL=router.js.map


/***/ }),

/***/ 1475:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Card": () => (/* reexport */ Card),
  "CardBottom": () => (/* reexport */ CardBottom),
  "CardContent": () => (/* reexport */ CardContent),
  "CardContext": () => (/* reexport */ CardContext),
  "CardFlipContent": () => (/* reexport */ CardFlipContent),
  "CardFooter": () => (/* reexport */ CardFooter),
  "CardHeader": () => (/* reexport */ CardHeader),
  "CardTop": () => (/* reexport */ CardTop),
  "default": () => (/* reexport */ Card)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(660);
// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card/card-core.js
var card_core = __webpack_require__(9336);
// EXTERNAL MODULE: ./node_modules/@core-front/badge/esm/badge-core.js
var badge_core = __webpack_require__(2230);
// EXTERNAL MODULE: ./node_modules/@core-front/icon/esm/icon.js + 2 modules
var icon = __webpack_require__(1858);
;// CONCATENATED MODULE: ./node_modules/@telia-front/badge/esm/badge.js



class Badge extends external_react_.Component {
    BEM() {
        const classArray = [];
        switch (this.props.purpose) {
            case 'secondary':
            case 'attention':
            case 'error':
            case 'information':
                classArray.push(`badge--${this.props.purpose}`);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getPurpose() {
        switch (this.props.purpose) {
            case 'secondary':
            case 'attention':
            case 'error':
            case 'information':
                return undefined;
            default:
                return this.props.purpose;
        }
    }
    render() {
        return (external_react_.createElement(badge_core/* default */.Z, Object.assign({}, this.props, { className: this.BEM(), purpose: this.getPurpose(), components: {
                Icon: icon/* default */.Z,
            } })));
    }
}

// EXTERNAL MODULE: ./node_modules/@core-front/button/esm/button-core.js
var button_core = __webpack_require__(1687);
// EXTERNAL MODULE: ./node_modules/@core-front/skeleton/esm/skeleton/skeleton.js
var skeleton = __webpack_require__(1127);
;// CONCATENATED MODULE: ./node_modules/@telia-front/skeleton/esm/skeleton/skeleton.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const Skeleton = (props) => {
    const { theme, className } = props, rest = __rest(props, ["theme", "className"]);
    const BEM = () => {
        const classArray = [];
        if (theme) {
            classArray.push(`skeleton--theme-${theme}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(skeleton/* default */.Z, Object.assign({}, rest, { className: BEM() })));
};
/* harmony default export */ const skeleton_skeleton = (Skeleton);

// EXTERNAL MODULE: ./node_modules/@core-front/skeleton/esm/skeleton-item/skeleton-item.js
var skeleton_item = __webpack_require__(4490);
// EXTERNAL MODULE: ./node_modules/@core-front/spinner/esm/spinner.js
var spinner = __webpack_require__(420);
;// CONCATENATED MODULE: ./node_modules/@telia-front/window/esm/index.js
const esm_navigate = (event) => {
    if (window.telia && window.telia.navigate) {
        window.telia.navigate(event);
    }
};

;// CONCATENATED MODULE: ./node_modules/@telia-front/button/esm/button.js
var button_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const Button = (props) => {
    const { isUnderlined = true } = props, rest = button_rest(props, ["isUnderlined"]);
    const BEM = () => {
        const classArray = [];
        switch (props.type) {
            case 'outer-twitter':
            case 'outer-diil':
            case 'outer-spotify':
            case 'expressive':
                classArray.push(`btn--${props.type}`);
        }
        if (props.theme) {
            classArray.push(`btn--theme-${props.theme}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const getType = () => {
        switch (props.type) {
            case 'outer-twitter':
            case 'outer-diil':
            case 'outer-spotify':
            case 'expressive':
                return undefined;
            default:
                return props.type;
        }
    };
    return (external_react_.createElement(button_core/* default */.Z, Object.assign({}, rest, { className: BEM(), type: getType(), isUnderlined: isUnderlined, components: {
            Icon: icon/* default */.Z,
            Skeleton: skeleton_skeleton,
            SkeletonItem: skeleton_item/* default */.Z,
            Spinner: spinner/* default */.Z,
        } })));
};
// defaultProps is used for when a component clones Button as it's child,
// child.props.onClick would be defined. For example, AnalyticsTrigger.
// React does not fill child.props from ES6 default values.
Button.defaultProps = {
    onClick: esm_navigate,
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/close-button/node_modules/@core-front/label-provider/esm/label-provider.js


const defaultContext = {
    get: (key) => {
        if (typeof process === 'undefined' ||  true && process.env.STYLEGUIDE === 'false') {
            console.error('LabelProvider missing! Application must be wrapped with <LabelProvider>');
        }
        return key;
    },
};
const LabelContext = external_react_.createContext(defaultContext);
const replaceParams = (label, params) => {
    return Object.keys(params).reduce((text, key) => text.replace(`$\{${key}}`, params[key]), label);
};
const LabelProvider = (props) => {
    const { labels, children, } = props;
    const { log } = useErrorLog();
    const get = (key, params) => {
        const label = labels[key];
        if (!label) {
            log(`Label missing for key "${key}".`);
            return key;
        }
        if (params) {
            return replaceParams(label, params);
        }
        return label;
    };
    return (React.createElement(LabelContext.Provider, { value: { get } }, children));
};
/* harmony default export */ const label_provider = ((/* unused pure expression or super */ null && (LabelProvider)));

;// CONCATENATED MODULE: ./node_modules/@telia-front/close-button/node_modules/@core-front/label-provider/esm/use-labels.js


const useLabels = () => {
    return external_react_.useContext(LabelContext);
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/close-button/node_modules/@core-front/close-button/esm/close-button-core.js


const CloseButtonCore = (props) => {
    const labels = useLabels();
    const { className, components: { Icon }, label, onClick, } = props;
    const BEM = () => {
        const classArray = ['close-button'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("button", { className: BEM(), onClick: onClick, type: "button" },
        external_react_.createElement("span", { className: "close-button__inner" },
            external_react_.createElement(Icon, { modifiers: "#close", className: "close-button__icon" }),
            external_react_.createElement("span", { className: "sr-only" }, label || labels.get('close')))));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/close-button/esm/close-button.js



const close_button_CloseButton = (props) => {
    return (external_react_.createElement(CloseButtonCore, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
        } })));
};


// EXTERNAL MODULE: ./node_modules/@telia-front/colors/esm/index.js
var esm = __webpack_require__(9356);
// EXTERNAL MODULE: ./node_modules/debounce/index.js
var debounce = __webpack_require__(296);
;// CONCATENATED MODULE: ./node_modules/@telia-front/image/node_modules/@core-front/error-provider/esm/error-provider.js

const error_provider_defaultContext = {
    log: (message) => console.error(message),
};
const ErrorContext = external_react_.createContext(error_provider_defaultContext);
const ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const error_provider = ((/* unused pure expression or super */ null && (ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@telia-front/image/node_modules/@core-front/error-provider/esm/use-log.js


const use_log_useErrorLog = () => {
    return external_react_.useContext(ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/image/node_modules/@core-front/image/esm/image.js


const getPlaceholder = (aspectRatio) => {
    if (aspectRatio) {
        return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${aspectRatio.width} ${aspectRatio.height}"%3E%3C/svg%3E`;
    }
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
};
const ImageImg = (props) => {
    const BEM = () => {
        const classArray = ['image', 'lazyload'];
        if (props.shape) {
            classArray.push('image--' + props.shape);
        }
        if (props.align) {
            classArray.push('image--' + props.align);
        }
        if (props.isInactive) {
            classArray.push('image--inactive');
        }
        if (props.noFade) {
            classArray.push('image--no-fade');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("img", { key: props.src || props.srcset, src: getPlaceholder(props.aspectRatio), "data-src": props.src, "data-srcset": props.srcset, "data-sizes": props.srcset ? 'auto' : undefined, className: BEM(), alt: props.role === 'presentation' ? '' : props.alt, width: props.width, onError: props.onError, onLoad: props.onLoad, style: props.style, ref: props.imageRef }));
};
const ImagePicture = (props) => {
    return (external_react_.createElement("picture", { className: props.pictureClassName },
        props.sources.map((item, index) => {
            return (external_react_.createElement("source", { key: index, srcSet: item.aspectRatio && getPlaceholder(item.aspectRatio), "data-srcset": item.srcset, media: `(min-width: ${item.minWidth})` }));
        }),
        external_react_.createElement(ImageImg, Object.assign({}, props))));
};
const Image = (props) => {
    const { role, alt, src, sources, srcset } = props;
    const { log } = use_log_useErrorLog();
    external_react_.useEffect(() => {
        if (role !== 'presentation' && !alt) {
            const srcIndentifier = src ? `src: ${src}` : undefined;
            const srcSetIndentifier = srcset ? `srcset: ${srcset}` : undefined;
            log(`react-front: image is missing required alt prop (${srcSetIndentifier || srcIndentifier})`);
        }
    }, [role, alt, src, srcset, log]);
    return sources ? external_react_.createElement(ImagePicture, Object.assign({}, props, { sources: sources })) : external_react_.createElement(ImageImg, Object.assign({}, props));
};
/* harmony default export */ const esm_image = (Image);

;// CONCATENATED MODULE: ./node_modules/@telia-front/label-provider/node_modules/@core-front/label-provider/esm/label-provider.js


const label_provider_defaultContext = {
    get: (key) => {
        if (typeof process === 'undefined' ||  true && process.env.STYLEGUIDE === 'false') {
            console.error('LabelProvider missing! Application must be wrapped with <LabelProvider>');
        }
        return key;
    },
};
const label_provider_LabelContext = external_react_.createContext(label_provider_defaultContext);
const label_provider_replaceParams = (label, params) => {
    return Object.keys(params).reduce((text, key) => text.replace(`$\{${key}}`, params[key]), label);
};
const label_provider_LabelProvider = (props) => {
    const { labels, children, } = props;
    const { log } = useErrorLog();
    const get = (key, params) => {
        const label = labels[key];
        if (!label) {
            log(`Label missing for key "${key}".`);
            return key;
        }
        if (params) {
            return label_provider_replaceParams(label, params);
        }
        return label;
    };
    return (React.createElement(label_provider_LabelContext.Provider, { value: { get } }, children));
};
/* harmony default export */ const esm_label_provider = ((/* unused pure expression or super */ null && (label_provider_LabelProvider)));

;// CONCATENATED MODULE: ./node_modules/@telia-front/label-provider/node_modules/@core-front/label-provider/esm/use-labels.js


const use_labels_useLabels = () => {
    return external_react_.useContext(label_provider_LabelContext);
};


// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-responsive-props.js + 1 modules
var use_responsive_props = __webpack_require__(9097);
// EXTERNAL MODULE: ./node_modules/@core-front/theme-provider/esm/use-theme.js
var use_theme = __webpack_require__(3286);
;// CONCATENATED MODULE: ./node_modules/@telia-front/tag/node_modules/@core-front/tag/esm/tag-core.js
var tag_core_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const TagCore = (props) => {
    const { responsive } = props, rest = tag_core_rest(props, ["responsive"]);
    return responsive ? external_react_.createElement(TagResponsiveCore, Object.assign({}, rest, { responsive: responsive })) : external_react_.createElement(TagInnerCore, Object.assign({}, rest));
};
const TagResponsiveCore = (props) => {
    const { responsive } = props, rest = tag_core_rest(props, ["responsive"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsiveProps = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive });
    return external_react_.createElement(TagInnerCore, Object.assign({}, rest, responsiveProps));
};
const tagSizeFontSize = {
    tiny: 'small',
    small: 'large',
    medium: 'extra-large',
    large: 'small',
};
class TagInnerCore extends external_react_.Component {
    constructor(props) {
        super(props);
        this.fadeDuration = 300;
        this.interval = 0;
        /**
         * Called after every animationDuration
         * Sets animationState and animated content index
         */
        this.updateState = () => {
            if (!this.props.content) {
                return;
            }
            this.setState({
                animationState: 'fade-out',
            }, () => setTimeout(() => {
                let nextIndex = this.state.currentIndex + 1;
                if (this.props.content && nextIndex === this.props.content.length) {
                    nextIndex = 0;
                }
                this.setState({
                    animationState: 'fade-in',
                    currentIndex: nextIndex,
                }, () => setTimeout(() => {
                    this.setState({
                        animationState: 'faded-in',
                    });
                }, this.fadeDuration));
            }, this.fadeDuration));
        };
        this.state = {
            animationState: 'faded-in',
            currentIndex: 0,
        };
    }
    componentDidMount() {
        if (this.props.content && this.props.content.length > 1 && this.props.size !== 'tiny') {
            this.interval = window.setInterval(this.updateState, (this.props.animationDuration || 3000) - this.fadeDuration);
        }
    }
    componentWillUnmount() {
        if (this.props.content) {
            window.clearInterval(this.interval);
        }
    }
    BEM() {
        const { size } = this.props;
        const classArray = ['tag', `tag--${size}`];
        if (this.props.purpose) {
            classArray.push(`tag--${this.props.purpose}`);
        }
        if (this.props.icon && !this.props.content) {
            classArray.push('tag--icon');
        }
        if (this.props.image && !this.props.content) {
            classArray.push('tag--image');
        }
        if (this.props.content) {
            classArray.push('tag--animating');
        }
        if (this.props.isDisabled) {
            classArray.push('tag--disabled');
        }
        if (this.props.tooltip) {
            classArray.push('tag--tooltip');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    contentBEM(item) {
        const classArray = ['tag__content'];
        if (this.props.content && this.props.size !== 'tiny') {
            const index = this.props.content.findIndex((i) => item === i);
            if (this.state.currentIndex === index) {
                classArray.push(`tag__content--${this.state.animationState}`);
            }
        }
        return classArray.join(' ');
    }
    renderIcon(icon) {
        const { Icon } = this.props.components;
        return external_react_.createElement(Icon, { className: "tag__icon", modifiers: icon });
    }
    renderText(item) {
        const { Fittext } = this.props.components;
        const classArray = ['tag__text'];
        const { size } = this.props;
        if (item.image || (item.icon && this.props.size !== 'large' && this.props.size !== 'tiny')) {
            classArray.push('tag__text--hidden');
        }
        if (item.fontSize) {
            classArray.push('tag__text--' + item.fontSize);
        }
        else if (this.props.tagSizeFontSizeProp) {
            classArray.push('tag__text--' + this.props.tagSizeFontSizeProp[size]);
        }
        else if (tagSizeFontSize[size]) {
            classArray.push('tag__text--' + tagSizeFontSize[size]);
        }
        let tagTextContent;
        if (typeof item.text === 'string') {
            tagTextContent = external_react_.createElement(Fittext, null, item.text);
        }
        else {
            tagTextContent = item.text;
        }
        return (external_react_.createElement("span", { className: classArray.join(' ') }, this.props.renderContent ? this.props.renderContent : tagTextContent));
    }
    renderImage(image) {
        const { Image } = this.props.components;
        return (external_react_.createElement(Image, Object.assign({}, image, { className: "tag__image" })));
    }
    renderContent(item, key) {
        const ContentElement = this.props.tooltip ? 'span' : 'div';
        return (external_react_.createElement(ContentElement, { className: this.contentBEM(item), key: key },
            item.icon && this.props.size !== 'tiny' && this.renderIcon(item.icon),
            item.text && !this.props.renderContent && this.renderText(item),
            item.image && this.renderImage(item.image),
            this.props.text && this.props.renderContent && this.renderText(item)));
    }
    renderMultipleContent(content) {
        return content.map((item, key) => this.renderContent(item, key));
    }
    renderToolTipWrapper(defaultItem, tooltip) {
        const { id } = tooltip, tooltipProps = tag_core_rest(tooltip, ["id"]);
        const { Tooltip } = this.props.components;
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement("button", { type: "button", id: id, className: this.BEM() }, this.props.content ? this.renderMultipleContent(this.props.content) : this.renderContent(defaultItem)),
            external_react_.createElement(Tooltip, Object.assign({ referenceElement: `#${id}` }, tooltipProps))));
    }
    renderDefaultWrapper(defaultItem) {
        return (external_react_.createElement("div", { className: this.BEM() }, this.props.content ? this.renderMultipleContent(this.props.content) : this.renderContent(defaultItem)));
    }
    render() {
        const defaultItem = {
            fontSize: this.props.fontSize,
            icon: this.props.icon,
            image: this.props.image,
            text: this.props.text,
        };
        const { tooltip } = this.props;
        return tooltip ? this.renderToolTipWrapper(defaultItem, tooltip) : this.renderDefaultWrapper(defaultItem);
    }
}
TagInnerCore.defaultProps = {
    animationDuration: 3000,
    size: 'large',
};


// EXTERNAL MODULE: ./node_modules/@core-front/fittext/esm/fittext.js + 2 modules
var fittext = __webpack_require__(6537);
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(7111);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/popper.js + 53 modules
var popper = __webpack_require__(4511);
// EXTERNAL MODULE: ./node_modules/tabbable/dist/index.esm.js
var index_esm = __webpack_require__(8388);
// EXTERNAL MODULE: ./node_modules/@core-front/input-provider/esm/input-provider.js
var input_provider = __webpack_require__(8606);
;// CONCATENATED MODULE: ./node_modules/@telia-front/tooltip/node_modules/@core-front/error-provider/esm/error-provider.js

const esm_error_provider_defaultContext = {
    log: (message) => console.error(message),
};
const error_provider_ErrorContext = external_react_.createContext(esm_error_provider_defaultContext);
const error_provider_ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(error_provider_ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const esm_error_provider = ((/* unused pure expression or super */ null && (error_provider_ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@telia-front/tooltip/node_modules/@core-front/error-provider/esm/use-log.js


const esm_use_log_useErrorLog = () => {
    return external_react_.useContext(error_provider_ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/tooltip/node_modules/@core-front/props-checker/esm/props-checker.js


const PropsChecker = (props) => {
    const { componentName, componentProps, defaultValueName, valueName, onChangeNames, onChangeAltNames, isComponentDisabled, children, } = props;
    const { log } = esm_use_log_useErrorLog();
    const isInitial = external_react_.useRef(true);
    const didWarnControlledToUncontrolled = external_react_.useRef(false);
    const didWarnUncontrolledToControlled = external_react_.useRef(false);
    const checkHasOnChange = () => {
        const onChangeNamesArray = Array.isArray(onChangeNames) ? onChangeNames : [onChangeNames];
        const onChangeAltNamesArray = Array.isArray(onChangeAltNames) ? onChangeAltNames : (onChangeAltNames ? [onChangeAltNames] : []);
        return onChangeNamesArray.every((onChangeName) => !!componentProps[onChangeName])
            || onChangeAltNamesArray && onChangeAltNamesArray.length > 0 && onChangeAltNamesArray.every((onChangeName) => !!componentProps[onChangeName]);
    };
    const hasOnChange = checkHasOnChange();
    const checkIsControlled = () => {
        const isDefined = typeof componentProps[valueName] !== 'undefined';
        if (isComponentDisabled) {
            return isDefined;
        }
        return hasOnChange && isDefined;
    };
    const newIsControlled = checkIsControlled();
    const isControlledRef = external_react_.useRef(newIsControlled);
    external_react_.useEffect(() => {
        function hasValuePropWithoutOnChangeProp() {
            return typeof componentProps[valueName] !== 'undefined' && !hasOnChange;
        }
        function formattedNames(names) {
            if (Array.isArray(names)) {
                return names.join(', ');
            }
            return names;
        }
        if (isInitial.current && hasValuePropWithoutOnChangeProp() && !isComponentDisabled) {
            log(`You provided a "${valueName}" prop without an "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} handler in "${componentName}" component. ` +
                `If the state is handled outside component, set "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} prop. Otherwise use "${defaultValueName}" prop.`);
            isInitial.current = false;
        }
    }, [componentName, componentProps, defaultValueName, hasOnChange, isComponentDisabled, onChangeAltNames, onChangeNames, valueName, log]);
    external_react_.useEffect(() => {
        if (!isControlledRef.current && newIsControlled && !didWarnUncontrolledToControlled.current) {
            log(`The "${componentName}" component is changing from uncontrolled to be controlled. ` +
                `This is likely caused by the "${valueName}" changing from undefined to ` +
                'a defined value, which should not happen.');
            didWarnUncontrolledToControlled.current = true;
        }
        if (isControlledRef.current && !newIsControlled && !didWarnControlledToUncontrolled.current) {
            log(`The "${componentName}" component is changing from controlled to be uncontrolled. ` +
                `This is likely caused by the "${valueName}" changing from a defined to ` +
                'undefined value, which should not happen.');
            didWarnControlledToUncontrolled.current = true;
        }
        isControlledRef.current = newIsControlled;
    }, [componentProps, componentName, didWarnUncontrolledToControlled, didWarnControlledToUncontrolled, newIsControlled, valueName, log]);
    return (external_react_.createElement(external_react_.Fragment, null, children));
};
/* harmony default export */ const props_checker = (PropsChecker);

;// CONCATENATED MODULE: ./node_modules/@telia-front/tooltip/node_modules/@core-front/tooltip/esm/tooltip.js




var TooltipColors;
(function (TooltipColors) {
    TooltipColors["info"] = "info";
    TooltipColors["success"] = "success";
    TooltipColors["error"] = "error";
    TooltipColors["employee"] = "employee";
})(TooltipColors || (TooltipColors = {}));
const Tooltip = (props) => {
    return (React.createElement(TooltipCore, Object.assign({}, props, { components: {
            CloseButton,
            PageAccess,
        } })));
};
/* harmony default export */ const tooltip = ((/* unused pure expression or super */ null && (Tooltip)));

;// CONCATENATED MODULE: ./node_modules/@telia-front/tooltip/node_modules/@core-front/tooltip/esm/tooltip-core.js








const tooltip_core_TooltipCore = (props) => {
    const { input } = external_react_.useContext(input_provider/* InputContext */.r);
    return (external_react_.createElement(props_checker, { componentProps: props, componentName: "Tooltip", defaultValueName: "defaultIsShown", valueName: "isShown", onChangeNames: "onToggle", onChangeAltNames: ['onShow', 'onHide'] },
        external_react_.createElement(TooltipInner, Object.assign({}, props, { inputIntent: input }))));
};
/* harmony default export */ const tooltip_core = (tooltip_core_TooltipCore);
class TooltipInner extends external_react_.PureComponent {
    constructor(props) {
        super(props);
        this.tooltip = null;
        this.referenceElement = null;
        this.popper = null;
        this.focusTimeout = 0;
        this.destroyPopper = () => {
            if (this.popper) {
                this.popper.destroy();
                this.popper = null;
            }
        };
        this.hideToolTipReferenceElement = () => {
            if (!this.tooltip) {
                this.hideTooltip();
                return;
            }
            if (this.geInputIntent(this.props.inputIntent) && !this.tooltip.matches(':hover')) {
                this.hideTooltip();
            }
        };
        this.hideToolTipElement = () => {
            if (!this.referenceElement) {
                this.hideTooltip();
                return;
            }
            if (this.geInputIntent(this.props.inputIntent) && !this.referenceElement.matches(':hover')) {
                this.hideTooltip();
            }
        };
        this.showTooltip = () => {
            if (!this.isShown) {
                if (!this.state.isShown && typeof this.props.isShown === 'undefined') {
                    this.setState({
                        isShown: true,
                    });
                }
                if (this.props.onShow) {
                    this.props.onShow();
                }
                if (this.props.onToggle) {
                    this.props.onToggle(true);
                }
            }
        };
        this.hideTooltip = () => {
            if (this.isShown) {
                if (this.state.isShown && typeof this.props.isShown === 'undefined') {
                    this.setState({
                        isShown: false,
                    });
                }
                if (this.props.onHide) {
                    this.props.onHide();
                }
                if (this.props.onToggle) {
                    this.props.onToggle(false);
                }
            }
        };
        this.toggleTooltip = () => {
            if (this.isShown) {
                this.hideTooltip();
            }
            else {
                this.showTooltip();
            }
        };
        this.onClickOutside = (event) => {
            if (event.target instanceof Element) {
                this.hideIfOutside(event.target);
            }
        };
        this.handleCloseClick = (event) => {
            event.preventDefault();
            this.hideTooltip();
        };
        this.setRef = (element) => {
            this.tooltip = element;
            if (this.props.elementRef) {
                this.props.elementRef(element);
            }
        };
        this.onEntered = () => {
            this.focusFirstElement();
        };
        this.onExited = () => {
            var _a;
            if (this.props.inputIntent !== 'mouse') {
                (_a = this.referenceElement) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        this.onKeyDown = (event) => {
            switch (event.key) {
                // Invoke this.props.onClose when user hits ESC key.
                case 'Escape':
                case 'Esc':
                    this.hideTooltip();
                    break;
                case 'Tab':
                    /* istanbul ignore else */
                    if (this.tooltip) {
                        const tabbableElements = (0,index_esm/* tabbable */.ht)(this.tooltip);
                        if (tabbableElements.length) {
                            const firstTabbableElement = tabbableElements[0];
                            const lastTabbableElement = tabbableElements[tabbableElements.length - 1];
                            if (event.shiftKey) {
                                if (document.activeElement === firstTabbableElement) {
                                    event.preventDefault();
                                    lastTabbableElement.focus();
                                }
                            }
                            else {
                                if (document.activeElement === lastTabbableElement) {
                                    event.preventDefault();
                                    firstTabbableElement.focus();
                                }
                            }
                        }
                        else {
                            event.preventDefault();
                        }
                    }
            }
        };
        this.state = {
            isMounted: false,
            isReady: false,
            isShown: props.defaultIsShown || false,
        };
    }
    componentDidMount() {
        this.setReferenceElement();
        this.setState({ isMounted: true }, () => {
            if (this.isShown) {
                this.initPopper();
                this.focusFirstElement();
            }
            if (this.props.inputIntent !== 'initial') {
                this.bindEventListeners(this.geInputIntent(this.props.inputIntent));
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if ((this.geInputIntent(prevProps.inputIntent) !== this.geInputIntent(this.props.inputIntent)) && prevProps.inputIntent !== 'initial' && this.isShown) {
            this.hideTooltip();
        }
        if (this.geInputIntent(prevProps.inputIntent) !== this.geInputIntent(this.props.inputIntent)) {
            this.bindEventListeners(this.geInputIntent(this.props.inputIntent));
        }
        if ((this.state.isShown !== prevState.isShown) || (this.props.isShown !== prevProps.isShown)) {
            if (this.isShown) {
                this.initPopper();
                if (this.tooltip && this.geInputIntent(this.props.inputIntent) === 'mouse' && this.props.trigger !== 'none') {
                    this.tooltip.addEventListener('mouseenter', this.showTooltip);
                    this.tooltip.addEventListener('mouseleave', this.hideToolTipElement);
                }
            }
            else if (!this.isShown) {
                this.destroyPopper();
            }
        }
    }
    componentWillUnmount() {
        this.unbindAllEventListeners();
        this.destroyPopper();
        window.clearTimeout(this.focusTimeout);
    }
    get isShown() {
        return (this.props.onToggle || (this.props.onHide && this.props.onShow)) && typeof this.props.isShown !== 'undefined' ? this.props.isShown : this.state.isShown;
    }
    isSpecColor(color) {
        return color ? color in TooltipColors : false;
    }
    geInputIntent(input) {
        if (this.props.trigger === 'click') {
            return 'touch';
        }
        return input;
    }
    setReferenceElement() {
        if (typeof this.props.referenceElement === 'string') {
            this.referenceElement = document.querySelector(this.props.referenceElement);
        }
        else if (this.props.referenceElement instanceof SVGElement ||
            this.props.referenceElement instanceof HTMLElement) {
            this.referenceElement = this.props.referenceElement;
        }
        else {
            this.referenceElement = this.tooltip && this.tooltip.parentElement;
        }
    }
    focusFirstElement() {
        this.focusTimeout = window.setTimeout(() => {
            /* istanbul ignore else */
            if (this.tooltip && this.props.inputIntent !== 'mouse') {
                const firstTabbableElement = (0,index_esm/* tabbable */.ht)(this.tooltip)[0];
                if (firstTabbableElement) {
                    firstTabbableElement.focus();
                    return;
                }
                this.tooltip.focus();
            }
        });
    }
    /**
     * Initialize popper.js to automagically position the tooltip according to available space.
     */
    initPopper() {
        if (!this.tooltip || !this.referenceElement) {
            return;
        }
        this.popper = (0,popper/* createPopper */.fi)(this.referenceElement, this.tooltip, {
            modifiers: [
                { name: 'applyStyles', enabled: false },
                {
                    name: 'updateState',
                    enabled: true,
                    phase: 'write',
                    requires: ['computeStyles'],
                    fn: ({ state }) => this.updatePopperState(state),
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'bottom', 'right', 'left'],
                        padding: { top: 137, right: 17, bottom: 17, left: 17 },
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 15,
                    },
                },
            ],
            onFirstUpdate: () => {
                if (this.popper) {
                    this.popper.update().then(() => {
                        this.setState({
                            isReady: true,
                        });
                    });
                }
            },
            placement: this.props.placement,
        });
    }
    updatePopperState(state) {
        const popperStyle = Object.assign({}, state.styles.popper);
        const popperAttributes = Object.assign({}, state.attributes.popper);
        const popperArrowStyle = Object.assign({}, state.styles.arrow);
        if (!this.isSpecColor(this.props.color)) {
            popperArrowStyle.color = this.props.color;
        }
        this.setState({
            popperStyle,
            popperAttributes,
            popperArrowStyle,
        });
    }
    bindEventListeners(type) {
        if (this.props.trigger === 'none') {
            return;
        }
        this.unbindAllEventListeners();
        if (this.props.hideWithIntent && this.props.hideWithIntent.includes(this.geInputIntent(this.props.inputIntent))) {
            return;
        }
        switch (type) {
            case 'mouse':
                return this.bindHoverEventListeners();
            case 'keyboard':
            default:
                return this.bindClickEventListeners();
        }
    }
    bindClickEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.addEventListener('click', this.toggleTooltip);
        }
        document.addEventListener('click', this.onClickOutside);
    }
    unbindClickEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.removeEventListener('click', this.toggleTooltip);
        }
        document.removeEventListener('click', this.onClickOutside);
    }
    bindHoverEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.addEventListener('mouseenter', this.showTooltip);
            this.referenceElement.addEventListener('mouseleave', this.hideToolTipReferenceElement);
        }
    }
    unbindHoverEventListeners() {
        if (this.referenceElement) {
            this.referenceElement.removeEventListener('mouseenter', this.showTooltip);
            this.referenceElement.removeEventListener('mouseleave', this.hideToolTipReferenceElement);
        }
        if (this.tooltip) {
            this.tooltip.removeEventListener('mouseenter', this.showTooltip);
            this.tooltip.removeEventListener('mouseleave', this.hideToolTipElement);
        }
    }
    unbindAllEventListeners() {
        this.unbindClickEventListeners();
        this.unbindHoverEventListeners();
    }
    // calls this.hideTooltip if target is not a descendant of the tooltip nor the reference element.
    hideIfOutside(target) {
        if (this.isShown) {
            while (target !== null) {
                if (target === this.tooltip || target === this.referenceElement || (this.props.outsideClickCloseFilter && this.props.outsideClickCloseFilter(target))) {
                    return;
                }
                target = target.parentElement;
            }
            this.hideTooltip();
        }
    }
    isCloseButtonShown() {
        const { isCloseButtonVisible, inputIntent } = this.props;
        return !!(isCloseButtonVisible && ['initial', 'pointer', 'touch', 'keyboard'].indexOf(this.geInputIntent(inputIntent)) > -1);
    }
    BEM(state) {
        const classArray = ['tooltip', `tooltip--trigger-${this.geInputIntent(this.props.inputIntent)}`];
        if (state) {
            classArray.push(`is-${state}`);
        }
        if (this.isShown) {
            classArray.push('is-shown');
        }
        if (this.state.isReady) {
            classArray.push('is-ready');
        }
        if (this.isSpecColor(this.props.color)) {
            classArray.push('tooltip--' + this.props.color);
        }
        if (this.isCloseButtonShown()) {
            classArray.push('tooltip--has-close-button');
        }
        if (this.props.fixedWidth) {
            classArray.push('tooltip--fixed-width');
        }
        if (this.props.noPadding) {
            classArray.push('tooltip--no-padding');
        }
        if (this.props.size) {
            classArray.push('tooltip--' + this.props.size);
        }
        if (this.props.onHeader) {
            classArray.push('tooltip--on-header');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    renderTooltip() {
        const { CloseButton, PageAccess } = this.props.components;
        const content = (state) => (external_react_.createElement("div", Object.assign({}, this.state.popperAttributes, { className: this.BEM(state), style: this.state.popperStyle, ref: this.setRef, tabIndex: -1, onKeyDown: this.onKeyDown, role: "dialog", "aria-modal": true, "aria-labelledby": this.props['aria-labelledby'] }),
            external_react_.createElement("div", { className: "tooltip__arrow", "data-popper-arrow": true, style: this.state.popperArrowStyle }),
            external_react_.createElement("div", { className: "tooltip__content", style: !this.isSpecColor(this.props.color) ? { borderColor: this.props.color } : undefined },
                this.isCloseButtonShown() && (external_react_.createElement(CloseButton, { className: "tooltip__close", onClick: this.handleCloseClick })),
                this.props.children)));
        if (!this.state.isMounted) {
            return content();
        }
        return (external_react_.createElement(PageAccess, { isInert: this.props.inputIntent !== 'mouse' && this.isShown },
            external_react_.createElement(Transition/* default */.ZP, { in: this.isShown, timeout: { enter: 0, exit: 100 }, mountOnEnter: true, unmountOnExit: true, onEntered: this.onEntered, onExited: this.onExited }, content)));
    }
    render() {
        return this.state.isMounted ? external_react_dom_.createPortal(this.renderTooltip(), document.body) : this.renderTooltip();
    }
}
TooltipInner.defaultProps = {
    fixedWidth: true,
    noPadding: false,
    placement: 'top',
    isCloseButtonVisible: true,
};

// EXTERNAL MODULE: ./node_modules/react-side-effect/lib/index.js
var lib = __webpack_require__(3524);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/@telia-front/page-access/node_modules/@core-front/helper/esm/index.js


let scrollAnimationFrame = 0;
const isScrollDisabled = () => {
    return document.body.classList.contains('is-scroll-disabled');
};
const disableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && !isScrollDisabled()) {
        const curScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        document.body.classList.add('is-scroll-disabled');
        contentElement.style.top = -curScroll + 'px';
        window.scroll(0, 0);
    }
};
const enableBodyScroll = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement && isScrollDisabled()) {
        const bodyScroll = contentElement.style && contentElement.style.top ? parseInt(contentElement.style.top, 10) : undefined;
        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll !== undefined) {
            window.scroll(0, -bodyScroll);
            contentElement.style.top = '';
        }
    }
};
const getHashArray = () => {
    const hash = window.location.hash;
    if (hash) {
        return hash.split('/').filter((item) => {
            return item.indexOf('?') !== 0 && item.length !== 1 && item.length !== 0;
        }).map((item) => {
            if (item.charAt(0) === '#') {
                return item.substr(1);
            }
            else {
                return item;
            }
        });
    }
    else {
        return false;
    }
};
const swingTo = (pos) => {
    pos /= 0.5;
    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2);
    }
    return -0.5 * ((pos -= 2) * pos - 2);
};
const doScrolling = (scrollTargetY, speed, parent = window, callback) => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(scrollAnimationFrame);
    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.pageYOffset;
    let currentTime = 0;
    // min time .1, max time .8 seconds
    const time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));
    /**
     * Tick a scroll point
     */
    function tick() {
        currentTime += 1 / 60;
        const p = currentTime / time;
        const t = swingTo(p);
        if (p < 1) {
            scrollAnimationFrame = window.requestAnimationFrame(tick);
            parent.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
        }
        else {
            parent.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    }
    tick();
};
const scrollToElement = (element, speed, offset, focusScrolledElement) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const duration = speed || 500;
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset;
        const topOffsetY = offset || getDefaultPageTopOffset(offsetY);
        const combinedOffsetY = Math.max(offsetY - topOffsetY, 0);
        const callback = focusScrolledElement ? () => {
            if (element && element instanceof HTMLElement) {
                if (!isFocusable(element)) {
                    element.setAttribute('tabindex', '-1');
                }
                element.focus();
            }
        } : undefined;
        doScrolling(combinedOffsetY, duration, window, callback);
    }
};
const isOnScreen = (element) => {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        /* istanbul ignore else */
        if (html) {
            return (rect.top >= getDefaultPageTopOffset() &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth));
        }
    }
    return false;
};
const isHeaderOpen = (refOffsetY) => {
    const header = document.getElementById('header');
    if (!refOffsetY) {
        return !!header && !header.classList.contains('has-scrolled');
    }
    else {
        const documentHeight = document.documentElement ? document.documentElement.offsetHeight : 0;
        const windowHeight = window.innerHeight;
        const headerHeight = header ? header.clientHeight : 0;
        if (refOffsetY <= headerHeight || windowHeight + refOffsetY >= documentHeight - headerHeight) {
            return true;
        }
        return false;
    }
};
const getDefaultPageTopOffset = (refOffsetY) => {
    const affixes = document.getElementsByClassName('affix');
    let pageTopOffset = 0;
    for (const affix of affixes) {
        pageTopOffset += affix.clientHeight;
    }
    return isHeaderOpen(refOffsetY) ? pageTopOffset + 150 : pageTopOffset;
};
const stringToNum = (str) => {
    return Number(str.replace(',', '.'));
};
const numToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.', ',');
};
const offset = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement && document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement && document.documentElement.scrollTop;
    return {
        left: rect.left + (scrollLeft || 0),
        top: rect.top + (scrollTop || 0),
    };
};
const setDocumentScrollTop = (scrollPosition) => {
    /* istanbul ignore else */
    if (document.documentElement) {
        document.documentElement.scrollTop = document.body.scrollTop = scrollPosition;
    }
};
const getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
const getParentsUntil = (elem, parent) => {
    // Setup parents array
    const parents = [];
    // Get matching parent elements
    for (; elem && elem !== document.documentElement; elem = elem.parentNode) {
        if (parent && elem === parent) {
            break;
        }
        parents.push(elem);
    }
    return parents;
};
const getOffsetFromParent = (element, parent) => {
    const pos = {
        left: 0,
        top: 0,
    };
    getParentsUntil(element, parent).forEach((parentEl) => {
        /* istanbul ignore else */
        if (parentEl instanceof HTMLElement) {
            const parentElStyle = getComputedStyle(parentEl);
            if (parentElStyle.position === 'static') {
                return;
            }
            pos.top += parentEl.offsetTop;
            pos.left += parentEl.offsetLeft;
        }
    });
    return pos;
};
const disablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.setAttribute('inert', 'inert');
        contentElement.setAttribute('aria-hidden', 'true');
    }
};
const enablePageAccess = () => {
    const contentElement = document.querySelector('#page-container');
    if (contentElement) {
        contentElement.removeAttribute('inert');
        contentElement.removeAttribute('aria-hidden');
    }
};





;// CONCATENATED MODULE: ./node_modules/@telia-front/page-access/node_modules/@core-front/page-access/esm/page-access.js



const page_access_PageAccess = (props) => {
    return external_react_.createElement(external_react_.Fragment, null, props.children);
};
function reducePropsToState(propsList) {
    return propsList.some((props) => props.isInert);
}
function handleStateChangeOnClient(isInert) {
    if (isInert) {
        disablePageAccess();
    }
    else {
        enablePageAccess();
    }
}
/* harmony default export */ const page_access = (lib_default()(reducePropsToState, handleStateChangeOnClient)(page_access_PageAccess));

;// CONCATENATED MODULE: ./node_modules/@telia-front/tooltip/esm/tooltip.js




const tooltip_Tooltip = (props) => {
    return (external_react_.createElement(tooltip_core, Object.assign({}, props, { components: {
            CloseButton: close_button_CloseButton,
            PageAccess: page_access,
        } })));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/tag/esm/tag.js
var tag_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const tag_tagSizeFontSize = {
    tiny: 'small',
    small: 'large',
    medium: 'extra-large',
    large: 'small',
    icon: undefined,
};
const Tag = (props) => {
    const { purpose } = props, rest = tag_rest(props, ["purpose"]);
    const getSize = () => {
        if (props.size !== 'icon') {
            return props.size;
        }
    };
    const BEM = () => {
        const classArray = [`tag--${props.purpose}`];
        if (props.size === 'icon') {
            classArray.push('tag--icon');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(TagCore, Object.assign({}, rest, { size: getSize(), className: BEM(), components: {
            Icon: icon/* default */.Z,
            Tooltip: tooltip_Tooltip,
            Image: esm_image,
            Fittext: fittext/* default */.Z,
        }, tagSizeFontSizeProp: tag_tagSizeFontSize })));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/tag-group/node_modules/@core-front/tag-group/esm/tag-group-core.js

const TagGroup = (props) => {
    const { Tag } = props.components;
    const BEM = () => {
        const classArray = ['tag-group'];
        const { align = 'vertical' } = props;
        classArray.push(`tag-group--align-${align}`);
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const tagBEM = (className) => {
        const classArray = ['tag-group__tag'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("div", { className: BEM() }, props.tags.map((tag, index) => (external_react_.createElement(Tag, Object.assign({}, tag, { key: index, size: props.size, className: tagBEM(tag.className) }))))));
};
/* harmony default export */ const tag_group_core = (TagGroup);

;// CONCATENATED MODULE: ./node_modules/@telia-front/tag-group/esm/tag-group.js
var tag_group_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const tag_group_TagGroup = (props) => {
    const { tags } = props, rest = tag_group_rest(props, ["tags"]);
    const getPurpose = (purpose) => {
        switch (purpose) {
            case 'primary':
                return purpose;
            default:
                return undefined;
        }
    };
    const getSize = () => {
        if (props.size !== 'icon') {
            return props.size;
        }
    };
    const tagBEM = (tag) => {
        const classArray = [];
        if (tag.purpose && getPurpose(tag.purpose) === undefined) {
            classArray.push(`tag--${tag.purpose}`);
        }
        if (props.size === 'icon') {
            classArray.push('tag--icon');
        }
        if (tag.className) {
            classArray.push(tag.className);
        }
        return classArray.join(' ');
    };
    const getTags = () => {
        return tags.map((tag) => {
            const { purpose } = tag, others = tag_group_rest(tag, ["purpose"]);
            return Object.assign(Object.assign({}, others), { className: tagBEM(tag), purpose: getPurpose(purpose), size: getSize() });
        });
    };
    return (external_react_.createElement(tag_group_core, Object.assign({}, rest, { components: {
            Tag: Tag,
        }, size: getSize(), tags: getTags() })));
};


// EXTERNAL MODULE: ./node_modules/@core-front/analytics/esm/analytics-trigger/analytics-trigger.js
var analytics_trigger = __webpack_require__(6341);
// EXTERNAL MODULE: ./node_modules/@core-front/cookie-consent-provider/esm/cookie-consent-provider.js
var cookie_consent_provider = __webpack_require__(7869);
;// CONCATENATED MODULE: ./node_modules/@telia-front/video/node_modules/@core-front/error-provider/esm/error-provider.js

const error_provider_esm_error_provider_defaultContext = {
    log: (message) => console.error(message),
};
const esm_error_provider_ErrorContext = external_react_.createContext(error_provider_esm_error_provider_defaultContext);
const esm_error_provider_ErrorProvider = (props) => {
    const log = (message) => {
        console.error(message);
        props.onError(message);
    };
    return (React.createElement(esm_error_provider_ErrorContext.Provider, { value: { log } }, props.children));
};
/* harmony default export */ const error_provider_esm_error_provider = ((/* unused pure expression or super */ null && (esm_error_provider_ErrorProvider)));

;// CONCATENATED MODULE: ./node_modules/@telia-front/video/node_modules/@core-front/error-provider/esm/use-log.js


const error_provider_esm_use_log_useErrorLog = () => {
    return external_react_.useContext(esm_error_provider_ErrorContext);
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/video/node_modules/@core-front/props-checker/esm/props-checker.js


const props_checker_PropsChecker = (props) => {
    const { componentName, componentProps, defaultValueName, valueName, onChangeNames, onChangeAltNames, isComponentDisabled, children, } = props;
    const { log } = error_provider_esm_use_log_useErrorLog();
    const isInitial = external_react_.useRef(true);
    const didWarnControlledToUncontrolled = external_react_.useRef(false);
    const didWarnUncontrolledToControlled = external_react_.useRef(false);
    const checkHasOnChange = () => {
        const onChangeNamesArray = Array.isArray(onChangeNames) ? onChangeNames : [onChangeNames];
        const onChangeAltNamesArray = Array.isArray(onChangeAltNames) ? onChangeAltNames : (onChangeAltNames ? [onChangeAltNames] : []);
        return onChangeNamesArray.every((onChangeName) => !!componentProps[onChangeName])
            || onChangeAltNamesArray && onChangeAltNamesArray.length > 0 && onChangeAltNamesArray.every((onChangeName) => !!componentProps[onChangeName]);
    };
    const hasOnChange = checkHasOnChange();
    const checkIsControlled = () => {
        const isDefined = typeof componentProps[valueName] !== 'undefined';
        if (isComponentDisabled) {
            return isDefined;
        }
        return hasOnChange && isDefined;
    };
    const newIsControlled = checkIsControlled();
    const isControlledRef = external_react_.useRef(newIsControlled);
    external_react_.useEffect(() => {
        function hasValuePropWithoutOnChangeProp() {
            return typeof componentProps[valueName] !== 'undefined' && !hasOnChange;
        }
        function formattedNames(names) {
            if (Array.isArray(names)) {
                return names.join(', ');
            }
            return names;
        }
        if (isInitial.current && hasValuePropWithoutOnChangeProp() && !isComponentDisabled) {
            log(`You provided a "${valueName}" prop without an "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} handler in "${componentName}" component. ` +
                `If the state is handled outside component, set "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} prop. Otherwise use "${defaultValueName}" prop.`);
            isInitial.current = false;
        }
    }, [componentName, componentProps, defaultValueName, hasOnChange, isComponentDisabled, onChangeAltNames, onChangeNames, valueName, log]);
    external_react_.useEffect(() => {
        if (!isControlledRef.current && newIsControlled && !didWarnUncontrolledToControlled.current) {
            log(`The "${componentName}" component is changing from uncontrolled to be controlled. ` +
                `This is likely caused by the "${valueName}" changing from undefined to ` +
                'a defined value, which should not happen.');
            didWarnUncontrolledToControlled.current = true;
        }
        if (isControlledRef.current && !newIsControlled && !didWarnControlledToUncontrolled.current) {
            log(`The "${componentName}" component is changing from controlled to be uncontrolled. ` +
                `This is likely caused by the "${valueName}" changing from a defined to ` +
                'undefined value, which should not happen.');
            didWarnControlledToUncontrolled.current = true;
        }
        isControlledRef.current = newIsControlled;
    }, [componentProps, componentName, didWarnUncontrolledToControlled, didWarnControlledToUncontrolled, newIsControlled, valueName, log]);
    return (external_react_.createElement(external_react_.Fragment, null, children));
};
/* harmony default export */ const esm_props_checker = (props_checker_PropsChecker);

;// CONCATENATED MODULE: ./node_modules/@telia-front/video/node_modules/@core-front/video/esm/video-core.js




const VideoCore = (props) => {
    return (external_react_.createElement(esm_props_checker, { componentProps: props, componentName: "Video", defaultValueName: "defaultPlaying", valueName: "playing", onChangeNames: "onPlay" },
        external_react_.createElement(analytics_trigger/* default */.Z, { trigger: { callback: 'onPlay', id: `Video - ${props.title}` } },
            external_react_.createElement(VideoCoreInner, Object.assign({}, props)))));
};
class VideoCoreInner extends external_react_.Component {
    constructor(props) {
        super(props);
        this.video = external_react_.createRef();
        this.handleClick = (event) => {
            event.preventDefault();
            this.play();
        };
        this.play = () => {
            if (typeof this.props.playing === 'undefined') {
                this.setState({
                    playing: true,
                });
            }
            if (this.props.onPlay) {
                this.props.onPlay();
            }
        };
        this.pause = () => {
            if (typeof this.props.playing === 'undefined') {
                this.setState({
                    playing: false,
                });
            }
            if (this.props.onPause) {
                this.props.onPause();
            }
        };
        this.getUrl = (props) => {
            let url = props.url + '?autoplay=1';
            if (this.props.defaultPlaying) {
                url += '&muted=1';
            }
            return url;
        };
        this.state = {
            playing: props.defaultPlaying || false,
            hideOverview: props.hideOverview || false,
            isMounted: false,
        };
    }
    componentDidMount() {
        this.hideOverview();
        this.setState({
            isMounted: true,
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.isHtml5(this.props) && this.props.sources) {
            const prevPlaying = prevProps.onPlay && typeof prevProps.playing !== 'undefined' ? prevProps.playing : prevState.playing;
            if (prevPlaying !== this.playing && this.video && this.video.current) {
                if (this.playing) {
                    this.video.current.play();
                }
                else {
                    this.video.current.pause();
                }
            }
        }
        this.hideOverview();
    }
    get playing() {
        const { needsConsent } = this.props;
        // if without consent, we are not allowed to load the video
        if (!this.context.hasConsent(needsConsent)) {
            return false;
        }
        return this.props.onPlay && typeof this.props.playing !== 'undefined' ? this.props.playing : this.state.playing;
    }
    hideOverview() {
        if (!this.state.hideOverview && this.playing) {
            this.setState({
                hideOverview: true,
            });
        }
    }
    isHtml5(props) {
        return props.implementation === 'html5';
    }
    BEM(modifier) {
        const { needsConsent, position, className } = this.props;
        const classArray = ['video'];
        if (this.props.placeholderText) {
            classArray.push('video--text');
        }
        if (this.state.hideOverview) {
            classArray.push('hide-overview');
        }
        if (position) {
            classArray.push('video--' + position);
        }
        if (!this.context.hasConsent(needsConsent)) {
            classArray.push('video--needs-consent');
        }
        if (className) {
            classArray.push(className);
        }
        if (modifier) {
            classArray.push(modifier);
        }
        return classArray.join(' ');
    }
    renderHtml5(props) {
        const { sources, url, attributes, defaultPlaying } = props;
        const sourceElements = sources ? sources.map((source, key) => (external_react_.createElement("source", Object.assign({}, source, { key: key })))) : null;
        const linkHref = sources ? sources[0].src : url;
        const isHTML5Supported = this.state.isMounted && (typeof (document.createElement('video').canPlayType) !== 'undefined');
        const video = (external_react_.createElement("video", Object.assign({ ref: this.video, preload: "metadata", playsInline: true, controls: true, muted: defaultPlaying ? true : undefined }, attributes, { autoPlay: this.playing, onPause: this.pause, onPlay: this.play, className: "video__html5 lazyload", src: url }), sourceElements));
        return this.renderVideoWrapper(this.BEM('video--html5'), isHTML5Supported ? video : null, linkHref);
    }
    renderIframe(props) {
        const iframe = (external_react_.createElement("iframe", { title: props.title, className: "video__iframe lazyload", "data-src": this.playing ? this.getUrl(props) : undefined, width: "640", height: "360", allowFullScreen: true, onLoad: props.onLoad }));
        return this.renderVideoWrapper(this.BEM(), iframe, props.url);
    }
    renderPosterImage() {
        const { Image } = this.props.components;
        return external_react_.createElement(Image, Object.assign({ className: "video__image" }, this.props.poster));
    }
    renderVideoWrapper(className, children, linkHref) {
        const { Icon } = this.props.components;
        const { needsConsent } = this.props;
        const showOnlyImage = this.props.hideWithoutConsent === 'showPoster' && !this.context.hasConsent(needsConsent);
        const video = (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement("a", { href: linkHref, className: "video__btn", target: "_blank", rel: "noopener noreferrer", onClick: this.context.hasConsent(needsConsent) ? this.handleClick : undefined, ref: this.props.elementRef },
                this.renderPosterImage(),
                external_react_.createElement("div", { className: "video__content" },
                    external_react_.createElement("div", { className: "video__icon-wrapper" },
                        external_react_.createElement(Icon, { modifiers: "#play", className: "video__icon" })),
                    this.props.placeholderText && external_react_.createElement("div", { className: "h3 video__placeholder-text" }, this.props.placeholderText))),
            external_react_.createElement("div", { className: "video__holder" }, children)));
        return (external_react_.createElement("figure", { className: className },
            external_react_.createElement("div", { className: "video__inner" }, showOnlyImage ? this.renderPosterImage() : video)));
    }
    render() {
        const { needsConsent, hideWithoutConsent } = this.props;
        if (!this.context.hasConsent(needsConsent) && typeof hideWithoutConsent === 'boolean' && hideWithoutConsent) {
            return null;
        }
        if (this.isHtml5(this.props)) {
            return this.renderHtml5(this.props);
        }
        return this.renderIframe(this.props);
    }
}
VideoCoreInner.defaultProps = {
    needsConsent: ['statistics', 'marketing'],
    implementation: 'iframe',
};
VideoCoreInner.contextType = cookie_consent_provider/* CookieConsentContext */.Q;
/* harmony default export */ const video_core = (VideoCore);

;// CONCATENATED MODULE: ./node_modules/@telia-front/video/esm/video.js




const Video = (props) => {
    return (external_react_.createElement(video_core, Object.assign({}, props, { components: {
            Icon: icon/* default */.Z,
            Image: esm_image,
        } })));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-content/card-content-core.js
var card_content_core = __webpack_require__(2485);
;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card-content/card-content.js
var card_content_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





const CardContent = (props) => {
    const { background, children, className, style, tagTop } = props, rest = card_content_rest(props, ["background", "children", "className", "style", "tagTop"]);
    const getBackground = () => {
        if (background) {
            return background;
        }
    };
    const getTagProps = () => {
        if (typeof tagTop === 'object') {
            return tagTop;
        }
    };
    const BEM = () => {
        const classArray = [];
        const background = getBackground();
        if (background) {
            classArray.push((0,esm/* getBackgroundColorClass */.q)(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement(card_content_core/* default */.Z, Object.assign({ className: BEM(), style: style, tagTop: tagTop }, rest, { components: {
            Tag: (props) => external_react_default().createElement(Tag, Object.assign({}, props, getTagProps())),
            Image: esm_image,
        } }), children));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card-flip-content/card-flip-content.js
var card_flip_content_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



const CardFlipContent = (props) => {
    const { children } = props, rest = card_flip_content_rest(props, ["children"]);
    const context = external_react_default().useContext(CardContext);
    external_react_default().useEffect(() => {
        if (children) {
            context.setHasFlipContent(true);
        }
    }, [children, context]);
    const BEM = () => {
        const classArray = ['card__flip-content'];
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement(CardContent, Object.assign({}, rest, { className: BEM() }), children));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card/card.js
var card_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
















const CardContext = external_react_default().createContext({
    padding: 'medium',
    background: 'primary-4',
    setHasFlipContent: () => false,
});
const Card = (props) => {
    const labels = use_labels_useLabels();
    const { background, badgeTop, children, className, isFixedHeight, fullWidth, image, isClosable, leftBorderColor, leftBorderColorHex, padding = 'medium', tag, type, onClickClose } = props, rest = card_rest(props, ["background", "badgeTop", "children", "className", "isFixedHeight", "fullWidth", "image", "isClosable", "leftBorderColor", "leftBorderColorHex", "padding", "tag", "type", "onClickClose"]);
    const [hasFlipContent, setHasFlipContent] = external_react_default().useState(false);
    const [isFlipOpen, setIsFlipOpen] = external_react_default().useState(false);
    const [contentHeight, setContentHeight] = external_react_default().useState(undefined);
    const [flipHeight, setFlipHeight] = external_react_default().useState(undefined);
    const [height, setHeight] = external_react_default().useState(undefined);
    const [isAnimating, setIsAnimating] = external_react_default().useState(false);
    const cardRef = external_react_default().useRef(null);
    const contentRef = external_react_default().useRef(null);
    const flipRef = external_react_default().useRef(null);
    const updateHeight = external_react_default().useCallback(() => {
        if (flipRef.current) {
            setFlipHeight(flipRef.current.clientHeight);
        }
        if (contentRef.current) {
            setContentHeight(contentRef.current.clientHeight);
        }
    }, [setFlipHeight, setContentHeight]);
    const debouncedResizeHandler = external_react_default().useMemo(() => (0,debounce.debounce)(updateHeight, 100), [updateHeight]);
    external_react_default().useEffect(() => {
        updateHeight();
    }, [updateHeight]);
    external_react_default().useEffect(() => {
        window.addEventListener('resize', debouncedResizeHandler);
        return () => {
            window.removeEventListener('resize', debouncedResizeHandler);
        };
    }, [debouncedResizeHandler]);
    const getBackground = () => {
        if (background) {
            switch (background) {
                case 'transparent':
                    return;
                default:
                    return background;
            }
        }
        return 'primary-3';
    };
    const backgroundColor = getBackground();
    const BEM = () => {
        const classArray = [];
        if (type) {
            classArray.push(`card--${type}`);
        }
        if (backgroundColor) {
            classArray.push((0,esm/* getBackgroundColorClass */.q)(backgroundColor));
        }
        if (leftBorderColor || leftBorderColorHex) {
            classArray.push('card--left-bordered');
        }
        if (leftBorderColor) {
            classArray.push(`card--left-bordered-${leftBorderColor}`);
        }
        if (fullWidth) {
            classArray.push('card--full-width');
        }
        if (hasFlipContent) {
            classArray.push('card--with-flip-content');
            if (isFlipOpen) {
                classArray.push('is-flipped');
            }
            if (isAnimating) {
                classArray.push('is-animating');
            }
            if (isFixedHeight) {
                classArray.push('is-fixed-height');
            }
        }
        if (isClosable) {
            classArray.push('card--is-closable');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const renderRegularContent = (state) => (external_react_default().createElement((external_react_default()).Fragment, null, external_react_default().Children.map(children, (child) => {
        if (!external_react_default().isValidElement(child)) {
            return child;
        }
        if (child.type === CardContent) {
            const BEM = (childProps) => {
                const classArray = [`is-${state}`];
                if (childProps.className) {
                    classArray.push(childProps.className);
                }
                return classArray.join(' ');
            };
            return external_react_default().cloneElement(child, Object.assign(Object.assign({}, child.props), { className: BEM(child.props), elementRef: (el) => {
                    if (contentRef.current !== el) {
                        contentRef.current = el;
                        updateHeight();
                    }
                } }));
        }
    })));
    const renderFlipContent = (state) => (external_react_default().createElement((external_react_default()).Fragment, null, external_react_default().Children.map(children, (child) => {
        if (!external_react_default().isValidElement(child)) {
            return child;
        }
        if (child.type === CardFlipContent) {
            const BEM = (childProps) => {
                const classArray = [`is-${state}`];
                if (childProps.className) {
                    classArray.push(childProps.className);
                }
                return classArray.join(' ');
            };
            return external_react_default().cloneElement(child, Object.assign(Object.assign({}, child.props), { className: BEM(child.props), elementRef: (el) => {
                    if (flipRef.current !== el) {
                        flipRef.current = el;
                        updateHeight();
                    }
                } }));
        }
    })));
    const renderAnimatedContent = () => (external_react_default().createElement((external_react_default()).Fragment, null,
        external_react_default().createElement(Transition/* default */.ZP, { in: !isFlipOpen, timeout: { enter: 150, exit: 150 }, onEnter: () => setIsAnimating(true), onEntering: () => {
                window.setTimeout(() => {
                    setHeight(contentHeight);
                });
            }, onExiting: () => setIsAnimating(true), onExited: () => setIsAnimating(false) }, renderRegularContent),
        external_react_default().createElement(Transition/* default */.ZP, { in: isFlipOpen, timeout: { enter: 150, exit: 150 }, onEnter: () => setIsAnimating(true), onEntering: () => {
                window.setTimeout(() => {
                    setHeight(flipHeight);
                });
            }, onExiting: () => setIsAnimating(true), onExited: () => setIsAnimating(false) }, renderFlipContent)));
    const renderContent = () => (external_react_default().createElement((external_react_default()).Fragment, null,
        isClosable && onClickClose && (external_react_default().createElement(close_button_CloseButton, { className: "card__close", onClick: onClickClose })),
        image && (external_react_default().createElement("div", { className: "card__figure" },
            external_react_default().createElement(esm_image, Object.assign({}, image, { className: "card__image" })))),
        children));
    const getHeight = () => {
        if (hasFlipContent && isAnimating && !isFixedHeight) {
            return height ? height : contentHeight;
        }
    };
    const getBadgeTopProps = () => {
        if (typeof badgeTop === 'object') {
            return badgeTop;
        }
    };
    return (external_react_default().createElement(CardContext.Provider, { value: {
            padding: padding,
            background: backgroundColor || 'transparent',
            setHasFlipContent,
        } },
        external_react_default().createElement(card_core/* default */.ZP, Object.assign({}, rest, { className: BEM(), padding: padding, badgeTop: badgeTop, tag: tag, components: {
                Video: Video,
                Image: esm_image,
                Badge: (props) => (external_react_default().createElement(Badge, Object.assign({}, props, getBadgeTopProps()))),
                Tag: Tag,
                TagGroup: tag_group_TagGroup,
            }, style: {
                borderLeftColor: leftBorderColorHex || undefined,
                height: getHeight(),
            }, elementRef: (el) => {
                if (cardRef.current !== el) {
                    cardRef.current = el;
                }
            } }),
            hasFlipContent && (external_react_default().createElement(Button, { className: "card__flip-toggle", icon: isFlipOpen ? '#close' : '#info-round', text: labels.get(isFlipOpen ? 'card.closeInfo' : 'card.showInfo'), link: true, onClick: () => setIsFlipOpen(!isFlipOpen) })),
            hasFlipContent ? renderAnimatedContent() : renderContent())));
};
Card.defaultProps = {
    onClick: esm_navigate,
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-bottom/card-bottom-core.js
var card_bottom_core = __webpack_require__(3302);
;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card-bottom/card-bottom.js
var card_bottom_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardBottom = (props) => {
    const { children } = props, rest = card_bottom_rest(props, ["children"]);
    return (external_react_default().createElement(card_bottom_core/* default */.Z, Object.assign({}, rest), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-footer/card-footer-core.js
var card_footer_core = __webpack_require__(6912);
;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card-footer/card-footer.js
var card_footer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const CardFooter = (props) => {
    const { background, children, className } = props, rest = card_footer_rest(props, ["background", "children", "className"]);
    const { background: cardColor } = external_react_default().useContext(CardContext);
    const getBackground = () => {
        if (background) {
            return background;
        }
        switch (cardColor) {
            case 'neutral-1':
                return 'primary-3';
            case 'transparent':
                return;
            default:
                return 'neutral-1';
        }
    };
    const BEM = () => {
        const classArray = [];
        const background = getBackground();
        if (background) {
            classArray.push((0,esm/* getBackgroundColorClass */.q)(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement(card_footer_core/* default */.Z, Object.assign({ className: BEM() }, rest), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-header/card-header-core.js
var card_header_core = __webpack_require__(5892);
;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card-header/card-header.js
var card_header_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const CardHeader = (props) => {
    const { background, children, className } = props, rest = card_header_rest(props, ["background", "children", "className"]);
    const { background: cardColor } = external_react_default().useContext(CardContext);
    const getBackground = () => {
        if (background) {
            return background;
        }
        switch (cardColor) {
            case 'neutral-1':
                return 'primary-3';
            case 'transparent':
                return;
            default:
                return 'neutral-1';
        }
    };
    const BEM = () => {
        const classArray = [];
        const background = getBackground();
        if (background) {
            classArray.push((0,esm/* getBackgroundColorClass */.q)(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_default().createElement(card_header_core/* default */.Z, Object.assign({ className: BEM() }, rest), children));
};


// EXTERNAL MODULE: ./node_modules/@core-front/card/esm/card-top/card-top-core.js
var card_top_core = __webpack_require__(7058);
;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/card-top/card-top.js
var card_top_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const CardTop = (props) => {
    const { children } = props, rest = card_top_rest(props, ["children"]);
    return (external_react_default().createElement(card_top_core/* default */.Z, Object.assign({}, rest), children));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/card/esm/index.js









/***/ }),

/***/ 9356:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ getBackgroundColorClass)
/* harmony export */ });
/* unused harmony export getColorClass */
const getBackgroundColorClass = (type) => `bg-${type}`;
const getColorClass = (type) => `c-${type}`;


/***/ }),

/***/ 7706:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Table": () => (/* reexport */ Table),
  "TableCell": () => (/* reexport */ TableCell),
  "TableRow": () => (/* reexport */ TableRow),
  "default": () => (/* reexport */ Table)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
var react_responsive_default = /*#__PURE__*/__webpack_require__.n(react_responsive);
// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-responsive-props.js + 1 modules
var use_responsive_props = __webpack_require__(9097);
// EXTERNAL MODULE: ./node_modules/@core-front/helper/esm/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(8539);
// EXTERNAL MODULE: ./node_modules/@core-front/theme-provider/esm/use-theme.js
var use_theme = __webpack_require__(3286);
// EXTERNAL MODULE: ./node_modules/@telia-front/colors/esm/index.js
var esm = __webpack_require__(9356);
;// CONCATENATED MODULE: ./node_modules/@telia-front/table/esm/table-cell/table-cell.js


const TableCell = (props) => {
    const { type = 'td', width, padding, indentLevel, valign, background, className, id, colSpan, rowSpan, headless, scope, children, } = props;
    const Element = type;
    const BEM = () => {
        const classArray = ['table__cell'];
        if (width) {
            classArray.push(`table__cell--${width}`);
        }
        if (padding) {
            classArray.push(`table__cell--padding-${padding}`);
        }
        if (indentLevel) {
            classArray.push(`table__cell--indent-level-${indentLevel}`);
        }
        if (valign) {
            classArray.push(`table__cell--valign-${valign}`);
        }
        if (background && background !== 'transparent') {
            classArray.push((0,esm/* getBackgroundColorClass */.q)(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement(Element, { className: BEM(), id: id, colSpan: colSpan, rowSpan: rowSpan, "data-headless": headless, scope: type === 'th' ? scope : undefined }, children));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/table/esm/table-row/table-row.js


const TableRow = (props) => {
    const { type, leftBorderColor, background, className, id, onClick, children, } = props;
    const BEM = () => {
        const classArray = ['table__row'];
        if (type) {
            classArray.push('table__row--' + type);
        }
        if (leftBorderColor) {
            classArray.push('table__row--left-bordered-' + leftBorderColor);
        }
        if (background && background !== 'transparent') {
            classArray.push((0,esm/* getBackgroundColorClass */.q)(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (external_react_.createElement("tr", { className: BEM(), id: id, onClick: onClick }, children));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/table/esm/table/table.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const Table = (props) => {
    const { responsiveProps } = props, rest = __rest(props, ["responsiveProps"]);
    return responsiveProps ? external_react_.createElement(TableInnerResponsive, Object.assign({}, rest, { responsiveProps: responsiveProps })) : external_react_.createElement(TableInner, Object.assign({}, rest));
};
const TableInnerResponsive = (props) => {
    const { responsiveProps } = props, rest = __rest(props, ["responsiveProps"]);
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const responsive = (0,use_responsive_props/* useResponsiveProps */.S)({ breakPoints, responsive: responsiveProps });
    return external_react_.createElement(TableInner, Object.assign({}, rest, responsive));
};
const TableInner = (props) => {
    const { break: breakpoint = 'sm', responsive, hover, stickyHeader, className, bordered, maxHeight, minWidth, children, onScroll, elementRef, } = props;
    const { breakPoints } = (0,use_theme/* useTheme */.F)();
    const tableRef = external_react_.useRef(null);
    const [isSticky, setIsSticky] = external_react_.useState(false);
    const isMounted = (0,use_is_mounted/* useIsMounted */.t)();
    const BEM = () => {
        const classArray = ['table'];
        if (responsive) {
            classArray.push('table--responsive');
        }
        if (hover) {
            classArray.push('table--hover');
        }
        if (bordered) {
            classArray.push('table--bordered');
        }
        if (stickyHeader) {
            classArray.push(`table--sticky-header-${stickyHeader}`);
            if (isSticky) {
                classArray.push('is-sticky');
            }
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const currentBreakpoint = external_react_.useMemo(() => {
        if (!responsive) {
            return 0;
        }
        return breakPoints[breakpoint];
    }, [breakPoints, breakpoint, responsive]);
    const handleScroll = (e) => {
        const { current } = tableRef;
        const isBroken = breakpoint && window.matchMedia(`(max-width: ${currentBreakpoint - 1}px)`).matches;
        if (current && !isBroken) {
            const currentIsSticky = current.scrollTop > 0;
            setIsSticky(currentIsSticky);
        }
        if (onScroll) {
            onScroll(e);
        }
    };
    const getCleanTable = external_react_.useMemo(() => {
        // Remove whitespace added via Wordpress and react-jsx-parser
        const tableSections = external_react_.Children.map(children, (child, childIndex) => {
            if (external_react_.isValidElement(child) && (child.type === 'thead' || child.type === 'tbody')) {
                const rows = external_react_.Children.map(child.props.children, (tr, trIndex) => {
                    if (!external_react_.isValidElement(tr)) {
                        return null;
                    }
                    if (tr.type === 'tr' || tr.type === TableRow) {
                        // handle normal row
                        const cells = external_react_.Children.map(tr.props.children, (td) => {
                            if (external_react_.isValidElement(td) && (td.type === 'td' || td.type === 'th' || td.type === TableCell)) {
                                return td;
                            }
                            return null;
                        });
                        const newRowProps = {
                            children: cells,
                            key: trIndex,
                        };
                        return external_react_.cloneElement(tr, newRowProps);
                    }
                    return null;
                });
                const newChildProps = {
                    children: rows,
                    key: childIndex,
                };
                const newChild = external_react_.cloneElement(child, newChildProps);
                return newChild;
            }
            return null;
        });
        return tableSections;
    }, [children]);
    const getTableDataCols = external_react_.useMemo(() => {
        const cleanedTable = getCleanTable;
        const tables = [];
        const thead = [];
        let footer = null;
        cleanedTable.forEach((child) => {
            if (!external_react_.isValidElement(child)) {
                return null;
            }
            external_react_.Children.forEach(child.props.children, (tr, trIndex) => {
                if (!external_react_.isValidElement(tr) || tr.props.type === 'highlight-header') {
                    return null;
                }
                let cellIndex = 0;
                const rowChildrenCount = external_react_.Children.count(tr.props.children);
                const rowChildrenAsArray = external_react_.Children.toArray(tr.props.children);
                // Create table (exclude thead)
                if (child.type === 'tbody' &&
                    !tables[trIndex]) {
                    tables[trIndex] = [];
                }
                if ((tr.props['data-footer'] || tr.props.type === 'footer') && rowChildrenCount <= 2) {
                    footer = {
                        cells: [rowChildrenAsArray[0], rowChildrenAsArray[rowChildrenCount - 1]],
                        row: tr,
                    };
                }
                else {
                    external_react_.Children.forEach(rowChildrenAsArray, (td) => {
                        if (!external_react_.isValidElement(td)) {
                            return null;
                        }
                        // Store theads
                        if (child.type === 'thead') {
                            thead.push(td);
                            return;
                        }
                        // Shift table index until it finds empty one (avoid rows filled by rowSpan - avoid row overrides)
                        if (tables[trIndex][cellIndex]) {
                            do {
                                cellIndex += 1;
                            } while (tables[trIndex][cellIndex]);
                        }
                        // Add cell and duplicate it in other tables (duplicate rowSpan cells between tables)
                        const tableRepeat = td.props.rowSpan || 1;
                        for (let i = 0; i < tableRepeat; i += 1) {
                            // create table row
                            const row = child.props.children[trIndex + i];
                            // Create table if not defined
                            if (!tables[trIndex + i]) {
                                tables[trIndex + i] = [];
                            }
                            // add row to table
                            tables[trIndex + i][cellIndex] = { cells: [thead[cellIndex], td], row };
                            // has col span
                            if (td.props.colSpan) {
                                for (let j = 1; j < td.props.colSpan; j += 1) {
                                    tables[trIndex + i][cellIndex + j] = { cells: [thead[cellIndex + j]], row };
                                }
                            }
                        }
                        if ((td.props['data-headless'] || td.props.headless) && td.props.colSpan) {
                            for (let i = 0; i < td.props.colSpan; i++) {
                                if (cellIndex + i !== cellIndex) {
                                    delete tables[trIndex][cellIndex + i];
                                }
                            }
                        }
                    });
                }
            });
        });
        if (footer) {
            tables[tables.length - 1] = [];
            tables[tables.length - 1].push(footer);
        }
        return tables;
    }, [getCleanTable]);
    const getTableDataRows = external_react_.useMemo(() => {
        const cleanedTable = getCleanTable;
        const tables = [];
        let rowIndex = 0; // flatten thead and tbody row indexes
        let footer = null;
        cleanedTable.forEach((child) => {
            if (!external_react_.isValidElement(child)) {
                return null;
            }
            external_react_.Children.forEach(child.props.children, (tr, trIndex) => {
                if (!external_react_.isValidElement(tr)) {
                    return null;
                }
                // Index th/td cells as tables index (excludes row headers and fast forwards with colsPan)
                let tableIndex = 0;
                const rowChildrenCount = external_react_.Children.count(tr.props.children);
                const rowChildrenAsArray = external_react_.Children.toArray(tr.props.children);
                if (tr.props['data-footer'] || tr.props.type === 'footer') {
                    footer = {
                        cells: [rowChildrenAsArray[0], rowChildrenAsArray[rowChildrenCount - 1]],
                        row: tr,
                    };
                }
                else {
                    external_react_.Children.forEach(rowChildrenAsArray, (td, tdIndex) => {
                        if (!external_react_.isValidElement(td)) {
                            return null;
                        }
                        // Shift table based on th colSpan
                        if (tdIndex === 0 && td.props.colSpan) {
                            tableIndex += td.props.colSpan - 1;
                        }
                        // No table for row header
                        if (tdIndex === 0) {
                            return;
                        }
                        // Create table
                        if (!tables[tableIndex]) {
                            tables[tableIndex] = [];
                        }
                        // Shift table index until it finds empty one (avoid rows filled by rowSpan - avoid row overrides)
                        if (tables[tableIndex][rowIndex]) {
                            do {
                                tableIndex += 1;
                            } while (tables[tableIndex][rowIndex]);
                        }
                        // Add cell and duplicate it in other tables (duplicate colSpan cells between tables)
                        const tableRepeat = td.props.colSpan || 1;
                        for (let i = 0; i < tableRepeat; i += 1) {
                            // create table row
                            // Create table if not defined (missing thead)
                            if (!tables[tableIndex]) {
                                tables[tableIndex] = [];
                            }
                            // add row to table
                            tables[tableIndex][rowIndex] = {
                                cells: [rowChildrenAsArray[0], td],
                                row: tr,
                                type: (child.type === 'thead') ? 'thead' : 'tbody',
                            };
                            // has row span
                            if (td.props.rowSpan) {
                                // Fill table's next rows based on rowSpan
                                for (let j = 1; j < td.props.rowSpan; j += 1) {
                                    // Using trIndex over rowIndex since child specific request
                                    const row = child.props.children[trIndex + j];
                                    tables[tableIndex][rowIndex + j] = {
                                        cells: [row.props.children[0] || row.props.children],
                                        row,
                                        type: (child.type === 'thead') ? 'thead' : 'tbody',
                                    };
                                }
                            }
                            // shift table index
                            tableIndex += 1;
                        }
                    });
                }
                // shift row index
                rowIndex += 1;
            });
        });
        if (footer) {
            tables[tables.length] = [];
            tables[tables.length - 1].push(footer);
        }
        return tables;
    }, [getCleanTable]);
    const isHeadless = (row) => {
        return (row.row.props['data-headless'] || row.row.props.headless) || (row.cells[1] &&
            (row.cells[1].props['data-headless'] || row.cells[1].props.headless));
    };
    const genThead = (thead, key) => {
        return (external_react_.createElement("thead", { key: key }, thead));
    };
    const genTbody = (tbody, key, className) => {
        return (external_react_.createElement("tbody", { key: key, className: className }, tbody));
    };
    const getTableData = external_react_.useMemo(() => {
        switch (responsive) {
            case 'rows':
                return getTableDataRows;
            case 'cols':
                return getTableDataCols;
            default:
                return [];
        }
    }, [getTableDataCols, getTableDataRows, responsive]);
    const getAltTable = external_react_.useMemo(() => {
        const tablesData = getTableData;
        const newTable = [];
        tablesData.forEach((tableData, tableIndex) => {
            const thead = {
                children: [],
                type: 'thead',
            };
            const bodyClassArray = [];
            const tbody = {
                children: [],
                className: undefined,
                type: 'tbody',
            };
            newTable[tableIndex] = [];
            tableData.forEach((rowData, index) => {
                // Add classNames to tbody from TableRows
                if (rowData.row.props.bodyClassName) {
                    bodyClassArray.push(rowData.row.props.bodyClassName);
                }
                const headless = isHeadless(rowData);
                const colSpan = (headless) ? 2 : 0;
                const cell1 = (!headless) ? rowData.cells[0] : null;
                const cell2 = rowData.cells[1];
                let newCell1 = null;
                let newCell2 = null;
                // Cell1
                if (cell1) {
                    const newCell1Props = {
                        colSpan: 0,
                        key: 0,
                    };
                    newCell1 = external_react_.cloneElement(cell1, newCell1Props);
                }
                // Cell2
                if (cell2) {
                    let newCell2Props = {
                        colSpan,
                        key: 1,
                    };
                    if (responsive === 'cols') {
                        // colSpan => rowSpan
                        newCell2Props = {
                            colSpan,
                            key: 1,
                            rowSpan: (cell2.props['data-headless'] || cell2.props.headless) ? 1 : cell2.props.colSpan,
                        };
                    }
                    newCell2 = external_react_.cloneElement(cell2, newCell2Props);
                }
                // Row1
                const newRowProps = {
                    children: [
                        newCell1,
                        newCell2,
                    ],
                    key: index,
                };
                const newRow = external_react_.cloneElement(rowData.row, newRowProps);
                // Don't show empty rows
                if (cell2 && !cell2.props.children) {
                    return;
                }
                if (newRow.props['data-table-collapse'] || newRow.props.collapsible) {
                    bodyClassArray.push('table-collapse__body');
                }
                if (rowData.type === 'thead') {
                    thead.children.push(newRow);
                }
                else {
                    tbody.children.push(newRow);
                }
            });
            tbody.className = bodyClassArray.join(' ');
            newTable[tableIndex] = [thead, tbody];
        });
        const blocks = newTable
            .reduce((arr, curr) => {
            return arr.concat(curr);
        }, [])
            .map((block, i) => {
            if (block.type === 'thead') {
                return genThead(block.children, i);
            }
            else {
                return genTbody(block.children, i, block.className);
            }
        });
        return (external_react_.createElement("table", null, blocks));
    }, [getTableData, responsive]);
    const getDynamicTable = () => {
        return (external_react_.createElement(external_react_.Fragment, null,
            external_react_.createElement((react_responsive_default()), { minWidth: currentBreakpoint }, getDefaultTable(true)),
            external_react_.createElement((react_responsive_default()), { maxWidth: currentBreakpoint - 1 },
                external_react_.createElement("div", { className: "table__responsive" }, responsive && getAltTable))));
    };
    const getDefaultTable = (hasBreakProp) => {
        const tableContent = hasBreakProp ? getCleanTable : children;
        return (external_react_.createElement("div", { className: "table__original" },
            external_react_.createElement("table", { style: minWidth ? { minWidth: typeof minWidth === 'string' ? minWidth : `${minWidth}px` } : undefined }, tableContent)));
    };
    const tableStyle = external_react_.useMemo(() => {
        let styles = {};
        if (maxHeight) {
            styles = Object.assign(Object.assign({}, styles), { maxHeight });
        }
        return styles;
    }, [maxHeight]);
    external_react_.useEffect(() => {
        if (elementRef && tableRef.current) {
            elementRef(tableRef.current);
        }
    }, [elementRef, tableRef]);
    return (external_react_.createElement("div", { className: BEM(), style: tableStyle, ref: tableRef, onScroll: handleScroll }, (isMounted && responsive) ? getDynamicTable() : getDefaultTable(false)));
};


;// CONCATENATED MODULE: ./node_modules/@telia-front/table/esm/index.js





/***/ }),

/***/ 5302:
/***/ ((module) => {

"use strict";
/*!
 * array-unique <https://github.com/jonschlinkert/array-unique>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



module.exports = function unique(arr) {
  if (!Array.isArray(arr)) {
    throw new TypeError('array-unique expects an array.');
  }

  var len = arr.length;
  var i = -1;

  while (i++ < len) {
    var j = i + 1;

    for (; j < arr.length; ++j) {
      if (arr[i] === arr[j]) {
        arr.splice(j--, 1);
      }
    }
  }
  return arr;
};

module.exports.immutable = function uniqueImmutable(arr) {
  if (!Array.isArray(arr)) {
    throw new TypeError('array-unique expects an array.');
  }

  var arrLen = arr.length;
  var newArr = new Array(arrLen);

  for (var i = 0; i < arrLen; i++) {
    newArr[i] = arr[i];
  }

  return module.exports(newArr);
};


/***/ }),

/***/ 9669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(1609);

/***/ }),

/***/ 5448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var settle = __webpack_require__(6026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(5327);
var buildFullPath = __webpack_require__(4097);
var parseHeaders = __webpack_require__(4109);
var isURLSameOrigin = __webpack_require__(7985);
var transitionalDefaults = __webpack_require__(7874);
var AxiosError = __webpack_require__(2648);
var CanceledError = __webpack_require__(644);
var parseProtocol = __webpack_require__(205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 1609:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var bind = __webpack_require__(1849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(7185);
var defaults = __webpack_require__(5546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(644);
axios.CancelToken = __webpack_require__(4972);
axios.isCancel = __webpack_require__(6502);
axios.VERSION = (__webpack_require__(7288).version);
axios.toFormData = __webpack_require__(7675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(2648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(6268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 4972:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var CanceledError = __webpack_require__(644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 644:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var AxiosError = __webpack_require__(2648);
var utils = __webpack_require__(4867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 6502:
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var buildURL = __webpack_require__(5327);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(3572);
var mergeConfig = __webpack_require__(7185);
var buildFullPath = __webpack_require__(4097);
var validator = __webpack_require__(4875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 2648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 782:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 4097:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var isAbsoluteURL = __webpack_require__(1793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 3572:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var transformData = __webpack_require__(8527);
var isCancel = __webpack_require__(6502);
var defaults = __webpack_require__(5546);
var CanceledError = __webpack_require__(644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 7185:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6026:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var AxiosError = __webpack_require__(2648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8527:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var defaults = __webpack_require__(5546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 5546:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var normalizeHeaderName = __webpack_require__(6016);
var AxiosError = __webpack_require__(2648);
var transitionalDefaults = __webpack_require__(7874);
var toFormData = __webpack_require__(7675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(5448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(5448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(1623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 7874:
/***/ ((module) => {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 7288:
/***/ ((module) => {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 1849:
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 5327:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 1793:
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 6268:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 7985:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 6016:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 1623:
/***/ ((module) => {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 4109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 205:
/***/ ((module) => {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 7675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 4875:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var VERSION = (__webpack_require__(7288).version);
var AxiosError = __webpack_require__(2648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 4867:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(1849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 1924:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var callBind = __webpack_require__(5559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 5559:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(8612);
var GetIntrinsic = __webpack_require__(210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 4184:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 4810:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ addLeadingZeros)
/* harmony export */ });
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),

/***/ 8958:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ defaultLocale)
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ const _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ const _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ const _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ const _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ const _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ const en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ const defaultLocale = (en_US);

/***/ }),

/***/ 4314:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ setDefaultOptions),
/* harmony export */   "j": () => (/* binding */ getDefaultOptions)
/* harmony export */ });
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 5834:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4810);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0,_addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(fractionalSeconds, token.length);
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatters);

/***/ }),

/***/ 7621:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (longFormatters);

/***/ }),

/***/ 4262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getTimezoneOffsetInMilliseconds)
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 9702:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ getUTCISOWeek)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(9013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(6979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(3882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7032:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getUTCISOWeekYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6979);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 3324:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ getUTCWeek)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(9013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(9025);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(3882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(3946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(4314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7651:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getUTCWeekYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9025);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4314);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5267:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": () => (/* binding */ isProtectedWeekYearToken),
/* harmony export */   "Iu": () => (/* binding */ isProtectedDayOfYearToken),
/* harmony export */   "qp": () => (/* binding */ throwProtectedError)
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 3882:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ requiredArgs)
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 3645:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ getRoundingMethod)
/* harmony export */ });
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/***/ }),

/***/ 6979:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfUTCISOWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 9025:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfUTCWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4314);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 3946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ toInteger)
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 9422:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ add)
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7349);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1640);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }







/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  if (!duration || _typeof(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.years) : 0;
  var months = duration.months ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.weeks) : 0;
  var days = duration.days ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.days) : 0;
  var hours = duration.hours ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.seconds) : 0; // Add years and months

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var dateWithMonths = months || years ? (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, months + years * 12) : date; // Add weeks and days

  var dateWithDays = days || weeks ? (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}

/***/ }),

/***/ 7349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ addDays)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 1820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ addMilliseconds)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 1640:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ addMonths)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 1593:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ addYears)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * 12);
}

/***/ }),

/***/ 6948:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CU": () => (/* binding */ monthsInYear),
/* harmony export */   "LI": () => (/* binding */ maxTime),
/* harmony export */   "Ob": () => (/* binding */ monthsInQuarter),
/* harmony export */   "QI": () => (/* binding */ minTime),
/* harmony export */   "R3": () => (/* binding */ secondsInHour),
/* harmony export */   "Y2": () => (/* binding */ secondsInQuarter),
/* harmony export */   "_j": () => (/* binding */ quartersInYear),
/* harmony export */   "dT": () => (/* binding */ daysInYear),
/* harmony export */   "fR": () => (/* binding */ minutesInHour),
/* harmony export */   "gM": () => (/* binding */ secondsInDay),
/* harmony export */   "ju": () => (/* binding */ daysInWeek),
/* harmony export */   "nZ": () => (/* binding */ secondsInMonth),
/* harmony export */   "qk": () => (/* binding */ millisecondsInSecond),
/* harmony export */   "rz": () => (/* binding */ secondsInYear),
/* harmony export */   "vh": () => (/* binding */ millisecondsInHour),
/* harmony export */   "vr": () => (/* binding */ secondsInWeek),
/* harmony export */   "xx": () => (/* binding */ secondsInMinute),
/* harmony export */   "yJ": () => (/* binding */ millisecondsInMinute)
/* harmony export */ });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 2300:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ differenceInCalendarDays)
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4262);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 9910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ differenceInMilliseconds)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateLeft).getTime() - (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateRight).getTime();
}

/***/ }),

/***/ 1699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ differenceInSeconds)
/* harmony export */ });
/* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9910);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_roundingMethods_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3645);



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var diff = (0,_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateLeft, dateRight) / 1000;
  return (0,_lib_roundingMethods_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getRoundingMethod */ .u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),

/***/ 5639:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ format)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(2274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(1218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(9013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(3882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(9702);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(3324);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__(4810);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var lightFormatters = __webpack_require__(5834);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters/* default.y */.Z.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0,addLeadingZeros/* default */.Z)(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return (0,addLeadingZeros/* default */.Z)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date); // Padding

    return (0,addLeadingZeros/* default */.Z)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return (0,addLeadingZeros/* default */.Z)(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return (0,addLeadingZeros/* default */.Z)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return (0,addLeadingZeros/* default */.Z)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters/* default.M */.Z.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return (0,addLeadingZeros/* default */.Z)(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters/* default.d */.Z.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return (0,addLeadingZeros/* default */.Z)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return (0,addLeadingZeros/* default */.Z)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return (0,addLeadingZeros/* default */.Z)(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters/* default.h */.Z.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters/* default.H */.Z.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters/* default.m */.Z.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters/* default.s */.Z.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters/* default.S */.Z.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0,addLeadingZeros/* default */.Z)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0,addLeadingZeros/* default */.Z)(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0,addLeadingZeros/* default */.Z)(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0,addLeadingZeros/* default */.Z)(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0,addLeadingZeros/* default */.Z)(Math.floor(absOffset / 60), 2);
  var minutes = (0,addLeadingZeros/* default */.Z)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ const format_formatters = (formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(7621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(4262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(3946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(4314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(8958);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getDaysInMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/***/ }),

/***/ 4500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getISODay)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */

function getISODay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day;
}

/***/ }),

/***/ 911:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getISOWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6573);
/* harmony import */ var _startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(546);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);




var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var diff = (0,_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date).getTime() - (0,_startOfISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 5425:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getISOWeekYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6573);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5570:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getFullYear();
}

/***/ }),

/***/ 429:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "add": () => (/* reexport */ add/* default */.Z),
  "addBusinessDays": () => (/* reexport */ addBusinessDays),
  "addDays": () => (/* reexport */ addDays/* default */.Z),
  "addHours": () => (/* reexport */ addHours),
  "addISOWeekYears": () => (/* reexport */ addISOWeekYears),
  "addMilliseconds": () => (/* reexport */ addMilliseconds/* default */.Z),
  "addMinutes": () => (/* reexport */ addMinutes),
  "addMonths": () => (/* reexport */ addMonths/* default */.Z),
  "addQuarters": () => (/* reexport */ addQuarters),
  "addSeconds": () => (/* reexport */ addSeconds),
  "addWeeks": () => (/* reexport */ addWeeks),
  "addYears": () => (/* reexport */ addYears/* default */.Z),
  "areIntervalsOverlapping": () => (/* reexport */ areIntervalsOverlapping),
  "clamp": () => (/* reexport */ clamp),
  "closestIndexTo": () => (/* reexport */ closestIndexTo),
  "closestTo": () => (/* reexport */ closestTo),
  "compareAsc": () => (/* reexport */ compareAsc),
  "compareDesc": () => (/* reexport */ compareDesc),
  "daysInWeek": () => (/* reexport */ constants/* daysInWeek */.ju),
  "daysInYear": () => (/* reexport */ constants/* daysInYear */.dT),
  "daysToWeeks": () => (/* reexport */ daysToWeeks),
  "differenceInBusinessDays": () => (/* reexport */ differenceInBusinessDays),
  "differenceInCalendarDays": () => (/* reexport */ differenceInCalendarDays/* default */.Z),
  "differenceInCalendarISOWeekYears": () => (/* reexport */ differenceInCalendarISOWeekYears),
  "differenceInCalendarISOWeeks": () => (/* reexport */ differenceInCalendarISOWeeks),
  "differenceInCalendarMonths": () => (/* reexport */ differenceInCalendarMonths),
  "differenceInCalendarQuarters": () => (/* reexport */ differenceInCalendarQuarters),
  "differenceInCalendarWeeks": () => (/* reexport */ differenceInCalendarWeeks),
  "differenceInCalendarYears": () => (/* reexport */ differenceInCalendarYears),
  "differenceInDays": () => (/* reexport */ differenceInDays),
  "differenceInHours": () => (/* reexport */ differenceInHours),
  "differenceInISOWeekYears": () => (/* reexport */ differenceInISOWeekYears),
  "differenceInMilliseconds": () => (/* reexport */ differenceInMilliseconds/* default */.Z),
  "differenceInMinutes": () => (/* reexport */ differenceInMinutes),
  "differenceInMonths": () => (/* reexport */ differenceInMonths),
  "differenceInQuarters": () => (/* reexport */ differenceInQuarters),
  "differenceInSeconds": () => (/* reexport */ differenceInSeconds/* default */.Z),
  "differenceInWeeks": () => (/* reexport */ differenceInWeeks),
  "differenceInYears": () => (/* reexport */ differenceInYears),
  "eachDayOfInterval": () => (/* reexport */ eachDayOfInterval),
  "eachHourOfInterval": () => (/* reexport */ eachHourOfInterval),
  "eachMinuteOfInterval": () => (/* reexport */ eachMinuteOfInterval),
  "eachMonthOfInterval": () => (/* reexport */ eachMonthOfInterval),
  "eachQuarterOfInterval": () => (/* reexport */ eachQuarterOfInterval),
  "eachWeekOfInterval": () => (/* reexport */ eachWeekOfInterval),
  "eachWeekendOfInterval": () => (/* reexport */ eachWeekendOfInterval),
  "eachWeekendOfMonth": () => (/* reexport */ eachWeekendOfMonth),
  "eachWeekendOfYear": () => (/* reexport */ eachWeekendOfYear),
  "eachYearOfInterval": () => (/* reexport */ eachYearOfInterval),
  "endOfDay": () => (/* reexport */ endOfDay),
  "endOfDecade": () => (/* reexport */ endOfDecade),
  "endOfHour": () => (/* reexport */ endOfHour),
  "endOfISOWeek": () => (/* reexport */ endOfISOWeek),
  "endOfISOWeekYear": () => (/* reexport */ endOfISOWeekYear),
  "endOfMinute": () => (/* reexport */ endOfMinute),
  "endOfMonth": () => (/* reexport */ endOfMonth),
  "endOfQuarter": () => (/* reexport */ endOfQuarter),
  "endOfSecond": () => (/* reexport */ endOfSecond),
  "endOfToday": () => (/* reexport */ endOfToday),
  "endOfTomorrow": () => (/* reexport */ endOfTomorrow),
  "endOfWeek": () => (/* reexport */ endOfWeek),
  "endOfYear": () => (/* reexport */ endOfYear),
  "endOfYesterday": () => (/* reexport */ endOfYesterday),
  "format": () => (/* reexport */ format/* default */.Z),
  "formatDistance": () => (/* reexport */ formatDistance),
  "formatDistanceStrict": () => (/* reexport */ formatDistanceStrict),
  "formatDistanceToNow": () => (/* reexport */ formatDistanceToNow),
  "formatDistanceToNowStrict": () => (/* reexport */ formatDistanceToNowStrict),
  "formatDuration": () => (/* reexport */ formatDuration),
  "formatISO": () => (/* reexport */ formatISO),
  "formatISO9075": () => (/* reexport */ formatISO9075),
  "formatISODuration": () => (/* reexport */ formatISODuration),
  "formatRFC3339": () => (/* reexport */ formatRFC3339),
  "formatRFC7231": () => (/* reexport */ formatRFC7231),
  "formatRelative": () => (/* reexport */ formatRelative),
  "fromUnixTime": () => (/* reexport */ fromUnixTime),
  "getDate": () => (/* reexport */ getDate),
  "getDay": () => (/* reexport */ getDay),
  "getDayOfYear": () => (/* reexport */ getDayOfYear),
  "getDaysInMonth": () => (/* reexport */ getDaysInMonth/* default */.Z),
  "getDaysInYear": () => (/* reexport */ getDaysInYear),
  "getDecade": () => (/* reexport */ getDecade),
  "getDefaultOptions": () => (/* reexport */ getDefaultOptions),
  "getHours": () => (/* reexport */ getHours),
  "getISODay": () => (/* reexport */ getISODay/* default */.Z),
  "getISOWeek": () => (/* reexport */ getISOWeek/* default */.Z),
  "getISOWeekYear": () => (/* reexport */ getISOWeekYear/* default */.Z),
  "getISOWeeksInYear": () => (/* reexport */ getISOWeeksInYear),
  "getMilliseconds": () => (/* reexport */ getMilliseconds),
  "getMinutes": () => (/* reexport */ getMinutes),
  "getMonth": () => (/* reexport */ getMonth),
  "getOverlappingDaysInIntervals": () => (/* reexport */ getOverlappingDaysInIntervals),
  "getQuarter": () => (/* reexport */ getQuarter),
  "getSeconds": () => (/* reexport */ getSeconds),
  "getTime": () => (/* reexport */ getTime),
  "getUnixTime": () => (/* reexport */ getUnixTime),
  "getWeek": () => (/* reexport */ getWeek),
  "getWeekOfMonth": () => (/* reexport */ getWeekOfMonth),
  "getWeekYear": () => (/* reexport */ getWeekYear),
  "getWeeksInMonth": () => (/* reexport */ getWeeksInMonth),
  "getYear": () => (/* reexport */ getYear/* default */.Z),
  "hoursToMilliseconds": () => (/* reexport */ hoursToMilliseconds),
  "hoursToMinutes": () => (/* reexport */ hoursToMinutes),
  "hoursToSeconds": () => (/* reexport */ hoursToSeconds),
  "intervalToDuration": () => (/* reexport */ intervalToDuration),
  "intlFormat": () => (/* reexport */ intlFormat),
  "intlFormatDistance": () => (/* reexport */ intlFormatDistance),
  "isAfter": () => (/* reexport */ isAfter/* default */.Z),
  "isBefore": () => (/* reexport */ isBefore/* default */.Z),
  "isDate": () => (/* reexport */ isDate/* default */.Z),
  "isEqual": () => (/* reexport */ isEqual/* default */.Z),
  "isExists": () => (/* reexport */ isExists),
  "isFirstDayOfMonth": () => (/* reexport */ isFirstDayOfMonth),
  "isFriday": () => (/* reexport */ isFriday),
  "isFuture": () => (/* reexport */ isFuture),
  "isLastDayOfMonth": () => (/* reexport */ isLastDayOfMonth),
  "isLeapYear": () => (/* reexport */ isLeapYear/* default */.Z),
  "isMatch": () => (/* reexport */ isMatch),
  "isMonday": () => (/* reexport */ isMonday),
  "isPast": () => (/* reexport */ isPast),
  "isSameDay": () => (/* reexport */ isSameDay/* default */.Z),
  "isSameHour": () => (/* reexport */ isSameHour),
  "isSameISOWeek": () => (/* reexport */ isSameISOWeek),
  "isSameISOWeekYear": () => (/* reexport */ isSameISOWeekYear),
  "isSameMinute": () => (/* reexport */ isSameMinute/* default */.Z),
  "isSameMonth": () => (/* reexport */ isSameMonth/* default */.Z),
  "isSameQuarter": () => (/* reexport */ isSameQuarter),
  "isSameSecond": () => (/* reexport */ isSameSecond),
  "isSameWeek": () => (/* reexport */ isSameWeek/* default */.Z),
  "isSameYear": () => (/* reexport */ isSameYear/* default */.Z),
  "isSaturday": () => (/* reexport */ isSaturday),
  "isSunday": () => (/* reexport */ isSunday),
  "isThisHour": () => (/* reexport */ isThisHour),
  "isThisISOWeek": () => (/* reexport */ isThisISOWeek),
  "isThisMinute": () => (/* reexport */ isThisMinute),
  "isThisMonth": () => (/* reexport */ isThisMonth),
  "isThisQuarter": () => (/* reexport */ isThisQuarter),
  "isThisSecond": () => (/* reexport */ isThisSecond),
  "isThisWeek": () => (/* reexport */ isThisWeek),
  "isThisYear": () => (/* reexport */ isThisYear),
  "isThursday": () => (/* reexport */ isThursday),
  "isToday": () => (/* reexport */ isToday),
  "isTomorrow": () => (/* reexport */ isTomorrow),
  "isTuesday": () => (/* reexport */ isTuesday),
  "isValid": () => (/* reexport */ isValid/* default */.Z),
  "isWednesday": () => (/* reexport */ isWednesday),
  "isWeekend": () => (/* reexport */ isWeekend),
  "isWithinInterval": () => (/* reexport */ isWithinInterval),
  "isYesterday": () => (/* reexport */ isYesterday),
  "lastDayOfDecade": () => (/* reexport */ lastDayOfDecade),
  "lastDayOfISOWeek": () => (/* reexport */ lastDayOfISOWeek),
  "lastDayOfISOWeekYear": () => (/* reexport */ lastDayOfISOWeekYear),
  "lastDayOfMonth": () => (/* reexport */ lastDayOfMonth),
  "lastDayOfQuarter": () => (/* reexport */ lastDayOfQuarter),
  "lastDayOfWeek": () => (/* reexport */ lastDayOfWeek),
  "lastDayOfYear": () => (/* reexport */ lastDayOfYear),
  "lightFormat": () => (/* reexport */ lightFormat),
  "max": () => (/* reexport */ max),
  "maxTime": () => (/* reexport */ constants/* maxTime */.LI),
  "milliseconds": () => (/* reexport */ milliseconds),
  "millisecondsInHour": () => (/* reexport */ constants/* millisecondsInHour */.vh),
  "millisecondsInMinute": () => (/* reexport */ constants/* millisecondsInMinute */.yJ),
  "millisecondsInSecond": () => (/* reexport */ constants/* millisecondsInSecond */.qk),
  "millisecondsToHours": () => (/* reexport */ millisecondsToHours),
  "millisecondsToMinutes": () => (/* reexport */ millisecondsToMinutes),
  "millisecondsToSeconds": () => (/* reexport */ millisecondsToSeconds),
  "min": () => (/* reexport */ min),
  "minTime": () => (/* reexport */ constants/* minTime */.QI),
  "minutesInHour": () => (/* reexport */ constants/* minutesInHour */.fR),
  "minutesToHours": () => (/* reexport */ minutesToHours),
  "minutesToMilliseconds": () => (/* reexport */ minutesToMilliseconds),
  "minutesToSeconds": () => (/* reexport */ minutesToSeconds),
  "monthsInQuarter": () => (/* reexport */ constants/* monthsInQuarter */.Ob),
  "monthsInYear": () => (/* reexport */ constants/* monthsInYear */.CU),
  "monthsToQuarters": () => (/* reexport */ monthsToQuarters),
  "monthsToYears": () => (/* reexport */ monthsToYears),
  "nextDay": () => (/* reexport */ nextDay),
  "nextFriday": () => (/* reexport */ nextFriday),
  "nextMonday": () => (/* reexport */ nextMonday),
  "nextSaturday": () => (/* reexport */ nextSaturday),
  "nextSunday": () => (/* reexport */ nextSunday),
  "nextThursday": () => (/* reexport */ nextThursday),
  "nextTuesday": () => (/* reexport */ nextTuesday),
  "nextWednesday": () => (/* reexport */ nextWednesday),
  "parse": () => (/* reexport */ parse),
  "parseISO": () => (/* reexport */ parseISO/* default */.Z),
  "parseJSON": () => (/* reexport */ parseJSON),
  "previousDay": () => (/* reexport */ previousDay),
  "previousFriday": () => (/* reexport */ previousFriday),
  "previousMonday": () => (/* reexport */ previousMonday),
  "previousSaturday": () => (/* reexport */ previousSaturday),
  "previousSunday": () => (/* reexport */ previousSunday),
  "previousThursday": () => (/* reexport */ previousThursday),
  "previousTuesday": () => (/* reexport */ previousTuesday),
  "previousWednesday": () => (/* reexport */ previousWednesday),
  "quartersInYear": () => (/* reexport */ constants/* quartersInYear */._j),
  "quartersToMonths": () => (/* reexport */ quartersToMonths),
  "quartersToYears": () => (/* reexport */ quartersToYears),
  "roundToNearestMinutes": () => (/* reexport */ roundToNearestMinutes),
  "secondsInDay": () => (/* reexport */ constants/* secondsInDay */.gM),
  "secondsInHour": () => (/* reexport */ constants/* secondsInHour */.R3),
  "secondsInMinute": () => (/* reexport */ constants/* secondsInMinute */.xx),
  "secondsInMonth": () => (/* reexport */ constants/* secondsInMonth */.nZ),
  "secondsInQuarter": () => (/* reexport */ constants/* secondsInQuarter */.Y2),
  "secondsInWeek": () => (/* reexport */ constants/* secondsInWeek */.vr),
  "secondsInYear": () => (/* reexport */ constants/* secondsInYear */.rz),
  "secondsToHours": () => (/* reexport */ secondsToHours),
  "secondsToMilliseconds": () => (/* reexport */ secondsToMilliseconds),
  "secondsToMinutes": () => (/* reexport */ secondsToMinutes),
  "set": () => (/* reexport */ set/* default */.Z),
  "setDate": () => (/* reexport */ setDate),
  "setDay": () => (/* reexport */ setDay),
  "setDayOfYear": () => (/* reexport */ setDayOfYear),
  "setDefaultOptions": () => (/* reexport */ setDefaultOptions),
  "setHours": () => (/* reexport */ setHours),
  "setISODay": () => (/* reexport */ setISODay/* default */.Z),
  "setISOWeek": () => (/* reexport */ setISOWeek/* default */.Z),
  "setISOWeekYear": () => (/* reexport */ setISOWeekYear),
  "setMilliseconds": () => (/* reexport */ setMilliseconds),
  "setMinutes": () => (/* reexport */ setMinutes),
  "setMonth": () => (/* reexport */ setMonth/* default */.Z),
  "setQuarter": () => (/* reexport */ setQuarter),
  "setSeconds": () => (/* reexport */ setSeconds),
  "setWeek": () => (/* reexport */ setWeek),
  "setWeekYear": () => (/* reexport */ setWeekYear),
  "setYear": () => (/* reexport */ setYear),
  "startOfDay": () => (/* reexport */ startOfDay/* default */.Z),
  "startOfDecade": () => (/* reexport */ startOfDecade),
  "startOfHour": () => (/* reexport */ startOfHour),
  "startOfISOWeek": () => (/* reexport */ startOfISOWeek/* default */.Z),
  "startOfISOWeekYear": () => (/* reexport */ startOfISOWeekYear/* default */.Z),
  "startOfMinute": () => (/* reexport */ startOfMinute/* default */.Z),
  "startOfMonth": () => (/* reexport */ startOfMonth/* default */.Z),
  "startOfQuarter": () => (/* reexport */ startOfQuarter),
  "startOfSecond": () => (/* reexport */ startOfSecond),
  "startOfToday": () => (/* reexport */ startOfToday),
  "startOfTomorrow": () => (/* reexport */ startOfTomorrow),
  "startOfWeek": () => (/* reexport */ startOfWeek/* default */.Z),
  "startOfWeekYear": () => (/* reexport */ startOfWeekYear),
  "startOfYear": () => (/* reexport */ startOfYear/* default */.Z),
  "startOfYesterday": () => (/* reexport */ startOfYesterday),
  "sub": () => (/* reexport */ sub/* default */.Z),
  "subBusinessDays": () => (/* reexport */ subBusinessDays),
  "subDays": () => (/* reexport */ subDays/* default */.Z),
  "subHours": () => (/* reexport */ subHours),
  "subISOWeekYears": () => (/* reexport */ subISOWeekYears),
  "subMilliseconds": () => (/* reexport */ subMilliseconds/* default */.Z),
  "subMinutes": () => (/* reexport */ subMinutes),
  "subMonths": () => (/* reexport */ subMonths/* default */.Z),
  "subQuarters": () => (/* reexport */ subQuarters),
  "subSeconds": () => (/* reexport */ subSeconds),
  "subWeeks": () => (/* reexport */ subWeeks),
  "subYears": () => (/* reexport */ subYears),
  "toDate": () => (/* reexport */ toDate/* default */.Z),
  "weeksToDays": () => (/* reexport */ weeksToDays),
  "yearsToMonths": () => (/* reexport */ yearsToMonths),
  "yearsToQuarters": () => (/* reexport */ yearsToQuarters)
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(9422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(9013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(3882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isWeekend/index.js


/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */

function isWeekend(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(3946);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSunday/index.js


/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */

function isSunday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDay() === 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSaturday/index.js


/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */

function isSaturday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDay() === 6;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addBusinessDays/index.js






/**
 * @name addBusinessDays
 * @category Day Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the business days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */

function addBusinessDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var startedOnWeekend = isWeekend(date);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) return new Date(NaN);
  var hours = date.getHours();
  var sign = amount < 0 ? -1 : 1;
  var fullWeeks = (0,toInteger/* default */.Z)(amount / 5);
  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week

  var restDays = Math.abs(amount % 5); // Loops over remaining days

  while (restDays > 0) {
    date.setDate(date.getDate() + sign);
    if (!isWeekend(date)) restDays -= 1;
  } // If the date is a weekend day and we reduce a dividable of
  // 5 from it, we land on a weekend date.
  // To counter this, we add days accordingly to land on the next business day


  if (startedOnWeekend && isWeekend(date) && amount !== 0) {
    // If we're reducing days, we want to add days until we land on a weekday
    // If we're adding days we want to reduce days until we land on a weekday
    if (isSaturday(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
    if (isSunday(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
  } // Restore hours to avoid DST lag


  date.setHours(hours);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(7349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js
var addMilliseconds = __webpack_require__(1820);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addHours/index.js



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addMilliseconds/* default */.Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getISOWeekYear/index.js
var getISOWeekYear = __webpack_require__(5425);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfISOWeekYear/index.js
var startOfISOWeekYear = __webpack_require__(546);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(2300);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setISOWeekYear/index.js





/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */

function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var isoWeekYear = (0,toInteger/* default */.Z)(dirtyISOWeekYear);
  var diff = (0,differenceInCalendarDays/* default */.Z)(date, (0,startOfISOWeekYear/* default */.Z)(date));
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  date = (0,startOfISOWeekYear/* default */.Z)(fourthOfJanuary);
  date.setDate(date.getDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addISOWeekYears/index.js




/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the ISO week-numbering years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */

function addISOWeekYears(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return setISOWeekYear(dirtyDate, (0,getISOWeekYear/* default */.Z)(dirtyDate) + amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMinutes/index.js



var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addMilliseconds/* default */.Z)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(1640);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addQuarters/index.js



/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */

function addQuarters(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  var months = amount * 3;
  return (0,addMonths/* default */.Z)(dirtyDate, months);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addSeconds/index.js



/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addMilliseconds/* default */.Z)(dirtyDate, amount * 1000);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addWeeks/index.js



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  var days = amount * 7;
  return (0,addDays/* default */.Z)(dirtyDate, days);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(1593);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/areIntervalsOverlapping/index.js


/**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
 * @returns {Boolean} whether the time intervals are overlapping
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */

function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var leftStartTime = (0,toDate/* default */.Z)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.start).getTime();
  var leftEndTime = (0,toDate/* default */.Z)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.end).getTime();
  var rightStartTime = (0,toDate/* default */.Z)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.start).getTime();
  var rightEndTime = (0,toDate/* default */.Z)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval');
  }

  if (options !== null && options !== void 0 && options.inclusive) {
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  }

  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/max/index.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/min/index.js
function min_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { min_typeof = function _typeof(obj) { return typeof obj; }; } else { min_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return min_typeof(obj); }



/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (min_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/clamp/index.js



/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 *
 * @param {Date | Number} date - the date to be bounded
 * @param {Interval} interval - the interval to bound to
 * @returns {Date} the date bounded by the start and the end of the interval
 * @throws {TypeError} 2 arguments required
 */

function clamp(date, _ref) {
  var start = _ref.start,
      end = _ref.end;
  (0,requiredArgs/* default */.Z)(2, arguments);
  return min([max([date, start]), end]);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/closestIndexTo/index.js


/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date | Number} dateToCompare - the date to compare with
 * @param {Array<Date> | Array<number>} datesArray - the array to search
 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */

function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return NaN;
  var timeToCompare = dateToCompare.getTime();
  var datesArray; // `dirtyDatesArray` is undefined or null

  if (dirtyDatesArray == null) {
    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }

  var result;
  var minDistance;
  datesArray.forEach(function (dirtyDate, index) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }

    var distance = Math.abs(timeToCompare - currentDate.getTime());

    if (result == null || distance < Number(minDistance)) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/closestTo/index.js


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date | Number} dateToCompare - the date to compare with
 * @param {Array<Date> | Array<number>} datesArray - the array to search
 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */

function closestTo(dirtyDateToCompare, dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return new Date(NaN);
  var timeToCompare = dateToCompare.getTime();
  var datesArray; // `dirtyDatesArray` is undefined or null

  if (dirtyDatesArray == null) {
    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }

  var result;
  var minDistance;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = new Date(NaN);
      minDistance = NaN;
      return;
    }

    var distance = Math.abs(timeToCompare - currentDate.getTime());

    if (result == null || distance < Number(minDistance)) {
      result = currentDate;
      minDistance = distance;
    }
  });
  return result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/compareAsc/index.js


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/compareDesc/index.js


/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */

function compareDesc(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(6948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/daysToWeeks/index.js


/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @param {number} days - number of days to be converted
 *
 * @returns {number} the number of days converted in weeks
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */

function daysToWeeks(days) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weeks = days / constants/* daysInWeek */.ju;
  return Math.floor(weeks);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(2274);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInBusinessDays/index.js








/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of business days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */

function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  if (!(0,isValid/* default */.Z)(dateLeft) || !(0,isValid/* default */.Z)(dateRight)) return NaN;
  var calendarDifference = (0,differenceInCalendarDays/* default */.Z)(dateLeft, dateRight);
  var sign = calendarDifference < 0 ? -1 : 1;
  var weeks = (0,toInteger/* default */.Z)(calendarDifference / 7);
  var result = weeks * 5;
  dateRight = (0,addDays/* default */.Z)(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week

  while (!(0,isSameDay/* default */.Z)(dateLeft, dateRight)) {
    // sign is used to account for both negative and positive differences
    result += isWeekend(dateRight) ? 0 : sign;
    dateRight = (0,addDays/* default */.Z)(dateRight, sign);
  }

  return result === 0 ? 0 : result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js


/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */

function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  return (0,getISOWeekYear/* default */.Z)(dirtyDateLeft) - (0,getISOWeekYear/* default */.Z)(dirtyDateRight);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(4262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js
var startOfISOWeek = __webpack_require__(6573);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js



var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */

function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfISOWeekLeft = (0,startOfISOWeek/* default */.Z)(dirtyDateLeft);
  var startOfISOWeekRight = (0,startOfISOWeek/* default */.Z)(dirtyDateRight);
  var timestampLeft = startOfISOWeekLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfISOWeekLeft);
  var timestampRight = startOfISOWeekRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfISOWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getQuarter/index.js


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarQuarters/index.js



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */

function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight);
  return yearDiff * 4 + quarterDiff;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(584);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfWeekLeft = (0,startOfWeek/* default */.Z)(dirtyDateLeft, options);
  var startOfWeekRight = (0,startOfWeek/* default */.Z)(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarYears/index.js


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs((0,differenceInCalendarDays/* default */.Z)(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__(9910);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMethods = __webpack_require__(3645);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js




/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInMilliseconds/* default */.Z)(dateLeft, dateRight) / constants/* millisecondsInHour */.vh;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subISOWeekYears/index.js



/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */

function subISOWeekYears(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addISOWeekYears(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInISOWeekYears/index.js





/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */

function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarISOWeekYears(dateLeft, dateRight));
  dateLeft = subISOWeekYears(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastISOWeekYearNotFull = Number(compareAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMinutes/index.js




/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInMilliseconds/* default */.Z)(dateLeft, dateRight) / constants/* millisecondsInMinute */.yJ;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfDay/index.js


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isLastDayOfMonth/index.js




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js





/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth((0,toDate/* default */.Z)(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInQuarters/index.js



/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */

function differenceInQuarters(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(1699);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInWeeks/index.js



/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInYears/index.js




/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days

  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

  return result === 0 ? 0 : result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachDayOfInterval/index.js


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  var _options$step;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push((0,toDate/* default */.Z)(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachHourOfInterval/index.js




/**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */
function eachHourOfInterval(dirtyInterval, options) {
  var _options$step;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setMinutes(0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push((0,toDate/* default */.Z)(currentDate));
    currentDate = addHours(currentDate, step);
  }

  return dates;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMinute/index.js
var startOfMinute = __webpack_require__(8717);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachMinuteOfInterval/index.js





/**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The step must be equal to or greater than 1
 * @throws {TypeError} 1 argument required
 * @returns {Date[]} the array with starts of minutes from the minute of the interval start to the minute of the interval end
 * @throws {RangeError} `options.step` must be a number equal to or greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */
function eachMinuteOfInterval(interval, options) {
  var _options$step;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var startDate = (0,startOfMinute/* default */.Z)((0,toDate/* default */.Z)(interval.start));
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();

  if (startTime >= endTime) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal to or greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push((0,toDate/* default */.Z)(currentDate));
    currentDate = addMinutes(currentDate, step);
  }

  return dates;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachMonthOfInterval/index.js


/**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */

function eachMonthOfInterval(dirtyInterval) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var endTime = endDate.getTime();
  var dates = []; // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setDate(1);

  while (currentDate.getTime() <= endTime) {
    dates.push((0,toDate/* default */.Z)(currentDate));
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return dates;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfQuarter/index.js


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachQuarterOfInterval/index.js




/**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */

function eachQuarterOfInterval(dirtyInterval) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var startDateQuarter = startOfQuarter(startDate);
  var endDateQuarter = startOfQuarter(endDate);
  endTime = endDateQuarter.getTime();
  var quarters = [];
  var currentQuarter = startDateQuarter;

  while (currentQuarter.getTime() <= endTime) {
    quarters.push((0,toDate/* default */.Z)(currentQuarter));
    currentQuarter = addQuarters(currentQuarter, 1);
  }

  return quarters;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachWeekOfInterval/index.js




/**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */

function eachWeekOfInterval(dirtyInterval, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var startDateWeek = (0,startOfWeek/* default */.Z)(startDate, options);
  var endDateWeek = (0,startOfWeek/* default */.Z)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet

  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  endTime = endDateWeek.getTime();
  var weeks = [];
  var currentWeek = startDateWeek;

  while (currentWeek.getTime() <= endTime) {
    currentWeek.setHours(0);
    weeks.push((0,toDate/* default */.Z)(currentWeek));
    currentWeek = addWeeks(currentWeek, 1);
    currentWeek.setHours(15);
  }

  return weeks;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachWeekendOfInterval/index.js




/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */

function eachWeekendOfInterval(interval) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var dateInterval = eachDayOfInterval(interval);
  var weekends = [];
  var index = 0;

  while (index < dateInterval.length) {
    var date = dateInterval[index++];

    if (isWeekend(date)) {
      weekends.push(date);
      if (isSunday(date)) index = index + 5;
    }
  }

  return weekends;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(3703);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachWeekendOfMonth/index.js




/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @param {Date|Number} date - the given month
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The passed date is invalid
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */

function eachWeekendOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var startDate = (0,startOfMonth/* default */.Z)(dirtyDate);
  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
  var endDate = endOfMonth(dirtyDate);
  return eachWeekendOfInterval({
    start: startDate,
    end: endDate
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfYear/index.js


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfYear/index.js
var startOfYear = __webpack_require__(8148);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachWeekendOfYear/index.js




/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @param {Date|Number} date - the given year
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The passed date is invalid
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */

function eachWeekendOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var startDate = (0,startOfYear/* default */.Z)(dirtyDate);
  var endDate = endOfYear(dirtyDate);
  return eachWeekendOfInterval({
    start: startDate,
    end: endDate
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachYearOfInterval/index.js


/**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */

function eachYearOfInterval(dirtyInterval) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setMonth(0, 1);

  while (currentDate.getTime() <= endTime) {
    dates.push((0,toDate/* default */.Z)(currentDate));
    currentDate.setFullYear(currentDate.getFullYear() + 1);
  }

  return dates;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfDecade/index.js


/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a decade
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */

function endOfDecade(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade, 11, 31);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfHour/index.js


/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */

function endOfHour(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(4314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfWeek/index.js





/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfISOWeek/index.js


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfISOWeekYear/index.js



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */

function endOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var date = (0,startOfISOWeek/* default */.Z)(fourthOfJanuaryOfNextYear);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfMinute/index.js


/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */

function endOfMinute(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setSeconds(59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfQuarter/index.js


/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfQuarter(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfSecond/index.js


/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */

function endOfSecond(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setMilliseconds(999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfToday/index.js

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */

function endOfToday() {
  return endOfDay(Date.now());
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfTomorrow/index.js
/**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfYesterday/index.js
/**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 2 modules
var format = __webpack_require__(5639);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(8958);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/cloneObject/index.js

function cloneObject(object) {
  return assign_assign({}, object);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistance/index.js










var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = assign_assign(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = (0,toDate/* default */.Z)(dirtyBaseDate);
    dateRight = (0,toDate/* default */.Z)(dirtyDate);
  } else {
    dateLeft = (0,toDate/* default */.Z)(dirtyDate);
    dateRight = (0,toDate/* default */.Z)(dirtyBaseDate);
  }

  var seconds = (0,differenceInSeconds/* default */.Z)(dateRight, dateLeft);
  var offsetInSeconds = ((0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateRight) - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months; // 0 up to 2 mins

  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    } // 2 mins up to 0.75 hrs

  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }

  months = differenceInMonths(dateRight, dateLeft); // 2 months up to 12 months

  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12); // N years up to 1 years 3 months

    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistanceStrict/index.js








var formatDistanceStrict_MILLISECONDS_IN_MINUTE = 1000 * 60;
var formatDistanceStrict_MINUTES_IN_DAY = 60 * 24;
var formatDistanceStrict_MINUTES_IN_MONTH = formatDistanceStrict_MINUTES_IN_DAY * 30;
var MINUTES_IN_YEAR = formatDistanceStrict_MINUTES_IN_DAY * 365;
/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _options$roundingMeth;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain localize.formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = assign_assign(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = (0,toDate/* default */.Z)(dirtyBaseDate);
    dateRight = (0,toDate/* default */.Z)(dirtyDate);
  } else {
    dateLeft = (0,toDate/* default */.Z)(dirtyDate);
    dateRight = (0,toDate/* default */.Z)(dirtyBaseDate);
  }

  var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
  var roundingMethodFn;

  if (roundingMethod === 'floor') {
    roundingMethodFn = Math.floor;
  } else if (roundingMethod === 'ceil') {
    roundingMethodFn = Math.ceil;
  } else if (roundingMethod === 'round') {
    roundingMethodFn = Math.round;
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  }

  var milliseconds = dateRight.getTime() - dateLeft.getTime();
  var minutes = milliseconds / formatDistanceStrict_MILLISECONDS_IN_MINUTE;
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateRight) - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.

  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / formatDistanceStrict_MILLISECONDS_IN_MINUTE;
  var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
  var unit;

  if (!defaultUnit) {
    if (minutes < 1) {
      unit = 'second';
    } else if (minutes < 60) {
      unit = 'minute';
    } else if (minutes < formatDistanceStrict_MINUTES_IN_DAY) {
      unit = 'hour';
    } else if (dstNormalizedMinutes < formatDistanceStrict_MINUTES_IN_MONTH) {
      unit = 'day';
    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
      unit = 'month';
    } else {
      unit = 'year';
    }
  } else {
    unit = String(defaultUnit);
  } // 0 up to 60 seconds


  if (unit === 'second') {
    var seconds = roundingMethodFn(milliseconds / 1000);
    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
  } else if (unit === 'minute') {
    var roundedMinutes = roundingMethodFn(minutes);
    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions); // 1 up to 24 hours
  } else if (unit === 'hour') {
    var hours = roundingMethodFn(minutes / 60);
    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
  } else if (unit === 'day') {
    var days = roundingMethodFn(dstNormalizedMinutes / formatDistanceStrict_MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
  } else if (unit === 'month') {
    var months = roundingMethodFn(dstNormalizedMinutes / formatDistanceStrict_MINUTES_IN_MONTH);
    return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
  } else if (unit === 'year') {
    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
    return locale.formatDistance('xYears', years, localizeOptions);
  }

  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistanceToNow/index.js



/**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function formatDistanceToNow(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return formatDistance(dirtyDate, Date.now(), options);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js


/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */

function formatDistanceToNowStrict(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return formatDistanceStrict(dirtyDate, Date.now(), options);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDuration/index.js


var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @param {Duration} duration - the duration to format
 * @param {Object} [options] - an object with options.
 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
 * @param {boolean} [options.zero=false] - should zeros be included in the output?
 * @param {string} [options.delimiter=' '] - delimiter string
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {string} the formatted date string
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */

function formatDuration(duration, options) {
  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;

  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';

  if (!locale.formatDistance) {
    return '';
  }

  var result = format.reduce(function (acc, unit) {
    var token = "x".concat(unit.replace(/(^.)/, function (m) {
      return m.toUpperCase();
    }));
    var value = duration[unit];

    if (typeof value === 'number' && (zero || duration[unit])) {
      return acc.concat(locale.formatDistance(token, value));
    }

    return acc;
  }, []).join(delimiter);
  return result;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__(4810);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatISO/index.js



/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(date, options) {
  var _options$format, _options$representati;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var originalDate = (0,toDate/* default */.Z)(date);

  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }

  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = (0,addLeadingZeros/* default */.Z)(originalDate.getDate(), 2);
    var month = (0,addLeadingZeros/* default */.Z)(originalDate.getMonth() + 1, 2);
    var year = (0,addLeadingZeros/* default */.Z)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = (0,addLeadingZeros/* default */.Z)(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = (0,addLeadingZeros/* default */.Z)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = (0,addLeadingZeros/* default */.Z)(originalDate.getHours(), 2);
    var minute = (0,addLeadingZeros/* default */.Z)(originalDate.getMinutes(), 2);
    var second = (0,addLeadingZeros/* default */.Z)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatISO9075/index.js




/**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */
function formatISO9075(dirtyDate, options) {
  var _options$format, _options$representati;

  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = (0,addLeadingZeros/* default */.Z)(originalDate.getDate(), 2);
    var month = (0,addLeadingZeros/* default */.Z)(originalDate.getMonth() + 1, 2);
    var year = (0,addLeadingZeros/* default */.Z)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    var hour = (0,addLeadingZeros/* default */.Z)(originalDate.getHours(), 2);
    var minute = (0,addLeadingZeros/* default */.Z)(originalDate.getMinutes(), 2);
    var second = (0,addLeadingZeros/* default */.Z)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space

    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatISODuration/index.js
function formatISODuration_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { formatISODuration_typeof = function _typeof(obj) { return typeof obj; }; } else { formatISODuration_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return formatISODuration_typeof(obj); }


/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param {Duration} duration - the duration to format
 *
 * @returns {String} The ISO 8601 duration string
 * @throws {TypeError} Requires 1 argument
 * @throws {Error} Argument must be an object
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */

function formatISODuration(duration) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (formatISODuration_typeof(duration) !== 'object') throw new Error('Duration must be an object');
  var _duration$years = duration.years,
      years = _duration$years === void 0 ? 0 : _duration$years,
      _duration$months = duration.months,
      months = _duration$months === void 0 ? 0 : _duration$months,
      _duration$days = duration.days,
      days = _duration$days === void 0 ? 0 : _duration$days,
      _duration$hours = duration.hours,
      hours = _duration$hours === void 0 ? 0 : _duration$hours,
      _duration$minutes = duration.minutes,
      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
      _duration$seconds = duration.seconds,
      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatRFC3339/index.js





/**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
 * //=> '2019-09-18T19:00:52.23Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
 * //=> '2019-09-18T19:00:52.234Z'
 */
function formatRFC3339(dirtyDate, options) {
  var _options$fractionDigi;

  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var fractionDigits = Number((_options$fractionDigi = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options$fractionDigi !== void 0 ? _options$fractionDigi : 0); // Test if fractionDigits is between 0 and 3 _and_ is not NaN

  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
  }

  var day = (0,addLeadingZeros/* default */.Z)(originalDate.getDate(), 2);
  var month = (0,addLeadingZeros/* default */.Z)(originalDate.getMonth() + 1, 2);
  var year = originalDate.getFullYear();
  var hour = (0,addLeadingZeros/* default */.Z)(originalDate.getHours(), 2);
  var minute = (0,addLeadingZeros/* default */.Z)(originalDate.getMinutes(), 2);
  var second = (0,addLeadingZeros/* default */.Z)(originalDate.getSeconds(), 2);
  var fractionalSecond = '';

  if (fractionDigits > 0) {
    var milliseconds = originalDate.getMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
    fractionalSecond = '.' + (0,addLeadingZeros/* default */.Z)(fractionalSeconds, fractionDigits);
  }

  var offset = '';
  var tzOffset = originalDate.getTimezoneOffset();

  if (tzOffset !== 0) {
    var absoluteOffset = Math.abs(tzOffset);
    var hourOffset = (0,addLeadingZeros/* default */.Z)((0,toInteger/* default */.Z)(absoluteOffset / 60), 2);
    var minuteOffset = (0,addLeadingZeros/* default */.Z)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

    var sign = tzOffset < 0 ? '+' : '-';
    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
  } else {
    offset = 'Z';
  }

  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatRFC7231/index.js



var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */

function formatRFC7231(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var dayName = days[originalDate.getUTCDay()];
  var dayOfMonth = (0,addLeadingZeros/* default */.Z)(originalDate.getUTCDate(), 2);
  var monthName = months[originalDate.getUTCMonth()];
  var year = originalDate.getUTCFullYear();
  var hour = (0,addLeadingZeros/* default */.Z)(originalDate.getUTCHours(), 2);
  var minute = (0,addLeadingZeros/* default */.Z)(originalDate.getUTCMinutes(), 2);
  var second = (0,addLeadingZeros/* default */.Z)(originalDate.getUTCSeconds(), 2); // Result variables.

  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(1218);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatRelative/index.js









/**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @param {Date|Number} date - the date to format
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {String} the date in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(addDays(new Date(), -6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */

function formatRelative(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var baseDate = (0,toDate/* default */.Z)(dirtyBaseDate);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  if (!locale.formatRelative) {
    throw new RangeError('locale must contain formatRelative property');
  }

  var diff = (0,differenceInCalendarDays/* default */.Z)(date, baseDate);

  if (isNaN(diff)) {
    throw new RangeError('Invalid time value');
  }

  var token;

  if (diff < -6) {
    token = 'other';
  } else if (diff < -1) {
    token = 'lastWeek';
  } else if (diff < 0) {
    token = 'yesterday';
  } else if (diff < 1) {
    token = 'today';
  } else if (diff < 2) {
    token = 'tomorrow';
  } else if (diff < 7) {
    token = 'nextWeek';
  } else {
    token = 'other';
  }

  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var utcBaseDate = (0,subMilliseconds/* default */.Z)(baseDate, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(baseDate));
  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
    locale: locale,
    weekStartsOn: weekStartsOn
  });
  return (0,format/* default */.Z)(date, formatStr, {
    locale: locale,
    weekStartsOn: weekStartsOn
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/fromUnixTime/index.js



/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param {Number} unixTime - the given Unix timestamp (in seconds)
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */

function fromUnixTime(dirtyUnixTime) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var unixTime = (0,toInteger/* default */.Z)(dirtyUnixTime);
  return (0,toDate/* default */.Z)(unixTime * 1000);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDate/index.js


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDay/index.js


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  return day;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDayOfYear/index.js




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */

function getDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,differenceInCalendarDays/* default */.Z)(date, (0,startOfYear/* default */.Z)(date));
  var dayOfYear = diff + 1;
  return dayOfYear;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js
var getDaysInMonth = __webpack_require__(890);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isLeapYear/index.js
var isLeapYear = __webpack_require__(6491);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInYear/index.js



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */

function getDaysInYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);

  if (String(new Date(date)) === 'Invalid Date') {
    return NaN;
  }

  return (0,isLeapYear/* default */.Z)(date) ? 366 : 365;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDecade/index.js


/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year of decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */

function getDecade(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  return decade;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDefaultOptions/index.js


/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions]{@link https://date-fns.org/docs/setDefaultOptions}.
 *
 * @returns {Object} default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */

function getDefaultOptions() {
  return assign_assign({}, (0,_lib_defaultOptions/* getDefaultOptions */.j)());
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getHours/index.js


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var hours = date.getHours();
  return hours;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getISODay/index.js
var getISODay = __webpack_require__(4500);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getISOWeek/index.js
var getISOWeek = __webpack_require__(911);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeeksInYear/index.js



var getISOWeeksInYear_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */

function getISOWeeksInYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var thisYear = (0,startOfISOWeekYear/* default */.Z)(dirtyDate);
  var nextYear = (0,startOfISOWeekYear/* default */.Z)(addWeeks(thisYear, 60));
  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getISOWeeksInYear_MILLISECONDS_IN_WEEK);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMilliseconds/index.js


/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */

function getMilliseconds(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var milliseconds = date.getMilliseconds();
  return milliseconds;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMinutes/index.js


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMonth/index.js


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  return month;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js


var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
 * @returns {Number} the number of days that overlap in two time intervals
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */

function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var intervalLeft = dirtyIntervalLeft || {};
  var intervalRight = dirtyIntervalRight || {};
  var leftStartTime = (0,toDate/* default */.Z)(intervalLeft.start).getTime();
  var leftEndTime = (0,toDate/* default */.Z)(intervalLeft.end).getTime();
  var rightStartTime = (0,toDate/* default */.Z)(intervalRight.start).getTime();
  var rightEndTime = (0,toDate/* default */.Z)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval');
  }

  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;

  if (!isOverlapping) {
    return 0;
  }

  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
  var differenceInMs = overlapEndDate - overlapStartDate;
  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getSeconds/index.js


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getTime/index.js


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */

function getUnixTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(getTime(dirtyDate) / 1000);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */

function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = (0,startOfWeek/* default */.Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = (0,startOfWeek/* default */.Z)(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfWeekYear/index.js





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = (0,startOfWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfWeek/* default */.Z)(date, options).getTime() - startOfWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeekOfMonth/index.js






/**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the week of month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6 inclusively
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */

function getWeekOfMonth(date, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var currentDayOfMonth = getDate(date);
  if (isNaN(currentDayOfMonth)) return NaN;
  var startWeekDay = getDay((0,startOfMonth/* default */.Z)(date));
  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */

function lastDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeeksInMonth/index.js





/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date), (0,startOfMonth/* default */.Z)(date), options) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(5570);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/hoursToMilliseconds/index.js


/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted to milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */

function hoursToMilliseconds(hours) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(hours * constants/* millisecondsInHour */.vh);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/hoursToMinutes/index.js


/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */

function hoursToMinutes(hours) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(hours * constants/* minutesInHour */.fR);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/hoursToSeconds/index.js


/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */

function hoursToSeconds(hours) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(hours * constants/* secondsInHour */.R3);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/intervalToDuration/index.js










/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @param {Interval} interval - the interval to convert to duration
 *
 * @returns {Duration} The duration Object
 * @throws {TypeError} Requires 2 arguments
 * @throws {RangeError} `start` must not be Invalid Date
 * @throws {RangeError} `end` must not be Invalid Date
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */

function intervalToDuration(interval) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var start = (0,toDate/* default */.Z)(interval.start);
  var end = (0,toDate/* default */.Z)(interval.end);
  if (isNaN(start.getTime())) throw new RangeError('Start Date is invalid');
  if (isNaN(end.getTime())) throw new RangeError('End Date is invalid');
  var duration = {};
  duration.years = Math.abs(differenceInYears(end, start));
  var sign = compareAsc(end, start);
  var remainingMonths = (0,add/* default */.Z)(start, {
    years: sign * duration.years
  });
  duration.months = Math.abs(differenceInMonths(end, remainingMonths));
  var remainingDays = (0,add/* default */.Z)(remainingMonths, {
    months: sign * duration.months
  });
  duration.days = Math.abs(differenceInDays(end, remainingDays));
  var remainingHours = (0,add/* default */.Z)(remainingDays, {
    days: sign * duration.days
  });
  duration.hours = Math.abs(differenceInHours(end, remainingHours));
  var remainingMinutes = (0,add/* default */.Z)(remainingHours, {
    hours: sign * duration.hours
  });
  duration.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
  var remainingSeconds = (0,add/* default */.Z)(remainingMinutes, {
    minutes: sign * duration.minutes
  });
  duration.seconds = Math.abs((0,differenceInSeconds/* default */.Z)(end, remainingSeconds));
  return duration;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/intlFormat/index.js


/**
 * @name intlFormat
 * @category Common Helpers
 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @param {Date|Number} argument - the original date.
 * @param {Object} [formatOptions] - an object with options.
 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
 * @param {String} [formatOptions.timeZone] - the time zone to use.
 * @param {Object} [localeOptions] - an object with locale.
 * @param {String|String[]} [localeOptions.locale] - the locale code
 * @returns {String} the formatted date string.
 * @throws {TypeError} 1 argument required.
 * @throws {RangeError} `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      weekday: 'long',
 *      year: 'numeric',
 *      month: 'long',
 *      day: 'numeric',
 *    }, {
 *      locale: 'de-DE',
 *  })
 * //=> Freitag, 4. Oktober 2019
 *
 * @example
 * // Represent 10 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      year: 'numeric',
 *      month: 'numeric',
 *      day: 'numeric',
 *      hour: 'numeric',
 *  })
 * //=> 10/4/2019, 12 PM
 *
 * @example
 * // Represent 10 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      locale: 'ko-KR',
 *  })
 * //=> 2019. 10. 4.
 *
 * @example
 * // Represent 10 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */
function intlFormat(date, formatOrLocale, localeOptions) {
  var _localeOptions;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var formatOptions;

  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }

  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
}

function isFormatOptions(opts) {
  return opts !== undefined && !('locale' in opts);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/intlFormatDistance/index.js












/**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with.
 * @param {Object} [options] - an object with options.
 * @param {String} [options.unit] - formats the distance with the given unit ('year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second').
 * @param {String|String[]} [options.locale] - the locale to use.
 * @param {String} [options.localeMatcher='best fit'] - the locale matching algorithm to use. Other value: 'lookup'.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * @param {String} [options.numeric='auto'] - the output message format. The values are 'auto' (e.g. `yesterday`), 'always'(e.g. `1 day ago`).
 * @param {String} [options.style='long'] - the length of the result. The values are: 'long' (e.g. `1 month`), 'short' (e.g. 'in 1 mo.'), 'narrow' (e.g. 'in 1 mo.').
 * The narrow one could be similar to the short one for some locales.
 * @returns {String} the distance in words according to language-sensitive relative time formatting.
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.unit` must not be invalid Unit
 * @throws {RangeError} `options.locale` must not be invalid locale
 * @throws {RangeError} `options.localeMatcher` must not be invalid localeMatcher
 * @throws {RangeError} `options.numeric` must not be invalid numeric
 * @throws {RangeError} `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */
function intlFormatDistance(date, baseDate, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var value = 0;
  var unit;
  var dateLeft = (0,toDate/* default */.Z)(date);
  var dateRight = (0,toDate/* default */.Z)(baseDate);

  if (!(options !== null && options !== void 0 && options.unit)) {
    // Get the unit based on diffInSeconds calculations if no unit is specified
    var diffInSeconds = (0,differenceInSeconds/* default */.Z)(dateLeft, dateRight); // The smallest unit

    if (Math.abs(diffInSeconds) < constants/* secondsInMinute */.xx) {
      value = (0,differenceInSeconds/* default */.Z)(dateLeft, dateRight);
      unit = 'second';
    } else if (Math.abs(diffInSeconds) < constants/* secondsInHour */.R3) {
      value = differenceInMinutes(dateLeft, dateRight);
      unit = 'minute';
    } else if (Math.abs(diffInSeconds) < constants/* secondsInDay */.gM && Math.abs((0,differenceInCalendarDays/* default */.Z)(dateLeft, dateRight)) < 1) {
      value = differenceInHours(dateLeft, dateRight);
      unit = 'hour';
    } else if (Math.abs(diffInSeconds) < constants/* secondsInWeek */.vr && (value = (0,differenceInCalendarDays/* default */.Z)(dateLeft, dateRight)) && Math.abs(value) < 7) {
      unit = 'day';
    } else if (Math.abs(diffInSeconds) < constants/* secondsInMonth */.nZ) {
      value = differenceInCalendarWeeks(dateLeft, dateRight);
      unit = 'week';
    } else if (Math.abs(diffInSeconds) < constants/* secondsInQuarter */.Y2) {
      value = differenceInCalendarMonths(dateLeft, dateRight);
      unit = 'month';
    } else if (Math.abs(diffInSeconds) < constants/* secondsInYear */.rz) {
      if (differenceInCalendarQuarters(dateLeft, dateRight) < 4) {
        // To filter out cases that are less than a year but match 4 quarters
        value = differenceInCalendarQuarters(dateLeft, dateRight);
        unit = 'quarter';
      } else {
        value = differenceInCalendarYears(dateLeft, dateRight);
        unit = 'year';
      }
    } else {
      value = differenceInCalendarYears(dateLeft, dateRight);
      unit = 'year';
    }
  } else {
    // Get the value if unit is specified
    unit = options === null || options === void 0 ? void 0 : options.unit;

    if (unit === 'second') {
      value = (0,differenceInSeconds/* default */.Z)(dateLeft, dateRight);
    } else if (unit === 'minute') {
      value = differenceInMinutes(dateLeft, dateRight);
    } else if (unit === 'hour') {
      value = differenceInHours(dateLeft, dateRight);
    } else if (unit === 'day') {
      value = (0,differenceInCalendarDays/* default */.Z)(dateLeft, dateRight);
    } else if (unit === 'week') {
      value = differenceInCalendarWeeks(dateLeft, dateRight);
    } else if (unit === 'month') {
      value = differenceInCalendarMonths(dateLeft, dateRight);
    } else if (unit === 'quarter') {
      value = differenceInCalendarQuarters(dateLeft, dateRight);
    } else if (unit === 'year') {
      value = differenceInCalendarYears(dateLeft, dateRight);
    }
  }

  var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
    localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
    numeric: (options === null || options === void 0 ? void 0 : options.numeric) || 'auto',
    style: options === null || options === void 0 ? void 0 : options.style
  });
  return rtf.format(value, unit);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(2699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__(1381);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isEqual/index.js
var isEqual = __webpack_require__(6843);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isExists/index.js
/**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param {Number} year of the date to check
 * @param {Number} month of the date to check
 * @param {Number} day of the date to check
 * @returns {Boolean} the date exists
 * @throws {TypeError} 3 arguments required
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */
function isExists(year, month, day) {
  if (arguments.length < 3) {
    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
  }

  var date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isFirstDayOfMonth/index.js


/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */

function isFirstDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDate() === 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isFriday/index.js


/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */

function isFriday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDay() === 5;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isFuture/index.js


/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */

function isFuture(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getTime() > Date.now();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(7621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Setter.js
function Setter_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Setter_typeof = function _typeof(obj) { return typeof obj; }; } else { Setter_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Setter_typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (Setter_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);

    _defineProperty(this, "subPriority", 0);
  }

  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);

  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);

  var _super = _createSuper(ValueSetter);

  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;

    _classCallCheck(this, ValueSetter);

    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;

    if (subPriority) {
      _this.subPriority = subPriority;
    }

    return _this;
  }

  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);

  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);

  var _super2 = _createSuper(DateToSystemTimezoneSetter);

  function DateToSystemTimezoneSetter() {
    var _this2;

    _classCallCheck(this, DateToSystemTimezoneSetter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);

    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);

    return _this2;
  }

  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }

      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);

  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Parser.js
function Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Parser_defineProperties(Constructor, staticProps); return Constructor; }


var Parser = /*#__PURE__*/function () {
  function Parser() {
    Parser_classCallCheck(this, Parser);
  }

  Parser_createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);

      if (!result) {
        return null;
      }

      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);

  return Parser;
}();
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js
function EraParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { EraParser_typeof = function _typeof(obj) { return typeof obj; }; } else { EraParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return EraParser_typeof(obj); }

function EraParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EraParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function EraParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) EraParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) EraParser_defineProperties(Constructor, staticProps); return Constructor; }

function EraParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) EraParser_setPrototypeOf(subClass, superClass); }

function EraParser_setPrototypeOf(o, p) { EraParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return EraParser_setPrototypeOf(o, p); }

function EraParser_createSuper(Derived) { var hasNativeReflectConstruct = EraParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = EraParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = EraParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return EraParser_possibleConstructorReturn(this, result); }; }

function EraParser_possibleConstructorReturn(self, call) { if (call && (EraParser_typeof(call) === "object" || typeof call === "function")) { return call; } return EraParser_assertThisInitialized(self); }

function EraParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function EraParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function EraParser_getPrototypeOf(o) { EraParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return EraParser_getPrototypeOf(o); }

function EraParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var EraParser = /*#__PURE__*/function (_Parser) {
  EraParser_inherits(EraParser, _Parser);

  var _super = EraParser_createSuper(EraParser);

  function EraParser() {
    var _this;

    EraParser_classCallCheck(this, EraParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    EraParser_defineProperty(EraParser_assertThisInitialized(_this), "priority", 140);

    EraParser_defineProperty(EraParser_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);

    return _this;
  }

  EraParser_createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return EraParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js
function YearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { YearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { YearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return YearParser_typeof(obj); }

function YearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function YearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function YearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) YearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) YearParser_defineProperties(Constructor, staticProps); return Constructor; }

function YearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) YearParser_setPrototypeOf(subClass, superClass); }

function YearParser_setPrototypeOf(o, p) { YearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return YearParser_setPrototypeOf(o, p); }

function YearParser_createSuper(Derived) { var hasNativeReflectConstruct = YearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = YearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = YearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return YearParser_possibleConstructorReturn(this, result); }; }

function YearParser_possibleConstructorReturn(self, call) { if (call && (YearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return YearParser_assertThisInitialized(self); }

function YearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function YearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function YearParser_getPrototypeOf(o) { YearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return YearParser_getPrototypeOf(o); }

function YearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  YearParser_inherits(YearParser, _Parser);

  var _super = YearParser_createSuper(YearParser);

  function YearParser() {
    var _this;

    YearParser_classCallCheck(this, YearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    YearParser_defineProperty(YearParser_assertThisInitialized(_this), "priority", 130);

    YearParser_defineProperty(YearParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  YearParser_createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return YearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(9025);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js
function LocalWeekYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalWeekYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalWeekYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalWeekYearParser_typeof(obj); }

function LocalWeekYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalWeekYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalWeekYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalWeekYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalWeekYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalWeekYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalWeekYearParser_setPrototypeOf(subClass, superClass); }

function LocalWeekYearParser_setPrototypeOf(o, p) { LocalWeekYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalWeekYearParser_setPrototypeOf(o, p); }

function LocalWeekYearParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalWeekYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalWeekYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalWeekYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalWeekYearParser_possibleConstructorReturn(this, result); }; }

function LocalWeekYearParser_possibleConstructorReturn(self, call) { if (call && (LocalWeekYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalWeekYearParser_assertThisInitialized(self); }

function LocalWeekYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalWeekYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalWeekYearParser_getPrototypeOf(o) { LocalWeekYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalWeekYearParser_getPrototypeOf(o); }

function LocalWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  LocalWeekYearParser_inherits(LocalWeekYearParser, _Parser);

  var _super = LocalWeekYearParser_createSuper(LocalWeekYearParser);

  function LocalWeekYearParser() {
    var _this;

    LocalWeekYearParser_classCallCheck(this, LocalWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalWeekYearParser_defineProperty(LocalWeekYearParser_assertThisInitialized(_this), "priority", 130);

    LocalWeekYearParser_defineProperty(LocalWeekYearParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  LocalWeekYearParser_createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }
  }]);

  return LocalWeekYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(6979);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js
function ISOWeekYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOWeekYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOWeekYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOWeekYearParser_typeof(obj); }

function ISOWeekYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOWeekYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOWeekYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOWeekYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOWeekYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOWeekYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOWeekYearParser_setPrototypeOf(subClass, superClass); }

function ISOWeekYearParser_setPrototypeOf(o, p) { ISOWeekYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOWeekYearParser_setPrototypeOf(o, p); }

function ISOWeekYearParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOWeekYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOWeekYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOWeekYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOWeekYearParser_possibleConstructorReturn(this, result); }; }

function ISOWeekYearParser_possibleConstructorReturn(self, call) { if (call && (ISOWeekYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOWeekYearParser_assertThisInitialized(self); }

function ISOWeekYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOWeekYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOWeekYearParser_getPrototypeOf(o) { ISOWeekYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOWeekYearParser_getPrototypeOf(o); }

function ISOWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO week-numbering year

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  ISOWeekYearParser_inherits(ISOWeekYearParser, _Parser);

  var _super = ISOWeekYearParser_createSuper(ISOWeekYearParser);

  function ISOWeekYearParser() {
    var _this;

    ISOWeekYearParser_classCallCheck(this, ISOWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOWeekYearParser_defineProperty(ISOWeekYearParser_assertThisInitialized(_this), "priority", 130);

    ISOWeekYearParser_defineProperty(ISOWeekYearParser_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISOWeekYearParser_createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    }
  }]);

  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js
function ExtendedYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ExtendedYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ExtendedYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ExtendedYearParser_typeof(obj); }

function ExtendedYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ExtendedYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ExtendedYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ExtendedYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ExtendedYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function ExtendedYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ExtendedYearParser_setPrototypeOf(subClass, superClass); }

function ExtendedYearParser_setPrototypeOf(o, p) { ExtendedYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ExtendedYearParser_setPrototypeOf(o, p); }

function ExtendedYearParser_createSuper(Derived) { var hasNativeReflectConstruct = ExtendedYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ExtendedYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ExtendedYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ExtendedYearParser_possibleConstructorReturn(this, result); }; }

function ExtendedYearParser_possibleConstructorReturn(self, call) { if (call && (ExtendedYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ExtendedYearParser_assertThisInitialized(self); }

function ExtendedYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ExtendedYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ExtendedYearParser_getPrototypeOf(o) { ExtendedYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ExtendedYearParser_getPrototypeOf(o); }

function ExtendedYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  ExtendedYearParser_inherits(ExtendedYearParser, _Parser);

  var _super = ExtendedYearParser_createSuper(ExtendedYearParser);

  function ExtendedYearParser() {
    var _this;

    ExtendedYearParser_classCallCheck(this, ExtendedYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ExtendedYearParser_defineProperty(ExtendedYearParser_assertThisInitialized(_this), "priority", 130);

    ExtendedYearParser_defineProperty(ExtendedYearParser_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  ExtendedYearParser_createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js
function QuarterParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { QuarterParser_typeof = function _typeof(obj) { return typeof obj; }; } else { QuarterParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return QuarterParser_typeof(obj); }

function QuarterParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function QuarterParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function QuarterParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) QuarterParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) QuarterParser_defineProperties(Constructor, staticProps); return Constructor; }

function QuarterParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) QuarterParser_setPrototypeOf(subClass, superClass); }

function QuarterParser_setPrototypeOf(o, p) { QuarterParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return QuarterParser_setPrototypeOf(o, p); }

function QuarterParser_createSuper(Derived) { var hasNativeReflectConstruct = QuarterParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = QuarterParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = QuarterParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return QuarterParser_possibleConstructorReturn(this, result); }; }

function QuarterParser_possibleConstructorReturn(self, call) { if (call && (QuarterParser_typeof(call) === "object" || typeof call === "function")) { return call; } return QuarterParser_assertThisInitialized(self); }

function QuarterParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function QuarterParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function QuarterParser_getPrototypeOf(o) { QuarterParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return QuarterParser_getPrototypeOf(o); }

function QuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var QuarterParser = /*#__PURE__*/function (_Parser) {
  QuarterParser_inherits(QuarterParser, _Parser);

  var _super = QuarterParser_createSuper(QuarterParser);

  function QuarterParser() {
    var _this;

    QuarterParser_classCallCheck(this, QuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    QuarterParser_defineProperty(QuarterParser_assertThisInitialized(_this), "priority", 120);

    QuarterParser_defineProperty(QuarterParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  QuarterParser_createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js
function StandAloneQuarterParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneQuarterParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneQuarterParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneQuarterParser_typeof(obj); }

function StandAloneQuarterParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneQuarterParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneQuarterParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneQuarterParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneQuarterParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneQuarterParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneQuarterParser_setPrototypeOf(subClass, superClass); }

function StandAloneQuarterParser_setPrototypeOf(o, p) { StandAloneQuarterParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneQuarterParser_setPrototypeOf(o, p); }

function StandAloneQuarterParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneQuarterParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneQuarterParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneQuarterParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneQuarterParser_possibleConstructorReturn(this, result); }; }

function StandAloneQuarterParser_possibleConstructorReturn(self, call) { if (call && (StandAloneQuarterParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneQuarterParser_assertThisInitialized(self); }

function StandAloneQuarterParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneQuarterParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneQuarterParser_getPrototypeOf(o) { StandAloneQuarterParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneQuarterParser_getPrototypeOf(o); }

function StandAloneQuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  StandAloneQuarterParser_inherits(StandAloneQuarterParser, _Parser);

  var _super = StandAloneQuarterParser_createSuper(StandAloneQuarterParser);

  function StandAloneQuarterParser() {
    var _this;

    StandAloneQuarterParser_classCallCheck(this, StandAloneQuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneQuarterParser_defineProperty(StandAloneQuarterParser_assertThisInitialized(_this), "priority", 120);

    StandAloneQuarterParser_defineProperty(StandAloneQuarterParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  StandAloneQuarterParser_createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js
function MonthParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MonthParser_typeof = function _typeof(obj) { return typeof obj; }; } else { MonthParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MonthParser_typeof(obj); }

function MonthParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MonthParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MonthParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) MonthParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) MonthParser_defineProperties(Constructor, staticProps); return Constructor; }

function MonthParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MonthParser_setPrototypeOf(subClass, superClass); }

function MonthParser_setPrototypeOf(o, p) { MonthParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MonthParser_setPrototypeOf(o, p); }

function MonthParser_createSuper(Derived) { var hasNativeReflectConstruct = MonthParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MonthParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MonthParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MonthParser_possibleConstructorReturn(this, result); }; }

function MonthParser_possibleConstructorReturn(self, call) { if (call && (MonthParser_typeof(call) === "object" || typeof call === "function")) { return call; } return MonthParser_assertThisInitialized(self); }

function MonthParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MonthParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function MonthParser_getPrototypeOf(o) { MonthParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MonthParser_getPrototypeOf(o); }

function MonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MonthParser = /*#__PURE__*/function (_Parser) {
  MonthParser_inherits(MonthParser, _Parser);

  var _super = MonthParser_createSuper(MonthParser);

  function MonthParser() {
    var _this;

    MonthParser_classCallCheck(this, MonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    MonthParser_defineProperty(MonthParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    MonthParser_defineProperty(MonthParser_assertThisInitialized(_this), "priority", 110);

    return _this;
  }

  MonthParser_createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js
function StandAloneMonthParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneMonthParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneMonthParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneMonthParser_typeof(obj); }

function StandAloneMonthParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneMonthParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneMonthParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneMonthParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneMonthParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneMonthParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneMonthParser_setPrototypeOf(subClass, superClass); }

function StandAloneMonthParser_setPrototypeOf(o, p) { StandAloneMonthParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneMonthParser_setPrototypeOf(o, p); }

function StandAloneMonthParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneMonthParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneMonthParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneMonthParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneMonthParser_possibleConstructorReturn(this, result); }; }

function StandAloneMonthParser_possibleConstructorReturn(self, call) { if (call && (StandAloneMonthParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneMonthParser_assertThisInitialized(self); }

function StandAloneMonthParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneMonthParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneMonthParser_getPrototypeOf(o) { StandAloneMonthParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneMonthParser_getPrototypeOf(o); }

function StandAloneMonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  StandAloneMonthParser_inherits(StandAloneMonthParser, _Parser);

  var _super = StandAloneMonthParser_createSuper(StandAloneMonthParser);

  function StandAloneMonthParser() {
    var _this;

    StandAloneMonthParser_classCallCheck(this, StandAloneMonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneMonthParser_defineProperty(StandAloneMonthParser_assertThisInitialized(_this), "priority", 110);

    StandAloneMonthParser_defineProperty(StandAloneMonthParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  StandAloneMonthParser_createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneMonthParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(3324);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js
function LocalWeekParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalWeekParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalWeekParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalWeekParser_typeof(obj); }

function LocalWeekParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalWeekParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalWeekParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalWeekParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalWeekParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalWeekParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalWeekParser_setPrototypeOf(subClass, superClass); }

function LocalWeekParser_setPrototypeOf(o, p) { LocalWeekParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalWeekParser_setPrototypeOf(o, p); }

function LocalWeekParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalWeekParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalWeekParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalWeekParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalWeekParser_possibleConstructorReturn(this, result); }; }

function LocalWeekParser_possibleConstructorReturn(self, call) { if (call && (LocalWeekParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalWeekParser_assertThisInitialized(self); }

function LocalWeekParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalWeekParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalWeekParser_getPrototypeOf(o) { LocalWeekParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalWeekParser_getPrototypeOf(o); }

function LocalWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // Local week of year

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  LocalWeekParser_inherits(LocalWeekParser, _Parser);

  var _super = LocalWeekParser_createSuper(LocalWeekParser);

  function LocalWeekParser() {
    var _this;

    LocalWeekParser_classCallCheck(this, LocalWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalWeekParser_defineProperty(LocalWeekParser_assertThisInitialized(_this), "priority", 100);

    LocalWeekParser_defineProperty(LocalWeekParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  LocalWeekParser_createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    }
  }]);

  return LocalWeekParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(9702);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js
function ISOWeekParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOWeekParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOWeekParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOWeekParser_typeof(obj); }

function ISOWeekParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOWeekParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOWeekParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOWeekParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOWeekParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOWeekParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOWeekParser_setPrototypeOf(subClass, superClass); }

function ISOWeekParser_setPrototypeOf(o, p) { ISOWeekParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOWeekParser_setPrototypeOf(o, p); }

function ISOWeekParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOWeekParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOWeekParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOWeekParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOWeekParser_possibleConstructorReturn(this, result); }; }

function ISOWeekParser_possibleConstructorReturn(self, call) { if (call && (ISOWeekParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOWeekParser_assertThisInitialized(self); }

function ISOWeekParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOWeekParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOWeekParser_getPrototypeOf(o) { ISOWeekParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOWeekParser_getPrototypeOf(o); }

function ISOWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // ISO week of year

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  ISOWeekParser_inherits(ISOWeekParser, _Parser);

  var _super = ISOWeekParser_createSuper(ISOWeekParser);

  function ISOWeekParser() {
    var _this;

    ISOWeekParser_classCallCheck(this, ISOWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOWeekParser_defineProperty(ISOWeekParser_assertThisInitialized(_this), "priority", 100);

    ISOWeekParser_defineProperty(ISOWeekParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISOWeekParser_createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
    }
  }]);

  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js
function DateParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DateParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DateParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DateParser_typeof(obj); }

function DateParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DateParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DateParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DateParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DateParser_defineProperties(Constructor, staticProps); return Constructor; }

function DateParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DateParser_setPrototypeOf(subClass, superClass); }

function DateParser_setPrototypeOf(o, p) { DateParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DateParser_setPrototypeOf(o, p); }

function DateParser_createSuper(Derived) { var hasNativeReflectConstruct = DateParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DateParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DateParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DateParser_possibleConstructorReturn(this, result); }; }

function DateParser_possibleConstructorReturn(self, call) { if (call && (DateParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DateParser_assertThisInitialized(self); }

function DateParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DateParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DateParser_getPrototypeOf(o) { DateParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DateParser_getPrototypeOf(o); }

function DateParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

var DateParser = /*#__PURE__*/function (_Parser) {
  DateParser_inherits(DateParser, _Parser);

  var _super = DateParser_createSuper(DateParser);

  function DateParser() {
    var _this;

    DateParser_classCallCheck(this, DateParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "priority", 90);

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "subPriority", 1);

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DateParser_createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);

        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js
function DayOfYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayOfYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayOfYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayOfYearParser_typeof(obj); }

function DayOfYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayOfYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayOfYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayOfYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayOfYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayOfYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayOfYearParser_setPrototypeOf(subClass, superClass); }

function DayOfYearParser_setPrototypeOf(o, p) { DayOfYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayOfYearParser_setPrototypeOf(o, p); }

function DayOfYearParser_createSuper(Derived) { var hasNativeReflectConstruct = DayOfYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayOfYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayOfYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayOfYearParser_possibleConstructorReturn(this, result); }; }

function DayOfYearParser_possibleConstructorReturn(self, call) { if (call && (DayOfYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayOfYearParser_assertThisInitialized(self); }

function DayOfYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayOfYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayOfYearParser_getPrototypeOf(o) { DayOfYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayOfYearParser_getPrototypeOf(o); }

function DayOfYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  DayOfYearParser_inherits(DayOfYearParser, _Parser);

  var _super = DayOfYearParser_createSuper(DayOfYearParser);

  function DayOfYearParser() {
    var _this;

    DayOfYearParser_classCallCheck(this, DayOfYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "priority", 90);

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "subpriority", 1);

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DayOfYearParser_createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);

        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayOfYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js
function DayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayParser_typeof(obj); }

function DayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayParser_setPrototypeOf(subClass, superClass); }

function DayParser_setPrototypeOf(o, p) { DayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayParser_setPrototypeOf(o, p); }

function DayParser_createSuper(Derived) { var hasNativeReflectConstruct = DayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayParser_possibleConstructorReturn(this, result); }; }

function DayParser_possibleConstructorReturn(self, call) { if (call && (DayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayParser_assertThisInitialized(self); }

function DayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayParser_getPrototypeOf(o) { DayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayParser_getPrototypeOf(o); }

function DayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // Day of week

var DayParser = /*#__PURE__*/function (_Parser) {
  DayParser_inherits(DayParser, _Parser);

  var _super = DayParser_createSuper(DayParser);

  function DayParser() {
    var _this;

    DayParser_classCallCheck(this, DayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayParser_defineProperty(DayParser_assertThisInitialized(_this), "priority", 90);

    DayParser_defineProperty(DayParser_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DayParser_createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js
function LocalDayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalDayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalDayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalDayParser_typeof(obj); }

function LocalDayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalDayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalDayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalDayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalDayParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalDayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalDayParser_setPrototypeOf(subClass, superClass); }

function LocalDayParser_setPrototypeOf(o, p) { LocalDayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalDayParser_setPrototypeOf(o, p); }

function LocalDayParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalDayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalDayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalDayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalDayParser_possibleConstructorReturn(this, result); }; }

function LocalDayParser_possibleConstructorReturn(self, call) { if (call && (LocalDayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalDayParser_assertThisInitialized(self); }

function LocalDayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalDayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalDayParser_getPrototypeOf(o) { LocalDayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalDayParser_getPrototypeOf(o); }

function LocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Local day of week

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  LocalDayParser_inherits(LocalDayParser, _Parser);

  var _super = LocalDayParser_createSuper(LocalDayParser);

  function LocalDayParser() {
    var _this;

    LocalDayParser_classCallCheck(this, LocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalDayParser_defineProperty(LocalDayParser_assertThisInitialized(_this), "priority", 90);

    LocalDayParser_defineProperty(LocalDayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);

    return _this;
  }

  LocalDayParser_createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js
function StandAloneLocalDayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneLocalDayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneLocalDayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneLocalDayParser_typeof(obj); }

function StandAloneLocalDayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneLocalDayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneLocalDayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneLocalDayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneLocalDayParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneLocalDayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneLocalDayParser_setPrototypeOf(subClass, superClass); }

function StandAloneLocalDayParser_setPrototypeOf(o, p) { StandAloneLocalDayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneLocalDayParser_setPrototypeOf(o, p); }

function StandAloneLocalDayParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneLocalDayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneLocalDayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneLocalDayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneLocalDayParser_possibleConstructorReturn(this, result); }; }

function StandAloneLocalDayParser_possibleConstructorReturn(self, call) { if (call && (StandAloneLocalDayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneLocalDayParser_assertThisInitialized(self); }

function StandAloneLocalDayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneLocalDayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneLocalDayParser_getPrototypeOf(o) { StandAloneLocalDayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneLocalDayParser_getPrototypeOf(o); }

function StandAloneLocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Stand-alone local day of week

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  StandAloneLocalDayParser_inherits(StandAloneLocalDayParser, _Parser);

  var _super = StandAloneLocalDayParser_createSuper(StandAloneLocalDayParser);

  function StandAloneLocalDayParser() {
    var _this;

    StandAloneLocalDayParser_classCallCheck(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneLocalDayParser_defineProperty(StandAloneLocalDayParser_assertThisInitialized(_this), "priority", 90);

    StandAloneLocalDayParser_defineProperty(StandAloneLocalDayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);

    return _this;
  }

  StandAloneLocalDayParser_createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js
function ISODayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISODayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISODayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISODayParser_typeof(obj); }

function ISODayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISODayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISODayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISODayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISODayParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISODayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISODayParser_setPrototypeOf(subClass, superClass); }

function ISODayParser_setPrototypeOf(o, p) { ISODayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISODayParser_setPrototypeOf(o, p); }

function ISODayParser_createSuper(Derived) { var hasNativeReflectConstruct = ISODayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISODayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISODayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISODayParser_possibleConstructorReturn(this, result); }; }

function ISODayParser_possibleConstructorReturn(self, call) { if (call && (ISODayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISODayParser_assertThisInitialized(self); }

function ISODayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISODayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISODayParser_getPrototypeOf(o) { ISODayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISODayParser_getPrototypeOf(o); }

function ISODayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO day of week

var ISODayParser = /*#__PURE__*/function (_Parser) {
  ISODayParser_inherits(ISODayParser, _Parser);

  var _super = ISODayParser_createSuper(ISODayParser);

  function ISODayParser() {
    var _this;

    ISODayParser_classCallCheck(this, ISODayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISODayParser_defineProperty(ISODayParser_assertThisInitialized(_this), "priority", 90);

    ISODayParser_defineProperty(ISODayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISODayParser_createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd

        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T

        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu

        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday

        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js
function AMPMParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AMPMParser_typeof = function _typeof(obj) { return typeof obj; }; } else { AMPMParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AMPMParser_typeof(obj); }

function AMPMParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AMPMParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AMPMParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AMPMParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AMPMParser_defineProperties(Constructor, staticProps); return Constructor; }

function AMPMParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AMPMParser_setPrototypeOf(subClass, superClass); }

function AMPMParser_setPrototypeOf(o, p) { AMPMParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AMPMParser_setPrototypeOf(o, p); }

function AMPMParser_createSuper(Derived) { var hasNativeReflectConstruct = AMPMParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AMPMParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AMPMParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AMPMParser_possibleConstructorReturn(this, result); }; }

function AMPMParser_possibleConstructorReturn(self, call) { if (call && (AMPMParser_typeof(call) === "object" || typeof call === "function")) { return call; } return AMPMParser_assertThisInitialized(self); }

function AMPMParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AMPMParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AMPMParser_getPrototypeOf(o) { AMPMParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AMPMParser_getPrototypeOf(o); }

function AMPMParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AMPMParser = /*#__PURE__*/function (_Parser) {
  AMPMParser_inherits(AMPMParser, _Parser);

  var _super = AMPMParser_createSuper(AMPMParser);

  function AMPMParser() {
    var _this;

    AMPMParser_classCallCheck(this, AMPMParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    AMPMParser_defineProperty(AMPMParser_assertThisInitialized(_this), "priority", 80);

    AMPMParser_defineProperty(AMPMParser_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  AMPMParser_createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js
function AMPMMidnightParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AMPMMidnightParser_typeof = function _typeof(obj) { return typeof obj; }; } else { AMPMMidnightParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AMPMMidnightParser_typeof(obj); }

function AMPMMidnightParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AMPMMidnightParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AMPMMidnightParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AMPMMidnightParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AMPMMidnightParser_defineProperties(Constructor, staticProps); return Constructor; }

function AMPMMidnightParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AMPMMidnightParser_setPrototypeOf(subClass, superClass); }

function AMPMMidnightParser_setPrototypeOf(o, p) { AMPMMidnightParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AMPMMidnightParser_setPrototypeOf(o, p); }

function AMPMMidnightParser_createSuper(Derived) { var hasNativeReflectConstruct = AMPMMidnightParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AMPMMidnightParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AMPMMidnightParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AMPMMidnightParser_possibleConstructorReturn(this, result); }; }

function AMPMMidnightParser_possibleConstructorReturn(self, call) { if (call && (AMPMMidnightParser_typeof(call) === "object" || typeof call === "function")) { return call; } return AMPMMidnightParser_assertThisInitialized(self); }

function AMPMMidnightParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AMPMMidnightParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AMPMMidnightParser_getPrototypeOf(o) { AMPMMidnightParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AMPMMidnightParser_getPrototypeOf(o); }

function AMPMMidnightParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  AMPMMidnightParser_inherits(AMPMMidnightParser, _Parser);

  var _super = AMPMMidnightParser_createSuper(AMPMMidnightParser);

  function AMPMMidnightParser() {
    var _this;

    AMPMMidnightParser_classCallCheck(this, AMPMMidnightParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    AMPMMidnightParser_defineProperty(AMPMMidnightParser_assertThisInitialized(_this), "priority", 80);

    AMPMMidnightParser_defineProperty(AMPMMidnightParser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  AMPMMidnightParser_createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js
function DayPeriodParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayPeriodParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayPeriodParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayPeriodParser_typeof(obj); }

function DayPeriodParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayPeriodParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayPeriodParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayPeriodParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayPeriodParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayPeriodParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayPeriodParser_setPrototypeOf(subClass, superClass); }

function DayPeriodParser_setPrototypeOf(o, p) { DayPeriodParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayPeriodParser_setPrototypeOf(o, p); }

function DayPeriodParser_createSuper(Derived) { var hasNativeReflectConstruct = DayPeriodParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayPeriodParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayPeriodParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayPeriodParser_possibleConstructorReturn(this, result); }; }

function DayPeriodParser_possibleConstructorReturn(self, call) { if (call && (DayPeriodParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayPeriodParser_assertThisInitialized(self); }

function DayPeriodParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayPeriodParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayPeriodParser_getPrototypeOf(o) { DayPeriodParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayPeriodParser_getPrototypeOf(o); }

function DayPeriodParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // in the morning, in the afternoon, in the evening, at night

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  DayPeriodParser_inherits(DayPeriodParser, _Parser);

  var _super = DayPeriodParser_createSuper(DayPeriodParser);

  function DayPeriodParser() {
    var _this;

    DayPeriodParser_classCallCheck(this, DayPeriodParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayPeriodParser_defineProperty(DayPeriodParser_assertThisInitialized(_this), "priority", 80);

    DayPeriodParser_defineProperty(DayPeriodParser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);

    return _this;
  }

  DayPeriodParser_createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js
function Hour1to12Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour1to12Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour1to12Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour1to12Parser_typeof(obj); }

function Hour1to12Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour1to12Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour1to12Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour1to12Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour1to12Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour1to12Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour1to12Parser_setPrototypeOf(subClass, superClass); }

function Hour1to12Parser_setPrototypeOf(o, p) { Hour1to12Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour1to12Parser_setPrototypeOf(o, p); }

function Hour1to12Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour1to12Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour1to12Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour1to12Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour1to12Parser_possibleConstructorReturn(this, result); }; }

function Hour1to12Parser_possibleConstructorReturn(self, call) { if (call && (Hour1to12Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour1to12Parser_assertThisInitialized(self); }

function Hour1to12Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour1to12Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour1to12Parser_getPrototypeOf(o) { Hour1to12Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour1to12Parser_getPrototypeOf(o); }

function Hour1to12Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  Hour1to12Parser_inherits(Hour1to12Parser, _Parser);

  var _super = Hour1to12Parser_createSuper(Hour1to12Parser);

  function Hour1to12Parser() {
    var _this;

    Hour1to12Parser_classCallCheck(this, Hour1to12Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour1to12Parser_defineProperty(Hour1to12Parser_assertThisInitialized(_this), "priority", 70);

    Hour1to12Parser_defineProperty(Hour1to12Parser_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);

    return _this;
  }

  Hour1to12Parser_createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);

        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js
function Hour0to23Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour0to23Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour0to23Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour0to23Parser_typeof(obj); }

function Hour0to23Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour0to23Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour0to23Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour0to23Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour0to23Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour0to23Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour0to23Parser_setPrototypeOf(subClass, superClass); }

function Hour0to23Parser_setPrototypeOf(o, p) { Hour0to23Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour0to23Parser_setPrototypeOf(o, p); }

function Hour0to23Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour0to23Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour0to23Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour0to23Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour0to23Parser_possibleConstructorReturn(this, result); }; }

function Hour0to23Parser_possibleConstructorReturn(self, call) { if (call && (Hour0to23Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour0to23Parser_assertThisInitialized(self); }

function Hour0to23Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour0to23Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour0to23Parser_getPrototypeOf(o) { Hour0to23Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour0to23Parser_getPrototypeOf(o); }

function Hour0to23Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  Hour0to23Parser_inherits(Hour0to23Parser, _Parser);

  var _super = Hour0to23Parser_createSuper(Hour0to23Parser);

  function Hour0to23Parser() {
    var _this;

    Hour0to23Parser_classCallCheck(this, Hour0to23Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour0to23Parser_defineProperty(Hour0to23Parser_assertThisInitialized(_this), "priority", 70);

    Hour0to23Parser_defineProperty(Hour0to23Parser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);

    return _this;
  }

  Hour0to23Parser_createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);

        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);

  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js
function Hour0To11Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour0To11Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour0To11Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour0To11Parser_typeof(obj); }

function Hour0To11Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour0To11Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour0To11Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour0To11Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour0To11Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour0To11Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour0To11Parser_setPrototypeOf(subClass, superClass); }

function Hour0To11Parser_setPrototypeOf(o, p) { Hour0To11Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour0To11Parser_setPrototypeOf(o, p); }

function Hour0To11Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour0To11Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour0To11Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour0To11Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour0To11Parser_possibleConstructorReturn(this, result); }; }

function Hour0To11Parser_possibleConstructorReturn(self, call) { if (call && (Hour0To11Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour0To11Parser_assertThisInitialized(self); }

function Hour0To11Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour0To11Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour0To11Parser_getPrototypeOf(o) { Hour0To11Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour0To11Parser_getPrototypeOf(o); }

function Hour0To11Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  Hour0To11Parser_inherits(Hour0To11Parser, _Parser);

  var _super = Hour0To11Parser_createSuper(Hour0To11Parser);

  function Hour0To11Parser() {
    var _this;

    Hour0To11Parser_classCallCheck(this, Hour0To11Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour0To11Parser_defineProperty(Hour0To11Parser_assertThisInitialized(_this), "priority", 70);

    Hour0To11Parser_defineProperty(Hour0To11Parser_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);

    return _this;
  }

  Hour0To11Parser_createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);

        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js
function Hour1To24Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour1To24Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour1To24Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour1To24Parser_typeof(obj); }

function Hour1To24Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour1To24Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour1To24Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour1To24Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour1To24Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour1To24Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour1To24Parser_setPrototypeOf(subClass, superClass); }

function Hour1To24Parser_setPrototypeOf(o, p) { Hour1To24Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour1To24Parser_setPrototypeOf(o, p); }

function Hour1To24Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour1To24Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour1To24Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour1To24Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour1To24Parser_possibleConstructorReturn(this, result); }; }

function Hour1To24Parser_possibleConstructorReturn(self, call) { if (call && (Hour1To24Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour1To24Parser_assertThisInitialized(self); }

function Hour1To24Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour1To24Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour1To24Parser_getPrototypeOf(o) { Hour1To24Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour1To24Parser_getPrototypeOf(o); }

function Hour1To24Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  Hour1To24Parser_inherits(Hour1To24Parser, _Parser);

  var _super = Hour1To24Parser_createSuper(Hour1To24Parser);

  function Hour1To24Parser() {
    var _this;

    Hour1To24Parser_classCallCheck(this, Hour1To24Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour1To24Parser_defineProperty(Hour1To24Parser_assertThisInitialized(_this), "priority", 70);

    Hour1To24Parser_defineProperty(Hour1To24Parser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);

    return _this;
  }

  Hour1To24Parser_createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);

        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);

  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js
function MinuteParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MinuteParser_typeof = function _typeof(obj) { return typeof obj; }; } else { MinuteParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MinuteParser_typeof(obj); }

function MinuteParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MinuteParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MinuteParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) MinuteParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) MinuteParser_defineProperties(Constructor, staticProps); return Constructor; }

function MinuteParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MinuteParser_setPrototypeOf(subClass, superClass); }

function MinuteParser_setPrototypeOf(o, p) { MinuteParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MinuteParser_setPrototypeOf(o, p); }

function MinuteParser_createSuper(Derived) { var hasNativeReflectConstruct = MinuteParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MinuteParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MinuteParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MinuteParser_possibleConstructorReturn(this, result); }; }

function MinuteParser_possibleConstructorReturn(self, call) { if (call && (MinuteParser_typeof(call) === "object" || typeof call === "function")) { return call; } return MinuteParser_assertThisInitialized(self); }

function MinuteParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MinuteParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function MinuteParser_getPrototypeOf(o) { MinuteParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MinuteParser_getPrototypeOf(o); }

function MinuteParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MinuteParser = /*#__PURE__*/function (_Parser) {
  MinuteParser_inherits(MinuteParser, _Parser);

  var _super = MinuteParser_createSuper(MinuteParser);

  function MinuteParser() {
    var _this;

    MinuteParser_classCallCheck(this, MinuteParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    MinuteParser_defineProperty(MinuteParser_assertThisInitialized(_this), "priority", 60);

    MinuteParser_defineProperty(MinuteParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  MinuteParser_createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);

        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);

  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js
function SecondParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SecondParser_typeof = function _typeof(obj) { return typeof obj; }; } else { SecondParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SecondParser_typeof(obj); }

function SecondParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SecondParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SecondParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) SecondParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) SecondParser_defineProperties(Constructor, staticProps); return Constructor; }

function SecondParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) SecondParser_setPrototypeOf(subClass, superClass); }

function SecondParser_setPrototypeOf(o, p) { SecondParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SecondParser_setPrototypeOf(o, p); }

function SecondParser_createSuper(Derived) { var hasNativeReflectConstruct = SecondParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SecondParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SecondParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SecondParser_possibleConstructorReturn(this, result); }; }

function SecondParser_possibleConstructorReturn(self, call) { if (call && (SecondParser_typeof(call) === "object" || typeof call === "function")) { return call; } return SecondParser_assertThisInitialized(self); }

function SecondParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SecondParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SecondParser_getPrototypeOf(o) { SecondParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SecondParser_getPrototypeOf(o); }

function SecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SecondParser = /*#__PURE__*/function (_Parser) {
  SecondParser_inherits(SecondParser, _Parser);

  var _super = SecondParser_createSuper(SecondParser);

  function SecondParser() {
    var _this;

    SecondParser_classCallCheck(this, SecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    SecondParser_defineProperty(SecondParser_assertThisInitialized(_this), "priority", 50);

    SecondParser_defineProperty(SecondParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  SecondParser_createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);

        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);

  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js
function FractionOfSecondParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FractionOfSecondParser_typeof = function _typeof(obj) { return typeof obj; }; } else { FractionOfSecondParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FractionOfSecondParser_typeof(obj); }

function FractionOfSecondParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FractionOfSecondParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FractionOfSecondParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) FractionOfSecondParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) FractionOfSecondParser_defineProperties(Constructor, staticProps); return Constructor; }

function FractionOfSecondParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FractionOfSecondParser_setPrototypeOf(subClass, superClass); }

function FractionOfSecondParser_setPrototypeOf(o, p) { FractionOfSecondParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FractionOfSecondParser_setPrototypeOf(o, p); }

function FractionOfSecondParser_createSuper(Derived) { var hasNativeReflectConstruct = FractionOfSecondParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = FractionOfSecondParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = FractionOfSecondParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return FractionOfSecondParser_possibleConstructorReturn(this, result); }; }

function FractionOfSecondParser_possibleConstructorReturn(self, call) { if (call && (FractionOfSecondParser_typeof(call) === "object" || typeof call === "function")) { return call; } return FractionOfSecondParser_assertThisInitialized(self); }

function FractionOfSecondParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FractionOfSecondParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function FractionOfSecondParser_getPrototypeOf(o) { FractionOfSecondParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FractionOfSecondParser_getPrototypeOf(o); }

function FractionOfSecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  FractionOfSecondParser_inherits(FractionOfSecondParser, _Parser);

  var _super = FractionOfSecondParser_createSuper(FractionOfSecondParser);

  function FractionOfSecondParser() {
    var _this;

    FractionOfSecondParser_classCallCheck(this, FractionOfSecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    FractionOfSecondParser_defineProperty(FractionOfSecondParser_assertThisInitialized(_this), "priority", 30);

    FractionOfSecondParser_defineProperty(FractionOfSecondParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  FractionOfSecondParser_createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);

  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js
function ISOTimezoneWithZParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOTimezoneWithZParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOTimezoneWithZParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOTimezoneWithZParser_typeof(obj); }

function ISOTimezoneWithZParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOTimezoneWithZParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOTimezoneWithZParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOTimezoneWithZParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOTimezoneWithZParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOTimezoneWithZParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOTimezoneWithZParser_setPrototypeOf(subClass, superClass); }

function ISOTimezoneWithZParser_setPrototypeOf(o, p) { ISOTimezoneWithZParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOTimezoneWithZParser_setPrototypeOf(o, p); }

function ISOTimezoneWithZParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOTimezoneWithZParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOTimezoneWithZParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOTimezoneWithZParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOTimezoneWithZParser_possibleConstructorReturn(this, result); }; }

function ISOTimezoneWithZParser_possibleConstructorReturn(self, call) { if (call && (ISOTimezoneWithZParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOTimezoneWithZParser_assertThisInitialized(self); }

function ISOTimezoneWithZParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOTimezoneWithZParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOTimezoneWithZParser_getPrototypeOf(o) { ISOTimezoneWithZParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOTimezoneWithZParser_getPrototypeOf(o); }

function ISOTimezoneWithZParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601. +00:00 is `'Z'`)

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  ISOTimezoneWithZParser_inherits(ISOTimezoneWithZParser, _Parser);

  var _super = ISOTimezoneWithZParser_createSuper(ISOTimezoneWithZParser);

  function ISOTimezoneWithZParser() {
    var _this;

    ISOTimezoneWithZParser_classCallCheck(this, ISOTimezoneWithZParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOTimezoneWithZParser_defineProperty(ISOTimezoneWithZParser_assertThisInitialized(_this), "priority", 10);

    ISOTimezoneWithZParser_defineProperty(ISOTimezoneWithZParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);

    return _this;
  }

  ISOTimezoneWithZParser_createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js
function ISOTimezoneParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOTimezoneParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOTimezoneParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOTimezoneParser_typeof(obj); }

function ISOTimezoneParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOTimezoneParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOTimezoneParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOTimezoneParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOTimezoneParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOTimezoneParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOTimezoneParser_setPrototypeOf(subClass, superClass); }

function ISOTimezoneParser_setPrototypeOf(o, p) { ISOTimezoneParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOTimezoneParser_setPrototypeOf(o, p); }

function ISOTimezoneParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOTimezoneParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOTimezoneParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOTimezoneParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOTimezoneParser_possibleConstructorReturn(this, result); }; }

function ISOTimezoneParser_possibleConstructorReturn(self, call) { if (call && (ISOTimezoneParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOTimezoneParser_assertThisInitialized(self); }

function ISOTimezoneParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOTimezoneParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOTimezoneParser_getPrototypeOf(o) { ISOTimezoneParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOTimezoneParser_getPrototypeOf(o); }

function ISOTimezoneParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601)

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  ISOTimezoneParser_inherits(ISOTimezoneParser, _Parser);

  var _super = ISOTimezoneParser_createSuper(ISOTimezoneParser);

  function ISOTimezoneParser() {
    var _this;

    ISOTimezoneParser_classCallCheck(this, ISOTimezoneParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOTimezoneParser_defineProperty(ISOTimezoneParser_assertThisInitialized(_this), "priority", 10);

    ISOTimezoneParser_defineProperty(ISOTimezoneParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);

    return _this;
  }

  ISOTimezoneParser_createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js
function TimestampSecondsParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimestampSecondsParser_typeof = function _typeof(obj) { return typeof obj; }; } else { TimestampSecondsParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimestampSecondsParser_typeof(obj); }

function TimestampSecondsParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimestampSecondsParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimestampSecondsParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimestampSecondsParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimestampSecondsParser_defineProperties(Constructor, staticProps); return Constructor; }

function TimestampSecondsParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TimestampSecondsParser_setPrototypeOf(subClass, superClass); }

function TimestampSecondsParser_setPrototypeOf(o, p) { TimestampSecondsParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TimestampSecondsParser_setPrototypeOf(o, p); }

function TimestampSecondsParser_createSuper(Derived) { var hasNativeReflectConstruct = TimestampSecondsParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TimestampSecondsParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TimestampSecondsParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TimestampSecondsParser_possibleConstructorReturn(this, result); }; }

function TimestampSecondsParser_possibleConstructorReturn(self, call) { if (call && (TimestampSecondsParser_typeof(call) === "object" || typeof call === "function")) { return call; } return TimestampSecondsParser_assertThisInitialized(self); }

function TimestampSecondsParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TimestampSecondsParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TimestampSecondsParser_getPrototypeOf(o) { TimestampSecondsParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TimestampSecondsParser_getPrototypeOf(o); }

function TimestampSecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  TimestampSecondsParser_inherits(TimestampSecondsParser, _Parser);

  var _super = TimestampSecondsParser_createSuper(TimestampSecondsParser);

  function TimestampSecondsParser() {
    var _this;

    TimestampSecondsParser_classCallCheck(this, TimestampSecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    TimestampSecondsParser_defineProperty(TimestampSecondsParser_assertThisInitialized(_this), "priority", 40);

    TimestampSecondsParser_defineProperty(TimestampSecondsParser_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  TimestampSecondsParser_createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js
function TimestampMillisecondsParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimestampMillisecondsParser_typeof = function _typeof(obj) { return typeof obj; }; } else { TimestampMillisecondsParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimestampMillisecondsParser_typeof(obj); }

function TimestampMillisecondsParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimestampMillisecondsParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimestampMillisecondsParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimestampMillisecondsParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimestampMillisecondsParser_defineProperties(Constructor, staticProps); return Constructor; }

function TimestampMillisecondsParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TimestampMillisecondsParser_setPrototypeOf(subClass, superClass); }

function TimestampMillisecondsParser_setPrototypeOf(o, p) { TimestampMillisecondsParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TimestampMillisecondsParser_setPrototypeOf(o, p); }

function TimestampMillisecondsParser_createSuper(Derived) { var hasNativeReflectConstruct = TimestampMillisecondsParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TimestampMillisecondsParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TimestampMillisecondsParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TimestampMillisecondsParser_possibleConstructorReturn(this, result); }; }

function TimestampMillisecondsParser_possibleConstructorReturn(self, call) { if (call && (TimestampMillisecondsParser_typeof(call) === "object" || typeof call === "function")) { return call; } return TimestampMillisecondsParser_assertThisInitialized(self); }

function TimestampMillisecondsParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TimestampMillisecondsParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TimestampMillisecondsParser_getPrototypeOf(o) { TimestampMillisecondsParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TimestampMillisecondsParser_getPrototypeOf(o); }

function TimestampMillisecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  TimestampMillisecondsParser_inherits(TimestampMillisecondsParser, _Parser);

  var _super = TimestampMillisecondsParser_createSuper(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    TimestampMillisecondsParser_classCallCheck(this, TimestampMillisecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    TimestampMillisecondsParser_defineProperty(TimestampMillisecondsParser_assertThisInitialized(_this), "priority", 20);

    TimestampMillisecondsParser_defineProperty(TimestampMillisecondsParser_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  TimestampMillisecondsParser_createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js
function parse_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { parse_typeof = function _typeof(obj) { return typeof obj; }; } else { parse_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return parse_typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate/* default */.Z)(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  var _iterator = _createForOfIteratorHelper(tokens),
      _step;

  try {
    var _loop = function _loop() {
      var token = _step.value;

      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });

          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);

        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }

        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character


        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date


        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (parse_typeof(_ret) === "object") return _ret.v;
    } // Check if the remaining input contains something other than whitespace

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate/* default */.Z)(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.


  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};

  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;

      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return utcDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isMatch/index.js




/**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 *
 *
 * @param {String} dateString - the date string to verify
 * @param {String} formatString - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Boolean}
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */
function isMatch(dateString, formatString, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  return (0,isValid/* default */.Z)(parse(dateString, formatString, new Date(), options));
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isMonday/index.js


/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */

function isMonday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(date).getDay() === 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isPast/index.js


/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */

function isPast(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getTime() < Date.now();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfHour/index.js


/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameHour/index.js


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour (and same day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameWeek/index.js
var isSameWeek = __webpack_require__(3725);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameISOWeek/index.js


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */

function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  return (0,isSameWeek/* default */.Z)(dirtyDateLeft, dirtyDateRight, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameISOWeekYear/index.js


/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */

function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfYear = (0,startOfISOWeekYear/* default */.Z)(dirtyDateLeft);
  var dateRightStartOfYear = (0,startOfISOWeekYear/* default */.Z)(dirtyDateRight);
  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMinute/index.js
var isSameMinute = __webpack_require__(9952);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(9160);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameQuarter/index.js


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfSecond/index.js


/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */

function startOfSecond(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setMilliseconds(0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameSecond/index.js


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */

function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameYear/index.js
var isSameYear = __webpack_require__(792);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisHour/index.js


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */

function isThisHour(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return isSameHour(Date.now(), dirtyDate);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisISOWeek/index.js


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */

function isThisISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return isSameISOWeek(dirtyDate, Date.now());
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisMinute/index.js


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */

function isThisMinute(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameMinute/* default */.Z)(Date.now(), dirtyDate);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisMonth/index.js


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */

function isThisMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameMonth/* default */.Z)(Date.now(), dirtyDate);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisQuarter/index.js


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */

function isThisQuarter(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return isSameQuarter(Date.now(), dirtyDate);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisSecond/index.js


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */

function isThisSecond(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return isSameSecond(Date.now(), dirtyDate);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisWeek/index.js



/**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */
function isThisWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameWeek/* default */.Z)(dirtyDate, Date.now(), options);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisYear/index.js


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */

function isThisYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameYear/* default */.Z)(dirtyDate, Date.now());
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThursday/index.js


/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */

function isThursday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDay() === 4;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isToday/index.js


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */

function isToday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameDay/* default */.Z)(dirtyDate, Date.now());
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isTomorrow/index.js



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */

function isTomorrow(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameDay/* default */.Z)(dirtyDate, (0,addDays/* default */.Z)(Date.now(), 1));
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isTuesday/index.js


/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */

function isTuesday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDay() === 2;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isWednesday/index.js


/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */

function isWednesday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getDay() === 3;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isWithinInterval/index.js



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var time = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var startTime = (0,toDate/* default */.Z)(interval.start).getTime();
  var endTime = (0,toDate/* default */.Z)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(7069);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isYesterday/index.js



/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */

function isYesterday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameDay/* default */.Z)(dirtyDate, (0,subDays/* default */.Z)(Date.now(), 1));
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfDecade/index.js


/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */

function lastDayOfDecade(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfWeek/index.js




/**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */

function lastDayOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfISOWeek/index.js


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */

function lastDayOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return lastDayOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */

function lastDayOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = (0,startOfISOWeek/* default */.Z)(fourthOfJanuary);
  date.setDate(date.getDate() - 1);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfQuarter/index.js


/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of a quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */

function lastDayOfQuarter(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfYear/index.js


/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */

function lastDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var lightFormatters = __webpack_require__(5834);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/lightFormat/index.js





 // This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var lightFormat_formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var lightFormat_escapedStringRegExp = /^'([^]*?)'?$/;
var lightFormat_doubleQuoteRegExp = /''/g;
var lightFormat_unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */

function lightFormat(dirtyDate, formatStr) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var tokens = formatStr.match(lightFormat_formattingTokensRegExp); // The only case when formattingTokensRegExp doesn't match the string is when it's empty

  if (!tokens) return '';
  var result = tokens.map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return lightFormat_cleanEscapedString(substring);
    }

    var formatter = lightFormatters/* default */.Z[firstCharacter];

    if (formatter) {
      return formatter(utcDate, substring);
    }

    if (firstCharacter.match(lightFormat_unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function lightFormat_cleanEscapedString(input) {
  var matches = input.match(lightFormat_escapedStringRegExp);

  if (!matches) {
    return input;
  }

  return matches[1].replace(lightFormat_doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/milliseconds/index.js

// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
var daysInYear = 365.2425;
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */

function milliseconds(_ref) {
  var years = _ref.years,
      months = _ref.months,
      weeks = _ref.weeks,
      days = _ref.days,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var totalDays = 0;
  if (years) totalDays += years * daysInYear;
  if (months) totalDays += months * (daysInYear / 12);
  if (weeks) totalDays += weeks * 7;
  if (days) totalDays += days;
  var totalSeconds = totalDays * 24 * 60 * 60;
  if (hours) totalSeconds += hours * 60 * 60;
  if (minutes) totalSeconds += minutes * 60;
  if (seconds) totalSeconds += seconds;
  return Math.round(totalSeconds * 1000);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/millisecondsToHours/index.js


/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param {number} milliseconds - number of milliseconds to be converted
 *
 * @returns {number} the number of milliseconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */

function millisecondsToHours(milliseconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var hours = milliseconds / constants/* millisecondsInHour */.vh;
  return Math.floor(hours);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/millisecondsToMinutes/index.js


/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param {number} milliseconds - number of milliseconds to be converted.
 *
 * @returns {number} the number of milliseconds converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */

function millisecondsToMinutes(milliseconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var minutes = milliseconds / constants/* millisecondsInMinute */.yJ;
  return Math.floor(minutes);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/millisecondsToSeconds/index.js


/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param {number} milliseconds - number of milliseconds to be converted
 *
 * @returns {number} the number of milliseconds converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */

function millisecondsToSeconds(milliseconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var seconds = milliseconds / constants/* millisecondsInSecond */.qk;
  return Math.floor(seconds);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/minutesToHours/index.js


/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */

function minutesToHours(minutes) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var hours = minutes / constants/* minutesInHour */.fR;
  return Math.floor(hours);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/minutesToMilliseconds/index.js


/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */

function minutesToMilliseconds(minutes) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(minutes * constants/* millisecondsInMinute */.yJ);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/minutesToSeconds/index.js


/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param { number } minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */

function minutesToSeconds(minutes) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(minutes * constants/* secondsInMinute */.xx);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/monthsToQuarters/index.js


/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param {number} months - number of months to be converted.
 *
 * @returns {number} the number of months converted in quarters
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */

function monthsToQuarters(months) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var quarters = months / constants/* monthsInQuarter */.Ob;
  return Math.floor(quarters);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/monthsToYears/index.js


/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param {number} months - number of months to be converted
 *
 * @returns {number} the number of months converted in years
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */

function monthsToYears(months) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var years = months / constants/* monthsInYear */.CU;
  return Math.floor(years);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextDay/index.js



/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @param {Date | number} date - the date to check
 * @param {Day} day - day of the week
 * @returns {Date} - the date is the next day of week
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */

function nextDay(date, day) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var delta = day - getDay(date);
  if (delta <= 0) delta += 7;
  return (0,addDays/* default */.Z)(date, delta);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextFriday/index.js


/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */

function nextFriday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 5);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextMonday/index.js


/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */

function nextMonday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 1);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextSaturday/index.js


/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */

function nextSaturday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 6);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextSunday/index.js


/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */

function nextSunday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 0);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextThursday/index.js


/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */

function nextThursday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 4);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextTuesday/index.js


/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */

function nextTuesday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 2);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/nextWednesday/index.js


/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */

function nextWednesday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return nextDay(date, 3);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(3855);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parseJSON/index.js


/**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate]{@link https://date-fns.org/docs/toDate}:
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 */

function parseJSON(argument) {
  (0,requiredArgs/* default */.Z)(1, arguments);

  if (typeof argument === 'string') {
    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);

    if (parts) {
      // Group 8 matches the sign
      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
    }

    return new Date(NaN);
  }

  return (0,toDate/* default */.Z)(argument);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousDay/index.js




/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @param {Date | number} date - the date to check
 * @param {number} day - day of the week
 * @returns {Date} - the date is the previous day of week
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */
function previousDay(date, day) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var delta = getDay(date) - day;
  if (delta <= 0) delta += 7;
  return (0,subDays/* default */.Z)(date, delta);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousFriday/index.js


/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */

function previousFriday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 5);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousMonday/index.js


/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */

function previousMonday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 1);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousSaturday/index.js


/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */

function previousSaturday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 6);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousSunday/index.js


/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */

function previousSunday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 0);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousThursday/index.js


/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */

function previousThursday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 4);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousTuesday/index.js


/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */

function previousTuesday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 2);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/previousWednesday/index.js


/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */

function previousWednesday(date) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return previousDay(date, 3);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/quartersToMonths/index.js


/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @param {number} quarters - number of quarters to be converted
 *
 * @returns {number} the number of quarters converted in months
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */

function quartersToMonths(quarters) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(quarters * constants/* monthsInQuarter */.Ob);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/quartersToYears/index.js


/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @param {number} quarters - number of quarters to be converted
 *
 * @returns {number} the number of quarters converted in years
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */

function quartersToYears(quarters) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var years = quarters / constants/* quartersInYear */._j;
  return Math.floor(years);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/roundToNearestMinutes/index.js



/**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @param {Date|Number} date - the date to round
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Date} the new date rounded to the closest minute
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
 * //=> Thu Jul 10 2014 12:15:00
 */

function roundToNearestMinutes(dirtyDate, options) {
  var _options$nearestTo;

  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only none provided present');
  }

  var nearestTo = (0,toInteger/* default */.Z)((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);

  if (nearestTo < 1 || nearestTo > 30) {
    throw new RangeError('`options.nearestTo` must be between 1 and 30');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case

  var minutes = date.getMinutes() + seconds / 60;
  var roundingMethod = (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod);
  var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
  var remainderMinutes = minutes % nearestTo;
  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/secondsToHours/index.js


/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */

function secondsToHours(seconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var hours = seconds / constants/* secondsInHour */.R3;
  return Math.floor(hours);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/secondsToMilliseconds/index.js


/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */

function secondsToMilliseconds(seconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return seconds * constants/* millisecondsInSecond */.qk;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/secondsToMinutes/index.js


/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */

function secondsToMinutes(seconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var minutes = seconds / constants/* secondsInMinute */.xx;
  return Math.floor(minutes);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/set/index.js
var set = __webpack_require__(2311);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setDate/index.js



/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */

function setDate(dirtyDate, dirtyDayOfMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dayOfMonth = (0,toInteger/* default */.Z)(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setDay/index.js





/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */

function setDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var delta = 7 - weekStartsOn;
  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return (0,addDays/* default */.Z)(date, diff);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setDayOfYear/index.js



/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */

function setDayOfYear(dirtyDate, dirtyDayOfYear) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dayOfYear = (0,toInteger/* default */.Z)(dirtyDayOfYear);
  date.setMonth(0);
  date.setDate(dayOfYear);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setDefaultOptions/index.js


/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param {Object} newOptions - an object with options.
 * @param {Locale} [newOptions.locale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [newOptions.weekStartsOn] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [newOptions.firstWeekContainsDate] - the day of January, which is always in the first week of the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */

function setDefaultOptions(newOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var result = {};
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();

  for (var property in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
      ;
      result[property] = defaultOptions[property];
    }
  }

  for (var _property in newOptions) {
    if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
      if (newOptions[_property] === undefined) {
        delete result[_property];
      } else {
        ;
        result[_property] = newOptions[_property];
      }
    }
  }

  (0,_lib_defaultOptions/* setDefaultOptions */.b)(result);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setHours/index.js



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var hours = (0,toInteger/* default */.Z)(dirtyHours);
  date.setHours(hours);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setISODay/index.js
var setISODay = __webpack_require__(927);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setISOWeek/index.js
var setISOWeek = __webpack_require__(4515);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMilliseconds/index.js



/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */

function setMilliseconds(dirtyDate, dirtyMilliseconds) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var milliseconds = (0,toInteger/* default */.Z)(dirtyMilliseconds);
  date.setMilliseconds(milliseconds);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMinutes/index.js



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var minutes = (0,toInteger/* default */.Z)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setMonth/index.js
var setMonth = __webpack_require__(6623);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setQuarter/index.js




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var quarter = (0,toInteger/* default */.Z)(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return (0,setMonth/* default */.Z)(date, date.getMonth() + diff * 3);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setSeconds/index.js



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var seconds = (0,toInteger/* default */.Z)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setWeek/index.js




/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} week - the week of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */

function setWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = getWeek(date, options) - week;
  date.setDate(date.getDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setWeekYear/index.js






/**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} weekYear - the local week-numbering year of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week-numbering year set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */

function setWeekYear(dirtyDate, dirtyWeekYear, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var weekYear = (0,toInteger/* default */.Z)(dirtyWeekYear);
  var diff = (0,differenceInCalendarDays/* default */.Z)(date, startOfWeekYear(date, options));
  var firstWeek = new Date(0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  date = startOfWeekYear(firstWeek, options);
  date.setDate(date.getDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = (0,toInteger/* default */.Z)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(9119);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfDecade/index.js


/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */

function startOfDecade(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  date.setFullYear(decade, 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfToday/index.js

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */

function startOfToday() {
  return (0,startOfDay/* default */.Z)(Date.now());
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfTomorrow/index.js
/**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfYesterday/index.js
/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js
var sub = __webpack_require__(734);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subBusinessDays/index.js



/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the business days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */

function subBusinessDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addBusinessDays(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subHours/index.js



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addHours(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMinutes/index.js



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMinutes(dirtyDate, -amount);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMonths/index.js
var subMonths = __webpack_require__(4559);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subQuarters/index.js



/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */

function subQuarters(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subSeconds/index.js



/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */

function subSeconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addSeconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subWeeks/index.js



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subYears/index.js



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addYears/* default */.Z)(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/weeksToDays/index.js


/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param {number} weeks - number of weeks to be converted
 *
 * @returns {number} the number of weeks converted in days
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */

function weeksToDays(weeks) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(weeks * constants/* daysInWeek */.ju);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/yearsToMonths/index.js


/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param {number} years - number of years to be converted
 *
 * @returns {number} the number of years converted in months
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */

function yearsToMonths(years) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(years * constants/* monthsInYear */.CU);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/yearsToQuarters/index.js


/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param {number} years - number of years to be converted
 *
 * @returns {number} the number of years converted in quarters
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */

function yearsToQuarters(years) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(years * constants/* quartersInYear */._j);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/index.js
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

















































































































































































































































/***/ }),

/***/ 2699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isAfter)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isBefore)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),

/***/ 1381:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isDate)
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ 6843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isEqual)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyLeftDate);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),

/***/ 6491:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isLeapYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */

function isLeapYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

/***/ }),

/***/ 3151:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isSameDay)
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 9952:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isSameMinute)
/* harmony export */ });
/* harmony import */ var _startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8717);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */

function isSameMinute(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfMinute = (0,_startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRightStartOfMinute = (0,_startOfMinute_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}

/***/ }),

/***/ 9160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isSameMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 3725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isSameWeek)
/* harmony export */ });
/* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(584);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week (and month and year)
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfWeek = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft, options);
  var dateRightStartOfWeek = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

/***/ }),

/***/ 792:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isSameYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),

/***/ 2274:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isValid)
/* harmony export */ });
/* harmony import */ var _isDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1381);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);

  if (!(0,_isDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 3855:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ parseISO)
/* harmony export */ });
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6948);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 2311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ set)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6623);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }






/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set(dirtyDate, values) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);

  if (_typeof(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  if (values.year != null) {
    date.setFullYear(values.year);
  }

  if (values.month != null) {
    date = (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, values.month);
  }

  if (values.date != null) {
    date.setDate((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(values.date));
  }

  if (values.hours != null) {
    date.setHours((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(values.hours));
  }

  if (values.minutes != null) {
    date.setMinutes((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(values.minutes));
  }

  if (values.seconds != null) {
    date.setSeconds((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(values.seconds));
  }

  if (values.milliseconds != null) {
    date.setMilliseconds((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(values.milliseconds));
  }

  return date;
}

/***/ }),

/***/ 927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ setISODay)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7349);
/* harmony import */ var _getISODay_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4500);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);





/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */

function setISODay(dirtyDate, dirtyDay) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDay);
  var currentDay = (0,_getISODay_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date);
  var diff = day - currentDay;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(date, diff);
}

/***/ }),

/***/ 4515:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ setISOWeek)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _getISOWeek_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(911);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);




/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */

function setISOWeek(dirtyDate, dirtyISOWeek) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var isoWeek = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyISOWeek);
  var diff = (0,_getISOWeek_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date) - isoWeek;
  date.setDate(date.getDate() - diff * 7);
  return date;
}

/***/ }),

/***/ 6623:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ setMonth)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(890);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var month = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = (0,_getDaysInMonth_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),

/***/ 9119:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfDay)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 6573:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfISOWeek)
/* harmony export */ });
/* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(584);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate, {
    weekStartsOn: 1
  });
}

/***/ }),

/***/ 546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfISOWeekYear)
/* harmony export */ });
/* harmony import */ var _getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5425);
/* harmony import */ var _startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6573);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var year = (0,_getISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = (0,_startOfISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuary);
  return date;
}

/***/ }),

/***/ 8717:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfMinute)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */

function startOfMinute(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setSeconds(0, 0);
  return date;
}

/***/ }),

/***/ 3703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfMonth)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 584:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4314);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 8148:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ startOfYear)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var cleanDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 734:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ sub)
/* harmony export */ });
/* harmony import */ var _subDays_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7069);
/* harmony import */ var _subMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4559);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */

function sub(date, duration) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  if (!duration || _typeof(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.years) : 0;
  var months = duration.months ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.weeks) : 0;
  var days = duration.days ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.days) : 0;
  var hours = duration.hours ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.seconds) : 0; // Subtract years and months

  var dateWithoutMonths = (0,_subMonths_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, months + years * 12); // Subtract weeks and days

  var dateWithoutDays = (0,_subDays_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds

  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}

/***/ }),

/***/ 7069:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ subDays)
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 1218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ subMilliseconds)
/* harmony export */ });
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 4559:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ subMonths)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 9013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ toDate)
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 296:
/***/ ((module) => {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),

/***/ 2988:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var QueryHandler = __webpack_require__(1755);
var each = (__webpack_require__(6665).each);

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 9964:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MediaQuery = __webpack_require__(2988);
var Util = __webpack_require__(6665);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 1755:
/***/ ((module) => {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 6665:
/***/ ((module) => {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 4974:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MediaQueryDispatch = __webpack_require__(9964);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 3162:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g?__webpack_require__.g:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g, true&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map

/***/ }),

/***/ 7648:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 8612:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(7648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1405)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(8612);
var hasOwn = __webpack_require__(7642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 1405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(5419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 5419:
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 7642:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(8612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 8679:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 2445:
/***/ (() => {

"inert"in HTMLElement.prototype||(Object.defineProperty(HTMLElement.prototype,"inert",{enumerable:!0,get:function(){return this.hasAttribute("inert")},set:function(h){h?this.setAttribute("inert",""):this.removeAttribute("inert")}}),window.addEventListener("load",function(){function h(a){var b=null;try{b=new KeyboardEvent("keydown",{keyCode:9,which:9,key:"Tab",code:"Tab",keyIdentifier:"U+0009",shiftKey:!!a,bubbles:!0})}catch(g){try{b=document.createEvent("KeyboardEvent"),b.initKeyboardEvent("keydown",
!0,!0,window,"Tab",0,a?"Shift":"",!1,"en")}catch(d){}}if(b){try{Object.defineProperty(b,"keyCode",{value:9})}catch(g){}document.dispatchEvent(b)}}function k(a){for(;a&&a!==document.documentElement;){if(a.hasAttribute("inert"))return a;a=a.parentElement}return null}function e(a){var b=a.path;return b&&b[0]||a.target}function l(a){a.path[a.path.length-1]!==window&&(m(e(a)),a.preventDefault(),a.stopPropagation())}function m(a){var b=k(a);if(b){if(document.hasFocus()&&0!==f){var g=(c||document).activeElement;
h(0>f?!0:!1);if(g!=(c||document).activeElement)return;var d=document.createTreeWalker(document.body,NodeFilter.SHOW_ELEMENT,{acceptNode:function(a){return!a||!a.focus||0>a.tabIndex?NodeFilter.FILTER_SKIP:b.contains(a)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT}});d.currentNode=b;d=(-1===Math.sign(f)?d.previousNode:d.nextNode).bind(d);for(var e;e=d();)if(e.focus(),(c||document).activeElement!==g)return}a.blur()}}(function(a){var b=document.createElement("style");b.type="text/css";b.styleSheet?
b.styleSheet.cssText=a:b.appendChild(document.createTextNode(a));document.body.appendChild(b)})("/*[inert]*/*[inert]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}");var n=function(a){return null};window.ShadowRoot&&(n=function(a){for(;a&&a!==document.documentElement;){if(a instanceof window.ShadowRoot)return a;a=a.parentNode}return null});var f=0;document.addEventListener("keydown",function(a){f=9===a.keyCode?a.shiftKey?-1:1:0});document.addEventListener("mousedown",
function(a){f=0});var c=null;document.body.addEventListener("focus",function(a){var b=e(a);a=b==a.target?null:n(b);if(a!=c){if(c){if(!(c instanceof window.ShadowRoot))throw Error("not shadow root: "+c);c.removeEventListener("focusin",l,!0)}a&&a.addEventListener("focusin",l,!0);c=a}m(b)},!0);document.addEventListener("click",function(a){var b=e(a);k(b)&&(a.preventDefault(),a.stopPropagation())},!0)}));


/***/ }),

/***/ 6337:
/***/ (() => {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detachEvent == 'function') {
    node.detachEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),

/***/ 973:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var camel2hyphen = __webpack_require__(1169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 7090:
/***/ ((module) => {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ 1296:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(4654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 2703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 5798:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(8261);
var parse = __webpack_require__(5235);
var formats = __webpack_require__(5798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 5235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(2769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 8261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(7478);
var utils = __webpack_require__(2769);
var formats = __webpack_require__(5798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (commaRoundTrip && isArray(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 2769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(5798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 9921:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 1852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(8156));
	else {}
})(this, (__WEBPACK_EXTERNAL_MODULE_react__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/css-mediaquery/index.js":
/*!**********************************************!*\
  !*** ./node_modules/css-mediaquery/index.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/



exports.match = matchQuery;
exports.parse = parseQuery;

// -----------------------------------------------------------------------------

var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;

function matchQuery(mediaQuery, values) {
    return parseQuery(mediaQuery).some(function (query) {
        var inverse = query.inverse;

        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;

        // Quit early when `type` doesn't match, but take "not" into account.
        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
            return false;
        }

        var expressionsMatch = query.expressions.every(function (expression) {
            var feature  = expression.feature,
                modifier = expression.modifier,
                expValue = expression.value,
                value    = values[feature];

            // Missing or falsy values don't match.
            if (!value) { return false; }

            switch (feature) {
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();

                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = toPx(expValue);
                    value    = toPx(value);
                    break;

                case 'resolution':
                    expValue = toDpi(expValue);
                    value    = toDpi(value);
                    break;

                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */ 'device-pixel-ratio':
                    expValue = toDecimal(expValue);
                    value    = toDecimal(value);
                    break;

                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value    = parseInt(value, 10) || 0;
                    break;
            }

            switch (modifier) {
                case 'min': return value >= expValue;
                case 'max': return value <= expValue;
                default   : return value === expValue;
            }
        });

        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
    });
}

function parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function (query) {
        query = query.trim();

        var captures    = query.match(RE_MEDIA_QUERY),
            modifier    = captures[1],
            type        = captures[2],
            expressions = captures[3] || '',
            parsed      = {};

        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type    = type ? type.toLowerCase() : 'all';

        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];

        parsed.expressions = expressions.map(function (expression) {
            var captures = expression.match(RE_MQ_EXPRESSION),
                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);

            return {
                modifier: feature[1],
                feature : feature[2],
                value   : captures[2]
            };
        });

        return parsed;
    });
}

// -- Utilities ----------------------------------------------------------------

function toDecimal(ratio) {
    var decimal = Number(ratio),
        numbers;

    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }

    return decimal;
}

function toDpi(resolution) {
    var value = parseFloat(resolution),
        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];

    switch (units) {
        case 'dpcm': return value / 2.54;
        case 'dppx': return value * 96;
        default    : return value;
    }
}

function toPx(length) {
    var value = parseFloat(length),
        units = String(length).match(RE_LENGTH_UNIT)[1];

    switch (units) {
        case 'em' : return value * 16;
        case 'rem': return value * 16;
        case 'cm' : return value * 96 / 2.54;
        case 'mm' : return value * 96 / 2.54 / 10;
        case 'in' : return value * 96;
        case 'pt' : return value * 72;
        case 'pc' : return value * 72 / 12;
        default   : return value;
    }
}


/***/ }),

/***/ "./node_modules/hyphenate-style-name/index.js":
/*!****************************************************!*\
  !*** ./node_modules/hyphenate-style-name/index.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __nested_webpack_require_6053__) => {

"use strict";
__nested_webpack_require_6053__.r(__webpack_exports__);
/* harmony export */ __nested_webpack_require_6053__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (hyphenateStyleName);


/***/ }),

/***/ "./node_modules/matchmediaquery/index.js":
/*!***********************************************!*\
  !*** ./node_modules/matchmediaquery/index.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_7064__) => {

"use strict";


var staticMatch = (__nested_webpack_require_7064__(/*! css-mediaquery */ "./node_modules/css-mediaquery/index.js").match);
var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;

// our fake MediaQueryList
function Mql(query, values, forceStatic){
  var self = this;
  if(dynamicMatch && !forceStatic){
    var mql = dynamicMatch.call(window, query);
    this.matches = mql.matches;
    this.media = mql.media;
    // TODO: is there a time it makes sense to remove this listener?
    mql.addListener(update);
  } else {
    this.matches = staticMatch(query, values);
    this.media = query;
  }

  this.addListener = addListener;
  this.removeListener = removeListener;
  this.dispose = dispose;

  function addListener(listener){
    if(mql){
      mql.addListener(listener);
    }
  }

  function removeListener(listener){
    if(mql){
      mql.removeListener(listener);
    }
  }

  // update ourselves!
  function update(evt){
    self.matches = evt.matches;
    self.media = evt.media;
  }

  function dispose(){
    if(mql){
      mql.removeListener(update);
    }
  }
}

function matchMedia(query, values, forceStatic){
  return new Mql(query, values, forceStatic);
}

module.exports = matchMedia;


/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "./node_modules/prop-types/checkPropTypes.js":
/*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_10944__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (true) {
  var ReactPropTypesSecret = __nested_webpack_require_10944__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
  var loggedTypeFailures = {};
  var has = __nested_webpack_require_10944__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (true) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),

/***/ "./node_modules/prop-types/factoryWithTypeCheckers.js":
/*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_15184__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __nested_webpack_require_15184__(/*! react-is */ "./node_modules/react-is/index.js");
var assign = __nested_webpack_require_15184__(/*! object-assign */ "./node_modules/object-assign/index.js");

var ReactPropTypesSecret = __nested_webpack_require_15184__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
var has = __nested_webpack_require_15184__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
var checkPropTypes = __nested_webpack_require_15184__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");

var printWarning = function() {};

if (true) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (  true && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (true) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
        true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_38303__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (true) {
  var ReactIs = __nested_webpack_require_38303__(/*! react-is */ "./node_modules/react-is/index.js");

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __nested_webpack_require_38303__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
} else {}


/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/prop-types/lib/has.js":
/*!********************************************!*\
  !*** ./node_modules/prop-types/lib/has.js ***!
  \********************************************/
/***/ ((module) => {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.development.js":
/*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (true) {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),

/***/ "./node_modules/react-is/index.js":
/*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_47361__) => {

"use strict";


if (false) {} else {
  module.exports = __nested_webpack_require_47361__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
}


/***/ }),

/***/ "./node_modules/shallow-equal/dist/index.esm.js":
/*!******************************************************!*\
  !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __nested_webpack_require_47861__) => {

"use strict";
__nested_webpack_require_47861__.r(__webpack_exports__);
/* harmony export */ __nested_webpack_require_47861__.d(__webpack_exports__, {
/* harmony export */   "shallowEqualArrays": () => (/* binding */ shallowEqualArrays),
/* harmony export */   "shallowEqualObjects": () => (/* binding */ shallowEqualObjects)
/* harmony export */ });
function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }

  return true;
}

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}




/***/ }),

/***/ "./src/Component.ts":
/*!**************************!*\
  !*** ./src/Component.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_49201__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var useMediaQuery_1 = __importDefault(__nested_webpack_require_49201__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
// ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
var MediaQuery = function (_a) {
    var children = _a.children, device = _a.device, onChange = _a.onChange, settings = __rest(_a, ["children", "device", "onChange"]);
    var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
    if (typeof children === 'function') {
        return children(matches);
    }
    return matches ? children : null;
};
exports["default"] = MediaQuery;


/***/ }),

/***/ "./src/Context.ts":
/*!************************!*\
  !*** ./src/Context.ts ***!
  \************************/
/***/ ((__unused_webpack_module, exports, __nested_webpack_require_50747__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __nested_webpack_require_50747__(/*! react */ "react");
var Context = (0, react_1.createContext)(undefined);
exports["default"] = Context;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_51164__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
var useMediaQuery_1 = __importDefault(__nested_webpack_require_51164__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
exports.useMediaQuery = useMediaQuery_1.default;
var Component_1 = __importDefault(__nested_webpack_require_51164__(/*! ./Component */ "./src/Component.ts"));
exports["default"] = Component_1.default;
var toQuery_1 = __importDefault(__nested_webpack_require_51164__(/*! ./toQuery */ "./src/toQuery.ts"));
exports.toQuery = toQuery_1.default;
var Context_1 = __importDefault(__nested_webpack_require_51164__(/*! ./Context */ "./src/Context.ts"));
exports.Context = Context_1.default;


/***/ }),

/***/ "./src/mediaQuery.ts":
/*!***************************!*\
  !*** ./src/mediaQuery.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_52239__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var prop_types_1 = __importDefault(__nested_webpack_require_52239__(/*! prop-types */ "./node_modules/prop-types/index.js"));
var stringOrNumber = prop_types_1.default.oneOfType([
    prop_types_1.default.string,
    prop_types_1.default.number
]);
// media types
var types = {
    all: prop_types_1.default.bool,
    grid: prop_types_1.default.bool,
    aural: prop_types_1.default.bool,
    braille: prop_types_1.default.bool,
    handheld: prop_types_1.default.bool,
    print: prop_types_1.default.bool,
    projection: prop_types_1.default.bool,
    screen: prop_types_1.default.bool,
    tty: prop_types_1.default.bool,
    tv: prop_types_1.default.bool,
    embossed: prop_types_1.default.bool
};
// properties that match media queries
var matchers = {
    orientation: prop_types_1.default.oneOf([
        'portrait',
        'landscape'
    ]),
    scan: prop_types_1.default.oneOf([
        'progressive',
        'interlace'
    ]),
    aspectRatio: prop_types_1.default.string,
    deviceAspectRatio: prop_types_1.default.string,
    height: stringOrNumber,
    deviceHeight: stringOrNumber,
    width: stringOrNumber,
    deviceWidth: stringOrNumber,
    color: prop_types_1.default.bool,
    colorIndex: prop_types_1.default.bool,
    monochrome: prop_types_1.default.bool,
    resolution: stringOrNumber,
    type: Object.keys(types)
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var type = matchers.type, featureMatchers = __rest(matchers
// media features
, ["type"]);
// media features
var features = __assign({ minAspectRatio: prop_types_1.default.string, maxAspectRatio: prop_types_1.default.string, minDeviceAspectRatio: prop_types_1.default.string, maxDeviceAspectRatio: prop_types_1.default.string, minHeight: stringOrNumber, maxHeight: stringOrNumber, minDeviceHeight: stringOrNumber, maxDeviceHeight: stringOrNumber, minWidth: stringOrNumber, maxWidth: stringOrNumber, minDeviceWidth: stringOrNumber, maxDeviceWidth: stringOrNumber, minColor: prop_types_1.default.number, maxColor: prop_types_1.default.number, minColorIndex: prop_types_1.default.number, maxColorIndex: prop_types_1.default.number, minMonochrome: prop_types_1.default.number, maxMonochrome: prop_types_1.default.number, minResolution: stringOrNumber, maxResolution: stringOrNumber }, featureMatchers);
var all = __assign(__assign({}, types), features);
exports["default"] = {
    all: all,
    types: types,
    matchers: matchers,
    features: features
};


/***/ }),

/***/ "./src/toQuery.ts":
/*!************************!*\
  !*** ./src/toQuery.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_55990__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var hyphenate_style_name_1 = __importDefault(__nested_webpack_require_55990__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
var mediaQuery_1 = __importDefault(__nested_webpack_require_55990__(/*! ./mediaQuery */ "./src/mediaQuery.ts"));
var negate = function (cond) { return "not ".concat(cond); };
var keyVal = function (k, v) {
    var realKey = (0, hyphenate_style_name_1.default)(k);
    // px shorthand
    if (typeof v === 'number') {
        v = "".concat(v, "px");
    }
    if (v === true) {
        return realKey;
    }
    if (v === false) {
        return negate(realKey);
    }
    return "(".concat(realKey, ": ").concat(v, ")");
};
var join = function (conds) { return conds.join(' and '); };
var toQuery = function (obj) {
    var rules = [];
    Object.keys(mediaQuery_1.default.all).forEach(function (k) {
        var v = obj[k];
        if (v != null) {
            rules.push(keyVal(k, v));
        }
    });
    return join(rules);
};
exports["default"] = toQuery;


/***/ }),

/***/ "./src/useMediaQuery.ts":
/*!******************************!*\
  !*** ./src/useMediaQuery.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_57428__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __nested_webpack_require_57428__(/*! react */ "react");
var matchmediaquery_1 = __importDefault(__nested_webpack_require_57428__(/*! matchmediaquery */ "./node_modules/matchmediaquery/index.js"));
var hyphenate_style_name_1 = __importDefault(__nested_webpack_require_57428__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
var shallow_equal_1 = __nested_webpack_require_57428__(/*! shallow-equal */ "./node_modules/shallow-equal/dist/index.esm.js");
var toQuery_1 = __importDefault(__nested_webpack_require_57428__(/*! ./toQuery */ "./src/toQuery.ts"));
var Context_1 = __importDefault(__nested_webpack_require_57428__(/*! ./Context */ "./src/Context.ts"));
var makeQuery = function (settings) { return settings.query || (0, toQuery_1.default)(settings); };
var hyphenateKeys = function (obj) {
    if (!obj)
        return undefined;
    var keys = Object.keys(obj);
    return keys.reduce(function (result, key) {
        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
        return result;
    }, {});
};
var useIsUpdate = function () {
    var ref = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        ref.current = true;
    }, []);
    return ref.current;
};
var useDevice = function (deviceFromProps) {
    var deviceFromContext = (0, react_1.useContext)(Context_1.default);
    var getDevice = function () {
        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
    };
    var _a = (0, react_1.useState)(getDevice), device = _a[0], setDevice = _a[1];
    (0, react_1.useEffect)(function () {
        var newDevice = getDevice();
        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) {
            setDevice(newDevice);
        }
    }, [deviceFromProps, deviceFromContext]);
    return device;
};
var useQuery = function (settings) {
    var getQuery = function () { return makeQuery(settings); };
    var _a = (0, react_1.useState)(getQuery), query = _a[0], setQuery = _a[1];
    (0, react_1.useEffect)(function () {
        var newQuery = getQuery();
        if (query !== newQuery) {
            setQuery(newQuery);
        }
    }, [settings]);
    return query;
};
var useMatchMedia = function (query, device) {
    var getMatchMedia = function () { return (0, matchmediaquery_1.default)(query, device || {}, !!device); };
    var _a = (0, react_1.useState)(getMatchMedia), mq = _a[0], setMq = _a[1];
    var isUpdate = useIsUpdate();
    (0, react_1.useEffect)(function () {
        if (isUpdate) {
            // skip on mounting, it has already been set
            var newMq_1 = getMatchMedia();
            setMq(newMq_1);
            return function () {
                if (newMq_1) {
                    newMq_1.dispose();
                }
            };
        }
    }, [query, device]);
    return mq;
};
var useMatches = function (mediaQuery) {
    var _a = (0, react_1.useState)(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
    (0, react_1.useEffect)(function () {
        var updateMatches = function (ev) {
            setMatches(ev.matches);
        };
        mediaQuery.addListener(updateMatches);
        setMatches(mediaQuery.matches);
        return function () {
            mediaQuery.removeListener(updateMatches);
        };
    }, [mediaQuery]);
    return matches;
};
var useMediaQuery = function (settings, device, onChange) {
    var deviceSettings = useDevice(device);
    var query = useQuery(settings);
    if (!query)
        throw new Error('Invalid or missing MediaQuery!');
    var mq = useMatchMedia(query, deviceSettings);
    var matches = useMatches(mq);
    var isUpdate = useIsUpdate();
    (0, react_1.useEffect)(function () {
        if (isUpdate && onChange) {
            onChange(matches);
        }
    }, [matches]);
    (0, react_1.useEffect)(function () { return function () {
        if (mq) {
            mq.dispose();
        }
    }; }, []);
    return matches;
};
exports["default"] = useMediaQuery;


/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_62230__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_62230__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_62230__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_62230__.o(definition, key) && !__nested_webpack_require_62230__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_62230__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_62230__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __nested_webpack_require_62230__("./src/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 9655:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AbortedDeferredError": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.X3),
/* harmony export */   "Await": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.Await),
/* harmony export */   "BrowserRouter": () => (/* binding */ BrowserRouter),
/* harmony export */   "Form": () => (/* binding */ Form),
/* harmony export */   "HashRouter": () => (/* binding */ HashRouter),
/* harmony export */   "Link": () => (/* binding */ Link),
/* harmony export */   "MemoryRouter": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.MemoryRouter),
/* harmony export */   "NavLink": () => (/* binding */ NavLink),
/* harmony export */   "Navigate": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.Navigate),
/* harmony export */   "NavigationType": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.aU),
/* harmony export */   "Outlet": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.Outlet),
/* harmony export */   "Route": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.Route),
/* harmony export */   "Router": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.Router),
/* harmony export */   "RouterProvider": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.RouterProvider),
/* harmony export */   "Routes": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.Routes),
/* harmony export */   "ScrollRestoration": () => (/* binding */ ScrollRestoration),
/* harmony export */   "UNSAFE_DataRouterContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterContext),
/* harmony export */   "UNSAFE_DataRouterStateContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterStateContext),
/* harmony export */   "UNSAFE_DataStaticRouterContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataStaticRouterContext),
/* harmony export */   "UNSAFE_LocationContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_LocationContext),
/* harmony export */   "UNSAFE_NavigationContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_NavigationContext),
/* harmony export */   "UNSAFE_RouteContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_RouteContext),
/* harmony export */   "UNSAFE_enhanceManualRouteObjects": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_enhanceManualRouteObjects),
/* harmony export */   "createBrowserRouter": () => (/* binding */ createBrowserRouter),
/* harmony export */   "createHashRouter": () => (/* binding */ createHashRouter),
/* harmony export */   "createMemoryRouter": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.createMemoryRouter),
/* harmony export */   "createPath": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.Ep),
/* harmony export */   "createRoutesFromChildren": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.createRoutesFromChildren),
/* harmony export */   "createRoutesFromElements": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.createRoutesFromElements),
/* harmony export */   "createSearchParams": () => (/* binding */ createSearchParams),
/* harmony export */   "defer": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.PQ),
/* harmony export */   "generatePath": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.Gn),
/* harmony export */   "isRouteErrorResponse": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.WK),
/* harmony export */   "json": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.AV),
/* harmony export */   "matchPath": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.LX),
/* harmony export */   "matchRoutes": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.fp),
/* harmony export */   "parsePath": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.cP),
/* harmony export */   "redirect": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.uX),
/* harmony export */   "renderMatches": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.renderMatches),
/* harmony export */   "resolvePath": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_1__.i3),
/* harmony export */   "unstable_HistoryRouter": () => (/* binding */ HistoryRouter),
/* harmony export */   "useActionData": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useActionData),
/* harmony export */   "useAsyncError": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useAsyncError),
/* harmony export */   "useAsyncValue": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useAsyncValue),
/* harmony export */   "useFetcher": () => (/* binding */ useFetcher),
/* harmony export */   "useFetchers": () => (/* binding */ useFetchers),
/* harmony export */   "useFormAction": () => (/* binding */ useFormAction),
/* harmony export */   "useHref": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useHref),
/* harmony export */   "useInRouterContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useInRouterContext),
/* harmony export */   "useLinkClickHandler": () => (/* binding */ useLinkClickHandler),
/* harmony export */   "useLoaderData": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useLoaderData),
/* harmony export */   "useLocation": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useLocation),
/* harmony export */   "useMatch": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useMatch),
/* harmony export */   "useMatches": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useMatches),
/* harmony export */   "useNavigate": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useNavigate),
/* harmony export */   "useNavigation": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useNavigation),
/* harmony export */   "useNavigationType": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useNavigationType),
/* harmony export */   "useOutlet": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useOutlet),
/* harmony export */   "useOutletContext": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useOutletContext),
/* harmony export */   "useParams": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useParams),
/* harmony export */   "useResolvedPath": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useResolvedPath),
/* harmony export */   "useRevalidator": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useRevalidator),
/* harmony export */   "useRouteError": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useRouteError),
/* harmony export */   "useRouteLoaderData": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useRouteLoaderData),
/* harmony export */   "useRoutes": () => (/* reexport safe */ react_router__WEBPACK_IMPORTED_MODULE_2__.useRoutes),
/* harmony export */   "useSearchParams": () => (/* binding */ useSearchParams),
/* harmony export */   "useSubmit": () => (/* binding */ useSubmit)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9250);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2599);
/**
 * React Router DOM v6.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */





function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
  return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function shouldProcessLinkClick(event, target) {
  return event.button === 0 && ( // Ignore everything but left clicks
  !target || target === "_self") && // Let browser handle "target=_blank" etc.
  !isModifiedEvent(event) // Ignore clicks with modifier keys
  ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */

function createSearchParams(init) {
  if (init === void 0) {
    init = "";
  }

  return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key) => {
    let value = init[key];
    return memo.concat(Array.isArray(value) ? value.map(v => [key, v]) : [[key, value]]);
  }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
  let searchParams = createSearchParams(locationSearch);

  for (let key of defaultSearchParams.keys()) {
    if (!searchParams.has(key)) {
      defaultSearchParams.getAll(key).forEach(value => {
        searchParams.append(key, value);
      });
    }
  }

  return searchParams;
}
function getFormSubmissionInfo(target, defaultAction, options) {
  let method;
  let action;
  let encType;
  let formData;

  if (isFormElement(target)) {
    let submissionTrigger = options.submissionTrigger;
    method = options.method || target.getAttribute("method") || defaultMethod;
    action = options.action || target.getAttribute("action") || defaultAction;
    encType = options.encType || target.getAttribute("enctype") || defaultEncType;
    formData = new FormData(target);

    if (submissionTrigger && submissionTrigger.name) {
      formData.append(submissionTrigger.name, submissionTrigger.value);
    }
  } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
    let form = target.form;

    if (form == null) {
      throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
    } // <button>/<input type="submit"> may override attributes of <form>


    method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
    action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
    encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || defaultEncType;
    formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
    // matches an existing input name

    if (target.name) {
      formData.append(target.name, target.value);
    }
  } else if (isHtmlElement(target)) {
    throw new Error("Cannot submit element that is not <form>, <button>, or " + "<input type=\"submit|image\">");
  } else {
    method = options.method || defaultMethod;
    action = options.action || defaultAction;
    encType = options.encType || defaultEncType;

    if (target instanceof FormData) {
      formData = target;
    } else {
      formData = new FormData();

      if (target instanceof URLSearchParams) {
        for (let [name, value] of target) {
          formData.append(name, value);
        }
      } else if (target != null) {
        for (let name of Object.keys(target)) {
          formData.append(name, target[name]);
        }
      }
    }
  }

  let {
    protocol,
    host
  } = window.location;
  let url = new URL(action, protocol + "//" + host);
  return {
    url,
    method,
    encType,
    formData
  };
}

const _excluded = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset"],
      _excluded2 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "children"],
      _excluded3 = ["reloadDocument", "replace", "method", "action", "onSubmit", "fetcherKey", "routeId", "relative"];
//#region Routers
////////////////////////////////////////////////////////////////////////////////

function createBrowserRouter(routes, opts) {
  var _window;

  return (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createRouter */ .p7)({
    basename: opts == null ? void 0 : opts.basename,
    history: (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createBrowserHistory */ .lX)({
      window: opts == null ? void 0 : opts.window
    }),
    hydrationData: (opts == null ? void 0 : opts.hydrationData) || ((_window = window) == null ? void 0 : _window.__staticRouterHydrationData),
    routes: (0,react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_enhanceManualRouteObjects)(routes)
  }).initialize();
}
function createHashRouter(routes, opts) {
  var _window2;

  return (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createRouter */ .p7)({
    basename: opts == null ? void 0 : opts.basename,
    history: (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createHashHistory */ .q_)({
      window: opts == null ? void 0 : opts.window
    }),
    hydrationData: (opts == null ? void 0 : opts.hydrationData) || ((_window2 = window) == null ? void 0 : _window2.__staticRouterHydrationData),
    routes: (0,react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_enhanceManualRouteObjects)(routes)
  }).initialize();
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */

function BrowserRouter(_ref) {
  let {
    basename,
    children,
    window
  } = _ref;
  let historyRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  if (historyRef.current == null) {
    historyRef.current = (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createBrowserHistory */ .lX)({
      window,
      v5Compat: true
    });
  }

  let history = historyRef.current;
  let [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    action: history.action,
    location: history.location
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => history.listen(setState), [history]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router__WEBPACK_IMPORTED_MODULE_2__.Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */

function HashRouter(_ref2) {
  let {
    basename,
    children,
    window
  } = _ref2;
  let historyRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  if (historyRef.current == null) {
    historyRef.current = (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createHashHistory */ .q_)({
      window,
      v5Compat: true
    });
  }

  let history = historyRef.current;
  let [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    action: history.action,
    location: history.location
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => history.listen(setState), [history]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router__WEBPACK_IMPORTED_MODULE_2__.Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */

function HistoryRouter(_ref3) {
  let {
    basename,
    children,
    history
  } = _ref3;
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    action: history.action,
    location: history.location
  });
  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => history.listen(setState), [history]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router__WEBPACK_IMPORTED_MODULE_2__.Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}

if (false) {}
/**
 * The public API for rendering a history-aware <a>.
 */

const Link = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function LinkWithRef(_ref4, ref) {
  let {
    onClick,
    relative,
    reloadDocument,
    replace,
    state,
    target,
    to,
    preventScrollReset
  } = _ref4,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded);

  let href = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useHref)(to, {
    relative
  });
  let internalOnClick = useLinkClickHandler(to, {
    replace,
    state,
    target,
    preventScrollReset,
    relative
  });

  function handleClick(event) {
    if (onClick) onClick(event);

    if (!event.defaultPrevented) {
      internalOnClick(event);
    }
  }

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", _extends({}, rest, {
      href: href,
      onClick: reloadDocument ? onClick : handleClick,
      ref: ref,
      target: target
    }))
  );
});

if (false) {}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


const NavLink = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NavLinkWithRef(_ref5, ref) {
  let {
    "aria-current": ariaCurrentProp = "page",
    caseSensitive = false,
    className: classNameProp = "",
    end = false,
    style: styleProp,
    to,
    children
  } = _ref5,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);

  let path = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useResolvedPath)(to);
  let match = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useMatch)({
    path: path.pathname,
    end,
    caseSensitive
  });
  let routerState = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterStateContext);
  let nextLocation = routerState == null ? void 0 : routerState.navigation.location;
  let nextPath = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useResolvedPath)(nextLocation || "");
  let nextMatch = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => nextLocation ? (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .matchPath */ .LX)({
    path: path.pathname,
    end,
    caseSensitive
  }, nextPath.pathname) : null, [nextLocation, path.pathname, caseSensitive, end, nextPath.pathname]);
  let isPending = nextMatch != null;
  let isActive = match != null;
  let ariaCurrent = isActive ? ariaCurrentProp : undefined;
  let className;

  if (typeof classNameProp === "function") {
    className = classNameProp({
      isActive,
      isPending
    });
  } else {
    // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [classNameProp, isActive ? "active" : null, isPending ? "pending" : null].filter(Boolean).join(" ");
  }

  let style = typeof styleProp === "function" ? styleProp({
    isActive,
    isPending
  }) : styleProp;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Link, _extends({}, rest, {
    "aria-current": ariaCurrent,
    className: className,
    ref: ref,
    style: style,
    to: to
  }), typeof children === "function" ? children({
    isActive,
    isPending
  }) : children);
});

if (false) {}
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */


const Form = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormImpl, _extends({}, props, {
    ref: ref
  }));
});

if (false) {}

const FormImpl = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref6, forwardedRef) => {
  let {
    reloadDocument,
    replace,
    method = defaultMethod,
    action,
    onSubmit,
    fetcherKey,
    routeId,
    relative
  } = _ref6,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded3);

  let submit = useSubmitImpl(fetcherKey, routeId);
  let formMethod = method.toLowerCase() === "get" ? "get" : "post";
  let formAction = useFormAction(action, {
    relative
  });

  let submitHandler = event => {
    onSubmit && onSubmit(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    let submitter = event.nativeEvent.submitter;
    submit(submitter || event.currentTarget, {
      method,
      replace,
      relative
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("form", _extends({
    ref: forwardedRef,
    method: formMethod,
    action: formAction,
    onSubmit: reloadDocument ? onSubmit : submitHandler
  }, props));
});

if (false) {}
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */


function ScrollRestoration(_ref7) {
  let {
    getKey,
    storageKey
  } = _ref7;
  useScrollRestoration({
    getKey,
    storageKey
  });
  return null;
}

if (false) {} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////

/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */


function useLinkClickHandler(to, _temp) {
  let {
    target,
    replace: replaceProp,
    state,
    preventScrollReset,
    relative
  } = _temp === void 0 ? {} : _temp;
  let navigate = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useNavigate)();
  let location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useLocation)();
  let path = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useResolvedPath)(to, {
    relative
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(event => {
    if (shouldProcessLinkClick(event, target)) {
      event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
      // a push, so do the same here unless the replace prop is explicitly set

      let replace = replaceProp !== undefined ? replaceProp : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createPath */ .Ep)(location) === (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createPath */ .Ep)(path);
      navigate(to, {
        replace,
        state,
        preventScrollReset,
        relative
      });
    }
  }, [location, navigate, path, replaceProp, state, target, to, preventScrollReset, relative]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */

function useSearchParams(defaultInit) {
   false ? 0 : void 0;
  let defaultSearchParamsRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(createSearchParams(defaultInit));
  let location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useLocation)();
  let searchParams = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [location.search]);
  let navigate = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useNavigate)();
  let setSearchParams = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((nextInit, navigateOptions) => {
    const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
    navigate("?" + newSearchParams, navigateOptions);
  }, [navigate, searchParams]);
  return [searchParams, setSearchParams];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */

function useSubmit() {
  return useSubmitImpl();
}

function useSubmitImpl(fetcherKey, routeId) {
  let dataRouterContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterContext);
  !dataRouterContext ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let {
    router
  } = dataRouterContext;
  let defaultAction = useFormAction();
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (target, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof document === "undefined") {
      throw new Error("You are calling submit during the server render. " + "Try calling submit within a `useEffect` or callback instead.");
    }

    let {
      method,
      encType,
      formData,
      url
    } = getFormSubmissionInfo(target, defaultAction, options);
    let href = url.pathname + url.search;
    let opts = {
      replace: options.replace,
      formData,
      formMethod: method,
      formEncType: encType
    };

    if (fetcherKey) {
      !(routeId != null) ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
      router.fetch(fetcherKey, routeId, href, opts);
    } else {
      router.navigate(href, opts);
    }
  }, [defaultAction, router, fetcherKey, routeId]);
}

function useFormAction(action, _temp2) {
  let {
    relative
  } = _temp2 === void 0 ? {} : _temp2;
  let routeContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_RouteContext);
  !routeContext ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let [match] = routeContext.matches.slice(-1);
  let resolvedAction = action != null ? action : ".";
  let path = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useResolvedPath)(resolvedAction, {
    relative
  }); // Previously we set the default action to ".". The problem with this is that
  // `useResolvedPath(".")` excludes search params and the hash of the resolved
  // URL. This is the intended behavior of when "." is specifically provided as
  // the form action, but inconsistent w/ browsers when the action is omitted.
  // https://github.com/remix-run/remix/issues/927

  let location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useLocation)();

  if (action == null) {
    // Safe to write to these directly here since if action was undefined, we
    // would have called useResolvedPath(".") which will never include a search
    // or hash
    path.search = location.search;
    path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
    // inserted ?index param so we match the useResolvedPath search behavior
    // which would not include ?index

    if (match.route.index) {
      let params = new URLSearchParams(path.search);
      params.delete("index");
      path.search = params.toString() ? "?" + params.toString() : "";
    }
  }

  if ((!action || action === ".") && match.route.index) {
    path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
  }

  return (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .createPath */ .Ep)(path);
}

function createFetcherForm(fetcherKey, routeId) {
  let FetcherForm = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormImpl, _extends({}, props, {
      ref: ref,
      fetcherKey: fetcherKey,
      routeId: routeId
    }));
  });

  if (false) {}

  return FetcherForm;
}

let fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */

function useFetcher() {
  var _route$matches;

  let dataRouterContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterContext);
  !dataRouterContext ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let {
    router
  } = dataRouterContext;
  let route = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_RouteContext);
  !route ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
  !(routeId != null) ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let [fetcherKey] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => String(++fetcherId));
  let [Form] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    !routeId ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
    return createFetcherForm(fetcherKey, routeId);
  });
  let [load] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => href => {
    !router ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
    !routeId ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
    router.fetch(fetcherKey, routeId, href);
  });
  let submit = useSubmitImpl(fetcherKey, routeId);
  let fetcher = router.getFetcher(fetcherKey);
  let fetcherWithComponents = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => _extends({
    Form,
    submit,
    load
  }, fetcher), [fetcher, Form, submit, load]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Is this busted when the React team gets real weird and calls effects
    // twice on mount?  We really just need to garbage collect here when this
    // fetcher is no longer around.
    return () => {
      if (!router) {
        console.warn("No fetcher available to clean up from useFetcher()");
        return;
      }

      router.deleteFetcher(fetcherKey);
    };
  }, [router, fetcherKey]);
  return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */

function useFetchers() {
  let state = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterStateContext);
  !state ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  return [...state.fetchers.values()];
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */

function useScrollRestoration(_temp3) {
  let {
    getKey,
    storageKey
  } = _temp3 === void 0 ? {} : _temp3;
  let location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useLocation)();
  let matches = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useMatches)();
  let navigation = (0,react_router__WEBPACK_IMPORTED_MODULE_2__.useNavigation)();
  let dataRouterContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterContext);
  !dataRouterContext ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let {
    router
  } = dataRouterContext;
  let state = react__WEBPACK_IMPORTED_MODULE_0__.useContext(react_router__WEBPACK_IMPORTED_MODULE_2__.UNSAFE_DataRouterStateContext);
  !(router != null && state != null) ?  false ? 0 : (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(false) : void 0;
  let {
    restoreScrollPosition,
    preventScrollReset
  } = state; // Trigger manual scroll restoration while we're active

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = "auto";
    };
  }, []); // Save positions on unload

  useBeforeUnload(react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (navigation.state === "idle") {
      let key = (getKey ? getKey(location, matches) : null) || location.key;
      savedScrollPositions[key] = window.scrollY;
    }

    sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
    window.history.scrollRestoration = "auto";
  }, [storageKey, getKey, navigation.state, location, matches])); // Read in any saved scroll locations

  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => {
    try {
      let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);

      if (sessionPositions) {
        savedScrollPositions = JSON.parse(sessionPositions);
      }
    } catch (e) {// no-op, use default empty object
    }
  }, [storageKey]); // Enable scroll restoration in the router

  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => {
    let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, () => window.scrollY, getKey);
    return () => disableScrollRestoration && disableScrollRestoration();
  }, [router, getKey]); // Restore scrolling when state.restoreScrollPosition changes

  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => {
    // Explicit false means don't do anything (used for submissions)
    if (restoreScrollPosition === false) {
      return;
    } // been here before, scroll to it


    if (typeof restoreScrollPosition === "number") {
      window.scrollTo(0, restoreScrollPosition);
      return;
    } // try to scroll to the hash


    if (location.hash) {
      let el = document.getElementById(location.hash.slice(1));

      if (el) {
        el.scrollIntoView();
        return;
      }
    } // Opt out of scroll reset if this link requested it


    if (preventScrollReset === true) {
      return;
    } // otherwise go to the top on new locations


    window.scrollTo(0, 0);
  }, [location, restoreScrollPosition, preventScrollReset]);
}

function useBeforeUnload(callback) {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    window.addEventListener("beforeunload", callback);
    return () => {
      window.removeEventListener("beforeunload", callback);
    };
  }, [callback]);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////


function warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);

    try {
      // Welcome to debugging React Router!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
} //#endregion


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 9250:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AbortedDeferredError": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.X3),
/* harmony export */   "Await": () => (/* binding */ Await),
/* harmony export */   "MemoryRouter": () => (/* binding */ MemoryRouter),
/* harmony export */   "Navigate": () => (/* binding */ Navigate),
/* harmony export */   "NavigationType": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.aU),
/* harmony export */   "Outlet": () => (/* binding */ Outlet),
/* harmony export */   "Route": () => (/* binding */ Route),
/* harmony export */   "Router": () => (/* binding */ Router),
/* harmony export */   "RouterProvider": () => (/* binding */ RouterProvider),
/* harmony export */   "Routes": () => (/* binding */ Routes),
/* harmony export */   "UNSAFE_DataRouterContext": () => (/* binding */ DataRouterContext),
/* harmony export */   "UNSAFE_DataRouterStateContext": () => (/* binding */ DataRouterStateContext),
/* harmony export */   "UNSAFE_DataStaticRouterContext": () => (/* binding */ DataStaticRouterContext),
/* harmony export */   "UNSAFE_LocationContext": () => (/* binding */ LocationContext),
/* harmony export */   "UNSAFE_NavigationContext": () => (/* binding */ NavigationContext),
/* harmony export */   "UNSAFE_RouteContext": () => (/* binding */ RouteContext),
/* harmony export */   "UNSAFE_enhanceManualRouteObjects": () => (/* binding */ enhanceManualRouteObjects),
/* harmony export */   "createMemoryRouter": () => (/* binding */ createMemoryRouter),
/* harmony export */   "createPath": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.Ep),
/* harmony export */   "createRoutesFromChildren": () => (/* binding */ createRoutesFromChildren),
/* harmony export */   "createRoutesFromElements": () => (/* binding */ createRoutesFromChildren),
/* harmony export */   "defer": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.PQ),
/* harmony export */   "generatePath": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.Gn),
/* harmony export */   "isRouteErrorResponse": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.WK),
/* harmony export */   "json": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.AV),
/* harmony export */   "matchPath": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.LX),
/* harmony export */   "matchRoutes": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.fp),
/* harmony export */   "parsePath": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.cP),
/* harmony export */   "redirect": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.uX),
/* harmony export */   "renderMatches": () => (/* binding */ renderMatches),
/* harmony export */   "resolvePath": () => (/* reexport safe */ _remix_run_router__WEBPACK_IMPORTED_MODULE_0__.i3),
/* harmony export */   "useActionData": () => (/* binding */ useActionData),
/* harmony export */   "useAsyncError": () => (/* binding */ useAsyncError),
/* harmony export */   "useAsyncValue": () => (/* binding */ useAsyncValue),
/* harmony export */   "useHref": () => (/* binding */ useHref),
/* harmony export */   "useInRouterContext": () => (/* binding */ useInRouterContext),
/* harmony export */   "useLoaderData": () => (/* binding */ useLoaderData),
/* harmony export */   "useLocation": () => (/* binding */ useLocation),
/* harmony export */   "useMatch": () => (/* binding */ useMatch),
/* harmony export */   "useMatches": () => (/* binding */ useMatches),
/* harmony export */   "useNavigate": () => (/* binding */ useNavigate),
/* harmony export */   "useNavigation": () => (/* binding */ useNavigation),
/* harmony export */   "useNavigationType": () => (/* binding */ useNavigationType),
/* harmony export */   "useOutlet": () => (/* binding */ useOutlet),
/* harmony export */   "useOutletContext": () => (/* binding */ useOutletContext),
/* harmony export */   "useParams": () => (/* binding */ useParams),
/* harmony export */   "useResolvedPath": () => (/* binding */ useResolvedPath),
/* harmony export */   "useRevalidator": () => (/* binding */ useRevalidator),
/* harmony export */   "useRouteError": () => (/* binding */ useRouteError),
/* harmony export */   "useRouteLoaderData": () => (/* binding */ useRouteLoaderData),
/* harmony export */   "useRoutes": () => (/* binding */ useRoutes)
/* harmony export */ });
/* harmony import */ var _remix_run_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2599);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/**
 * React Router v6.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */




function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

function isPolyfill(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

const is = typeof Object.is === "function" ? Object.is : isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.

const {
  useState,
  useEffect,
  useLayoutEffect,
  useDebugValue
} = react__WEBPACK_IMPORTED_MODULE_1__;
let didWarnOld18Alpha = false;
let didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.

function useSyncExternalStore$2(subscribe, getSnapshot, // Note: The shim does not use getServerSnapshot, because pre-18 versions of
// React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
  if (false) {} // Read the current snapshot from the store on every render. Again, this
  // breaks the rules of React, and only works here because of specific
  // implementation details, most importantly that updates are
  // always synchronous.


  const value = getSnapshot();

  if (false) {} // Because updates are synchronous, we don't queue them. Instead we force a
  // re-render whenever the subscribed state changes by updating an some
  // arbitrary useState hook. Then, during render, we call getSnapshot to read
  // the current value.
  //
  // Because we don't actually use the state returned by the useState hook, we
  // can save a bit of memory by storing other stuff in that slot.
  //
  // To implement the early bailout, we need to track some things on a mutable
  // object. Usually, we would put that in a useRef hook, but we can stash it in
  // our useState hook instead.
  //
  // To force a re-render, we call forceUpdate({inst}). That works because the
  // new object always fails an equality check.


  const [{
    inst
  }, forceUpdate] = useState({
    inst: {
      value,
      getSnapshot
    }
  }); // Track the latest getSnapshot function with a ref. This needs to be updated
  // in the layout phase so we can access it during the tearing check that
  // happens on subscribe.

  useLayoutEffect(() => {
    inst.value = value;
    inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
    // commit phase if there was an interleaved mutation. In concurrent mode
    // this can happen all the time, but even in synchronous mode, an earlier
    // effect may have mutated the store.

    if (checkIfSnapshotChanged(inst)) {
      // Force a re-render.
      forceUpdate({
        inst
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [subscribe, value, getSnapshot]);
  useEffect(() => {
    // Check for changes right before subscribing. Subsequent changes will be
    // detected in the subscription handler.
    if (checkIfSnapshotChanged(inst)) {
      // Force a re-render.
      forceUpdate({
        inst
      });
    }

    const handleStoreChange = () => {
      // TODO: Because there is no cross-renderer API for batching updates, it's
      // up to the consumer of this library to wrap their subscription event
      // with unstable_batchedUpdates. Should we try to detect when this isn't
      // the case and print a warning in development?
      // The store changed. Check if the snapshot changed since the last time we
      // read from the store.
      if (checkIfSnapshotChanged(inst)) {
        // Force a re-render.
        forceUpdate({
          inst
        });
      }
    }; // Subscribe to the store and return a clean-up function.


    return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribe]);
  useDebugValue(value);
  return value;
}

function checkIfSnapshotChanged(inst) {
  const latestGetSnapshot = inst.getSnapshot;
  const prevValue = inst.value;

  try {
    const nextValue = latestGetSnapshot();
    return !is(prevValue, nextValue);
  } catch (error) {
    return true;
  }
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */
function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
  // Note: The shim does not use getServerSnapshot, because pre-18 versions of
  // React do not expose a way to check if we're hydrating. So users of the shim
  // will need to track that themselves and return the correct value
  // from `getSnapshot`.
  return getSnapshot();
}

/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */
const canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const isServerEnvironment = !canUseDOM;
const shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore$2;
const useSyncExternalStore = "useSyncExternalStore" in react__WEBPACK_IMPORTED_MODULE_1__ ? (module => module.useSyncExternalStore)(react__WEBPACK_IMPORTED_MODULE_1__) : shim;

// Contexts for data routers
const DataStaticRouterContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

const DataRouterContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

const DataRouterStateContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

const AwaitContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

const NavigationContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

const LocationContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

const RouteContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext({
  outlet: null,
  matches: []
});

if (false) {}

const RouteErrorContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);

if (false) {}

/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-href
 */

function useHref(to, _temp) {
  let {
    relative
  } = _temp === void 0 ? {} : _temp;
  !useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  let {
    basename,
    navigator
  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(NavigationContext);
  let {
    hash,
    pathname,
    search
  } = useResolvedPath(to, {
    relative
  });
  let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
  // to creating the href.  If this is a root navigation, then just use the raw
  // basename which allows the basename to have full control over the presence
  // of a trailing slash on root links

  if (basename !== "/") {
    joinedPathname = pathname === "/" ? basename : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .joinPaths */ .RQ)([basename, pathname]);
  }

  return navigator.createHref({
    pathname: joinedPathname,
    search,
    hash
  });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-in-router-context
 */

function useInRouterContext() {
  return react__WEBPACK_IMPORTED_MODULE_1__.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-location
 */

function useLocation() {
  !useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  return react__WEBPACK_IMPORTED_MODULE_1__.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-navigation-type
 */

function useNavigationType() {
  return react__WEBPACK_IMPORTED_MODULE_1__.useContext(LocationContext).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-match
 */

function useMatch(pattern) {
  !useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  let {
    pathname
  } = useLocation();
  return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .matchPath */ .LX)(pattern, pathname), [pathname, pattern]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */

/**
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */
function getPathContributingMatches(matches) {
  return matches.filter((match, index) => index === 0 || !match.route.index && match.pathnameBase !== matches[index - 1].pathnameBase);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-navigate
 */


function useNavigate() {
  !useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  let {
    basename,
    navigator
  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(NavigationContext);
  let {
    matches
  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let routePathnamesJson = JSON.stringify(getPathContributingMatches(matches).map(match => match.pathnameBase));
  let activeRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(false);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    activeRef.current = true;
  });
  let navigate = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function (to, options) {
    if (options === void 0) {
      options = {};
    }

     false ? 0 : void 0;
    if (!activeRef.current) return;

    if (typeof to === "number") {
      navigator.go(to);
      return;
    }

    let path = (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .resolveTo */ .pC)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
    // to handing off to history.  If this is a root navigation, then we
    // navigate to the raw basename which allows the basename to have full
    // control over the presence of a trailing slash on root links

    if (basename !== "/") {
      path.pathname = path.pathname === "/" ? basename : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .joinPaths */ .RQ)([basename, path.pathname]);
    }

    (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
  }, [basename, navigator, routePathnamesJson, locationPathname]);
  return navigate;
}
const OutletContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/hooks/use-outlet-context
 */

function useOutletContext() {
  return react__WEBPACK_IMPORTED_MODULE_1__.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-outlet
 */

function useOutlet(context) {
  let outlet = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext).outlet;

  if (outlet) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(OutletContext.Provider, {
      value: context
    }, outlet);
  }

  return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-params
 */

function useParams() {
  let {
    matches
  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  let routeMatch = matches[matches.length - 1];
  return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-resolved-path
 */

function useResolvedPath(to, _temp2) {
  let {
    relative
  } = _temp2 === void 0 ? {} : _temp2;
  let {
    matches
  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let routePathnamesJson = JSON.stringify(getPathContributingMatches(matches).map(match => match.pathnameBase));
  return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .resolveTo */ .pC)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [to, routePathnamesJson, locationPathname, relative]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-routes
 */

function useRoutes(routes, locationArg) {
  !useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  let dataRouterStateContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(DataRouterStateContext);
  let {
    matches: parentMatches
  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  let routeMatch = parentMatches[parentMatches.length - 1];
  let parentParams = routeMatch ? routeMatch.params : {};
  let parentPathname = routeMatch ? routeMatch.pathname : "/";
  let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
  let parentRoute = routeMatch && routeMatch.route;

  if (false) {}

  let locationFromContext = useLocation();
  let location;

  if (locationArg) {
    var _parsedLocationArg$pa;

    let parsedLocationArg = typeof locationArg === "string" ? (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .parsePath */ .cP)(locationArg) : locationArg;
    !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
    location = parsedLocationArg;
  } else {
    location = locationFromContext;
  }

  let pathname = location.pathname || "/";
  let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
  let matches = (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .matchRoutes */ .fp)(routes, {
    pathname: remainingPathname
  });

  if (false) {}

  let renderedMatches = _renderMatches(matches && matches.map(match => Object.assign({}, match, {
    params: Object.assign({}, parentParams, match.params),
    pathname: (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .joinPaths */ .RQ)([parentPathnameBase, match.pathname]),
    pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .joinPaths */ .RQ)([parentPathnameBase, match.pathnameBase])
  })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
  // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
  // to use the scoped location instead of the global location.


  if (locationArg) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(LocationContext.Provider, {
      value: {
        location: _extends({
          pathname: "/",
          search: "",
          hash: "",
          state: null,
          key: "default"
        }, location),
        navigationType: _remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .Action.Pop */ .aU.Pop
      }
    }, renderedMatches);
  }

  return renderedMatches;
}

function DefaultErrorElement() {
  let error = useRouteError();
  let message = (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .isRouteErrorResponse */ .WK)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
  let stack = error instanceof Error ? error.stack : null;
  let lightgrey = "rgba(200,200,200, 0.5)";
  let preStyles = {
    padding: "0.5rem",
    backgroundColor: lightgrey
  };
  let codeStyles = {
    padding: "2px 4px",
    backgroundColor: lightgrey
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, message), stack ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("pre", {
    style: preStyles
  }, stack) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("code", {
    style: codeStyles
  }, "errorElement"), " props on\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("code", {
    style: codeStyles
  }, "<Route>")));
}

class RenderErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.location,
      error: props.error
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }

  static getDerivedStateFromProps(props, state) {
    // When we get into an error state, the user will likely click "back" to the
    // previous page that didn't have an error. Because this wraps the entire
    // application, that will have no effect--the error page continues to display.
    // This gives us a mechanism to recover from the error when the location changes.
    //
    // Whether we're in an error state or not, we update the location in state
    // so that when we are in an error state, it gets reset when a new location
    // comes in and the user recovers from the error.
    if (state.location !== props.location) {
      return {
        error: props.error,
        location: props.location
      };
    } // If we're not changing locations, preserve the location but still surface
    // any new errors that may come through. We retain the existing error, we do
    // this because the error provided from the app state may be cleared without
    // the location changing.


    return {
      error: props.error || state.error,
      location: state.location
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Router caught the following error during render", error, errorInfo);
  }

  render() {
    return this.state.error ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(RouteErrorContext.Provider, {
      value: this.state.error,
      children: this.props.component
    }) : this.props.children;
  }

}

function RenderedRoute(_ref) {
  let {
    routeContext,
    match,
    children
  } = _ref;
  let dataStaticRouterContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(DataStaticRouterContext); // Track how deep we got in our render pass to emulate SSR componentDidCatch
  // in a DataStaticRouter

  if (dataStaticRouterContext && match.route.errorElement) {
    dataStaticRouterContext._deepestRenderedBoundaryId = match.route.id;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(RouteContext.Provider, {
    value: routeContext
  }, children);
}

function _renderMatches(matches, parentMatches, dataRouterState) {
  if (parentMatches === void 0) {
    parentMatches = [];
  }

  if (matches == null) {
    if (dataRouterState != null && dataRouterState.errors) {
      // Don't bail if we have data router errors so we can render them in the
      // boundary.  Use the pre-matched (or shimmed) matches
      matches = dataRouterState.matches;
    } else {
      return null;
    }
  }

  let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary

  let errors = dataRouterState == null ? void 0 : dataRouterState.errors;

  if (errors != null) {
    let errorIndex = renderedMatches.findIndex(m => m.route.id && (errors == null ? void 0 : errors[m.route.id]));
    !(errorIndex >= 0) ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
    renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
  }

  return renderedMatches.reduceRight((outlet, match, index) => {
    let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors

    let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(DefaultErrorElement, null) : null;

    let getChildren = () => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(RenderedRoute, {
      match: match,
      routeContext: {
        outlet,
        matches: parentMatches.concat(renderedMatches.slice(0, index + 1))
      }
    }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
    // errorElement on this route.  Otherwise let it bubble up to an ancestor
    // errorElement


    return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(RenderErrorBoundary, {
      location: dataRouterState.location,
      component: errorElement,
      error: error,
      children: getChildren()
    }) : getChildren();
  }, null);
}
var DataRouterHook;

(function (DataRouterHook) {
  DataRouterHook["UseLoaderData"] = "useLoaderData";
  DataRouterHook["UseActionData"] = "useActionData";
  DataRouterHook["UseRouteError"] = "useRouteError";
  DataRouterHook["UseNavigation"] = "useNavigation";
  DataRouterHook["UseRouteLoaderData"] = "useRouteLoaderData";
  DataRouterHook["UseMatches"] = "useMatches";
  DataRouterHook["UseRevalidator"] = "useRevalidator";
})(DataRouterHook || (DataRouterHook = {}));

function useDataRouterState(hookName) {
  let state = react__WEBPACK_IMPORTED_MODULE_1__.useContext(DataRouterStateContext);
  !state ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  return state;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */


function useNavigation() {
  let state = useDataRouterState(DataRouterHook.UseNavigation);
  return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */

function useRevalidator() {
  let dataRouterContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(DataRouterContext);
  !dataRouterContext ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  let state = useDataRouterState(DataRouterHook.UseRevalidator);
  return {
    revalidate: dataRouterContext.router.revalidate,
    state: state.revalidation
  };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */

function useMatches() {
  let {
    matches,
    loaderData
  } = useDataRouterState(DataRouterHook.UseMatches);
  return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => matches.map(match => {
    let {
      pathname,
      params
    } = match; // Note: This structure matches that created by createUseMatchesMatch
    // in the @remix-run/router , so if you change this please also change
    // that :)  Eventually we'll DRY this up

    return {
      id: match.route.id,
      pathname,
      params,
      data: loaderData[match.route.id],
      handle: match.route.handle
    };
  }), [matches, loaderData]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */

function useLoaderData() {
  let state = useDataRouterState(DataRouterHook.UseLoaderData);
  let route = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  !route ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  let thisRoute = route.matches[route.matches.length - 1];
  !thisRoute.route.id ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  return state.loaderData[thisRoute.route.id];
}
/**
 * Returns the loaderData for the given routeId
 */

function useRouteLoaderData(routeId) {
  let state = useDataRouterState(DataRouterHook.UseRouteLoaderData);
  return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */

function useActionData() {
  let state = useDataRouterState(DataRouterHook.UseActionData);
  let route = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  !route ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */

function useRouteError() {
  var _state$errors;

  let error = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteErrorContext);
  let state = useDataRouterState(DataRouterHook.UseRouteError);
  let route = react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouteContext);
  let thisRoute = route.matches[route.matches.length - 1]; // If this was a render error, we put it in a RouteError context inside
  // of RenderErrorBoundary

  if (error) {
    return error;
  }

  !route ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
  !thisRoute.route.id ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0; // Otherwise look for errors from our data router state

  return (_state$errors = state.errors) == null ? void 0 : _state$errors[thisRoute.route.id];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */

function useAsyncValue() {
  let value = react__WEBPACK_IMPORTED_MODULE_1__.useContext(AwaitContext);
  return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */

function useAsyncError() {
  let value = react__WEBPACK_IMPORTED_MODULE_1__.useContext(AwaitContext);
  return value == null ? void 0 : value._error;
}
const alreadyWarned = {};

function warningOnce(key, cond, message) {
  if (!cond && !alreadyWarned[key]) {
    alreadyWarned[key] = true;
     false ? 0 : void 0;
  }
}

/**
 * Given a Remix Router instance, render the appropriate UI
 */
function RouterProvider(_ref) {
  let {
    fallbackElement,
    router
  } = _ref;
  // Sync router state to our component state to force re-renders
  let state = useSyncExternalStore(router.subscribe, () => router.state, // We have to provide this so React@18 doesn't complain during hydration,
  // but we pass our serialized hydration data into the router so state here
  // is already synced with what the server saw
  () => router.state);
  let navigator = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    return {
      createHref: router.createHref,
      go: n => router.navigate(n),
      push: (to, state, opts) => router.navigate(to, {
        state,
        preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
      }),
      replace: (to, state, opts) => router.navigate(to, {
        replace: true,
        state,
        preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
      })
    };
  }, [router]);
  let basename = router.basename || "/";
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(DataRouterContext.Provider, {
    value: {
      router,
      navigator,
      static: false,
      // Do we need this?
      basename
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(DataRouterStateContext.Provider, {
    value: state
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Router, {
    basename: router.basename,
    location: router.state.location,
    navigationType: router.state.historyAction,
    navigator: navigator
  }, router.state.initialized ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Routes, null) : fallbackElement)));
}

/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/routers/memory-router
 */
function MemoryRouter(_ref2) {
  let {
    basename,
    children,
    initialEntries,
    initialIndex
  } = _ref2;
  let historyRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef();

  if (historyRef.current == null) {
    historyRef.current = (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .createMemoryHistory */ .PP)({
      initialEntries,
      initialIndex,
      v5Compat: true
    });
  }

  let history = historyRef.current;
  let [state, setState] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
    action: history.action,
    location: history.location
  });
  react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(() => history.listen(setState), [history]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}

/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/components/navigate
 */
function Navigate(_ref3) {
  let {
    to,
    replace,
    state,
    relative
  } = _ref3;
  !useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
   false ? 0 : void 0;
  let dataRouterState = react__WEBPACK_IMPORTED_MODULE_1__.useContext(DataRouterStateContext);
  let navigate = useNavigate();
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    // Avoid kicking off multiple navigations if we're in the middle of a
    // data-router navigation, since components get re-rendered when we enter
    // a submitting/loading state
    if (dataRouterState && dataRouterState.navigation.state !== "idle") {
      return;
    }

    navigate(to, {
      replace,
      state,
      relative
    });
  });
  return null;
}

/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/components/outlet
 */
function Outlet(props) {
  return useOutlet(props.context);
}

/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/components/route
 */
function Route(_props) {
   false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) ;
}

/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/routers/router
 */
function Router(_ref4) {
  let {
    basename: basenameProp = "/",
    children = null,
    location: locationProp,
    navigationType = _remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .Action.Pop */ .aU.Pop,
    navigator,
    static: staticProp = false
  } = _ref4;
  !!useInRouterContext() ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0; // Preserve trailing slashes on basename, so we can let the user control
  // the enforcement of trailing slashes throughout the app

  let basename = basenameProp.replace(/^\/*/, "/");
  let navigationContext = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({
    basename,
    navigator,
    static: staticProp
  }), [basename, navigator, staticProp]);

  if (typeof locationProp === "string") {
    locationProp = (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .parsePath */ .cP)(locationProp);
  }

  let {
    pathname = "/",
    search = "",
    hash = "",
    state = null,
    key = "default"
  } = locationProp;
  let location = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    let trailingPathname = (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .stripBasename */ .Zn)(pathname, basename);

    if (trailingPathname == null) {
      return null;
    }

    return {
      pathname: trailingPathname,
      search,
      hash,
      state,
      key
    };
  }, [basename, pathname, search, hash, state, key]);
   false ? 0 : void 0;

  if (location == null) {
    return null;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(NavigationContext.Provider, {
    value: navigationContext
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(LocationContext.Provider, {
    children: children,
    value: {
      location,
      navigationType
    }
  }));
}

/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/components/routes
 */
function Routes(_ref5) {
  let {
    children,
    location
  } = _ref5;
  let dataRouterContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(DataRouterContext); // When in a DataRouterContext _without_ children, we use the router routes
  // directly.  If we have children, then we're in a descendant tree and we
  // need to use child routes.

  let routes = dataRouterContext && !children ? dataRouterContext.router.routes : createRoutesFromChildren(children);
  return useRoutes(routes, location);
}

/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */
function Await(_ref6) {
  let {
    children,
    errorElement,
    resolve
  } = _ref6;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(AwaitErrorBoundary, {
    resolve: resolve,
    errorElement: errorElement
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus;

(function (AwaitRenderStatus) {
  AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
  AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
  AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})(AwaitRenderStatus || (AwaitRenderStatus = {}));

const neverSettledPromise = new Promise(() => {});

class AwaitErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("<Await> caught the following error during render", error, errorInfo);
  }

  render() {
    let {
      children,
      errorElement,
      resolve
    } = this.props;
    let promise = null;
    let status = AwaitRenderStatus.pending;

    if (!(resolve instanceof Promise)) {
      // Didn't get a promise - provide as a resolved promise
      status = AwaitRenderStatus.success;
      promise = Promise.resolve();
      Object.defineProperty(promise, "_tracked", {
        get: () => true
      });
      Object.defineProperty(promise, "_data", {
        get: () => resolve
      });
    } else if (this.state.error) {
      // Caught a render error, provide it as a rejected promise
      status = AwaitRenderStatus.error;
      let renderError = this.state.error;
      promise = Promise.reject().catch(() => {}); // Avoid unhandled rejection warnings

      Object.defineProperty(promise, "_tracked", {
        get: () => true
      });
      Object.defineProperty(promise, "_error", {
        get: () => renderError
      });
    } else if (resolve._tracked) {
      // Already tracked promise - check contents
      promise = resolve;
      status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
    } else {
      // Raw (untracked) promise - track it
      status = AwaitRenderStatus.pending;
      Object.defineProperty(resolve, "_tracked", {
        get: () => true
      });
      promise = resolve.then(data => Object.defineProperty(resolve, "_data", {
        get: () => data
      }), error => Object.defineProperty(resolve, "_error", {
        get: () => error
      }));
    }

    if (status === AwaitRenderStatus.error && promise._error instanceof _remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .AbortedDeferredError */ .X3) {
      // Freeze the UI by throwing a never resolved promise
      throw neverSettledPromise;
    }

    if (status === AwaitRenderStatus.error && !errorElement) {
      // No errorElement, throw to the nearest route-level error boundary
      throw promise._error;
    }

    if (status === AwaitRenderStatus.error) {
      // Render via our errorElement
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(AwaitContext.Provider, {
        value: promise,
        children: errorElement
      });
    }

    if (status === AwaitRenderStatus.success) {
      // Render children with resolved value
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(AwaitContext.Provider, {
        value: promise,
        children: children
      });
    } // Throw to the suspense boundary


    throw promise;
  }

}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */


function ResolveAwait(_ref7) {
  let {
    children
  } = _ref7;
  let data = useAsyncValue();

  if (typeof children === "function") {
    return children(data);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, children);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////

/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/create-routes-from-children
 */


function createRoutesFromChildren(children, parentPath) {
  if (parentPath === void 0) {
    parentPath = [];
  }

  let routes = [];
  react__WEBPACK_IMPORTED_MODULE_1__.Children.forEach(children, (element, index) => {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(element)) {
      // Ignore non-elements. This allows people to more easily inline
      // conditionals in their route config.
      return;
    }

    if (element.type === react__WEBPACK_IMPORTED_MODULE_1__.Fragment) {
      // Transparently support React.Fragment and its children.
      routes.push.apply(routes, createRoutesFromChildren(element.props.children, parentPath));
      return;
    }

    !(element.type === Route) ?  false ? 0 : (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(false) : void 0;
    let treePath = [...parentPath, index];
    let route = {
      id: element.props.id || treePath.join("-"),
      caseSensitive: element.props.caseSensitive,
      element: element.props.element,
      index: element.props.index,
      path: element.props.path,
      loader: element.props.loader,
      action: element.props.action,
      errorElement: element.props.errorElement,
      hasErrorBoundary: element.props.errorElement != null,
      shouldRevalidate: element.props.shouldRevalidate,
      handle: element.props.handle
    };

    if (element.props.children) {
      route.children = createRoutesFromChildren(element.props.children, treePath);
    }

    routes.push(route);
  });
  return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */

function renderMatches(matches) {
  return _renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */

function enhanceManualRouteObjects(routes) {
  return routes.map(route => {
    let routeClone = _extends({}, route);

    if (routeClone.hasErrorBoundary == null) {
      routeClone.hasErrorBoundary = routeClone.errorElement != null;
    }

    if (routeClone.children) {
      routeClone.children = enhanceManualRouteObjects(routeClone.children);
    }

    return routeClone;
  });
}

function createMemoryRouter(routes, opts) {
  return (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .createRouter */ .p7)({
    basename: opts == null ? void 0 : opts.basename,
    history: (0,_remix_run_router__WEBPACK_IMPORTED_MODULE_0__/* .createMemoryHistory */ .PP)({
      initialEntries: opts == null ? void 0 : opts.initialEntries,
      initialIndex: opts == null ? void 0 : opts.initialIndex
    }),
    hydrationData: opts == null ? void 0 : opts.hydrationData,
    routes: enhanceManualRouteObjects(routes)
  }).initialize();
} ///////////////////////////////////////////////////////////////////////////////


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 3524:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(8156);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),

/***/ 8877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(5697),__webpack_require__(8156),__webpack_require__(1518),__webpack_require__(1400)):0}(this,function(e,t,n,r){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),l=n(2),d=r(l),v=n(3),h=r(v),_=n(4),g=r(_),m=function(e){function t(){var e,n,r,u;o(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r._sigPad=null,r._excludeOurProps=function(){var e=r.props,t=(e.canvasProps,e.clearOnResize,a(e,["canvasProps","clearOnResize"]));return t},r.getCanvas=function(){return r._canvas},r.getTrimmedCanvas=function(){var e=document.createElement("canvas");return e.width=r._canvas.width,e.height=r._canvas.height,e.getContext("2d").drawImage(r._canvas,0,0),(0,g.default)(e)},r.getSignaturePad=function(){return r._sigPad},r._checkClearOnResize=function(){r.props.clearOnResize&&r._resizeCanvas()},r._resizeCanvas=function(){var e=r.props.canvasProps||{},t=e.width,n=e.height;if(!t||!n){var a=r._canvas,o=Math.max(window.devicePixelRatio||1,1);t||(a.width=a.offsetWidth*o),n||(a.height=a.offsetHeight*o),a.getContext("2d").scale(o,o),r.clear()}},r.on=function(){return window.addEventListener("resize",r._checkClearOnResize),r._sigPad.on()},r.off=function(){return window.removeEventListener("resize",r._checkClearOnResize),r._sigPad.off()},r.clear=function(){return r._sigPad.clear()},r.isEmpty=function(){return r._sigPad.isEmpty()},r.fromDataURL=function(e,t){return r._sigPad.fromDataURL(e,t)},r.toDataURL=function(e,t){return r._sigPad.toDataURL(e,t)},r.fromData=function(e){return r._sigPad.fromData(e)},r.toData=function(){return r._sigPad.toData()},u=n,i(r,u)}return u(t,e),c(t,[{key:"componentDidMount",value:function(){this._sigPad=new h.default(this._canvas,this._excludeOurProps()),this._resizeCanvas(),this.on()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"componentDidUpdate",value:function(){Object.assign(this._sigPad,this._excludeOurProps())}},{key:"render",value:function(){var e=this,t=this.props.canvasProps;return d.default.createElement("canvas",s({ref:function(t){e._canvas=t}},t))}}]),t}(l.Component);m.propTypes={velocityFilterWeight:p.default.number,minWidth:p.default.number,maxWidth:p.default.number,minDistance:p.default.number,dotSize:p.default.oneOfType([p.default.number,p.default.func]),penColor:p.default.string,throttle:p.default.number,onEnd:p.default.func,onBegin:p.default.func,canvasProps:p.default.object,clearOnResize:p.default.bool},m.defaultProps={clearOnResize:!0},t.default=m},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){e.exports=r}])});

/***/ }),

/***/ 7723:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ esm_CSSTransition)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(4578);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(660);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(9391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) (0,reflow/* forceReflow */.Q)(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/external_react_default().createElement(Transition/* default */.ZP, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}((external_react_default()).Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ const esm_CSSTransition = (CSSTransition);

/***/ }),

/***/ 660:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ esm_Transition)
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(4578);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(8156);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(7111);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ const config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ const TransitionGroupContext = (external_react_default().createContext(null));
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(9391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : external_react_dom_default().findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0,reflow/* forceReflow */.Q)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [external_react_dom_default().findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : external_react_dom_default().findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : external_react_dom_default().findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      external_react_default().createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : external_react_default().cloneElement(external_react_default().Children.only(children), childProps))
    );
  };

  return Transition;
}((external_react_default()).Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ const esm_Transition = (Transition);

/***/ }),

/***/ 9391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ forceReflow)
/* harmony export */ });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),

/***/ 1033:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (index);


/***/ }),

/***/ 7478:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(210);
var callBound = __webpack_require__(1924);
var inspect = __webpack_require__(631);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 523:
/***/ ((module) => {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),

/***/ 1169:
/***/ ((module) => {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 8388:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EB": () => (/* binding */ isFocusable),
/* harmony export */   "Wq": () => (/* binding */ isTabbable),
/* harmony export */   "ht": () => (/* binding */ tabbable)
/* harmony export */ });
/* unused harmony export focusable */
/*!
* tabbable 6.1.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 2852:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

var _classnames = _interopRequireDefault(__webpack_require__(4184));

var _innerSliderUtils = __webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 6301:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 5644:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

var _classnames = _interopRequireDefault(__webpack_require__(4184));

var _innerSliderUtils = __webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else if (spec.slidesToScroll > 1) {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  } else {
    dots = Math.ceil(spec.slideCount);
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 7892:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _slider = _interopRequireDefault(__webpack_require__(12));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports.Z = _default;

/***/ }),

/***/ 6978:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 8307:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

var _initialState = _interopRequireDefault(__webpack_require__(6978));

var _lodash = _interopRequireDefault(__webpack_require__(1296));

var _classnames = _interopRequireDefault(__webpack_require__(4184));

var _innerSliderUtils = __webpack_require__(954);

var _track = __webpack_require__(3298);

var _dots = __webpack_require__(5644);

var _arrows = __webpack_require__(2852);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1033));

var _excluded = ["animating"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, _excluded);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!Object.prototype.hasOwnProperty.call(prevProps, key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 12:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

var _innerSlider = __webpack_require__(8307);

var _json2mq = _interopRequireDefault(__webpack_require__(973));

var _defaultProps = _interopRequireDefault(__webpack_require__(6301));

var _innerSliderUtils = __webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(4974);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 3298:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

var _classnames = _interopRequireDefault(__webpack_require__(4184));

var _innerSliderUtils = __webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 954:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = exports.clamp = exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;

var _react = _interopRequireDefault(__webpack_require__(8156));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var clamp = function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
};

exports.clamp = clamp;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (!spec.centerMode && (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow)) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && !centerMode && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && Object.prototype.hasOwnProperty.call(spec, key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 5157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SsoClient),
/* harmony export */   "deleteCookie": () => (/* binding */ deleteCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "getRootDomain": () => (/* binding */ getRootDomain),
/* harmony export */   "getSsoCookieValue": () => (/* binding */ getSsoCookieValue),
/* harmony export */   "isTeliaDomain": () => (/* binding */ isTeliaDomain),
/* harmony export */   "setCookie": () => (/* binding */ setCookie),
/* harmony export */   "setCookieIfNeeded": () => (/* binding */ setCookieIfNeeded),
/* harmony export */   "shouldRegisterCookies": () => (/* binding */ shouldRegisterCookies)
/* harmony export */ });
class URLUtil {
    static getDomainName(hostname) {
        if (this.regex.test(hostname)) {
            return hostname.match(this.regex)[1];
        }
        return null;
    }
    static resolveBackendEnv() {
        const hostName = window.location.hostname || '';
        if (hostName.includes('test')) {
            return 'test';
        }
        if (hostName.includes('dev2')) {
            return 'dev2';
        }
        if (['arendus', 'dev', 'localhost', 'ng-pood'].some((env) => hostName.includes(env))) {
            return 'dev';
        }
        return 'live';
    }
    static resolveBackendUrl(env) {
        const hostname = URLUtil.resolveBackendHost();
        const resolvedEnv = env || this.resolveBackendEnv();
        let tier = '';
        switch (resolvedEnv) {
            case 'dev':
                tier = '-arendus';
                break;
            case 'dev2':
                tier = '-dev2';
                break;
            case 'test':
                tier = '-test';
        }
        return `https://sso${tier}.${hostname}`;
    }
    static resolveBackendHost() {
        const hostName = window.location.hostname || '';
        if (URLUtil.ssoUIRegex.test(hostName)) {
            const parts = hostName.match(URLUtil.ssoUIRegex);
            return ((parts === null || parts === void 0 ? void 0 : parts.length) && parts[1]) || 'telia.ee';
        }
        return 'telia.ee';
    }
}
URLUtil.domains = [
    'telia\\.ee',
    'diil\\.ee',
    'minutv\\.ee',
    'suhtlus\\.ee',
    'online\\.ee',
    'elion\\.ee',
    'emt\\.ee',
    'simpel\\.ee',
    'super\\.ee',
    'teliatv\\.ee',
    'telia\\.com',
    'hgrupp\\.ee',
    'teliasonera\\.com'
];
URLUtil.ssoUiDomains = [
    'telia\\.ee',
    'diil\\.ee',
    'mtasku\\.ee',
    'super\\.ee',
    'teliatv\\.ee'
];
URLUtil.regex = new RegExp(`^(?:(?:[A-Za-z0-9\-])+\.)*(${URLUtil.domains.join('|')})$`);
URLUtil.ssoUIRegex = new RegExp(`^(?:(?:[A-Za-z0-9\-])+\.)*(${URLUtil.ssoUiDomains.join('|')})$`);
URLUtil.getDomainNameFromUrl = (url) => {
    const hostname = URLUtil.getHostname(url);
    return URLUtil.getDomainName(hostname);
};
URLUtil.getHostname = (url) => {
    if (!url) {
        return '';
    }
    return URLUtil.extractHyperlink(url).hostname;
};
URLUtil.extractHyperlink = (url) => {
    const link = document.createElement('a');
    link.href = url;
    return link;
};

const OPENAM_COOKIE_NAME = 'iPlanetDirectoryPro';
const GA_COOKIE_NAME = 'gaString';
const SSO_COOKIE_AGE_IN_DAYS = 10 * 365; //Ten years
const TEN_SECONDS_IN_MILLIS = 10 * 1000;
const ONE_DAY_IN_MILLIS = 864e5;
const cookieNames = { dev: 'ssoui-arendus', test: 'ssoui-test', live: 'ssoui' };
const ignoredActions = ['showDealerSessionExpirationNotice'];
// keep in sync with interface declaration
function normalizeOptions(options) {
    const { authLevel, selectMandate, app, locale, panelFilter, hideB2B, autoSelectSelf, tabId, allowStatisticsCookies, forceSelectCustomerId, goto, customerId, hideRememberMe } = options;
    return {
        authLevel,
        selectMandate,
        app,
        locale,
        panelFilter,
        hideB2B,
        autoSelectSelf,
        tabId,
        allowStatisticsCookies,
        forceSelectCustomerId,
        goto,
        customerId,
        hideRememberMe
    };
}
// keep in sync with interface declaration
function normalizeConf(conf) {
    const { onLogin, onLogout, onSaveDealerPreferences, renderIframe, registerCookies, disableTabSync, env } = conf;
    return {
        onLogin,
        onLogout,
        onSaveDealerPreferences,
        renderIframe,
        registerCookies,
        disableTabSync,
        env
    };
}
/**
 * sso client script to be used in client side
 */
class SsoClient {
    constructor(conf, options) {
        this.options = {};
        this.handlers = [];
        this.handleStatisticsCookieDecline = () => {
            if (statisticsCookieConsent() !== 'true') {
                this.deleteGaCookieIfExists();
            }
        };
        this.deleteGaCookieIfExists = () => {
            if (getCookie(GA_COOKIE_NAME)) {
                deleteCookie(GA_COOKIE_NAME);
            }
        };
        this.startTimerForDealerAuthentication = () => {
            return setInterval(() => {
                const currentTime = new Date().getTime();
                if ((this.dealerSessionExpirationTime - 1000 * 15 * 60) - currentTime <= 0 && this.dealerSessionExpirationTime > currentTime) {
                    window.postMessage({ action: 'showDealerSessionExpirationNotice' }, '*');
                }
            }, TEN_SECONDS_IN_MILLIS * 6 * 2);
        };
        this.startLogoutTimerForDealer = () => {
            return setInterval(() => {
                if (this.dealerSessionExpirationTime <= new Date().getTime()) {
                    this.doLogout();
                }
            }, TEN_SECONDS_IN_MILLIS);
        };
        this.conf = normalizeConf(conf);
        this.setOptions(options);
        this.backendUri = URLUtil.resolveBackendUrl(this.conf.env);
        this.registerListeners();
        window.addEventListener('message', event => this.onMessageReceived(event));
        window.addEventListener('CookiebotOnLoad', () => this.handleStatisticsCookieDecline());
    }
    static connect(conf, options) {
        return new SsoClient(conf, options);
    }
    /** Renders a temporary iframe to load whatever context there currently is in sso session user context. */
    loadInitialState(tabId) {
        let src = this.getUrl('/ui/webapi', false, { tabId });
        this.renderTempAuthFrame(src);
    }
    /** Renders a temporary iframe to update the representative in sso session by the provided customer id. */
    updateRepresentativeByCustomerId(customerId, withoutBackendUri = false) {
        let src = this.getUrl('/ui/mandate/select', withoutBackendUri, { customerId: customerId });
        this.renderTempAuthFrame(src);
    }
    /** Sets options as composition of: defaults + (current options) + (specified options) */
    setOptions(options) {
        this.options = normalizeOptions({ locale: 'et', ...this.options, ...options });
    }
    /**
     * Set iframe path for logging in, passed options will override sso.options
     * onLoadedCallback function can be used for closing iframe, if needed.
     *
     * @param customOptions additional parameters to override stored options
     * @param onLoadedCallback optional method that will be invoked when the current frame receives 'loaded' push message. This callback will be invoked only
     *   once.
     * @returns {Promise<any>}
     */
    doLogin(customOptions, onLoadedCallback) {
        if (onLoadedCallback) {
            this.subscribe('loaded', onLoadedCallback, true);
        }
        if (this.iframe) {
            this.iframe.src = this.getLoginUrl(customOptions);
            this.iframe.style.display = (this.iframe.style.display === 'none') ? 'block' : this.iframe.style.display;
        }
        else {
            throw new Error('Iframe element not assigned, must assign with sso.setIframe(document.getElementById(\'ssoIframe\')');
        }
    }
    doLoginWithPromise(customOptions) {
        return new Promise(((resolve) => {
            this.doLogin(customOptions, resolve);
        }));
    }
    doLogout() {
        this.renderTempAuthFrame(this.getLogoutUrl());
        // send logoutEvent to all windows
        window.postMessage({ action: 'logout', data: {} }, '*');
        this.clearDealerTimeouts();
        return null;
    }
    getLoginUrl(customOptions = {}, withoutBackendUri = false) {
        return this.getUrl('/', withoutBackendUri, customOptions);
    }
    getLogoutUrl(withoutBackendUri = false) {
        return this.getUrl('/ui/webapi/logout', withoutBackendUri);
    }
    getDealerMandatesUrl(withoutBackendUri = false) {
        return this.getUrl('/admin/mandates', withoutBackendUri);
    }
    getEmployeeSettingsUrl(withoutBackendUri = false) {
        return this.getUrl('/admin/config', withoutBackendUri);
    }
    getSessionExpiringNoticeUrl(withoutBackendUri = false) {
        return this.getUrl('/admin/session-expiration-notification', withoutBackendUri);
    }
    getUrl(path, withoutBackendUri, customOptions = {}) {
        const mergedOptions = { ...this.options, ...(customOptions || {}) };
        if (mergedOptions.goto) {
            mergedOptions.goto = encodeURIComponent(mergedOptions.goto);
        }
        return `${!withoutBackendUri && this.backendUri || ''}${path}?webapi=true&${optionsToParamsStr(normalizeOptions(mergedOptions))}`;
    }
    addListenerFrame() {
        if (!this.conf.disableTabSync && !document.getElementById('sso.listener.iframe')) {
            let iframe = document.createElement('iframe');
            iframe.id = 'sso.listener.iframe';
            iframe.src = this.getUrl('/ui/listener', false);
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }
    }
    registerListeners() {
        this.addListenerFrame();
        this.registerOnLoadedCommon();
        this.registerConfiguredOnLogout();
        this.registerSaveDealerPreferences();
        this.registerOnDealerSessionExtended();
    }
    registerOnLoadedCommon() {
        this.subscribe('loaded', state => {
            this.handleGaStringCookie(state);
            this.handleSessionCookies(state);
            this.handleDealerSessionDuration(state);
            setSessionInfo(state);
            if (this.conf.onLogin) {
                this.conf.onLogin(state);
            }
        });
    }
    registerOnDealerSessionExtended() {
        this.subscribe('dealerSessionExtended', (data) => {
            this.handleDealerSessionDuration(data);
        });
    }
    handleSessionCookies(state) {
        if (this.conf.registerCookies && shouldRegisterCookies()) {
            if (state.am) {
                setCookieIfNeeded(OPENAM_COOKIE_NAME, state.am, 1);
            }
            const env = this.conf.env ? this.conf.env : 'live';
            setCookieIfNeeded(cookieNames[env] || 'ssoui', getSsoCookieValue(state.token), SSO_COOKIE_AGE_IN_DAYS);
        }
    }
    handleGaStringCookie(state) {
        const hasConsentedStatisticsCookie = statisticsCookieConsent() === 'true';
        if (state && hasConsentedStatisticsCookie) {
            setCookieIfNeeded(GA_COOKIE_NAME, state.auth ? state.auth.gaString : null, SSO_COOKIE_AGE_IN_DAYS);
        }
    }
    registerConfiguredOnLogout() {
        this.subscribe('logout', () => {
            this.deleteGaCookieIfExists();
            setSessionInfo({});
            if (this.conf.registerCookies && shouldRegisterCookies() && getCookie(OPENAM_COOKIE_NAME)) {
                deleteCookie(OPENAM_COOKIE_NAME);
            }
            if (this.conf.onLogout) {
                this.conf.onLogout();
            }
        });
    }
    registerSaveDealerPreferences() {
        this.subscribe('save-dealer-preferences', data => {
            if (this.conf.onSaveDealerPreferences) {
                this.conf.onSaveDealerPreferences(data);
            }
        });
    }
    clearDealerTimeouts() {
        if (this.sessionExpirationNoticeTimeout || this.sessionExpirationTimeout) {
            clearInterval(this.sessionExpirationNoticeTimeout);
            clearInterval(this.sessionExpirationTimeout);
        }
    }
    handleDealerSessionDuration(state) {
        this.dealerSessionExpirationTime = state === null || state === void 0 ? void 0 : state.sessionExpirationTime;
        if (this.dealerSessionExpirationTime) {
            this.clearDealerTimeouts();
            this.sessionExpirationNoticeTimeout = this.startTimerForDealerAuthentication();
            this.sessionExpirationTimeout = this.startLogoutTimerForDealer();
        }
    }
    /** Renders a temporary iframe containing sso webapi page, and removes it after it has loaded (and posted its message). */
    renderTempAuthFrame(src) {
        let iframe = document.createElement('iframe');
        iframe.id = 'sso.iframe';
        iframe.src = src;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        iframe.onload = () => {
            setTimeout(() => {
                iframe.remove();
            }, 0);
        };
    }
    setIframe(target) {
        if (!target) {
            throw new Error('Iframe not accessible, is dom loaded?');
        }
        this.iframe = target;
    }
    subscribe(action, callback, isPromise = false) {
        let handler = { action, callback, isPromise };
        this.handlers.unshift(handler); // insert to beginning
        return handler;
    }
    unsubscribe(handler) {
        const handlerIndex = this.handlers.indexOf(handler);
        if (handlerIndex === -1) {
            throw new Error(`Attempted to remove a handler but no matching handler was found.`);
        }
        this.handlers.splice(handlerIndex, 1);
    }
    onMessageReceived(event) {
        if (!URLUtil.getDomainNameFromUrl(event.origin)) {
            return;
        }
        if (typeof event.data !== 'object') {
            return; // invalid message
        }
        if (!event.data.action) {
            return;
        }
        const unsubscribeList = [];
        const handled = this.handlers.reduce((accumulatedHandled, handler) => {
            if (handler.action === event.data.action) {
                handler.callback(event.data.data);
                if (handler.isPromise) {
                    unsubscribeList.push(handler);
                }
                return true;
            }
            return accumulatedHandled;
        }, false);
        // cleanup promises
        unsubscribeList.forEach((item) => {
            this.unsubscribe(item);
        });
        if (!ignoredActions.includes(event.data.action) && !handled) {
            log(`Action ${event.data.action} has no subscribers`);
        }
    }
}
function optionsToParamsStr(options) {
    const toHttpParamName = (optionKey) => {
        return (optionKey === 'authLevel') ? 'authlevel' : optionKey;
    };
    options.allowStatisticsCookies = statisticsCookieConsent();
    const paramStrs = [];
    for (const optionKey of Object.keys(options)) {
        if (optionKey && options[optionKey]) {
            paramStrs.push(`${toHttpParamName(optionKey)}=${options[optionKey]}`);
        }
    }
    return paramStrs.join('&');
}
function log(...args) {
    console.log('[SSO]', ...args);
}
function setSessionInfo(data) {
    var _a, _b, _c, _d;
    // @ts-ignore
    if (!window.telia) {
        // @ts-ignore
        window.telia = {};
    }
    // @ts-ignore
    window.telia.session = {
        customer_id: (_b = (_a = data.auth) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.customerId,
        employee_id: (_d = (_c = data.auth) === null || _c === void 0 ? void 0 : _c.dealer) === null || _d === void 0 ? void 0 : _d.userName
    };
}
function statisticsCookieConsent() {
    var _a, _b, _c;
    // @ts-ignore
    if (!((_a = window.Cookiebot) === null || _a === void 0 ? void 0 : _a.hasResponse)) {
        return '';
    }
    // @ts-ignore
    const isConsentGiven = (_c = (_b = window.Cookiebot) === null || _b === void 0 ? void 0 : _b.consent) === null || _c === void 0 ? void 0 : _c.statistics;
    return isConsentGiven === undefined ? '' : `${isConsentGiven}`;
}
function getSsoCookieValue(ssoSessionToken) {
    return ssoSessionToken ? ssoSessionToken.split('.')[0] : '';
}
function isTeliaDomain() {
    return getRootDomain() === 'telia.ee';
}
function shouldRegisterCookies() {
    return !isTeliaDomain() && URLUtil.resolveBackendHost() == 'telia.ee';
}
function getRootDomain() {
    return URLUtil.getDomainName(window.location.hostname);
}
function setCookieIfNeeded(name, value, days) {
    const currentValue = getCookie(name);
    if (!value && currentValue) {
        deleteCookie(name);
    }
    else if (value !== currentValue) {
        setCookie(name, value, days);
    }
}
function getCookie(name) {
    const cookies = '; ' + document.cookie;
    const parts = cookies.split(`; ${name}=`);
    if (parts.length == 2) {
        let part = parts.pop();
        return part ? part.split(';').shift() : null;
    }
    return null;
}
function setCookie(name, value, days = 7) {
    const domain = getRootDomain();
    if (domain) {
        const expires = new Date(Date.now() + days * ONE_DAY_IN_MILLIS).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${domain}; SameSite=None; secure`;
    }
}
function deleteCookie(name) {
    if (getCookie(name)) {
        setCookie(name, '', -1);
    }
}
window['SsoClient'] = SsoClient;




/***/ }),

/***/ 1400:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),

/***/ 488:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class ContactInfoAPI {
    constructor(componentsApiBaseUrl) {
        Object.defineProperty(this, "PERSON_CONTACT_INFO_BASE_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person'
        });
        Object.defineProperty(this, "GET_PERSON_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person'
        });
        Object.defineProperty(this, "PUT_PERSON_COMMUNICATION_LANGUAGE_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person/contact-info/communication-language'
        });
        Object.defineProperty(this, "PUT_PERSON_CONTACT_INFO_CONFIRMED_TS_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person/contact-info-confirmed-ts'
        });
        Object.defineProperty(this, "PUT_PERSON_CONTACT_INFO_UPDATE_EMAIL_AND_PHONE", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person/contact-info/email-and-phone'
        });
        Object.defineProperty(this, "GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/contact-info'
        });
        Object.defineProperty(this, "POST_PRIVATE_CUSTOMERS_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/private-customers'
        });
        Object.defineProperty(this, "POST_LEGAL_ENTITY_CUSTOMERS_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/legal-entity-customers'
        });
        Object.defineProperty(this, "componentsApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "CUSTOMER_PERSON_CONTACT_INFO_BASE_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer-person'
        });
        this.componentsApiBaseUrl = componentsApiBaseUrl;
    }
    getPerson() {
        return ApiUtil_1.default.get(this.componentsApiBaseUrl.concat(this.GET_PERSON_PATH));
    }
    postPrivateCustomer(privateCustomerResource) {
        return ApiUtil_1.default.post(this.componentsApiBaseUrl.concat(this.POST_PRIVATE_CUSTOMERS_PATH), privateCustomerResource);
    }
    postLegalEntityCustomer(legalEntityCustomerResource) {
        return ApiUtil_1.default.post(this.componentsApiBaseUrl.concat(this.POST_LEGAL_ENTITY_CUSTOMERS_PATH), legalEntityCustomerResource);
    }
    getContactInfo(isPrivate, customerPersonId) {
        const baseUrl = this.componentsApiBaseUrl.concat(this.getContactInfoBaseUrl(isPrivate).concat(this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH));
        const url = customerPersonId ? `${baseUrl}/${customerPersonId}` : baseUrl;
        return ApiUtil_1.default.get(url);
    }
    putContactInfo(isPrivate, contactInfo) {
        return ApiUtil_1.default.put(this.componentsApiBaseUrl.concat(this.getContactInfoBaseUrl(isPrivate).concat(this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH)), contactInfo);
    }
    postContactInfo(isPrivate, contactInfo, customerPersonId) {
        const baseUrl = this.componentsApiBaseUrl.concat(this.getContactInfoBaseUrl(isPrivate).concat(this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH));
        const url = customerPersonId ? `${baseUrl}/${customerPersonId}` : baseUrl;
        return ApiUtil_1.default.post(url, contactInfo);
    }
    deleteContactInfo(contactInfoId) {
        return ApiUtil_1.default.delete(this.componentsApiBaseUrl.concat(`${this.PERSON_CONTACT_INFO_BASE_URL}${this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH}/${contactInfoId}`));
    }
    putPersonContactInfoConfirmedTs() {
        return ApiUtil_1.default.put(this.componentsApiBaseUrl.concat(this.PUT_PERSON_CONTACT_INFO_CONFIRMED_TS_PATH));
    }
    putPersonCommunicationLanguage(value) {
        return ApiUtil_1.default.put(this.componentsApiBaseUrl.concat(this.PUT_PERSON_COMMUNICATION_LANGUAGE_PATH), value, { headers: { 'Content-Type': 'text/plain' } });
    }
    putEmailAndPhoneNumberContactInformations(contactInfos) {
        return ApiUtil_1.default.put(this.componentsApiBaseUrl.concat(this.PUT_PERSON_CONTACT_INFO_UPDATE_EMAIL_AND_PHONE), contactInfos);
    }
    getContactInfoBaseUrl(isPrivate) {
        return isPrivate ? this.PERSON_CONTACT_INFO_BASE_URL : this.CUSTOMER_PERSON_CONTACT_INFO_BASE_URL;
    }
}
exports["default"] = ContactInfoAPI;


/***/ }),

/***/ 1417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
const Config_1 = __importDefault(__webpack_require__(5269));
class ContactInfoValidationApi {
    static isContactInfoValidated(contactInfoId) {
        return ApiUtil_1.default.get(`${Config_1.default.apiUrl}/validation/contact-info/${contactInfoId}/is-validated`);
    }
    static sendContactInfoValidationCode(contactInfoId) {
        return ApiUtil_1.default.post(`${Config_1.default.apiUrl}/validation/contact-info/${contactInfoId}/send-code`);
    }
    static validateByValidationCodeAndContactInfoId(contactInfoId, validationCode) {
        return ApiUtil_1.default.post(`${Config_1.default.apiUrl}/validation/contact-info/${contactInfoId}/code/${validationCode}/validate`);
    }
}
exports["default"] = ContactInfoValidationApi;


/***/ }),

/***/ 3803:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importStar(__webpack_require__(2965));
class ContractAPI {
    constructor(apiBaseUrl) {
        Object.defineProperty(this, "CUSTOMER_CONTRACT_BASE_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract'
        });
        Object.defineProperty(this, "GET_CONTRACT_DOCUMENT_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/document'
        });
        Object.defineProperty(this, "GET_SIGNED_CUSTOMER_CONTRACT_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/is-signed'
        });
        Object.defineProperty(this, "GET_PREPARED_CLICK_ACCEPT_CONTRACT_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/has-prepared-click-accept'
        });
        Object.defineProperty(this, "GET_PREPARED_ON_SCREEN_CONTRACT_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/has-prepared-on-screen'
        });
        Object.defineProperty(this, "GET_PREPARED_PAPER_CONTRACT_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/has-prepared-paper'
        });
        Object.defineProperty(this, "POST_DATA_REFRESH_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/data-refresh'
        });
        Object.defineProperty(this, "POST_SIGN_CONTRACT_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/sign'
        });
        Object.defineProperty(this, "PUT_CUSTOMER_SIGNER_PATH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/customer/contract/customer-signers'
        });
        Object.defineProperty(this, "crmApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.crmApiBaseUrl = apiBaseUrl;
    }
    getSignedCustomerContract() {
        return ApiUtil_1.default.get(this.crmApiBaseUrl.concat(this.GET_SIGNED_CUSTOMER_CONTRACT_PATH));
    }
    getPreparedClickAcceptContract() {
        return ApiUtil_1.default.get(this.crmApiBaseUrl.concat(this.GET_PREPARED_CLICK_ACCEPT_CONTRACT_PATH));
    }
    getPreparedOnScreenContract() {
        return ApiUtil_1.default.get(this.crmApiBaseUrl.concat(this.GET_PREPARED_ON_SCREEN_CONTRACT_PATH));
    }
    getPreparedPaperContract() {
        return ApiUtil_1.default.get(this.crmApiBaseUrl.concat(this.GET_PREPARED_PAPER_CONTRACT_PATH));
    }
    postContractDataRefresh(contractId) {
        return ApiUtil_1.default.post(this.crmApiBaseUrl.concat(this.POST_DATA_REFRESH_PATH), contractId);
    }
    postNewContract(templateCode) {
        return ApiUtil_1.default.post(this.crmApiBaseUrl.concat(this.CUSTOMER_CONTRACT_BASE_PATH), templateCode, { headers: { 'Content-Type': 'text/plain' } });
    }
    postSignContract(contractId) {
        return ApiUtil_1.default.post(this.crmApiBaseUrl.concat(this.POST_SIGN_CONTRACT_PATH), contractId);
    }
    postSignDealerContract(contractId) {
        return ApiUtil_1.default.post(this.crmApiBaseUrl.concat(`${this.CUSTOMER_CONTRACT_BASE_PATH}/${contractId}/signing`));
    }
    postOnScreenSignatures(contractId, data) {
        return ApiUtil_1.default.post(this.crmApiBaseUrl.concat(`${this.CUSTOMER_CONTRACT_BASE_PATH}/${contractId}/on-screen-signatures`), data);
    }
    getContractDocument(contractId) {
        const queryParams = { ...ApiUtil_1.API_CONF, responseType: 'blob', timeout: 10000 };
        return ApiUtil_1.default.get(this.crmApiBaseUrl.concat(`${this.GET_CONTRACT_DOCUMENT_PATH}/${contractId}`), queryParams);
    }
    updateContractSigners(contractId, customerSigners) {
        return ApiUtil_1.default.put(this.crmApiBaseUrl.concat(`${this.PUT_CUSTOMER_SIGNER_PATH}/${contractId}`), { customerSigners });
    }
    putEmployeeSigner(contractId, employeeADUsername) {
        return ApiUtil_1.default.put(this.crmApiBaseUrl.concat(`${this.CUSTOMER_CONTRACT_BASE_PATH}/${contractId}/employee-signer`), { employeeSigner: employeeADUsername });
    }
}
exports["default"] = ContractAPI;


/***/ }),

/***/ 3865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GET_CREDITINFO_LEGAL_ENTITIES_PATH = void 0;
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
exports.GET_CREDITINFO_LEGAL_ENTITIES_PATH = '/creditinfo-legal-entities';
class CreditInfoLegalEntitiesAPI {
    constructor(apiBaseUrl) {
        Object.defineProperty(this, "componentsApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getCreditInfoLegalEntities", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return ApiUtil_1.default.get(this.componentsApiBaseUrl.concat(exports.GET_CREDITINFO_LEGAL_ENTITIES_PATH));
            }
        });
        Object.defineProperty(this, "getCreditInfoLegalEntity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (registrationNumber) => {
                return ApiUtil_1.default.get(`${this.componentsApiBaseUrl.concat(exports.GET_CREDITINFO_LEGAL_ENTITIES_PATH)}/${registrationNumber}`);
            }
        });
        this.componentsApiBaseUrl = apiBaseUrl;
    }
}
exports["default"] = CreditInfoLegalEntitiesAPI;


/***/ }),

/***/ 9697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH = void 0;
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
exports.GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH = '/employees/signature';
class EmployeeSignatureAPI {
    constructor(componentsApiBaseUrl) {
        Object.defineProperty(this, "componentsApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getSignature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return ApiUtil_1.default.get(this.componentsApiBaseUrl.concat(exports.GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH));
            }
        });
        Object.defineProperty(this, "saveSignature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (employeeSignature) => {
                return ApiUtil_1.default.post(this.componentsApiBaseUrl.concat(exports.GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH), employeeSignature);
            }
        });
        Object.defineProperty(this, "deleteSignature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return ApiUtil_1.default.delete(this.componentsApiBaseUrl.concat(exports.GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH));
            }
        });
        this.componentsApiBaseUrl = componentsApiBaseUrl;
    }
}
exports["default"] = EmployeeSignatureAPI;


/***/ }),

/***/ 9353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class InvoiceSettingsAPI {
    constructor(apiBaseUrl) {
        Object.defineProperty(this, "componentsApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getCustomerInvoiceSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (customerId, brand) => {
                return ApiUtil_1.default.get(this.componentsApiBaseUrl.concat(`/customers/${customerId}/invoice-settings/brand/${brand}`));
            }
        });
        Object.defineProperty(this, "putCustomerInvoiceSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (customerId, referenceNumber, brand, invoiceSetting) => {
                return ApiUtil_1.default.put(this.componentsApiBaseUrl.concat(`/customers/${customerId}/invoice-settings/${referenceNumber}/brand/${brand}`), invoiceSetting);
            }
        });
        this.componentsApiBaseUrl = apiBaseUrl;
    }
}
exports["default"] = InvoiceSettingsAPI;


/***/ }),

/***/ 6668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GET_CUSTOMER_MANDATES_PATH = exports.GET_PERSON_MANDATES_PATH = void 0;
const ApiUtil_1 = __importStar(__webpack_require__(2965));
exports.GET_PERSON_MANDATES_PATH = '/mandate/person-mandates';
exports.GET_CUSTOMER_MANDATES_PATH = '/mandate/customer-mandates';
class MandateAPI {
    constructor(apiBaseUrl) {
        Object.defineProperty(this, "componentsApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getPersonMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return ApiUtil_1.default.get(this.componentsApiBaseUrl.concat(exports.GET_PERSON_MANDATES_PATH));
            }
        });
        Object.defineProperty(this, "getCustomerMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (registrationNumber) => {
                const paramsMap = {};
                if (registrationNumber) {
                    paramsMap.registrationNumber = registrationNumber;
                }
                return ApiUtil_1.default.get(this.componentsApiBaseUrl.concat((0, ApiUtil_1.getUrl)(exports.GET_CUSTOMER_MANDATES_PATH, paramsMap)));
            }
        });
        this.componentsApiBaseUrl = apiBaseUrl;
    }
}
exports["default"] = MandateAPI;


/***/ }),

/***/ 2512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importStar(__webpack_require__(2965));
const Config_1 = __importDefault(__webpack_require__(5269));
class MarketingOffersAPI {
    static updateMarketingOffers(marketingOffersAllowed, sms, email) {
        const requestConf = { timeout: ApiUtil_1.API_CONF.timeout };
        const marketingOffersResource = {
            marketingChannelsResource: {
                sms,
                email
            },
            marketingOffersAllowedResource: {
                marketingOffersAllowed
            }
        };
        return ApiUtil_1.default.put(Config_1.default.apiUrl.concat('/marketing-offers'), marketingOffersResource, requestConf);
    }
}
exports["default"] = MarketingOffersAPI;


/***/ }),

/***/ 4918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importStar(__webpack_require__(2965));
const Config_1 = __importDefault(__webpack_require__(5269));
class RegistryAddressAPI {
    static getRegistryAddress(addressId, requestType) {
        const requestConf = { params: { type: requestType }, timeout: ApiUtil_1.API_CONF.timeout };
        return ApiUtil_1.default.get(Config_1.default.apiUrl.concat(`/address/${addressId}`), requestConf).then((response) => response.data);
    }
    static getRegistryAddressSuggestions(searchTerm) {
        const requestConf = { params: { term: searchTerm }, timeout: ApiUtil_1.API_CONF.timeout };
        return ApiUtil_1.default.get(Config_1.default.apiUrl.concat('/address/suggest'), requestConf).then((response) => response.data);
    }
}
exports["default"] = RegistryAddressAPI;


/***/ }),

/***/ 7409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
const Config_1 = __importDefault(__webpack_require__(5269));
class TranslationApi {
    static getTranslations(lang) {
        return ApiUtil_1.default.get(Config_1.default.apiUrl.concat(`/translations/${lang}`));
    }
}
exports["default"] = TranslationApi;


/***/ }),

/***/ 9645:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const DevEnv_1 = __importDefault(__webpack_require__(1943));
const LiveEnv_1 = __importDefault(__webpack_require__(451));
const TestEnv_1 = __importDefault(__webpack_require__(8848));
class EnvironmentPropertiesFactory {
    constructor(environment) {
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        switch (environment) {
            case 'dev':
                this.environment = new DevEnv_1.default();
                break;
            case 'test':
                this.environment = new TestEnv_1.default();
                break;
            case 'live':
                this.environment = new LiveEnv_1.default();
                break;
            default:
                this.environment = new DevEnv_1.default();
                break;
        }
    }
    getEnvironment() {
        return this.environment;
    }
}
exports["default"] = EnvironmentPropertiesFactory;


/***/ }),

/***/ 1943:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class DevEnv {
    constructor() {
        Object.defineProperty(this, "teliaSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-dev.telia.ee'
        });
        Object.defineProperty(this, "diilSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-dev.diil.ee'
        });
        Object.defineProperty(this, "ssoBackendURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://sso-arendus.telia.ee'
        });
        Object.defineProperty(this, "rusGeneralTermsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-dev.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_rus.pdf'
        });
        Object.defineProperty(this, "estGeneralTermsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-dev.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_est.pdf'
        });
        Object.defineProperty(this, "estGoToShopUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://www-dev.telia.ee/kontaktid#esindused'
        });
        Object.defineProperty(this, "rusGoToShopUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://www-dev.telia.ee/ru/kontaktid#esindused'
        });
    }
}
exports["default"] = DevEnv;


/***/ }),

/***/ 451:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class LiveEnv {
    constructor() {
        Object.defineProperty(this, "teliaSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus.telia.ee'
        });
        Object.defineProperty(this, "diilSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus.diil.ee'
        });
        Object.defineProperty(this, "ssoBackendURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://sso.telia.ee'
        });
        Object.defineProperty(this, "rusGeneralTermsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_rus.pdf'
        });
        Object.defineProperty(this, "estGeneralTermsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_est.pdf'
        });
        Object.defineProperty(this, "estGoToShopUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://www.telia.ee/kontaktid#esindused'
        });
        Object.defineProperty(this, "rusGoToShopUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://www.telia.ee/ru/kontaktid#esindused'
        });
    }
}
exports["default"] = LiveEnv;


/***/ }),

/***/ 8848:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class TestEnv {
    constructor() {
        Object.defineProperty(this, "teliaSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-test.telia.ee'
        });
        Object.defineProperty(this, "diilSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-test.diil.ee'
        });
        Object.defineProperty(this, "ssoBackendURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://sso-test.telia.ee'
        });
        Object.defineProperty(this, "rusGeneralTermsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-test.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_rus.pdf'
        });
        Object.defineProperty(this, "estGeneralTermsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://iseteenindus-test.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_est.pdf'
        });
        Object.defineProperty(this, "estGoToShopUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://www-test.telia.ee/kontaktid#esindused'
        });
        Object.defineProperty(this, "rusGoToShopUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'https://www-test.telia.ee/ru/kontaktid#esindused'
        });
    }
}
exports["default"] = TestEnv;


/***/ }),

/***/ 6531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LanguageContext = void 0;
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const ComponentRootStore_1 = __importStar(__webpack_require__(5929));
let ComponentRootStoreProvider = class ComponentRootStoreProvider extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.componentRootStore = new ComponentRootStore_1.default(this.props.environment, this.props.frontLibrary, this.props.brand, this.props.disableSsoClientTabSync);
    }
    render() {
        return (React.createElement(lib_1.LabelProvider, { labels: this.componentRootStore.componentTranslateStore.translations },
            React.createElement(exports.LanguageContext.Provider, { value: this.props.language },
                React.createElement(mobx_react_1.Provider, { ...this.componentRootStore },
                    React.createElement(ComponentRootStore_1.ComponentRootStoreContext.Provider, { value: this.componentRootStore }, this.props.children)))));
    }
};
__decorate([
    mobx_1.observable
], ComponentRootStoreProvider.prototype, "componentRootStore", void 0);
ComponentRootStoreProvider = __decorate([
    mobx_react_1.observer
], ComponentRootStoreProvider);
exports["default"] = ComponentRootStoreProvider;
exports.LanguageContext = React.createContext(null);


/***/ }),

/***/ 6624:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const customerIdAsKey_1 = __importDefault(__webpack_require__(2468));
const StoresUtil_1 = __webpack_require__(5855);
const CountrySelect_1 = __importDefault(__webpack_require__(816));
const ForeignContactAddress_1 = __importDefault(__webpack_require__(804));
const RegistryContactAddress_1 = __importDefault(__webpack_require__(5421));
let ContactAddress = class ContactAddress extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
    }
    get areStoresLoaded() {
        return this.componentContactAddressStore.isLoaded;
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.componentSsoStore.customerId, () => {
            this.componentContactAddressStore.init();
        }, { fireImmediately: true });
    }
    render() {
        if (!this.areStoresLoaded) {
            return this.renderSpinner();
        }
        if (this.componentContactAddressStore.hasAddress) {
            return this.renderContactAddressComponent();
        }
        if (!this.componentContactAddressStore.hasCountrySelected) {
            return this.renderEmptyRegistryAddressComponent();
        }
        if (!this.componentContactAddressStore.isRegistryAddressSelected) {
            return this.renderEmptyForeignAddressComponent();
        }
        return this.renderEmptyRegistryAddressComponent();
    }
    renderSpinner() {
        const { GridColumn, Spinner } = this.frontLibrary;
        return (React.createElement(GridColumn, { width: ['xs-12', 'md-4'] },
            React.createElement(Spinner, null)));
    }
    renderEmptyRegistryAddressComponent() {
        return (React.createElement(React.Fragment, null,
            this.renderCountrySelect(),
            React.createElement(RegistryContactAddress_1.default, { addressWidth: this.props.addressWidth, roomWidth: this.props.roomWidth })));
    }
    renderEmptyForeignAddressComponent() {
        return (React.createElement(React.Fragment, null,
            this.renderCountrySelect(),
            React.createElement(ForeignContactAddress_1.default, { addressWidth: this.props.addressWidth })));
    }
    renderContactAddressComponent() {
        return (React.createElement(React.Fragment, null,
            this.renderCountrySelect(),
            this.componentContactAddressStore.isRegistryAddressSelected ? (React.createElement(RegistryContactAddress_1.default, { addressWidth: this.props.addressWidth, roomWidth: this.props.roomWidth, helper: this.props.registryAddressHelper })) : (React.createElement(ForeignContactAddress_1.default, { addressWidth: this.props.addressWidth }))));
    }
    renderCountrySelect() {
        const { GridColumn, Grid } = this.frontLibrary;
        return (React.createElement(Grid, null,
            React.createElement(GridColumn, { width: this.props.countrySelectWidth },
                React.createElement(CountrySelect_1.default, { currentLanguage: this.props.currentLanguage }))));
    }
};
__decorate([
    mobx_1.computed
], ContactAddress.prototype, "areStoresLoaded", null);
ContactAddress = __decorate([
    customerIdAsKey_1.default,
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactAddress);
exports["default"] = ContactAddress;


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const StoresUtil_1 = __webpack_require__(5855);
let ForeignContactAddress = class ForeignContactAddress extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentForeignAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onRegionChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentForeignAddressEditStore.newForeignAddress.region = value;
                this.setIsAddressDirtyTrue();
            }
        });
        Object.defineProperty(this, "onCityChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentForeignAddressEditStore.newForeignAddress.city = value;
                this.setIsAddressDirtyTrue();
            }
        });
        Object.defineProperty(this, "onStreetChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentForeignAddressEditStore.newForeignAddress.street = value;
                this.setIsAddressDirtyTrue();
            }
        });
        Object.defineProperty(this, "onBuildingChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentForeignAddressEditStore.newForeignAddress.building = value;
                this.setIsAddressDirtyTrue();
            }
        });
        Object.defineProperty(this, "onRoomChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentForeignAddressEditStore.newForeignAddress.room = value;
                this.setIsAddressDirtyTrue();
            }
        });
        Object.defineProperty(this, "onPostalCodeChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentForeignAddressEditStore.newForeignAddress.postalCode = value;
                this.setIsAddressDirtyTrue();
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { translate } = this.componentTranslateStore;
        const { Text, TextField } = this.frontLibrary;
        return (React.createElement(lib_1.Grid, null,
            React.createElement(lib_1.GridColumn, { width: this.props.addressWidth },
                React.createElement(Text, null,
                    React.createElement(TextField, { id: 'foreignAddress-region', label: translate('foreignAddress.region'), value: this.componentForeignAddressEditStore.newForeignAddress.region, onChange: this.onRegionChange }),
                    React.createElement(TextField, { id: 'foreignAddress-city', label: translate('foreignAddress.city'), value: this.componentForeignAddressEditStore.newForeignAddress.city, onChange: this.onCityChange, isInvalid: !this.componentForeignAddressEditStore.isCityValid }),
                    React.createElement(TextField, { id: 'foreignAddress-street', label: translate('foreignAddress.street'), value: this.componentForeignAddressEditStore.newForeignAddress.street, onChange: this.onStreetChange, isInvalid: !this.componentForeignAddressEditStore.isStreetValid }),
                    React.createElement(TextField, { id: 'foreignAddress-building', label: translate('foreignAddress.building'), value: this.componentForeignAddressEditStore.newForeignAddress.building, onChange: this.onBuildingChange }),
                    React.createElement(TextField, { id: 'foreignAddress-room', label: translate('foreignAddress.room'), value: this.componentForeignAddressEditStore.newForeignAddress.room, onChange: this.onRoomChange }),
                    React.createElement(TextField, { id: 'foreignAddress-postal-code', label: translate('foreignAddress.postalCode'), value: this.componentForeignAddressEditStore.newForeignAddress.postalCode, onChange: this.onPostalCodeChange, isInvalid: !this.componentForeignAddressEditStore.isPostalCodeValid })))));
    }
    setIsAddressDirtyTrue() {
        this.componentForeignAddressEditStore.setIsAddressDirtyTrue();
        if (this.props.onAddressChange) {
            this.props.onAddressChange(this.componentForeignAddressEditStore.getAsContactAddress());
        }
    }
};
__decorate([
    mobx_1.action
], ForeignContactAddress.prototype, "onRegionChange", void 0);
__decorate([
    mobx_1.action
], ForeignContactAddress.prototype, "onCityChange", void 0);
__decorate([
    mobx_1.action
], ForeignContactAddress.prototype, "onStreetChange", void 0);
__decorate([
    mobx_1.action
], ForeignContactAddress.prototype, "onBuildingChange", void 0);
__decorate([
    mobx_1.action
], ForeignContactAddress.prototype, "onRoomChange", void 0);
__decorate([
    mobx_1.action
], ForeignContactAddress.prototype, "onPostalCodeChange", void 0);
ForeignContactAddress = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ForeignContactAddress);
exports["default"] = ForeignContactAddress;


/***/ }),

/***/ 5421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const throttle_debounce_1 = __webpack_require__(2189);
const StoresUtil_1 = __webpack_require__(5855);
let RegistryContactAddress = class RegistryContactAddress extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentAddressSuggestionStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistryAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "debouncedFetchAddressAutocompleteOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onRoomChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentRegistryAddressEditStore.setIsAddressDirtyTrue();
                this.componentRegistryAddressEditStore.roomText = value;
                this.componentRegistryAddressEditStore.submitChange();
                if (this.props.onAddressChange) {
                    this.props.onAddressChange(this.componentRegistryAddressEditStore.getAsContactAddress());
                }
            }
        });
        Object.defineProperty(this, "onAddressAutocompleteChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (searchTerm) => {
                this.componentRegistryAddressEditStore.setIsAddressDirtyTrue();
                if (this.componentRegistryAddressEditStore.addressText === searchTerm) {
                    return;
                }
                this.setNewSearchTerm(searchTerm);
                const suggestionItem = findSuggestionItemByLabel(this.suggestions, this.componentRegistryAddressEditStore.addressText);
                if (!suggestionItem) {
                    this.debouncedFetchAddressAutocompleteOptions();
                }
                else {
                    this.onAddressAutocompleteSelection(suggestionItem);
                }
            }
        });
        Object.defineProperty(this, "onAddressAutocompleteSelection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (item) => {
                const address = await this.componentAddressSuggestionStore.getAddressById(item.id);
                this.componentRegistryAddressEditStore.initSelectedAddress(address);
                this.componentRegistryAddressEditStore.initRooms(this.componentRegistryAddressEditStore.roomText);
                this.componentRegistryAddressEditStore.submitChange();
                if (this.props.onAddressChange) {
                    this.props.onAddressChange(this.componentRegistryAddressEditStore.getAsContactAddress());
                }
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    componentDidMount() {
        this.debouncedFetchAddressAutocompleteOptions = (0, throttle_debounce_1.debounce)(350, this.componentRegistryAddressEditStore.fetchAddressSuggestions);
    }
    get roomSuggestions() {
        return this.componentRegistryAddressEditStore.roomOptions.slice();
    }
    get suggestions() {
        return this.componentRegistryAddressEditStore.addressAutocompleteItems.slice();
    }
    render() {
        return this.renderRegistryAddress();
    }
    renderRegistryAddress() {
        const { translate } = this.componentTranslateStore;
        const { Grid, GridColumn, SuggestionField, Icon } = this.frontLibrary;
        const { helper } = this.props;
        return (React.createElement(Grid, null,
            React.createElement(GridColumn, { noGutter: !this.componentRegistryAddressEditStore.addressValidatedOrChanged, width: this.props.addressWidth },
                React.createElement(SuggestionField, { id: "address-field", value: this.componentRegistryAddressEditStore.addressText, label: translate('registryAddress.address'), isInvalid: !this.componentRegistryAddressEditStore.newAddress, items: this.suggestions, onChange: this.onAddressAutocompleteChange, onSelect: this.onAddressAutocompleteSelection, helper: helper })),
            React.createElement(GridColumn, { noGutter: !this.componentRegistryAddressEditStore.addressValidatedOrChanged, width: this.props.roomWidth },
                React.createElement(SuggestionField, { id: "apartment-field", value: this.componentRegistryAddressEditStore.roomText, label: translate('registryAddress.room'), items: this.roomSuggestions, isInvalid: this.componentRegistryAddressEditStore.hasRoomsButNoneSelected(), onChange: this.onRoomChange })),
            !this.componentRegistryAddressEditStore.addressValidatedOrChanged && (React.createElement(GridColumn, null,
                React.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }),
                React.createElement("span", { className: "text-small" }, translate('common.contactInfo.addressUnvalidated'))))));
    }
    setNewSearchTerm(searchTerm) {
        this.componentRegistryAddressEditStore.addressText = searchTerm;
        this.componentRegistryAddressEditStore.selectedAddress = null;
        this.componentRegistryAddressEditStore.roomOptions = [];
        this.componentRegistryAddressEditStore.roomText = '';
    }
};
__decorate([
    mobx_1.computed
], RegistryContactAddress.prototype, "roomSuggestions", null);
__decorate([
    mobx_1.computed
], RegistryContactAddress.prototype, "suggestions", null);
__decorate([
    mobx_1.action
], RegistryContactAddress.prototype, "onRoomChange", void 0);
__decorate([
    mobx_1.action
], RegistryContactAddress.prototype, "setNewSearchTerm", null);
RegistryContactAddress = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], RegistryContactAddress);
exports["default"] = RegistryContactAddress;
const findSuggestionItemByLabel = (suggestions, label) => {
    return suggestions.find((item) => item.label === label);
};


/***/ }),

/***/ 816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const util_1 = __webpack_require__(8910);
const StoresUtil_1 = __webpack_require__(5855);
let CountrySelect = class CountrySelect extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "changeCountry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.componentContactAddressStore.countrySelected = value;
                this.componentContactAddressStore.setIsAddressDirtyTrue();
                this.componentContactAddressStore.setAddressChanged();
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { translate } = this.componentTranslateStore;
        const { Select } = this.frontLibrary;
        return (React.createElement(Select, { id: "country-select", isInvalid: !util_1.CountryUtil.getCountriesContainingSearchTerm('', this.props.currentLanguage), label: translate('countrySelect.country'), live: true, onChange: this.changeCountry, options: util_1.CountryUtil.countriesForView('', this.props.currentLanguage), placeholder: this.placeHolder(), value: this.componentContactAddressStore.countrySelected }));
    }
    placeHolder() {
        return util_1.CountryUtil.getCountryNameByCountryCode(this.componentContactAddressStore.getCountryCode(), this.props.currentLanguage);
    }
};
__decorate([
    mobx_1.action
], CountrySelect.prototype, "changeCountry", void 0);
CountrySelect = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], CountrySelect);
exports["default"] = CountrySelect;


/***/ }),

/***/ 1871:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.iso3166CountryMap = exports.countryAliases = void 0;
exports.countryAliases = [
    { value: 'CO', label: { et: 'Kolumbia', ru: '', en: '' } },
    { value: 'GB', label: { et: 'Inglismaa', ru: '', en: '' } },
    { value: 'GB', label: { et: 'Ühendkuningriik', ru: '', en: '' } },
    { value: 'GB', label: { et: 'Briti', ru: '', en: '' } },
    { value: 'GE', label: { et: 'Georgia', ru: '', en: '' } },
    { value: 'US', label: { et: 'USA', ru: '', en: '' } }
];
exports.iso3166CountryMap = [
    { value: 'AF', label: { et: 'Afganistan', ru: 'Афганистан', en: 'Afghanistan' } },
    { value: 'AX', label: { et: 'Ahvenamaa', ru: 'Аландские острова', en: 'Åland' } },
    { value: 'AL', label: { et: 'Albaania', ru: 'Албания', en: 'Albania' } },
    { value: 'DZ', label: { et: 'Alžeeria', ru: 'Алжир', en: 'Algeria' } },
    { value: 'AS', label: { et: 'Ameerika Samoa', ru: 'Американское Самоа', en: 'American Samoa' } },
    { value: 'US', label: { et: 'Ameerika Ühendriigid', ru: 'США', en: 'United States of America' } },
    { value: 'AD', label: { et: 'Andorra', ru: 'Андорра', en: 'Andorra' } },
    { value: 'AO', label: { et: 'Angola', ru: 'Ангола', en: 'Angola' } },
    { value: 'AI', label: { et: 'Anguilla', ru: 'Ангилья', en: 'Anguilla' } },
    { value: 'AQ', label: { et: 'Antarktis', ru: 'Антарктида', en: 'Antarctica' } },
    { value: 'AG', label: { et: 'Antigua ja Barbuda', ru: 'Антигуа и Барбуда', en: 'Antigua and Barbuda' } },
    { value: 'MO', label: { et: 'Aomen - Hiina erihalduspiirkond', ru: 'Макао', en: 'Macau' } },
    { value: 'AE', label: { et: 'Araabia Ühendemiraadid', ru: 'ОАЭ', en: 'United Arab Emirates' } },
    { value: 'AR', label: { et: 'Argentina', ru: 'Аргентина', en: 'Argentina' } },
    { value: 'AM', label: { et: 'Armeenia', ru: 'Армения', en: 'Armenia' } },
    { value: 'AW', label: { et: 'Aruba', ru: 'Аруба', en: 'Aruba' } },
    { value: 'AZ', label: { et: 'Aserbaidžaan', ru: 'Азербайджан', en: 'Azerbaijan' } },
    { value: 'AU', label: { et: 'Austraalia', ru: 'Австралия', en: 'Australia' } },
    { value: 'AT', label: { et: 'Austria', ru: 'Австрия', en: 'Austria' } },
    { value: 'BS', label: { et: 'Bahama', ru: 'Багамы', en: 'Bahama' } },
    { value: 'BH', label: { et: 'Bahrein', ru: 'Бахрейн', en: 'Bahrain' } },
    { value: 'BD', label: { et: 'Bangladesh', ru: 'Бангладеш', en: 'Bangladesh' } },
    { value: 'BB', label: { et: 'Barbados', ru: 'Барбадос', en: 'Barbados' } },
    { value: 'PW', label: { et: 'Belau', ru: 'Палау', en: 'Palau' } },
    { value: 'BE', label: { et: 'Belgia', ru: 'Бельгия', en: 'Belgium' } },
    { value: 'BZ', label: { et: 'Belize', ru: 'Белиз', en: 'Belize' } },
    { value: 'BJ', label: { et: 'Benin', ru: 'Бенин', en: 'Benin' } },
    { value: 'BM', label: { et: 'Bermuda', ru: 'Бермуды', en: 'Bermuda' } },
    { value: 'BT', label: { et: 'Bhutan', ru: 'Бутан', en: 'Bhutan' } },
    { value: 'BO', label: { et: 'Boliivia', ru: 'Боливия', en: 'Bolivia' } },
    { value: 'BA', label: { et: 'Bosnia ja Hertsegoviina', ru: 'Босния и Герцеговина', en: 'Bosnia and Herzegovina' } },
    { value: 'BW', label: { et: 'Botswana', ru: 'Ботсвана', en: 'Botswana' } },
    { value: 'BV', label: { et: 'Bouvet’i saar', ru: 'Остров Буве', en: 'Bouvet Island' } },
    { value: 'BR', label: { et: 'Brasiilia', ru: 'Бразилия', en: 'Brazil' } },
    { value: 'BQ', label: { et: 'Bonaire, Sint Eustatius ja Saba', ru: 'Бонэйр, Синт-Эстатиус и Саба', en: 'Bonaire, Sint Eustatius and Saba' } },
    { value: 'IO', label: { et: 'Briti India ookeani ala', ru: 'Британская территория в Индийском океане', en: 'British Indian Ocean Territory' } },
    { value: 'VG', label: { et: 'Briti Neitsisaared', ru: 'Британские Виргинские острова', en: 'British Virgin Islands' } },
    { value: 'BN', label: { et: 'Brunei', ru: 'Бруней', en: 'Brunei' } },
    { value: 'BG', label: { et: 'Bulgaaria', ru: 'Болгария', en: 'Bulgaria' } },
    { value: 'BF', label: { et: 'Burkina Faso', ru: 'Буркина-Фасо', en: 'Burkina Faso' } },
    { value: 'BI', label: { et: 'Burundi', ru: 'Бурунди', en: 'Burundi' } },
    { value: 'CO', label: { et: 'Colombia', ru: 'Колумбия', en: 'Colombia' } },
    { value: 'CK', label: { et: 'Cooki saared', ru: 'Острова Кука', en: 'Cook Islands' } },
    { value: 'CR', label: { et: 'Costa Rica', ru: 'Коста-Рика', en: 'Costa Rica' } },
    { value: 'CI', label: { et: 'Côte d`Ivoire', ru: 'Кот-д’Ивуар', en: 'Ivory Coast' } },
    { value: 'CW', label: { et: 'Curaçao', ru: 'Кюрасао', en: 'Curaçao' } },
    { value: 'DJ', label: { et: 'Djibouti', ru: 'Джибути', en: 'Djibouti' } },
    { value: 'DM', label: { et: 'Dominica', ru: 'Доминика', en: 'Dominica' } },
    { value: 'DO', label: { et: 'Dominikaani Vabariik', ru: 'Доминиканская Республика', en: 'Dominican Republic' } },
    { value: 'EC', label: { et: 'Ecuador', ru: 'Эквадор', en: 'Ecuador' } },
    { value: 'EE', label: { et: 'Eesti', ru: 'Эстония', en: 'Estonian' } },
    { value: 'EG', label: { et: 'Egiptus', ru: 'Египет', en: 'Egypt' } },
    { value: 'GQ', label: { et: 'Ekvatoriaal-Guinea', ru: 'Экваториальная Гвинея', en: 'Equatorial Guinea' } },
    { value: 'SV', label: { et: 'El Salvador', ru: 'Сальвадор', en: 'El Salvador' } },
    { value: 'ER', label: { et: 'Eritrea', ru: 'Эритрея', en: 'Eritrea' } },
    { value: 'ET', label: { et: 'Etioopia', ru: 'Эфиопия', en: 'Ethiopia' } },
    { value: 'FK', label: { et: 'Falklandi saared', ru: 'Фолклендские острова', en: 'Falkland Islands' } },
    { value: 'FJ', label: { et: 'Fidži', ru: 'Фиджи', en: 'Fiji' } },
    { value: 'PH', label: { et: 'Filipiinid', ru: 'Филиппины', en: 'Philippines' } },
    { value: 'FO', label: { et: 'Fääri saared', ru: 'Фареры', en: 'Faroe Islands' } },
    { value: 'GA', label: { et: 'Gabon', ru: 'Габон', en: 'Gabon' } },
    { value: 'GM', label: { et: 'Gambia', ru: 'Гамбия', en: 'Gambia' } },
    { value: 'GH', label: { et: 'Ghana', ru: 'Гана', en: 'Ghana' } },
    { value: 'GI', label: { et: 'Gibraltar', ru: 'Гибралтар', en: 'Gibraltar' } },
    { value: 'GD', label: { et: 'Grenada', ru: 'Гренада', en: 'Grenada' } },
    { value: 'GE', label: { et: 'Gruusia', ru: 'Грузия', en: 'Georgia' } },
    { value: 'GL', label: { et: 'Gröönimaa', ru: 'Гренландия', en: 'Greenland' } },
    { value: 'GP', label: { et: 'Guadeloupe', ru: 'Гваделупа', en: 'Guadeloupe' } },
    { value: 'GU', label: { et: 'Guam', ru: 'Гуам', en: 'Guam' } },
    { value: 'GT', label: { et: 'Guatemala', ru: 'Гватемала', en: 'Guatemala' } },
    { value: 'GG', label: { et: 'Guernsey', ru: 'Гернси', en: 'Guernsey' } },
    { value: 'GN', label: { et: 'Guinea', ru: 'Гвинея', en: 'Guinea' } },
    { value: 'GW', label: { et: 'Guinea-Bissau', ru: 'Гвинея-Бисау', en: 'Guinea-Bissau' } },
    { value: 'GY', label: { et: 'Guyana', ru: 'Гайана', en: 'Guyana' } },
    { value: 'HT', label: { et: 'Haiti', ru: 'Гаити', en: 'Haiti' } },
    { value: 'HM', label: { et: 'Heard ja McDonald saared', ru: 'Херд и Макдональд', en: 'Heard Island and McDonald Islands' } },
    { value: 'CN', label: { et: 'Hiina', ru: 'КНР (Китайская Народная Республика)', en: 'China' } },
    { value: 'ES', label: { et: 'Hispaania', ru: 'Испания', en: 'Spain' } },
    { value: 'NL', label: { et: 'Holland', ru: 'Нидерланды', en: 'Holland' } },
    { value: 'HN', label: { et: 'Honduras', ru: 'Гондурас', en: 'Honduras' } },
    { value: 'HK', label: { et: 'Hongkong - Hiina erihalduspiirkond', ru: 'Гонконг', en: 'Hong Kong' } },
    { value: 'HR', label: { et: 'Horvaatia', ru: 'Хорватия', en: 'Croatia' } },
    { value: 'TL', label: { et: 'Ida-Timor', ru: 'Восточный Тимор', en: 'East Timor' } },
    { value: 'IE', label: { et: 'Iirimaa', ru: 'Ирландия', en: 'Ireland' } },
    { value: 'IL', label: { et: 'Iisrael', ru: 'Израиль', en: 'Israel' } },
    { value: 'IN', label: { et: 'India', ru: 'Индия', en: 'India' } },
    { value: 'ID', label: { et: 'Indoneesia', ru: 'Индонезия', en: 'Indonesia' } },
    { value: 'IQ', label: { et: 'Iraak', ru: 'Ирак', en: 'Iraq' } },
    { value: 'IR', label: { et: 'Iraan', ru: 'Иран', en: 'Iran' } },
    { value: 'IS', label: { et: 'Island', ru: 'Исландия', en: 'Iceland' } },
    { value: 'IT', label: { et: 'Itaalia', ru: 'Италия', en: 'Italy' } },
    { value: 'JP', label: { et: 'Jaapan', ru: 'Япония', en: 'Japan' } },
    { value: 'JM', label: { et: 'Jamaica', ru: 'Ямайка', en: 'Jamaica' } },
    { value: 'YE', label: { et: 'Jeemen', ru: 'Йемен', en: 'Yemen' } },
    { value: 'JE', label: { et: 'Jersey', ru: 'Джерси', en: 'Jersey' } },
    { value: 'JO', label: { et: 'Jordaania', ru: 'Иордания', en: 'Jordan' } },
    { value: 'CX', label: { et: 'Jõulusaar', ru: 'Остров Рождества', en: 'Christmas Island' } },
    { value: 'KY', label: { et: 'Kaimanisaared', ru: 'Острова Кайман', en: 'Cayman Islands' } },
    { value: 'KH', label: { et: 'Kambodža', ru: 'Камбоджа', en: 'Cambodia' } },
    { value: 'CM', label: { et: 'Kamerun', ru: 'Камерун', en: 'Cameroon' } },
    { value: 'CA', label: { et: 'Kanada', ru: 'Канада', en: 'Canada' } },
    { value: 'KZ', label: { et: 'Kasahstan', ru: 'Казахстан', en: 'Kazakhstan' } },
    { value: 'QA', label: { et: 'Katar', ru: 'Катар', en: 'Qatar' } },
    { value: 'KE', label: { et: 'Keenia', ru: 'Кения', en: 'Kenya' } },
    { value: 'CF', label: { et: 'Kesk-Aafrika Vabariik', ru: 'ЦАР', en: 'Central African Republic' } },
    { value: 'KI', label: { et: 'Kiribati', ru: 'Кирибати', en: 'Kiribati' } },
    { value: 'KM', label: { et: 'Komoorid', ru: 'Коморы', en: 'Comoros' } },
    { value: 'CD', label: { et: 'Kongo DV', ru: 'Демократическая Республика Конго', en: 'Democratic Republic of the Congo' } },
    { value: 'CG', label: { et: 'Kongo-Brazzaville', ru: 'Республика Конго', en: 'Republic of the Congo' } },
    { value: 'CC', label: { et: 'Kookossaared', ru: 'Кокосовые острова', en: 'Republic of the Congo' } },
    { value: 'GR', label: { et: 'Kreeka', ru: 'Греция', en: 'Greece' } },
    { value: 'CU', label: { et: 'Kuuba', ru: 'Куба', en: 'Cuba' } },
    { value: 'KW', label: { et: 'Kuveit', ru: 'Кувейт', en: 'Kuwait' } },
    { value: 'KG', label: { et: 'Kõrgõzstan', ru: 'Киргизия', en: 'Kyrgyzstan' } },
    { value: 'CY', label: { et: 'Küpros', ru: 'Кипр', en: 'Cyprus' } },
    { value: 'LA', label: { et: 'Laos', ru: 'Лаос', en: 'Laos' } },
    { value: 'LT', label: { et: 'Leedu', ru: 'Литва', en: 'Lithuania' } },
    { value: 'LS', label: { et: 'Lesotho', ru: 'Лесото', en: 'Lesotho' } },
    { value: 'LR', label: { et: 'Libeeria', ru: 'Либерия', en: 'Liberia' } },
    { value: 'LI', label: { et: 'Liechtenstein', ru: 'Лихтенштейн', en: 'Liechtenstein' } },
    { value: 'LB', label: { et: 'Liibanon', ru: 'Ливан', en: 'Lebanon' } },
    { value: 'LY', label: { et: 'Liibüa', ru: 'Ливия', en: 'Libya' } },
    { value: 'LU', label: { et: 'Luksemburg', ru: 'Люксембург', en: 'Luxembourg' } },
    { value: 'ZA', label: { et: 'Lõuna-Aafrika Vabariik', ru: 'ЮАР', en: 'Republic of South Africa' } },
    {
        value: 'GS',
        label: { et: 'Lõuna-Georgia ja Lõuna-Sandwichi saared', ru: 'Южная Георгия и Южные Сандвичевы Острова', en: 'South Georgia and the South Sandwich Islands' }
    },
    { value: 'KR', label: { et: 'Lõuna-Korea', ru: 'Республика Корея', en: 'South Korea' } },
    { value: 'LV', label: { et: 'Läti', ru: 'Латвия', en: 'Latvia' } },
    { value: 'EH', label: { et: 'Lääne-Sahara', ru: 'САДР', en: 'Western Sahara' } },
    { value: 'MG', label: { et: 'Madagaskar', ru: 'Мадагаскар', en: 'Madagascar' } },
    { value: 'MK', label: { et: 'Makedoonia', ru: 'Македония', en: 'Macedonia' } },
    { value: 'MY', label: { et: 'Malaisia', ru: 'Малайзия', en: 'Malaysia' } },
    { value: 'MW', label: { et: 'Malawi', ru: 'Малави', en: 'Malawi' } },
    { value: 'MV', label: { et: 'Maldiivid', ru: 'Мальдивы', en: 'Maldives' } },
    { value: 'ML', label: { et: 'Mali', ru: 'Мали', en: 'Mali' } },
    { value: 'MT', label: { et: 'Malta', ru: 'Мальта', en: 'Malta' } },
    { value: 'IM', label: { et: 'Mani saar', ru: 'Остров Мэн', en: 'Isle of Man' } },
    { value: 'MA', label: { et: 'Maroko', ru: 'Марокко', en: 'Morocco' } },
    { value: 'MH', label: { et: 'Marshalli saared', ru: 'Маршалловы Остров', en: 'Marshall Islands' } },
    { value: 'MQ', label: { et: 'Martinique', ru: 'Мартиника', en: 'Martinique' } },
    { value: 'MR', label: { et: 'Mauritaania', ru: 'Мавритания', en: 'Mauritania' } },
    { value: 'MU', label: { et: 'Mauritius', ru: 'Маврикий', en: 'Mauritius' } },
    { value: 'YT', label: { et: 'Mayotte', ru: 'Майотта', en: 'Mayotte' } },
    { value: 'MX', label: { et: 'Mehhiko', ru: 'Мексика', en: 'Mexico' } },
    { value: 'FM', label: { et: 'Mikroneesia Liiduriigid', ru: 'Микронезия', en: 'Federated States of Micronesia' } },
    { value: 'MD', label: { et: 'Moldova', ru: 'Молдавия', en: 'Moldova' } },
    { value: 'MC', label: { et: 'Monaco', ru: 'Монако', en: 'Monaco' } },
    { value: 'MN', label: { et: 'Mongoolia', ru: 'Монголия', en: 'Mongolia' } },
    { value: 'ME', label: { et: 'Montenegro', ru: 'Черногория', en: 'Montenegro' } },
    { value: 'MS', label: { et: 'Montserrat', ru: 'Монтсеррат', en: 'Montserrat' } },
    { value: 'MZ', label: { et: 'Mosambiik', ru: 'Мозамбик', en: 'Mozambique' } },
    { value: 'MM', label: { et: 'Myanmar', ru: 'Мьянма', en: 'Myanmar' } },
    { value: 'NA', label: { et: 'Namiibia', ru: 'Намибия', en: 'Namibia' } },
    { value: 'NR', label: { et: 'Nauru', ru: 'Науру', en: 'Nauru' } },
    { value: 'NP', label: { et: 'Nepal', ru: 'Непал', en: 'Nepal' } },
    { value: 'NI', label: { et: 'Nicaragua', ru: 'Никарагуа', en: 'Nicaragua' } },
    { value: 'NG', label: { et: 'Nigeeria', ru: 'Нигерия', en: 'Nigeria' } },
    { value: 'NE', label: { et: 'Niger', ru: 'Нигер', en: 'Niger' } },
    { value: 'NU', label: { et: 'Niue', ru: 'Ниуэ', en: 'Niue' } },
    { value: 'NF', label: { et: 'Norfolk', ru: 'Остров Норфолк', en: 'Norfolk' } },
    { value: 'NO', label: { et: 'Norra', ru: 'Норвегия', en: 'Norway' } },
    { value: 'OM', label: { et: 'Omaan', ru: 'Оман', en: 'Oman' } },
    { value: 'PG', label: { et: 'Paapua Uus-Guinea', ru: 'Папуа - Новая Гвинея', en: 'Papua New Guinea' } },
    { value: 'PK', label: { et: 'Pakistan', ru: 'Пакистан', en: 'Pakistan' } },
    { value: 'PS', label: { et: 'Palestiina ala', ru: 'Государство Палестина', en: 'Palestine' } },
    { value: 'PA', label: { et: 'Panama', ru: 'Панама', en: 'Panama' } },
    { value: 'PY', label: { et: 'Paraguay', ru: 'Парагвай', en: 'Paraguay' } },
    { value: 'PE', label: { et: 'Peruu', ru: 'Перу', en: 'Peru' } },
    { value: 'PN', label: { et: 'Pitcairn', ru: 'Острова Питкэрн', en: 'Pitcairn' } },
    { value: 'PL', label: { et: 'Poola', ru: 'Польша', en: 'Poland' } },
    { value: 'PT', label: { et: 'Portugal', ru: 'Португалия', en: 'Portugal' } },
    { value: 'GF', label: { et: 'Prantsuse Guajaana', ru: 'Гвиана', en: 'French Guiana' } },
    { value: 'TF', label: { et: 'Prantsuse Lõunaalad', ru: 'Французские Южные и Антарктические Территории', en: 'French Southern Territories' } },
    { value: 'PF', label: { et: 'Prantsuse Polüneesia', ru: 'Французская Полинезия', en: 'French Polynesia' } },
    { value: 'FR', label: { et: 'Prantsusmaa', ru: 'Франция', en: 'France' } },
    { value: 'PR', label: { et: 'Puerto Rico', ru: 'Пуэрто-Рико', en: 'Puerto Rico' } },
    { value: 'KP', label: { et: 'Põhja-Korea', ru: 'КНДР (Корейская Народно-Демократическая Республика)', en: 'North Korea' } },
    { value: 'MP', label: { et: 'Põhja-Mariaanid', ru: 'Северные Марианские Острова', en: 'Northern Mariana Islands' } },
    { value: 'RE', label: { et: 'Réunion', ru: 'Реюньон', en: 'Réunion' } },
    { value: 'CV', label: { et: 'Roheneemesaared', ru: 'Кабо-Верде', en: 'Cape Verde' } },
    { value: 'SE', label: { et: 'Rootsi', ru: 'Швеция', en: 'Sweden' } },
    { value: 'SX', label: { et: 'Sint Maarten', ru: 'Синт-Мартен', en: 'Sint Maarten' } },
    { value: 'RO', label: { et: 'Rumeenia', ru: 'Румыния', en: 'Romania' } },
    { value: 'RW', label: { et: 'Rwanda', ru: 'Руанда', en: 'Rwanda' } },
    { value: 'SB', label: { et: 'Saalomoni Saared', ru: 'Соломоновы Острова', en: 'Solomon Islands' } },
    { value: 'BL', label: { et: 'Saint Barthélemy', ru: 'Сен-Бартелеми', en: 'Saint-Barthélemy' } },
    { value: 'SH', label: { et: 'Saint Helena', ru: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья', en: 'Saint Helena' } },
    { value: 'KN', label: { et: 'Saint Kitts ja Nevis', ru: 'Сент-Китс и Невис', en: 'Saint Kitts and Nevis' } },
    { value: 'LC', label: { et: 'Saint Lucia', ru: 'Сент-Люсия', en: 'Saint Lucia' } },
    { value: 'MF', label: { et: 'Saint Martin', ru: 'Сен-Мартен', en: 'Saint Martin' } },
    { value: 'PM', label: { et: 'Saint Pierre ja Miquelon', ru: 'Сен-Пьер и Микелон', en: 'Saint Pierre and Miquelon' } },
    { value: 'VC', label: { et: 'Saint Vincent ja Grenadiinid', ru: 'Сент-Винсент и Гренадины', en: 'Saint Vincent and the Grenadines' } },
    { value: 'DE', label: { et: 'Saksamaa', ru: 'Германия', en: 'Germany' } },
    { value: 'ZM', label: { et: 'Sambia', ru: 'Замбия', en: 'Zambia' } },
    { value: 'WS', label: { et: 'Samoa', ru: 'Самоа', en: 'Samoa' } },
    { value: 'SM', label: { et: 'San Marino', ru: 'Сан-Марино', en: 'San Marino' } },
    { value: 'ST', label: { et: 'São Tomé ja Príncipe', ru: 'Сан-Томе и Принсипи', en: 'São Tomé and Príncipe' } },
    { value: 'SA', label: { et: 'Saudi Araabia', ru: 'Аравия', en: 'Saudi Arabia' } },
    { value: 'SC', label: { et: 'Seišellid', ru: 'Сейшельские Острова', en: 'Seychelles' } },
    { value: 'SN', label: { et: 'Senegal', ru: 'Сенегал', en: 'Senegal' } },
    { value: 'RS', label: { et: 'Serbia', ru: 'Сербия', en: 'Serbia' } },
    { value: 'SL', label: { et: 'Sierra Leone', ru: 'Сьерра-Леоне', en: 'Sierra Leone' } },
    { value: 'SG', label: { et: 'Singapur', ru: 'Сингапур', en: 'Singapore' } },
    { value: 'SK', label: { et: 'Slovakkia', ru: 'Словакия', en: 'Slovakia' } },
    { value: 'SI', label: { et: 'Sloveenia', ru: 'Словения', en: 'Slovenia' } },
    { value: 'SO', label: { et: 'Somaalia', ru: 'Сомали', en: 'Somalia' } },
    { value: 'FI', label: { et: 'Soome', ru: 'Финляндия', en: 'Finland' } },
    { value: 'LK', label: { et: 'Sri Lanka', ru: 'Шри-Ланка', en: 'Sri Lanka' } },
    { value: 'SD', label: { et: 'Sudaan', ru: 'Судан', en: 'Sudan' } },
    { value: 'SS', label: { et: 'Lõuna-Sudaan', ru: 'Южный Судан', en: 'South Sudan' } },
    { value: 'SR', label: { et: 'Suriname', ru: 'Суринам', en: 'Suriname' } },
    { value: 'GB', label: { et: 'Suurbritannia', ru: 'Великобритания', en: 'Great Britain' } },
    { value: 'SZ', label: { et: 'Svaasimaa', ru: 'Свазиленд', en: 'Swaziland' } },
    { value: 'SJ', label: { et: 'Svalbard ja Jan Mayen', ru: 'Шпицберген и Ян-Майен', en: 'Svalbard and Jan Mayen' } },
    { value: 'SY', label: { et: 'Süüria', ru: 'Сирия', en: 'Syria' } },
    { value: 'CH', label: { et: 'Šveits', ru: 'Швейцария', en: 'Switzerland' } },
    { value: 'ZW', label: { et: 'Zimbabwe', ru: 'Зимбабве', en: 'Zimbabwe' } },
    { value: 'DK', label: { et: 'Taani', ru: 'Дания', en: 'Denmark' } },
    { value: 'TJ', label: { et: 'Tadžikistan', ru: 'Таджикистан', en: 'Tajikistan' } },
    { value: 'TH', label: { et: 'Tai', ru: 'Таиланд', en: 'Thailand' } },
    { value: 'TW', label: { et: 'Taiwan', ru: 'Китайская Республика', en: 'Taiwan' } },
    { value: 'TZ', label: { et: 'Tansaania', ru: 'Танзания', en: 'Tanzania' } },
    { value: 'TG', label: { et: 'Togo', ru: 'Того', en: 'Togo' } },
    { value: 'TK', label: { et: 'Tokelau', ru: 'Токелау', en: 'Tokelau' } },
    { value: 'TO', label: { et: 'Tonga', ru: 'Тонга', en: 'Tonga' } },
    { value: 'TT', label: { et: 'Trinidad ja Tobago', ru: 'Тринидад и Тобаго', en: 'Trinidad and Tobago' } },
    { value: 'TD', label: { et: 'Tšaad', ru: 'Чад', en: 'Chad' } },
    { value: 'CZ', label: { et: 'Tšehhi', ru: 'Чехия', en: 'Czech Republic' } },
    { value: 'CL', label: { et: 'Tšiili', ru: 'Чили', en: 'Chile' } },
    { value: 'TN', label: { et: 'Tuneesia', ru: 'Тунис', en: 'Tunisia' } },
    { value: 'TC', label: { et: 'Turks ja Caicos', ru: 'Тёркс и Кайкос', en: 'Turks and Caicos' } },
    { value: 'TV', label: { et: 'Tuvalu', ru: 'Тувалу', en: 'Tuvalu' } },
    { value: 'TR', label: { et: 'Türgi', ru: 'Турция', en: 'Turkey' } },
    { value: 'TM', label: { et: 'Türkmenistan', ru: 'Туркмения', en: 'Turkmenistan' } },
    { value: 'UG', label: { et: 'Uganda', ru: 'Уганда', en: 'Uganda' } },
    { value: 'UA', label: { et: 'Ukraina', ru: 'Украина', en: 'Ukraine' } },
    { value: 'HU', label: { et: 'Ungari', ru: 'Венгрия', en: 'Hungary' } },
    { value: 'UY', label: { et: 'Uruguay', ru: 'Уругвай', en: 'Uruguay' } },
    { value: 'VI', label: { et: 'USA Neitsisaared', ru: 'Виргинские Острова (США)', en: 'United States Virgin Islands' } },
    { value: 'UZ', label: { et: 'Usbekistan', ru: 'Узбекистан', en: 'Uzbekistan' } },
    { value: 'NC', label: { et: 'Uus-Kaledoonia', ru: 'Новая Каледония', en: 'New Caledonia' } },
    { value: 'NZ', label: { et: 'Uus-Meremaa', ru: 'Новая Зеландия', en: 'New Zealand' } },
    { value: 'BY', label: { et: 'Valgevene', ru: 'Белоруссия', en: 'Belarus' } },
    { value: 'WF', label: { et: 'Wallis ja Futuna', ru: 'Уоллис и Футуна', en: 'Wallis and Futuna' } },
    { value: 'VU', label: { et: 'Vanuatu', ru: 'Вануату', en: 'Vanuatu' } },
    { value: 'VA', label: { et: 'Vatikan', ru: 'Ватикан', en: 'Vatican' } },
    { value: 'RU', label: { et: 'Venemaa', ru: 'Россия', en: 'Russia' } },
    { value: 'VE', label: { et: 'Venezuela', ru: 'Венесуэла', en: 'Venezuela' } },
    { value: 'VN', label: { et: 'Vietnam', ru: 'Вьетнам', en: 'Vietnam' } },
    { value: 'UM', label: { et: 'Ühendriikide hajasaared', ru: 'Внешние малые острова (США)', en: 'United States Minor Outlying Islands' } },
    { value: 'OTHER', label: { et: 'Muu', ru: 'Другая страна', en: 'Other' } }
];


/***/ }),

/***/ 6331:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const StoresUtil_1 = __webpack_require__(5855);
let ApplicationErrorBoundary = class ApplicationErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "hasError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        if (this.hasError) {
            const { Container, Separator, Grid, GridColumn, Logo, Image, Text } = this.frontLibrary;
            return (react_1.default.createElement(Container, null,
                react_1.default.createElement(Separator, { spacing: "medium", color: "invisible" }),
                react_1.default.createElement(Grid, { align: ['center-sm'] },
                    react_1.default.createElement(GridColumn, { width: ['sm-12', 'md-12'] },
                        react_1.default.createElement(Grid, null,
                            react_1.default.createElement(GridColumn, { width: ['sm-6', 'md-6'] },
                                react_1.default.createElement(Text, null,
                                    react_1.default.createElement(Logo, { text: 'Telia' }),
                                    react_1.default.createElement("h1", null, "Vabandame, tekkis tehniline viga"),
                                    react_1.default.createElement(Separator, { spacing: "small", color: "invisible" }),
                                    react_1.default.createElement("h1", null, "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0448\u0438\u0431\u043A"))),
                            react_1.default.createElement(GridColumn, { width: ['sm-6', 'md-6'] },
                                react_1.default.createElement(Separator, { spacing: "small", color: "invisible" }),
                                react_1.default.createElement(Image, { srcset: this.brand === 'TELIA'
                                        ? 'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best/404_dcvqgh.jpg'
                                        : '//res.cloudinary.com/telia/image/upload/c_scale,w_400,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 400w', width: 400, align: "center", alt: "Technical error fallback image" }))))),
                react_1.default.createElement(Separator, { spacing: "medium", color: "invisible" })));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, this.props.children);
    }
    componentDidCatch(error, info) {
        this.hasError = true;
    }
};
__decorate([
    mobx_1.observable
], ApplicationErrorBoundary.prototype, "hasError", void 0);
__decorate([
    mobx_1.action
], ApplicationErrorBoundary.prototype, "componentDidCatch", null);
ApplicationErrorBoundary = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ApplicationErrorBoundary);
exports["default"] = ApplicationErrorBoundary;


/***/ }),

/***/ 6306:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCurrentLanguage = exports.setLanguage = exports.LanguageContext = exports.SsoContext = void 0;
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const react_router_dom_1 = __webpack_require__(9655);
const ComponentRootStore_1 = __importStar(__webpack_require__(5929));
const ApplicationErrorBoundary_1 = __importDefault(__webpack_require__(6331));
const NavigationUtil_1 = __importDefault(__webpack_require__(5853));
const util_1 = __webpack_require__(8910);
const MandateUtil_1 = __importDefault(__webpack_require__(3225));
const ApplicationWrapper = (0, mobx_react_1.observer)((props) => {
    var _a;
    const [componentRootStore, setComponentRootStore] = React.useState(null);
    const [isEveryMandateLoaded, setIsEveryMandateLoaded] = React.useState(false);
    const { environment, frontLibrary, brand, sso, icons, children, disableSsoClientTabSync, disableSso } = props;
    React.useEffect(() => {
        const rootStore = new ComponentRootStore_1.default(environment, frontLibrary, brand, disableSsoClientTabSync, disableSso);
        rootStore.urlDataStore.redirectUrl = new URLSearchParams(window.location.search).get('goToUrl');
        setComponentRootStore(rootStore);
        initializeMandates();
    }, []);
    React.useEffect(() => {
        initializeMandates();
    }, [sso]);
    const initializeMandates = () => {
        var _a;
        if (((_a = sso === null || sso === void 0 ? void 0 : sso.representative) === null || _a === void 0 ? void 0 : _a.registrationNumber) && (componentRootStore === null || componentRootStore === void 0 ? void 0 : componentRootStore.urlDataStore.componentsAPIURL) && !MandateUtil_1.default.isInitialized) {
            MandateUtil_1.default.initPersonMandates(componentRootStore.urlDataStore.componentsAPIURL).then(() => setIsEveryMandateLoaded(true));
        }
    };
    if (!componentRootStore ||
        !componentRootStore.componentTranslateStore.globalTranslations ||
        (((_a = sso === null || sso === void 0 ? void 0 : sso.representative) === null || _a === void 0 ? void 0 : _a.registrationNumber) && !isEveryMandateLoaded)) {
        return null;
    }
    const { ThemeProvider, LabelProvider, AnalyticsProvider } = componentRootStore.frontLibrary;
    return (React.createElement(ComponentRootStore_1.ComponentRootStoreContext.Provider, { value: componentRootStore },
        React.createElement(ApplicationErrorBoundary_1.default, null,
            React.createElement(exports.SsoContext.Provider, { value: sso },
                React.createElement(ThemeProvider, { getIconPath: (name) => icons + name },
                    React.createElement(LabelProvider, { labels: componentRootStore.componentTranslateStore.globalTranslations },
                        React.createElement(AnalyticsProvider, null,
                            React.createElement(mobx_react_1.Provider, { ...componentRootStore },
                                React.createElement(exports.LanguageContext.Provider, { value: NavigationUtil_1.default.get().currentLanguage },
                                    React.createElement(react_router_dom_1.BrowserRouter, null, children))))))))));
});
exports.SsoContext = React.createContext(null);
exports.LanguageContext = React.createContext(util_1.Language.ET);
const setLanguage = (language) => NavigationUtil_1.default.get().setCurrentLanguage(language);
exports.setLanguage = setLanguage;
const getCurrentLanguage = () => NavigationUtil_1.default.get().currentLanguage;
exports.getCurrentLanguage = getCurrentLanguage;
exports["default"] = ApplicationWrapper;


/***/ }),

/***/ 5741:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__(8910);
const GUEST_LANGUAGE_COOKIE_NAME = 'LANGUAGE_EXT';
const LANGUAGE_ID_TO_LOCALE_MAP = { et_EE: util_1.Language.ET, ru_RU: util_1.Language.RU, en_EN: util_1.Language.EN };
const CookieApi = {
    getLanguageCookieValue() {
        const pair = document.cookie.match(new RegExp(`${GUEST_LANGUAGE_COOKIE_NAME}=([^;]+)`));
        if (!!pair) {
            return LANGUAGE_ID_TO_LOCALE_MAP[pair[1]];
        }
        return undefined;
    },
    languageCookieExists() {
        return document.cookie.includes(GUEST_LANGUAGE_COOKIE_NAME);
    },
    setLanguageCookie: (language, domain = '.telia.ee', expires) => {
        const expirationDate = new Date();
        expirationDate.setFullYear(new Date().getFullYear() + 1);
        const locale = Object.keys(LANGUAGE_ID_TO_LOCALE_MAP).find((key) => LANGUAGE_ID_TO_LOCALE_MAP[key] === language);
        document.cookie = `${GUEST_LANGUAGE_COOKIE_NAME}=${locale}; expires=${expires || expirationDate.toUTCString()}; domain=${domain}; path=/;`;
    }
};
exports["default"] = CookieApi;


/***/ }),

/***/ 3225:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const MandateAPI_1 = __importDefault(__webpack_require__(6668));
class MandateUtil {
    static async initPersonMandates(baseUrl) {
        this.personMandates = [];
        const mandateAPI = new MandateAPI_1.default(baseUrl);
        await mandateAPI
            .getPersonMandates()
            .then(({ data }) => (this.personMandates = data))
            .then(() => (this.isInitialized = true));
    }
    static getReceivedMandatesFrom(customerId) {
        return this.personMandates.filter((personMandate) => personMandate.customerId === customerId);
    }
    static hasDiilMandate(mandate) {
        var _a;
        return (_a = mandate.diilAccounts) === null || _a === void 0 ? void 0 : _a.length;
    }
    static hasTeliaMandate(mandate) {
        var _a, _b, _c;
        return ((_a = mandate.emtAccounts) === null || _a === void 0 ? void 0 : _a.length) || ((_b = mandate.elionAccounts) === null || _b === void 0 ? void 0 : _b.length) || ((_c = mandate.emtProducts) === null || _c === void 0 ? void 0 : _c.length);
    }
    static hasLegalStipulation(customerId) {
        var _a, _b, _c, _d;
        const customerMandates = (_b = (_a = this.personMandates) === null || _a === void 0 ? void 0 : _a.find((personMandate) => personMandate.customerId === customerId)) === null || _b === void 0 ? void 0 : _b.mandates;
        return ((_d = (_c = customerMandates === null || customerMandates === void 0 ? void 0 : customerMandates.find((mandate) => mandate.type === 'LEGAL')) === null || _c === void 0 ? void 0 : _c.representationStipulation) === null || _d === void 0 ? void 0 : _d.length) > 0;
    }
}
exports["default"] = MandateUtil;
Object.defineProperty(MandateUtil, "isInitialized", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: false
});
Object.defineProperty(MandateUtil, "personMandates", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: []
});


/***/ }),

/***/ 5853:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useParams = exports.navigate = exports.removeLanguageSlug = void 0;
const react_router_1 = __webpack_require__(9250);
const CookieApi_1 = __importDefault(__webpack_require__(5741));
const util_1 = __webpack_require__(8910);
class NavigationUtil {
    constructor() {
        Object.defineProperty(this, "currentLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NavigationUtil.currentLanguageFromCookie || NavigationUtil.currentLanguageFromUrl || NavigationUtil.DEFAULT_LANGUAGE
        });
        Object.defineProperty(this, "currentRoute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigateFn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "routeMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "routeErrorsMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    set navigateFunction(navigateFunction) {
        this.navigateFn = navigateFunction;
    }
    static init(brand = 'TELIA', translateStore) {
        NavigationUtil.get().brand = brand;
        NavigationUtil.get().translateStore = translateStore;
        if (!!NavigationUtil.currentLanguageFromCookie && NavigationUtil.currentLanguageFromCookie !== NavigationUtil.currentLanguageFromUrl) {
            (0, exports.navigate)(window.location.pathname + window.location.search, true);
        }
    }
    get navigate() {
        return this.navigateFn;
    }
    getRoute(path) {
        if (path === '*') {
            return this.routeMap.get('*');
        }
        if (path.charAt(0) !== '/') {
            return undefined;
        }
        const pathToCheck = path.length > 1 && path.endsWith('/') ? path.substring(0, path.length - 1) : path;
        return this.routeMap.get(new URL((0, exports.removeLanguageSlug)(pathToCheck), `https://${window.location.host}`).pathname);
    }
    setRoute(path, route) {
        this.routeMap.set(path, route);
    }
    setCurrentRoute(route) {
        this.currentRoute = route;
    }
    setCurrentLanguage(language) {
        if (this.currentLanguage !== language) {
            this.translateStore.fetchTranslations(language);
            this.currentLanguage = language;
        }
        CookieApi_1.default.setLanguageCookie(language, this.brand === 'TELIA' ? '.telia.ee' : '.diil.ee');
        document.querySelector('html').setAttribute('lang', language);
        const navTarget = window.location.pathname + window.location.search;
        (0, exports.navigate)(navTarget, true);
    }
    setRouteErrors(path, errors) {
        this.routeErrorsMap.set(path, errors);
    }
    getRouteErrors(path) {
        return this.routeErrorsMap.get((0, exports.removeLanguageSlug)(path)) || [];
    }
    static getCurrentLanguageFromUrl() {
        for (const lang in util_1.Language) {
            const langStr = util_1.Language[lang];
            const path = window.location.pathname;
            if (path === `/${langStr}` || path.startsWith(`/${langStr}?`) || path.startsWith(`/${langStr}/`)) {
                return langStr;
            }
        }
        return undefined;
    }
}
exports["default"] = NavigationUtil;
Object.defineProperty(NavigationUtil, "DEFAULT_LANGUAGE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: util_1.Language.ET
});
Object.defineProperty(NavigationUtil, "currentLanguageFromUrl", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: NavigationUtil.getCurrentLanguageFromUrl()
});
Object.defineProperty(NavigationUtil, "currentLanguageFromCookie", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: CookieApi_1.default.getLanguageCookieValue()
});
Object.defineProperty(NavigationUtil, "get", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: () => {
        if (!NavigationUtil.instance) {
            NavigationUtil.instance = new NavigationUtil();
        }
        return NavigationUtil.instance;
    }
});
const removeLanguageSlug = (path) => {
    for (const lang in util_1.Language) {
        const langStr = util_1.Language[lang];
        if (path.startsWith(`/${langStr}/`) || path.startsWith(`/${langStr}?`)) {
            return path.substring(`/${langStr}/`.length - 1);
        }
        if (path === `/${langStr}`) {
            return path.substring(`/${langStr}`.length);
        }
    }
    return path;
};
exports.removeLanguageSlug = removeLanguageSlug;
const addLanguageSlug = (path) => {
    const currentLanguageIsDefault = NavigationUtil.get().currentLanguage === NavigationUtil.DEFAULT_LANGUAGE;
    const pathWithoutLang = (0, exports.removeLanguageSlug)(path);
    return (currentLanguageIsDefault ? '' : '/'.concat(NavigationUtil.get().currentLanguage)).concat(pathWithoutLang);
};
const navigate = (to, keepLanguageSlug = false) => {
    if (to.charAt(0) !== '/' && to !== '*') {
        if (keepLanguageSlug) {
            const url = new URL(to);
            window.location.assign(to.replace(url.pathname, addLanguageSlug(url.pathname)));
        }
        else {
            window.location.assign((0, exports.removeLanguageSlug)(to));
        }
    }
    else {
        const slugWithLang = addLanguageSlug(to);
        NavigationUtil.get().navigate(slugWithLang);
    }
};
exports.navigate = navigate;
const useParams = () => (0, react_router_1.useParams)();
exports.useParams = useParams;


/***/ }),

/***/ 61:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(8156));
class Route extends React.Component {
    constructor(props) {
        super(props);
    }
}
exports["default"] = Route;


/***/ }),

/***/ 9998:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const mobx_react_1 = __webpack_require__(5264);
const StoresUtil_1 = __webpack_require__(5855);
const mobx_1 = __webpack_require__(259);
let RouteErrorBoundary = class RouteErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        if (this.hasError) {
            const { Container, Separator, Notice } = this.frontLibrary;
            const { translateGlobal } = this.componentTranslateStore;
            return (react_1.default.createElement(Container, null,
                react_1.default.createElement(Separator, { spacing: "large", color: "invisible" }),
                react_1.default.createElement(Notice, { type: "error" }, translateGlobal('general.error.message')),
                react_1.default.createElement(Separator, { spacing: "large", color: "invisible" })));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, this.props.children);
    }
    componentDidCatch(error, info) {
        this.hasError = true;
    }
};
__decorate([
    mobx_1.observable
], RouteErrorBoundary.prototype, "hasError", void 0);
__decorate([
    mobx_1.action
], RouteErrorBoundary.prototype, "componentDidCatch", null);
RouteErrorBoundary = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], RouteErrorBoundary);
exports["default"] = RouteErrorBoundary;


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const util_1 = __webpack_require__(8910);
const ContractValidator_1 = __importDefault(__webpack_require__(1445));
const NavigationUtil_1 = __importDefault(__webpack_require__(5853));
const Route_1 = __importDefault(__webpack_require__(61));
const RouteErrorBoundary_1 = __importDefault(__webpack_require__(9998));
const RouteValidator_1 = __importDefault(__webpack_require__(3506));
class RouteUtil {
    constructor(args) {
        Object.defineProperty(this, "sso", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "routeValidator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainRestrictions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainFallbackElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notFoundElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.sso = args.sso;
        this.mainRestrictions = args.restrictions;
        this.routeValidator = new RouteValidator_1.default(args.sso, args.brand);
        this.mainFallbackElement = args.fallbackElement;
        this.notFoundElement = args.notFoundElement;
    }
    getRoutes(routes) {
        const result = [];
        react_1.default.Children.forEach(routes, (c) => {
            const routeElement = RouteUtil.verifyRouteElementType(c);
            const renderElement = this.getRenderElement(routeElement);
            result.push({ path: routeElement.props.path, element: renderElement });
            NavigationUtil_1.default.get().setRoute(routeElement.props.path, routeElement.props);
            result.push(...RouteUtil.getLanguageElements(routeElement, renderElement));
        });
        if (!result.find((route) => route.path === '*')) {
            result.push(this.getCatchAllRoute());
        }
        return result;
    }
    getCatchAllRoute() {
        const routeElement = { path: '*', element: this.notFoundElement };
        NavigationUtil_1.default.get().setRoute('*', routeElement);
        return routeElement;
    }
    static verifyRouteElementType(routeElement) {
        const element = routeElement;
        if (element.type !== Route_1.default) {
            throw new Error('Children of Routes need to be of type Route (from CRM-Components)');
        }
        return element;
    }
    getRenderElement(routeElement) {
        const restrictions = this.getRestrictions(routeElement);
        const routeValid = this.routeValidator.validate(restrictions);
        NavigationUtil_1.default.get().setRouteErrors(routeElement.props.path, this.routeValidator.errors);
        const { customerType, customerContract } = restrictions || {
            customerType: undefined,
            customerContract: { requiresContract: false }
        };
        const FallbackElement = () => null;
        let element = routeValid
            ? this.getRenderElementByCustomerType(routeElement, customerType)
            : routeElement.props.fallbackElement || this.mainFallbackElement || react_1.default.createElement(FallbackElement, null);
        if (customerContract === null || customerContract === void 0 ? void 0 : customerContract.requiresContract) {
            element = (react_1.default.createElement(ContractValidator_1.default, { customer: this.sso.isLoggedIn ? this.sso.representative : undefined, redirectLink: customerContract.redirectLink }, element));
        }
        return react_1.default.createElement(RouteErrorBoundary_1.default, null, element);
    }
    getRestrictions(routeElement) {
        return routeElement.props.restrictions !== null ? { ...this.mainRestrictions, ...routeElement.props.restrictions } : null;
    }
    getRenderElementByCustomerType(routeElement, customerType) {
        switch (customerType) {
            case 'both':
                const rc = routeElement.props.element;
                if (this.sso.representative.type === 'B2C') {
                    return rc.b2c;
                }
                else if (this.sso.representative.type === 'B2B') {
                    return rc.b2b;
                }
                else if (this.sso.representative.type === undefined) {
                    return null;
                }
                throw new Error(`Unknown customer type: ${this.sso.representative.type}`);
            default:
                return routeElement.props.element;
        }
    }
    static getLanguageElements(routeElement, renderElement) {
        const result = [];
        if (routeElement.props.path !== '*') {
            for (const lang in util_1.Language) {
                const langStr = util_1.Language[lang];
                const pathWithLang = `/${langStr}${routeElement.props.path}`;
                result.push({ path: pathWithLang, element: renderElement });
            }
        }
        return result;
    }
}
exports["default"] = RouteUtil;


/***/ }),

/***/ 3506:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RouteErrorType = void 0;
const MandateUtil_1 = __importDefault(__webpack_require__(3225));
var RouteErrorType;
(function (RouteErrorType) {
    RouteErrorType[RouteErrorType["AUTH_LEVEL"] = 0] = "AUTH_LEVEL";
    RouteErrorType[RouteErrorType["USER_TYPE"] = 1] = "USER_TYPE";
    RouteErrorType[RouteErrorType["CUSTOMER_TYPE"] = 2] = "CUSTOMER_TYPE";
    RouteErrorType[RouteErrorType["REPRESENTATIVE"] = 3] = "REPRESENTATIVE";
    RouteErrorType[RouteErrorType["MANDATE"] = 4] = "MANDATE";
    RouteErrorType[RouteErrorType["DEALER_ROLE"] = 5] = "DEALER_ROLE";
    RouteErrorType[RouteErrorType["STIPULATION_PRESENT"] = 6] = "STIPULATION_PRESENT";
})(RouteErrorType = exports.RouteErrorType || (exports.RouteErrorType = {}));
class RouteValidator {
    constructor(sso, brand) {
        Object.defineProperty(this, "sso", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "restrictions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "routeErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.sso = sso;
        this.brand = brand;
    }
    validate(restrictions) {
        this.routeErrors = [];
        if (!restrictions) {
            return true;
        }
        this.restrictions = restrictions;
        const correctAuthLevel = this.validateAuthLevel();
        const correctUserType = this.validateUserType();
        const correctCustomerType = this.validateCustomerType();
        const correctRepresentative = this.validateRepresentative();
        const correctMandates = this.validateMandates();
        const correctDealerRoles = this.validateDealerRoles();
        return correctAuthLevel && correctUserType && correctCustomerType && correctRepresentative && correctMandates && correctDealerRoles;
    }
    get errors() {
        return this.routeErrors;
    }
    validateAuthLevel() {
        const { requiresAuth, requiresHardAuth } = this.restrictions;
        if (!requiresAuth && !requiresHardAuth) {
            return true;
        }
        const { isLoggedIn, isLoggedInWithHardAuth, isDealer } = this.sso;
        if (!!requiresAuth && !isLoggedIn) {
            this.insertErrorText(RouteErrorType.AUTH_LEVEL, 'soft auth', 'not logged in');
            return false;
        }
        if (!!requiresHardAuth && !isLoggedInWithHardAuth && !isDealer) {
            this.insertErrorText(RouteErrorType.AUTH_LEVEL, 'hard auth', isLoggedIn ? 'soft auth' : 'not logged in');
            return false;
        }
        return true;
    }
    validateUserType() {
        const { requiresDealer } = this.restrictions;
        if (!requiresDealer) {
            return true;
        }
        const { isDealer } = this.sso;
        if (!!requiresDealer && !isDealer) {
            this.insertErrorText(RouteErrorType.USER_TYPE, 'dealer', 'not');
            return false;
        }
        return true;
    }
    validateCustomerType() {
        const { customerType } = this.restrictions;
        if (!customerType || customerType === 'both' || customerType === 'any') {
            return true;
        }
        if (customerType === 'B2C' && this.sso.representative.type !== 'B2C') {
            this.insertErrorText(RouteErrorType.CUSTOMER_TYPE, 'B2C', this.sso.representative.type);
            return false;
        }
        if (customerType === 'B2B' && this.sso.representative.type !== 'B2B') {
            this.insertErrorText(RouteErrorType.CUSTOMER_TYPE, 'B2B', this.sso.representative.type);
            return false;
        }
        return true;
    }
    validateRepresentative() {
        var _a;
        const { requiresRepresentative, requiresRepresentingSelf, requiresBrandSpecificOrLegalMandate } = this.restrictions;
        if (!requiresRepresentative && !requiresRepresentingSelf) {
            return true;
        }
        const { representative, loggedInPerson } = this.sso;
        const hasRepresentative = !!representative && !!representative.registrationNumber && !!representative.registrationNumberCountryCode;
        const hasLoggedInPerson = !!loggedInPerson && !!loggedInPerson.registrationNumber && !!loggedInPerson.registrationNumberCountryCode;
        if (requiresBrandSpecificOrLegalMandate) {
            const personMandate = (_a = MandateUtil_1.default.getReceivedMandatesFrom(representative.customerId)) === null || _a === void 0 ? void 0 : _a.find((mandate) => (mandate.customerId = representative.customerId));
            const hasBrandSpecificOrLegalMandate = personMandate === null || personMandate === void 0 ? void 0 : personMandate.mandates.some((authMandate) => (this.brand === 'TELIA' ? MandateUtil_1.default.hasTeliaMandate(authMandate) : MandateUtil_1.default.hasDiilMandate(authMandate)) || authMandate.type === 'LEGAL');
            if (!hasBrandSpecificOrLegalMandate) {
                this.insertErrorText(RouteErrorType.REPRESENTATIVE, 'brand specific or legal mandate', 'none');
                return false;
            }
        }
        if ((requiresRepresentative || requiresRepresentingSelf) && (!hasRepresentative || !hasLoggedInPerson)) {
            this.insertErrorText(RouteErrorType.REPRESENTATIVE, 'any', 'none');
            return false;
        }
        if (requiresRepresentingSelf) {
            if (!!representative.customerId && !!loggedInPerson.customerId) {
                if (representative.customerId !== loggedInPerson.customerId) {
                    this.insertErrorText(RouteErrorType.REPRESENTATIVE, 'self', 'someone else');
                    return false;
                }
                return true;
            }
            if (representative.registrationNumber === loggedInPerson.registrationNumber &&
                representative.registrationNumberCountryCode === loggedInPerson.registrationNumberCountryCode) {
                return true;
            }
            this.insertErrorText(RouteErrorType.REPRESENTATIVE, 'self', 'someone else');
            return false;
        }
        if (!!representative) {
            return true;
        }
        this.insertErrorText(RouteErrorType.REPRESENTATIVE, 'any', 'none');
        return false;
    }
    validateMandates() {
        var _a;
        const { receivedMandates } = this.restrictions;
        if (!receivedMandates) {
            return true;
        }
        const { requiresMandates, filter, applyToLegalMandate, mustNotHaveStipulation } = receivedMandates;
        const { customerId } = this.sso.representative;
        if (mustNotHaveStipulation && MandateUtil_1.default.hasLegalStipulation(customerId)) {
            this.insertErrorText(RouteErrorType.STIPULATION_PRESENT, "user doesn't have stipulation", 'user has stipulation');
            return false;
        }
        const mandateTypes = (_a = MandateUtil_1.default.getReceivedMandatesFrom(customerId)
            .find((personMandate) => personMandate.customerId === customerId)) === null || _a === void 0 ? void 0 : _a.mandates.map((mandate) => mandate.type);
        if (!mandateTypes) {
            this.insertErrorText(RouteErrorType.MANDATE, 'any given mandates', 'no given mandates');
            return false;
        }
        if (!applyToLegalMandate) {
            if (mandateTypes.includes('LEGAL')) {
                return true;
            }
        }
        if (!filter || filter === 'any') {
            const result = !!mandateTypes.find((mandateType) => requiresMandates.includes(mandateType));
            if (!result) {
                this.insertErrorText(RouteErrorType.MANDATE, `any of ${requiresMandates.toString()}`, `${mandateTypes.toString()}`);
            }
            return result;
        }
        const result = !requiresMandates.find((mandate) => !mandateTypes.includes(mandate));
        if (!result) {
            this.insertErrorText(RouteErrorType.MANDATE, `all of ${requiresMandates.toString()}`, `${mandateTypes.toString()}`);
        }
        return result;
    }
    validateDealerRoles() {
        const { requiresDealerRoles } = this.restrictions;
        const { dealerRoles } = this.sso;
        if (!requiresDealerRoles) {
            return true;
        }
        const result = requiresDealerRoles.some((requiredRole) => dealerRoles === null || dealerRoles === void 0 ? void 0 : dealerRoles.includes(requiredRole));
        if (!result) {
            this.insertErrorText(RouteErrorType.DEALER_ROLE, `any of ${requiresDealerRoles.toString()}`, `${dealerRoles === null || dealerRoles === void 0 ? void 0 : dealerRoles.toString()}`);
        }
        return result;
    }
    insertErrorText(type, expected, actual) {
        let errorTypeText;
        switch (type) {
            case RouteErrorType.AUTH_LEVEL:
                errorTypeText = 'insufficient authentication level';
                break;
            case RouteErrorType.USER_TYPE:
                errorTypeText = 'wrong user type';
                break;
            case RouteErrorType.CUSTOMER_TYPE:
                errorTypeText = 'wrong customer type';
                break;
            case RouteErrorType.REPRESENTATIVE:
                errorTypeText = 'wrong representative';
                break;
            case RouteErrorType.MANDATE:
                errorTypeText = 'insufficient mandates';
                break;
            case RouteErrorType.DEALER_ROLE:
                errorTypeText = 'insufficient dealer role';
                break;
            case RouteErrorType.STIPULATION_PRESENT:
                errorTypeText = 'stipulation error';
                break;
            default:
                errorTypeText = 'unknown error';
        }
        const routeErrorPrefix = 'Route validation error';
        const getErrorText = () => `${routeErrorPrefix}: ${errorTypeText} - expected ${expected}, but was ${actual}`;
        this.routeErrors.push({ type, text: getErrorText() });
    }
}
exports["default"] = RouteValidator;


/***/ }),

/***/ 3294:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(8156));
const react_router_1 = __webpack_require__(9250);
const stores_1 = __webpack_require__(4547);
const ApplicationWrapper_1 = __webpack_require__(6306);
const NavigationUtil_1 = __importStar(__webpack_require__(5853));
const RouteUtil_1 = __importDefault(__webpack_require__(3620));
const Routes = (props) => {
    var _a, _b, _c, _d;
    const location = (0, react_router_1.useLocation)();
    const NotFoundElement = () => (React.createElement(Container, null,
        React.createElement(Notice, { type: "error" }, translateGlobal('404.text'))));
    const { frontLibrary: { Notice, Container }, componentTranslateStore: { translateGlobal }, componentTranslateStore, brand } = React.useContext(stores_1.ComponentRootStoreContext);
    const sso = React.useContext(ApplicationWrapper_1.SsoContext);
    const routeUtilProps = {
        sso,
        brand,
        restrictions: props.restrictions,
        fallbackElement: props.fallbackElement,
        notFoundElement: React.createElement(NotFoundElement, null)
    };
    const routeUtil = new RouteUtil_1.default(routeUtilProps);
    const routes = routeUtil.getRoutes(props.children);
    NavigationUtil_1.default.get().navigateFunction = (0, react_router_1.useNavigate)();
    React.useEffect(() => {
        NavigationUtil_1.default.init(brand, componentTranslateStore);
    }, []);
    React.useEffect(() => {
        const [{ route }] = (0, react_router_1.matchRoutes)(routes, location);
        const routeProps = NavigationUtil_1.default.get().getRoute((0, NavigationUtil_1.removeLanguageSlug)(route.path)) || NavigationUtil_1.default.get().getRoute('*');
        if (routeProps) {
            NavigationUtil_1.default.get().setCurrentRoute(routeProps);
            if (routeProps.title) {
                document.title = routeProps.title;
            }
        }
        if (props.onChange) {
            props.onChange(routeProps, NavigationUtil_1.default.get().getRouteErrors(routeProps.path));
        }
    }, [
        location,
        (_a = sso.representative) === null || _a === void 0 ? void 0 : _a.type,
        (_b = sso.representative) === null || _b === void 0 ? void 0 : _b.registrationNumber,
        (_c = sso.representative) === null || _c === void 0 ? void 0 : _c.registrationNumberCountryCode,
        (_d = sso.representative) === null || _d === void 0 ? void 0 : _d.customerId
    ]);
    return (0, react_router_1.useRoutes)(routes);
};
exports["default"] = Routes;


/***/ }),

/***/ 120:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(8156));
const PhoneValidation_1 = __importDefault(__webpack_require__(5520));
const stores_1 = __webpack_require__(4547);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const EmailValidation_1 = __importDefault(__webpack_require__(4768));
const ContactInfoValidationModal = (0, mobx_react_1.observer)((props) => {
    const { componentContactInfoValidationStore: { isModalOpen, isValidationComplete, isLoaded, isEmailValidation, isPhoneValidation }, componentContactInfoValidationStore, componentTranslateStore: { translate }, frontLibrary: { Modal, ModalContent, Button, Container, ModalFooter, Grid, GridColumn } } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    (0, react_1.useEffect)((0, mobx_1.action)(() => {
        componentContactInfoValidationStore.init(props.contactInfo);
        componentContactInfoValidationStore.isModalOpen = props.isOpen;
    }), [props.isOpen, props.contactInfo]);
    (0, react_1.useEffect)(() => {
        if (isModalOpen !== props.isOpen || isValidationComplete) {
            props.onClose(isValidationComplete);
            componentContactInfoValidationStore.reset();
        }
    }, [isModalOpen, isValidationComplete]);
    if (!props.contactInfo || !isLoaded) {
        return null;
    }
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Modal, { size: "6-col", isOpen: isModalOpen, hasContentComponent: true, isClosable: false },
            react_1.default.createElement(ModalContent, null,
                isEmailValidation && react_1.default.createElement(EmailValidation_1.default, { isDealer: props.isDealer }),
                isPhoneValidation && react_1.default.createElement(PhoneValidation_1.default, { isDealer: props.isDealer })),
            react_1.default.createElement(ModalFooter, null,
                react_1.default.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
                    react_1.default.createElement(GridColumn, { width: ['xs'] },
                        react_1.default.createElement(Button, { text: translate('contactInfo.validation.modal.cancel'), type: props.isDealer ? 'employee' : null, iconLeft: "#close", link: true, onClick: () => componentContactInfoValidationStore.reset() })),
                    isPhoneValidation && (react_1.default.createElement(GridColumn, { width: ['xs'] },
                        react_1.default.createElement(Button, { text: translate('contactInfo.validation.modal.phone.confirm'), type: props.isDealer ? 'employee' : null, iconRight: "#arrow-right", onClick: () => componentContactInfoValidationStore.validatePhone() }))))))));
});
exports["default"] = ContactInfoValidationModal;


/***/ }),

/***/ 4768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importStar(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const EmailValidation = (0, mobx_react_1.observer)((props) => {
    const { isDealer } = props;
    const { frontLibrary: { Anchor, Heading, Text }, componentTranslateStore: { translate }, componentContactInfoValidationStore } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    if (!componentContactInfoValidationStore.isLoaded || !componentContactInfoValidationStore.contactInfo) {
        return null;
    }
    return (react_1.default.createElement(Text, null,
        react_1.default.createElement(Heading, { element: "h1", className: "h3" }, translate(isDealer ? 'contactInfo.validation.modal.email.heading.dealer' : 'contactInfo.validation.modal.email.heading')),
        react_1.default.createElement("p", { dangerouslySetInnerHTML: {
                __html: translate('contactInfo.validation.modal.email.codeSent', {
                    email: componentContactInfoValidationStore.contactInfo.value
                })
            } }),
        isDealer && react_1.default.createElement("p", null, translate('contactInfo.validation.modal.email.dealerInfo')),
        react_1.default.createElement("p", null,
            translate(isDealer ? 'contactInfo.validation.modal.email.question.dealer' : 'contactInfo.validation.modal.email.question'),
            "\u00A0",
            react_1.default.createElement(Anchor, { url: "#", color: isDealer ? 'employee' : null, onClick: () => componentContactInfoValidationStore.sendValidationCode() }, translate(isDealer ? 'contactInfo.validation.modal.email.resend.dealer' : 'contactInfo.validation.modal.email.resend')))));
});
exports["default"] = EmailValidation;


/***/ }),

/***/ 5520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importStar(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const PhoneValidation = (0, mobx_react_1.observer)((props) => {
    const { isDealer } = props;
    const { frontLibrary: { Anchor, Grid, GridColumn, Heading, Text, TextField }, componentTranslateStore: { translate }, componentContactInfoValidationStore } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    const placeholderValue = ' ';
    const [displayValue, setDisplayValue] = (0, react_1.useState)(placeholderValue);
    const isNumber = (input) => /^\d+$/.test(input);
    if (!componentContactInfoValidationStore.isLoaded || !componentContactInfoValidationStore.contactInfo) {
        return null;
    }
    return (react_1.default.createElement(Text, null,
        react_1.default.createElement(Heading, { element: "h1", className: "h3" }, translate(isDealer ? 'contactInfo.validation.modal.phone.heading.dealer' : 'contactInfo.validation.modal.phone.heading')),
        react_1.default.createElement("p", { className: isDealer ? 'text__margin-double' : null, dangerouslySetInnerHTML: {
                __html: translate('contactInfo.validation.modal.phone.codeSent', {
                    number: componentContactInfoValidationStore.contactInfo.value
                })
            } }),
        isDealer && react_1.default.createElement("p", null, translate('contactInfo.validation.modal.phone.dealerInfo')),
        react_1.default.createElement(Grid, { align: ['start-md', 'center-xs'] },
            react_1.default.createElement(GridColumn, { width: ['xs-6'] },
                react_1.default.createElement(TextField, { id: "phone-validation-code-input", label: translate('contactInfo.validation.modal.phone.code'), size: "large", align: "center", value: displayValue, defaultIsFocused: true, helper: componentContactInfoValidationStore.isErrorOnValidation && {
                        text: translate('contactInfo.validation.modal.phone.incorrect'),
                        type: 'error'
                    }, onChange: (0, mobx_1.action)((value) => {
                        if ((isNumber(value) && value.length <= 4) || value === '') {
                            componentContactInfoValidationStore.validationCodeInputValue = value;
                            setDisplayValue(value);
                        }
                    }), onFocus: () => {
                        if (!componentContactInfoValidationStore.validationCodeInputValue) {
                            setDisplayValue('');
                        }
                    }, onBlur: () => {
                        if (!componentContactInfoValidationStore.validationCodeInputValue) {
                            setDisplayValue(placeholderValue);
                        }
                    } }))),
        react_1.default.createElement("p", null,
            translate(isDealer ? 'contactInfo.validation.modal.phone.question.dealer' : 'contactInfo.validation.modal.phone.question'),
            "\u00A0",
            react_1.default.createElement(Anchor, { url: "#", color: isDealer ? 'employee' : null, onClick: () => componentContactInfoValidationStore.sendValidationCode() }, translate('contactInfo.validation.modal.phone.resend')))));
});
exports["default"] = PhoneValidation;


/***/ }),

/***/ 2464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ComponentAddressStore_1 = __importDefault(__webpack_require__(4584));
const stores_1 = __webpack_require__(4547);
const StoresUtil_1 = __webpack_require__(5855);
const util_1 = __webpack_require__(8910);
const mobx_1 = __webpack_require__(259);
const ApplicationWrapper_1 = __webpack_require__(6306);
let Address = class Address extends react_1.default.Component {
    constructor(props) {
        var _a, _b;
        super(props);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddressValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "foreignAddressValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "displayRegistryAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "displayCountrySelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "componentAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "foreignAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddressWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "foreignAddressWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "countrySelectWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddressRequiredFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "foreignAddressRequiredFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onCountryChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, mobx_1.action)(() => {
                this.displayRegistryAddress = this.componentAddressStore.selectedCountryIsEstonia;
                this.onAddressChange();
            })
        });
        Object.defineProperty(this, "onAddressChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.onChange(this.componentAddressStore.selectedAddress, this.displayRegistryAddress ? this.registryAddressValid : this.foreignAddressValid);
            }
        });
        Object.defineProperty(this, "onRoomChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.onChange(this.componentAddressStore.selectedAddress, this.displayRegistryAddress ? this.registryAddressValid : this.foreignAddressValid);
            }
        });
        Object.defineProperty(this, "onValidityChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (valid) => {
                if (this.displayRegistryAddress) {
                    this.registryAddressValid = valid;
                }
                else {
                    this.foreignAddressValid = valid;
                }
            }
        });
        (0, mobx_1.makeObservable)(this);
        const isRegistryAddress = !!this.props.type && this.props.type === 'registry';
        const isForeignAddress = !!this.props.type && this.props.type === 'foreign';
        const isCombinedAddress = !this.props.type || this.props.type === 'combined';
        if (isCombinedAddress) {
            if (!this.props.defaultValue) {
                this.registryAddress = {};
            }
            else {
                const getRegistryId = (value) => value.addressRegistryId || value.buildingRegistryId || value.roomRegistryId;
                const getCountryCode = (value) => value.countryCode;
                if (getRegistryId(this.props.defaultValue) || getCountryCode(this.props.defaultValue) === 'EE') {
                    this.registryAddress = this.props.defaultValue;
                }
                else {
                    this.foreignAddress = this.props.defaultValue;
                }
            }
            this.registryAddressWidth = this.props.width.registryAddress;
            this.foreignAddressWidth = this.props.width.foreignAddress;
            this.countrySelectWidth = this.props.width.countrySelect;
            this.displayCountrySelect = true;
            if (this.props.requiredFields) {
                this.registryAddressRequiredFields = this.props.requiredFields.registryAddress;
                this.foreignAddressRequiredFields = this.props.requiredFields.foreignAddress;
            }
            else {
                this.registryAddressRequiredFields = [];
                this.foreignAddressRequiredFields = [];
            }
        }
        if (isRegistryAddress) {
            this.registryAddress = this.props.defaultValue;
            this.registryAddressWidth = this.props.width;
            this.registryAddressRequiredFields = this.props.requiredFields ? this.props.requiredFields : [];
            this.displayCountrySelect = false;
        }
        if (isForeignAddress) {
            this.foreignAddress = this.props.defaultValue;
            this.foreignAddressWidth = this.props.width;
            this.foreignAddressRequiredFields = this.props.requiredFields ? this.props.requiredFields : [];
            this.displayCountrySelect = false;
        }
        const registryAddressConfig = isRegistryAddress
            ? this.props.config
            : isForeignAddress
                ? undefined
                : (_a = this.props.config) === null || _a === void 0 ? void 0 : _a.registryAddress;
        this.displayRegistryAddress = isRegistryAddress || !!this.registryAddress;
        this.componentAddressStore = new ComponentAddressStore_1.default();
        this.componentAddressStore.init(this.registryAddress, this.foreignAddress, registryAddressConfig);
        this.componentAddressStore.selectedCountryCode =
            !!this.registryAddress || this.componentAddressStore.noAddress ? 'EE' : ((_b = this.foreignAddress) === null || _b === void 0 ? void 0 : _b.countryCode) || 'AF';
        this.registryAddressValid =
            !!this.registryAddress &&
                (!this.registryAddressRequiredFields.includes('address') || !!this.registryAddress.addressRegistryId) &&
                (!this.registryAddressRequiredFields.includes('room') || !!this.registryAddress.roomRegistryId);
        this.foreignAddressValid =
            !!this.foreignAddress &&
                (!this.foreignAddressRequiredFields.includes('region') || !!this.foreignAddress.region) &&
                (!this.foreignAddressRequiredFields.includes('city') || !!this.foreignAddress.city) &&
                (!this.foreignAddressRequiredFields.includes('street') || !!this.foreignAddress.street) &&
                (!this.foreignAddressRequiredFields.includes('building') || !!this.foreignAddress.building) &&
                (!this.foreignAddressRequiredFields.includes('room') || !!this.foreignAddress.room) &&
                (!this.foreignAddressRequiredFields.includes('postalCode') || !!this.foreignAddress.postalCode);
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const { Spinner } = this.frontLibrary;
        if (this.componentAddressStore.isLoading) {
            return react_1.default.createElement(Spinner, null);
        }
        if (this.displayRegistryAddress || this.componentAddressStore.noAddress) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                this.displayCountrySelect && (react_1.default.createElement(CountrySelectComponent, { onChange: this.onCountryChange, width: this.countrySelectWidth, value: 'EE', componentAddressStore: this.componentAddressStore })),
                react_1.default.createElement(RegistryAddressComponent, { addressWidth: this.registryAddressWidth.address, onAddressSelect: this.onAddressChange, addressRequired: this.registryAddressRequiredFields.includes('address'), roomWidth: this.registryAddressWidth.room, onRoomChange: this.onRoomChange, onRoomSelect: this.onRoomChange, roomRequired: this.registryAddressRequiredFields.includes('room'), validityCallback: this.onValidityChange, componentAddressStore: this.componentAddressStore, helper: this.props.helper })));
        }
        const getForeignAddressField = (type, value) => {
            return { type, value, isRequired: this.foreignAddressRequiredFields.includes(type) };
        };
        const foreignAddressFields = [
            getForeignAddressField(ForeignAddressFieldType.REGION, (_a = this.foreignAddress) === null || _a === void 0 ? void 0 : _a.region),
            getForeignAddressField(ForeignAddressFieldType.CITY, (_b = this.foreignAddress) === null || _b === void 0 ? void 0 : _b.city),
            getForeignAddressField(ForeignAddressFieldType.STREET, (_c = this.foreignAddress) === null || _c === void 0 ? void 0 : _c.street),
            getForeignAddressField(ForeignAddressFieldType.BUILDING, (_d = this.foreignAddress) === null || _d === void 0 ? void 0 : _d.building),
            getForeignAddressField(ForeignAddressFieldType.ROOM, (_e = this.foreignAddress) === null || _e === void 0 ? void 0 : _e.room),
            getForeignAddressField(ForeignAddressFieldType.POSTALCODE, (_f = this.foreignAddress) === null || _f === void 0 ? void 0 : _f.postalCode)
        ];
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.displayCountrySelect && (react_1.default.createElement(CountrySelectComponent, { onChange: this.onCountryChange, width: this.countrySelectWidth, componentAddressStore: this.componentAddressStore })),
            react_1.default.createElement(ForeignAddressComponent, { width: this.foreignAddressWidth, fields: foreignAddressFields, onChange: this.onAddressChange, validityCallback: this.onValidityChange, componentAddressStore: this.componentAddressStore })));
    }
};
__decorate([
    mobx_1.observable
], Address.prototype, "displayRegistryAddress", void 0);
Address = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], Address);
exports["default"] = Address;
const CountrySelectComponent = (0, mobx_react_1.observer)((props) => {
    const { componentTranslateStore: { translate }, frontLibrary: { Grid, GridColumn, Select } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const currentLanguage = react_1.default.useContext(ApplicationWrapper_1.LanguageContext);
    const getValue = () => {
        return { value: props.componentAddressStore.selectedCountry.value, label: props.componentAddressStore.selectedCountry.label[currentLanguage] };
    };
    const onChange = (newValue) => {
        props.componentAddressStore.selectedCountryCode = newValue.value;
        props.onChange();
    };
    return (react_1.default.createElement(Grid, null,
        react_1.default.createElement(GridColumn, { width: props.width },
            react_1.default.createElement(Select, { id: "country-select", isInvalid: !util_1.CountryUtil.getCountriesContainingSearchTerm('', currentLanguage), label: translate('countrySelect.country'), live: true, onChange: onChange, options: util_1.CountryUtil.countriesForView('', currentLanguage), placeholder: util_1.CountryUtil.getCountryNameByCountryCode('EE', currentLanguage), value: getValue() }))));
});
const RegistryAddressComponent = (0, mobx_react_1.observer)((props) => {
    const { componentAddressStore } = props;
    const { componentTranslateStore: { translate }, frontLibrary: { Grid, GridColumn, SuggestionField } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const convert = (item) => {
        return {
            id: item.id,
            label: item.label,
            subLabel: item.subLabel,
            url: '#',
            isActive: item.isSelected
        };
    };
    const [addressValid, setAddressValid] = react_1.default.useState(props.addressRequired ? !!componentAddressStore.registryAddressLabel : true);
    const [roomValid, setRoomValid] = react_1.default.useState(props.roomRequired ? componentAddressStore.registryRoomAutocompleteItems.length === 0 || !!componentAddressStore.registryRoomLabel : true);
    const [roomText, setRoomText] = react_1.default.useState(componentAddressStore.registryRoomLabel || '');
    const onAddressChange = (newValue) => {
        componentAddressStore.addressSearchTerm = newValue;
        setAddressValid(!!newValue ? !props.addressRequired : false);
        setRoomText('');
    };
    const onAddressSelect = (id) => {
        componentAddressStore.selectedAddressId = id;
        const newRoomValid = props.roomRequired
            ? componentAddressStore.registryRoomAutocompleteItems.length === 0 || !!componentAddressStore.selectedAddress.selectedRoom
            : true;
        setAddressValid(true);
        setRoomValid(newRoomValid);
        props.validityCallback(newRoomValid);
        props.onAddressSelect();
    };
    const onRoomSelect = (id) => {
        componentAddressStore.selectedRoomId = id;
        setRoomValid(true);
        props.validityCallback(true);
        props.onRoomSelect();
    };
    const onRoomChange = (newValue) => {
        let newRoomValid = true;
        if (props.roomRequired) {
            if (componentAddressStore.registryRoomAutocompleteItems.length > 0) {
                newRoomValid = false;
            }
            else {
                newRoomValid = !newValue;
            }
        }
        setRoomValid(newRoomValid);
        setRoomText(newValue);
        if (!props.roomRequired) {
            props.componentAddressStore.selectedAddress.selectedRoom = { roomName: newValue };
        }
        props.validityCallback(newRoomValid);
        props.onRoomChange();
    };
    return (react_1.default.createElement(Grid, null,
        react_1.default.createElement(GridColumn, { width: props.addressWidth },
            react_1.default.createElement(SuggestionField, { id: "registry-address-address", defaultValue: componentAddressStore.registryAddressLabel, label: translate('registryAddress.address'), isInvalid: !addressValid, items: componentAddressStore.registryAddressAutocompleteItems.map((item) => convert(item)), onChange: onAddressChange, onSelect: (value) => onAddressSelect(value.id), helper: props.helper })),
        react_1.default.createElement(GridColumn, { width: props.roomWidth, border: ['left-sm'] },
            react_1.default.createElement(SuggestionField, { id: "registry-address-room", value: roomText, label: translate('registryAddress.room'), items: componentAddressStore.registryRoomAutocompleteItems.map((item) => convert(item)), isInvalid: !roomValid, onChange: onRoomChange, onSelect: (value) => onRoomSelect(value.id) }))));
});
var ForeignAddressFieldType;
(function (ForeignAddressFieldType) {
    ForeignAddressFieldType["REGION"] = "region";
    ForeignAddressFieldType["CITY"] = "city";
    ForeignAddressFieldType["STREET"] = "street";
    ForeignAddressFieldType["BUILDING"] = "building";
    ForeignAddressFieldType["ROOM"] = "room";
    ForeignAddressFieldType["POSTALCODE"] = "postalCode";
})(ForeignAddressFieldType || (ForeignAddressFieldType = {}));
const ForeignAddressComponent = (0, mobx_react_1.observer)((props) => {
    const { componentTranslateStore: { translate }, frontLibrary: { Grid, GridColumn, Text, TextField } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const fieldOrder = [
        ForeignAddressFieldType.REGION,
        ForeignAddressFieldType.CITY,
        ForeignAddressFieldType.STREET,
        ForeignAddressFieldType.BUILDING,
        ForeignAddressFieldType.ROOM,
        ForeignAddressFieldType.POSTALCODE
    ];
    const sorted = props.fields.sort((f1, f2) => (fieldOrder.indexOf(f1.type) > fieldOrder.indexOf(f2.type) ? 1 : -1));
    const onChange = (0, mobx_1.action)((newValue, field) => {
        props.componentAddressStore.setForeignAddressFieldValue(field.type.valueOf(), newValue);
        validityMap.set(field.type, !field.isRequired || newValue.length > 0);
        let hasInvalidValues = false;
        validityMap.forEach((value) => {
            if (!value) {
                hasInvalidValues = true;
                return;
            }
        });
        props.validityCallback(!hasInvalidValues);
        props.onChange();
    });
    const getFieldValue = (fieldType) => props.componentAddressStore.selectedAddress[fieldType.valueOf()];
    const validityMap = mobx_1.observable.map();
    sorted.forEach((field) => {
        const fieldValue = getFieldValue(field.type);
        validityMap.set(field.type, !field.isRequired || (fieldValue && fieldValue.length > 0));
    });
    return (react_1.default.createElement(Grid, null,
        react_1.default.createElement(GridColumn, { width: props.width },
            react_1.default.createElement(Text, null, sorted.map((field, index) => {
                return (react_1.default.createElement(TextField, { id: `foreign-address-${field.type}`, key: `foreign-address-field-${field.type}-${index}`, label: translate(`foreignAddress.${field.type}`), defaultValue: getFieldValue(field.type), isInvalid: !validityMap.get(field.type), onChange: (newValue) => onChange(newValue, field) }));
            })))));
});


/***/ }),

/***/ 7560:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommunicationLanguage = void 0;
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const StoresUtil_1 = __webpack_require__(5855);
let CommunicationLanguageSelector = class CommunicationLanguageSelector extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getCommunicationLanguageProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isDisabled) => {
                const { translate } = this.componentTranslateStore;
                return [
                    {
                        id: 'ET',
                        label: translate('registration.contactInfo.communicationLanguage.ET'),
                        name: 'eesti',
                        value: 'ET',
                        disabled: isDisabled
                    },
                    {
                        id: 'EN',
                        label: translate('registration.contactInfo.communicationLanguage.EN'),
                        name: 'inglise',
                        value: 'EN',
                        disabled: isDisabled
                    },
                    {
                        id: 'RU',
                        label: translate('registration.contactInfo.communicationLanguage.RU'),
                        name: 'vene',
                        value: 'RU',
                        disabled: isDisabled
                    }
                ];
            }
        });
    }
    render() {
        const { defaultValue, helper, label } = this.props;
        const { translate } = this.componentTranslateStore;
        const isDisabled = this.props.isDisabled || false;
        return (react_1.default.createElement(lib_1.Selector, { id: "contact-channels-language", items: this.getCommunicationLanguageProps(isDisabled), label: label || translate('contactChannels.language'), defaultValue: defaultValue, helper: helper, onChange: (val) => this.onChange(val) }));
    }
    onChange(value) {
        this.props.onChange(value);
    }
};
__decorate([
    mobx_1.action
], CommunicationLanguageSelector.prototype, "onChange", null);
CommunicationLanguageSelector = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], CommunicationLanguageSelector);
exports["default"] = CommunicationLanguageSelector;
var CommunicationLanguage;
(function (CommunicationLanguage) {
    CommunicationLanguage["ET"] = "ET";
    CommunicationLanguage["EN"] = "EN";
    CommunicationLanguage["RU"] = "RU";
})(CommunicationLanguage = exports.CommunicationLanguage || (exports.CommunicationLanguage = {}));


/***/ }),

/***/ 2022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const ContactInfoUtil_1 = __webpack_require__(1203);
const StoresUtil_1 = __webpack_require__(5855);
let ContactChannels = class ContactChannels extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "contactChannelsData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.contactChannelsData = props.contactChannelsData;
    }
    get isPhoneInvalid() {
        const { contactChannelsData: { isPhoneValid, isPhoneRequired, phone } } = this;
        return !isPhoneValid || (isPhoneRequired && !phone);
    }
    get isEmailInvalid() {
        const { contactChannelsData: { isEmailValid, isEmailRequired, email } } = this;
        return !isEmailValid || (isEmailRequired && !email);
    }
    componentDidMount() {
        this.contactChannelsData = this.validateContactChannelsData(this.props.contactChannelsData);
    }
    componentDidUpdate() {
        this.contactChannelsData = this.validateContactChannelsData(this.props.contactChannelsData);
    }
    render() {
        const { width } = this.props;
        const { translate } = this.componentTranslateStore;
        const { TextField, Separator, Grid, GridColumn } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: width || ['xs-6'] },
                    React.createElement(TextField, { id: 'contactChannel-phone', label: translate('contactChannel.phone'), value: this.contactChannelsData.phone, helper: this.props.helper && this.props.helper.phone, isInvalid: this.isPhoneInvalid, onChange: (value) => this.contactChannelsData.changePhone(value) }),
                    React.createElement(Separator, { spacing: this.props.separatorSize || 'xxsmall', color: 'invisible' }),
                    React.createElement(TextField, { id: 'contactChannel-email', label: translate('contactChannel.email'), value: this.contactChannelsData.email, helper: this.props.helper && this.props.helper.email, isInvalid: this.isEmailInvalid, onChange: (value) => this.contactChannelsData.changeEmail(value) })),
                React.createElement(GridColumn, null, this.renderCommunicationLanguageSelector()))));
    }
    renderCommunicationLanguageSelector() {
        const { Separator, Selector } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement(Selector, { ...this.getLanguageSelectorProps(this.contactChannelsData.languageDisabled, this.componentTranslateStore) })));
    }
    validateContactChannelsData(contactChannelsData) {
        contactChannelsData.email = contactChannelsData.email || '';
        contactChannelsData.phone = contactChannelsData.phone || '';
        return contactChannelsData;
    }
    getLanguageSelectorProps(isLanguageDisabled, componentTranslateStore) {
        const selectorProps = {
            id: 'contactChannels.language',
            items: (0, ContactInfoUtil_1.getCommunicationLanguageProps)(isLanguageDisabled, componentTranslateStore),
            label: componentTranslateStore.translate('contactChannels.language'),
            value: this.contactChannelsData.communicationLanguageCode,
            helper: this.props.helper && this.props.helper.communicationLanguage,
            size: 'small',
            onChange: (value) => {
                this.contactChannelsData.changeCommunicationLanguageCode(value);
            }
        };
        return selectorProps;
    }
};
__decorate([
    mobx_1.observable
], ContactChannels.prototype, "contactChannelsData", void 0);
ContactChannels = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactChannels);
exports["default"] = ContactChannels;


/***/ }),

/***/ 613:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ContactInfoUtil_1 = __webpack_require__(1203);
const StoresUtil_1 = __webpack_require__(5855);
let Email = class Email extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "valid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "required", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.required = !!props.required ? props.required : false;
        this.valid = this.required ? !!props.defaultValue : !props.defaultValue || (0, ContactInfoUtil_1.isEmailValid)(props.defaultValue);
    }
    render() {
        const { defaultValue, helper, label, id, key } = this.props;
        const { translate } = this.componentTranslateStore;
        return (react_1.default.createElement(lib_1.TextField, { id: id || 'email', key: key || 'email', label: label || translate('contactChannel.email'), defaultValue: defaultValue, helper: helper, isInvalid: !this.valid, onChange: (val) => this.onChange(val) }));
    }
    onChange(value) {
        this.valid = !!value ? (0, ContactInfoUtil_1.isEmailValid)(value) : !this.required;
        this.props.onChange(value, this.valid);
    }
};
__decorate([
    mobx_1.observable
], Email.prototype, "valid", void 0);
__decorate([
    mobx_1.action
], Email.prototype, "onChange", null);
Email = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], Email);
exports["default"] = Email;


/***/ }),

/***/ 3892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ContactInfoUtil_1 = __webpack_require__(1203);
const StoresUtil_1 = __webpack_require__(5855);
let Phone = class Phone extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "valid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "required", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.required = !!props.required ? props.required : false;
        this.valid = this.required ? !!props.defaultValue : !props.defaultValue || (0, ContactInfoUtil_1.isPhoneValid)(props.defaultValue);
    }
    render() {
        const { defaultValue, helper, label } = this.props;
        const { translate } = this.componentTranslateStore;
        return (react_1.default.createElement(lib_1.TextField, { id: "contact-channel-phone", label: label || translate('contactChannel.phone'), defaultValue: defaultValue, helper: helper, isInvalid: !this.valid, onChange: (val) => this.onChange(val) }));
    }
    onChange(value) {
        this.valid = !!value ? (0, ContactInfoUtil_1.isPhoneValid)(value) : !this.required;
        this.props.onChange(value, this.valid);
    }
};
__decorate([
    mobx_1.observable
], Phone.prototype, "valid", void 0);
__decorate([
    mobx_1.action
], Phone.prototype, "onChange", null);
Phone = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], Phone);
exports["default"] = Phone;


/***/ }),

/***/ 3206:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const util_1 = __webpack_require__(8910);
let CountrySuggestionField = class CountrySuggestionField extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "selectTriggered", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchTerm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getSearchTermFromCountry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.props.country ? this.props.country.label[this.props.currentLanguage] : '';
            }
        });
        Object.defineProperty(this, "onCountryChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (searchTerm) => {
                this.searchTerm = searchTerm;
                this.props.onChange(util_1.CountryUtil.getSelectedCountry(searchTerm, this.props.currentLanguage));
                if (this.selectTriggered) {
                    if (this.props.onSelect) {
                        this.props.onSelect();
                    }
                    this.selectTriggered = false;
                }
            }
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.onBlur) {
                    this.props.onBlur();
                }
            }
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            }
        });
        Object.defineProperty(this, "onSelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.selectTriggered = true;
                if (this.props.onSelect) {
                    this.props.onSelect();
                }
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.selectTriggered = true;
        this.searchTerm = this.getSearchTermFromCountry();
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.props.currentLanguage, () => {
            this.searchTerm = this.getSearchTermFromCountry();
        });
    }
    render() {
        return (React.createElement(lib_1.SuggestionField, { id: this.props.id, label: this.props.label, onBlur: this.onBlur, onChange: this.onCountryChange, onFocus: this.onFocus, items: util_1.CountryUtil.mapCountriesForSuggestionField(this.searchTerm, this.props.currentLanguage), value: this.searchTerm, onSelect: this.onSelect, isInvalid: this.props.isInvalid, helper: this.props.helper }));
    }
};
__decorate([
    mobx_1.observable
], CountrySuggestionField.prototype, "selectTriggered", void 0);
__decorate([
    mobx_1.observable
], CountrySuggestionField.prototype, "searchTerm", void 0);
__decorate([
    mobx_1.action
], CountrySuggestionField.prototype, "onCountryChange", void 0);
__decorate([
    mobx_1.action
], CountrySuggestionField.prototype, "onSelect", void 0);
CountrySuggestionField = __decorate([
    mobx_react_1.observer
], CountrySuggestionField);
exports["default"] = CountrySuggestionField;


/***/ }),

/***/ 2740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContactInfoValidationModal = exports.ORDERED_MODIFIABLE_MANDATE_TYPES = exports.ReferenceNumbersModal = exports.useParams = exports.navigate = exports.RouteErrorType = exports.Routes = exports.Route = exports.setLanguage = exports.getCurrentLanguage = exports.ApplicationWrapper = exports.InformationCheckWrapper = exports.InformationCheck = exports.InformationUpdate = exports.CommunicationLanguage = exports.CommunicationLanguageSelector = exports.Address = exports.Email = exports.Phone = exports.B2cCustomerInfo = exports.CountrySuggestionField = exports.ContactChannels = exports.ContactAddress = exports.Registration = exports.ComponentRootStoreProvider = exports.ContractValidator = void 0;
var ContractValidator_1 = __webpack_require__(1445);
Object.defineProperty(exports, "ContractValidator", ({ enumerable: true, get: function () { return __importDefault(ContractValidator_1).default; } }));
var ComponentRootStoreProvider_1 = __webpack_require__(6531);
Object.defineProperty(exports, "ComponentRootStoreProvider", ({ enumerable: true, get: function () { return __importDefault(ComponentRootStoreProvider_1).default; } }));
var Registration_1 = __webpack_require__(4137);
Object.defineProperty(exports, "Registration", ({ enumerable: true, get: function () { return __importDefault(Registration_1).default; } }));
var ContactAddress_1 = __webpack_require__(6624);
Object.defineProperty(exports, "ContactAddress", ({ enumerable: true, get: function () { return __importDefault(ContactAddress_1).default; } }));
var ContactChannels_1 = __webpack_require__(2022);
Object.defineProperty(exports, "ContactChannels", ({ enumerable: true, get: function () { return __importDefault(ContactChannels_1).default; } }));
var CountrySuggestionField_1 = __webpack_require__(3206);
Object.defineProperty(exports, "CountrySuggestionField", ({ enumerable: true, get: function () { return __importDefault(CountrySuggestionField_1).default; } }));
var B2cCustomerInfo_1 = __webpack_require__(2929);
Object.defineProperty(exports, "B2cCustomerInfo", ({ enumerable: true, get: function () { return __importDefault(B2cCustomerInfo_1).default; } }));
var Phone_1 = __webpack_require__(3892);
Object.defineProperty(exports, "Phone", ({ enumerable: true, get: function () { return __importDefault(Phone_1).default; } }));
var Email_1 = __webpack_require__(613);
Object.defineProperty(exports, "Email", ({ enumerable: true, get: function () { return __importDefault(Email_1).default; } }));
var Address_1 = __webpack_require__(2464);
Object.defineProperty(exports, "Address", ({ enumerable: true, get: function () { return __importDefault(Address_1).default; } }));
var CommunicationLanguageSelector_1 = __webpack_require__(7560);
Object.defineProperty(exports, "CommunicationLanguageSelector", ({ enumerable: true, get: function () { return __importDefault(CommunicationLanguageSelector_1).default; } }));
Object.defineProperty(exports, "CommunicationLanguage", ({ enumerable: true, get: function () { return CommunicationLanguageSelector_1.CommunicationLanguage; } }));
var InformationUpdate_1 = __webpack_require__(9);
Object.defineProperty(exports, "InformationUpdate", ({ enumerable: true, get: function () { return __importDefault(InformationUpdate_1).default; } }));
var InformationCheck_1 = __webpack_require__(1802);
Object.defineProperty(exports, "InformationCheck", ({ enumerable: true, get: function () { return __importDefault(InformationCheck_1).default; } }));
var InformationCheckWrapper_1 = __webpack_require__(7255);
Object.defineProperty(exports, "InformationCheckWrapper", ({ enumerable: true, get: function () { return __importDefault(InformationCheckWrapper_1).default; } }));
var ApplicationWrapper_1 = __webpack_require__(6306);
Object.defineProperty(exports, "ApplicationWrapper", ({ enumerable: true, get: function () { return __importDefault(ApplicationWrapper_1).default; } }));
Object.defineProperty(exports, "getCurrentLanguage", ({ enumerable: true, get: function () { return ApplicationWrapper_1.getCurrentLanguage; } }));
Object.defineProperty(exports, "setLanguage", ({ enumerable: true, get: function () { return ApplicationWrapper_1.setLanguage; } }));
var Route_1 = __webpack_require__(61);
Object.defineProperty(exports, "Route", ({ enumerable: true, get: function () { return __importDefault(Route_1).default; } }));
var Routes_1 = __webpack_require__(3294);
Object.defineProperty(exports, "Routes", ({ enumerable: true, get: function () { return __importDefault(Routes_1).default; } }));
var RouteValidator_1 = __webpack_require__(3506);
Object.defineProperty(exports, "RouteErrorType", ({ enumerable: true, get: function () { return RouteValidator_1.RouteErrorType; } }));
var NavigationUtil_1 = __webpack_require__(5853);
Object.defineProperty(exports, "navigate", ({ enumerable: true, get: function () { return NavigationUtil_1.navigate; } }));
Object.defineProperty(exports, "useParams", ({ enumerable: true, get: function () { return NavigationUtil_1.useParams; } }));
var ReferenceNumbersModal_1 = __webpack_require__(1054);
Object.defineProperty(exports, "ReferenceNumbersModal", ({ enumerable: true, get: function () { return __importDefault(ReferenceNumbersModal_1).default; } }));
var MandateUtil_1 = __webpack_require__(4305);
Object.defineProperty(exports, "ORDERED_MODIFIABLE_MANDATE_TYPES", ({ enumerable: true, get: function () { return MandateUtil_1.ORDERED_MODIFIABLE_MANDATE_TYPES; } }));
var ContactInfoValidationModal_1 = __webpack_require__(120);
Object.defineProperty(exports, "ContactInfoValidationModal", ({ enumerable: true, get: function () { return __importDefault(ContactInfoValidationModal_1).default; } }));


/***/ }),

/***/ 1802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importStar(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const ContactInfoUtil_1 = __webpack_require__(1203);
const LocationUtils_1 = __importDefault(__webpack_require__(1513));
const StringUtil_1 = __webpack_require__(5085);
const InformationCheck = (0, mobx_react_1.observer)((props) => {
    const [isModalOpen, setModalOpen] = (0, react_1.useState)(false);
    const { frontLibrary: { Button, Grid, GridColumn, Heading, Notice, Spinner, Text, Modal, ModalContent, ModalFooter, Icon }, componentCustomerContactInfoStore, componentInformationCheckStore, componentInformationCheckStore: { customerCommunicationLanguage, isLoading, customerPhoneValue, customerEmailValue, customerAddressFormatted, amountOfInvoices, contactAddressIsMatchingOnInvoicesAndContactInfo, customerPhoneValidated, customerEmailValidated, customerAddressValidated }, componentContactAddressStore, componentTranslateStore: { translate }, componentSsoStore, componentSsoStore: { person }, brand } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    (0, react_1.useEffect)(() => {
        if (!!componentSsoStore.customerId) {
            componentInformationCheckStore.init().finally(() => {
                setModalOpen(true);
            });
        }
    }, [componentSsoStore.customerId]);
    const handleChangeNowOnClick = () => {
        if (!props.redirectToInformationUpdate) {
            LocationUtils_1.default.changePath('/konto/andmete-uuendamine');
            return;
        }
        props.redirectToInformationUpdate();
    };
    const isRequiredContactInformationPresent = () => {
        return componentContactAddressStore.isAddressValid() && (!!customerPhoneValue || !!customerEmailValue);
    };
    const confirmData = () => {
        Promise.all([
            componentContactAddressStore.saveAddress(),
            componentCustomerContactInfoStore.updateContactInfo(false),
            componentCustomerContactInfoStore.updateContactInfoConfirmedTs()
        ]).then(() => setModalOpen(false));
    };
    return (react_1.default.createElement(Modal, { hasContentComponent: true, isOpen: isModalOpen, "aria-labelledby": "information-check-heading", initialFocusedElementId: "change-data", cover: brand === 'TELIA'
            ? {
                backgroundColor: '#999999',
                minHeight: 500,
                image: {
                    srcset: 'https://res.cloudinary.com/telia/image/upload/q_5/w_400,h_800,c_fill/crm-components/Telia_Company_112_2.png',
                    role: 'presentation'
                },
                fillImage: true
            }
            : undefined, onClose: () => setModalOpen(false) },
        react_1.default.createElement(ModalContent, null, isLoading ? (react_1.default.createElement(Spinner, null)) : (react_1.default.createElement(Text, null,
            react_1.default.createElement(Heading, { className: "h2", id: "information-check-heading" }, translate('dataconfirm.informationcheck.heading')),
            react_1.default.createElement("p", { className: "h4 text-bold" }, translate('dataconfirm.informationcheck.greeting', { name: person.firstName })),
            react_1.default.createElement("p", null, translate('dataconfirm.informationcheck.checkyourinformation')),
            react_1.default.createElement(LabelValue, { label: "dataconfirm.informationcheck.phone", value: customerPhoneValue, className: "text__margin-double" }),
            !customerPhoneValidated && (react_1.default.createElement("p", { className: "text__margin-none" },
                react_1.default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }),
                react_1.default.createElement("span", { className: "text-small" }, translate('common.contactInfo.phoneUnvalidated')))),
            react_1.default.createElement(LabelValue, { label: "dataconfirm.informationcheck.email", value: customerEmailValue }),
            !customerEmailValidated && (react_1.default.createElement("p", { className: "text__margin-none" },
                react_1.default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }),
                react_1.default.createElement("span", { className: "text-small" }, translate('common.contactInfo.emailUnvalidated')))),
            react_1.default.createElement(LabelValue, { label: "dataconfirm.informationcheck.postAddress", value: customerAddressFormatted }),
            !customerAddressValidated && (react_1.default.createElement("p", { className: "text__margin-none" },
                react_1.default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }),
                react_1.default.createElement("span", { className: "text-small" }, translate('common.contactInfo.addressUnvalidated')))),
            react_1.default.createElement(LabelValue, { label: "dataconfirm.informationcheck.communicationLanguage", value: (0, ContactInfoUtil_1.getTranslatedCommunicationLanguage)(customerCommunicationLanguage, translate) }),
            amountOfInvoices ? react_1.default.createElement(LabelValue, { label: "dataconfirm.informationcheck.monthlyInvoices", value: amountOfInvoices }) : null,
            !contactAddressIsMatchingOnInvoicesAndContactInfo && (react_1.default.createElement(Notice, { type: "error", size: "small", className: "text__margin-double" }, translate('dataconfirm.informationcheck.notice')))))),
        react_1.default.createElement(ModalFooter, null,
            react_1.default.createElement(Grid, { align: ['middle-xs', 'center-xs', 'start-md'], reverse: ['xs'], className: "text-center" },
                react_1.default.createElement(GridColumn, { width: ['xs-12', 'md'] },
                    react_1.default.createElement(Button, { text: translate('dataconfirm.informationcheck.changeNow'), onClick: handleChangeNowOnClick, id: "change-data" })),
                react_1.default.createElement(GridColumn, { width: ['xs-12', 'md'] },
                    react_1.default.createElement(Button, { text: translate('dataconfirm.informationcheck.confirmData'), variant: "secondary", onClick: confirmData, disabled: !isRequiredContactInformationPresent() })),
                react_1.default.createElement(GridColumn, { width: ['xs-12', 'md'] },
                    react_1.default.createElement(Button, { text: translate('dataconfirm.informationcheck.changeLater'), iconRight: "#arrow-right", link: true, onClick: () => setModalOpen(false) }))))));
});
const LabelValue = ({ label, value, className = 'text__margin-half' }) => {
    const { componentTranslateStore: { translate }, frontLibrary: { Grid, GridColumn } } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    return (react_1.default.createElement("p", { className: className },
        react_1.default.createElement(Grid, { element: "span" },
            react_1.default.createElement(GridColumn, { width: ['xs-4', 'lg-3'] }, translate(label)),
            react_1.default.createElement(GridColumn, { width: ['xs-8', 'lg-9'], className: "text-bold" }, (0, StringUtil_1.valueOrDash)(value)))));
};
exports["default"] = InformationCheck;


/***/ }),

/***/ 7255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importStar(__webpack_require__(8156));
const react_router_1 = __webpack_require__(9250);
const NavigationUtil_1 = __importDefault(__webpack_require__(5853));
const stores_1 = __webpack_require__(4547);
const InformationCheck_1 = __importDefault(__webpack_require__(1802));
const EXCLUDED_PATHS = ['/konto/registreerimine', '/konto/andmete-uuendamine'];
const InformationCheckWrapper = (0, mobx_react_1.observer)(({ children, redirectToInformationUpdate }) => {
    const { componentCustomerContactInfoStore, componentSsoStore: { customerId, dealer, isSsoLoaded, isRepresentingSelf }, componentInformationCheckStore } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    const [shouldShowModal, setShowModal] = (0, react_1.useState)(false);
    const location = (0, react_router_1.useLocation)();
    (0, react_1.useEffect)(() => {
        toggleModalVisibilityIfNeeded();
    }, [location]);
    (0, react_1.useEffect)(() => {
        if (isSsoLoaded && !!customerId && (!componentCustomerContactInfoStore.isLoaded || componentCustomerContactInfoStore.initialCustomerId !== customerId)) {
            componentCustomerContactInfoStore.init().finally(() => {
                toggleModalVisibilityIfNeeded();
            });
        }
    }, [customerId]);
    const isOnExcludedPath = () => {
        const route = NavigationUtil_1.default.get().getRoute(location.pathname);
        return EXCLUDED_PATHS.includes(route === null || route === void 0 ? void 0 : route.path);
    };
    const toggleModalVisibilityIfNeeded = () => {
        setShowModal(!isOnExcludedPath() && !dealer && isRepresentingSelf && componentInformationCheckStore.isContactInfoOutdated);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        shouldShowModal && react_1.default.createElement(InformationCheck_1.default, { redirectToInformationUpdate: redirectToInformationUpdate }),
        children));
});
exports["default"] = InformationCheckWrapper;


/***/ }),

/***/ 9:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const card_1 = __webpack_require__(1475);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const StoresUtil_1 = __webpack_require__(5855);
const NavigationUtil_1 = __webpack_require__(5853);
const EditContactInfo_1 = __importDefault(__webpack_require__(6988));
const EditInvoices_1 = __importDefault(__webpack_require__(6960));
let InformationUpdate = class InformationUpdate extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isSaving", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isErrorDuringSaving", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "goToUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceSettingsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistryAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentForeignAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.isSaving) {
                    return;
                }
                this.isSaving = true;
                this.isErrorDuringSaving = false;
                Promise.all([
                    this.componentContactAddressStore.saveAddress(),
                    this.componentCustomerContactInfoStore.updateContactInfo(false),
                    this.componentInvoiceSettingsStore.saveInvoices()
                ])
                    .then((0, mobx_1.action)(async () => {
                    if (this.componentContactAddressStore.isErrorDuringSave ||
                        this.componentCustomerContactInfoStore.isError ||
                        this.componentInvoiceSettingsStore.saveError) {
                        this.isErrorDuringSaving = true;
                    }
                    else {
                        await this.componentCustomerContactInfoStore.updateContactInfoConfirmedTs();
                        if (this.goToUrl) {
                            (0, NavigationUtil_1.navigate)(this.goToUrl);
                        }
                        else {
                            this.props.onSave();
                        }
                    }
                }))
                    .finally((0, mobx_1.action)(() => (this.isSaving = false)));
            }
        });
        this.goToUrl = new URLSearchParams(location.search).get('goToUrl');
        (0, mobx_1.makeObservable)(this);
    }
    isSubmitButtonDisabled() {
        const isAddressInvalid = this.componentContactAddressStore.isRegistryAddressSelected
            ? this.componentRegistryAddressEditStore.addressError
            : this.componentForeignAddressEditStore.addressError;
        const isEmailInvalid = this.componentSsoStore.dealer && !this.componentCustomerContactInfoStore.email.isUserInputError
            ? false
            : this.componentCustomerContactInfoStore.email.isUserInputError || !this.componentCustomerContactInfoStore.email.hasValue;
        const isPhoneInvalid = this.componentSsoStore.dealer && !this.componentCustomerContactInfoStore.phone.isUserInputError
            ? false
            : this.componentCustomerContactInfoStore.phone.isUserInputError || !this.componentCustomerContactInfoStore.phone.hasValue;
        const isContactInfoMissing = !this.componentCustomerContactInfoStore.phone.hasValue && !this.componentCustomerContactInfoStore.email.hasValue;
        return isEmailInvalid || isPhoneInvalid || isAddressInvalid || isContactInfoMissing;
    }
    render() {
        const { Container, Heading, Text, Button, Separator, Spinner, Notice } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        const { isSsoLoaded } = this.componentSsoStore;
        if (!isSsoLoaded) {
            return react_1.default.createElement(Spinner, null);
        }
        return (react_1.default.createElement(Container, null,
            react_1.default.createElement(Text, null,
                react_1.default.createElement(Heading, { className: "h2" }, translate('dataconfirm.title')),
                react_1.default.createElement(Separator, { color: "invisible", spacing: "small" }),
                react_1.default.createElement(InformationUpdateCard, { icon: "#contact", heading: translate('dataconfirm.contactInfo.title') },
                    react_1.default.createElement(EditContactInfo_1.default, null)),
                react_1.default.createElement(InformationUpdateCard, { icon: "#file-settings", heading: translate('dataconfirm.invoices.invoice.invoiceDetails') },
                    react_1.default.createElement(EditInvoices_1.default, null)),
                react_1.default.createElement("div", { className: "text-center text__margin-double" },
                    this.isErrorDuringSaving && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Notice, { type: "error" },
                            react_1.default.createElement("span", null, translate('dataconfirm.saving.error'))),
                        react_1.default.createElement(Separator, { color: "invisible", spacing: "xsmall" }))),
                    react_1.default.createElement(Button, { text: translate('dataconfirm.confirm'), onClick: this.onSave, disabled: this.isSubmitButtonDisabled(), iconRight: "#arrow-right", isLoading: this.isSaving })))));
    }
};
__decorate([
    mobx_1.observable
], InformationUpdate.prototype, "isSaving", void 0);
__decorate([
    mobx_1.observable
], InformationUpdate.prototype, "isErrorDuringSaving", void 0);
__decorate([
    mobx_1.action
], InformationUpdate.prototype, "onSave", void 0);
InformationUpdate = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], InformationUpdate);
exports["default"] = InformationUpdate;
const InformationUpdateCard = (props) => {
    const { frontLibrary: { Icon, Text, Grid, GridColumn, Heading } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    return (react_1.default.createElement(card_1.Card, { padding: "medium", background: "transparent", type: "light" },
        react_1.default.createElement(card_1.CardContent, null,
            react_1.default.createElement(Text, null,
                react_1.default.createElement(Grid, { align: ['middle-xs'] },
                    react_1.default.createElement(GridColumn, { width: ['xs'] },
                        react_1.default.createElement(Icon, { modifiers: props.icon, size: "md" })),
                    react_1.default.createElement(GridColumn, { width: ['xs'] },
                        react_1.default.createElement(Heading, { element: "h2", className: "h3" }, props.heading))),
                props.children))));
};


/***/ }),

/***/ 6988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importStar(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const util_1 = __webpack_require__(8910);
const ContactAddress_1 = __importDefault(__webpack_require__(6624));
const EditContactInfo = (0, mobx_react_1.observer)(() => {
    var _a, _b;
    const { frontLibrary: { Text, Card, CardContent, TextField, Grid, GridColumn, Selector, Spinner, Icon }, componentTranslateStore: { translate }, componentSsoStore: { customerId, customer, dealer }, componentCustomerContactInfoStore, componentRegistryAddressEditStore } = (0, react_1.useContext)(stores_1.ComponentRootStoreContext);
    const [isLoaded, setLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        init();
    }, [customerId]);
    const init = async () => {
        setLoaded(false);
        await componentCustomerContactInfoStore.init();
        setLoaded(true);
    };
    if (!isLoaded) {
        return react_1.default.createElement(Spinner, null);
    }
    const isPhoneInvalid = () => {
        if (dealer) {
            return ((!componentCustomerContactInfoStore.email.hasValue && !componentCustomerContactInfoStore.phone.hasValue) ||
                componentCustomerContactInfoStore.phone.isUserInputError);
        }
        return !componentCustomerContactInfoStore.phone.hasValue || componentCustomerContactInfoStore.phone.isUserInputError;
    };
    const isEmailInvalid = () => {
        if (dealer) {
            return ((!componentCustomerContactInfoStore.email.hasValue && !componentCustomerContactInfoStore.phone.hasValue) ||
                componentCustomerContactInfoStore.email.isUserInputError);
        }
        return !componentCustomerContactInfoStore.email.hasValue || componentCustomerContactInfoStore.email.isUserInputError;
    };
    const showErrorTooltipIfNecessary = (contactInfo) => {
        if (contactInfo.isUserInputError) {
            return {
                text: translate(`dataconfirm.contactInfo.${contactInfo.type.toLowerCase()}.helper.error`),
                type: 'error'
            };
        }
        else if (contactInfo.isSavingError) {
            return {
                text: translate(`dataconfirm.contactInfo.${contactInfo.type.toLowerCase()}.helper.savingError`),
                type: 'error'
            };
        }
        return undefined;
    };
    const failedToSave = (contactInfo) => {
        return contactInfo.isSavingError;
    };
    return (react_1.default.createElement(Text, null,
        react_1.default.createElement(Card, { background: 'primary-3' },
            react_1.default.createElement(CardContent, null,
                react_1.default.createElement(Grid, null,
                    react_1.default.createElement(GridColumn, { width: ['sm-12', 'md'] },
                        react_1.default.createElement("div", { className: "text-small" }, translate('dataconfirm.contactInfo.name')),
                        react_1.default.createElement("div", { className: "text-bold" }, customer.displayName)),
                    react_1.default.createElement(GridColumn, { width: ['sm-12', 'md'] },
                        react_1.default.createElement("div", { className: "text-small" }, translate('dataconfirm.contactInfo.personalCode')),
                        react_1.default.createElement("div", { className: "text-bold" }, customer.registrationNumber)),
                    react_1.default.createElement(GridColumn, { width: ['sm-12', 'md'] },
                        react_1.default.createElement("div", { className: "text-small" }, translate('dataconfirm.contactInfo.countryCode')),
                        react_1.default.createElement("div", { className: "text-bold" }, util_1.CountryUtil.getByCountryCode(customer.registrationNumberCountryCode)
                            ? util_1.CountryUtil.getByCountryCode(customer.registrationNumberCountryCode).label.et
                            : translate('dataconfirm.contactInfo.else')))))),
        react_1.default.createElement(Grid, { className: "text__margin-double" },
            react_1.default.createElement(GridColumn, { width: ['xs-12', 'lg-7'] },
                react_1.default.createElement(TextField, { id: "text-phone", label: translate('dataconfirm.contactInfo.phone'), value: (_a = componentCustomerContactInfoStore.phone) === null || _a === void 0 ? void 0 : _a.value, onChange: (value) => componentCustomerContactInfoStore.phone.onChange(value, !!dealer), isInvalid: isPhoneInvalid() || failedToSave(componentCustomerContactInfoStore.phone), helper: showErrorTooltipIfNecessary(componentCustomerContactInfoStore.phone) }),
                !componentCustomerContactInfoStore.isPhoneValidatedOrOldPhoneChanged() && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }),
                    react_1.default.createElement("span", { className: "text-small" }, translate('common.contactInfo.phoneUnvalidated')))))),
        react_1.default.createElement(Grid, null,
            react_1.default.createElement(GridColumn, { width: ['xs-12', 'lg-7'] },
                react_1.default.createElement(TextField, { id: "text-epost", label: translate('dataconfirm.contactInfo.email'), value: (_b = componentCustomerContactInfoStore.email) === null || _b === void 0 ? void 0 : _b.value, onChange: (value) => componentCustomerContactInfoStore.email.onChange(value, !!dealer), isInvalid: isEmailInvalid() || failedToSave(componentCustomerContactInfoStore.email), helper: showErrorTooltipIfNecessary(componentCustomerContactInfoStore.email) }),
                !componentCustomerContactInfoStore.isEmailValidatedOrOldEmailChanged() && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }),
                    react_1.default.createElement("span", { className: "text-small" }, translate('common.contactInfo.emailUnvalidated')))))),
        react_1.default.createElement(ContactAddress_1.default, { currentLanguage: "et", countrySelectWidth: ['xs-12', 'lg-7'], addressWidth: ['xs-12', 'md-8', 'lg-4'], roomWidth: ['xs-12', 'md-4', 'lg-3'], registryAddressHelper: componentRegistryAddressEditStore.addressError && {
                text: translate('dataconfirm.contactInfo.address.helper.error'),
                type: 'error'
            } }),
        react_1.default.createElement(Selector, { id: "contact-info-communication-language", className: "text__margin-double", label: translate('dataconfirm.contactInfo.communicationLanguage'), defaultValue: componentCustomerContactInfoStore.communicationLanguage.oldValue, items: [
                {
                    id: 'communication-language-et',
                    label: translate('communicationLanguage.ET'),
                    name: 'eesti',
                    value: 'ET'
                },
                {
                    id: 'communication-language-ru',
                    label: translate('communicationLanguage.RU'),
                    name: 'vene',
                    value: 'RU'
                },
                {
                    id: 'communication-language-en',
                    label: translate('communicationLanguage.EN'),
                    name: 'inglise',
                    value: 'EN'
                }
            ], helper: { text: translate('dataconfirm.contactInfo.communicationLanguage.helpText'), type: 'help' }, onChange: (value) => componentCustomerContactInfoStore.onCommunicationLanguageChange(value) })));
});
exports["default"] = EditContactInfo;


/***/ }),

/***/ 4133:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const card_1 = __webpack_require__(1475);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ComponentInvoiceSettingsStore_1 = __importDefault(__webpack_require__(8586));
const StoresUtil_1 = __webpack_require__(5855);
const Address_1 = __importDefault(__webpack_require__(2464));
const Email_1 = __importDefault(__webpack_require__(613));
let EditInvoiceDetailsModal = class EditInvoiceDetailsModal extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "invoiceChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "currentAddressValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "currentAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentEmails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceSettingsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceNameStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onAddressChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, isValid) => {
                this.invoiceChanged = true;
                this.currentAddress = value;
                this.currentAddressValid = isValid;
            }
        });
        Object.defineProperty(this, "onEmailChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, valid, index) => {
                this.invoiceChanged = true;
                const newEmails = this.currentEmails.map((email, i) => (i === index ? { value, valid } : email));
                this.currentEmails.replace(newEmails);
            }
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.onSave(this.currentEmails.map((email) => email.value), this.currentAddress);
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.currentEmails = mobx_1.observable.array(props.invoice.emailAddresses.slice().map((value) => {
            return { value, valid: true };
        }));
    }
    render() {
        const { onClose } = this.props;
        const { Heading, Notice, Grid, GridColumn, Button, Text } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        return (react_1.default.createElement(lib_1.Modal, { isOpen: true, hasContentComponent: true, size: "6-col", "aria-labelledby": "change-invoice-details-heading", onClose: onClose },
            react_1.default.createElement(lib_1.ModalContent, null,
                this.componentInvoiceSettingsStore.saving && this.renderSpinner(),
                react_1.default.createElement(Text, null,
                    react_1.default.createElement(Heading, { className: "h3", id: "change-invoice-details-heading" }, translate('dataconfirm.invoices.invoice.serviceDetailsChange')),
                    react_1.default.createElement(card_1.Card, { background: 'neutral-1', className: "text__margin-double" },
                        react_1.default.createElement(card_1.CardContent, null,
                            react_1.default.createElement(Text, null, this.renderData()))),
                    react_1.default.createElement(Notice, { size: "small" }, translate('dataconfirm.invoices.invoice.changeInvoiceInfo')),
                    react_1.default.createElement("div", { className: "text__margin-double" }, this.renderInputs()),
                    react_1.default.createElement("div", null, this.componentInvoiceSettingsStore.saveError && react_1.default.createElement(Notice, { type: "error" }, translate('dataconfirm.invoices.invoice.savingError'))))),
            react_1.default.createElement(lib_1.ModalFooter, null,
                react_1.default.createElement(Grid, { reverse: ['xs'], align: ['between-xs', 'middle-xs'] },
                    react_1.default.createElement(GridColumn, { width: ['xs'] },
                        react_1.default.createElement(Button, { text: translate('dataconfirm.invoices.invoice.confirm'), iconLeft: "#check", type: "expressive", disabled: !this.isConfirmEnabled, onClick: this.onSave })),
                    react_1.default.createElement(GridColumn, { width: ['xs'] },
                        react_1.default.createElement(Button, { text: translate('dataconfirm.invoices.invoice.back'), link: true, iconLeft: "#arrow-left", onClick: onClose }))))));
    }
    renderData() {
        const { invoice } = this.props;
        const { List, ListItem } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        const invoiceName = this.componentInvoiceNameStore.getRefNumberName(invoice.contentType, invoice.title, invoice.source);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "text-tiny text-color-normal" }, translate('dataconfirm.invoices.invoice.name')),
                react_1.default.createElement("p", { className: "text-bold" }, invoiceName)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "text-tiny text-color-normal" }, translate('dataconfirm.invoices.invoice.serviceDetails')),
                react_1.default.createElement(List, { noGutter: "vertical", type: "unstyled", direction: "inline", bordered: true, className: "text-bold" },
                    react_1.default.createElement(ListItem, null, invoice.title || invoice.refNumber))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "text-tiny text-color-normal" }, translate('dataconfirm.invoices.invoice.invoiceDeliveryType')),
                react_1.default.createElement("p", { className: "text-bold" }, invoice.invoiceDeliveries.length === 0
                    ? translate('dataconfirm.invoices.invoice.delivery.invoiceToSelfService')
                    : invoice.invoiceDeliveries.map((it) => translate(`dataconfirm.invoices.invoice.delivery.${it}`)).join(', ')))));
    }
    renderInputs() {
        const { invoice: { address, emailAddresses, invoiceDeliveries } } = this.props;
        const { Text } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        const invoiceDeliveriesComponents = invoiceDeliveries.map((type, index) => {
            if (type === 'EMAIL') {
                const emailAddressComponents = emailAddresses.map((email, emailIndex) => {
                    return (react_1.default.createElement(Email_1.default, { id: `invoice-e-mail-${emailIndex}`, key: `email-${emailIndex}`, defaultValue: email, required: true, onChange: (value, valid) => this.onEmailChange(value, valid, emailIndex), label: translate('dataconfirm.invoices.invoice.delivery.emailAddress') }));
                });
                return react_1.default.createElement(Text, { key: `email-${type}-${index}` }, emailAddressComponents);
            }
            if (type === 'POST') {
                const addressWidth = ['xs-12', 'md-8', 'xl-9'];
                const roomWidth = ['xs-12', 'md-4', 'xl-3'];
                const adr = ComponentInvoiceSettingsStore_1.default.convertToRegistryAddress(address);
                return (react_1.default.createElement(Address_1.default, { key: `address-${type}-${index}`, type: "registry", defaultValue: adr, width: { address: addressWidth, room: roomWidth }, onChange: this.onAddressChange, requiredFields: ['address', 'room'] }));
            }
            return null;
        });
        return react_1.default.createElement(Text, null, invoiceDeliveriesComponents);
    }
    renderSpinner() {
        const { Overlay } = this.frontLibrary;
        return react_1.default.createElement(Overlay, { className: "overlay--fixed", spinner: true });
    }
    get isConfirmEnabled() {
        return this.invoiceChanged && !this.currentEmails.some((email) => !email.valid) && this.currentAddressValid;
    }
};
__decorate([
    mobx_1.observable
], EditInvoiceDetailsModal.prototype, "invoiceChanged", void 0);
__decorate([
    mobx_1.observable
], EditInvoiceDetailsModal.prototype, "currentAddressValid", void 0);
__decorate([
    mobx_1.action
], EditInvoiceDetailsModal.prototype, "onAddressChange", void 0);
__decorate([
    mobx_1.action
], EditInvoiceDetailsModal.prototype, "onEmailChange", void 0);
__decorate([
    mobx_1.computed
], EditInvoiceDetailsModal.prototype, "isConfirmEnabled", null);
EditInvoiceDetailsModal = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], EditInvoiceDetailsModal);
exports["default"] = EditInvoiceDetailsModal;


/***/ }),

/***/ 6960:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const table_1 = __webpack_require__(7706);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const AddressFormatUtil_1 = __webpack_require__(9318);
const customerIdAsKey_1 = __importDefault(__webpack_require__(2468));
const StoresUtil_1 = __webpack_require__(5855);
const StringUtil_1 = __webpack_require__(5085);
const EditInvoiceDetailsModal_1 = __importDefault(__webpack_require__(4133));
let EditInvoices = class EditInvoices extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "selectedInvoice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailChangeAllVisibility", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "addressChangeAllVisibility", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceSettingsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailChangeNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { updateAllEmails, showChangeAllPostInvoiceEmailNotice } = this.componentInvoiceSettingsStore;
                const { email } = this.componentCustomerContactInfoStore;
                return (this.emailChangeAllVisibility &&
                    showChangeAllPostInvoiceEmailNotice &&
                    this.changeAllInvoiceInfoNotice('dataconfirm.invoices.invoice.button.applyEmailAll', email.value, updateAllEmails, this.closeEmailChangeAllVisibility));
            }
        });
        Object.defineProperty(this, "addressChangeNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { updateAllAddresses, showChangeAllPostInvoiceAddressesNotice } = this.componentInvoiceSettingsStore;
                return (this.addressChangeAllVisibility &&
                    showChangeAllPostInvoiceAddressesNotice &&
                    this.changeAllInvoiceInfoNotice('dataconfirm.invoices.invoice.button.applyAddressAll', (0, AddressFormatUtil_1.formatInvoiceAddress)(this.componentInvoiceSettingsStore.selectedRegistryAddressToInvoiceAddress()), updateAllAddresses, this.closeAddressChangeAllVisibility));
            }
        });
        Object.defineProperty(this, "changeAllInvoiceInfoNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (label, value, updateContact, closeNotice) => {
                const { Grid, GridColumn, Notice, Button } = this.frontLibrary;
                const { translate } = this.componentTranslateStore;
                return (react_1.default.createElement(Notice, { onCloseClick: closeNotice },
                    react_1.default.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                        react_1.default.createElement(GridColumn, { width: ['xs', 'max-sm'] },
                            react_1.default.createElement("p", { dangerouslySetInnerHTML: {
                                    __html: `${translate(label)} <b>${value}</b>?`
                                } })),
                        react_1.default.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                            react_1.default.createElement(Button, { variant: "secondary", text: translate('dataconfirm.invoices.invoice.confirmUpdate'), onClick: updateContact })))));
            }
        });
        Object.defineProperty(this, "invoiceTable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { translate } = this.componentTranslateStore;
                const { customerInvoiceSettings, customerInvoiceSettings: { invoiceSettings } } = this.componentInvoiceSettingsStore;
                return (react_1.default.createElement(table_1.Table, { responsive: "cols", break: "lg" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement(table_1.TableRow, null,
                            react_1.default.createElement(table_1.TableCell, { type: "th", scope: "col" }, translate('dataconfirm.invoices.invoice.name')),
                            react_1.default.createElement(table_1.TableCell, { type: "th", scope: "col" }, translate('dataconfirm.invoices.invoice.invoiceDeliveryType')),
                            react_1.default.createElement(table_1.TableCell, { type: "th", scope: "col" }, translate('dataconfirm.invoices.invoice.address')),
                            react_1.default.createElement(table_1.TableCell, { type: "th", scope: "col" },
                                react_1.default.createElement("span", { className: "sr-only" }, translate('dataconfirm.invoices.invoice.change'))))),
                    react_1.default.createElement("tbody", null, customerInvoiceSettings && invoiceSettings.map((invoice, index) => this.invoiceTableRow(invoice, index)))));
            }
        });
        Object.defineProperty(this, "invoiceTableRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (invoice, key) => {
                const { title, refNumber, invoiceDeliveries, address, emailAddresses } = invoice;
                const { Button } = this.frontLibrary;
                const { translate } = this.componentTranslateStore;
                const hasInvoiceDeliveries = invoiceDeliveries && invoiceDeliveries.length > 0;
                const invoiceDeliveryLabels = invoiceDeliveries.map((delivery) => translate(`dataconfirm.invoices.invoice.delivery.${delivery}`));
                return (react_1.default.createElement(table_1.TableRow, { key: key },
                    react_1.default.createElement(table_1.TableCell, { headless: true },
                        react_1.default.createElement("p", { className: 'text-bold' }, title || refNumber)),
                    react_1.default.createElement(table_1.TableCell, null, !hasInvoiceDeliveries
                        ? translate('dataconfirm.invoices.invoice.delivery.invoiceToSelfService')
                        : invoiceDeliveryLabels.map((label, index) => react_1.default.createElement("div", { key: `invoice-delivery-label-${index}` }, label))),
                    react_1.default.createElement(table_1.TableCell, null, !hasInvoiceDeliveries ? (react_1.default.createElement("div", null, "-")) : (react_1.default.createElement("div", null, invoiceDeliveryLabels.map((label, index) => {
                        if (invoiceDeliveries[index] === 'EMAIL') {
                            return react_1.default.createElement("div", { key: 'invoice-delivery-emails' }, (0, StringUtil_1.valueOrDash)(emailAddresses.join(', ')));
                        }
                        if (invoiceDeliveries[index] === 'POST' && address) {
                            return react_1.default.createElement("div", { key: 'invoice-delivery-address' }, (0, StringUtil_1.valueOrDash)(address.addressLabel));
                        }
                        return react_1.default.createElement("div", { key: 'empty-div' }, "-");
                    })))),
                    react_1.default.createElement(table_1.TableCell, { className: "text-right" },
                        react_1.default.createElement(Button, { onClick: () => this.openModal(invoice), disabled: this.changeButtonIsDisabled(invoice), text: translate('dataconfirm.invoices.invoice.button.change'), iconLeft: "#edit", link: true }))));
            }
        });
        Object.defineProperty(this, "changeButtonIsDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (invoice) => {
                return !invoice.invoiceDeliveries.some((deli) => ['POST', 'EMAIL'].includes(deli));
            }
        });
        Object.defineProperty(this, "closeModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.selectedInvoice = null;
            }
        });
        Object.defineProperty(this, "onInvoiceSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newEmails, newAddress) => {
                if (newAddress) {
                    this.componentInvoiceSettingsStore.updateAddress(this.selectedInvoice, newAddress);
                }
                if (newEmails) {
                    this.componentInvoiceSettingsStore.updateEmails(this.selectedInvoice, newEmails);
                }
                this.closeModal();
            }
        });
        Object.defineProperty(this, "closeAddressChangeAllVisibility", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.addressChangeAllVisibility = false;
            }
        });
        Object.defineProperty(this, "closeEmailChangeAllVisibility", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.emailChangeAllVisibility = false;
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.componentSsoStore.customerId, () => {
            this.componentInvoiceSettingsStore.init();
        }, { fireImmediately: true });
    }
    render() {
        const { Spinner, Grid, GridColumn } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        const { isLoaded, hasInvoices } = this.componentInvoiceSettingsStore;
        if (!isLoaded) {
            return react_1.default.createElement(Spinner, null);
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            hasInvoices && (react_1.default.createElement(Grid, null,
                react_1.default.createElement(GridColumn, { width: ['md-8'] },
                    react_1.default.createElement("p", null, translate('dataconfirm.invoices.invoice.changeInvoiceInfo'))))),
            this.emailChangeNotice(),
            this.addressChangeNotice(),
            hasInvoices ? this.invoiceTable() : this.renderNoInvoicesNotice(),
            this.selectedInvoice && react_1.default.createElement(EditInvoiceDetailsModal_1.default, { invoice: this.selectedInvoice, onSave: this.onInvoiceSave, onClose: this.closeModal })));
    }
    openModal(invoice) {
        this.selectedInvoice = invoice;
    }
    renderNoInvoicesNotice() {
        const { Notice } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        return (react_1.default.createElement(Notice, { size: "small" },
            react_1.default.createElement("p", { className: "text-left" }, translate('dataconfirm.invoices.noInvoices'))));
    }
};
__decorate([
    mobx_1.observable
], EditInvoices.prototype, "selectedInvoice", void 0);
__decorate([
    mobx_1.observable
], EditInvoices.prototype, "emailChangeAllVisibility", void 0);
__decorate([
    mobx_1.observable
], EditInvoices.prototype, "addressChangeAllVisibility", void 0);
__decorate([
    mobx_1.action
], EditInvoices.prototype, "closeModal", void 0);
__decorate([
    mobx_1.action
], EditInvoices.prototype, "openModal", null);
__decorate([
    mobx_1.action
], EditInvoices.prototype, "onInvoiceSave", void 0);
__decorate([
    mobx_1.action
], EditInvoices.prototype, "closeAddressChangeAllVisibility", void 0);
__decorate([
    mobx_1.action
], EditInvoices.prototype, "closeEmailChangeAllVisibility", void 0);
EditInvoices = __decorate([
    customerIdAsKey_1.default,
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], EditInvoices);
exports["default"] = EditInvoices;


/***/ }),

/***/ 3114:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["PERIODIC_INVOICES"] = "PERIODIC_INVOICES";
    ContentType["MOBILE"] = "MOBILE";
    ContentType["BROADBAND"] = "BROADBAND";
    ContentType["STATE_FEES"] = "STATE_FEES";
    ContentType["FINANCE"] = "FINANCE";
    ContentType["GOODS"] = "GOODS";
    ContentType["DEBT"] = "DEBT";
    ContentType["TELESERVICES"] = "TELESERVICES";
    ContentType["PENALTY"] = "PENALTY";
    ContentType["DAX_REF_NUMBER"] = "DAX_REF_NUMBER";
    ContentType["MASTER_REF_NUMBER"] = "MASTER_REF_NUMBER";
})(ContentType = exports.ContentType || (exports.ContentType = {}));


/***/ }),

/***/ 4631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InitialSettings = void 0;
const mobx_1 = __webpack_require__(259);
const RepresentationRightUtil_1 = __importDefault(__webpack_require__(8020));
const types_1 = __webpack_require__(2742);
const MandateUtil_1 = __webpack_require__(4305);
var InitialSettings;
(function (InitialSettings) {
    InitialSettings[InitialSettings["FROM_PERSON"] = 0] = "FROM_PERSON";
    InitialSettings[InitialSettings["CHECKED"] = 1] = "CHECKED";
    InitialSettings[InitialSettings["DELEGATABLE"] = 2] = "DELEGATABLE";
    InitialSettings[InitialSettings["UNCHECKED"] = 3] = "UNCHECKED";
})(InitialSettings = exports.InitialSettings || (exports.InitialSettings = {}));
class DisplayableReferenceNumbersHelper {
    constructor(representationRights, billingReferenceNumbers) {
        Object.defineProperty(this, "billingReferenceNumbers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "representationRightsGivenByCustomer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "customMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_byPerson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_forPerson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "giverRepresentationRightUtil", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "receiverRepresentationRightUtil", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "displayableMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx_1.observable.array([])
        });
        Object.defineProperty(this, "overriddenMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx_1.observable.array([])
        });
        Object.defineProperty(this, "modalViews", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx_1.observable.map()
        });
        Object.defineProperty(this, "initialSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "allAccountsRefNumTitleTranslation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        if (!!representationRights.representationRightsGivenByCustomer) {
            this.representationRightsGivenByCustomer = representationRights.representationRightsGivenByCustomer;
            this.billingReferenceNumbers = representationRights.billingReferenceNumbers;
        }
        else if (!!billingReferenceNumbers) {
            this.representationRightsGivenByCustomer = representationRights;
            this.billingReferenceNumbers = billingReferenceNumbers;
        }
        else {
            this.customMandates = representationRights;
        }
        this.initialSettings = InitialSettings.FROM_PERSON;
        if (this.usesCustomMandates) {
            this.initCustomMandates();
        }
    }
    static init(representationRights, billingReferenceNumbers) {
        return new DisplayableReferenceNumbersHelper(representationRights, billingReferenceNumbers);
    }
    initCustomMandates() {
        this.customMandates.forEach((repRight) => {
            const repRightCopy = JSON.parse(JSON.stringify(repRight));
            repRightCopy.displayableReferenceNumbers.sort(DisplayableReferenceNumbersHelper.SORT_BY.allAccountsFirst);
            this.displayableMandates.push(repRightCopy);
        });
        if (this.displayableMandates.length === 0) {
            throw new Error('No modifiable mandate types were given');
        }
        this.setUpDisplayableMandates();
    }
    initActualMandates() {
        if (!this.usesActualMandates || !this.giverRepresentationRightUtil) {
            return;
        }
        this.modifiableMandateTypes.forEach((mandateType) => {
            const refNumsUtil = this.giverRepresentationRightUtil.for(mandateType);
            const result = { mandateType, displayableReferenceNumbers: [] };
            result.displayableReferenceNumbers.push({
                referenceNumber: this.allAccountsRefNumTitleTranslation,
                accountId: -1,
                enabled: refNumsUtil.hasAllAccounts,
                enabledEditable: refNumsUtil.hasAllAccounts,
                delegatable: refNumsUtil.allAccountsDelegatable,
                delegatableEditable: refNumsUtil.allAccountsDelegatabilityEditable
            });
            result.displayableReferenceNumbers.push(...refNumsUtil.getDisplayableReferenceNumbers());
            result.displayableReferenceNumbers.sort(DisplayableReferenceNumbersHelper.SORT_BY.allAccountsFirst);
            this.displayableMandates.push(result);
        });
        this.setUpDisplayableMandates();
    }
    initModalViews() {
        this.displayableMandates.forEach((mandate) => {
            var _a;
            const allRefNums = mandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1);
            const hasAllAccounts = (this.usesActualMandates && this.giverRepresentationRightUtil.for(mandate.mandateType).hasAllAccounts) ||
                !!((_a = this.customMandates) === null || _a === void 0 ? void 0 : _a.find((customMandate) => customMandate.mandateType === mandate.mandateType).displayableReferenceNumbers.find((refNum) => refNum.accountId === -1));
            const defaultAllView = !hasAllAccounts ? false : allRefNums.enabled || mandate.displayableReferenceNumbers.every((refNum) => !refNum.enabled);
            this.modalViews.set(mandate.mandateType, defaultAllView ? types_1.ReferenceNumbersView.ALL : types_1.ReferenceNumbersView.SINGLE);
        });
    }
    forPerson(person) {
        this._forPerson = person;
        if (this.usesActualMandates && !!this.receiverRepresentationRight) {
            this.receiverRepresentationRightUtil = RepresentationRightUtil_1.default.init(this.receiverRepresentationRight, this.billingReferenceNumbers);
        }
        return this;
    }
    byPerson(person) {
        this._byPerson = person;
        if (this.usesActualMandates && !!this.giverRepresentationRight) {
            this.giverRepresentationRightUtil = RepresentationRightUtil_1.default.init(this.giverRepresentationRight, this.billingReferenceNumbers);
            this.initActualMandates();
        }
        return this;
    }
    withAllAccountsTitleTranslation(translation) {
        this.allAccountsRefNumTitleTranslation = translation;
        return this;
    }
    withReferenceNumbers(initialSettings) {
        this.initialSettings = initialSettings;
        return this;
    }
    withOverriddenMandates(overriddenMandates) {
        if (!!overriddenMandates && overriddenMandates.length > 0) {
            this.overriddenMandates = overriddenMandates;
        }
        return this;
    }
    get receiverRepresentationRight() {
        return this.findActualRepresentationRightForPerson(this._forPerson);
    }
    get giverRepresentationRight() {
        return this.findActualRepresentationRightForPerson(this._byPerson);
    }
    get usesActualMandates() {
        return !!this.representationRightsGivenByCustomer && !!this.billingReferenceNumbers;
    }
    get usesCustomMandates() {
        return !this.usesActualMandates;
    }
    get mandates() {
        this.initModalViews();
        this.setUpReferenceNumbersBasedOnMandateType();
        return this.displayableMandates;
    }
    get views() {
        return this.modalViews;
    }
    get anyRefNumsEnabled() {
        const hasAnyRefNumsEnabled = (mandateType) => {
            var _a;
            const view = this.modalViews.get(mandateType);
            const mandate = this.displayableMandates.find((mandate) => mandate.mandateType === mandateType);
            return view === types_1.ReferenceNumbersView.ALL
                ? (_a = mandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1)) === null || _a === void 0 ? void 0 : _a.enabled
                : !!mandate.displayableReferenceNumbers.find((refNum) => refNum.accountId !== -1 && refNum.enabled);
        };
        let hasOtherNonDisplayableMandates = false;
        if (this.usesActualMandates && !!this.receiverRepresentationRightUtil) {
            const nonDisplayableReceiverMandateTypes = this.receiverRepresentationRight.mandates
                .map((mandate) => mandate.type)
                .filter((mandateType) => !this.modifiableMandateTypes.includes(mandateType));
            hasOtherNonDisplayableMandates = nonDisplayableReceiverMandateTypes.length > 0;
        }
        return this.modifiableMandateTypes.some(hasAnyRefNumsEnabled) || hasOtherNonDisplayableMandates;
    }
    get modifiableMandateTypes() {
        const displayOrder = (a, b) => {
            return MandateUtil_1.ORDERED_MODIFIABLE_MANDATE_TYPES.indexOf(a) - MandateUtil_1.ORDERED_MODIFIABLE_MANDATE_TYPES.indexOf(b);
        };
        if (this.usesActualMandates) {
            if (this.giverRepresentationRightUtil.hasLegalMandate) {
                return MandateUtil_1.ORDERED_MODIFIABLE_MANDATE_TYPES;
            }
            return this.giverRepresentationRight.mandates
                .filter((mandate) => mandate.referenceNumbers.some((refNum) => refNum.delegatable))
                .map((mandate) => mandate.type)
                .sort(displayOrder);
        }
        return this.customMandates
            .filter((repRight) => repRight.displayableReferenceNumbers.length > 0)
            .map((repRight) => repRight.mandateType)
            .sort(displayOrder);
    }
    onDisplayedReferenceNumberChange(mandateType, referenceNumber) {
        const mandate = this.displayableMandates.find((mandate) => mandate.mandateType === mandateType);
        const refNum = mandate.displayableReferenceNumbers.find((refNum) => refNum.referenceNumber === referenceNumber.referenceNumber);
        refNum.enabled = referenceNumber.enabled;
        refNum.delegatable = referenceNumber.delegatable;
        this.setUpReferenceNumbersBasedOnMandateType();
    }
    onViewChange(newView, mandateType) {
        this.modalViews.set(mandateType, newView);
        this.setUpReferenceNumbersBasedOnMandateType();
    }
    get newRepresentationRight() {
        if (this.usesCustomMandates) {
            return this.displayableMandates;
        }
        const result = this.displayableMandates.slice();
        this.modifiableMandateTypes.forEach((mandateType) => {
            const displayableMandate = result.find((mandate) => mandate.mandateType === mandateType);
            const hasEnabledRefNums = displayableMandate.displayableReferenceNumbers.some((refNum) => refNum.enabled);
            if (hasEnabledRefNums) {
                const actualRefNums = [];
                displayableMandate.displayableReferenceNumbers
                    .filter((refNum) => refNum.enabled)
                    .forEach((refNum) => {
                    if (refNum.accountId === -1) {
                        actualRefNums.push({ ...this.giverRepresentationRightUtil.for(mandateType).newAllAccountsReferenceNumber(), delegatable: refNum.delegatable });
                    }
                    else {
                        const referenceNumbers = [];
                        if (!!this.receiverRepresentationRightUtil) {
                            referenceNumbers.push(...this.receiverRepresentationRightUtil.for(mandateType).getReferenceNumbers(refNum.accountId));
                        }
                        if (referenceNumbers.length === 0) {
                            referenceNumbers.push(...this.giverRepresentationRightUtil.for(mandateType).getReferenceNumbers(refNum.accountId));
                        }
                        referenceNumbers.forEach((actualRefNum) => (actualRefNum.delegatable = refNum.delegatable));
                        actualRefNums.push(...referenceNumbers);
                    }
                });
                displayableMandate.referenceNumbers = actualRefNums;
            }
            else {
                displayableMandate.referenceNumbers = [];
            }
        });
        return result;
    }
    setUpDisplayableMandates() {
        switch (this.initialSettings) {
            case InitialSettings.CHECKED:
                this.setAllRefNums(true, false);
                break;
            case InitialSettings.DELEGATABLE:
                this.setAllRefNums(true, true);
                break;
            case InitialSettings.UNCHECKED:
                this.setAllRefNums(false, false);
                break;
            default:
                this.setUpReferenceNumbersBasedOnReceiver();
        }
        this.setUpOverriddenMandates();
    }
    setAllRefNums(checked, delegatable) {
        this.displayableMandates.forEach((mandate) => {
            mandate.displayableReferenceNumbers.forEach((refNum) => {
                refNum.enabled = checked;
                refNum.delegatable = delegatable;
            });
        });
    }
    setUpReferenceNumbersBasedOnReceiver() {
        if (this.usesCustomMandates || this.initialSettings !== InitialSettings.FROM_PERSON) {
            return;
        }
        this.displayableMandates.forEach((mandate) => {
            const receiverRefNumUtil = this.receiverRepresentationRightUtil.for(mandate.mandateType);
            const receiverDisplayableRefNums = receiverRefNumUtil.getDisplayableReferenceNumbers();
            mandate.displayableReferenceNumbers.forEach((displayableRefNum) => {
                const actualRefNums = receiverRefNumUtil.getReferenceNumbers(displayableRefNum.accountId);
                const checked = receiverRefNumUtil.hasAllAccounts ||
                    (actualRefNums.length > 0 &&
                        actualRefNums.every((actualRefNum) => receiverRefNumUtil.exists(actualRefNum.elionAccountId || actualRefNum.emtAccountId || actualRefNum.diilAccountId)));
                const delegatable = receiverRefNumUtil.hasAllAccounts
                    ? receiverRefNumUtil.allAccountsDelegatable
                    : !!receiverDisplayableRefNums.find((refNum) => refNum.accountId === displayableRefNum.accountId);
                displayableRefNum.enabled = checked;
                displayableRefNum.delegatable = delegatable;
            });
        });
    }
    setUpReferenceNumbersBasedOnMandateType() {
        if (this.modalViews.size === 0) {
            return;
        }
        const billingMandate = this.displayableMandates.find((mandate) => mandate.mandateType === types_1.MandateType.BILLING);
        if (!billingMandate) {
            return;
        }
        const distinctionMandate = this.displayableMandates.find((mandate) => mandate.mandateType === types_1.MandateType.SERVICE_USAGE_DISTINCTION);
        if (!distinctionMandate) {
            return;
        }
        const billingMandateView = this.modalViews.get(types_1.MandateType.BILLING);
        const disableAndUncheck = (refNum) => {
            if (!!refNum) {
                refNum.enabledEditable = false;
                refNum.delegatableEditable = false;
                refNum.enabled = false;
                refNum.delegatable = false;
            }
        };
        const setDelegatableEditability = (refNum) => {
            refNum.delegatableEditable =
                this.giverRepresentationRightUtil.hasLegalMandate ||
                    this.giverRepresentationRightUtil.for(types_1.MandateType.SERVICE_USAGE_DISTINCTION).isDelegatable(refNum.accountId);
            if (!refNum.delegatableEditable) {
                refNum.delegatable = false;
            }
        };
        if (billingMandateView === types_1.ReferenceNumbersView.ALL) {
            const billingMandateAllRefNums = billingMandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1);
            if (!billingMandateAllRefNums.enabled) {
                distinctionMandate.displayableReferenceNumbers.forEach(disableAndUncheck);
            }
            else {
                distinctionMandate.displayableReferenceNumbers.forEach((distinctionRefNum) => {
                    distinctionRefNum.enabledEditable = true;
                    setDelegatableEditability(distinctionRefNum);
                });
            }
            if (!billingMandateAllRefNums.delegatable) {
                distinctionMandate.displayableReferenceNumbers.forEach((distinctionRefNum) => {
                    distinctionRefNum.delegatableEditable = false;
                    distinctionRefNum.delegatable = false;
                });
            }
            else {
                distinctionMandate.displayableReferenceNumbers.forEach(setDelegatableEditability);
            }
        }
        else {
            const distinctionMandateAllRefNums = distinctionMandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1);
            if (!!distinctionMandateAllRefNums) {
                disableAndUncheck(distinctionMandateAllRefNums);
            }
            billingMandate.displayableReferenceNumbers
                .filter((refNum) => refNum.accountId !== -1)
                .forEach((billingRefNum) => {
                const distinctionRefNum = distinctionMandate.displayableReferenceNumbers.find((distinctionRefNum) => distinctionRefNum.accountId === billingRefNum.accountId);
                if (!distinctionRefNum) {
                    return;
                }
                if (billingRefNum.enabled) {
                    distinctionRefNum.enabledEditable = true;
                    setDelegatableEditability(distinctionRefNum);
                }
                else {
                    disableAndUncheck(distinctionRefNum);
                }
                if (billingRefNum.delegatable) {
                    setDelegatableEditability(distinctionRefNum);
                }
                else {
                    distinctionRefNum.delegatableEditable = false;
                    distinctionRefNum.delegatable = false;
                }
            });
        }
    }
    setUpOverriddenMandates() {
        if (!this.overriddenMandates || this.overriddenMandates.length === 0) {
            return;
        }
        this.displayableMandates.forEach((mandate) => {
            const overriddenMandate = this.overriddenMandates.find((overriddenMandate) => overriddenMandate.mandateType === mandate.mandateType);
            if (!!overriddenMandate) {
                mandate.displayableReferenceNumbers.forEach((displayableRefNum) => {
                    const overriddenRefNum = overriddenMandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === displayableRefNum.accountId);
                    if (!!overriddenRefNum) {
                        displayableRefNum.enabled = overriddenRefNum.enabled;
                        displayableRefNum.delegatable = overriddenRefNum.delegatable;
                    }
                });
            }
        });
        this.resolveConflicts();
    }
    resolveConflicts() {
        this.displayableMandates.forEach((mandate) => {
            mandate.displayableReferenceNumbers.forEach((refNum) => {
                if (refNum.enabledEditable === false && refNum.enabled) {
                    refNum.enabled = false;
                }
                if (refNum.delegatableEditable === false && refNum.delegatable) {
                    refNum.delegatable = false;
                }
            });
        });
    }
    findActualRepresentationRightForPerson(person) {
        if (this.usesCustomMandates) {
            return undefined;
        }
        return this.representationRightsGivenByCustomer.find((repRight) => repRight.relevantParty.registrationNumber === person.personalCode && repRight.relevantParty.countryCode === person.personalCodeCountryCode);
    }
}
Object.defineProperty(DisplayableReferenceNumbersHelper, "SORT_BY", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        allAccountsFirst: (refNum1, refNum2) => {
            if (refNum1.accountId === -1) {
                return -1;
            }
            if (refNum2.accountId === -1) {
                return 1;
            }
            return 0;
        }
    }
});
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "billingReferenceNumbers", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "representationRightsGivenByCustomer", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "customMandates", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "_byPerson", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "_forPerson", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "giverRepresentationRightUtil", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "receiverRepresentationRightUtil", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "displayableMandates", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "overriddenMandates", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "modalViews", void 0);
__decorate([
    mobx_1.observable
], DisplayableReferenceNumbersHelper.prototype, "initialSettings", void 0);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "initCustomMandates", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "initActualMandates", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "initModalViews", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "forPerson", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "byPerson", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "withReferenceNumbers", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "withOverriddenMandates", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "receiverRepresentationRight", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "giverRepresentationRight", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "usesActualMandates", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "usesCustomMandates", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "mandates", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "views", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "anyRefNumsEnabled", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "modifiableMandateTypes", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "onDisplayedReferenceNumberChange", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "onViewChange", null);
__decorate([
    mobx_1.computed
], DisplayableReferenceNumbersHelper.prototype, "newRepresentationRight", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "setAllRefNums", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "setUpReferenceNumbersBasedOnReceiver", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "setUpReferenceNumbersBasedOnMandateType", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "setUpOverriddenMandates", null);
__decorate([
    mobx_1.action
], DisplayableReferenceNumbersHelper.prototype, "resolveConflicts", null);
exports["default"] = DisplayableReferenceNumbersHelper;


/***/ }),

/***/ 4305:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ORDERED_MODIFIABLE_MANDATE_TYPES = void 0;
const types_1 = __webpack_require__(2742);
exports.ORDERED_MODIFIABLE_MANDATE_TYPES = [
    types_1.MandateType.SERVICE,
    types_1.MandateType.BILLING,
    types_1.MandateType.SERVICE_USAGE_DISTINCTION,
    types_1.MandateType.LEASING,
    types_1.MandateType.GOODS
];


/***/ }),

/***/ 1054:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReferenceNumbersModalViewContext = void 0;
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const Footer_1 = __importDefault(__webpack_require__(8483));
const ReferenceNumbersModalContent_1 = __importDefault(__webpack_require__(9461));
const DisplayableReferenceNumbersHelper_1 = __importStar(__webpack_require__(4631));
const RepresentationRightUtil_1 = __importDefault(__webpack_require__(8020));
const types_1 = __webpack_require__(2742);
const InitialValues = {
    FROM_PERSON: 'FROM_PERSON',
    ALL_ENABLED: 'ALL_ENABLED',
    ALL_DELEGATABLE: 'ALL_DELEGATABLE',
    NONE_ENABLED: 'NONE_ENABLED'
};
const ReferenceNumbersModal = (0, mobx_react_1.observer)((props) => {
    var _a, _b;
    const { frontLibrary: { Modal, ModalContent, Text, ModalFooter, Tabs, TabsItem, Heading, Notice }, componentSsoStore: { person: { personalCode, personalCodeCountryCode } }, componentTranslateStore: { translate } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const [mandates, setMandates] = react_1.default.useState([]);
    const [currentPersonRepRightsUtil, setCurrentPersonRepRightsUtil] = react_1.default.useState(null);
    const [helper, setHelper] = react_1.default.useState(null);
    const modalWidth = ((_a = props.widths) === null || _a === void 0 ? void 0 : _a.main) === '12-col' ? undefined : ((_b = props.widths) === null || _b === void 0 ? void 0 : _b.main) || '8-col';
    const isRepresentationRight = !!props.representationRights.representationRightsGivenByCustomer;
    react_1.default.useEffect(() => {
        let refNumSettings;
        switch (props.initialValues) {
            case 'ALL_ENABLED':
                refNumSettings = DisplayableReferenceNumbersHelper_1.InitialSettings.CHECKED;
                break;
            case 'ALL_DELEGATABLE':
                refNumSettings = DisplayableReferenceNumbersHelper_1.InitialSettings.DELEGATABLE;
                break;
            case 'NONE_ENABLED':
                refNumSettings = DisplayableReferenceNumbersHelper_1.InitialSettings.UNCHECKED;
                break;
            default:
                refNumSettings = DisplayableReferenceNumbersHelper_1.InitialSettings.FROM_PERSON;
        }
        const helper = DisplayableReferenceNumbersHelper_1.default.init(props.representationRights)
            .withOverriddenMandates(props.overriddenMandates)
            .withReferenceNumbers(refNumSettings)
            .withAllAccountsTitleTranslation(translate('referenceNumbersModal.table.row.allAccounts'))
            .forPerson(props.forPerson)
            .byPerson({ personalCode, personalCodeCountryCode });
        if (helper.usesActualMandates && !helper.giverRepresentationRight) {
            throw new Error('User is not a representative');
        }
        setHelper(helper);
        if (helper.usesCustomMandates) {
            setMandates(helper.mandates);
            return;
        }
        const currentPersonRepRightUtil = RepresentationRightUtil_1.default.init(helper.giverRepresentationRight, helper.billingReferenceNumbers);
        if (!currentPersonRepRightUtil.canModifyAnyReferenceNumbers) {
            throw new Error(`You cannot modify reference numbers for this person: ${props.forPerson.personalCode}-${props.forPerson.personalCodeCountryCode}`);
        }
        setCurrentPersonRepRightsUtil(currentPersonRepRightUtil);
        setMandates(helper.mandates);
    }, []);
    if (mandates.length === 0 || (isRepresentationRight && !currentPersonRepRightsUtil)) {
        return null;
    }
    const canSwitchViews = (representationRight) => {
        var _a;
        return (!currentPersonRepRightsUtil && !!((_a = representationRight.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1)) === null || _a === void 0 ? void 0 : _a.enabled)) ||
            !!(currentPersonRepRightsUtil === null || currentPersonRepRightsUtil === void 0 ? void 0 : currentPersonRepRightsUtil.hasLegalMandate) ||
            !!(currentPersonRepRightsUtil === null || currentPersonRepRightsUtil === void 0 ? void 0 : currentPersonRepRightsUtil.for(representationRight.mandateType).allAccountsDelegatable);
    };
    const isFromPerson = !!!props.initialValues || props.initialValues === 'FROM_PERSON';
    return (react_1.default.createElement(exports.ReferenceNumbersModalViewContext.Provider, { value: helper.views },
        react_1.default.createElement(Modal, { size: modalWidth, hasContentComponent: true, isOpen: true, onClose: props.onClose },
            react_1.default.createElement(ModalContent, null,
                react_1.default.createElement(Text, null,
                    react_1.default.createElement(Heading, { element: "h2" }, translate('referenceNumbersModal.title')),
                    react_1.default.createElement(Tabs, { defaultCurrentTab: `ref-num-modal-tab-${mandates[0].mandateType}`, border: "top", "aria-labelledby": "ref-num-modal-tabs", size: "small" }, mandates.map((mandate) => (react_1.default.createElement(TabsItem, { key: `ref-num-modal-${mandate.mandateType}`, type: !!props.employee ? 'employee' : undefined, id: `ref-num-modal-tab-${mandate.mandateType}`, label: translate(`referenceNumbersModal.mandates.${mandate.mandateType}`) },
                        react_1.default.createElement(ReferenceNumbersModalContent_1.default, { key: `reference-numbers-modal-content-${mandate.mandateType}`, referenceNumbers: mandate.displayableReferenceNumbers, mandateType: mandate.mandateType, canSwitchViews: canSwitchViews(mandate), employee: props.employee, onChange: (refNum) => helper.onDisplayedReferenceNumberChange(mandate.mandateType, refNum), onViewChange: (view) => helper.onViewChange(view, mandate.mandateType) }),
                        isFromPerson && !helper.anyRefNumsEnabled && react_1.default.createElement(Notice, { type: "info" }, translate('referenceNumbersModal.removalWarning')))))))),
            react_1.default.createElement(ModalFooter, null,
                react_1.default.createElement(Footer_1.default, { employee: props.employee, onSave: () => {
                        const callbackObject = copyOf(helper.newRepresentationRight);
                        helper.newRepresentationRight.forEach((mandate, index) => {
                            const view = helper.views.get(mandate.mandateType);
                            const displayedRefNums = callbackObject[index].displayableReferenceNumbers;
                            const actualRefNums = callbackObject[index].referenceNumbers;
                            if (view === types_1.ReferenceNumbersView.ALL) {
                                callbackObject[index].referenceNumbers = actualRefNums.filter((refNum) => refNum.elionAccountId === -1 || refNum.emtAccountId === -1 || refNum.diilAccountId === -1);
                                callbackObject[index].displayableReferenceNumbers = displayedRefNums.filter((refNum) => refNum.accountId === -1);
                            }
                            else {
                                callbackObject[index].referenceNumbers = actualRefNums.filter((refNum) => refNum.elionAccountId !== -1 && refNum.emtAccountId !== -1 && refNum.diilAccountId !== -1);
                                callbackObject[index].displayableReferenceNumbers = displayedRefNums.filter((refNum) => refNum.accountId !== -1);
                            }
                        });
                        props.onSave(callbackObject);
                    }, onClose: props.onClose })))));
});
exports["default"] = ReferenceNumbersModal;
exports.ReferenceNumbersModalViewContext = react_1.default.createContext(null);
const copyOf = (arr) => JSON.parse(JSON.stringify(arr));


/***/ }),

/***/ 8020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReferenceNumberUtil = void 0;
const date_fns_1 = __webpack_require__(429);
const mobx_1 = __webpack_require__(259);
const types_1 = __webpack_require__(2742);
const getAccountId = (refNum) => {
    return refNum.elionAccountId || refNum.emtAccountId || refNum.diilAccountId;
};
class RepresentationRightUtil {
    constructor(representationRight, billingRefNums) {
        Object.defineProperty(this, "legalMandate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "billingRefNums", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "representationRight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.billingRefNums = billingRefNums;
        this.representationRight = representationRight;
        this.legalMandate = representationRight.mandates.find((mandate) => mandate.type === types_1.MandateType.LEGAL);
    }
    static init(representationRight, billingRefNums) {
        return new RepresentationRightUtil(representationRight, billingRefNums);
    }
    for(mandateType) {
        return new ReferenceNumberUtil(mandateType, this.billingRefNums, this.existingRefNums(mandateType), { hasLegal: this.hasLegalMandate });
    }
    get hasLegalMandate() {
        return !!this.legalMandate;
    }
    existingRefNums(mandateType) {
        var _a;
        return !!this.hasLegalMandate
            ? this.legalMandate.referenceNumbers
            : ((_a = this.representationRight.mandates.find((mandate) => mandate.type === mandateType)) === null || _a === void 0 ? void 0 : _a.referenceNumbers) || [];
    }
    get canModifyAnyReferenceNumbers() {
        return (this.hasLegalMandate ||
            this.representationRight.mandates
                .filter((mandate) => mandate.type !== types_1.MandateType.LEGAL)
                .map((mandate) => new ReferenceNumberUtil(mandate.type, this.billingRefNums, this.existingRefNums(mandate.type), { hasLegal: this.hasLegalMandate }))
                .some((refNumUtil) => refNumUtil.canModifyReferenceNumbers));
    }
}
__decorate([
    mobx_1.observable
], RepresentationRightUtil.prototype, "legalMandate", void 0);
__decorate([
    mobx_1.observable
], RepresentationRightUtil.prototype, "representationRight", void 0);
__decorate([
    mobx_1.computed
], RepresentationRightUtil.prototype, "hasLegalMandate", null);
__decorate([
    mobx_1.computed
], RepresentationRightUtil.prototype, "canModifyAnyReferenceNumbers", null);
exports["default"] = RepresentationRightUtil;
const copyOf = (obj) => JSON.parse(JSON.stringify(obj));
class ReferenceNumberUtil {
    constructor(mandateType, billingRefNums, existingRefNums, utilProps) {
        Object.defineProperty(this, "mandateType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "billingRefNums", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "existingRefNums", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasLegal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.mandateType = mandateType;
        this.billingRefNums = billingRefNums;
        this.existingRefNums = existingRefNums;
        this.hasLegal = utilProps.hasLegal || false;
    }
    getBillingReferenceNumbers() {
        if (this.mandateTypeIsOneOf(types_1.MandateType.BILLING, types_1.MandateType.SERVICE_USAGE_DISTINCTION)) {
            return this.hasLegal || this.hasAllAccounts ? copyOf(this.sourceBILLReferenceNumbers) : copyOf(this.sourceBILLDelegatableReferenceNumbers);
        }
        return this.hasLegal || this.hasAllAccounts ? copyOf(this.sourceNonBILLReferenceNumbers) : copyOf(this.sourceNonBILLDelegatableReferenceNumbers);
    }
    getDisplayableReferenceNumbers() {
        const billingRefNums = this.getBillingReferenceNumbers();
        return billingRefNums.map((billingRefNum) => {
            const existing = this.findExistingByAccountIdIncludingAll(billingRefNum.refNumberId);
            return {
                referenceNumber: billingRefNum.refNumber,
                title: billingRefNum.title,
                accountId: billingRefNum.refNumberId,
                enabled: true,
                enabledEditable: true,
                delegatable: existing === null || existing === void 0 ? void 0 : existing.delegatable,
                delegatableEditable: this.hasLegal
            };
        });
    }
    getReferenceNumbers(accountId) {
        if (this.isSourceBILLReferenceNumber(accountId)) {
            const nonBillAccountIds = this.getSourceNonBILLReferenceNumbers(accountId).map((refNum) => refNum.refNumberId);
            return copyOf(nonBillAccountIds.map((accountId) => this.findExistingByAccountIds(accountId)).filter((refNum) => !!refNum));
        }
        return copyOf([this.findExistingByAccountIds(accountId)].filter((refNum) => !!refNum));
    }
    exists(accountId) {
        return !!this.findExistingByAccountIdIncludingAll(accountId);
    }
    isDelegatable(accountId) {
        var _a;
        return !!((_a = this.findExistingByAccountIdIncludingAll(accountId)) === null || _a === void 0 ? void 0 : _a.delegatable);
    }
    labelFor(accountId) {
        return this.findBillingByAccountId(accountId).refNumber;
    }
    get canModifyReferenceNumbers() {
        return this.hasLegal || this.existingRefNums.some((referenceNumber) => referenceNumber.delegatable);
    }
    get hasAllAccounts() {
        return this.existingRefNums.length > 0 && this.existingRefNums.every((refNum) => getAccountId(refNum) === -1);
    }
    get allAccountsDelegatable() {
        var _a;
        return this.existingRefNums.length > 0 && !!((_a = this.existingRefNums.find((refNum) => getAccountId(refNum) === -1)) === null || _a === void 0 ? void 0 : _a.delegatable);
    }
    get allAccountsReferenceNumber() {
        return this.hasAllAccounts ? { ...this.existingRefNums.find((refNum) => getAccountId(refNum) === -1) } : null;
    }
    newAllAccountsReferenceNumber() {
        return this.generateNewReferenceNumber(-1);
    }
    get allAccountsDelegatabilityEditable() {
        return this.hasLegal;
    }
    get sourceBILLReferenceNumbers() {
        const hasChildren = (refNum) => this.billingRefNums.some((potentialChild) => potentialChild.masterRefNum === refNum.refNumber);
        return this.billingRefNums.filter((refNum) => refNum.source === 'BILL' && hasChildren(refNum));
    }
    get sourceBILLDelegatableReferenceNumbers() {
        const childrenFilter = (billRefNum) => {
            const nonBILLReferenceNumbers = this.getSourceNonBILLReferenceNumbers(billRefNum.refNumberId);
            return nonBILLReferenceNumbers.length > 0 && nonBILLReferenceNumbers.every((nonBillRefNum) => this.isDelegatable(nonBillRefNum.refNumberId));
        };
        return this.sourceBILLReferenceNumbers.filter(childrenFilter);
    }
    get sourceNonBILLReferenceNumbers() {
        return this.billingRefNums.filter((billingRefNum) => !['BILL', 'BALANCEAPI'].includes(billingRefNum.source));
    }
    get sourceNonBILLDelegatableReferenceNumbers() {
        return this.billingRefNums.filter((billingRefNum) => this.exists(billingRefNum.refNumberId) && this.isDelegatable(billingRefNum.refNumberId));
    }
    isSourceBILLReferenceNumber(accountId) {
        var _a;
        return ((_a = this.findBillingByAccountId(accountId)) === null || _a === void 0 ? void 0 : _a.source) === 'BILL';
    }
    getSourceNonBILLReferenceNumbers(accountId) {
        const label = this.labelFor(accountId);
        return this.sourceNonBILLReferenceNumbers.filter((billingRefNum) => billingRefNum.masterRefNum === label);
    }
    mandateTypeIsOneOf(...mandateTypes) {
        return mandateTypes.includes(this.mandateType);
    }
    findBillingByAccountId(accountId) {
        return this.billingRefNums.find((refNum) => refNum.refNumberId === accountId);
    }
    findExistingByAccountIdIncludingAll(accountId) {
        return this.findExistingByAccountIds(accountId, -1);
    }
    findExistingByAccountIds(...accountIds) {
        if (this.hasAllAccounts) {
            const singleAccountIds = accountIds.filter((accountId) => accountId !== -1);
            const allAccountIds = accountIds.filter((accountId) => accountId === -1);
            if (accountIds.length > 2 || singleAccountIds.length > 1) {
                throw new Error('Invalid input, cannot generate reference number');
            }
            if (singleAccountIds.length === 0 && allAccountIds.length !== 0) {
                return this.allAccountsReferenceNumber;
            }
            return this.generateNewReferenceNumber(accountIds.find((accountId) => accountId !== -1));
        }
        return this.existingRefNums.find((refNum) => accountIds.includes(getAccountId(refNum)));
    }
    generateNewReferenceNumber(accountId) {
        if (!accountId) {
            return undefined;
        }
        const newRefNum = {
            emtAccountId: null,
            elionAccountId: null,
            source: 'STANDARD',
            validUntil: (0, date_fns_1.endOfDay)((0, date_fns_1.addYears)(new Date(), 3)),
            representationStipulation: '',
            delegatable: this.hasLegal,
            diilAccountId: null,
            validFrom: new Date(),
            brand: 'TELIA',
            note: '',
            id: null
        };
        if (accountId === -1) {
            newRefNum.emtAccountId = -1;
            newRefNum.elionAccountId = -1;
            return newRefNum;
        }
        const billRefNum = this.billingRefNums.find((billRefNum) => billRefNum.refNumberId === accountId);
        newRefNum.elionAccountId = billRefNum.source === 'ARGOS' ? accountId : null;
        newRefNum.emtAccountId = billRefNum.source === 'TBCIS' ? accountId : null;
        return newRefNum;
    }
}
__decorate([
    mobx_1.observable
], ReferenceNumberUtil.prototype, "existingRefNums", void 0);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "canModifyReferenceNumbers", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "hasAllAccounts", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "allAccountsDelegatable", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "allAccountsReferenceNumber", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "allAccountsDelegatabilityEditable", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "sourceBILLReferenceNumbers", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "sourceBILLDelegatableReferenceNumbers", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "sourceNonBILLReferenceNumbers", null);
__decorate([
    mobx_1.computed
], ReferenceNumberUtil.prototype, "sourceNonBILLDelegatableReferenceNumbers", null);
exports.ReferenceNumberUtil = ReferenceNumberUtil;


/***/ }),

/***/ 8483:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const Footer = (props) => {
    const { frontLibrary: { Grid, GridColumn, Button }, componentTranslateStore: { translate } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    return (react_1.default.createElement(Grid, { align: ['middle-xs', 'between-xs'], reverse: ['xs'] },
        react_1.default.createElement(GridColumn, { width: ['xs'] },
            react_1.default.createElement(Button, { id: "reference-numbers-modal-save", type: !!props.employee ? 'employee' : undefined, text: translate('referenceNumbersModal.footer.confirm'), onClick: props.onSave, iconLeft: "#save" })),
        react_1.default.createElement(GridColumn, { width: ['xs'] },
            react_1.default.createElement(Button, { id: 'reference-numbers-modal-save-cancel', text: translate('referenceNumbersModal.footer.cancel'), link: true, iconLeft: "#close", type: !!props.employee ? 'employee' : undefined, onClick: props.onClose }))));
};
exports["default"] = Footer;


/***/ }),

/***/ 9461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReferenceNumbersModalContext = void 0;
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const ReferenceNumbersModal_1 = __webpack_require__(1054);
const types_1 = __webpack_require__(2742);
const Search_1 = __importDefault(__webpack_require__(7157));
const Table_1 = __importDefault(__webpack_require__(6250));
const ViewSelector_1 = __importDefault(__webpack_require__(9711));
const ReferenceNumbersModalContent = (props) => {
    var _a, _b;
    const { frontLibrary: { Text } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const viewBasedOnAllAccounts = () => {
        var _a;
        if ((_a = props.referenceNumbers.find((refNum) => refNum.accountId === -1)) === null || _a === void 0 ? void 0 : _a.enabled) {
            return types_1.ReferenceNumbersView.ALL;
        }
        if (props.referenceNumbers.every((refNum) => !refNum.enabled)) {
            return types_1.ReferenceNumbersView.ALL;
        }
        return types_1.ReferenceNumbersView.SINGLE;
    };
    const views = react_1.default.useContext(ReferenceNumbersModal_1.ReferenceNumbersModalViewContext);
    const defaultView = props.canSwitchViews ? views.get(props.mandateType) || viewBasedOnAllAccounts() : types_1.ReferenceNumbersView.SINGLE;
    const [view, setView] = react_1.default.useState(defaultView);
    const [filter, setFilter] = react_1.default.useState('');
    const changeView = (view) => {
        setView(view);
        props.onViewChange(view);
    };
    return (react_1.default.createElement(exports.ReferenceNumbersModalContext.Provider, { value: {
            currentView: view,
            currentFilter: filter,
            referenceNumbers: props.referenceNumbers,
            employee: props.employee
        } },
        react_1.default.createElement(Text, null,
            props.canSwitchViews && react_1.default.createElement(ViewSelector_1.default, { defaultValue: view, onViewChange: changeView, width: (_a = props.widths) === null || _a === void 0 ? void 0 : _a.viewSelector }),
            react_1.default.createElement(Search_1.default, { onChange: setFilter, width: (_b = props.widths) === null || _b === void 0 ? void 0 : _b.search }),
            react_1.default.createElement(Table_1.default, { onChange: props.onChange }))));
};
exports["default"] = ReferenceNumbersModalContent;
exports.ReferenceNumbersModalContext = react_1.default.createContext(null);


/***/ }),

/***/ 7157:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const types_1 = __webpack_require__(2742);
const ReferenceNumbersModalContent_1 = __webpack_require__(9461);
const Search = (props) => {
    const { currentView } = react_1.default.useContext(ReferenceNumbersModalContent_1.ReferenceNumbersModalContext);
    const { frontLibrary: { Grid, GridColumn, Search: SearchComponent }, componentTranslateStore: { translate } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    if (currentView !== types_1.ReferenceNumbersView.SINGLE) {
        return null;
    }
    return (react_1.default.createElement(Grid, null,
        react_1.default.createElement(GridColumn, { width: props.width || ['xs', 'sm-8', 'md-6'] },
            react_1.default.createElement(SearchComponent, { id: "ref-num-search", label: translate('referenceNumbersModal.search.placeholder'), placeholder: translate('referenceNumbersModal.search.placeholder'), onChange: (value) => props.onChange(value), onSubmit: (event) => {
                    event.preventDefault();
                } }))));
};
exports["default"] = Search;


/***/ }),

/***/ 9711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const types_1 = __webpack_require__(2742);
const ReferenceNumbersModalContent_1 = __webpack_require__(9461);
const ViewSelector = (props) => {
    const { frontLibrary: { Grid, GridColumn, ChoiceGroup }, componentTranslateStore: { translate } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const { employee } = react_1.default.useContext(ReferenceNumbersModalContent_1.ReferenceNumbersModalContext);
    const allRefNumsOption = {
        id: 'all-reference-numbers',
        labelText: translate('referenceNumbersModal.view.all'),
        value: types_1.ReferenceNumbersView.ALL,
        employee,
        employeeBackground: false
    };
    const singleRefNumsOption = {
        id: 'single-reference-numbers',
        labelText: translate('referenceNumbersModal.view.single'),
        value: types_1.ReferenceNumbersView.SINGLE,
        employee,
        employeeBackground: false
    };
    return (react_1.default.createElement(Grid, null,
        react_1.default.createElement(GridColumn, { width: props.width || ['xs', 'sm-8', 'md-6'] },
            react_1.default.createElement(ChoiceGroup, { id: "ref-numbers-choice-group", type: "radio", label: translate('referenceNumbersModal.view.title'), onChange: (value) => props.onViewChange(value), options: [allRefNumsOption, singleRefNumsOption], defaultValue: props.defaultValue, labelClass: "text-normal" }))));
};
exports["default"] = ViewSelector;


/***/ }),

/***/ 4844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const types_1 = __webpack_require__(2742);
const ReferenceNumbersModalContent_1 = __webpack_require__(9461);
const MAX_REF_NUMS_WITHOUT_TOGGLES = 10;
const Heading = (props) => {
    const { currentView, referenceNumbers } = react_1.default.useContext(ReferenceNumbersModalContent_1.ReferenceNumbersModalContext);
    const { frontLibrary: { Toggle } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const globalTogglesVisible = currentView === types_1.ReferenceNumbersView.SINGLE && referenceNumbers.length > MAX_REF_NUMS_WITHOUT_TOGGLES;
    return globalTogglesVisible ? (react_1.default.createElement(Toggle, { id: props.id, label: props.label, onChange: props.onToggle, checked: props.toggleEnabled, disabled: !!props.toggleDisabled },
        react_1.default.createElement("span", { className: "text-bold" }, props.label))) : (react_1.default.createElement("span", { className: "text-bold" }, props.label));
};
exports["default"] = Heading;


/***/ }),

/***/ 4697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const Row = (props) => {
    const { frontLibrary: { TableRow, TableCell, Toggle, Grid, GridColumn, Text }, componentTranslateStore: { translate } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const [wasDelegatable] = react_1.default.useState(props.referenceNumber.delegatable);
    return (react_1.default.createElement(TableRow, { key: props.key },
        react_1.default.createElement(TableCell, null,
            react_1.default.createElement(Grid, { verticalGutter: "none", horizontalGutter: "small", noWrap: true, align: ['start-xs'] },
                react_1.default.createElement(GridColumn, { width: ['max'] },
                    react_1.default.createElement(Text, null,
                        props.referenceNumber.accountId !== -1 && react_1.default.createElement("p", null, props.referenceNumber.title || '-'),
                        react_1.default.createElement("p", null, props.referenceNumber.referenceNumber))))),
        react_1.default.createElement(TableCell, { className: "text-left" },
            react_1.default.createElement(Toggle, { id: `enabled-${props.referenceNumber.referenceNumber}`, label: translate('referenceNumbersModal.table.row.no'), onLabel: translate('referenceNumbersModal.table.row.yes'), disabled: !props.referenceNumber.enabledEditable, checked: !!props.referenceNumber.enabled, onChange: (value) => {
                    props.referenceNumber.enabled = value;
                    if (!value) {
                        props.referenceNumber.delegatable = false;
                    }
                    if (!props.referenceNumber.delegatableEditable && wasDelegatable) {
                        props.referenceNumber.delegatable = value;
                    }
                    props.onChange(props.referenceNumber);
                } })),
        react_1.default.createElement(TableCell, { className: "text-left" },
            react_1.default.createElement(Toggle, { id: `delegatable-${props.referenceNumber.referenceNumber}`, label: translate('referenceNumbersModal.table.row.no'), onLabel: translate('referenceNumbersModal.table.row.yes'), disabled: !props.referenceNumber.enabled || !props.referenceNumber.delegatableEditable, checked: props.referenceNumber.delegatable, onChange: (value) => {
                    props.referenceNumber.delegatable = value;
                    props.onChange(props.referenceNumber);
                } }))));
};
exports["default"] = Row;


/***/ }),

/***/ 6250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const types_1 = __webpack_require__(2742);
const ReferenceNumbersModalContent_1 = __webpack_require__(9461);
const Heading_1 = __importDefault(__webpack_require__(4844));
const Row_1 = __importDefault(__webpack_require__(4697));
const Table = (props) => {
    const { frontLibrary: { Table, TableRow, TableCell, Notice }, componentTranslateStore: { translate } } = react_1.default.useContext(stores_1.ComponentRootStoreContext);
    const { referenceNumbers, currentView } = react_1.default.useContext(ReferenceNumbersModalContent_1.ReferenceNumbersModalContext);
    const [allEnabled, setAllEnabled] = react_1.default.useState(referenceNumbers.filter((refNum) => refNum.accountId !== -1).every((refNum) => refNum.enabled));
    const [allDelegatable, setAllDelegatable] = react_1.default.useState(referenceNumbers.filter((refNum) => refNum.accountId !== -1).every((refNum) => refNum.delegatable));
    const toggleAllEnabled = (value) => {
        setAllEnabled(value);
        if (!value) {
            toggleAllDelegatable(value);
        }
        referenceNumbers.forEach((refNum) => {
            refNum.enabled = value;
            props.onChange(refNum);
        });
    };
    const toggleAllDelegatable = (value) => {
        setAllDelegatable(value);
        referenceNumbers.forEach((refNum) => {
            refNum.delegatable = value;
            props.onChange(refNum);
        });
    };
    const Rows = getRows({ onChange: props.onChange });
    const hasNoRefNums = referenceNumbers.length === 0 || (referenceNumbers.length === 1 && referenceNumbers[0].accountId === -1 && currentView === types_1.ReferenceNumbersView.SINGLE);
    if (hasNoRefNums) {
        return (react_1.default.createElement(Notice, { type: "info", size: "small" }, translate('referenceNumbersModal.table.notice.noRefNums')));
    }
    return (react_1.default.createElement(Table, { className: "text__margin-double", responsive: "rows", break: "sm" },
        react_1.default.createElement("thead", null,
            react_1.default.createElement(TableRow, null,
                react_1.default.createElement(TableCell, { type: "th", className: "text-bold", scope: "col" }, translate('referenceNumbersModal.table.header.title')),
                react_1.default.createElement(TableCell, { type: "th", className: "text-bold text-left", scope: "col" },
                    react_1.default.createElement(Heading_1.default, { id: "manage-enabled", label: translate('referenceNumbersModal.table.header.allValid'), toggleEnabled: allEnabled, onToggle: toggleAllEnabled })),
                react_1.default.createElement(TableCell, { type: "th", className: "text-bold text-left", scope: "col" },
                    react_1.default.createElement(Heading_1.default, { id: "manage-delegatable", label: translate('referenceNumbersModal.table.header.allDelegatable'), toggleEnabled: allDelegatable, onToggle: toggleAllDelegatable, toggleDisabled: !allEnabled || !referenceNumbers.filter((refNum) => refNum.accountId !== -1).every((refNum) => refNum.delegatableEditable) })),
                react_1.default.createElement(TableCell, { type: "th", scope: "col" }))),
        react_1.default.createElement("tbody", null, Rows)));
};
const getRows = (props) => {
    const { currentView, referenceNumbers, currentFilter } = react_1.default.useContext(ReferenceNumbersModalContent_1.ReferenceNumbersModalContext);
    const result = [];
    referenceNumbers.forEach((refNum) => {
        var _a, _b;
        const row = (0, Row_1.default)({
            referenceNumber: refNum,
            onChange: props.onChange,
            key: `ref-num-row-${refNum.referenceNumber}`
        });
        if (refNum.accountId === -1 || !currentFilter || ((_a = refNum.referenceNumber) === null || _a === void 0 ? void 0 : _a.includes(currentFilter)) || ((_b = refNum.title) === null || _b === void 0 ? void 0 : _b.includes(currentFilter))) {
            result.push(row);
        }
    });
    return currentView === types_1.ReferenceNumbersView.ALL ? result.slice(0, 1) : result.slice(1);
};
exports["default"] = (0, mobx_react_1.observer)(Table);


/***/ }),

/***/ 2742:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContactInfoType = exports.ContactInfoSource = exports.MandateType = exports.ReferenceNumbersView = void 0;
var ReferenceNumbersView;
(function (ReferenceNumbersView) {
    ReferenceNumbersView["ALL"] = "ALL";
    ReferenceNumbersView["SINGLE"] = "SINGLE";
})(ReferenceNumbersView = exports.ReferenceNumbersView || (exports.ReferenceNumbersView = {}));
var MandateType;
(function (MandateType) {
    MandateType["LEGAL"] = "LEGAL";
    MandateType["SERVICE"] = "SERVICE";
    MandateType["GOODS"] = "GOODS";
    MandateType["SERVICE_USAGE_DISTINCTION"] = "SERVICE_USAGE_DISTINCTION";
    MandateType["LEASING"] = "LEASING";
    MandateType["BILLING"] = "BILLING";
})(MandateType = exports.MandateType || (exports.MandateType = {}));
var ContactInfoSource;
(function (ContactInfoSource) {
    ContactInfoSource["PERSON"] = "PERSON";
    ContactInfoSource["CUSTOMER_PERSON"] = "CUSTOMER_PERSON";
})(ContactInfoSource = exports.ContactInfoSource || (exports.ContactInfoSource = {}));
var ContactInfoType;
(function (ContactInfoType) {
    ContactInfoType["EMAIL"] = "EMAIL";
    ContactInfoType["PHONE"] = "PHONE";
})(ContactInfoType = exports.ContactInfoType || (exports.ContactInfoType = {}));


/***/ }),

/***/ 6156:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const StoresUtil_1 = __webpack_require__(5855);
let CustomerContract = class CustomerContract extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.componentTranslateStore;
        const contractStore = this.componentContractStore;
        const { Heading, Separator, Button, ChoiceGroup, Grid, GridColumn, Text, AnalyticsTrigger } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, null,
                React.createElement(Separator, { spacing: 'medium', color: 'invisible' }),
                React.createElement(Heading, { element: "h2", className: "h4 text-bold" }, translate('registration.contract.heading')),
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: translate('registration.contract.informative.text')
                    } }),
                React.createElement(AnalyticsTrigger, { trigger: { id: 'Link - contract download', callback: 'onClick' } },
                    React.createElement(Button, { text: translate('registration.contract.link'), link: true, iconLeft: "#file-pdf", isLoading: contractStore.isLoading || this.props.customerCreationInProgress, disabled: contractStore.isLoading || contractStore.isError || this.props.shouldDisableButtons || !!this.componentSsoStore.dealer, onClick: () => contractStore.getContractDocument() })),
                React.createElement(Separator, { spacing: 'xsmall', color: 'invisible' }),
                React.createElement(ChoiceGroup, { id: "customer-contract-general-conditions", label: "\u00DCldtingimused", type: "check", purpose: "agreement", hideLabel: "no-break", options: [
                        {
                            id: 'customerContractAcceptContactConditions',
                            labelText: contractStore.contractCheckboxValue.toString(),
                            value: contractStore.contractCheckboxValue.toString(),
                            disabled: contractStore.isLoading || contractStore.isError || this.props.shouldDisableButtons,
                            children: this.getAgreementOptionChildren()
                        }
                    ], value: contractStore.contractCheckboxValue, onChange: contractStore.contractCheckboxValue.length === 0 ? () => this.setChoiceGroupCheckedValues() : () => this.setChoiceGroupUnCheckedValues() })),
            React.createElement(Separator, { spacing: 'medium' }),
            React.createElement(Grid, { align: ['center-xs', 'middle-xs'] },
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(AnalyticsTrigger, { trigger: { id: 'Button - Confirm registration', callback: 'onClick' } },
                        React.createElement(Button, { text: translate('registration.confirm'), type: "expressive", iconRight: "#arrow-right", disabled: !contractStore.hasAgreedToTerms || contractStore.isLoading || !!this.componentSsoStore.dealer, onClick: async () => await contractStore.signContractAndRedirect(this.urlDataStore.redirectUrl || '') }))))));
    }
    setChoiceGroupCheckedValues() {
        this.componentContractStore.setAgreementChecked();
        this.componentContractStore.setContractCheckboxChecked();
    }
    setChoiceGroupUnCheckedValues() {
        this.componentContractStore.setAgreementUnChecked();
        this.componentContractStore.setContractCheckboxUnChecked();
    }
    getAgreementOptionChildren() {
        const { translate } = this.componentTranslateStore;
        const contractStore = this.componentContractStore;
        return (React.createElement("span", { className: "text-bold", dangerouslySetInnerHTML: {
                __html: translate('registration.contract.agreement', {
                    generalTermsLink: contractStore.generalTermsLink
                })
            } }));
    }
};
CustomerContract = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], CustomerContract);
exports["default"] = CustomerContract;


/***/ }),

/***/ 6103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ComponentContractStore_1 = __webpack_require__(1467);
const StoresUtil_1 = __webpack_require__(5855);
const B2cRegistration_1 = __webpack_require__(2984);
const PaperSigningModal_1 = __importDefault(__webpack_require__(7144));
let DealerSigningButtons = class DealerSigningButtons extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "currentView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: B2cRegistration_1.CurrentView.CUSTOMER_INFO
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "renderContentBlock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { Grid, GridColumn, Heading, Button, Separator, Text, AnalyticsTrigger } = this.frontLibrary;
                const { translate } = this.componentTranslateStore;
                return (react_1.default.createElement(Text, { className: "text-center" },
                    react_1.default.createElement(Heading, { element: "h4", className: "h3" }, translate('registration.b2c.dealer.title')),
                    react_1.default.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                    react_1.default.createElement(Grid, { align: ['center-xs'] },
                        react_1.default.createElement(GridColumn, { width: ['xs'] },
                            react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - sign on paper', callback: 'onClick' } },
                                react_1.default.createElement(Button, { text: translate('registration.b2c.dealer.signing.paper'), type: 'employee', onClick: () => this.updateView(B2cRegistration_1.CurrentView.DEALER_PAPER_CONTRACT_MODAL), disabled: !this.dealerButtonsEnabled }))),
                        react_1.default.createElement(GridColumn, { width: ['xs'] },
                            react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - sign on screen', callback: 'onClick' } },
                                react_1.default.createElement(Button, { text: translate('registration.b2c.dealer.signing.onscreen'), type: 'employee', onClick: () => this.updateView(B2cRegistration_1.CurrentView.DEALER_ON_SCREEN_SIGNING_VIEW), disabled: !this.dealerButtonsEnabled }))),
                        react_1.default.createElement(GridColumn, { width: ['xs'] },
                            react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - sign on phone', callback: 'onClick' } },
                                react_1.default.createElement(Button, { text: translate('registration.dealer.signing.phone'), type: 'employee', onClick: this.signViaPhone, disabled: this.componentSsoStore.isBusiness || !this.dealerButtonsEnabled }))),
                        this.componentSsoStore.isUnderage() && (react_1.default.createElement(GridColumn, { width: ['xs'] },
                            react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - enter with underage', callback: 'onClick' } },
                                react_1.default.createElement(Button, { text: translate('registration.dealer.enter.with.underage'), type: 'employee', onClick: this.signViaPhone, disabled: this.dealerButtonsSelectUnderAgeDisabled }))))),
                    this.componentSsoStore.customerId && (react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - show customer', callback: 'onClick' } },
                        react_1.default.createElement(Button, { text: translate('registration.dealer.showCustomer'), link: true, type: 'employee', iconRight: "#arrow-right", onClick: () => this.componentContractStore.redirectToGivenUrl('') }))),
                    this.currentView === B2cRegistration_1.CurrentView.DEALER_PAPER_CONTRACT_MODAL && (react_1.default.createElement(PaperSigningModal_1.default, { onClose: () => this.updateView(B2cRegistration_1.CurrentView.CUSTOMER_INFO), dealerRedirectUrl: this.props.dealerRedirectUrl }))));
            }
        });
        Object.defineProperty(this, "signViaPhone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.componentContractStore.setContractType(ComponentContractStore_1.ContractType.PAPER);
                await this.componentContractStore.ensurePreparedContractExists();
                await this.componentContractStore.refreshContractData();
                await this.componentContractStore.redirectToGivenUrl(this.urlDataStore.redirectUrl || '');
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { isCiConfirmationChecked, contactInfoUpdated } = this.componentCustomerContactInfoStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            isCiConfirmationChecked && !contactInfoUpdated && this.renderSpinner(),
            this.renderContentBlock()));
    }
    get storesAreLoading() {
        return this.componentContractStore.isLoading || this.componentCustomerContactInfoStore.isLoading();
    }
    updateView(view) {
        this.currentView = view;
        this.props.updateView(this.currentView);
    }
    get dealerButtonsEnabled() {
        if (this.currentView !== B2cRegistration_1.CurrentView.CUSTOMER_INFO) {
            return false;
        }
        const { isCiConfirmationChecked, contactInfoUpdated } = this.componentCustomerContactInfoStore;
        const { hasAgreedToTerms } = this.componentContractStore;
        return !this.storesAreLoading && contactInfoUpdated && isCiConfirmationChecked && hasAgreedToTerms;
    }
    get dealerButtonsSelectUnderAgeDisabled() {
        return this.componentContractStore.isLoading || !this.componentSsoStore.customerId || this.componentCustomerContactInfoStore.isLoading();
    }
    renderSpinner() {
        const { Overlay } = this.frontLibrary;
        return react_1.default.createElement(Overlay, { className: "overlay--fixed", spinner: true });
    }
};
__decorate([
    mobx_1.observable
], DealerSigningButtons.prototype, "currentView", void 0);
__decorate([
    mobx_1.computed
], DealerSigningButtons.prototype, "storesAreLoading", null);
__decorate([
    mobx_1.action
], DealerSigningButtons.prototype, "updateView", null);
__decorate([
    mobx_1.computed
], DealerSigningButtons.prototype, "dealerButtonsEnabled", null);
__decorate([
    mobx_1.computed
], DealerSigningButtons.prototype, "dealerButtonsSelectUnderAgeDisabled", null);
DealerSigningButtons = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], DealerSigningButtons);
exports["default"] = DealerSigningButtons;


/***/ }),

/***/ 795:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ComponentContractStore_1 = __webpack_require__(1467);
const LocationUtils_1 = __importDefault(__webpack_require__(1513));
const StoresUtil_1 = __webpack_require__(5855);
const SignatureComponent_1 = __webpack_require__(9255);
let OnScreenSigningView = class OnScreenSigningView extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "contractDocument", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signatures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "postingSignatures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasEmployeeSignatureChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "employeeSignaturePrefilled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSignerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentEmployeeSignatureStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getCustomerSignaturesBlock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { Heading } = this.frontLibrary;
                const { translate } = this.componentTranslateStore;
                return this.signatures.customerSigners.map((signer, index) => {
                    return (react_1.default.createElement("div", { key: index },
                        react_1.default.createElement(Heading, { element: "h2", className: "h4" },
                            `${signer.firstName} ${signer.lastName}`,
                            " ",
                            translate('registration.b2c.dealer.signing.onscreen.signature')),
                        react_1.default.createElement(SignatureComponent_1.SignatureComponent, { label: [
                                translate('registration.b2c.dealer.signing.onscreen.legalRepresentation'),
                                translate('registration.b2c.dealer.signing.onscreen.signatureHeading')
                            ].join(' '), index: index, onEnd: this.onCustomerEnd, onClear: this.onCustomerClear })));
                });
            }
        });
        Object.defineProperty(this, "onCustomerEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (signature, index) => {
                this.signatures.customerSigners[index].signature = signature;
            }
        });
        Object.defineProperty(this, "onEmployeeEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (signature) => {
                this.hasEmployeeSignatureChanged = true;
                this.signatures.employeeSigner.signature = signature;
            }
        });
        Object.defineProperty(this, "onCustomerClear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index) => {
                this.signatures.customerSigners[index].signature = '';
            }
        });
        Object.defineProperty(this, "onEmployeeClear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.hasEmployeeSignatureChanged = true;
                this.employeeSignaturePrefilled = false;
                this.componentEmployeeSignatureStore.deleteSignature();
                this.signatures.employeeSigner.signature = '';
            }
        });
        Object.defineProperty(this, "sign", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.postingSignatures = true;
                try {
                    await this.componentContractStore.contractAPI.postOnScreenSignatures(this.componentContractStore.preparedContract.contractId, this.signatures);
                    await this.componentContractStore.acceptAllB2bMarketingOffers();
                    await this.updateEmployeeSignatureIfChanged();
                }
                finally {
                    (0, mobx_1.runInAction)(() => {
                        this.postingSignatures = false;
                    });
                }
                LocationUtils_1.default.redirectToUrl(this.props.redirectUrl || this.urlDataStore.redirectUrl || '');
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    async componentDidMount() {
        window.scrollTo({ top: 0 });
        await this.componentEmployeeSignatureStore.initSignature();
        const { dealer } = this.componentSsoStore;
        const { signature } = this.componentEmployeeSignatureStore;
        if (!!signature) {
            this.employeeSignaturePrefilled = true;
        }
        this.signatures = {
            customerSigners: this.getCustomerSigners,
            employeeSigner: {
                employeeUsername: dealer.userName,
                signature
            }
        };
        this.componentContractStore.setContractType(ComponentContractStore_1.ContractType.ON_SCREEN);
        await this.componentContractStore.ensurePreparedContractExists();
        await this.componentContractStore.refreshContractData();
        const doc = await this.componentContractStore.contractAPI.getContractDocument(this.componentContractStore.preparedContract.contractId);
        this.contractDocument = doc.data;
    }
    render() {
        const { Text, Heading, Separator, Grid, GridColumn, Button, Spinner, AnalyticsTrigger } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        if (!this.signatures) {
            return react_1.default.createElement(Spinner, null);
        }
        return (react_1.default.createElement(Text, null,
            react_1.default.createElement(Heading, { element: "h1", className: "h2" }, translate('registration.b2c.dealer.signing.onscreen.title')),
            react_1.default.createElement(Heading, { element: "h2", className: "h4" }, translate('registration.b2c.dealer.signing.onscreen.documentHeading')),
            !this.componentContractStore.isLoading && this.contractDocument && (react_1.default.createElement("iframe", { src: window.URL.createObjectURL(this.contractDocument), width: "100%", height: "1000" })),
            this.componentContractStore.isLoading && react_1.default.createElement(Spinner, null),
            this.getCustomerSignaturesBlock(),
            react_1.default.createElement(Heading, { element: "h2", className: "h4" },
                translate('registration.b2c.dealer.signing.onscreen.dealer'),
                " ",
                translate('registration.b2c.dealer.signing.onscreen.signature')),
            react_1.default.createElement(SignatureComponent_1.SignatureComponent, { label: translate('registration.b2c.dealer.signing.onscreen.signatureHeading'), employee: true, onEnd: this.onEmployeeEnd, onClear: this.onEmployeeClear, signature: this.signatures.employeeSigner.signature, isDisabled: this.employeeSignaturePrefilled }),
            react_1.default.createElement(Separator, { color: "invisible", spacing: "medium" }),
            react_1.default.createElement(Grid, { align: ['middle-xs', 'center-xs'] },
                react_1.default.createElement(GridColumn, { width: ['xs'] },
                    react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - Back from on screen signing', callback: 'onClick' } },
                        react_1.default.createElement(Button, { text: translate('registration.b2c.dealer.signing.onscreen.back'), link: true, type: "employee", iconLeft: "#arrow-left", onClick: this.props.onBack }))),
                react_1.default.createElement(GridColumn, { width: ['xs'] },
                    react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - sign on screen', callback: 'onClick' } },
                        react_1.default.createElement(Button, { text: translate('registration.b2c.dealer.signing.onscreen.sign'), type: "employee", disabled: this.signingDisabled, onClick: this.sign }))))));
    }
    get signingDisabled() {
        return (this.postingSignatures ||
            (this.signatures.customerSigners[0] && (!this.signatures.customerSigners[0].signature || !this.signatures.employeeSigner.signature)));
    }
    get getCustomerSigners() {
        return this.componentSignerStore.getSelectedSigners().map((signer) => {
            return {
                firstName: signer.firstName,
                lastName: signer.lastName,
                personalCode: signer.personalCode,
                personalCodeCountryCode: signer.personalCodeCountryCode,
                basisOfRepresentationCode: 'LEGAL',
                signature: ''
            };
        });
    }
    async updateEmployeeSignatureIfChanged() {
        if (this.hasEmployeeSignatureChanged) {
            return this.componentEmployeeSignatureStore.saveSignature(this.signatures.employeeSigner.signature);
        }
        return null;
    }
};
__decorate([
    mobx_1.observable
], OnScreenSigningView.prototype, "contractDocument", void 0);
__decorate([
    mobx_1.observable
], OnScreenSigningView.prototype, "signatures", void 0);
__decorate([
    mobx_1.observable
], OnScreenSigningView.prototype, "postingSignatures", void 0);
__decorate([
    mobx_1.action
], OnScreenSigningView.prototype, "sign", void 0);
__decorate([
    mobx_1.computed
], OnScreenSigningView.prototype, "signingDisabled", null);
OnScreenSigningView = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], OnScreenSigningView);
exports["default"] = OnScreenSigningView;


/***/ }),

/***/ 7144:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const ComponentContractStore_1 = __webpack_require__(1467);
const StoresUtil_1 = __webpack_require__(5855);
let PaperSigningModal = class PaperSigningModal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async componentDidMount() {
        this.componentContractStore.setContractType(ComponentContractStore_1.ContractType.PAPER);
        await this.componentContractStore.ensurePreparedContractExists();
        await this.componentContractStore.refreshContractData();
    }
    render() {
        const { onClose, dealerRedirectUrl } = this.props;
        const { Button, AnalyticsTrigger, Modal, ModalContent, ModalFooter } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        return (react_1.default.createElement(Modal, { size: "8-col", hasContentComponent: true, isOpen: true, onClose: onClose },
            react_1.default.createElement(ModalContent, null,
                react_1.default.createElement(lib_1.Heading, { element: "h1", className: "h2" }, translate('registration.b2c.dealer.modal.title')),
                react_1.default.createElement(lib_1.Separator, { spacing: "xsmall", color: "invisible" }),
                react_1.default.createElement("p", null, translate('registration.b2c.dealer.modal.info1')),
                react_1.default.createElement("p", null, translate('registration.b2c.dealer.modal.info2')),
                react_1.default.createElement(lib_1.Separator, { spacing: "xsmall", color: "invisible" }),
                react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - sign on paper download contract', callback: 'onClick' } },
                    react_1.default.createElement(Button, { text: translate('registration.b2c.dealer.modal.contract'), link: true, isLoading: this.componentContractStore.isLoading, disabled: this.componentContractStore.isLoading, iconLeft: "#file-pdf", onClick: () => this.componentContractStore.getContractDocument() }))),
            react_1.default.createElement(ModalFooter, null,
                react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                        react_1.default.createElement(AnalyticsTrigger, { trigger: { id: 'Button - sign on paper confirm', callback: 'onClick' } },
                            react_1.default.createElement(Button, { type: 'employee', text: translate('registration.b2c.dealer.modal.confirm'), disabled: this.componentContractStore.isLoading, onClick: async () => {
                                    onClose();
                                    await this.componentContractStore.signContractAndRedirect(dealerRedirectUrl || this.urlDataStore.redirectUrl || '');
                                } })))))));
    }
};
PaperSigningModal = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], PaperSigningModal);
exports["default"] = PaperSigningModal;


/***/ }),

/***/ 4137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const ComponentGaDataStore_1 = __webpack_require__(2270);
const customerIdAsKey_1 = __importDefault(__webpack_require__(2468));
const StoresUtil_1 = __webpack_require__(5855);
const B2bRegistration_1 = __importDefault(__webpack_require__(3681));
const RegisterableCompaniesList_1 = __importDefault(__webpack_require__(9742));
const B2cRegistration_1 = __importDefault(__webpack_require__(2984));
let Registration = class Registration extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async componentDidMount() {
        await this.componentContractStore.init();
        await this.componentCustomerContactInfoStore.init();
        if (this.brand === 'TELIA') {
            await this.componentCreditInfoStore.init();
        }
    }
    render() {
        if (this.componentSsoStore.person) {
            if (this.componentSsoStore.isPrivate && !this.componentSsoStore.isRepresentingSelf) {
                return this.renderNoMandatesMessage();
            }
            if (!(this.componentSsoStore.dealer && this.componentSsoStore.isPrivate) && this.componentSsoStore.isUnderage()) {
                return this.renderUnderageMessage();
            }
            if (this.areStoresLoaded()) {
                if (this.componentSsoStore.customer &&
                    this.componentContractStore.hasSignedContract &&
                    !this.componentCreditInfoStore.hasRegistrableEntities &&
                    this.props.onNoRegistrableEntities) {
                    this.props.onNoRegistrableEntities();
                    return null;
                }
                if (((this.componentSsoStore.customer && this.componentContractStore.hasSignedContract) || !this.componentSsoStore.customer) &&
                    !this.componentCreditInfoStore.hasRegistrableEntities) {
                    return this.renderNoRegistrableLegalEntitiesMessage();
                }
                if (this.areStoresInError()) {
                    return this.renderErrorMessage();
                }
                else {
                    return this.renderRegistrationComponent();
                }
            }
        }
        return this.renderSpinner();
    }
    areStoresInError() {
        return this.componentContractStore.isError || this.componentCustomerContactInfoStore.isError;
    }
    areStoresLoaded() {
        return (this.componentContractStore.isLoaded && this.componentSsoStore.isSsoLoaded && (this.brand === 'TELIA' ? this.componentCreditInfoStore.isLoaded : true));
    }
    renderRegistrationComponent() {
        const AnalyticsProvider = this.frontLibrary.AnalyticsProvider;
        const analyticsContext = {
            group: 'registration',
            event: 'AutoEvent',
            page: 'crm-components-registration',
            onPush: ComponentGaDataStore_1.GaDataStore.push
        };
        return (React.createElement(AnalyticsProvider, { ...analyticsContext },
            this.shouldShowCompanyList() && React.createElement(RegisterableCompaniesList_1.default, null),
            this.shouldRenderB2bRegistration() && React.createElement(B2bRegistration_1.default, { currentLanguage: this.props.currentLanguage, redirectUrl: this.props.redirectUrl }),
            this.shouldRenderB2cRegistration() && React.createElement(B2cRegistration_1.default, { currentLanguage: this.props.currentLanguage, redirectUrl: this.props.redirectUrl })));
    }
    shouldRenderB2bRegistration() {
        return !!this.componentCreditInfoStore.entityToRegister || (this.componentSsoStore.isBusiness && !this.componentContractStore.hasSignedContract);
    }
    shouldRenderB2cRegistration() {
        return !this.componentContractStore.hasSignedContract && this.componentSsoStore.isPrivate;
    }
    shouldShowCompanyList() {
        return (((!this.componentSsoStore.customer && this.componentCreditInfoStore.creditInfoLegalEntities.length > 0) ||
            (this.componentSsoStore.customer &&
                this.componentContractStore.hasSignedContract &&
                this.componentCreditInfoStore.creditInfoLegalEntities.length > 0)) &&
            this.componentCreditInfoStore.entityToRegister === null &&
            this.brand === 'TELIA');
    }
    renderErrorMessage() {
        const { Notice } = this.frontLibrary;
        return React.createElement(Notice, { type: "error" }, this.componentTranslateStore.translate('technical.error'));
    }
    renderNoMandatesMessage() {
        const { Notice } = this.frontLibrary;
        return React.createElement(Notice, null, this.componentTranslateStore.translate('registration.noMandates.warning'));
    }
    renderNoRegistrableLegalEntitiesMessage() {
        const { Notice } = this.frontLibrary;
        return React.createElement(Notice, null, this.componentTranslateStore.translate('registration.noRegistrableLegalEntities.warning'));
    }
    renderSpinner() {
        const { Spinner } = this.frontLibrary;
        return React.createElement(Spinner, null);
    }
    renderUnderageMessage() {
        const { Notice } = this.frontLibrary;
        return React.createElement(Notice, null, this.componentTranslateStore.translate('registration.underage.warning'));
    }
};
Registration = __decorate([
    customerIdAsKey_1.default,
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], Registration);
exports["default"] = Registration;


/***/ }),

/***/ 9255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SignatureComponent = void 0;
const lib_1 = __webpack_require__(3571);
const react_1 = __importDefault(__webpack_require__(8156));
const SignatureComponent = (signatureProps) => {
    const { label, employee, signature, isDisabled } = signatureProps;
    const canvasRef = react_1.default.useRef(null);
    function onEnd() {
        if (signatureProps.onEnd && canvasRef.current) {
            signatureProps.onEnd(canvasRef.current.toDataURL('image/svg+xml', {}), signatureProps.index);
        }
    }
    function onClear() {
        canvasRef.current.clear();
        canvasRef.current.on();
        if (signatureProps.onClear) {
            signatureProps.onClear(signatureProps.index);
        }
    }
    return (react_1.default.createElement(lib_1.Signature, { className: isDisabled ? 'signature--disabled' : '', label: label, employee: employee, elementRef: (ref) => {
            if (ref && signature) {
                ref.fromDataURL(signature, {});
                isDisabled && ref.off();
            }
            canvasRef.current = ref;
        }, onEnd: onEnd, clearButton: { text: 'Tühjenda väli', iconLeft: undefined }, onClear: onClear }));
};
exports.SignatureComponent = SignatureComponent;


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const ComponentContractStore_1 = __webpack_require__(1467);
const ContactInfoUtil_1 = __webpack_require__(1203);
const customerIdAsKey_1 = __importDefault(__webpack_require__(2468));
const StoresUtil_1 = __webpack_require__(5855);
const ContactAddress_1 = __importDefault(__webpack_require__(6624));
let B2bCustomerInfo = class B2bCustomerInfo extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.componentContactAddressStore.isAddressDirty, (data) => {
            if (data) {
                this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
            }
        });
    }
    render() {
        const { Separator, Text } = this.frontLibrary;
        return (React.createElement(Text, null,
            this.renderB2bData(),
            React.createElement(Separator, { spacing: "medium" }),
            this.renderRepresentativeData(),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            this.renderConfirmContactInfoCheckBox(),
            React.createElement(Separator, { spacing: "medium" })));
    }
    renderRepresentativeData() {
        const { Grid, GridColumn, Heading, Notice, Separator, TextField, Text } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        const { person } = this.componentSsoStore;
        const { email, phone } = this.componentCustomerContactInfoStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { element: 'h2', className: "h4" }, translate('registration.b2b.representative.title')),
            React.createElement(Notice, { size: "small" }, translate('registration.b2b.representative.notice')),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(TextField, { id: "representative-name", label: translate('registration.b2b.representative.name'), isStatic: true, defaultValue: `${person.firstName} ${person.lastName}` })),
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(TextField, { id: "representative-personal-code", label: translate('registration.b2b.representative.personalCode'), isStatic: true, defaultValue: person.personalCode }))),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['lg-5', 'md-7', 'sm-8', 'xs-12'] },
                    React.createElement(Text, null,
                        React.createElement(TextField, { id: "email", label: translate('registration.b2b.representative.email'), isInvalid: email.isUserInputError, value: email.value, onChange: (value) => {
                                this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
                                email.onChange(value);
                            } }),
                        React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                        React.createElement(Grid, null,
                            React.createElement(GridColumn, { width: ['xs-12'] },
                                React.createElement(TextField, { id: "phoneNumber", label: translate('registration.b2b.representative.phone'), isInvalid: phone.isUserInputError, value: phone.value, onChange: (value) => {
                                        this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
                                        phone.onChange(value);
                                    } }))),
                        React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                        this.renderLanguageSelector())))));
    }
    renderB2bData() {
        const { currentLanguage } = this.props;
        const { Grid, GridColumn, Heading, TextField } = this.frontLibrary;
        const { entityToRegister } = this.componentCreditInfoStore;
        const { translate } = this.componentTranslateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xl'] },
                    React.createElement(Heading, { element: 'h1', className: "h2" }, translate('registration.b2b.company.contactInfo')))),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(TextField, { id: "business-name", label: translate('registration.b2b.company.name'), isStatic: true, defaultValue: entityToRegister && entityToRegister.name ? entityToRegister.name : this.componentSsoStore.customer.displayName })),
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(TextField, { id: "registry-code", label: translate('registration.b2b.company.regCode'), isStatic: true, defaultValue: entityToRegister && entityToRegister.registrationNumber
                            ? entityToRegister.registrationNumber
                            : this.componentSsoStore.customer.registrationNumber }))),
            React.createElement(ContactAddress_1.default, { translations: this.componentTranslateStore.translations, currentLanguage: currentLanguage, countrySelectWidth: ['lg-5', 'md-7', 'sm-8', 'xs-12'], addressWidth: ['md-5', 'sm-5', 'xs-12'], roomWidth: ['md-2', 'sm-3', 'xs-12'] })));
    }
    renderLanguageSelector() {
        const { Selector } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            React.createElement(Selector, { id: "b2b-communication-language", items: (0, ContactInfoUtil_1.getCommunicationLanguageProps)(this.componentCustomerContactInfoStore.contactInfoUpdated, this.componentTranslateStore), label: this.componentTranslateStore.translate('registration.b2c.contactInfo.communicationLanguage'), value: this.componentCustomerContactInfoStore.communicationLanguage.value, onChange: (item) => {
                    this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
                    this.componentCustomerContactInfoStore.onCommunicationLanguageChange(item);
                }, inputType: 'radio' })));
    }
    renderConfirmContactInfoCheckBox() {
        const { ChoiceGroup } = this.frontLibrary;
        return (React.createElement(ChoiceGroup, { id: "contactDataConfirm", label: "Kontaktandmete kinnitamine", type: "check", purpose: "agreement", hideLabel: true, options: [
                {
                    id: 'confirm-contactInfo',
                    labelText: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
                    value: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
                    disabled: !this.componentCustomerContactInfoStore.areMandatoryValuesValid() ||
                        !this.componentContactAddressStore.isAddressValid() ||
                        this.componentCustomerContactInfoStore.isCiConfirmationChecked,
                    children: this.getConfirmContactInfoOptionChildren()
                }
            ], value: this.componentCustomerContactInfoStore.ciCheckBoxValue, onChange: async () => {
                this.componentCustomerContactInfoStore.setCiConfirmationChecked();
                await this.updateB2bInfo();
            } }));
    }
    getConfirmContactInfoOptionChildren() {
        const { translate } = this.componentTranslateStore;
        return React.createElement("span", { className: "text-bold" }, translate('registration.contactInfo.confirmContactInfo'));
    }
    async updateB2bInfo() {
        this.componentCustomerContactInfoStore.setIsLoading();
        if (this.componentCustomerContactInfoStore.shouldUpdateContactInfo()) {
            this.isNewCustomer() ? await this.createB2bCustomer() : await this.updateB2bCustomer();
        }
        this.componentCustomerContactInfoStore.onLoaded();
    }
    isNewCustomer() {
        const { customer, customerId } = this.componentSsoStore;
        const { entityToRegister } = this.componentCreditInfoStore;
        return (!customerId ||
            (entityToRegister &&
                (entityToRegister.registrationNumber !== customer.registrationNumber ||
                    entityToRegister.registrationNumberCountryCode !== customer.registrationNumberCountryCode)));
    }
    async createB2bCustomer() {
        await this.componentCustomerContactInfoStore.createNewB2bCustomer(this.componentContactAddressStore.getAddress());
        if (!this.componentCustomerContactInfoStore.isError) {
            this.componentSsoStore.onLoginWithCallback(async () => {
                await this.componentContractStore.fetchExistingPreparedContract();
                await this.refreshDataAndSetStates();
            });
        }
    }
    async refreshDataAndSetStates() {
        if (!this.componentContractStore.isError) {
            if (this.componentCustomerContactInfoStore.ciCheckBoxCheckedTimes <= 1 || this.componentContactAddressStore.hasAddressChanged()) {
                await this.componentContractStore.refreshContractData();
            }
            this.componentContactAddressStore.setIsAddressDirtyFalse();
            this.componentCustomerContactInfoStore.setContactInfoUpdated();
        }
    }
    async updateB2bCustomer() {
        await this.componentContactAddressStore.saveAddress();
        await this.componentCustomerContactInfoStore.updateContactInfo();
        if (!this.componentCustomerContactInfoStore.isError && this.componentContactAddressStore.status !== 'ERROR') {
            if (!this.componentSsoStore.dealer) {
                this.componentContractStore.setContractType(ComponentContractStore_1.ContractType.CLICK_ACCEPT);
                await this.componentContractStore.ensurePreparedContractExists();
            }
        }
        await this.refreshDataAndSetStates();
    }
};
B2bCustomerInfo = __decorate([
    customerIdAsKey_1.default,
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], B2bCustomerInfo);
exports["default"] = B2bCustomerInfo;


/***/ }),

/***/ 3681:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const customerIdAsKey_1 = __importDefault(__webpack_require__(2468));
const StoresUtil_1 = __webpack_require__(5855);
const B2cRegistration_1 = __webpack_require__(2984);
const CustomerContract_1 = __importDefault(__webpack_require__(6156));
const DealerSigningButtons_1 = __importDefault(__webpack_require__(6103));
const OnScreenSigningView_1 = __importDefault(__webpack_require__(795));
const B2bCustomerInfo_1 = __importDefault(__webpack_require__(1461));
const RepresentationStipulationModal_1 = __importDefault(__webpack_require__(7670));
let B2bRegistration = class B2bRegistration extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "currentView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: B2cRegistration_1.CurrentView.CUSTOMER_INFO
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistrationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSignerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "updateView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (currentView) => {
                this.currentView = currentView;
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    async componentDidMount() {
        await this.componentSignerStore.initSigners();
    }
    render() {
        const { Separator } = this.frontLibrary;
        const { isLoading, isCiConfirmationChecked, contactInfoUpdated } = this.componentCustomerContactInfoStore;
        const { hasRepresentationStipulation } = this.componentRegistrationStore;
        const { dealer, customerId } = this.componentSsoStore;
        const shouldShowStipulationModal = !!dealer && hasRepresentationStipulation && !!customerId;
        if (!dealer && hasRepresentationStipulation) {
            return this.renderRepresentationStipulationNotice();
        }
        if (this.currentView === B2cRegistration_1.CurrentView.DEALER_ON_SCREEN_SIGNING_VIEW) {
            return this.renderOnScreenSigningComponent();
        }
        return (React.createElement(React.Fragment, null,
            shouldShowStipulationModal && React.createElement(RepresentationStipulationModal_1.default, null),
            this.componentContractStore.isLoading && contactInfoUpdated && isLoading() && this.renderSpinner(),
            React.createElement(B2bCustomerInfo_1.default, { currentLanguage: this.props.currentLanguage }),
            React.createElement(CustomerContract_1.default, { shouldDisableButtons: !(contactInfoUpdated || isCiConfirmationChecked) || isLoading(), customerCreationInProgress: isLoading() }),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            !!dealer && React.createElement(DealerSigningButtons_1.default, { updateView: this.updateView })));
    }
    renderRepresentationStipulationNotice() {
        const { Notice } = this.frontLibrary;
        const { translate } = this.componentTranslateStore;
        return (React.createElement(Notice, { id: "representation-stipulation-notice" },
            React.createElement("span", { dangerouslySetInnerHTML: {
                    __html: translate('registration.representationStipulation.notice', {
                        goToShopUrl: this.urlDataStore.goToShopUrl
                    })
                } })));
    }
    renderSpinner() {
        const { Overlay } = this.frontLibrary;
        return React.createElement(Overlay, { className: "overlay--fixed", spinner: true });
    }
    renderOnScreenSigningComponent() {
        return React.createElement(OnScreenSigningView_1.default, { onBack: () => (this.currentView = B2cRegistration_1.CurrentView.CUSTOMER_INFO), redirectUrl: this.props.redirectUrl });
    }
};
__decorate([
    mobx_1.observable
], B2bRegistration.prototype, "currentView", void 0);
__decorate([
    mobx_1.action
], B2bRegistration.prototype, "updateView", void 0);
B2bRegistration = __decorate([
    customerIdAsKey_1.default,
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], B2bRegistration);
exports["default"] = B2bRegistration;


/***/ }),

/***/ 9742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const StoresUtil_1 = __webpack_require__(5855);
let RegisterableCompaniesList = class RegisterableCompaniesList extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { ArrowList, ArrowListItem } = this.frontLibrary;
        const { creditInfoLegalEntities } = this.componentCreditInfoStore;
        return (this.componentCreditInfoStore.isLoaded && (React.createElement(React.Fragment, null, ArrowList && (React.createElement(ArrowList, { variant: "secondary" }, creditInfoLegalEntities.map((entity, index) => {
            return (React.createElement(ArrowListItem, { url: '#', key: index, onClick: async () => await this.componentCreditInfoStore.getAndSetEntityToRegister(entity.registrationNumber) }, entity.name));
        }))))));
    }
};
RegisterableCompaniesList = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], RegisterableCompaniesList);
exports["default"] = RegisterableCompaniesList;


/***/ }),

/***/ 7670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const table_1 = __webpack_require__(7706);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const react_1 = __importDefault(__webpack_require__(8156));
const StoresUtil_1 = __webpack_require__(5855);
let RepresentationStipulationModal = class RepresentationStipulationModal extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "modalIsOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSignerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistrationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "renderModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { Button, Modal, ModalContent, Table, Text, AnalyticsTrigger } = this.frontLibrary;
                const { translate } = this.componentTranslateStore;
                return (react_1.default.createElement(Modal, { hasContentComponent: true, isClosable: false, isOpen: this.modalIsOpen },
                    react_1.default.createElement(ModalContent, null,
                        react_1.default.createElement(Text, null,
                            react_1.default.createElement("h1", null, translate('contract.signers.modal.title')),
                            react_1.default.createElement("p", null, translate('contract.signers.modal.description')),
                            this.renderStipulation(),
                            react_1.default.createElement(Table, null,
                                react_1.default.createElement("thead", null,
                                    react_1.default.createElement(table_1.TableRow, null,
                                        react_1.default.createElement(table_1.TableCell, { type: "th", scope: "col" }, "Test"),
                                        react_1.default.createElement(table_1.TableCell, { type: "th", scope: "col" }, translate('contract.signers.modal.column.personalCode')))),
                                react_1.default.createElement("tbody", null, this.renderRows())),
                            react_1.default.createElement(lib_1.Separator, { color: "invisible" }),
                            react_1.default.createElement("p", { className: "text-center" },
                                react_1.default.createElement(AnalyticsTrigger, { trigger: {
                                        id: 'Button - representation stipulation modal continue',
                                        callback: 'onClick'
                                    } },
                                    react_1.default.createElement(Button, { id: "continue-btn", type: "employee", text: translate('contract.signers.modal.continue'), iconRight: "#arrow-right", onClick: this.onContinueClick })))))));
            }
        });
        Object.defineProperty(this, "onContinueClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.modalIsOpen = false;
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    async componentDidMount() {
        await this.componentSignerStore.initSigners();
    }
    render() {
        return react_1.default.createElement(react_1.default.Fragment, null, !this.componentSignerStore.isLoaded ? this.renderSpinner() : this.renderModal());
    }
    renderStipulation() {
        const { translate } = this.componentTranslateStore;
        return (react_1.default.createElement("p", null,
            translate('contract.signers.modal.stipulation'),
            this.componentRegistrationStore.getRepresentationStipulation));
    }
    renderRows() {
        const { isSamePerson } = this.componentSsoStore;
        const { Check } = this.frontLibrary;
        return this.componentSignerStore.signers.map((signer, index) => {
            return (react_1.default.createElement(table_1.TableRow, { key: signer.personalCode },
                react_1.default.createElement(table_1.TableCell, null,
                    react_1.default.createElement(Check, { labelText: `${signer.firstName} ${signer.lastName}`, id: `rep-${index}`, value: index.toString(), checked: signer.selected, onChange: (isChecked) => (signer.selected = isChecked), disabled: isSamePerson(signer.personalCode) }, `${signer.firstName} ${signer.lastName}`)),
                react_1.default.createElement(table_1.TableCell, null, signer.personalCode)));
        });
    }
    renderSpinner() {
        const { Overlay } = this.frontLibrary;
        return react_1.default.createElement(Overlay, { className: "overlay--fixed", spinner: true });
    }
};
__decorate([
    mobx_1.observable
], RepresentationStipulationModal.prototype, "modalIsOpen", void 0);
__decorate([
    mobx_1.action
], RepresentationStipulationModal.prototype, "onContinueClick", void 0);
RepresentationStipulationModal = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], RepresentationStipulationModal);
exports["default"] = RepresentationStipulationModal;


/***/ }),

/***/ 2929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const ComponentContractStore_1 = __webpack_require__(1467);
const ContactInfoUtil_1 = __webpack_require__(1203);
const StoresUtil_1 = __webpack_require__(5855);
const ContactAddress_1 = __importDefault(__webpack_require__(6624));
let B2cCustomerInfo = class B2cCustomerInfo extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.componentContactAddressStore.isAddressDirty, (data) => {
            if (data) {
                this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
            }
        });
    }
    render() {
        const customer = this.componentSsoStore.customer;
        const { translate } = this.componentTranslateStore;
        const { Heading, Separator } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            this.renderReadOnlyNameRegNumberFields(customer),
            React.createElement(Heading, { element: "h2", className: "h4 text-bold" }, translate('registration.contactInfo.header')),
            React.createElement(ContactAddress_1.default, { translations: this.componentTranslateStore.translations, currentLanguage: this.props.currentLanguage, countrySelectWidth: ['lg-4', 'md-6', 'sm-8', 'xs-12'], addressWidth: ['lg-4', 'md-6', 'sm-8', 'xs-12'], roomWidth: ['lg-2', 'md-2', 'sm-3', 'xs-12'] }),
            this.renderContactInfoFields(),
            React.createElement(Separator, { spacing: 'small', color: 'invisible' }),
            this.renderConfirmContactInfoCheckBox()));
    }
    renderConfirmContactInfoCheckBox() {
        const { ChoiceGroup } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            React.createElement(ChoiceGroup, { id: "b2c-confirm-contact-info", label: "Kontaktandmete kinnitamine", type: "check", purpose: "agreement", hideLabel: "no-break", options: [
                    {
                        id: 'confirm-contactInfo',
                        labelText: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
                        value: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
                        disabled: !this.componentCustomerContactInfoStore.areMandatoryValuesValid() ||
                            !this.componentContactAddressStore.isAddressValid() ||
                            this.componentCustomerContactInfoStore.isCiConfirmationChecked,
                        children: this.getConfirmContactInfoOptionChildren()
                    }
                ], value: this.componentCustomerContactInfoStore.ciCheckBoxValue, onChange: () => {
                    this.componentCustomerContactInfoStore.setCiConfirmationChecked();
                    this.updateB2cInfo();
                } })));
    }
    renderContactInfoFields() {
        const { translate } = this.componentTranslateStore;
        const { email, phone, isEmailValid, isPhoneValid } = this.componentCustomerContactInfoStore;
        const { TextField, Text } = this.frontLibrary;
        return (React.createElement(lib_1.Grid, null,
            React.createElement(lib_1.GridColumn, { width: ['lg-4', 'md-6', 'sm-8', 'xs-12'] },
                React.createElement(Text, null,
                    React.createElement(TextField, { id: "phone-number", label: translate('registration.b2c.contactInfo.phone'), value: phone.value, onChange: (value) => {
                            this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
                            phone.onChange(value);
                        }, isInvalid: !isPhoneValid }),
                    React.createElement(TextField, { id: "email", label: translate('registration.b2c.contactInfo.email'), value: email.value, onChange: (value) => {
                            this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
                            email.onChange(value);
                        }, isInvalid: !isEmailValid }),
                    this.renderLanguageSelector()))));
    }
    renderReadOnlyNameRegNumberFields(customer) {
        const { TextField } = this.frontLibrary;
        return (React.createElement(lib_1.Grid, null,
            React.createElement(lib_1.GridColumn, { width: ['xs'] },
                React.createElement(TextField, { id: "name", label: this.componentTranslateStore.translate('registration.b2c.contactInfo.name'), isStatic: true, onChange: () => undefined, value: customer.displayName })),
            React.createElement(lib_1.GridColumn, { width: ['xs'] },
                React.createElement(TextField, { id: "personal-code", label: this.componentTranslateStore.translate('registration.b2c.contactInfo.registrationNumber'), isStatic: true, onChange: () => undefined, value: customer.registrationNumber }))));
    }
    renderLanguageSelector() {
        const { Selector } = this.frontLibrary;
        return (React.createElement(React.Fragment, null,
            React.createElement(Selector, { items: (0, ContactInfoUtil_1.getCommunicationLanguageProps)(this.componentCustomerContactInfoStore.contactInfoUpdated, this.componentTranslateStore), label: this.componentTranslateStore.translate('registration.b2c.contactInfo.communicationLanguage'), value: this.componentCustomerContactInfoStore.communicationLanguage.value, onChange: (item) => {
                    this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
                    this.componentCustomerContactInfoStore.onCommunicationLanguageChange(item);
                }, size: "small", id: "b2c-communication-language" })));
    }
    async updateB2cInfo() {
        this.componentCustomerContactInfoStore.setIsLoading();
        if (this.componentCustomerContactInfoStore.shouldUpdateContactInfo()) {
            !!this.componentSsoStore.customerId ? await this.updateExistingCustomerInfo() : await this.updateNewCustomerInfo();
        }
        this.componentCustomerContactInfoStore.onLoaded();
    }
    async refreshData() {
        if (!this.componentContractStore.isError) {
            if (this.componentCustomerContactInfoStore.ciCheckBoxCheckedTimes <= 1 || this.componentContactAddressStore.hasAddressChanged()) {
                await this.componentContractStore.refreshContractData();
            }
        }
    }
    setStates() {
        if (!this.componentContractStore.isError) {
            this.componentContactAddressStore.setIsAddressDirtyFalse();
            this.componentCustomerContactInfoStore.setContactInfoUpdated();
        }
    }
    async updateNewCustomerInfo() {
        await this.componentCustomerContactInfoStore.createNewCustomer(this.componentSsoStore.person, this.componentContactAddressStore.getAddress());
        if (!this.componentCustomerContactInfoStore.isError) {
            this.componentSsoStore.onLoginWithCallback(async () => {
                await this.componentContractStore.ensurePreparedContractExists();
                await this.refreshData();
                this.setStates();
            });
        }
    }
    async updateExistingCustomerInfo() {
        await this.componentContactAddressStore.saveAddress();
        await this.componentCustomerContactInfoStore.updateContactInfo();
        if (!this.componentCustomerContactInfoStore.isError && this.componentContactAddressStore.status !== 'ERROR' && !this.componentSsoStore.dealer) {
            this.componentContractStore.setContractType(ComponentContractStore_1.ContractType.CLICK_ACCEPT);
            await this.componentContractStore.ensurePreparedContractExists();
        }
        if (!this.componentSsoStore.dealer) {
            await this.refreshData();
        }
        this.setStates();
    }
    getConfirmContactInfoOptionChildren() {
        const { translate } = this.componentTranslateStore;
        return React.createElement("span", { className: "text-bold" }, translate('registration.contactInfo.confirmContactInfo'));
    }
};
B2cCustomerInfo = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], B2cCustomerInfo);
exports["default"] = B2cCustomerInfo;


/***/ }),

/***/ 2984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CurrentView = void 0;
const lib_1 = __webpack_require__(3571);
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const customerIdAsKey_1 = __importDefault(__webpack_require__(2468));
const StoresUtil_1 = __webpack_require__(5855);
const CustomerContract_1 = __importDefault(__webpack_require__(6156));
const DealerSigningButtons_1 = __importDefault(__webpack_require__(6103));
const OnScreenSigningView_1 = __importDefault(__webpack_require__(795));
const B2cCustomerInfo_1 = __importDefault(__webpack_require__(2929));
var CurrentView;
(function (CurrentView) {
    CurrentView[CurrentView["CUSTOMER_INFO"] = 0] = "CUSTOMER_INFO";
    CurrentView[CurrentView["DEALER_PAPER_CONTRACT_MODAL"] = 1] = "DEALER_PAPER_CONTRACT_MODAL";
    CurrentView[CurrentView["DEALER_ON_SCREEN_SIGNING_VIEW"] = 2] = "DEALER_ON_SCREEN_SIGNING_VIEW";
})(CurrentView = exports.CurrentView || (exports.CurrentView = {}));
let B2cRegistration = class B2cRegistration extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: CurrentView.CUSTOMER_INFO
        });
        Object.defineProperty(this, "updateView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (view) => {
                this.currentView = view;
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        if (this.currentView === CurrentView.CUSTOMER_INFO || this.currentView === CurrentView.DEALER_PAPER_CONTRACT_MODAL) {
            return this.renderRegistrationComponent();
        }
        if (this.currentView === CurrentView.DEALER_ON_SCREEN_SIGNING_VIEW) {
            return this.renderOnScreenSigningComponent();
        }
        return React.createElement(lib_1.Spinner, null);
    }
    renderOnScreenSigningComponent() {
        return React.createElement(OnScreenSigningView_1.default, { onBack: () => this.updateView(CurrentView.CUSTOMER_INFO), redirectUrl: this.props.redirectUrl });
    }
    renderRegistrationComponent() {
        const { translate } = this.componentTranslateStore;
        const { isCiConfirmationChecked, contactInfoUpdated, isLoading } = this.componentCustomerContactInfoStore;
        const { Heading, Text, Separator, Notice } = this.frontLibrary;
        const ssoStore = this.componentSsoStore;
        return (React.createElement(React.Fragment, null,
            !!ssoStore.dealer && ssoStore.isUnderage() && (React.createElement(React.Fragment, null,
                React.createElement(Notice, { type: 'employee' }, this.componentTranslateStore.translate('registration.underage.notice')),
                React.createElement(Separator, { spacing: "small", color: "invisible" }))),
            this.componentContractStore.isLoading && contactInfoUpdated && isLoading() && this.renderSpinner(),
            React.createElement(Text, null,
                React.createElement(Heading, { element: "h1", className: "h2" }, translate('registration.header')),
                React.createElement("p", null, this.componentCustomerContactInfoStore.initialCustomerId
                    ? translate('registration.general.existingCustomer.text')
                    : translate('registration.general.newCustomer.text')),
                React.createElement(B2cCustomerInfo_1.default, { currentLanguage: this.props.currentLanguage }),
                React.createElement(Separator, { spacing: "medium" })),
            React.createElement(CustomerContract_1.default, { shouldDisableButtons: !(contactInfoUpdated || isCiConfirmationChecked) || this.componentCustomerContactInfoStore.isLoading(), customerCreationInProgress: this.componentCustomerContactInfoStore.isLoading() }),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            !!this.componentSsoStore.dealer && React.createElement(DealerSigningButtons_1.default, { updateView: this.updateView, dealerRedirectUrl: this.props.redirectUrl })));
    }
    renderSpinner() {
        const { Overlay } = this.frontLibrary;
        return React.createElement(Overlay, { className: "overlay--fixed", spinner: true });
    }
};
__decorate([
    mobx_1.observable
], B2cRegistration.prototype, "currentView", void 0);
__decorate([
    mobx_1.action
], B2cRegistration.prototype, "updateView", void 0);
B2cRegistration = __decorate([
    customerIdAsKey_1.default,
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], B2cRegistration);
exports["default"] = B2cRegistration;


/***/ }),

/***/ 1445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const LocationUtils_1 = __importDefault(__webpack_require__(1513));
const StoresUtil_1 = __webpack_require__(5855);
let ContractValidator = class ContractValidator extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractValidatorStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.props.customer, () => (this.contractValidatorStore.customer = this.props.customer), { fireImmediately: true });
    }
    render() {
        if (this.contractValidatorStore.isLoading) {
            return null;
        }
        if (!this.isAlreadyRedirected && this.contractValidatorStore.shouldRedirect) {
            LocationUtils_1.default.redirectToUrl(this.props.redirectLink);
            return null;
        }
        return React.createElement(React.Fragment, null, this.props.children);
    }
    get isAlreadyRedirected() {
        return this.urlDataStore.isCurrentPath(this.props.redirectLink);
    }
};
__decorate([
    mobx_1.computed
], ContractValidator.prototype, "isAlreadyRedirected", null);
ContractValidator = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContractValidator);
exports["default"] = ContractValidator;


/***/ }),

/***/ 3607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(2740), exports);
__exportStar(__webpack_require__(4547), exports);
__exportStar(__webpack_require__(929), exports);
__exportStar(__webpack_require__(8910), exports);


/***/ }),

/***/ 3287:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const util_1 = __webpack_require__(8910);
const ContactInfoValidationApi_1 = __importDefault(__webpack_require__(1417));
class ComponentContactInfoValidationStore {
    constructor() {
        Object.defineProperty(this, "contactInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validationCodeInputValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isModalOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isErrorOnValidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isValidationComplete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isResendAllowed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "pollingIntervalId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        (0, mobx_1.makeObservable)(this);
        (0, mobx_1.reaction)(() => this.contactInfo, (0, mobx_1.action)(() => {
            if (!this.isEmailValidation && this.pollingIntervalId) {
                this.stopPolling();
            }
        }));
    }
    init(contactInfo) {
        this.reset();
        this.contactInfo = contactInfo;
        if (this.isEmailValidation) {
            this.startPolling();
        }
        this.isLoaded = true;
    }
    reset() {
        this.stopPolling();
        this.validationCodeInputValue = '';
        this.contactInfo = null;
        this.isLoaded = false;
        this.isModalOpen = false;
        this.isErrorOnValidation = false;
        this.isValidationComplete = false;
        this.isResendAllowed = true;
    }
    get isEmailValidation() {
        var _a;
        return ((_a = this.contactInfo) === null || _a === void 0 ? void 0 : _a.type) === util_1.ContactInfoType.EMAIL;
    }
    get isPhoneValidation() {
        var _a;
        return ((_a = this.contactInfo) === null || _a === void 0 ? void 0 : _a.type) === util_1.ContactInfoType.PHONE;
    }
    startPolling() {
        this.pollingIntervalId = setInterval(this.poll.bind(this), ComponentContactInfoValidationStore.POLLING_INTERVAL);
    }
    stopPolling() {
        clearInterval(this.pollingIntervalId);
        this.pollingIntervalId = null;
    }
    poll() {
        ContactInfoValidationApi_1.default.isContactInfoValidated(this.contactInfo.contactInfoId).then((res) => {
            const isValidated = res.data;
            if (isValidated) {
                this.stopPolling();
                this.isValidationComplete = true;
            }
        });
    }
    validatePhone() {
        ContactInfoValidationApi_1.default.validateByValidationCodeAndContactInfoId(this.contactInfo.contactInfoId, this.validationCodeInputValue).then((0, mobx_1.action)((res) => {
            const isValidated = res.data;
            if (isValidated) {
                this.isValidationComplete = true;
            }
            else {
                this.isErrorOnValidation = true;
            }
        }));
    }
    forbidResend() {
        this.isResendAllowed = false;
        setTimeout((0, mobx_1.action)(() => {
            this.isResendAllowed = true;
        }), ComponentContactInfoValidationStore.RESEND_COOLDOWN);
    }
    sendValidationCode() {
        if (this.isResendAllowed) {
            this.forbidResend();
            ContactInfoValidationApi_1.default.sendContactInfoValidationCode(this.contactInfo.contactInfoId);
        }
    }
}
Object.defineProperty(ComponentContactInfoValidationStore, "POLLING_INTERVAL", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 1000 * 3
});
Object.defineProperty(ComponentContactInfoValidationStore, "RESEND_COOLDOWN", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 1000 * 30
});
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "contactInfo", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "validationCodeInputValue", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "isModalOpen", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "isErrorOnValidation", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "isValidationComplete", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "isResendAllowed", void 0);
__decorate([
    mobx_1.observable
], ComponentContactInfoValidationStore.prototype, "pollingIntervalId", void 0);
__decorate([
    mobx_1.action
], ComponentContactInfoValidationStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentContactInfoValidationStore.prototype, "reset", null);
__decorate([
    mobx_1.computed
], ComponentContactInfoValidationStore.prototype, "isEmailValidation", null);
__decorate([
    mobx_1.computed
], ComponentContactInfoValidationStore.prototype, "isPhoneValidation", null);
__decorate([
    mobx_1.action
], ComponentContactInfoValidationStore.prototype, "startPolling", null);
__decorate([
    mobx_1.action
], ComponentContactInfoValidationStore.prototype, "stopPolling", null);
__decorate([
    mobx_1.action
], ComponentContactInfoValidationStore.prototype, "forbidResend", null);
exports["default"] = ComponentContactInfoValidationStore;


/***/ }),

/***/ 1467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContractType = void 0;
const file_saver_1 = __webpack_require__(3162);
const mobx_1 = __webpack_require__(259);
const ContractAPI_1 = __importDefault(__webpack_require__(3803));
const MarketingOffersAPI_1 = __importDefault(__webpack_require__(2512));
const LocationUtils_1 = __importDefault(__webpack_require__(1513));
var ContractType;
(function (ContractType) {
    ContractType["CLICK_ACCEPT"] = "CLICK_ACCEPT";
    ContractType["PAPER"] = "PAPER";
    ContractType["ON_SCREEN"] = "ON_SCREEN";
})(ContractType = exports.ContractType || (exports.ContractType = {}));
class ComponentContractStore {
    constructor(rootStore) {
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasAgreedToTerms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasSignedContract", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "contractCheckboxValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "preparedContracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "contractAPI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSignerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "updateContractSigners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                const selectedSigners = this.componentSignerStore.getSelectedSigners();
                await this.contractAPI.updateContractSigners(this.preparedContract.contractId, selectedSigners);
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.urlData = rootStore.urlDataStore;
        this.apiUrl = rootStore.urlDataStore.componentsAPIURL;
        this.contractAPI = new ContractAPI_1.default(this.apiUrl);
        this.ssoStore = rootStore.componentSsoStore;
        this.componentSignerStore = rootStore.componentSignerStore;
    }
    async init() {
        this.isLoaded = false;
        this.hasSignedContract = false;
        this.contractType = this.ssoStore.dealer ? ContractType.PAPER : ContractType.CLICK_ACCEPT;
        if (this.ssoStore.customerId) {
            this.status = 'LOADING';
            await this.fetchExistingSignedContract();
            if (!this.hasSignedContract) {
                await this.fetchExistingPreparedContract();
            }
        }
        if (!this.componentSignerStore.signers || this.componentSignerStore.signers.length === 0) {
            await this.componentSignerStore.initSigners();
        }
        this.onLoaded();
    }
    setContractType(contractType) {
        this.contractType = contractType;
    }
    async fetchExistingPreparedContract() {
        this.setIsLoading(true);
        let apiRequest;
        switch (this.contractType) {
            case ContractType.CLICK_ACCEPT:
                apiRequest = this.contractAPI.getPreparedClickAcceptContract();
                break;
            case ContractType.PAPER:
                apiRequest = this.contractAPI.getPreparedPaperContract();
                break;
            case ContractType.ON_SCREEN:
                apiRequest = this.contractAPI.getPreparedOnScreenContract();
                break;
            default:
                this.onError();
                break;
        }
        await apiRequest
            .then((response) => {
            this.preparedContracts[this.contractType] = response.data;
            if (this.ssoStore.dealer && this.preparedContract.contractId) {
                this.contractAPI.putEmployeeSigner(this.preparedContract.contractId, this.ssoStore.dealer.userName);
            }
            this.setIsLoading(false);
        })
            .catch(() => {
            this.onError();
        });
    }
    async refreshContractData() {
        this.setIsLoading(true);
        if (this.preparedContract && !!this.preparedContract.contractId) {
            await this.contractAPI.postContractDataRefresh(this.preparedContract.contractId).catch(() => this.onError());
        }
        else {
            console.warn('Missing contractId');
        }
        this.setIsLoading(false);
    }
    async createNewContract() {
        this.setIsLoading(true);
        await this.contractAPI
            .postNewContract(this.contractType)
            .then(() => {
            this.setIsLoading(false);
        })
            .catch(() => this.onError());
    }
    async signContractAndRedirect(goToUrl) {
        this.setIsLoading(true);
        let apiRequest;
        switch (this.contractType) {
            case ContractType.CLICK_ACCEPT:
                apiRequest = this.contractAPI.postSignContract(this.preparedContract.contractId);
                break;
            case ContractType.PAPER:
            case ContractType.ON_SCREEN:
                apiRequest = this.contractAPI.postSignDealerContract(this.preparedContract.contractId);
                break;
            default:
                this.onError();
                break;
        }
        await apiRequest
            .then(async () => {
            await this.acceptAllB2bMarketingOffers();
            this.redirectToGivenUrl(goToUrl);
        })
            .catch(() => {
            this.onError();
        })
            .finally(() => {
            this.setIsLoading(false);
        });
    }
    async ensurePreparedContractExists() {
        if (!this.preparedContract) {
            await this.fetchExistingPreparedContract();
        }
        if (!this.preparedContract.hasContract) {
            await this.createNewContract();
            await this.fetchExistingPreparedContract();
        }
        if (this.preparedContract.contractId) {
            await this.updateContractSigners();
        }
    }
    redirectToGivenUrl(goToUrl) {
        goToUrl ? LocationUtils_1.default.redirectToUrl(goToUrl) : LocationUtils_1.default.redirectToUrl(LocationUtils_1.default.getDomain());
    }
    setAgreementChecked() {
        this.hasAgreedToTerms = true;
    }
    setAgreementUnChecked() {
        this.hasAgreedToTerms = false;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    onLoaded() {
        this.isLoaded = true;
        this.status = 'LOADED';
    }
    onExistingContractCheck(response) {
        this.hasSignedContract = response.data;
    }
    onError() {
        this.isLoading = false;
        this.isError = true;
    }
    setContractCheckboxChecked() {
        this.contractCheckboxValue.push('checked');
    }
    setContractCheckboxUnChecked() {
        this.contractCheckboxValue.pop();
    }
    async getContractDocument() {
        const contractDocBytes = await this.contractAPI.getContractDocument(this.preparedContract.contractId);
        return (0, file_saver_1.saveAs)(contractDocBytes.data, 'contract.pdf');
    }
    get generalTermsLink() {
        return this.urlData.generalTermsUrl;
    }
    get preparedContract() {
        return this.preparedContracts[this.contractType];
    }
    async fetchExistingSignedContract() {
        this.setIsLoading(true);
        await this.contractAPI
            .getSignedCustomerContract()
            .then((response) => {
            this.setIsLoading(false);
            this.onExistingContractCheck(response);
        })
            .catch(() => {
            this.onError();
        });
    }
    async acceptAllB2bMarketingOffers() {
        if (this.ssoStore.isBusiness) {
            await MarketingOffersAPI_1.default.updateMarketingOffers(true, true, true).catch(() => {
                this.onError();
            });
        }
    }
}
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "hasAgreedToTerms", void 0);
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "isLoading", void 0);
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "hasSignedContract", void 0);
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "isError", void 0);
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "contractCheckboxValue", void 0);
__decorate([
    mobx_1.observable
], ComponentContractStore.prototype, "status", void 0);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "setAgreementChecked", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "setAgreementUnChecked", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "setIsLoading", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "onLoaded", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "onExistingContractCheck", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "onError", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "setContractCheckboxChecked", null);
__decorate([
    mobx_1.action
], ComponentContractStore.prototype, "setContractCheckboxUnChecked", null);
exports["default"] = ComponentContractStore;


/***/ }),

/***/ 4334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class ComponentContractValidatorStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentURLDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signedCustomerContractExists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "customerHasLegalMandate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "currentCustomer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "customerInitialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                this.error = e;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentSsoStore = componentRootStore.componentSsoStore;
        this.componentMandateStore = componentRootStore.componentMandateStore;
        this.componentURLDataStore = componentRootStore.urlDataStore;
    }
    set customer(newCustomer) {
        const doSetCustomer = () => {
            this.currentCustomer = newCustomer;
            (0, mobx_1.runInAction)(() => {
                this.signedCustomerContractExists = null;
                this.customerHasLegalMandate = null;
                this.customerInitialized = true;
            });
            if (this.currentCustomer) {
                this.getSignedCustomerContractData();
                if (this.currentCustomer.type === 'B2B' && !!this.componentSsoStore.customerId) {
                    this.getCustomerHasLegalMandate();
                }
            }
        };
        if (!this.currentCustomer || !newCustomer) {
            doSetCustomer();
            return;
        }
        const customerIdDifferent = this.currentCustomer.customerId !== newCustomer.customerId;
        const registrationNumberDifferent = this.currentCustomer.registrationNumber !== newCustomer.registrationNumber;
        const registrationNumberCountryCodeDifferent = this.currentCustomer.registrationNumberCountryCode !== newCustomer.registrationNumberCountryCode;
        if (customerIdDifferent || registrationNumberDifferent || registrationNumberCountryCodeDifferent) {
            doSetCustomer();
        }
    }
    get isLoading() {
        return !this.customerInitialized || (!!this.currentCustomer && this.signedCustomerContractExists === null && this.customerHasLegalMandate === null);
    }
    get shouldRedirect() {
        if (this.error) {
            throw new Error(this.error);
        }
        if (this.componentSsoStore.dealer) {
            return false;
        }
        if (!this.currentCustomer) {
            return false;
        }
        if (!this.currentCustomer.customerId) {
            return true;
        }
        if (this.signedCustomerContractExists === null) {
            return false;
        }
        if (this.currentCustomer.type === 'B2B') {
            if (this.customerHasLegalMandate === null) {
                return false;
            }
            return !this.signedCustomerContractExists && this.customerHasLegalMandate;
        }
        if (this.componentSsoStore.isRepresentingSelf) {
            return !this.signedCustomerContractExists;
        }
        return false;
    }
    getSignedCustomerContractData() {
        ApiUtil_1.default.get(this.componentURLDataStore.componentsAPIURL.concat(ComponentContractValidatorStore.IS_SIGNED_CUSTOMER_CONTRACT_URL))
            .then((0, mobx_1.action)((response) => (this.signedCustomerContractExists = !!response.data)))
            .catch(this.handleError);
    }
    getCustomerHasLegalMandate() {
        this.componentMandateStore
            .hasCustomerMandate(['LEGAL'])
            .then((0, mobx_1.action)((response) => (this.customerHasLegalMandate = response)))
            .catch(this.handleError);
    }
}
Object.defineProperty(ComponentContractValidatorStore, "IS_SIGNED_CUSTOMER_CONTRACT_URL", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: '/customer/contract/is-signed'
});
__decorate([
    mobx_1.observable
], ComponentContractValidatorStore.prototype, "signedCustomerContractExists", void 0);
__decorate([
    mobx_1.observable
], ComponentContractValidatorStore.prototype, "customerHasLegalMandate", void 0);
__decorate([
    mobx_1.observable
], ComponentContractValidatorStore.prototype, "currentCustomer", void 0);
__decorate([
    mobx_1.observable
], ComponentContractValidatorStore.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], ComponentContractValidatorStore.prototype, "customerInitialized", void 0);
__decorate([
    mobx_1.computed
], ComponentContractValidatorStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], ComponentContractValidatorStore.prototype, "shouldRedirect", null);
__decorate([
    mobx_1.action
], ComponentContractValidatorStore.prototype, "handleError", void 0);
exports["default"] = ComponentContractValidatorStore;


/***/ }),

/***/ 2880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const CreditInfoLegalEntitiesAPI_1 = __importDefault(__webpack_require__(3865));
class ComponentCreditInfoStore {
    constructor(rootStore) {
        Object.defineProperty(this, "creditInfoLegalEntities", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "creditInfoLegalEntitiesAPI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "entityToRegister", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.creditInfoLegalEntitiesAPI = new CreditInfoLegalEntitiesAPI_1.default(rootStore.urlDataStore.componentsAPIURL);
        this.componentSsoStore = rootStore.componentSsoStore;
    }
    async init() {
        this.entityToRegister = null;
        await this.getCreditInfoLegalEntities();
    }
    async getCreditInfoLegalEntities() {
        if (this.status !== 'LOADING') {
            this.status = 'LOADING';
            const response = await this.creditInfoLegalEntitiesAPI.getCreditInfoLegalEntities();
            this.creditInfoLegalEntities = response.data.creditInfoLegalEntities;
        }
        this.status = 'LOADED';
        this.isLoaded = true;
    }
    async getAndSetEntityToRegister(registrationNumber) {
        if (this.status !== 'LOADING') {
            this.status = 'LOADING';
            const response = await this.creditInfoLegalEntitiesAPI.getCreditInfoLegalEntity(registrationNumber);
            if (response.data.name && response.data.registrationNumber) {
                this.entityToRegister = { ...response.data, registrationNumberCountryCode: 'EE' };
            }
        }
        this.status = 'LOADED';
        this.isLoaded = true;
    }
    get hasRegistrableEntities() {
        return this.creditInfoLegalEntities.length > 0;
    }
    get getSsoPersonRepresentationStipulationForEntityToRegister() {
        return (this.entityToRegister &&
            this.entityToRegister.personRelations &&
            this.entityToRegister.personRelations.find((pr) => this.componentSsoStore.isSamePerson(pr.person.personalCode)).representationStipulation);
    }
}
__decorate([
    mobx_1.observable
], ComponentCreditInfoStore.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], ComponentCreditInfoStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentCreditInfoStore.prototype, "entityToRegister", void 0);
__decorate([
    mobx_1.action
], ComponentCreditInfoStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentCreditInfoStore.prototype, "getCreditInfoLegalEntities", null);
__decorate([
    mobx_1.action
], ComponentCreditInfoStore.prototype, "getAndSetEntityToRegister", null);
exports["default"] = ComponentCreditInfoStore;


/***/ }),

/***/ 5104:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const ContactInfoAPI_1 = __importDefault(__webpack_require__(488));
const MandateAPI_1 = __importDefault(__webpack_require__(6668));
const ContactInfo_1 = __importDefault(__webpack_require__(1561));
const LegalEntityCreation_1 = __webpack_require__(2434);
const PrivateCustomer_1 = __webpack_require__(5860);
const util_1 = __webpack_require__(8910);
class ComponentCustomerContactInfoStore {
    constructor(rootStore) {
        Object.defineProperty(this, "contactInfoAPI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateAPI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialCustomerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ciCheckBoxValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "ciCheckBoxCheckedTimes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "contactInfoUpdated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "newCustomerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "customerPersonId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "hasRepresentationStipulationForCustomer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "email", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ContactInfo_1.default(util_1.ContactInfoType.EMAIL)
        });
        Object.defineProperty(this, "phone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ContactInfo_1.default(util_1.ContactInfoType.PHONE)
        });
        Object.defineProperty(this, "oldEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oldPhone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communicationLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { oldValue: '', value: '' }
        });
        Object.defineProperty(this, "contactInfoConfirmedTs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "componentsApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.status === 'LOADING';
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentsApiBaseUrl = rootStore.urlDataStore.componentsAPIURL;
        this.componentSsoStore = rootStore.componentSsoStore;
        this.contractStore = rootStore.componentContractStore;
        this.componentCreditInfoStore = rootStore.componentCreditInfoStore;
        this.mandateAPI = new MandateAPI_1.default(rootStore.urlDataStore.componentsAPIURL);
    }
    async init() {
        this.resetStates();
        this.setInitialCustomerId();
        await this.getPerson();
        if (!this.isLoading()) {
            this.setIsLoading();
            if (this.componentSsoStore.isPrivate) {
                await this.getContactInfo();
            }
            if (this.componentSsoStore.isBusiness) {
                await this.getCustomerPersonContactInfo();
            }
        }
        this.onLoaded();
    }
    resetStates() {
        this.isLoaded = false;
        this.customerPersonId = null;
        this.email = new ContactInfo_1.default(util_1.ContactInfoType.EMAIL);
        this.phone = new ContactInfo_1.default(util_1.ContactInfoType.PHONE);
        this.communicationLanguage = { oldValue: '', value: '' };
        this.contactInfoAPI = new ContactInfoAPI_1.default(this.componentsApiBaseUrl);
    }
    setInitialCustomerId() {
        if (this.initialCustomerId === null) {
            this.initialCustomerId = this.componentSsoStore.customerId;
        }
    }
    async updateContactInfo(updateConfirmedTs = true) {
        this.isError = false;
        if (!this.email.hasValue && !this.phone.hasValue) {
            throw new Error('Missing contact info.');
        }
        await Promise.allSettled([
            this.updateContactInfoIfChanged(this.email).catch(() => this.onError(this.email)),
            this.updateContactInfoIfChanged(this.phone).catch(() => this.onError(this.phone))
        ]);
        await this.getContactInfo(this.customerPersonId);
        if ((0, util_1.isContactInfoChanged)(this.communicationLanguage.value, this.communicationLanguage.oldValue)) {
            await this.updateCommunicationLanguage(this.communicationLanguage.value);
            if (!this.isError) {
                (0, mobx_1.runInAction)(() => (this.communicationLanguage.oldValue = this.communicationLanguage.value));
            }
        }
        if (this.componentSsoStore.isPrivate && !this.isError && updateConfirmedTs) {
            await this.updateContactInfoConfirmedTs();
        }
    }
    async updateContactInfoIfChanged(contactInfo) {
        if (contactInfo.hasValueChanged) {
            contactInfo.hasValue ? await this.updateOrCreateContactInfo(contactInfo) : await this.deleteContactInfo(contactInfo);
        }
    }
    async updateOrCreateContactInfo(contactInfo) {
        if ((!contactInfo.validated && contactInfo.value != null && contactInfo.value !== '') || (0, util_1.isContactInfoChanged)(contactInfo.value, contactInfo.oldValue)) {
            !contactInfo.contactInfoId ? await this.createEmailOrPhone(contactInfo) : await this.updateEmailOrPhone(contactInfo);
            contactInfo.oldValue = contactInfo.value;
        }
    }
    async deleteContactInfo(contactInfo) {
        if (!this.componentSsoStore.dealer) {
            this.isError = true;
            throw new Error('Only dealer can delete contact info.');
        }
        this.contactInfoAPI.deleteContactInfo(contactInfo.contactInfoId);
    }
    async getContactInfo(customerPersonId) {
        await this.contactInfoAPI
            .getContactInfo(this.componentSsoStore.isPrivate, customerPersonId)
            .then((response) => {
            this.populateContactInfo(response.data);
        })
            .catch(() => {
            this.onError();
        });
    }
    populateContactInfo(contactInfos) {
        contactInfos.forEach((contactInfo) => {
            if (contactInfo.type === 'EMAIL' && !this.email.isSavingError) {
                this.setEmailContactInfo(contactInfo);
            }
            else if (contactInfo.type === 'PHONE' && !this.phone.isSavingError) {
                this.setPhoneContactInfo(contactInfo);
            }
        });
    }
    setEmailContactInfo(contactInfo) {
        this.email.set(contactInfo);
        const oldEmail = new ContactInfo_1.default(util_1.ContactInfoType.EMAIL);
        oldEmail.set(contactInfo);
        this.oldEmail = oldEmail;
    }
    setPhoneContactInfo(contactInfo) {
        this.phone.set(contactInfo);
        const oldPhone = new ContactInfo_1.default(util_1.ContactInfoType.PHONE);
        oldPhone.set(contactInfo);
        this.oldPhone = oldPhone;
    }
    async getPerson() {
        await this.contactInfoAPI
            .getPerson()
            .then(async (response) => {
            this.onGetPersonSuccess(response);
        })
            .catch(() => {
            this.onError();
        });
    }
    async updateContactInfoConfirmedTs() {
        await this.contactInfoAPI.putPersonContactInfoConfirmedTs().catch(() => this.onError());
        await this.contactInfoAPI
            .getPerson()
            .then((0, mobx_1.action)((res) => {
            if (res.data !== null) {
                this.contactInfoConfirmedTs = res.data.contactInfoConfirmedTs;
            }
        }))
            .catch(() => this.onError());
    }
    async updateEmailOrPhone(contactInfo) {
        const contactInfoResource = contactInfo.getContactInfoResource();
        await this.contactInfoAPI.putContactInfo(this.componentSsoStore.isPrivate, contactInfoResource).catch(() => this.onError());
    }
    async updateCommunicationLanguage(newValue) {
        await this.contactInfoAPI.putPersonCommunicationLanguage(newValue).catch(() => this.onError());
    }
    async createEmailOrPhone(contactInfo) {
        const contactInfoResource = contactInfo.getContactInfoResource();
        await this.contactInfoAPI.postContactInfo(this.componentSsoStore.isPrivate, contactInfoResource, this.customerPersonId).catch(() => this.onError());
    }
    async createNewCustomer(person, address) {
        const privateCustomer = (0, PrivateCustomer_1.getPrivateCustomerResource)(person, this.email, this.phone, this.communicationLanguage.value, address);
        await this.contactInfoAPI.postPrivateCustomer(privateCustomer).catch(() => this.onError());
        await this.getCustomerAndUpdateSession(person.personalCode, person.personalCodeCountryCode);
    }
    async createNewB2bCustomer(address) {
        const customer = this.getLegalEntity();
        const legalEntityCustomer = (0, LegalEntityCreation_1.getLegalEntityCreation)(this.componentSsoStore.person, this.email, this.phone, this.communicationLanguage.value, address, customer);
        await this.contactInfoAPI.postLegalEntityCustomer(legalEntityCustomer).catch(() => this.onError());
        await this.getCustomerAndUpdateSession(customer.registrationNumber, customer.registrationNumberCountryCode);
    }
    async getCustomerAndUpdateSession(registrationNumber, registrationNumberCountryCode) {
        await this.getCustomerId(registrationNumber, registrationNumberCountryCode);
        if (this.newCustomerId) {
            this.componentSsoStore.updateSessionByCustomerId(this.newCustomerId);
        }
    }
    async getCustomerId(registrationNumber, registrationNumberCountryCode) {
        await this.mandateAPI
            .getPersonMandates()
            .then((response) => {
            const mandate = response.data.find((entity) => entity.registrationNumber === registrationNumber && entity.registrationNumberCountryCode === registrationNumberCountryCode);
            this.newCustomerId = mandate.customerId;
            this.customerPersonId = mandate.customerPersonId;
        })
            .catch(() => this.onError());
    }
    onGetPersonSuccess(response) {
        if (response.data !== null) {
            this.onCommunicationLanguageChange(response.data.communicationLanguageCode);
            this.communicationLanguage.oldValue = this.communicationLanguage.value;
            this.contactInfoConfirmedTs = response.data.contactInfoConfirmedTs;
        }
    }
    onCommunicationLanguageChange(value) {
        this.communicationLanguage.value = value;
    }
    setContactInfoUpdated() {
        this.contactInfoUpdated = true;
    }
    setContactInfoNotUpdated() {
        this.contactInfoUpdated = false;
    }
    onLoaded() {
        this.isLoaded = true;
        this.status = 'LOADED';
    }
    onError(contactInfo) {
        this.isError = true;
        contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.setSavingError(true);
    }
    setIsLoading() {
        this.status = 'LOADING';
    }
    isEmailValidatedOrOldEmailChanged() {
        var _a;
        return this.email == null || this.oldEmail == null || this.email.validated || this.email.value !== ((_a = this.oldEmail) === null || _a === void 0 ? void 0 : _a.value);
    }
    isPhoneValidatedOrOldPhoneChanged() {
        var _a;
        return this.phone == null || this.oldPhone == null || this.phone.validated || this.phone.value !== ((_a = this.oldPhone) === null || _a === void 0 ? void 0 : _a.value);
    }
    setCiConfirmationChecked() {
        this.ciCheckBoxCheckedTimes = this.ciCheckBoxCheckedTimes + 1;
        this.ciCheckBoxValue.push('checked');
    }
    setCiConfirmationUnChecked() {
        this.ciCheckBoxValue.pop();
        this.setContactInfoNotUpdated();
        this.contractStore.setAgreementUnChecked();
        this.contractStore.setContractCheckboxUnChecked();
    }
    get isCiConfirmationChecked() {
        return this.ciCheckBoxValue.length > 0;
    }
    shouldUpdateContactInfo() {
        return this.areMandatoryValuesValid() && this.isCiConfirmationChecked;
    }
    async getCustomerPersonContactInfo() {
        if (this.componentSsoStore.customerId) {
            await this.mandateAPI
                .getCustomerMandates(this.componentSsoStore.person.personalCode)
                .then((0, mobx_1.action)((response) => {
                var _a;
                const customerMandates = (_a = response.data) === null || _a === void 0 ? void 0 : _a.customerMandates;
                if (customerMandates && customerMandates.length) {
                    this.customerPersonId = customerMandates[0].customerPersonId;
                    this.hasRepresentationStipulationForCustomer = customerMandates[0].mandates[0].representationStipulation !== null;
                }
                else {
                    this.onError();
                }
            }))
                .catch(() => this.onError());
        }
        if (this.customerPersonId) {
            await this.getContactInfo(this.customerPersonId);
        }
    }
    getLegalEntity() {
        const { entityToRegister } = this.componentCreditInfoStore;
        const { customer } = this.componentSsoStore;
        return {
            name: entityToRegister && entityToRegister.name ? entityToRegister.name : customer.displayName,
            registrationNumber: entityToRegister && entityToRegister.registrationNumber ? entityToRegister.registrationNumber : customer.registrationNumber,
            registrationNumberCountryCode: entityToRegister && entityToRegister.registrationNumberCountryCode
                ? entityToRegister.registrationNumberCountryCode
                : customer.registrationNumberCountryCode
        };
    }
    get isEmailValid() {
        if (!this.email.isInputValid) {
            return false;
        }
        if (!!this.componentSsoStore.dealer) {
            return this.phone.hasValue || this.email.hasValue;
        }
        else {
            return this.email.hasValue;
        }
    }
    get isPhoneValid() {
        if (!this.phone.isInputValid) {
            return false;
        }
        if (!!this.componentSsoStore.dealer) {
            return this.email.hasValue || this.phone.hasValue;
        }
        else {
            return this.phone.hasValue;
        }
    }
    areMandatoryValuesValid() {
        return !!this.communicationLanguage.value && this.isPhoneValid && this.isEmailValid;
    }
}
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "isError", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "ciCheckBoxValue", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "ciCheckBoxCheckedTimes", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "contactInfoUpdated", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "newCustomerId", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "customerPersonId", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "hasRepresentationStipulationForCustomer", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "email", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "phone", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "oldEmail", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "oldPhone", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "communicationLanguage", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "contactInfoConfirmedTs", void 0);
__decorate([
    mobx_1.observable
], ComponentCustomerContactInfoStore.prototype, "status", void 0);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "resetStates", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "updateContactInfo", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "populateContactInfo", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setEmailContactInfo", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setPhoneContactInfo", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "onGetPersonSuccess", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "onCommunicationLanguageChange", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setContactInfoUpdated", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setContactInfoNotUpdated", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "onLoaded", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "onError", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setIsLoading", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "isEmailValidatedOrOldEmailChanged", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "isPhoneValidatedOrOldPhoneChanged", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setCiConfirmationChecked", null);
__decorate([
    mobx_1.action
], ComponentCustomerContactInfoStore.prototype, "setCiConfirmationUnChecked", null);
__decorate([
    mobx_1.computed
], ComponentCustomerContactInfoStore.prototype, "isCiConfirmationChecked", null);
__decorate([
    mobx_1.computed
], ComponentCustomerContactInfoStore.prototype, "isEmailValid", null);
__decorate([
    mobx_1.computed
], ComponentCustomerContactInfoStore.prototype, "isPhoneValid", null);
exports["default"] = ComponentCustomerContactInfoStore;


/***/ }),

/***/ 961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const EmployeeSignatureAPI_1 = __importDefault(__webpack_require__(9697));
const EmployeeSignature_1 = __webpack_require__(8851);
class ComponentEmployeeSignatureStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "employeeSignature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "employeeSignatureApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.employeeSignatureApi = new EmployeeSignatureAPI_1.default(componentRootStore.urlDataStore.componentsAPIURL);
    }
    async initSignature() {
        var _a;
        const response = (_a = (await this.employeeSignatureApi.getSignature())) === null || _a === void 0 ? void 0 : _a.data;
        this.employeeSignature = !!response ? response.signatureImage : '';
    }
    get signature() {
        return this.employeeSignature;
    }
    async saveSignature(signature) {
        return this.employeeSignatureApi.saveSignature(new EmployeeSignature_1.EmployeeSignatureResource(signature));
    }
    deleteSignature() {
        this.employeeSignatureApi.deleteSignature();
    }
}
exports["default"] = ComponentEmployeeSignatureStore;


/***/ }),

/***/ 2270:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GaDataStore = void 0;
class GaDataStore {
    static push(data) {
        var _a;
        if (window.dataLayer) {
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
                event: data.event,
                eventCategory: data.page,
                eventLabel: data.id,
                eventAction: data.group
            });
        }
    }
}
exports.GaDataStore = GaDataStore;


/***/ }),

/***/ 3047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const StringUtil_1 = __webpack_require__(5085);
class ComponentInformationCheckStore {
    constructor(rootStore) {
        Object.defineProperty(this, "informationCheckAccepted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "componentMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceSettingsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasEmailInvoices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.some((invoice) => invoice.invoiceDeliveries.includes('EMAIL'));
            }
        });
        Object.defineProperty(this, "hasPostInvoices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.some((invoice) => invoice.invoiceDeliveries.includes('POST'));
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentContactAddressStore = rootStore.componentContactAddressStore;
        this.componentMandateStore = rootStore.componentMandateStore;
        this.componentCustomerContactInfoStore = rootStore.componentCustomerContactInfoStore;
        this.componentInvoiceSettingsStore = rootStore.componentInvoiceSettingsStore;
        this.componentSsoStore = rootStore.componentSsoStore;
    }
    async init() {
        if (this.componentSsoStore.customerId && this.isLoading) {
            await this.componentCustomerContactInfoStore.init();
            await this.componentContactAddressStore.init();
            await this.componentInvoiceSettingsStore.init();
            this.isLoading = false;
        }
    }
    get addressExists() {
        return this.componentContactAddressStore.contactAddress && !!this.componentContactAddressStore.contactAddress.address;
    }
    get customerCommunicationLanguage() {
        return this.componentCustomerContactInfoStore.communicationLanguage.value;
    }
    get customerPhoneValue() {
        return (this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.phone && this.componentCustomerContactInfoStore.phone.value);
    }
    get customerPhoneValidated() {
        return (this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.phone && this.componentCustomerContactInfoStore.phone.validated);
    }
    get customerEmailValue() {
        return (this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.email && this.componentCustomerContactInfoStore.email.value);
    }
    get customerEmailValidated() {
        return (this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.email && this.componentCustomerContactInfoStore.email.validated);
    }
    get customerAddressFormatted() {
        return (this.componentContactAddressStore.isLoaded &&
            this.componentContactAddressStore.contactAddress &&
            this.formatAddress(this.componentContactAddressStore.contactAddress.address));
    }
    get customerAddressValidated() {
        return (this.componentContactAddressStore.isLoaded &&
            this.componentContactAddressStore.contactAddress &&
            this.componentContactAddressStore.contactAddress.validated);
    }
    get amountOfInvoices() {
        return (this.componentInvoiceSettingsStore.customerInvoiceSettings &&
            this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings &&
            this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.length);
    }
    get contactAddressIsMatchingOnInvoicesAndContactInfo() {
        if (!this.componentInvoiceSettingsStore.customerInvoiceSettings || !this.addressExists) {
            return false;
        }
        let emailAddressExistsOnInvoices, addressExistsOnInvoices;
        const emailAddress = this.componentCustomerContactInfoStore.email.value;
        const contactAddress = this.componentContactAddressStore.contactAddress.address;
        if (emailAddress) {
            emailAddressExistsOnInvoices = this.hasEmailInvoices()
                ? this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings
                    .filter((invoice) => invoice.invoiceDeliveries.includes('EMAIL'))
                    .every((invoice) => invoice.emailAddresses.includes(emailAddress))
                : true;
        }
        else {
            emailAddressExistsOnInvoices = true;
        }
        if (contactAddress) {
            addressExistsOnInvoices = this.hasPostInvoices()
                ? this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings
                    .filter((invoice) => invoice.invoiceDeliveries.includes('POST'))
                    .every((invoice) => this.validateInvoiceAndContactAddressAreEqual(invoice.address, contactAddress))
                : true;
        }
        else {
            addressExistsOnInvoices = true;
        }
        return emailAddressExistsOnInvoices && !!addressExistsOnInvoices;
    }
    get isContactInfoOutdated() {
        const { contactInfoConfirmedTs } = this.componentCustomerContactInfoStore;
        const date = new Date();
        date.setFullYear(date.getFullYear() - 1);
        return !contactInfoConfirmedTs || new Date(contactInfoConfirmedTs) < date;
    }
    formatAddress(address) {
        const houseName = [address.street, address.building].join(' ') + (address.room ? `-${address.room}` : '');
        return [
            (0, StringUtil_1.capitalizeString)(houseName),
            [address.city ? (0, StringUtil_1.capitalizeString)(address.city) : (0, StringUtil_1.capitalizeString)(address.municipality), address.postalCode].join(' '),
            (0, StringUtil_1.capitalizeString)(address.region)
        ].join(', ');
    }
    validateInvoiceAndContactAddressAreEqual(invoiceAddress, contactAddress) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!invoiceAddress) {
            return false;
        }
        return (((_a = contactAddress.city) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = invoiceAddress.city) === null || _b === void 0 ? void 0 : _b.toUpperCase()) &&
            ((_c = contactAddress.municipality) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === ((_d = invoiceAddress.municipality) === null || _d === void 0 ? void 0 : _d.toUpperCase()) &&
            ((_e = contactAddress.region) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === ((_f = invoiceAddress.county) === null || _f === void 0 ? void 0 : _f.toUpperCase()) &&
            contactAddress.postalCode === invoiceAddress.zipCode &&
            ((_g = contactAddress.street) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === ((_h = invoiceAddress.streetName) === null || _h === void 0 ? void 0 : _h.toUpperCase()) &&
            contactAddress.building === invoiceAddress.houseNumber &&
            contactAddress.room === invoiceAddress.apartmentNumber);
    }
}
__decorate([
    mobx_1.observable
], ComponentInformationCheckStore.prototype, "informationCheckAccepted", void 0);
__decorate([
    mobx_1.observable
], ComponentInformationCheckStore.prototype, "isLoading", void 0);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "addressExists", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerCommunicationLanguage", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerPhoneValue", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerPhoneValidated", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerEmailValue", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerEmailValidated", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerAddressFormatted", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "customerAddressValidated", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "amountOfInvoices", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "contactAddressIsMatchingOnInvoicesAndContactInfo", null);
__decorate([
    mobx_1.computed
], ComponentInformationCheckStore.prototype, "isContactInfoOutdated", null);
exports["default"] = ComponentInformationCheckStore;


/***/ }),

/***/ 2921:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const ContentType_1 = __webpack_require__(3114);
class ComponentInvoiceNameStore {
    constructor(rootStore) {
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.ssoStore = rootStore.componentSsoStore;
        this.translateStore = rootStore.componentTranslateStore;
    }
    getRefNumberName(contentType, assignedName, source) {
        const alwaysShowDefaultName = source === 'TBCIS' && contentType === 'MOBILE' && this.ssoStore.isPrivate;
        if (alwaysShowDefaultName) {
            return this.getDefaultInvoiceName(contentType);
        }
        if (assignedName) {
            return assignedName;
        }
        return this.getDefaultInvoiceName(contentType);
    }
    getDefaultInvoiceName(contentType) {
        const translate = this.translateStore.translate;
        switch (contentType) {
            case ContentType_1.ContentType.MOBILE:
                return translate('dataconfirm.invoices.invoiceName.mobileService');
            case ContentType_1.ContentType.BROADBAND:
                if (this.ssoStore.isPrivate) {
                    return translate('dataconfirm.invoices.invoiceName.homeService');
                }
                else {
                    return translate('dataconfirm.invoices.invoiceName.businessService');
                }
            case ContentType_1.ContentType.GOODS:
                return translate('dataconfirm.invoices.invoiceName.product');
            case ContentType_1.ContentType.PERIODIC_INVOICES:
                return translate('dataconfirm.invoices.invoiceName.unified');
            case ContentType_1.ContentType.STATE_FEES:
                return translate('dataconfirm.invoices.invoiceName.stateFees');
            case ContentType_1.ContentType.FINANCE:
                if (this.ssoStore.isPrivate) {
                    return translate('dataconfirm.invoices.invoiceName.financeHome');
                }
                else {
                    return translate('dataconfirm.invoices.invoiceName.financeBusiness');
                }
            case ContentType_1.ContentType.DEBT:
                return translate('dataconfirm.invoices.invoiceName.debt');
            case ContentType_1.ContentType.TELESERVICES:
                return translate('dataconfirm.invoices.invoiceName.teleServices');
            case ContentType_1.ContentType.PENALTY:
                return translate('dataconfirm.invoices.invoiceName.penalty');
            case ContentType_1.ContentType.DAX_REF_NUMBER:
                return translate('dataconfirm.invoices.invoiceName.daxRefNumber');
            case ContentType_1.ContentType.MASTER_REF_NUMBER:
                return translate('dataconfirm.invoices.invoiceName.masterRefNumber');
            default:
                return translate('dataconfirm.invoices.invoiceName.other');
        }
    }
}
exports["default"] = ComponentInvoiceNameStore;


/***/ }),

/***/ 8586:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const InvoiceSettingsAPI_1 = __importDefault(__webpack_require__(9353));
const util_1 = __webpack_require__(8910);
const AddressFormatUtil_1 = __webpack_require__(9318);
class ComponentInvoiceSettingsStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "customerInvoiceSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invoiceSaved", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "saveError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "saving", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "invoiceSettingsAPI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistryAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setInvoice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (invoice) => {
                invoice.isChanged = true;
                const invoiceIndex = this.customerInvoiceSettings.invoiceSettings.findIndex((it) => it.refNumber === invoice.refNumber);
                this.customerInvoiceSettings.invoiceSettings[invoiceIndex] = invoice;
            }
        });
        Object.defineProperty(this, "setLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (loaded) => {
                this.isLoaded = loaded;
            }
        });
        Object.defineProperty(this, "updateAllAddresses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { selectedAddress, newRoom } = this.componentRegistryAddressEditStore;
                for (const invoice of this.customerInvoiceSettings.invoiceSettings.filter((it) => it.invoiceDeliveries.includes('POST'))) {
                    if (invoice.invoiceDeliveries.includes('POST')) {
                        this.updateAddress(invoice, { ...selectedAddress, countryCode: 'EE', selectedRoom: newRoom });
                    }
                }
            }
        });
        Object.defineProperty(this, "updateAllEmails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { email } = this.componentCustomerContactInfoStore;
                const invoicesWithEmail = this.customerInvoiceSettings.invoiceSettings.filter((it) => it.invoiceDeliveries.includes('EMAIL'));
                for (const invoice of invoicesWithEmail) {
                    const emails = [...invoice.emailAddresses];
                    const index = emails.indexOf(email.oldValue);
                    if (index !== -1) {
                        emails[index] = email.value;
                        this.updateEmails(invoice, emails);
                    }
                }
            }
        });
        Object.defineProperty(this, "selectedRegistryAddressToInvoiceAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { selectedAddress, newRoom } = this.componentRegistryAddressEditStore;
                return ComponentInvoiceSettingsStore.convertToInvoiceAddress({ ...selectedAddress, countryCode: 'EE', selectedRoom: newRoom });
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.brand = componentRootStore.brand;
        this.componentSsoStore = componentRootStore.componentSsoStore;
        this.componentRegistryAddressEditStore = componentRootStore.componentRegistryAddressEditStore;
        this.componentContactAddressStore = componentRootStore.componentContactAddressStore;
        this.componentCustomerContactInfoStore = componentRootStore.componentCustomerContactInfoStore;
        this.invoiceSettingsAPI = new InvoiceSettingsAPI_1.default(componentRootStore.urlDataStore.componentsAPIURL);
    }
    init() {
        this.setLoaded(false);
        if (this.componentSsoStore.customerId) {
            return this.invoiceSettingsAPI
                .getCustomerInvoiceSettings(this.componentSsoStore.customerId, this.brand)
                .then((response) => (this.customerInvoiceSettings = response.data))
                .then(() => {
                this.customerInvoiceSettings.invoiceSettings.forEach((invoice) => {
                    invoice.isChanged = false;
                    if (invoice.invoiceDeliveries.includes('POST')) {
                        invoice.address.addressLabel = (0, AddressFormatUtil_1.formatInvoiceAddress)(invoice.address);
                    }
                });
                this.setLoaded(true);
            });
        }
        return Promise.resolve();
    }
    updateAddress(invoice, address) {
        invoice.address = ComponentInvoiceSettingsStore.convertToInvoiceAddress(address);
        invoice.address.addressLabel = (0, AddressFormatUtil_1.formatInvoiceAddress)(invoice.address);
        this.setInvoice(invoice);
    }
    updateEmails(invoice, emails) {
        invoice.emailAddresses = emails;
        this.setInvoice(invoice);
    }
    saveInvoices() {
        this.saveError = false;
        const invoicesToUpdate = this.customerInvoiceSettings.invoiceSettings.filter((invoice) => invoice.isChanged);
        return Promise.all(invoicesToUpdate.map((invoice) => this.invoiceSettingsAPI
            .putCustomerInvoiceSettings(this.componentSsoStore.customerId, invoice.refNumber, this.brand, invoice)
            .catch((0, mobx_1.action)(() => (this.saveError = true)))));
    }
    get showChangeAllPostInvoiceEmailNotice() {
        const { email, isEmailValid } = this.componentCustomerContactInfoStore;
        return (email.oldValue !== email.value &&
            isEmailValid &&
            !!this.customerInvoiceSettings.invoiceSettings.some((it) => it.invoiceDeliveries.includes('EMAIL')) &&
            !!this.customerInvoiceSettings.invoiceSettings.some((it) => it.emailAddresses.includes(email.oldValue)));
    }
    get showChangeAllPostInvoiceAddressesNotice() {
        const { isRegistryAddressSelected } = this.componentContactAddressStore;
        const { hasAddressChanged, selectedAddress } = this.componentRegistryAddressEditStore;
        return (isRegistryAddressSelected &&
            this.componentContactAddressStore.isAddressValid() &&
            hasAddressChanged &&
            selectedAddress !== null &&
            this.customerInvoiceSettings.invoiceSettings.some((it) => it.invoiceDeliveries.includes('POST')) &&
            this.customerInvoiceSettings.invoiceSettings
                .filter((it) => it.invoiceDeliveries.includes('POST'))
                .every((invoice) => this.isInvoiceAddressNotMatchingSelectedAddress(invoice.address)));
    }
    isInvoiceAddressNotMatchingSelectedAddress(invoiceAddress) {
        return invoiceAddress.addressLabel !== (0, AddressFormatUtil_1.formatInvoiceAddress)(this.selectedRegistryAddressToInvoiceAddress());
    }
    get hasInvoices() {
        return this.customerInvoiceSettings && this.customerInvoiceSettings.invoiceSettings && this.customerInvoiceSettings.invoiceSettings.length > 0;
    }
    static convertToRegistryAddress(address) {
        return {
            fallbackLabel: address.addressLabel,
            addressRegistryId: address.addressRegisterId && address.addressRegisterId.toString(),
            buildingRegistryId: address.buildingRegistryId && address.buildingRegistryId.toString(),
            roomRegistryId: address.roomRegistryId && address.roomRegistryId.toString(),
            postalCode: address.zipCode,
            room: address.apartmentNumber
        };
    }
    static convertToInvoiceAddress(address) {
        var _a;
        return {
            addressId: address.id ? Number.parseInt(address.id, 10) : null,
            addressRegisterId: address.id && Number.parseInt(address.id, 10),
            buildingRegistryId: address.buildingId && Number.parseInt(address.buildingId, 10),
            country: util_1.CountryUtil.getByCountryCode(address.countryCode).label.et.toUpperCase(),
            county: address.region,
            city: address.city ? address.city : address.cityCounty,
            municipality: address.municipality ? address.municipality : address.city ? address.city : address.cityCounty,
            streetName: address.street,
            houseNumber: address.house,
            apartmentNumber: (_a = address.selectedRoom) === null || _a === void 0 ? void 0 : _a.roomName,
            zipCode: address.postalCode,
            roomRegistryId: address.selectedRoom && Number.parseInt(address.selectedRoom.roomId, 10),
            selected: true,
            type: address.addressType,
            addressLabel: address.label2
        };
    }
}
__decorate([
    mobx_1.observable
], ComponentInvoiceSettingsStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentInvoiceSettingsStore.prototype, "customerInvoiceSettings", void 0);
__decorate([
    mobx_1.observable
], ComponentInvoiceSettingsStore.prototype, "invoiceSaved", void 0);
__decorate([
    mobx_1.observable
], ComponentInvoiceSettingsStore.prototype, "saveError", void 0);
__decorate([
    mobx_1.observable
], ComponentInvoiceSettingsStore.prototype, "saving", void 0);
__decorate([
    mobx_1.action
], ComponentInvoiceSettingsStore.prototype, "setInvoice", void 0);
__decorate([
    mobx_1.action
], ComponentInvoiceSettingsStore.prototype, "setLoaded", void 0);
__decorate([
    mobx_1.action
], ComponentInvoiceSettingsStore.prototype, "updateAddress", null);
__decorate([
    mobx_1.action
], ComponentInvoiceSettingsStore.prototype, "updateEmails", null);
__decorate([
    mobx_1.action
], ComponentInvoiceSettingsStore.prototype, "updateAllEmails", void 0);
__decorate([
    mobx_1.action
], ComponentInvoiceSettingsStore.prototype, "saveInvoices", null);
__decorate([
    mobx_1.computed
], ComponentInvoiceSettingsStore.prototype, "showChangeAllPostInvoiceEmailNotice", null);
__decorate([
    mobx_1.computed
], ComponentInvoiceSettingsStore.prototype, "showChangeAllPostInvoiceAddressesNotice", null);
__decorate([
    mobx_1.computed
], ComponentInvoiceSettingsStore.prototype, "hasInvoices", null);
exports["default"] = ComponentInvoiceSettingsStore;


/***/ }),

/***/ 811:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const MandateAPI_1 = __importDefault(__webpack_require__(6668));
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class ComponentMandateStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "customerMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateAPI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.componentRootStore = componentRootStore;
        this.componentSsoStore = componentRootStore.componentSsoStore;
        this.mandateAPI = new MandateAPI_1.default(componentRootStore.urlDataStore.componentsAPIURL);
    }
    async hasCustomerMandate(mandates) {
        const { urlDataStore } = this.componentRootStore;
        const response = await ApiUtil_1.default.get(urlDataStore.componentsAPIURL.concat(ComponentMandateStore.CUSTOMER_MANDATES), {
            params: { mandates, stipulationAllowed: true }
        });
        return response.data;
    }
    async initCustomerMandates() {
        if (!!this.componentSsoStore.customerId) {
            await this.mandateAPI
                .getCustomerMandates()
                .then((0, mobx_1.action)((response) => {
                this.customerMandates = response.data.customerMandates;
            }))
                .catch((error) => {
                console.error(error);
            });
        }
    }
    get stipulationForSsoPerson() {
        return (!!this.customerMandates &&
            this.customerMandates.find((cm) => this.componentSsoStore.isSamePerson(cm.person.personalCode)).mandates[0].representationStipulation);
    }
}
Object.defineProperty(ComponentMandateStore, "CUSTOMER_MANDATES", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: '/mandate/has-any-mandate'
});
__decorate([
    mobx_1.observable
], ComponentMandateStore.prototype, "customerMandates", void 0);
__decorate([
    mobx_1.computed
], ComponentMandateStore.prototype, "stipulationForSsoPerson", null);
exports["default"] = ComponentMandateStore;


/***/ }),

/***/ 6638:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class ComponentRegistrationStore {
    constructor(rootStore) {
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentMandatesStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.componentCreditInfoStore = rootStore.componentCreditInfoStore;
        this.componentContractStore = rootStore.componentContractStore;
        this.componentSsoStore = rootStore.componentSsoStore;
        this.componentMandatesStore = rootStore.componentMandateStore;
    }
    isEntityToRegisterChosen() {
        return this.componentCreditInfoStore.entityToRegister !== null;
    }
    hasRepresentationStipulationForCustomer() {
        return !!this.componentMandatesStore.stipulationForSsoPerson;
    }
    get hasRepresentationStipulationForEntityToRegister() {
        return !!this.componentCreditInfoStore.getSsoPersonRepresentationStipulationForEntityToRegister;
    }
    get hasRepresentationStipulation() {
        return this.hasRepresentationStipulationForEntityToRegister || this.hasRepresentationStipulationForCustomer();
    }
    get getRepresentationStipulation() {
        if (this.hasRepresentationStipulationForEntityToRegister) {
            return this.componentCreditInfoStore.getSsoPersonRepresentationStipulationForEntityToRegister;
        }
        else if (this.hasRepresentationStipulationForCustomer()) {
            return this.componentMandatesStore.stipulationForSsoPerson;
        }
        return null;
    }
    get hasSignedContract() {
        return this.componentContractStore.isLoaded && this.componentContractStore.hasSignedContract;
    }
    get hasRegistrableLegalEntities() {
        return this.componentCreditInfoStore.isLoaded && this.componentCreditInfoStore.hasRegistrableEntities;
    }
}
exports["default"] = ComponentRegistrationStore;


/***/ }),

/***/ 5929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentRootStoreContext = void 0;
const react_1 = __webpack_require__(8156);
const ComponentAddressSuggestionStore_1 = __importDefault(__webpack_require__(4803));
const ComponentContactAddressStore_1 = __importDefault(__webpack_require__(2748));
const ComponentForeignAddressEditStore_1 = __importDefault(__webpack_require__(1334));
const ComponentRegistryAddressEditStore_1 = __importDefault(__webpack_require__(1899));
const ComponentContractStore_1 = __importDefault(__webpack_require__(1467));
const ComponentContractValidatorStore_1 = __importDefault(__webpack_require__(4334));
const ComponentCreditInfoStore_1 = __importDefault(__webpack_require__(2880));
const ComponentCustomerContactInfoStore_1 = __importDefault(__webpack_require__(5104));
const ComponentEmployeeSignatureStore_1 = __importDefault(__webpack_require__(961));
const ComponentInformationCheckStore_1 = __importDefault(__webpack_require__(3047));
const ComponentInvoiceNameStore_1 = __importDefault(__webpack_require__(2921));
const ComponentInvoiceSettingsStore_1 = __importDefault(__webpack_require__(8586));
const ComponentMandateStore_1 = __importDefault(__webpack_require__(811));
const ComponentRegistrationStore_1 = __importDefault(__webpack_require__(6638));
const ComponentSignerStore_1 = __importDefault(__webpack_require__(6055));
const ComponentSsoStore_1 = __importDefault(__webpack_require__(8146));
const ComponentTranslateStore_1 = __importDefault(__webpack_require__(9371));
const ComponentURLDataStore_1 = __importDefault(__webpack_require__(614));
const ComponentContactInfoValidationStore_1 = __importDefault(__webpack_require__(3287));
exports.ComponentRootStoreContext = (0, react_1.createContext)(null);
class ComponentRootStore {
    constructor(environment, frontLibrary, brand, disableSsoClientTabSync = false, disableSso = false) {
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "frontLibrary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractValidatorStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentAddressSuggestionStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistryAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentForeignAddressEditStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentTranslateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCustomerContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContractStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRegistrationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSignerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceSettingsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInvoiceNameStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentInformationCheckStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentEmployeeSignatureStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactInfoValidationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environment = environment;
        this.frontLibrary = frontLibrary;
        this.brand = brand;
        this.urlDataStore = new ComponentURLDataStore_1.default(environment);
        this.componentSsoStore = new ComponentSsoStore_1.default(this, disableSsoClientTabSync, disableSso);
        this.componentMandateStore = new ComponentMandateStore_1.default(this);
        this.contractValidatorStore = new ComponentContractValidatorStore_1.default(this);
        this.componentTranslateStore = new ComponentTranslateStore_1.default();
        this.componentCreditInfoStore = new ComponentCreditInfoStore_1.default(this);
        this.componentSignerStore = new ComponentSignerStore_1.default(this);
        this.componentContractStore = new ComponentContractStore_1.default(this);
        this.componentCustomerContactInfoStore = new ComponentCustomerContactInfoStore_1.default(this);
        this.componentRegistrationStore = new ComponentRegistrationStore_1.default(this);
        this.componentAddressSuggestionStore = new ComponentAddressSuggestionStore_1.default(this);
        this.componentContactAddressStore = new ComponentContactAddressStore_1.default(this);
        this.componentRegistryAddressEditStore = new ComponentRegistryAddressEditStore_1.default(this);
        this.componentForeignAddressEditStore = new ComponentForeignAddressEditStore_1.default(this);
        this.componentInvoiceSettingsStore = new ComponentInvoiceSettingsStore_1.default(this);
        this.componentInvoiceNameStore = new ComponentInvoiceNameStore_1.default(this);
        this.componentInformationCheckStore = new ComponentInformationCheckStore_1.default(this);
        this.componentEmployeeSignatureStore = new ComponentEmployeeSignatureStore_1.default(this);
        this.componentContactInfoValidationStore = new ComponentContactInfoValidationStore_1.default();
    }
}
exports["default"] = ComponentRootStore;


/***/ }),

/***/ 6055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const typings_1 = __webpack_require__(929);
class ComponentSignerStore {
    constructor(rootStore) {
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "signers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initSigners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                if (this.componentSsoStore.isBusiness) {
                    if (!!this.componentSsoStore.customerId) {
                        await this.initSignersBasedOnCustomer();
                    }
                    else {
                        await this.initSignersBasedOnEntityToRegister();
                    }
                }
                if ((!this.signers || this.signers.length === 0) && this.componentSsoStore.person) {
                    this.signers = [this.getSignerFromMandate(this.componentSsoStore.person)];
                }
                this.isLoaded = true;
            }
        });
        Object.defineProperty(this, "getSignerFromMandate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (mandate) => {
                const signer = new typings_1.Signer();
                signer.firstName = mandate.firstName;
                signer.lastName = mandate.lastName;
                signer.personalCode = mandate.personalCode;
                signer.personalCodeCountryCode = mandate.personalCodeCountryCode;
                signer.selected = this.componentSsoStore.isSamePerson(mandate.personalCode);
                return signer;
            }
        });
        Object.defineProperty(this, "getSelectedSigners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.signers
                .filter((signer) => signer.selected)
                .map((signer) => {
                return {
                    firstName: signer.firstName,
                    lastName: signer.lastName,
                    personalCode: signer.personalCode,
                    personalCodeCountryCode: signer.personalCodeCountryCode
                };
            })
        });
        (0, mobx_1.makeObservable)(this);
        this.componentSsoStore = rootStore.componentSsoStore;
        this.componentMandateStore = rootStore.componentMandateStore;
        this.componentCreditInfoStore = rootStore.componentCreditInfoStore;
    }
    async initSignersBasedOnEntityToRegister() {
        if (!this.componentCreditInfoStore.entityToRegister) {
            await this.componentCreditInfoStore.getAndSetEntityToRegister(this.componentSsoStore.customerRegistrationNumber);
        }
        const entityToRegister = this.componentCreditInfoStore.entityToRegister;
        if (entityToRegister && entityToRegister.personRelations && entityToRegister.personRelations.length > 0) {
            this.signers = entityToRegister.personRelations.map((relation) => this.getSignerFromMandate(relation.person));
            this.signers = this.signers && this.signers.filter((v, i, a) => a.findIndex((t) => t.personalCode === v.personalCode) === i);
        }
    }
    async initSignersBasedOnCustomer() {
        if (!this.componentMandateStore.customerMandates) {
            await this.componentMandateStore.initCustomerMandates();
        }
        const mandates = this.componentMandateStore.customerMandates;
        this.signers = mandates && mandates.map((mandate) => this.getSignerFromMandate(mandate.person));
    }
}
__decorate([
    mobx_1.observable
], ComponentSignerStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentSignerStore.prototype, "signers", void 0);
__decorate([
    mobx_1.action
], ComponentSignerStore.prototype, "initSigners", void 0);
exports["default"] = ComponentSignerStore;


/***/ }),

/***/ 8146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const telia_sso_client_1 = __importDefault(__webpack_require__(5157));
const util_1 = __webpack_require__(8910);
class ComponentSsoStore {
    constructor(componentRootStore, disableTabSync = false, disableSso = false) {
        Object.defineProperty(this, "auth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hardAuthRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "isLoggingOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isMandateSelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loginCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clientState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handleLogout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.isLoggingOut = true;
                this.clientState = null;
                this.auth = null;
                this.loginCallback = null;
            }
        });
        Object.defineProperty(this, "handleLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ssoResult) => {
                this.clientState = ssoResult;
                this.auth = ssoResult.auth;
                if (this.loginCallback && typeof this.loginCallback === 'function') {
                    this.loginCallback();
                    this.loginCallback = null;
                }
            }
        });
        Object.defineProperty(this, "updateSessionByCustomerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (customerId) => {
                this.ssoClient.updateRepresentativeByCustomerId(customerId);
            }
        });
        Object.defineProperty(this, "onLoginWithCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.setParameters(callback);
            }
        });
        Object.defineProperty(this, "setParameters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (loginCallback) => {
                this.loginCallback = loginCallback;
            }
        });
        Object.defineProperty(this, "isSamePerson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (personalCode) => {
                return this.personRegistrationNumber === personalCode;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentRootStore = componentRootStore;
        this.initializeAuthentication(disableTabSync, disableSso);
    }
    initializeAuthentication(disableTabSync, disableSso) {
        if (disableSso) {
            return;
        }
        this.ssoClient = telia_sso_client_1.default.connect({
            onLogout: this.handleLogout,
            onLogin: this.handleLogin,
            disableTabSync
        }, { authLevel: 2 });
        this.ssoClient.loadInitialState();
    }
    get customerId() {
        return !!this.auth && !!this.auth.customer && this.auth.customer.customerId;
    }
    get customerRegistrationNumber() {
        return this.customer && this.auth.customer.registrationNumber;
    }
    get personRegistrationNumber() {
        return this.auth.person && this.auth.person.personalCode;
    }
    get person() {
        return this.auth && this.auth.person;
    }
    get loggedIn() {
        return !!this.auth && !!this.auth.person;
    }
    get dealer() {
        return this.auth && this.auth.dealer;
    }
    get customer() {
        return this.auth && this.auth.customer;
    }
    get loggedInWithHardAuth() {
        return this.loggedIn && this.auth.authLevel > 1;
    }
    get isSsoLoaded() {
        return !!this.ssoClientState;
    }
    get ssoClientState() {
        return (0, mobx_1.toJS)(this.clientState);
    }
    get isPrivate() {
        return this.customer && this.customer.type === 'B2C';
    }
    get isBusiness() {
        return this.customer && this.customer.type === 'B2B';
    }
    get isRepresentingSelf() {
        return (this.person &&
            this.customer &&
            this.person.personalCode === this.customer.registrationNumber &&
            this.person.personalCodeCountryCode === this.customer.registrationNumberCountryCode);
    }
    isUnderage() {
        if (this.person.personalCodeCountryCode === 'EE') {
            return (0, util_1.isUnderage)(this.person.personalCode);
        }
        return false;
    }
}
__decorate([
    mobx_1.observable
], ComponentSsoStore.prototype, "auth", void 0);
__decorate([
    mobx_1.observable
], ComponentSsoStore.prototype, "hardAuthRequired", void 0);
__decorate([
    mobx_1.observable
], ComponentSsoStore.prototype, "isLoggingOut", void 0);
__decorate([
    mobx_1.observable
], ComponentSsoStore.prototype, "isMandateSelect", void 0);
__decorate([
    mobx_1.observable
], ComponentSsoStore.prototype, "loginCallback", void 0);
__decorate([
    mobx_1.observable
], ComponentSsoStore.prototype, "clientState", void 0);
__decorate([
    mobx_1.action
], ComponentSsoStore.prototype, "handleLogout", void 0);
__decorate([
    mobx_1.action
], ComponentSsoStore.prototype, "handleLogin", void 0);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "customerId", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "customerRegistrationNumber", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "personRegistrationNumber", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "person", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "loggedIn", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "dealer", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "customer", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "loggedInWithHardAuth", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "isSsoLoaded", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "isPrivate", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "isBusiness", null);
__decorate([
    mobx_1.computed
], ComponentSsoStore.prototype, "isRepresentingSelf", null);
__decorate([
    mobx_1.action
], ComponentSsoStore.prototype, "onLoginWithCallback", void 0);
__decorate([
    mobx_1.action
], ComponentSsoStore.prototype, "setParameters", void 0);
exports["default"] = ComponentSsoStore;


/***/ }),

/***/ 9371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const ParamsUtil_1 = __webpack_require__(8685);
const TranslationApi_1 = __importDefault(__webpack_require__(7409));
const components_1 = __webpack_require__(2740);
class ComponentTranslateStore {
    constructor() {
        Object.defineProperty(this, "translations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "defaultTranslateAppName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'crmcomponents'
        });
        Object.defineProperty(this, "globalTranslateAppName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'global'
        });
        Object.defineProperty(this, "translate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, paramObject) => this.getTranslationForGroup(this.defaultTranslateAppName, key, paramObject)
        });
        Object.defineProperty(this, "translateGlobal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, paramObject) => this.getTranslationForGroup(this.globalTranslateAppName, key, paramObject)
        });
        Object.defineProperty(this, "translateHtml", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, paramObject) => ({ __html: this.translate(key, paramObject) })
        });
        Object.defineProperty(this, "getTranslationForGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (group, key, paramObject) => {
                const groupTranslations = this.translations[group];
                let textValue;
                if (groupTranslations) {
                    textValue = groupTranslations[key];
                }
                if (textValue) {
                    if (paramObject) {
                        return (0, ParamsUtil_1.parseParams)(textValue, paramObject);
                    }
                    return textValue;
                }
                return `${group}:${key}`;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.fetchTranslations((0, components_1.getCurrentLanguage)());
    }
    fetchTranslations(lang) {
        TranslationApi_1.default.getTranslations(lang).then(({ data: { translations } }) => this.setTranslations(translations));
    }
    setTranslations(translations) {
        this.translations = translations;
    }
    get globalTranslations() {
        return this.translations[this.globalTranslateAppName];
    }
}
__decorate([
    mobx_1.observable
], ComponentTranslateStore.prototype, "translations", void 0);
__decorate([
    mobx_1.action
], ComponentTranslateStore.prototype, "setTranslations", null);
__decorate([
    mobx_1.computed
], ComponentTranslateStore.prototype, "globalTranslations", null);
exports["default"] = ComponentTranslateStore;


/***/ }),

/***/ 614:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const EnvironmentPropertiesFactory_1 = __importDefault(__webpack_require__(9645));
const Config_1 = __importDefault(__webpack_require__(5269));
class ComponentURLDataStore {
    constructor(environment) {
        Object.defineProperty(this, "redirectUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environment = new EnvironmentPropertiesFactory_1.default(environment).getEnvironment();
        Config_1.default.init(this);
    }
    get ssoBackendURL() {
        return this.environment.ssoBackendURL;
    }
    get componentsAPIURL() {
        const hostname = window.location.hostname;
        let selfServiceURL = this.environment.teliaSelfServiceURL;
        if (hostname.includes('diil.ee')) {
            selfServiceURL = this.environment.diilSelfServiceURL;
        }
        return selfServiceURL.concat('/crm-components-api');
    }
    get generalTermsUrl() {
        const locale = ComponentURLDataStore.getLocaleFromPath();
        if (locale === 'ru') {
            return this.environment.rusGeneralTermsURL;
        }
        return this.environment.estGeneralTermsURL;
    }
    get goToShopUrl() {
        const locale = ComponentURLDataStore.getLocaleFromPath();
        if (locale === 'ru') {
            return this.environment.rusGoToShopUrl;
        }
        return this.environment.estGoToShopUrl;
    }
    get getPathWithoutLocale() {
        const path = ComponentURLDataStore.getPath();
        if ((path.startsWith('/et') || path.startsWith('/ru') || path.startsWith('/en')) && path[3] === '/') {
            return path.substring(3);
        }
        else {
            return path;
        }
    }
    static getLocaleFromPath() {
        const path = ComponentURLDataStore.getPath();
        if (path.startsWith('/et') || path.startsWith('/ru') || path.startsWith('/en')) {
            return path.substring(1, 3);
        }
        else {
            return 'et';
        }
    }
    isCurrentPath(redirectLink) {
        return redirectLink === this.getPathWithoutLocale;
    }
    static getPath() {
        return window.location.pathname;
    }
}
exports["default"] = ComponentURLDataStore;
Object.defineProperty(ComponentURLDataStore, "hasCurrentHost", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (url) => {
        return url.startsWith(`${window.location.protocol}//${window.location.host}`);
    }
});
Object.defineProperty(ComponentURLDataStore, "getPreviousURL", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: () => document.referrer
});
Object.defineProperty(ComponentURLDataStore, "redirectToPreviousUrl", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: () => {
        document.location.href = ComponentURLDataStore.getPreviousURL();
    }
});


/***/ }),

/***/ 4584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const throttle_debounce_1 = __webpack_require__(2189);
const RegistryAddressAPI_1 = __importDefault(__webpack_require__(4918));
const util_1 = __webpack_require__(8910);
class ComponentAddressStore {
    constructor() {
        Object.defineProperty(this, "registryAddressLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryRoomLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "registryAddressAutocompleteItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryRoomAutocompleteItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddressSearchTerm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddressSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "selectedRegistryAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectedForeignAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_selectedCountry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registryAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "foreignAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "debounceActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "debounceDelay", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 350
        });
        Object.defineProperty(this, "registryAddressConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetchRegistryAddressSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const addressItems = [];
                const setRegistryAddressSuggestions = (values) => {
                    this.registryAddressSuggestions = values.map((value) => {
                        return { ...value, countryCode: 'EE' };
                    });
                    values.forEach((value) => {
                        const address = { id: value.id, label: value.label2, subLabel: value.buildingType };
                        const rooms = value.rooms.map((room) => {
                            return { id: room.roomId, label: room.roomName };
                        });
                        addressItems.push({ ...address, rooms });
                    });
                };
                const setRegistryAddressAutocompleteItems = () => this.registryAddressAutocompleteItems.replace(addressItems);
                return RegistryAddressAPI_1.default.getRegistryAddressSuggestions(this.registryAddressSearchTerm || this.registryAddressLabel)
                    .then(setRegistryAddressSuggestions)
                    .then((0, mobx_1.action)(setRegistryAddressAutocompleteItems))
                    .then(() => (this.debounceActive = false));
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    init(registryAddress, foreignAddress, registryAddressConfig) {
        this.registryAddress = registryAddress;
        this.foreignAddress = foreignAddress;
        this.registryAddressConfig = registryAddressConfig;
        this.setConfigDefaultValues();
        this.registryAddressAutocompleteItems = mobx_1.observable.array([]);
        this.registryRoomAutocompleteItems = mobx_1.observable.array([]);
        (0, mobx_1.runInAction)(() => {
            this.isLoading = true;
            this.registryAddressLabel = '';
            this.registryRoomLabel = '';
            this.registryAddressSearchTerm = '';
        });
        this.initializeAddresses().then((0, mobx_1.action)(() => (this.isLoading = false)));
    }
    initializeAddresses() {
        this.selectedRegistryAddress = { countryCode: 'EE' };
        this.selectedForeignAddress = { countryCode: 'OTHER' };
        if (this.registryAddress) {
            this.selectedCountryCode = 'EE';
            const { addressRegistryId, buildingRegistryId, roomRegistryId, fallbackLabel } = this.registryAddress;
            const requestId = addressRegistryId || buildingRegistryId || roomRegistryId;
            if (requestId) {
                const requestType = addressRegistryId ? 'ADDRESS' : buildingRegistryId ? 'BUILDING' : roomRegistryId ? 'ROOM' : null;
                let selectedRegistryAddressId;
                const setRegistryAddressLabel = (value) => {
                    this.registryAddressLabel = value.label2 || '';
                    selectedRegistryAddressId = value.id;
                };
                const setSelectedRegistryAddressSuggestion = () => {
                    if (this.registryAddressAutocompleteItems.length > 0) {
                        this.selectedAddressId = this.registryAddressAutocompleteItems.find((adr) => adr.id.toString() === selectedRegistryAddressId.toString()).id;
                    }
                };
                const setSelectedRegistryRoomLabel = () => {
                    this.registryRoomLabel = this.registryAddress.room;
                    if (this.registryRoomAutocompleteItems.length > 0 && this.registryAddress.roomRegistryId) {
                        this.selectedRoomId = this.registryRoomAutocompleteItems.find((room) => room.id.toString() === this.registryAddress.roomRegistryId.toString()).id;
                    }
                };
                return RegistryAddressAPI_1.default.getRegistryAddress(requestId, requestType)
                    .then((0, mobx_1.action)(setRegistryAddressLabel))
                    .then(this.fetchRegistryAddressSuggestions)
                    .then((0, mobx_1.action)(setSelectedRegistryAddressSuggestion))
                    .then((0, mobx_1.action)(setSelectedRegistryRoomLabel));
            }
            else if (fallbackLabel) {
                this.registryAddressLabel = fallbackLabel;
                this.registryRoomLabel = this.registryAddress.room;
                const assumeFirstSuggestionIsSelectedIfNeeded = () => {
                    const autoselectFirstMatch = this.registryAddressConfig.autoselectFirstMatchOnInitialLoad && this.registryAddressAutocompleteItems.length > 0;
                    if (autoselectFirstMatch) {
                        this.selectedAddressId = this.registryAddressAutocompleteItems[0].id;
                    }
                };
                return this.fetchRegistryAddressSuggestions().then((0, mobx_1.action)(assumeFirstSuggestionIsSelectedIfNeeded));
            }
        }
        if (this.foreignAddress && Object.keys((0, mobx_1.toJS)(this.foreignAddress)).length !== 0) {
            this.selectedCountryCode = this.foreignAddress.countryCode;
            this.selectedForeignAddress = { ...this.foreignAddress, countryCode: this.selectedCountry.value };
        }
        return Promise.resolve();
    }
    setConfigDefaultValues() {
        const getOrDefault = (existingValue, defaultValue) => (existingValue !== undefined ? existingValue : defaultValue);
        if (!this.registryAddressConfig) {
            this.registryAddressConfig = {};
        }
        const { autoselectFirstMatchOnInitialLoad } = this.registryAddressConfig;
        this.registryAddressConfig.autoselectFirstMatchOnInitialLoad = getOrDefault(autoselectFirstMatchOnInitialLoad, true);
    }
    set addressSearchTerm(value) {
        this.registryAddressSearchTerm = value;
        (0, mobx_1.runInAction)(() => {
            this.registryRoomAutocompleteItems.clear();
        });
        if (value && !this.debounceActive) {
            this.debounceActive = true;
            (0, throttle_debounce_1.debounce)(this.debounceDelay, this.fetchRegistryAddressSuggestions)();
        }
    }
    set selectedAddressId(id) {
        (0, mobx_1.runInAction)(() => {
            this.registryAddressAutocompleteItems.forEach((address) => (address.isSelected = address.id === id));
            const rooms = this.registryAddressAutocompleteItems.find((adr) => adr.id === id).rooms;
            if (rooms.length > 0) {
                this.registryRoomAutocompleteItems.replace(rooms);
            }
        });
        const foundAddress = this.registryAddressSuggestions.find((adr) => adr.id === id);
        this.selectedRegistryAddress = foundAddress;
        this.registryAddressLabel = foundAddress.label2;
        this.selectedRegistryAddress.addressRegistryId = foundAddress.id;
        this.selectedRegistryAddress.buildingRegistryId = foundAddress.buildingId;
        this.selectedRegistryAddress.selectedRoom = undefined;
    }
    set selectedRoomId(id) {
        (0, mobx_1.runInAction)(() => {
            this.registryRoomAutocompleteItems.forEach((room) => (room.isSelected = room.id === id));
        });
        const foundRoom = this.selectedRegistryAddress.rooms.find((room) => room.roomId === id);
        this.selectedRegistryAddress.selectedRoom = foundRoom;
        this.registryRoomLabel = foundRoom === null || foundRoom === void 0 ? void 0 : foundRoom.roomName;
        this.selectedRegistryAddress.roomRegistryId = foundRoom.roomId;
    }
    get selectedAddress() {
        return this.selectedCountryIsEstonia ? this.selectedRegistryAddress : this.selectedForeignAddress;
    }
    set selectedCountryCode(code) {
        this.selectedCountry = util_1.CountryUtil.getByCountryCode(code);
    }
    set selectedCountry(country) {
        (0, mobx_1.runInAction)(() => {
            this._selectedCountry = country;
            if (this.selectedCountry && this.selectedCountry.value) {
                this.selectedAddress.countryCode = this.selectedCountry.value;
            }
        });
    }
    get selectedCountry() {
        return this._selectedCountry;
    }
    get selectedCountryIsEstonia() {
        if (this.selectedCountry.value) {
            return this.selectedCountry.value === util_1.CountryUtil.getByCountryCode('EE').value;
        }
        return false;
    }
    setForeignAddressFieldValue(field, value) {
        this.selectedForeignAddress[field] = value;
    }
    get noAddress() {
        const noRegistryAddress = !this.registryAddress || Object.keys((0, mobx_1.toJS)(this.registryAddress)).length === 0;
        const noForeignAddress = !this.foreignAddress || Object.keys((0, mobx_1.toJS)(this.foreignAddress)).length === 0;
        return noRegistryAddress && noForeignAddress;
    }
}
__decorate([
    mobx_1.observable
], ComponentAddressStore.prototype, "isLoading", void 0);
__decorate([
    mobx_1.observable
], ComponentAddressStore.prototype, "_selectedCountry", void 0);
__decorate([
    mobx_1.action
], ComponentAddressStore.prototype, "initializeAddresses", null);
__decorate([
    mobx_1.computed
], ComponentAddressStore.prototype, "selectedAddress", null);
__decorate([
    mobx_1.computed
], ComponentAddressStore.prototype, "selectedCountry", null);
__decorate([
    mobx_1.computed
], ComponentAddressStore.prototype, "selectedCountryIsEstonia", null);
__decorate([
    mobx_1.computed
], ComponentAddressStore.prototype, "noAddress", null);
exports["default"] = ComponentAddressStore;


/***/ }),

/***/ 4803:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const ApiUtil_1 = __importStar(__webpack_require__(2965));
class ComponentAddressSuggestionStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "urlDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.componentRootStore = componentRootStore;
        this.urlDataStore = componentRootStore.urlDataStore;
    }
    static resolveAddressType(address) {
        if (address.addressRegistryId) {
            return 'ADDRESS';
        }
        else if (address.buildingRegistryId) {
            return 'BUILDING';
        }
        return 'ROOM';
    }
    fetchAddressResult(queryString) {
        if (!queryString) {
            return Promise.resolve([]);
        }
        return ApiUtil_1.default.get(this.urlDataStore.componentsAPIURL.concat('/address/suggest'), {
            params: { term: queryString },
            timeout: ApiUtil_1.API_CONF.timeout
        })
            .then((response) => response.data)
            .catch(() => {
            return [];
        });
    }
    getAddressById(addressId) {
        return ApiUtil_1.default.get(this.urlDataStore.componentsAPIURL.concat(`/address/${addressId}`), { timeout: ApiUtil_1.API_CONF.timeout })
            .then((result) => result.data)
            .catch(() => {
            return null;
        });
    }
    getAddressFromContactAddress(address) {
        const addressId = address.addressRegistryId || address.buildingRegistryId || address.roomRegistryId;
        const type = ComponentAddressSuggestionStore.resolveAddressType(address);
        return ApiUtil_1.default.get(this.urlDataStore.componentsAPIURL.concat(`/address/${addressId}`), {
            params: { type },
            timeout: ApiUtil_1.API_CONF.timeout
        })
            .then((result) => result.data)
            .catch(() => {
            return null;
        });
    }
}
exports["default"] = ComponentAddressSuggestionStore;


/***/ }),

/***/ 2748:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const util_1 = __webpack_require__(8910);
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class ComponentContactAddressStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "countrySelected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "contactAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "customerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "isErrorDuringSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentCreditInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "PERSON_ENDPOINT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person/contact-address'
        });
        Object.defineProperty(this, "LEGAL_ENTITY_ENDPOINT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/legal-entity/contact-address'
        });
        Object.defineProperty(this, "onSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                const addresses = response.data;
                if (!addresses.length) {
                    this.status = 'FETCHED';
                    return;
                }
                this.contactAddress = addresses[0];
                this.setInitialCountrySelected();
                this.status = 'FETCHED';
            }
        });
        Object.defineProperty(this, "onError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.contactAddress = null;
                this.status = 'ERROR';
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentRootStore = componentRootStore;
        this.ssoStore = componentRootStore.componentSsoStore;
        this.componentCreditInfoStore = componentRootStore.componentCreditInfoStore;
    }
    async init() {
        this.isLoaded = false;
        this.contactAddress = null;
        if (this.status !== 'FETCHING') {
            this.status = 'FETCHING';
            await this.loadAddress();
        }
        if (!this.hasAddress) {
            this.componentRootStore.componentForeignAddressEditStore.reset();
            this.componentRootStore.componentRegistryAddressEditStore.reset();
            this.onLoaded();
            return;
        }
        if (this.isEstonianAddress) {
            this.componentRootStore.componentForeignAddressEditStore.reset();
            await this.componentRootStore.componentRegistryAddressEditStore.init();
        }
        else {
            this.componentRootStore.componentRegistryAddressEditStore.reset();
            await this.componentRootStore.componentForeignAddressEditStore.init();
        }
        this.onLoaded();
    }
    async saveAddress() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        this.isErrorDuringSave = false;
        if (this.isRegistryAddressSelected && (this.isAddressDirty || !componentRegistryAddressEditStore.addressValidated)) {
            await componentRegistryAddressEditStore.saveAddress().then((0, mobx_1.action)((success) => (this.isErrorDuringSave = !success)));
        }
        else if (!this.isRegistryAddressSelected && this.isAddressDirty) {
            await componentForeignAddressEditStore.saveAddress().then((0, mobx_1.action)((success) => (this.isErrorDuringSave = !success)));
        }
    }
    async reloadAddress() {
        await this.fetchAddress();
    }
    get addressId() {
        return this.contactAddress && this.contactAddress.id;
    }
    get isAddressDirty() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        return this.isRegistryAddressSelected ? componentRegistryAddressEditStore.isAddressDirty : componentForeignAddressEditStore.isAddressDirty;
    }
    get isRegistryAddressSelected() {
        return (this.countrySelected && util_1.CountryUtil.isEstonia(this.countrySelected.value)) || !this.countrySelected;
    }
    get hasCountrySelected() {
        return this.countrySelected !== null;
    }
    get hasAddress() {
        return this.contactAddress && this.contactAddress.prime;
    }
    setIsAddressDirtyFalse() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        this.isRegistryAddressSelected ? componentRegistryAddressEditStore.setIsAddressDirtyFalse() : componentForeignAddressEditStore.setIsAddressDirtyFalse();
    }
    setIsAddressDirtyTrue() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        this.isRegistryAddressSelected ? componentRegistryAddressEditStore.setIsAddressDirtyTrue() : componentForeignAddressEditStore.setIsAddressDirtyTrue();
    }
    hasAddressChanged() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        return this.isRegistryAddressSelected ? componentRegistryAddressEditStore.isAddressDirty : componentForeignAddressEditStore.isAddressDirty;
    }
    getAddress() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        return this.isRegistryAddressSelected ? componentRegistryAddressEditStore.getAddress() : componentForeignAddressEditStore.getAddress();
    }
    isAddressValid() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        return this.isRegistryAddressSelected ? !componentRegistryAddressEditStore.addressError : !componentForeignAddressEditStore.addressError;
    }
    getCountryCode() {
        if (!this.hasAddress) {
            return 'EE';
        }
        return this.getContactAddress.countryCode;
    }
    onLoaded() {
        this.isLoaded = true;
    }
    async loadAddress() {
        const { customer } = this.ssoStore;
        const { entityToRegister } = this.componentCreditInfoStore;
        if (!customer ||
            (entityToRegister &&
                (entityToRegister.registrationNumber !== customer.registrationNumber ||
                    entityToRegister.registrationNumberCountryCode !== customer.registrationNumberCountryCode))) {
            this.status = 'FETCHED';
            return Promise.resolve();
        }
        this.customerId = this.ssoStore.customerId;
        return this.fetchAddress();
    }
    setInitialCountrySelected() {
        const country = util_1.CountryUtil.getByCountryCode(this.getCountryCode());
        this.countrySelected = {
            value: country.value,
            label: this.isEstonianAddress ? country.label.et : country.label.ru
        };
    }
    async fetchAddress() {
        this.status = 'FETCHING';
        const baseUrl = this.componentRootStore.urlDataStore.componentsAPIURL;
        const isPerson = this.componentRootStore.componentSsoStore.isPrivate;
        const fullUrl = baseUrl.concat(`${isPerson ? this.PERSON_ENDPOINT : this.LEGAL_ENTITY_ENDPOINT}`).concat('?include-unvalidated=true');
        return ApiUtil_1.default.get(fullUrl).then(this.onSuccess).catch(this.onError);
    }
    get getContactAddress() {
        return this.contactAddress && this.contactAddress.address;
    }
    get isEstonianAddress() {
        return util_1.CountryUtil.isEstonia(this.getContactAddress.countryCode);
    }
    setAddressChanged() {
        const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
        this.isRegistryAddressSelected ? componentRegistryAddressEditStore.setAddressChanged() : componentForeignAddressEditStore.setAddressChanged();
    }
}
__decorate([
    mobx_1.observable
], ComponentContactAddressStore.prototype, "countrySelected", void 0);
__decorate([
    mobx_1.observable
], ComponentContactAddressStore.prototype, "contactAddress", void 0);
__decorate([
    mobx_1.observable
], ComponentContactAddressStore.prototype, "isLoaded", void 0);
__decorate([
    mobx_1.observable
], ComponentContactAddressStore.prototype, "customerId", void 0);
__decorate([
    mobx_1.observable
], ComponentContactAddressStore.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], ComponentContactAddressStore.prototype, "isErrorDuringSave", void 0);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "saveAddress", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "reloadAddress", null);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "addressId", null);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "isAddressDirty", null);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "isRegistryAddressSelected", null);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "hasCountrySelected", null);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "hasAddress", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "onLoaded", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "loadAddress", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "setInitialCountrySelected", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "fetchAddress", null);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action
], ComponentContactAddressStore.prototype, "onError", void 0);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "getContactAddress", null);
__decorate([
    mobx_1.computed
], ComponentContactAddressStore.prototype, "isEstonianAddress", null);
exports["default"] = ComponentContactAddressStore;


/***/ }),

/***/ 1334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class ComponentForeignAddressEditStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "initialForeignAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                id: null,
                countryCode: undefined,
                region: undefined,
                city: undefined,
                building: undefined,
                street: undefined,
                room: undefined,
                postalCode: undefined
            }
        });
        Object.defineProperty(this, "newForeignAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { ...this.initialForeignAddress }
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "isAddressDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "PERSON_ENDPOINT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person/contact-address/foreign-address'
        });
        Object.defineProperty(this, "LEGAL_ENTITY_ENDPOINT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/legal-entity/contact-address/foreign-address'
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.status = 'ERROR';
            }
        });
        Object.defineProperty(this, "handleSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.status = 'FETCHED';
                this.componentContactAddressStore.reloadAddress();
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentRootStore = componentRootStore;
        this.componentContactAddressStore = componentRootStore.componentContactAddressStore;
        this.componentSsoStore = componentRootStore.componentSsoStore;
    }
    setIsAddressDirtyFalse() {
        this.isAddressDirty = false;
    }
    setIsAddressDirtyTrue() {
        this.isAddressDirty = true;
    }
    get addressError() {
        if (!this.isStreetValid || !this.isPostalCodeValid || !this.isCityValid) {
            return true;
        }
        return this.status === 'ERROR';
    }
    get isCityValid() {
        return !!this.newForeignAddress.city && this.newForeignAddress.city.length > 0;
    }
    get isStreetValid() {
        return !!this.newForeignAddress.street && this.newForeignAddress.street.length > 0;
    }
    get isPostalCodeValid() {
        return !!this.newForeignAddress.postalCode && this.newForeignAddress.postalCode.length < 11;
    }
    get hasAddressChanged() {
        return (this.initialForeignAddress.id !== this.newForeignAddress.id ||
            this.initialForeignAddress.countryCode !== this.newForeignAddress.countryCode ||
            this.initialForeignAddress.region !== this.newForeignAddress.region ||
            this.initialForeignAddress.city !== this.newForeignAddress.city ||
            this.initialForeignAddress.building !== this.newForeignAddress.building ||
            this.initialForeignAddress.street !== this.newForeignAddress.street ||
            this.initialForeignAddress.room !== this.newForeignAddress.room ||
            this.initialForeignAddress.postalCode !== this.newForeignAddress.postalCode ||
            this.hasChanged);
    }
    reset() {
        this.resetForeignAddress();
        this.status = 'UNINITIALIZED';
    }
    resetForeignAddress() {
        this.initialForeignAddress = {
            id: null,
            countryCode: undefined,
            region: undefined,
            city: undefined,
            building: undefined,
            street: undefined,
            room: undefined,
            postalCode: undefined
        };
        this.newForeignAddress = { ...this.initialForeignAddress };
    }
    init() {
        const address = this.componentContactAddressStore.contactAddress.address;
        this.initialForeignAddress.countryCode = address.countryCode ? address.countryCode : undefined;
        this.initialForeignAddress.region = address.region ? address.region : undefined;
        this.initialForeignAddress.city = address.city ? address.city : undefined;
        this.initialForeignAddress.street = address.street ? address.street : undefined;
        this.initialForeignAddress.building = address.building ? address.building : undefined;
        this.initialForeignAddress.room = address.room ? address.room : undefined;
        this.initialForeignAddress.postalCode = address.postalCode ? address.postalCode : undefined;
        this.newForeignAddress = { ...this.initialForeignAddress };
    }
    getAddress() {
        this.newForeignAddress.countryCode = this.componentContactAddressStore.countrySelected.value;
        const newContactAddress = this.newForeignAddress;
        const addressId = this.componentContactAddressStore.addressId;
        if (addressId) {
            newContactAddress.id = addressId;
        }
        return newContactAddress;
    }
    async saveAddress() {
        this.newForeignAddress.countryCode = this.componentContactAddressStore.countrySelected.value;
        this.status = 'UNINITIALIZED';
        if (!this.hasAddressChanged || this.addressError) {
            return Promise.resolve(false);
        }
        const newAddress = this.getAddress();
        const baseUrl = this.componentRootStore.urlDataStore.componentsAPIURL;
        const isPerson = this.componentSsoStore.isPrivate;
        const fullUrl = baseUrl.concat(`${isPerson ? this.PERSON_ENDPOINT : this.LEGAL_ENTITY_ENDPOINT}`);
        const updateAddress = !!newAddress.id;
        this.status = 'FETCHING';
        if (updateAddress) {
            await ApiUtil_1.default.put(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
        }
        else {
            await ApiUtil_1.default.post(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
        }
        return this.status !== 'ERROR';
    }
    setAddressChanged() {
        this.hasChanged = true;
    }
    getAsContactAddress() {
        const { street, room, region, postalCode, countryCode, city, building } = this.newForeignAddress;
        return {
            countryCode,
            region,
            city,
            municipality: city,
            street,
            building,
            room,
            postalCode
        };
    }
}
__decorate([
    mobx_1.observable
], ComponentForeignAddressEditStore.prototype, "initialForeignAddress", void 0);
__decorate([
    mobx_1.observable
], ComponentForeignAddressEditStore.prototype, "newForeignAddress", void 0);
__decorate([
    mobx_1.observable
], ComponentForeignAddressEditStore.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], ComponentForeignAddressEditStore.prototype, "isAddressDirty", void 0);
__decorate([
    mobx_1.observable
], ComponentForeignAddressEditStore.prototype, "hasChanged", void 0);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "setIsAddressDirtyFalse", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "setIsAddressDirtyTrue", null);
__decorate([
    mobx_1.computed
], ComponentForeignAddressEditStore.prototype, "addressError", null);
__decorate([
    mobx_1.computed
], ComponentForeignAddressEditStore.prototype, "isCityValid", null);
__decorate([
    mobx_1.computed
], ComponentForeignAddressEditStore.prototype, "isStreetValid", null);
__decorate([
    mobx_1.computed
], ComponentForeignAddressEditStore.prototype, "isPostalCodeValid", null);
__decorate([
    mobx_1.computed
], ComponentForeignAddressEditStore.prototype, "hasAddressChanged", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "reset", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "resetForeignAddress", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "getAddress", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "saveAddress", null);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "handleError", void 0);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "handleSuccess", void 0);
__decorate([
    mobx_1.action
], ComponentForeignAddressEditStore.prototype, "setAddressChanged", null);
exports["default"] = ComponentForeignAddressEditStore;


/***/ }),

/***/ 1899:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const AddressFormatUtil_1 = __webpack_require__(9318);
const ApiUtil_1 = __importDefault(__webpack_require__(2965));
class ComponentRegistryAddressEditStore {
    constructor(componentRootStore) {
        Object.defineProperty(this, "selectedAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "newAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "newRoom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "addressText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "roomText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "addressAutocompleteItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "roomOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "hasAddressChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isAddressDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isInitializing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "componentRootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentContactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentAddressSuggestionStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentSsoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "PERSON_ENDPOINT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/person/contact-address/registry-address'
        });
        Object.defineProperty(this, "LEGAL_ENTITY_ENDPOINT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/legal-entity/contact-address/registry-address'
        });
        Object.defineProperty(this, "initSelectedAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (address) => {
                this.selectedAddress = address;
                this.addressText = this.selectedAddress ? this.selectedAddress.label2 : '';
            }
        });
        Object.defineProperty(this, "fetchAddressSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.componentAddressSuggestionStore.fetchAddressResult(this.addressText).then(this.onFetchAddressSuccess).catch(console.error);
            }
        });
        Object.defineProperty(this, "submitChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.onAddressChange(this.selectedAddress, findRoom(this.roomOptions, this.roomText));
            }
        });
        Object.defineProperty(this, "initRooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (roomText) => {
                if (roomText === null) {
                    roomText = '';
                }
                this.roomText = roomText;
                this.roomOptions = [];
                if (this.selectedAddress && this.selectedAddress.rooms) {
                    this.roomOptions = sortAndMapRoomsToSuggestionItems(this.selectedAddress.rooms.filter((r) => r.roomAddressId === this.selectedAddress.id));
                }
            }
        });
        Object.defineProperty(this, "onAddressChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (address, room) => {
                if (!this.isInitializing) {
                    this.hasAddressChanged = true;
                }
                this.newAddress = address;
                this.newRoom = room;
            }
        });
        Object.defineProperty(this, "onFetchAddressSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (addresses) => {
                this.addressAutocompleteItems = mapAddressesToAutocompleteItems(addresses, this.addressText, this.translateStore);
                this.submitChange();
            }
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.status = 'ERROR';
            }
        });
        Object.defineProperty(this, "handleSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.status = 'FETCHED';
                this.componentContactAddressStore.reloadAddress();
            }
        });
        Object.defineProperty(this, "getAsContactAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { id, buildingId, house, municipality, postalCode, region, street, cityCounty } = this.newAddress;
                return {
                    countryCode: 'EE',
                    addressRegistryId: id,
                    buildingRegistryId: buildingId,
                    roomRegistryId: this.newRoom && this.newRoom.roomId,
                    postalCode,
                    region,
                    city: cityCounty,
                    municipality,
                    street,
                    room: this.newRoom && this.newRoom.roomName,
                    building: house
                };
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.componentRootStore = componentRootStore;
        this.componentContactAddressStore = componentRootStore.componentContactAddressStore;
        this.componentAddressSuggestionStore = componentRootStore.componentAddressSuggestionStore;
        this.componentSsoStore = componentRootStore.componentSsoStore;
        this.translateStore = componentRootStore.componentTranslateStore;
    }
    setIsAddressDirtyFalse() {
        this.isAddressDirty = false;
    }
    setIsAddressDirtyTrue() {
        this.isAddressDirty = true;
    }
    get addressError() {
        return !this.newAddress || this.hasRoomsButNoneSelected();
    }
    reset() {
        this.selectedAddress = null;
        this.newAddress = null;
        this.newRoom = null;
        this.addressText = '';
        this.roomText = '';
        this.addressAutocompleteItems = [];
        this.roomOptions = [];
        this.status = 'UNINITIALIZED';
        this.hasAddressChanged = false;
        this.isInitializing = false;
    }
    async init() {
        const address = this.componentContactAddressStore.contactAddress.address;
        this.isInitializing = true;
        await this.getAddressSuggestionIfAddressIdExists(address);
        await this.fetchAddressSuggestions();
        this.initRooms(address.room);
        this.submitChange();
        this.isInitializing = false;
    }
    async getAddressSuggestionIfAddressIdExists(address) {
        if (address.addressRegistryId || address.buildingRegistryId || address.roomRegistryId) {
            await this.componentAddressSuggestionStore.getAddressFromContactAddress(address).then(this.initSelectedAddress);
        }
    }
    async saveAddress() {
        this.status = 'UNINITIALIZED';
        if ((this.addressValidated && !this.hasAddressChanged) || this.addressError) {
            return Promise.resolve(false);
        }
        const newAddress = this.getAddress();
        const baseUrl = this.componentRootStore.urlDataStore.componentsAPIURL;
        const isPerson = this.componentSsoStore.isPrivate;
        const fullUrl = baseUrl.concat(`${isPerson ? this.PERSON_ENDPOINT : this.LEGAL_ENTITY_ENDPOINT}`);
        const updateAddress = !!newAddress.id;
        this.status = 'FETCHING';
        if (updateAddress) {
            await ApiUtil_1.default.put(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
        }
        else {
            await ApiUtil_1.default.post(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
        }
        return this.status !== 'ERROR';
    }
    hasRoomsButNoneSelected() {
        if (!this.newAddress) {
            return false;
        }
        return this.newAddress.rooms && this.newAddress.rooms.slice().length > 0 && !this.newRoom;
    }
    getAddress() {
        const newContactAddress = addressToRegistryAddress(this.newAddress, this.newRoom);
        const addressId = this.componentContactAddressStore.addressId;
        if (addressId) {
            newContactAddress.id = addressId;
        }
        return newContactAddress;
    }
    setAddressChanged() {
        this.hasAddressChanged = true;
    }
    get addressValidatedOrChanged() {
        var _a, _b, _c, _d, _e;
        const { contactAddress } = this.componentContactAddressStore;
        return (contactAddress === null ||
            contactAddress.validated ||
            ((_b = (_a = contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.address) === null || _a === void 0 ? void 0 : _a.addressRegistryId) === null || _b === void 0 ? void 0 : _b.toString()) !== ((_c = this.newAddress) === null || _c === void 0 ? void 0 : _c.id) ||
            ((_d = contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.address) === null || _d === void 0 ? void 0 : _d.room) !== ((_e = this.newRoom) === null || _e === void 0 ? void 0 : _e.roomName));
    }
    get addressValidated() {
        const { contactAddress } = this.componentContactAddressStore;
        return contactAddress === null || contactAddress === void 0 ? void 0 : contactAddress.validated;
    }
}
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "selectedAddress", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "newAddress", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "newRoom", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "addressText", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "roomText", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "addressAutocompleteItems", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "roomOptions", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "hasAddressChanged", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "isAddressDirty", void 0);
__decorate([
    mobx_1.observable
], ComponentRegistryAddressEditStore.prototype, "isInitializing", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "setIsAddressDirtyFalse", null);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "setIsAddressDirtyTrue", null);
__decorate([
    mobx_1.computed
], ComponentRegistryAddressEditStore.prototype, "addressError", null);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "reset", null);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "init", null);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "initSelectedAddress", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "initRooms", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "saveAddress", null);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "onAddressChange", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "onFetchAddressSuccess", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "handleError", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "handleSuccess", void 0);
__decorate([
    mobx_1.action
], ComponentRegistryAddressEditStore.prototype, "setAddressChanged", null);
__decorate([
    mobx_1.computed
], ComponentRegistryAddressEditStore.prototype, "addressValidatedOrChanged", null);
__decorate([
    mobx_1.computed
], ComponentRegistryAddressEditStore.prototype, "addressValidated", null);
exports["default"] = ComponentRegistryAddressEditStore;
const parseIntWithNanToNull = (value) => {
    const valueAsNumber = Number.parseInt(value, 10);
    return isNaN(valueAsNumber) ? null : valueAsNumber;
};
const addressToRegistryAddress = (address, room) => {
    if (!address) {
        return null;
    }
    return {
        addressRegistryId: parseIntWithNanToNull(address.id),
        buildingRegistryId: parseIntWithNanToNull(address.buildingId),
        roomRegistryId: room ? parseIntWithNanToNull(room.roomId) : null,
        privatePostalCode: address.postalCode,
        room: room && !room.roomId ? room.roomName : null
    };
};
const findSuggestionItemByLabel = (suggestions, label) => {
    return suggestions.find((item) => item.label === label);
};
const mapAddressesToAutocompleteItems = (addressList, addressText, translateStore) => {
    return addressList.map((address) => ({
        id: address.id,
        url: '#',
        label: address.label2,
        isActive: address.label2 === addressText,
        subLabel: translateStore.translate(AddressFormatUtil_1.buildingTypes.get(address.buildingType))
    }));
};
const sortAndMapRoomsToSuggestionItems = (rooms) => {
    return rooms
        .map((room) => ({ label: room.roomName, id: room.roomId, url: '#' }))
        .sort((a, b) => {
        const aAsInt = Number.parseInt(a.label, 10);
        const bAsInt = Number.parseInt(b.label, 10);
        if ((isNaN(a.label) || isNaN(b.label)) && aAsInt === bAsInt) {
            return a.label.localeCompare(b.label);
        }
        else {
            return aAsInt - bAsInt;
        }
    });
};
const findRoom = (roomOptions, roomText) => {
    const roomOption = findSuggestionItemByLabel(roomOptions, roomText);
    return roomOption ? { roomId: roomOption.id, roomName: roomOption.label } : null;
};


/***/ }),

/***/ 4547:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentInformationCheckStore = exports.ComponentSignerStore = exports.ComponentURLDataStore = exports.ComponentTranslateStore = exports.ComponentSsoStore = exports.ComponentRootStoreContext = exports.ComponentRootStore = exports.ComponentMandateStore = exports.ComponentContractStore = exports.ComponentCreditInfoStore = exports.ComponentRegistrationStore = exports.ComponentCustomerContactInfoStore = exports.ComponentContactAddressStore = void 0;
var ComponentContactAddressStore_1 = __webpack_require__(2748);
Object.defineProperty(exports, "ComponentContactAddressStore", ({ enumerable: true, get: function () { return __importDefault(ComponentContactAddressStore_1).default; } }));
var ComponentCustomerContactInfoStore_1 = __webpack_require__(5104);
Object.defineProperty(exports, "ComponentCustomerContactInfoStore", ({ enumerable: true, get: function () { return __importDefault(ComponentCustomerContactInfoStore_1).default; } }));
var ComponentRegistrationStore_1 = __webpack_require__(6638);
Object.defineProperty(exports, "ComponentRegistrationStore", ({ enumerable: true, get: function () { return __importDefault(ComponentRegistrationStore_1).default; } }));
var ComponentCreditInfoStore_1 = __webpack_require__(2880);
Object.defineProperty(exports, "ComponentCreditInfoStore", ({ enumerable: true, get: function () { return __importDefault(ComponentCreditInfoStore_1).default; } }));
var ComponentContractStore_1 = __webpack_require__(1467);
Object.defineProperty(exports, "ComponentContractStore", ({ enumerable: true, get: function () { return __importDefault(ComponentContractStore_1).default; } }));
var ComponentMandateStore_1 = __webpack_require__(811);
Object.defineProperty(exports, "ComponentMandateStore", ({ enumerable: true, get: function () { return __importDefault(ComponentMandateStore_1).default; } }));
var ComponentRootStore_1 = __webpack_require__(5929);
Object.defineProperty(exports, "ComponentRootStore", ({ enumerable: true, get: function () { return __importDefault(ComponentRootStore_1).default; } }));
Object.defineProperty(exports, "ComponentRootStoreContext", ({ enumerable: true, get: function () { return ComponentRootStore_1.ComponentRootStoreContext; } }));
var ComponentSsoStore_1 = __webpack_require__(8146);
Object.defineProperty(exports, "ComponentSsoStore", ({ enumerable: true, get: function () { return __importDefault(ComponentSsoStore_1).default; } }));
var ComponentTranslateStore_1 = __webpack_require__(9371);
Object.defineProperty(exports, "ComponentTranslateStore", ({ enumerable: true, get: function () { return __importDefault(ComponentTranslateStore_1).default; } }));
var ComponentURLDataStore_1 = __webpack_require__(614);
Object.defineProperty(exports, "ComponentURLDataStore", ({ enumerable: true, get: function () { return __importDefault(ComponentURLDataStore_1).default; } }));
var ComponentSignerStore_1 = __webpack_require__(6055);
Object.defineProperty(exports, "ComponentSignerStore", ({ enumerable: true, get: function () { return __importDefault(ComponentSignerStore_1).default; } }));
var ComponentInformationCheckStore_1 = __webpack_require__(3047);
Object.defineProperty(exports, "ComponentInformationCheckStore", ({ enumerable: true, get: function () { return __importDefault(ComponentInformationCheckStore_1).default; } }));


/***/ }),

/***/ 3142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContactChannelsRequiredValidation = void 0;
const mobx_1 = __webpack_require__(259);
const ContactInfoUtil_1 = __webpack_require__(1203);
var ContactChannelsRequiredValidation;
(function (ContactChannelsRequiredValidation) {
    ContactChannelsRequiredValidation[ContactChannelsRequiredValidation["EMAIL"] = 0] = "EMAIL";
    ContactChannelsRequiredValidation[ContactChannelsRequiredValidation["PHONE"] = 1] = "PHONE";
    ContactChannelsRequiredValidation[ContactChannelsRequiredValidation["EMAIL_AND_PHONE"] = 2] = "EMAIL_AND_PHONE";
    ContactChannelsRequiredValidation[ContactChannelsRequiredValidation["EMAIL_OR_PHONE"] = 3] = "EMAIL_OR_PHONE";
})(ContactChannelsRequiredValidation = exports.ContactChannelsRequiredValidation || (exports.ContactChannelsRequiredValidation = {}));
class ContactChannelsData {
    constructor({ languageDisabled, phone, email, communicationLanguageCode, requiredValidation }) {
        Object.defineProperty(this, "languageDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "phone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "email", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communicationLanguageCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requiredValidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "changeEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email) => {
                this.email = email;
            }
        });
        Object.defineProperty(this, "changePhone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (phone) => {
                this.phone = phone;
            }
        });
        Object.defineProperty(this, "changeCommunicationLanguageCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (communicationLanguageCode) => {
                this.communicationLanguageCode = communicationLanguageCode;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.languageDisabled = languageDisabled || false;
        this.phone = phone || '';
        this.email = email || '';
        this.communicationLanguageCode = communicationLanguageCode;
        this.requiredValidation = requiredValidation || ContactChannelsRequiredValidation.EMAIL_OR_PHONE;
    }
    get isEmailValid() {
        return this.email ? (0, ContactInfoUtil_1.isEmailValid)(this.email) : true;
    }
    get isPhoneValid() {
        return this.phone ? (0, ContactInfoUtil_1.isPhoneValid)(this.phone) : true;
    }
    get isEmailRequired() {
        return (this.requiredValidation === ContactChannelsRequiredValidation.EMAIL ||
            this.requiredValidation === ContactChannelsRequiredValidation.EMAIL_AND_PHONE ||
            (this.requiredValidation === ContactChannelsRequiredValidation.EMAIL_OR_PHONE && !this.phone));
    }
    get isPhoneRequired() {
        return (this.requiredValidation === ContactChannelsRequiredValidation.PHONE ||
            this.requiredValidation === ContactChannelsRequiredValidation.EMAIL_AND_PHONE ||
            (this.requiredValidation === ContactChannelsRequiredValidation.EMAIL_OR_PHONE && !this.email));
    }
    get isValid() {
        if (!this.communicationLanguageCode || (this.isEmailRequired && !this.email) || (this.isPhoneRequired && !this.phone)) {
            return false;
        }
        return this.isPhoneValid && this.isEmailValid;
    }
}
__decorate([
    mobx_1.observable
], ContactChannelsData.prototype, "languageDisabled", void 0);
__decorate([
    mobx_1.observable
], ContactChannelsData.prototype, "phone", void 0);
__decorate([
    mobx_1.observable
], ContactChannelsData.prototype, "email", void 0);
__decorate([
    mobx_1.observable
], ContactChannelsData.prototype, "communicationLanguageCode", void 0);
__decorate([
    mobx_1.observable
], ContactChannelsData.prototype, "requiredValidation", void 0);
__decorate([
    mobx_1.action
], ContactChannelsData.prototype, "changeEmail", void 0);
__decorate([
    mobx_1.action
], ContactChannelsData.prototype, "changePhone", void 0);
__decorate([
    mobx_1.action
], ContactChannelsData.prototype, "changeCommunicationLanguageCode", void 0);
__decorate([
    mobx_1.computed
], ContactChannelsData.prototype, "isEmailValid", null);
__decorate([
    mobx_1.computed
], ContactChannelsData.prototype, "isPhoneValid", null);
__decorate([
    mobx_1.computed
], ContactChannelsData.prototype, "isEmailRequired", null);
__decorate([
    mobx_1.computed
], ContactChannelsData.prototype, "isPhoneRequired", null);
__decorate([
    mobx_1.computed
], ContactChannelsData.prototype, "isValid", null);
exports["default"] = ContactChannelsData;


/***/ }),

/***/ 1561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
const ContactInfoUtil_1 = __webpack_require__(1203);
class ContactInfo {
    constructor(contactInfoType) {
        Object.defineProperty(this, "contactInfoId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "validated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "oldValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isUserInputError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSavingError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.type = contactInfoType;
    }
    onChange(value, isDealer) {
        this.value = value;
        this.checkValueValidity(isDealer);
        this.isSavingError && (this.isSavingError = false);
    }
    checkValueValidity(isDealer) {
        const isValueValid = (this.type === 'EMAIL' ? (0, ContactInfoUtil_1.isEmailValid)(this.value) : (0, ContactInfoUtil_1.isPhoneValid)(this.value)) || (isDealer && this.value === '');
        this.isUserInputError = this.hasValueChanged ? !isValueValid : false;
    }
    get isInputValid() {
        return !this.isUserInputError;
    }
    get hasValue() {
        return this.value !== '';
    }
    setSavingError(isError) {
        this.isSavingError = isError;
    }
    set(contactInfo) {
        this.contactInfoId = contactInfo.contactInfoId;
        this.prime = contactInfo.prime;
        this.type = contactInfo.type;
        this.value = contactInfo.value;
        this.isUserInputError = contactInfo.isUserInputError;
        this.oldValue = contactInfo.value;
        this.validated = contactInfo.validated;
        this.checkValueValidity();
    }
    get hasValueChanged() {
        return this.oldValue !== this.value;
    }
    getContactInfoResource() {
        return {
            prime: this.prime,
            type: this.type,
            contactInfoId: this.contactInfoId,
            value: this.value
        };
    }
}
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "contactInfoId", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "prime", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "validated", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "type", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "value", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "oldValue", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "isUserInputError", void 0);
__decorate([
    mobx_1.observable
], ContactInfo.prototype, "isSavingError", void 0);
__decorate([
    mobx_1.action
], ContactInfo.prototype, "onChange", null);
__decorate([
    mobx_1.action
], ContactInfo.prototype, "checkValueValidity", null);
__decorate([
    mobx_1.computed
], ContactInfo.prototype, "isInputValid", null);
__decorate([
    mobx_1.computed
], ContactInfo.prototype, "hasValue", null);
__decorate([
    mobx_1.action
], ContactInfo.prototype, "setSavingError", null);
__decorate([
    mobx_1.action
], ContactInfo.prototype, "set", null);
__decorate([
    mobx_1.computed
], ContactInfo.prototype, "hasValueChanged", null);
exports["default"] = ContactInfo;


/***/ }),

/***/ 9500:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getContactAddress = void 0;
const getContactAddress = (address) => {
    let contactAddress;
    if (address.addressRegistryId) {
        contactAddress = {
            addressRegistryAddressIdentifier: {
                addressRegistryId: address.addressRegistryId,
                roomRegistryId: address.roomRegistryId,
                buildingRegistryId: address.buildingRegistryId,
                room: address.room,
                privatePostalCode: address.privatePostalCode
            }
        };
    }
    if (address.countryCode) {
        contactAddress = {
            foreignAddressIdentifier: {
                countryCode: address.countryCode,
                region: address.region,
                city: address.city,
                municipality: address.municipality,
                street: address.street,
                building: address.building,
                room: address.room,
                postalCode: address.postalCode
            }
        };
    }
    return contactAddress;
};
exports.getContactAddress = getContactAddress;


/***/ }),

/***/ 8851:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EmployeeSignatureResource = void 0;
class EmployeeSignature {
    constructor(username, signatureImage) {
        Object.defineProperty(this, "username", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_signatureImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.username = username;
        this._signatureImage = signatureImage;
    }
    get signatureImage() {
        return this._signatureImage;
    }
}
exports["default"] = EmployeeSignature;
class EmployeeSignatureResource {
    constructor(signature) {
        Object.defineProperty(this, "signatureImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signatureImage = signature;
    }
}
exports.EmployeeSignatureResource = EmployeeSignatureResource;


/***/ }),

/***/ 2434:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getLegalEntityCreation = void 0;
const CustomerCreationContactAddress_1 = __webpack_require__(9500);
const getLegalEntityCreation = (person, email, phone, communicationLanguage, address, legalEntity) => {
    const legalEntityCreation = {
        legalEntity: {
            name: legalEntity.name,
            registrationNumber: legalEntity.registrationNumber,
            registrationNumberCountryCode: legalEntity.registrationNumberCountryCode,
            contactAddress: (0, CustomerCreationContactAddress_1.getContactAddress)(address)
        },
        legalCustomerPerson: {
            person: {
                firstName: person.firstName,
                lastName: person.lastName,
                personalCode: person.personalCode,
                personalCodeCountryCode: person.personalCodeCountryCode,
                communicationLanguageCode: communicationLanguage
            },
            mandate: {
                source: 'STANDARD'
            },
            contactInfos: []
        }
    };
    if (email.hasValue) {
        legalEntityCreation.legalCustomerPerson.contactInfos.push({
            type: email.type,
            value: email.value
        });
    }
    if (phone.hasValue) {
        legalEntityCreation.legalCustomerPerson.contactInfos.push({
            type: phone.type,
            value: phone.value
        });
    }
    return legalEntityCreation;
};
exports.getLegalEntityCreation = getLegalEntityCreation;


/***/ }),

/***/ 5860:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPrivateCustomerResource = void 0;
const CustomerCreationContactAddress_1 = __webpack_require__(9500);
const getPrivateCustomerResource = (person, email, phone, communicationLanguage, address) => {
    const privateCustomer = {
        person: {
            firstName: person.firstName,
            lastName: person.lastName,
            personalCode: person.personalCode,
            personalCodeCountryCode: person.personalCodeCountryCode,
            communicationLanguageCode: communicationLanguage,
            contactInfos: [],
            contactAddress: (0, CustomerCreationContactAddress_1.getContactAddress)(address)
        }
    };
    if (email.hasValue) {
        privateCustomer.person.contactInfos.push({
            type: email.type,
            value: email.value
        });
    }
    if (phone.hasValue) {
        privateCustomer.person.contactInfos.push({
            type: phone.type,
            value: phone.value
        });
    }
    return privateCustomer;
};
exports.getPrivateCustomerResource = getPrivateCustomerResource;


/***/ }),

/***/ 6081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_1 = __webpack_require__(259);
class Signer {
    constructor() {
        Object.defineProperty(this, "firstName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personalCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personalCodeCountryCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
    }
}
__decorate([
    mobx_1.observable
], Signer.prototype, "selected", void 0);
exports["default"] = Signer;


/***/ }),

/***/ 929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Signer = exports.ContactChannelsRequiredValidation = exports.ContactChannelsData = exports.ContactInfo = void 0;
var ContactInfo_1 = __webpack_require__(1561);
Object.defineProperty(exports, "ContactInfo", ({ enumerable: true, get: function () { return __importDefault(ContactInfo_1).default; } }));
var ContactChannelsData_1 = __webpack_require__(3142);
Object.defineProperty(exports, "ContactChannelsData", ({ enumerable: true, get: function () { return __importDefault(ContactChannelsData_1).default; } }));
Object.defineProperty(exports, "ContactChannelsRequiredValidation", ({ enumerable: true, get: function () { return ContactChannelsData_1.ContactChannelsRequiredValidation; } }));
var Signer_1 = __webpack_require__(6081);
Object.defineProperty(exports, "Signer", ({ enumerable: true, get: function () { return __importDefault(Signer_1).default; } }));


/***/ }),

/***/ 9318:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildingTypes = exports.formatInvoiceAddress = void 0;
const StringUtil_1 = __webpack_require__(5085);
const formatInvoiceAddress = (address) => {
    const houseName = [address.streetName, address.houseNumber].join(' ') + (address.apartmentNumber ? `-${address.apartmentNumber}` : '');
    return [(0, StringUtil_1.capitalizeString)(houseName), [(0, StringUtil_1.capitalizeString)(address.city), address.zipCode].join(' '), (0, StringUtil_1.capitalizeString)(address.county)].join(', ');
};
exports.formatInvoiceAddress = formatInvoiceAddress;
exports.buildingTypes = new Map([
    ['korrusmaja', 'building.type.apartment.building'],
    ['kaubandusk', 'building.type.shopping.mall'],
    ['muunimet', 'building.type.other'],
    ['vare', 'building.type.ruins'],
    ['kirik', 'building.type.church'],
    ['elamu', 'building.type.residential'],
    ['ridamaja', 'building.type.terraced.house'],
    ['eramu', 'building.type.private.house'],
    ['teadmata', 'building.type.unknown'],
    ['ärihoone', 'building.type.commercial.building'],
    ['üh./t.h.', 'building.type.communal.production.building'],
    ['abihoone', 'building.type.auxiliary.building'],
    ['paarismaja', 'building.type.semi.detached.house'],
    ['tootmish.', 'building.type.production.building']
]);


/***/ }),

/***/ 2965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getUrl = exports.API_CONF = void 0;
const axios_1 = __importDefault(__webpack_require__(9669));
const qs_1 = __webpack_require__(129);
exports.API_CONF = {
    timeout: 50000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: (params) => (0, qs_1.stringify)(params, { arrayFormat: 'repeat' })
};
const API = axios_1.default.create(exports.API_CONF);
exports["default"] = API;
function getUrl(url, paramsMap) {
    if (!paramsMap) {
        return url;
    }
    const queryParams = Object.entries(paramsMap)
        .filter(([_, v]) => v !== null)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
    return queryParams.length ? `${url}?${queryParams}` : url;
}
exports.getUrl = getUrl;


/***/ }),

/***/ 5269:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class Config {
    static init(componentURLDataStore) {
        Config.apiUrl = componentURLDataStore.componentsAPIURL;
    }
}
exports["default"] = Config;


/***/ }),

/***/ 1203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTranslatedCommunicationLanguage = exports.getCommunicationLanguageProps = exports.isContactInfoChanged = exports.isPhoneValid = exports.isEmailValid = exports.ContactInfoType = exports.Language = void 0;
const validator_1 = __importDefault(__webpack_require__(8966));
var Language;
(function (Language) {
    Language["ET"] = "et";
    Language["RU"] = "ru";
    Language["EN"] = "en";
})(Language = exports.Language || (exports.Language = {}));
var ContactInfoType;
(function (ContactInfoType) {
    ContactInfoType["EMAIL"] = "EMAIL";
    ContactInfoType["PHONE"] = "PHONE";
})(ContactInfoType = exports.ContactInfoType || (exports.ContactInfoType = {}));
const isEmailValid = (value) => {
    return validator_1.default.isEmail(value, { host_blacklist: ['eesti.ee'] });
};
exports.isEmailValid = isEmailValid;
const isPhoneValid = (phone) => {
    const regex = /^[+]?[0-9]{7,15}$/;
    return regex.test(phone);
};
exports.isPhoneValid = isPhoneValid;
const isContactInfoChanged = (newValue, oldValue) => {
    return newValue !== oldValue;
};
exports.isContactInfoChanged = isContactInfoChanged;
const getCommunicationLanguageProps = (isDisabled, translateStore) => {
    const { translate } = translateStore;
    return [
        {
            id: 'ET',
            label: translate('registration.contactInfo.communicationLanguage.ET'),
            name: 'eesti',
            value: Language.ET.toUpperCase(),
            disabled: isDisabled
        },
        {
            id: 'EN',
            label: translate('registration.contactInfo.communicationLanguage.EN'),
            name: 'inglise',
            value: Language.EN.toUpperCase(),
            disabled: isDisabled
        },
        {
            id: 'RU',
            label: translate('registration.contactInfo.communicationLanguage.RU'),
            name: 'vene',
            value: Language.RU.toUpperCase(),
            disabled: isDisabled
        }
    ];
};
exports.getCommunicationLanguageProps = getCommunicationLanguageProps;
const getTranslatedCommunicationLanguage = (communicationLanguage, translate) => {
    switch (communicationLanguage) {
        case 'ET':
            return translate('registration.contactInfo.communicationLanguage.ET');
        case 'RU':
            return translate('registration.contactInfo.communicationLanguage.RU');
        case 'EN':
            return translate('registration.contactInfo.communicationLanguage.EN');
        default:
            return '';
    }
};
exports.getTranslatedCommunicationLanguage = getTranslatedCommunicationLanguage;


/***/ }),

/***/ 2531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CountryUtil = void 0;
const array_unique_1 = __importDefault(__webpack_require__(5302));
const domain_1 = __webpack_require__(1871);
class CountryUtil {
    static countriesForView(searchTerm, currentLanguage) {
        currentLanguage = currentLanguage.toLowerCase();
        return this.findSuggestedCountries(searchTerm, currentLanguage).map((country) => ({ label: country.label[currentLanguage], value: country.value }));
    }
    static getCountryNameByCountryCode(countryCode, currentLanguage) {
        return countryCode ? this.getByCountryCode(countryCode).label[currentLanguage.toLowerCase()] : null;
    }
    static getByCountryCode(value) {
        if (!value) {
            return null;
        }
        return domain_1.iso3166CountryMap.find((country) => country.value === value) || null;
    }
    static findSuggestedCountries(searchTerm, currentLanguage) {
        const foundCountries = this.getCountriesContainingSearchTerm(searchTerm, currentLanguage);
        const aliasCountries = this.findByAlias(searchTerm, currentLanguage);
        currentLanguage = currentLanguage.toLowerCase();
        return (0, array_unique_1.default)(foundCountries
            .concat(aliasCountries)
            .sort((country1, country2) => country1.label[currentLanguage].localeCompare(country2.label[currentLanguage])));
    }
    static findByAlias(searchTerm, currentLanguage) {
        return domain_1.countryAliases
            .filter((country) => this.countryMatchesSearchTerm(country, searchTerm, currentLanguage))
            .map((alias) => this.getByCountryCode(alias.value));
    }
    static countryMatchesSearchTerm(country, searchTerm, currentLanguage) {
        const name = country.label[currentLanguage.toLowerCase()].toLowerCase();
        const nameFragments = name.replace('-', ' ').split(' ');
        const nameFragmentsMatchTerm = () => nameFragments.some((nameFragment) => this.startsWith(nameFragment, searchTerm));
        return this.startsWith(name, searchTerm) || nameFragmentsMatchTerm();
    }
    static getCountriesContainingSearchTerm(searchTerm, currentLanguage) {
        return domain_1.iso3166CountryMap.filter((country) => this.countryMatchesSearchTerm(country, searchTerm, currentLanguage));
    }
    static startsWith(name, searchTerm) {
        return name.startsWith(searchTerm.trim().toLowerCase());
    }
    static isEstonia(countryCode) {
        return countryCode === 'EE';
    }
    static mapCountriesForSuggestionField(searchTerm, language) {
        return this.findSuggestedCountries(searchTerm, language).map((country) => ({ label: country.label[language], url: '' }));
    }
    static getSelectedCountry(searchTerm, language) {
        const countries = this.findSuggestedCountries(searchTerm, language);
        if (countries.length === 0) {
            return null;
        }
        return countries.length === 1
            ? countries[0]
            : countries.find((country) => country.label[language].toLocaleLowerCase() === searchTerm.toLocaleLowerCase()) || null;
    }
}
exports.CountryUtil = CountryUtil;


/***/ }),

/***/ 1513:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class LocationUtils {
    static changePath(newPath) {
        window.location.pathname = newPath;
    }
    static redirectToUrl(url) {
        window.location.assign(url);
    }
    static getDomain() {
        return `${window.location.protocol}//${location.host}`;
    }
}
exports["default"] = LocationUtils;


/***/ }),

/***/ 8685:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getValueOrDash = exports.parseParams = void 0;
function parseParams(textValue, paramObject) {
    return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
}
exports.parseParams = parseParams;
function getValueOrDash(value) {
    return value && value.trim() ? value : '-';
}
exports.getValueOrDash = getValueOrDash;


/***/ }),

/***/ 9415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getBirthYear = exports.isUnderage = exports.DAY_END = exports.DAY_START = exports.MONTH_END = exports.MONTH_START = exports.YEAR_END = exports.YEAR_START = exports.CENTURY_END = exports.CENTURY_START = exports.CURRENT_CENTURY = exports.LAST_CENTURY = exports.LEGAL_AGE = exports.RADIX = void 0;
const date_fns_1 = __webpack_require__(429);
exports.RADIX = 10;
exports.LEGAL_AGE = 18;
exports.LAST_CENTURY = 1900;
exports.CURRENT_CENTURY = 2000;
exports.CENTURY_START = 0;
exports.CENTURY_END = 1;
exports.YEAR_START = 1;
exports.YEAR_END = 3;
exports.MONTH_START = 3;
exports.MONTH_END = 5;
exports.DAY_START = 5;
exports.DAY_END = 7;
const isUnderage = (personalCode) => {
    const year = (0, exports.getBirthYear)(personalCode);
    const month = parseInt(personalCode.slice(exports.MONTH_START, exports.MONTH_END), exports.RADIX) - 1;
    const day = parseInt(personalCode.slice(exports.DAY_START, exports.DAY_END), exports.RADIX);
    return (0, date_fns_1.differenceInYears)(new Date(), new Date(year, month, day)) < exports.LEGAL_AGE;
};
exports.isUnderage = isUnderage;
const getBirthYear = (personalCode) => {
    const century = parseInt(personalCode.slice(exports.CENTURY_START, exports.CENTURY_END), exports.RADIX);
    let year = parseInt(personalCode.slice(exports.YEAR_START, exports.YEAR_END), exports.RADIX);
    century < 5 ? (year += exports.LAST_CENTURY) : (year += exports.CURRENT_CENTURY);
    return year;
};
exports.getBirthYear = getBirthYear;


/***/ }),

/***/ 5855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.injectStores = void 0;
const react_1 = __importDefault(__webpack_require__(8156));
const stores_1 = __webpack_require__(4547);
const injectStores = (WrappedComponent) => {
    const ExtendedComponent = class extends WrappedComponent {
        UNSAFE_componentWillMount() {
            Object.getOwnPropertyNames(this.props.rootStore).forEach((propertyName) => {
                if (this[propertyName] === undefined) {
                    Object.defineProperty(this, propertyName, {
                        ...Object.getOwnPropertyDescriptor(this, propertyName),
                        value: this.props.rootStore[propertyName]
                    });
                }
            });
        }
    };
    return (props) => {
        const rootStore = react_1.default.useContext(stores_1.ComponentRootStoreContext);
        return (react_1.default.createElement(ExtendedComponent, { ...props, rootStore: rootStore }, props.children));
    };
};
exports.injectStores = injectStores;


/***/ }),

/***/ 5085:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.valueOrDash = exports.capitalizeString = void 0;
const capitalizeString = (word) => {
    return word && word[0].toUpperCase() + word.slice(1).toLowerCase();
};
exports.capitalizeString = capitalizeString;
const valueOrDash = (value) => {
    return !!value ? value : '-';
};
exports.valueOrDash = valueOrDash;


/***/ }),

/***/ 2468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const mobx_react_1 = __webpack_require__(5264);
const React = __importStar(__webpack_require__(8156));
const react_1 = __webpack_require__(8156);
const ComponentRootStore_1 = __webpack_require__(5929);
const customerIdAsKey = (WrappedComponent) => {
    return (0, mobx_react_1.observer)((props) => {
        const rootStore = (0, react_1.useContext)(ComponentRootStore_1.ComponentRootStoreContext);
        return (React.createElement(WrappedComponent, { ...props, key: rootStore.componentSsoStore.customerId }, props.children));
    });
};
exports["default"] = customerIdAsKey;


/***/ }),

/***/ 8910:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getBirthYear = exports.isUnderage = exports.CountryUtil = exports.isContactInfoChanged = exports.ContactInfoType = exports.Language = void 0;
var ContactInfoUtil_1 = __webpack_require__(1203);
Object.defineProperty(exports, "Language", ({ enumerable: true, get: function () { return ContactInfoUtil_1.Language; } }));
Object.defineProperty(exports, "ContactInfoType", ({ enumerable: true, get: function () { return ContactInfoUtil_1.ContactInfoType; } }));
Object.defineProperty(exports, "isContactInfoChanged", ({ enumerable: true, get: function () { return ContactInfoUtil_1.isContactInfoChanged; } }));
var CountryUtil_1 = __webpack_require__(2531);
Object.defineProperty(exports, "CountryUtil", ({ enumerable: true, get: function () { return CountryUtil_1.CountryUtil; } }));
var PersonUtil_1 = __webpack_require__(9415);
Object.defineProperty(exports, "isUnderage", ({ enumerable: true, get: function () { return PersonUtil_1.isUnderage; } }));
Object.defineProperty(exports, "getBirthYear", ({ enumerable: true, get: function () { return PersonUtil_1.getBirthYear; } }));


/***/ }),

/***/ 8966:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _toDate = _interopRequireDefault(__webpack_require__(8469));

var _toFloat = _interopRequireDefault(__webpack_require__(7536));

var _toInt = _interopRequireDefault(__webpack_require__(1359));

var _toBoolean = _interopRequireDefault(__webpack_require__(557));

var _equals = _interopRequireDefault(__webpack_require__(2315));

var _contains = _interopRequireDefault(__webpack_require__(9466));

var _matches = _interopRequireDefault(__webpack_require__(661));

var _isEmail = _interopRequireDefault(__webpack_require__(3868));

var _isURL = _interopRequireDefault(__webpack_require__(2492));

var _isMACAddress = _interopRequireDefault(__webpack_require__(8999));

var _isIP = _interopRequireDefault(__webpack_require__(1028));

var _isIPRange = _interopRequireDefault(__webpack_require__(7795));

var _isFQDN = _interopRequireDefault(__webpack_require__(221));

var _isDate = _interopRequireDefault(__webpack_require__(2549));

var _isBoolean = _interopRequireDefault(__webpack_require__(9493));

var _isLocale = _interopRequireDefault(__webpack_require__(7380));

var _isAlpha = _interopRequireWildcard(__webpack_require__(9234));

var _isAlphanumeric = _interopRequireWildcard(__webpack_require__(4583));

var _isNumeric = _interopRequireDefault(__webpack_require__(4986));

var _isPassportNumber = _interopRequireDefault(__webpack_require__(542));

var _isPort = _interopRequireDefault(__webpack_require__(4595));

var _isLowercase = _interopRequireDefault(__webpack_require__(3928));

var _isUppercase = _interopRequireDefault(__webpack_require__(7245));

var _isIMEI = _interopRequireDefault(__webpack_require__(5566));

var _isAscii = _interopRequireDefault(__webpack_require__(4094));

var _isFullWidth = _interopRequireDefault(__webpack_require__(7146));

var _isHalfWidth = _interopRequireDefault(__webpack_require__(2941));

var _isVariableWidth = _interopRequireDefault(__webpack_require__(9019));

var _isMultibyte = _interopRequireDefault(__webpack_require__(3590));

var _isSemVer = _interopRequireDefault(__webpack_require__(6826));

var _isSurrogatePair = _interopRequireDefault(__webpack_require__(2828));

var _isInt = _interopRequireDefault(__webpack_require__(937));

var _isFloat = _interopRequireWildcard(__webpack_require__(9146));

var _isDecimal = _interopRequireDefault(__webpack_require__(5218));

var _isHexadecimal = _interopRequireDefault(__webpack_require__(7117));

var _isOctal = _interopRequireDefault(__webpack_require__(6090));

var _isDivisibleBy = _interopRequireDefault(__webpack_require__(8335));

var _isHexColor = _interopRequireDefault(__webpack_require__(6298));

var _isRgbColor = _interopRequireDefault(__webpack_require__(6454));

var _isHSL = _interopRequireDefault(__webpack_require__(6648));

var _isISRC = _interopRequireDefault(__webpack_require__(4339));

var _isIBAN = _interopRequireWildcard(__webpack_require__(8177));

var _isBIC = _interopRequireDefault(__webpack_require__(2438));

var _isMD = _interopRequireDefault(__webpack_require__(368));

var _isHash = _interopRequireDefault(__webpack_require__(8874));

var _isJWT = _interopRequireDefault(__webpack_require__(4979));

var _isJSON = _interopRequireDefault(__webpack_require__(1008));

var _isEmpty = _interopRequireDefault(__webpack_require__(4069));

var _isLength = _interopRequireDefault(__webpack_require__(4958));

var _isByteLength = _interopRequireDefault(__webpack_require__(3235));

var _isUUID = _interopRequireDefault(__webpack_require__(7278));

var _isMongoId = _interopRequireDefault(__webpack_require__(9131));

var _isAfter = _interopRequireDefault(__webpack_require__(3315));

var _isBefore = _interopRequireDefault(__webpack_require__(1464));

var _isIn = _interopRequireDefault(__webpack_require__(7228));

var _isCreditCard = _interopRequireDefault(__webpack_require__(682));

var _isIdentityCard = _interopRequireDefault(__webpack_require__(9396));

var _isEAN = _interopRequireDefault(__webpack_require__(5807));

var _isISIN = _interopRequireDefault(__webpack_require__(7148));

var _isISBN = _interopRequireDefault(__webpack_require__(7612));

var _isISSN = _interopRequireDefault(__webpack_require__(9887));

var _isTaxID = _interopRequireDefault(__webpack_require__(3058));

var _isMobilePhone = _interopRequireWildcard(__webpack_require__(8355));

var _isEthereumAddress = _interopRequireDefault(__webpack_require__(2129));

var _isCurrency = _interopRequireDefault(__webpack_require__(94));

var _isBtcAddress = _interopRequireDefault(__webpack_require__(8021));

var _isISO = _interopRequireDefault(__webpack_require__(5061));

var _isRFC = _interopRequireDefault(__webpack_require__(4611));

var _isISO31661Alpha = _interopRequireDefault(__webpack_require__(1727));

var _isISO31661Alpha2 = _interopRequireDefault(__webpack_require__(6776));

var _isISO2 = _interopRequireDefault(__webpack_require__(9963));

var _isBase = _interopRequireDefault(__webpack_require__(2782));

var _isBase2 = _interopRequireDefault(__webpack_require__(5008));

var _isBase3 = _interopRequireDefault(__webpack_require__(2689));

var _isDataURI = _interopRequireDefault(__webpack_require__(8983));

var _isMagnetURI = _interopRequireDefault(__webpack_require__(2776));

var _isMimeType = _interopRequireDefault(__webpack_require__(4554));

var _isLatLong = _interopRequireDefault(__webpack_require__(478));

var _isPostalCode = _interopRequireWildcard(__webpack_require__(8140));

var _ltrim = _interopRequireDefault(__webpack_require__(4959));

var _rtrim = _interopRequireDefault(__webpack_require__(9778));

var _trim = _interopRequireDefault(__webpack_require__(4790));

var _escape = _interopRequireDefault(__webpack_require__(5152));

var _unescape = _interopRequireDefault(__webpack_require__(4816));

var _stripLow = _interopRequireDefault(__webpack_require__(8035));

var _whitelist = _interopRequireDefault(__webpack_require__(4714));

var _blacklist = _interopRequireDefault(__webpack_require__(4928));

var _isWhitelisted = _interopRequireDefault(__webpack_require__(8346));

var _normalizeEmail = _interopRequireDefault(__webpack_require__(2900));

var _isSlug = _interopRequireDefault(__webpack_require__(8220));

var _isLicensePlate = _interopRequireDefault(__webpack_require__(2786));

var _isStrongPassword = _interopRequireDefault(__webpack_require__(7633));

var _isVAT = _interopRequireDefault(__webpack_require__(5977));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '13.7.0';
var validator = {
  version: version,
  toDate: _toDate.default,
  toFloat: _toFloat.default,
  toInt: _toInt.default,
  toBoolean: _toBoolean.default,
  equals: _equals.default,
  contains: _contains.default,
  matches: _matches.default,
  isEmail: _isEmail.default,
  isURL: _isURL.default,
  isMACAddress: _isMACAddress.default,
  isIP: _isIP.default,
  isIPRange: _isIPRange.default,
  isFQDN: _isFQDN.default,
  isBoolean: _isBoolean.default,
  isIBAN: _isIBAN.default,
  isBIC: _isBIC.default,
  isAlpha: _isAlpha.default,
  isAlphaLocales: _isAlpha.locales,
  isAlphanumeric: _isAlphanumeric.default,
  isAlphanumericLocales: _isAlphanumeric.locales,
  isNumeric: _isNumeric.default,
  isPassportNumber: _isPassportNumber.default,
  isPort: _isPort.default,
  isLowercase: _isLowercase.default,
  isUppercase: _isUppercase.default,
  isAscii: _isAscii.default,
  isFullWidth: _isFullWidth.default,
  isHalfWidth: _isHalfWidth.default,
  isVariableWidth: _isVariableWidth.default,
  isMultibyte: _isMultibyte.default,
  isSemVer: _isSemVer.default,
  isSurrogatePair: _isSurrogatePair.default,
  isInt: _isInt.default,
  isIMEI: _isIMEI.default,
  isFloat: _isFloat.default,
  isFloatLocales: _isFloat.locales,
  isDecimal: _isDecimal.default,
  isHexadecimal: _isHexadecimal.default,
  isOctal: _isOctal.default,
  isDivisibleBy: _isDivisibleBy.default,
  isHexColor: _isHexColor.default,
  isRgbColor: _isRgbColor.default,
  isHSL: _isHSL.default,
  isISRC: _isISRC.default,
  isMD5: _isMD.default,
  isHash: _isHash.default,
  isJWT: _isJWT.default,
  isJSON: _isJSON.default,
  isEmpty: _isEmpty.default,
  isLength: _isLength.default,
  isLocale: _isLocale.default,
  isByteLength: _isByteLength.default,
  isUUID: _isUUID.default,
  isMongoId: _isMongoId.default,
  isAfter: _isAfter.default,
  isBefore: _isBefore.default,
  isIn: _isIn.default,
  isCreditCard: _isCreditCard.default,
  isIdentityCard: _isIdentityCard.default,
  isEAN: _isEAN.default,
  isISIN: _isISIN.default,
  isISBN: _isISBN.default,
  isISSN: _isISSN.default,
  isMobilePhone: _isMobilePhone.default,
  isMobilePhoneLocales: _isMobilePhone.locales,
  isPostalCode: _isPostalCode.default,
  isPostalCodeLocales: _isPostalCode.locales,
  isEthereumAddress: _isEthereumAddress.default,
  isCurrency: _isCurrency.default,
  isBtcAddress: _isBtcAddress.default,
  isISO8601: _isISO.default,
  isRFC3339: _isRFC.default,
  isISO31661Alpha2: _isISO31661Alpha.default,
  isISO31661Alpha3: _isISO31661Alpha2.default,
  isISO4217: _isISO2.default,
  isBase32: _isBase.default,
  isBase58: _isBase2.default,
  isBase64: _isBase3.default,
  isDataURI: _isDataURI.default,
  isMagnetURI: _isMagnetURI.default,
  isMimeType: _isMimeType.default,
  isLatLong: _isLatLong.default,
  ltrim: _ltrim.default,
  rtrim: _rtrim.default,
  trim: _trim.default,
  escape: _escape.default,
  unescape: _unescape.default,
  stripLow: _stripLow.default,
  whitelist: _whitelist.default,
  blacklist: _blacklist.default,
  isWhitelisted: _isWhitelisted.default,
  normalizeEmail: _normalizeEmail.default,
  toString: toString,
  isSlug: _isSlug.default,
  isStrongPassword: _isStrongPassword.default,
  isTaxID: _isTaxID.default,
  isDate: _isDate.default,
  isLicensePlate: _isLicensePlate.default,
  isVAT: _isVAT.default,
  ibanLocales: _isIBAN.locales
};
var _default = validator;
exports["default"] = _default;
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 79:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.commaDecimal = exports.dotDecimal = exports.farsiLocales = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
var alpha = {
  'en-US': /^[A-Z]+$/i,
  'az-AZ': /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  'bg-BG': /^[А-Я]+$/i,
  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[A-ZÆØÅ]+$/i,
  'de-DE': /^[A-ZÄÖÜß]+$/i,
  'el-GR': /^[Α-ώ]+$/i,
  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  'fa-IR': /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  'fi-FI': /^[A-ZÅÄÖ]+$/i,
  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'nb-NO': /^[A-ZÆØÅ]+$/i,
  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[A-ZÆØÅ]+$/i,
  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  'ru-RU': /^[А-ЯЁ]+$/i,
  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[A-ZÅÄÖ]+$/i,
  'th-TH': /^[ก-๐\s]+$/i,
  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  'vi-VN': /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  'hi-IN': /^[\u0900-\u0961]+[\u0972-\u097F]*$/i
};
exports.alpha = alpha;
var alphanumeric = {
  'en-US': /^[0-9A-Z]+$/i,
  'az-AZ': /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  'bg-BG': /^[0-9А-Я]+$/i,
  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
  'el-GR': /^[0-9Α-ω]+$/i,
  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  'fi-FI': /^[0-9A-ZÅÄÖ]+$/i,
  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  'ru-RU': /^[0-9А-ЯЁ]+$/i,
  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
  'th-TH': /^[ก-๙\s]+$/i,
  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  'vi-VN': /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  'hi-IN': /^[\u0900-\u0963]+[\u0966-\u097F]*$/i
};
exports.alphanumeric = alphanumeric;
var decimal = {
  'en-US': '.',
  ar: '٫'
};
exports.decimal = decimal;
var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
exports.englishLocales = englishLocales;

for (var locale, i = 0; i < englishLocales.length; i++) {
  locale = "en-".concat(englishLocales[i]);
  alpha[locale] = alpha['en-US'];
  alphanumeric[locale] = alphanumeric['en-US'];
  decimal[locale] = decimal['en-US'];
} // Source: http://www.localeplanet.com/java/


var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
exports.arabicLocales = arabicLocales;

for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
  _locale = "ar-".concat(arabicLocales[_i]);
  alpha[_locale] = alpha.ar;
  alphanumeric[_locale] = alphanumeric.ar;
  decimal[_locale] = decimal.ar;
}

var farsiLocales = ['IR', 'AF'];
exports.farsiLocales = farsiLocales;

for (var _locale2, _i2 = 0; _i2 < farsiLocales.length; _i2++) {
  _locale2 = "fa-".concat(farsiLocales[_i2]);
  alphanumeric[_locale2] = alphanumeric.fa;
  decimal[_locale2] = decimal.ar;
} // Source: https://en.wikipedia.org/wiki/Decimal_mark


var dotDecimal = ['ar-EG', 'ar-LB', 'ar-LY'];
exports.dotDecimal = dotDecimal;
var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'en-ZM', 'es-ES', 'fr-CA', 'fr-FR', 'id-ID', 'it-IT', 'ku-IQ', 'hi-IN', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA', 'vi-VN'];
exports.commaDecimal = commaDecimal;

for (var _i3 = 0; _i3 < dotDecimal.length; _i3++) {
  decimal[dotDecimal[_i3]] = decimal['en-US'];
}

for (var _i4 = 0; _i4 < commaDecimal.length; _i4++) {
  decimal[commaDecimal[_i4]] = ',';
}

alpha['fr-CA'] = alpha['fr-FR'];
alphanumeric['fr-CA'] = alphanumeric['fr-FR'];
alpha['pt-BR'] = alpha['pt-PT'];
alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
decimal['pt-BR'] = decimal['pt-PT']; // see #862

alpha['pl-Pl'] = alpha['pl-PL'];
alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
decimal['pl-Pl'] = decimal['pl-PL']; // see #1455

alpha['fa-AF'] = alpha.fa;

/***/ }),

/***/ 4928:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = blacklist;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blacklist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9466:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = contains;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _toString = _interopRequireDefault(__webpack_require__(1913));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaulContainsOptions = {
  ignoreCase: false,
  minOccurrences: 1
};

function contains(str, elem, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, defaulContainsOptions);

  if (options.ignoreCase) {
    return str.toLowerCase().split((0, _toString.default)(elem).toLowerCase()).length > options.minOccurrences;
  }

  return str.split((0, _toString.default)(elem)).length > options.minOccurrences;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2315:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = equals;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function equals(str, comparison) {
  (0, _assertString.default)(str);
  return str === comparison;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 5152:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = escape;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3315:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAfter;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _toDate = _interopRequireDefault(__webpack_require__(8469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAfter(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original > comparison);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9234:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAlpha;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _alpha = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlpha(_str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  (0, _assertString.default)(_str);
  var str = _str;
  var ignore = options.ignore;

  if (ignore) {
    if (ignore instanceof RegExp) {
      str = str.replace(ignore, '');
    } else if (typeof ignore === 'string') {
      str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
    } else {
      throw new Error('ignore should be instance of a String or RegExp');
    }
  }

  if (locale in _alpha.alpha) {
    return _alpha.alpha[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alpha);
exports.locales = locales;

/***/ }),

/***/ 4583:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAlphanumeric;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _alpha = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlphanumeric(_str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  (0, _assertString.default)(_str);
  var str = _str;
  var ignore = options.ignore;

  if (ignore) {
    if (ignore instanceof RegExp) {
      str = str.replace(ignore, '');
    } else if (typeof ignore === 'string') {
      str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
    } else {
      throw new Error('ignore should be instance of a String or RegExp');
    }
  }

  if (locale in _alpha.alphanumeric) {
    return _alpha.alphanumeric[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alphanumeric);
exports.locales = locales;

/***/ }),

/***/ 4094:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAscii;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */

function isAscii(str) {
  (0, _assertString.default)(str);
  return ascii.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2438:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBIC;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isISO31661Alpha = __webpack_require__(1727);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://en.wikipedia.org/wiki/ISO_9362
var isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;

function isBIC(str) {
  (0, _assertString.default)(str); // toUpperCase() should be removed when a new major version goes out that changes
  // the regex to [A-Z] (per the spec).

  if (!_isISO31661Alpha.CountryCodes.has(str.slice(4, 6).toUpperCase())) {
    return false;
  }

  return isBICReg.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2782:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBase32;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base32 = /^[A-Z2-7]+=*$/;

function isBase32(str) {
  (0, _assertString.default)(str);
  var len = str.length;

  if (len % 8 === 0 && base32.test(str)) {
    return true;
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 5008:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBase58;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Accepted chars - 123456789ABCDEFGH JKLMN PQRSTUVWXYZabcdefghijk mnopqrstuvwxyz
var base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;

function isBase58(str) {
  (0, _assertString.default)(str);

  if (base58Reg.test(str)) {
    return true;
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2689:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBase64;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notBase64 = /[^A-Z0-9+\/=]/i;
var urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
var defaultBase64Options = {
  urlSafe: false
};

function isBase64(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, defaultBase64Options);
  var len = str.length;

  if (options.urlSafe) {
    return urlSafeBase64.test(str);
  }

  if (len % 4 !== 0 || notBase64.test(str)) {
    return false;
  }

  var firstPaddingChar = str.indexOf('=');
  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 1464:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBefore;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _toDate = _interopRequireDefault(__webpack_require__(8469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBefore(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original < comparison);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9493:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBoolean;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  loose: false
};
var strictBooleans = ['true', 'false', '1', '0'];
var looseBooleans = [].concat(strictBooleans, ['yes', 'no']);

function isBoolean(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  (0, _assertString.default)(str);

  if (options.loose) {
    return looseBooleans.includes(str.toLowerCase());
  }

  return strictBooleans.includes(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8021:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBtcAddress;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// supports Bech32 addresses
var bech32 = /^(bc1)[a-z0-9]{25,39}$/;
var base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;

function isBtcAddress(str) {
  (0, _assertString.default)(str); // check for bech32

  if (str.startsWith('bc1')) {
    return bech32.test(str);
  }

  return base58.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3235:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isByteLength;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 682:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isCreditCard;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 94:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isCurrency;

var _merge = _interopRequireDefault(__webpack_require__(4808));

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function currencyRegex(options) {
  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
  options.digits_after_decimal.forEach(function (digit, index) {
    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
  });
  var symbol = "(".concat(options.symbol.replace(/\W/, function (m) {
    return "\\".concat(m);
  }), ")").concat(options.require_symbol ? '' : '?'),
      negative = '-?',
      whole_dollar_amount_without_sep = '[1-9]\\d*',
      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)

  if (options.allow_negatives && !options.parens_for_negatives) {
    if (options.negative_sign_after_digits) {
      pattern += negative;
    } else if (options.negative_sign_before_digits) {
      pattern = negative + pattern;
    }
  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)


  if (options.allow_negative_sign_placeholder) {
    pattern = "( (?!\\-))?".concat(pattern);
  } else if (options.allow_space_after_symbol) {
    pattern = " ?".concat(pattern);
  } else if (options.allow_space_after_digits) {
    pattern += '( (?!$))?';
  }

  if (options.symbol_after_digits) {
    pattern += symbol;
  } else {
    pattern = symbol + pattern;
  }

  if (options.allow_negatives) {
    if (options.parens_for_negatives) {
      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
      pattern = negative + pattern;
    }
  } // ensure there's a dollar and/or decimal amount, and that
  // it doesn't start with a space or a negative sign followed by a space


  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}

var default_currency_options = {
  symbol: '$',
  require_symbol: false,
  allow_space_after_symbol: false,
  symbol_after_digits: false,
  allow_negatives: true,
  parens_for_negatives: false,
  negative_sign_before_digits: false,
  negative_sign_after_digits: false,
  allow_negative_sign_placeholder: false,
  thousands_separator: ',',
  decimal_separator: '.',
  allow_decimal: true,
  require_decimal: false,
  digits_after_decimal: [2],
  allow_space_after_digits: false
};

function isCurrency(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_currency_options);
  return currencyRegex(options).test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8983:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDataURI;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;

function isDataURI(str) {
  (0, _assertString.default)(str);
  var data = str.split(',');

  if (data.length < 2) {
    return false;
  }

  var attributes = data.shift().trim().split(';');
  var schemeAndMediaType = attributes.shift();

  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
    return false;
  }

  var mediaType = schemeAndMediaType.substr(5);

  if (mediaType !== '' && !validMediaType.test(mediaType)) {
    return false;
  }

  for (var i = 0; i < attributes.length; i++) {
    if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') && !validAttribute.test(attributes[i])) {
      return false;
    }
  }

  for (var _i = 0; _i < data.length; _i++) {
    if (!validData.test(data[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2549:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDate;

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var default_date_options = {
  format: 'YYYY/MM/DD',
  delimiters: ['/', '-'],
  strictMode: false
};

function isValidFormat(format) {
  return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
}

function zip(date, format) {
  var zippedArr = [],
      len = Math.min(date.length, format.length);

  for (var i = 0; i < len; i++) {
    zippedArr.push([date[i], format[i]]);
  }

  return zippedArr;
}

function isDate(input, options) {
  if (typeof options === 'string') {
    // Allow backward compatbility for old format isDate(input [, format])
    options = (0, _merge.default)({
      format: options
    }, default_date_options);
  } else {
    options = (0, _merge.default)(options, default_date_options);
  }

  if (typeof input === 'string' && isValidFormat(options.format)) {
    var formatDelimiter = options.delimiters.find(function (delimiter) {
      return options.format.indexOf(delimiter) !== -1;
    });
    var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function (delimiter) {
      return input.indexOf(delimiter) !== -1;
    });
    var dateAndFormat = zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
    var dateObj = {};

    var _iterator = _createForOfIteratorHelper(dateAndFormat),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            dateWord = _step$value[0],
            formatWord = _step$value[1];

        if (dateWord.length !== formatWord.length) {
          return false;
        }

        dateObj[formatWord.charAt(0)] = dateWord;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return new Date("".concat(dateObj.m, "/").concat(dateObj.d, "/").concat(dateObj.y)).getDate() === +dateObj.d;
  }

  if (!options.strictMode) {
    return Object.prototype.toString.call(input) === '[object Date]' && isFinite(input);
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 5218:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDecimal;

var _merge = _interopRequireDefault(__webpack_require__(4808));

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _includes = _interopRequireDefault(__webpack_require__(8343));

var _alpha = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function decimalRegExp(options) {
  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
  return regExp;
}

var default_decimal_options = {
  force_decimal: false,
  decimal_digits: '1,',
  locale: 'en-US'
};
var blacklist = ['', '-', '+'];

function isDecimal(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_decimal_options);

  if (options.locale in _alpha.decimal) {
    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
  }

  throw new Error("Invalid locale '".concat(options.locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8335:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDivisibleBy;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _toFloat = _interopRequireDefault(__webpack_require__(7536));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDivisibleBy(str, num) {
  (0, _assertString.default)(str);
  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 5807:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEAN;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The most commonly used EAN standard is
 * the thirteen-digit EAN-13, while the
 * less commonly used 8-digit EAN-8 barcode was
 * introduced for use on small packages.
 * Also EAN/UCC-14 is used for Grouping of individual
 * trade items above unit level(Intermediate, Carton or Pallet).
 * For more info about EAN-14 checkout: https://www.gtin.info/itf-14-barcodes/
 * EAN consists of:
 * GS1 prefix, manufacturer code, product code and check digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number
 * Reference: https://www.gtin.info/
 */

/**
 * Define EAN Lenghts; 8 for EAN-8; 13 for EAN-13; 14 for EAN-14
 * and Regular Expression for valid EANs (EAN-8, EAN-13, EAN-14),
 * with exact numberic matching of 8 or 13 or 14 digits [0-9]
 */
var LENGTH_EAN_8 = 8;
var LENGTH_EAN_14 = 14;
var validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
/**
 * Get position weight given:
 * EAN length and digit index/position
 *
 * @param {number} length
 * @param {number} index
 * @return {number}
 */

function getPositionWeightThroughLengthAndIndex(length, index) {
  if (length === LENGTH_EAN_8 || length === LENGTH_EAN_14) {
    return index % 2 === 0 ? 3 : 1;
  }

  return index % 2 === 0 ? 1 : 3;
}
/**
 * Calculate EAN Check Digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number#Calculation_of_checksum_digit
 *
 * @param {string} ean
 * @return {number}
 */


function calculateCheckDigit(ean) {
  var checksum = ean.slice(0, -1).split('').map(function (char, index) {
    return Number(char) * getPositionWeightThroughLengthAndIndex(ean.length, index);
  }).reduce(function (acc, partialSum) {
    return acc + partialSum;
  }, 0);
  var remainder = 10 - checksum % 10;
  return remainder < 10 ? remainder : 0;
}
/**
 * Check if string is valid EAN:
 * Matches EAN-8/EAN-13/EAN-14 regex
 * Has valid check digit.
 *
 * @param {string} str
 * @return {boolean}
 */


function isEAN(str) {
  (0, _assertString.default)(str);
  var actualCheckDigit = Number(str.slice(-1));
  return validEanRegex.test(str) && actualCheckDigit === calculateCheckDigit(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3868:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEmail;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _merge = _interopRequireDefault(__webpack_require__(4808));

var _isByteLength = _interopRequireDefault(__webpack_require__(3235));

var _isFQDN = _interopRequireDefault(__webpack_require__(221));

var _isIP = _interopRequireDefault(__webpack_require__(1028));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true,
  blacklisted_chars: '',
  ignore_max_length: false,
  host_blacklist: []
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var defaultMaxEmailLength = 254;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

/**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */

function validateDisplayName(display_name) {
  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid

  if (!display_name_without_quotes.trim()) {
    return false;
  } // check whether display name contains illegal character


  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);

  if (contains_illegal) {
    // if contains illegal characters,
    // must to be enclosed in double-quotes, otherwise it's not a valid display name
    if (display_name_without_quotes === display_name) {
      return false;
    } // the quotes in display name must start with character symbol \


    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;

    if (!all_start_with_back_slash) {
      return false;
    }
  }

  return true;
}

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(splitNameAddress);

    if (display_email) {
      var display_name = display_email[1]; // Remove display name and angle brackets to get email address
      // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)

      str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
      // because there may be a space between display name and email address
      // eg. myname <address@gmail.com>
      // the display name is `myname` instead of `myname `, so need to trim the last space

      if (display_name.endsWith(' ')) {
        display_name = display_name.substr(0, display_name.length - 1);
      }

      if (!validateDisplayName(display_name)) {
        return false;
      }
    } else if (options.require_display_name) {
      return false;
    }
  }

  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
    return false;
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var lower_domain = domain.toLowerCase();

  if (options.host_blacklist.includes(lower_domain)) {
    return false;
  }

  var user = parts.join('@');

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace(/\./g, ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  }))) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  if (options.blacklisted_chars) {
    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4069:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEmpty;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_is_empty_options = {
  ignore_whitespace: false
};

function isEmpty(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_is_empty_options);
  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2129:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEthereumAddress;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eth = /^(0x)[0-9a-f]{40}$/i;

function isEthereumAddress(str) {
  (0, _assertString.default)(str);
  return eth.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 221:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFQDN;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_numeric_tld: false,
  allow_wildcard: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  /* Remove the optional wildcard before checking validity */


  if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
    str = str.substring(2);
  }

  var parts = str.split('.');
  var tld = parts[parts.length - 1];

  if (options.require_tld) {
    // disallow fqdns without tld
    if (parts.length < 2) {
      return false;
    }

    if (!/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/\s/.test(tld)) {
      return false;
    }
  } // reject numeric TLDs


  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
    return false;
  }

  return parts.every(function (part) {
    if (part.length > 63) {
      return false;
    }

    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    } // disallow parts starting or ending with hyphen


    if (/^-|-$/.test(part)) {
      return false;
    }

    if (!options.allow_underscores && /_/.test(part)) {
      return false;
    }

    return true;
  });
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9146:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFloat;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _alpha = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFloat(str, options) {
  (0, _assertString.default)(str);
  options = options || {};
  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));

  if (str === '' || str === '.' || str === '-' || str === '+') {
    return false;
  }

  var value = parseFloat(str.replace(',', '.'));
  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
}

var locales = Object.keys(_alpha.decimal);
exports.locales = locales;

/***/ }),

/***/ 7146:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFullWidth;
exports.fullWidth = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.fullWidth = fullWidth;

function isFullWidth(str) {
  (0, _assertString.default)(str);
  return fullWidth.test(str);
}

/***/ }),

/***/ 6648:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHSL;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
var hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;

function isHSL(str) {
  (0, _assertString.default)(str); // Strip duplicate spaces before calling the validation regex (See  #1598 for more info)

  var strippedStr = str.replace(/\s+/g, ' ').replace(/\s?(hsla?\(|\)|,)\s?/ig, '$1');

  if (strippedStr.indexOf(',') !== -1) {
    return hslComma.test(strippedStr);
  }

  return hslSpace.test(strippedStr);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2941:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHalfWidth;
exports.halfWidth = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.halfWidth = halfWidth;

function isHalfWidth(str) {
  (0, _assertString.default)(str);
  return halfWidth.test(str);
}

/***/ }),

/***/ 8874:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHash;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lengths = {
  md5: 32,
  md4: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8
};

function isHash(str, algorithm) {
  (0, _assertString.default)(str);
  var hash = new RegExp("^[a-fA-F0-9]{".concat(lengths[algorithm], "}$"));
  return hash.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 6298:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHexColor;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;

function isHexColor(str) {
  (0, _assertString.default)(str);
  return hexcolor.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7117:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHexadecimal;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;

function isHexadecimal(str) {
  (0, _assertString.default)(str);
  return hexadecimal.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8177:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIBAN;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * List of country codes with
 * corresponding IBAN regular expression
 * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
 */
var ibanRegexThroughCountryCode = {
  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  AT: /^(AT[0-9]{2})\d{16}$/,
  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  BA: /^(BA[0-9]{2})\d{16}$/,
  BE: /^(BE[0-9]{2})\d{12}$/,
  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  CR: /^(CR[0-9]{2})\d{18}$/,
  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  CZ: /^(CZ[0-9]{2})\d{20}$/,
  DE: /^(DE[0-9]{2})\d{18}$/,
  DK: /^(DK[0-9]{2})\d{14}$/,
  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
  EE: /^(EE[0-9]{2})\d{16}$/,
  EG: /^(EG[0-9]{2})\d{25}$/,
  ES: /^(ES[0-9]{2})\d{20}$/,
  FI: /^(FI[0-9]{2})\d{14}$/,
  FO: /^(FO[0-9]{2})\d{14}$/,
  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
  GL: /^(GL[0-9]{2})\d{14}$/,
  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
  HR: /^(HR[0-9]{2})\d{17}$/,
  HU: /^(HU[0-9]{2})\d{24}$/,
  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
  IL: /^(IL[0-9]{2})\d{19}$/,
  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
  IS: /^(IS[0-9]{2})\d{22}$/,
  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  LT: /^(LT[0-9]{2})\d{16}$/,
  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
  ME: /^(ME[0-9]{2})\d{18}$/,
  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
  MR: /^(MR[0-9]{2})\d{23}$/,
  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
  MZ: /^(MZ[0-9]{2})\d{21}$/,
  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
  NO: /^(NO[0-9]{2})\d{11}$/,
  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  PL: /^(PL[0-9]{2})\d{24}$/,
  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
  PT: /^(PT[0-9]{2})\d{21}$/,
  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
  RS: /^(RS[0-9]{2})\d{18}$/,
  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
  SE: /^(SE[0-9]{2})\d{20}$/,
  SI: /^(SI[0-9]{2})\d{15}$/,
  SK: /^(SK[0-9]{2})\d{20}$/,
  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  TL: /^(TL[0-9]{2})\d{19}$/,
  TN: /^(TN[0-9]{2})\d{20}$/,
  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
  VA: /^(VA[0-9]{2})\d{18}$/,
  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  XK: /^(XK[0-9]{2})\d{16}$/
};
/**
 * Check whether string has correct universal IBAN format
 * The IBAN consists of up to 34 alphanumeric characters, as follows:
 * Country Code using ISO 3166-1 alpha-2, two letters
 * check digits, two digits and
 * Basic Bank Account Number (BBAN), up to 30 alphanumeric characters.
 * NOTE: Permitted IBAN characters are: digits [0-9] and the 26 latin alphabetic [A-Z]
 *
 * @param {string} str - string under validation
 * @return {boolean}
 */

function hasValidIbanFormat(str) {
  // Strip white spaces and hyphens
  var strippedStr = str.replace(/[\s\-]+/gi, '').toUpperCase();
  var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
  return isoCountryCode in ibanRegexThroughCountryCode && ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
}
/**
   * Check whether string has valid IBAN Checksum
   * by performing basic mod-97 operation and
   * the remainder should equal 1
   * -- Start by rearranging the IBAN by moving the four initial characters to the end of the string
   * -- Replace each letter in the string with two digits, A -> 10, B = 11, Z = 35
   * -- Interpret the string as a decimal integer and
   * -- compute the remainder on division by 97 (mod 97)
   * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
   *
   * @param {string} str
   * @return {boolean}
   */


function hasValidIbanChecksum(str) {
  var strippedStr = str.replace(/[^A-Z0-9]+/gi, '').toUpperCase(); // Keep only digits and A-Z latin alphabetic

  var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
  var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function (char) {
    return char.charCodeAt(0) - 55;
  });
  var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function (acc, value) {
    return Number(acc + value) % 97;
  }, '');
  return remainder === 1;
}

function isIBAN(str) {
  (0, _assertString.default)(str);
  return hasValidIbanFormat(str) && hasValidIbanChecksum(str);
}

var locales = Object.keys(ibanRegexThroughCountryCode);
exports.locales = locales;

/***/ }),

/***/ 5566:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIMEI;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imeiRegexWithoutHypens = /^[0-9]{15}$/;
var imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;

function isIMEI(str, options) {
  (0, _assertString.default)(str);
  options = options || {}; // default regex for checking imei is the one without hyphens

  var imeiRegex = imeiRegexWithoutHypens;

  if (options.allow_hyphens) {
    imeiRegex = imeiRegexWithHypens;
  }

  if (!imeiRegex.test(str)) {
    return false;
  }

  str = str.replace(/-/g, '');
  var sum = 0,
      mul = 2,
      l = 14;

  for (var i = 0; i < l; i++) {
    var digit = str.substring(l - i - 1, l - i);
    var tp = parseInt(digit, 10) * mul;

    if (tp >= 10) {
      sum += tp % 10 + 1;
    } else {
      sum += tp;
    }

    if (mul === 1) {
      mul += 1;
    } else {
      mul -= 1;
    }
  }

  var chk = (10 - sum % 10) % 10;

  if (chk !== parseInt(str.substring(14, 15), 10)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 1028:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIP;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */
var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  }

  if (version === '4') {
    if (!IPv4AddressRegExp.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  }

  if (version === '6') {
    return !!IPv6AddressRegExp.test(str);
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7795:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIPRange;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isIP = _interopRequireDefault(__webpack_require__(1028));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var subnetMaybe = /^\d{1,3}$/;
var v4Subnet = 32;
var v6Subnet = 128;

function isIPRange(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet

  if (parts.length !== 2) {
    return false;
  }

  if (!subnetMaybe.test(parts[1])) {
    return false;
  } // Disallow preceding 0 i.e. 01, 02, ...


  if (parts[1].length > 1 && parts[1].startsWith('0')) {
    return false;
  }

  var isValidIP = (0, _isIP.default)(parts[0], version);

  if (!isValidIP) {
    return false;
  } // Define valid subnet according to IP's version


  var expectedSubnet = null;

  switch (String(version)) {
    case '4':
      expectedSubnet = v4Subnet;
      break;

    case '6':
      expectedSubnet = v6Subnet;
      break;

    default:
      expectedSubnet = (0, _isIP.default)(parts[0], '6') ? v6Subnet : v4Subnet;
  }

  return parts[1] <= expectedSubnet && parts[1] >= 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7612:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISBN;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var isbn13Maybe = /^(?:[0-9]{13})$/;
var factor = [1, 3];

function isISBN(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isISBN(str, 10) || isISBN(str, 13);
  }

  var sanitized = str.replace(/[\s-]+/g, '');
  var checksum = 0;
  var i;

  if (version === '10') {
    if (!isbn10Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 9; i++) {
      checksum += (i + 1) * sanitized.charAt(i);
    }

    if (sanitized.charAt(9) === 'X') {
      checksum += 10 * 10;
    } else {
      checksum += 10 * sanitized.charAt(9);
    }

    if (checksum % 11 === 0) {
      return !!sanitized;
    }
  } else if (version === '13') {
    if (!isbn13Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 12; i++) {
      checksum += factor[i % 2] * sanitized.charAt(i);
    }

    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
      return !!sanitized;
    }
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7148:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISIN;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/; // this link details how the check digit is calculated:
// https://www.isin.org/isin-format/. it is a little bit
// odd in that it works with digits, not numbers. in order
// to make only one pass through the ISIN characters, the
// each alpha character is handled as 2 characters within
// the loop.

function isISIN(str) {
  (0, _assertString.default)(str);

  if (!isin.test(str)) {
    return false;
  }

  var double = true;
  var sum = 0; // convert values

  for (var i = str.length - 2; i >= 0; i--) {
    if (str[i] >= 'A' && str[i] <= 'Z') {
      var value = str[i].charCodeAt(0) - 55;
      var lo = value % 10;
      var hi = Math.trunc(value / 10); // letters have two digits, so handle the low order
      // and high order digits separately.

      for (var _i = 0, _arr = [lo, hi]; _i < _arr.length; _i++) {
        var digit = _arr[_i];

        if (double) {
          if (digit >= 5) {
            sum += 1 + (digit - 5) * 2;
          } else {
            sum += digit * 2;
          }
        } else {
          sum += digit;
        }

        double = !double;
      }
    } else {
      var _digit = str[i].charCodeAt(0) - '0'.charCodeAt(0);

      if (double) {
        if (_digit >= 5) {
          sum += 1 + (_digit - 5) * 2;
        } else {
          sum += _digit * 2;
        }
      } else {
        sum += _digit;
      }

      double = !double;
    }
  }

  var check = Math.trunc((sum + 9) / 10) * 10 - sum;
  return +str[str.length - 1] === check;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 1727:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO31661Alpha2;
exports.CountryCodes = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var validISO31661Alpha2CountriesCodes = new Set(['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW']);

function isISO31661Alpha2(str) {
  (0, _assertString.default)(str);
  return validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
}

var CountryCodes = validISO31661Alpha2CountriesCodes;
exports.CountryCodes = CountryCodes;

/***/ }),

/***/ 6776:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO31661Alpha3;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
var validISO31661Alpha3CountriesCodes = new Set(['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE']);

function isISO31661Alpha3(str) {
  (0, _assertString.default)(str);
  return validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9963:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO4217;
exports.CurrencyCodes = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_4217
var validISO4217CurrencyCodes = new Set(['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV', 'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF', 'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUC', 'CUP', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU', 'UYW', 'UZS', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT', 'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWL']);

function isISO4217(str) {
  (0, _assertString.default)(str);
  return validISO4217CurrencyCodes.has(str.toUpperCase());
}

var CurrencyCodes = validISO4217CurrencyCodes;
exports.CurrencyCodes = CurrencyCodes;

/***/ }),

/***/ 5061:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO8601;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
// from http://goo.gl/0ejHHW
var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/; // same as above, except with a strict 'T' separator between date and time

var iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */

var isValidDate = function isValidDate(str) {
  // str must have passed the ISO8601 check
  // this check is meant to catch invalid dates
  // like 2009-02-31
  // first check for ordinal dates
  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);

  if (ordinalMatch) {
    var oYear = Number(ordinalMatch[1]);
    var oDay = Number(ordinalMatch[2]); // if is leap year

    if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
    return oDay <= 365;
  }

  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
  var year = match[1];
  var month = match[2];
  var day = match[3];
  var monthString = month ? "0".concat(month).slice(-2) : month;
  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare

  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));

  if (month && day) {
    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
  }

  return true;
};

function isISO8601(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _assertString.default)(str);
  var check = options.strictSeparator ? iso8601StrictSeparator.test(str) : iso8601.test(str);
  if (check && options.strict) return isValidDate(str);
  return check;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4339:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISRC;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;

function isISRC(str) {
  (0, _assertString.default)(str);
  return isrc.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9887:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISSN;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var issn = '^\\d{4}-?\\d{3}[\\dX]$';

function isISSN(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _assertString.default)(str);
  var testIssn = issn;
  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');

  if (!testIssn.test(str)) {
    return false;
  }

  var digits = str.replace('-', '').toUpperCase();
  var checksum = 0;

  for (var i = 0; i < digits.length; i++) {
    var digit = digits[i];
    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
  }

  return checksum % 11 === 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9396:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIdentityCard;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isInt = _interopRequireDefault(__webpack_require__(937));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  PL: function PL(str) {
    (0, _assertString.default)(str);
    var weightOfDigits = {
      1: 1,
      2: 3,
      3: 7,
      4: 9,
      5: 1,
      6: 3,
      7: 7,
      8: 9,
      9: 1,
      10: 3,
      11: 0
    };

    if (str != null && str.length === 11 && (0, _isInt.default)(str, {
      allow_leading_zeroes: true
    })) {
      var digits = str.split('').slice(0, -1);
      var sum = digits.reduce(function (acc, digit, index) {
        return acc + Number(digit) * weightOfDigits[index + 1];
      }, 0);
      var modulo = sum % 10;
      var lastDigit = Number(str.charAt(str.length - 1));

      if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) {
        return true;
      }
    }

    return false;
  },
  ES: function ES(str) {
    (0, _assertString.default)(str);
    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
    var charsValue = {
      X: 0,
      Y: 1,
      Z: 2
    };
    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input

    var sanitized = str.trim().toUpperCase(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    } // validate the control digit


    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
      return charsValue[char];
    });
    return sanitized.endsWith(controlDigits[number % 23]);
  },
  FI: function FI(str) {
    // https://dvv.fi/en/personal-identity-code#:~:text=control%20character%20for%20a-,personal,-identity%20code%20calculated
    (0, _assertString.default)(str);

    if (str.length !== 11) {
      return false;
    }

    if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) {
      return false;
    }

    var checkDigits = '0123456789ABCDEFHJKLMNPRSTUVWXY';
    var idAsNumber = parseInt(str.slice(0, 6), 10) * 1000 + parseInt(str.slice(7, 10), 10);
    var remainder = idAsNumber % 31;
    var checkDigit = checkDigits[remainder];
    return checkDigit === str.slice(10, 11);
  },
  IN: function IN(str) {
    var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/; // multiplication table

    var d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]]; // permutation table

    var p = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]]; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    }

    var c = 0;
    var invertedArray = sanitized.replace(/\s/g, '').split('').map(Number).reverse();
    invertedArray.forEach(function (val, i) {
      c = d[c][p[i % 8][val]];
    });
    return c === 0;
  },
  IR: function IR(str) {
    if (!str.match(/^\d{10}$/)) return false;
    str = "0000".concat(str).substr(str.length - 6);
    if (parseInt(str.substr(3, 6), 10) === 0) return false;
    var lastNumber = parseInt(str.substr(9, 1), 10);
    var sum = 0;

    for (var i = 0; i < 9; i++) {
      sum += parseInt(str.substr(i, 1), 10) * (10 - i);
    }

    sum %= 11;
    return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
  },
  IT: function IT(str) {
    if (str.length !== 9) return false;
    if (str === 'CA00000AA') return false; // https://it.wikipedia.org/wiki/Carta_d%27identit%C3%A0_elettronica_italiana

    return str.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
  },
  NO: function NO(str) {
    var sanitized = str.trim();
    if (isNaN(Number(sanitized))) return false;
    if (sanitized.length !== 11) return false;
    if (sanitized === '00000000000') return false; // https://no.wikipedia.org/wiki/F%C3%B8dselsnummer

    var f = sanitized.split('').map(Number);
    var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
    var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
    if (k1 !== f[9] || k2 !== f[10]) return false;
    return true;
  },
  TH: function TH(str) {
    if (!str.match(/^[1-8]\d{12}$/)) return false; // validate check digit

    var sum = 0;

    for (var i = 0; i < 12; i++) {
      sum += parseInt(str[i], 10) * (13 - i);
    }

    return str[12] === ((11 - sum % 11) % 10).toString();
  },
  LK: function LK(str) {
    var old_nic = /^[1-9]\d{8}[vx]$/i;
    var new_nic = /^[1-9]\d{11}$/i;
    if (str.length === 10 && old_nic.test(str)) return true;else if (str.length === 12 && new_nic.test(str)) return true;
    return false;
  },
  'he-IL': function heIL(str) {
    var DNI = /^\d{9}$/; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    }

    var id = sanitized;
    var sum = 0,
        incNum;

    for (var i = 0; i < id.length; i++) {
      incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2

      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
    }

    return sum % 10 === 0;
  },
  'ar-LY': function arLY(str) {
    // Libya National Identity Number NIN is 12 digits, the first digit is either 1 or 2
    var NIN = /^(1|2)\d{11}$/; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!NIN.test(sanitized)) {
      return false;
    }

    return true;
  },
  'ar-TN': function arTN(str) {
    var DNI = /^\d{8}$/; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    }

    return true;
  },
  'zh-CN': function zhCN(str) {
    var provincesAndCities = ['11', // 北京
    '12', // 天津
    '13', // 河北
    '14', // 山西
    '15', // 内蒙古
    '21', // 辽宁
    '22', // 吉林
    '23', // 黑龙江
    '31', // 上海
    '32', // 江苏
    '33', // 浙江
    '34', // 安徽
    '35', // 福建
    '36', // 江西
    '37', // 山东
    '41', // 河南
    '42', // 湖北
    '43', // 湖南
    '44', // 广东
    '45', // 广西
    '46', // 海南
    '50', // 重庆
    '51', // 四川
    '52', // 贵州
    '53', // 云南
    '54', // 西藏
    '61', // 陕西
    '62', // 甘肃
    '63', // 青海
    '64', // 宁夏
    '65', // 新疆
    '71', // 台湾
    '81', // 香港
    '82', // 澳门
    '91' // 国外
    ];
    var powers = ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2'];
    var parityBit = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

    var checkAddressCode = function checkAddressCode(addressCode) {
      return provincesAndCities.includes(addressCode);
    };

    var checkBirthDayCode = function checkBirthDayCode(birDayCode) {
      var yyyy = parseInt(birDayCode.substring(0, 4), 10);
      var mm = parseInt(birDayCode.substring(4, 6), 10);
      var dd = parseInt(birDayCode.substring(6), 10);
      var xdata = new Date(yyyy, mm - 1, dd);

      if (xdata > new Date()) {
        return false; // eslint-disable-next-line max-len
      } else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
        return true;
      }

      return false;
    };

    var getParityBit = function getParityBit(idCardNo) {
      var id17 = idCardNo.substring(0, 17);
      var power = 0;

      for (var i = 0; i < 17; i++) {
        power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
      }

      var mod = power % 11;
      return parityBit[mod];
    };

    var checkParityBit = function checkParityBit(idCardNo) {
      return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
    };

    var check15IdCardNo = function check15IdCardNo(idCardNo) {
      var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
      if (!check) return false;
      var addressCode = idCardNo.substring(0, 2);
      check = checkAddressCode(addressCode);
      if (!check) return false;
      var birDayCode = "19".concat(idCardNo.substring(6, 12));
      check = checkBirthDayCode(birDayCode);
      if (!check) return false;
      return true;
    };

    var check18IdCardNo = function check18IdCardNo(idCardNo) {
      var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
      if (!check) return false;
      var addressCode = idCardNo.substring(0, 2);
      check = checkAddressCode(addressCode);
      if (!check) return false;
      var birDayCode = idCardNo.substring(6, 14);
      check = checkBirthDayCode(birDayCode);
      if (!check) return false;
      return checkParityBit(idCardNo);
    };

    var checkIdCardNo = function checkIdCardNo(idCardNo) {
      var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
      if (!check) return false;

      if (idCardNo.length === 15) {
        return check15IdCardNo(idCardNo);
      }

      return check18IdCardNo(idCardNo);
    };

    return checkIdCardNo(str);
  },
  'zh-TW': function zhTW(str) {
    var ALPHABET_CODES = {
      A: 10,
      B: 11,
      C: 12,
      D: 13,
      E: 14,
      F: 15,
      G: 16,
      H: 17,
      I: 34,
      J: 18,
      K: 19,
      L: 20,
      M: 21,
      N: 22,
      O: 35,
      P: 23,
      Q: 24,
      R: 25,
      S: 26,
      T: 27,
      U: 28,
      V: 29,
      W: 32,
      X: 30,
      Y: 31,
      Z: 33
    };
    var sanitized = str.trim().toUpperCase();
    if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
    return Array.from(sanitized).reduce(function (sum, number, index) {
      if (index === 0) {
        var code = ALPHABET_CODES[number];
        return code % 10 * 9 + Math.floor(code / 10);
      }

      if (index === 9) {
        return (10 - sum % 10 - Number(number)) % 10 === 0;
      }

      return sum + Number(number) * (9 - index);
    }, 0);
  }
};

function isIdentityCard(str, locale) {
  (0, _assertString.default)(str);

  if (locale in validators) {
    return validators[locale](str);
  } else if (locale === 'any') {
    for (var key in validators) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if (validators.hasOwnProperty(key)) {
        var validator = validators[key];

        if (validator(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7228:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIn;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _toString = _interopRequireDefault(__webpack_require__(1913));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isIn(str, options) {
  (0, _assertString.default)(str);
  var i;

  if (Object.prototype.toString.call(options) === '[object Array]') {
    var array = [];

    for (i in options) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if ({}.hasOwnProperty.call(options, i)) {
        array[i] = (0, _toString.default)(options[i]);
      }
    }

    return array.indexOf(str) >= 0;
  } else if (_typeof(options) === 'object') {
    return options.hasOwnProperty(str);
  } else if (options && typeof options.indexOf === 'function') {
    return options.indexOf(str) >= 0;
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 937:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isInt;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var intLeadingZeroes = /^[-+]?[0-9]+$/;

function isInt(str, options) {
  (0, _assertString.default)(str);
  options = options || {}; // Get the regex to use for testing, based on whether
  // leading zeroes are allowed or not.

  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt

  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 1008:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isJSON;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var default_json_options = {
  allow_primitives: false
};

function isJSON(str, options) {
  (0, _assertString.default)(str);

  try {
    options = (0, _merge.default)(options, default_json_options);
    var primitives = [];

    if (options.allow_primitives) {
      primitives = [null, false, true];
    }

    var obj = JSON.parse(str);
    return primitives.includes(obj) || !!obj && _typeof(obj) === 'object';
  } catch (e) {
    /* ignore */
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4979:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isJWT;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isBase = _interopRequireDefault(__webpack_require__(2689));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isJWT(str) {
  (0, _assertString.default)(str);
  var dotSplit = str.split('.');
  var len = dotSplit.length;

  if (len > 3 || len < 2) {
    return false;
  }

  return dotSplit.reduce(function (acc, currElem) {
    return acc && (0, _isBase.default)(currElem, {
      urlSafe: true
    });
  }, true);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 478:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLatLong;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
var latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
var longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
var defaultLatLongOptions = {
  checkDMS: false
};

function isLatLong(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, defaultLatLongOptions);
  if (!str.includes(',')) return false;
  var pair = str.split(',');
  if (pair[0].startsWith('(') && !pair[1].endsWith(')') || pair[1].endsWith(')') && !pair[0].startsWith('(')) return false;

  if (options.checkDMS) {
    return latDMS.test(pair[0]) && longDMS.test(pair[1]);
  }

  return lat.test(pair[0]) && long.test(pair[1]);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4958:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLength;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1] || 0;
    max = arguments[2];
  }

  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2786:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLicensePlate;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  'cs-CZ': function csCZ(str) {
    return /^(([ABCDEFHKIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
  },
  'de-DE': function deDE(str) {
    return /^((AW|UL|AK|GA|AÖ|LF|AZ|AM|AS|ZE|AN|AB|A|KG|KH|BA|EW|BZ|HY|KM|BT|HP|B|BC|BI|BO|FN|TT|ÜB|BN|AH|BS|FR|HB|ZZ|BB|BK|BÖ|OC|OK|CW|CE|C|CO|LH|CB|KW|LC|LN|DA|DI|DE|DH|SY|NÖ|DO|DD|DU|DN|D|EI|EA|EE|FI|EM|EL|EN|PF|ED|EF|ER|AU|ZP|E|ES|NT|EU|FL|FO|FT|FF|F|FS|FD|FÜ|GE|G|GI|GF|GS|ZR|GG|GP|GR|NY|ZI|GÖ|GZ|GT|HA|HH|HM|HU|WL|HZ|WR|RN|HK|HD|HN|HS|GK|HE|HF|RZ|HI|HG|HO|HX|IK|IL|IN|J|JL|KL|KA|KS|KF|KE|KI|KT|KO|KN|KR|KC|KU|K|LD|LL|LA|L|OP|LM|LI|LB|LU|LÖ|HL|LG|MD|GN|MZ|MA|ML|MR|MY|AT|DM|MC|NZ|RM|RG|MM|ME|MB|MI|FG|DL|HC|MW|RL|MK|MG|MÜ|WS|MH|M|MS|NU|NB|ND|NM|NK|NW|NR|NI|NF|DZ|EB|OZ|TG|TO|N|OA|GM|OB|CA|EH|FW|OF|OL|OE|OG|BH|LR|OS|AA|GD|OH|KY|NP|WK|PB|PA|PE|PI|PS|P|PM|PR|RA|RV|RE|R|H|SB|WN|RS|RD|RT|BM|NE|GV|RP|SU|GL|RO|GÜ|RH|EG|RW|PN|SK|MQ|RU|SZ|RI|SL|SM|SC|HR|FZ|VS|SW|SN|CR|SE|SI|SO|LP|SG|NH|SP|IZ|ST|BF|TE|HV|OD|SR|S|AC|DW|ZW|TF|TS|TR|TÜ|UM|PZ|TP|UE|UN|UH|MN|KK|VB|V|AE|PL|RC|VG|GW|PW|VR|VK|KB|WA|WT|BE|WM|WE|AP|MO|WW|FB|WZ|WI|WB|JE|WF|WO|W|WÜ|BL|Z|GC)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(AIC|FDB|ABG|SLN|SAW|KLZ|BUL|ESB|NAB|SUL|WST|ABI|AZE|BTF|KÖT|DKB|FEU|ROT|ALZ|SMÜ|WER|AUR|NOR|DÜW|BRK|HAB|TÖL|WOR|BAD|BAR|BER|BIW|EBS|KEM|MÜB|PEG|BGL|BGD|REI|WIL|BKS|BIR|WAT|BOR|BOH|BOT|BRB|BLK|HHM|NEB|NMB|WSF|LEO|HDL|WMS|WZL|BÜS|CHA|KÖZ|ROD|WÜM|CLP|NEC|COC|ZEL|COE|CUX|DAH|LDS|DEG|DEL|RSL|DLG|DGF|LAN|HEI|MED|DON|KIB|ROK|JÜL|MON|SLE|EBE|EIC|HIG|WBS|BIT|PRÜ|LIB|EMD|WIT|ERH|HÖS|ERZ|ANA|ASZ|MAB|MEK|STL|SZB|FDS|HCH|HOR|WOL|FRG|GRA|WOS|FRI|FFB|GAP|GER|BRL|CLZ|GTH|NOH|HGW|GRZ|LÖB|NOL|WSW|DUD|HMÜ|OHA|KRU|HAL|HAM|HBS|QLB|HVL|NAU|HAS|EBN|GEO|HOH|HDH|ERK|HER|WAN|HEF|ROF|HBN|ALF|HSK|USI|NAI|REH|SAN|KÜN|ÖHR|HOL|WAR|ARN|BRG|GNT|HOG|WOH|KEH|MAI|PAR|RID|ROL|KLE|GEL|KUS|KYF|ART|SDH|LDK|DIL|MAL|VIB|LER|BNA|GHA|GRM|MTL|WUR|LEV|LIF|STE|WEL|LIP|VAI|LUP|HGN|LBZ|LWL|PCH|STB|DAN|MKK|SLÜ|MSP|TBB|MGH|MTK|BIN|MSH|EIL|HET|SGH|BID|MYK|MSE|MST|MÜR|WRN|MEI|GRH|RIE|MZG|MIL|OBB|BED|FLÖ|MOL|FRW|SEE|SRB|AIB|MOS|BCH|ILL|SOB|NMS|NEA|SEF|UFF|NEW|VOH|NDH|TDO|NWM|GDB|GVM|WIS|NOM|EIN|GAN|LAU|HEB|OHV|OSL|SFB|ERB|LOS|BSK|KEL|BSB|MEL|WTL|OAL|FÜS|MOD|OHZ|OPR|BÜR|PAF|PLÖ|CAS|GLA|REG|VIT|ECK|SIM|GOA|EMS|DIZ|GOH|RÜD|SWA|NES|KÖN|MET|LRO|BÜZ|DBR|ROS|TET|HRO|ROW|BRV|HIP|PAN|GRI|SHK|EIS|SRO|SOK|LBS|SCZ|MER|QFT|SLF|SLS|HOM|SLK|ASL|BBG|SBK|SFT|SHG|MGN|MEG|ZIG|SAD|NEN|OVI|SHA|BLB|SIG|SON|SPN|FOR|GUB|SPB|IGB|WND|STD|STA|SDL|OBG|HST|BOG|SHL|PIR|FTL|SEB|SÖM|SÜW|TIR|SAB|TUT|ANG|SDT|LÜN|LSZ|MHL|VEC|VER|VIE|OVL|ANK|OVP|SBG|UEM|UER|WLG|GMN|NVP|RDG|RÜG|DAU|FKB|WAF|WAK|SLZ|WEN|SOG|APD|WUG|GUN|ESW|WIZ|WES|DIN|BRA|BÜD|WHV|HWI|GHC|WTM|WOB|WUN|MAK|SEL|OCH|HOT|WDA)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
  },
  'de-LI': function deLI(str) {
    return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
  },
  'fi-FI': function fiFI(str) {
    return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
  },
  'pt-PT': function ptPT(str) {
    return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
  },
  'sq-AL': function sqAL(str) {
    return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
  },
  'pt-BR': function ptBR(str) {
    return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
  }
};

function isLicensePlate(str, locale) {
  (0, _assertString.default)(str);

  if (locale in validators) {
    return validators[locale](str);
  } else if (locale === 'any') {
    for (var key in validators) {
      /* eslint guard-for-in: 0 */
      var validator = validators[key];

      if (validator(str)) {
        return true;
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7380:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLocale;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localeReg = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/;

function isLocale(str) {
  (0, _assertString.default)(str);

  if (str === 'en_US_POSIX' || str === 'ca_ES_VALENCIA') {
    return true;
  }

  return localeReg.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3928:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLowercase;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLowercase(str) {
  (0, _assertString.default)(str);
  return str === str.toLowerCase();
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8999:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMACAddress;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var macAddress = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
var macAddressNoSeparators = /^([0-9a-fA-F]){12}$/;
var macAddressWithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;

function isMACAddress(str, options) {
  (0, _assertString.default)(str);
  /**
   * @deprecated `no_colons` TODO: remove it in the next major
  */

  if (options && (options.no_colons || options.no_separators)) {
    return macAddressNoSeparators.test(str);
  }

  return macAddress.test(str) || macAddressWithDots.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 368:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMD5;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md5 = /^[a-f0-9]{32}$/;

function isMD5(str) {
  (0, _assertString.default)(str);
  return md5.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2776:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMagnetURI;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var magnetURI = /^magnet:\?xt(?:\.1)?=urn:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?($|&)/i;

function isMagnetURI(url) {
  (0, _assertString.default)(url);
  return magnetURI.test(url.trim());
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4554:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMimeType;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/
// Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"

var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"

var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len

function isMimeType(str) {
  (0, _assertString.default)(str);
  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8355:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMobilePhone;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'am-AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
  'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-LB': /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
  'ar-KW': /^(\+?965)[569]\d{7}$/,
  'ar-LY': /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  'ar-MA': /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  'ar-OM': /^((\+|00)968)?(9[1-9])\d{6}$/,
  'ar-PS': /^(\+?970|0)5[6|9](\d{7})$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
  'az-AZ': /^(\+994|0)(5[015]|7[07]|99)\d{7}$/,
  'bs-BA': /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
  'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
  'ca-AD': /^(\+376)?[346]\d{5}$/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'de-DE': /^((\+49|0)[1|3])([0|5][0-45-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
  'de-CH': /^(\+41|0)([1-9])\d{1,9}$/,
  'de-LU': /^(\+352)?((6\d1)\d{6})$/,
  'dv-MV': /^(\+?960)?(7[2-9]|91|9[3-9])\d{7}$/,
  'el-GR': /^(\+?30|0)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-BM': /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}))/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-GG': /^(\+?44|0)1481\d{6}$/,
  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  'en-GY': /^(\+592|0)6\d{6}$/,
  'en-HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  'en-MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
  'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
  'en-KI': /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  'en-MU': /^(\+?230|0)?\d{8}$/,
  'en-NA': /^(\+?264|0)(6|8)\d{7}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
  'en-PK': /^((00|\+)?92|0)3[0-6]\d{8}$/,
  'en-PH': /^(09|\+639)\d{9}$/,
  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
  'en-SG': /^(\+65)?[3689]\d{7}$/,
  'en-SL': /^(\+?232|0)\d{8}$/,
  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'en-ZW': /^(\+263)[0-9]{9}$/,
  'en-BW': /^(\+?267)?(7[1-8]{1})\d{6}$/,
  'es-AR': /^\+?549(11|[2368]\d)\d{8}$/,
  'es-BO': /^(\+?591)?(6|7)\d{7}$/,
  'es-CO': /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  'es-CR': /^(\+506)?[2-8]\d{7}$/,
  'es-CU': /^(\+53|0053)?5\d{7}/,
  'es-DO': /^(\+?1)?8[024]9\d{7}$/,
  'es-HN': /^(\+?504)?[9|8]\d{7}$/,
  'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  'es-ES': /^(\+?34)?[6|7]\d{8}$/,
  'es-PE': /^(\+?51)?9\d{8}$/,
  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
  'es-PA': /^(\+?507)\d{7,8}$/,
  'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
  'es-SV': /^(\+?503)?[67]\d{7}$/,
  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
  'es-VE': /^(\+?58)?(2|4)\d{9}$/,
  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
  'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'fr-BF': /^(\+226|0)[67]\d{7}$/,
  'fr-CM': /^(\+?237)6[0-9]{8}$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
  'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
  'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
  'fr-PF': /^(\+?689)?8[789]\d{6}$/,
  'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  'hu-HU': /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'it-SM': /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  'ka-GE': /^(\+?995)?(5|79)\d{7}$/,
  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  'lt-LT': /^(\+370|8)\d{8}$/,
  'lv-LV': /^(\+?371)2\d{7}$/,
  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'mz-MZ': /^(\+?258)?8[234567]\d{7}$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'ne-NP': /^(\+?977)?9[78]\d{8}$/,
  'nl-BE': /^(\+?32|0)4\d{8}$/,
  'nl-NL': /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[2-9]{1}\d{3}\-?\d{4}))$/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'pt-AO': /^(\+244)\d{9}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'si-LK': /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'sq-AL': /^(\+355|0)6[789]\d{6}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  'tg-TJ': /^(\+?992)?[5][5]\d{7}$/,
  'th-TH': /^(\+66|66|0)\d{9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'tk-TM': /^(\+993|993|8)\d{8}$/,
  'uk-UA': /^(\+?38|8)?0\d{9}$/,
  'uz-UZ': /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  'vi-VN': /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  'zh-CN': /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/,
  'dz-BT': /^(\+?975|0)?(17|16|77|02)\d{6}$/
};
/* eslint-enable max-len */
// aliases

phones['en-CA'] = phones['en-US'];
phones['fr-CA'] = phones['en-CA'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];
phones['zh-MO'] = phones['en-MO'];
phones['ga-IE'] = phones['en-IE'];
phones['fr-CH'] = phones['de-CH'];
phones['it-CH'] = phones['fr-CH'];

function isMobilePhone(str, locale, options) {
  (0, _assertString.default)(str);

  if (options && options.strictMode && !str.startsWith('+')) {
    return false;
  }

  if (Array.isArray(locale)) {
    return locale.some(function (key) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }

      return false;
    });
  } else if (locale in phones) {
    return phones[locale].test(str); // alias falsey locale as 'any'
  } else if (!locale || locale === 'any') {
    for (var key in phones) {
      // istanbul ignore else
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(phones);
exports.locales = locales;

/***/ }),

/***/ 9131:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMongoId;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isHexadecimal = _interopRequireDefault(__webpack_require__(7117));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMongoId(str) {
  (0, _assertString.default)(str);
  return (0, _isHexadecimal.default)(str) && str.length === 24;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3590:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMultibyte;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */

function isMultibyte(str) {
  (0, _assertString.default)(str);
  return multibyte.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4986:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isNumeric;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _alpha = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numericNoSymbols = /^[0-9]+$/;

function isNumeric(str, options) {
  (0, _assertString.default)(str);

  if (options && options.no_symbols) {
    return numericNoSymbols.test(str);
  }

  return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? _alpha.decimal[options.locale] : '.', "])?[0-9]+$")).test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 6090:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isOctal;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var octal = /^(0o)?[0-7]+$/i;

function isOctal(str) {
  (0, _assertString.default)(str);
  return octal.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 542:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPassportNumber;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Reference:
 * https://en.wikipedia.org/ -- Wikipedia
 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
 * https://countrycode.org/ -- Country Codes
 */
var passportRegexByCountryCode = {
  AM: /^[A-Z]{2}\d{7}$/,
  // ARMENIA
  AR: /^[A-Z]{3}\d{6}$/,
  // ARGENTINA
  AT: /^[A-Z]\d{7}$/,
  // AUSTRIA
  AU: /^[A-Z]\d{7}$/,
  // AUSTRALIA
  BE: /^[A-Z]{2}\d{6}$/,
  // BELGIUM
  BG: /^\d{9}$/,
  // BULGARIA
  BR: /^[A-Z]{2}\d{6}$/,
  // BRAZIL
  BY: /^[A-Z]{2}\d{7}$/,
  // BELARUS
  CA: /^[A-Z]{2}\d{6}$/,
  // CANADA
  CH: /^[A-Z]\d{7}$/,
  // SWITZERLAND
  CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
  // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
  CY: /^[A-Z](\d{6}|\d{8})$/,
  // CYPRUS
  CZ: /^\d{8}$/,
  // CZECH REPUBLIC
  DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
  // GERMANY
  DK: /^\d{9}$/,
  // DENMARK
  DZ: /^\d{9}$/,
  // ALGERIA
  EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
  // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
  ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
  // SPAIN
  FI: /^[A-Z]{2}\d{7}$/,
  // FINLAND
  FR: /^\d{2}[A-Z]{2}\d{5}$/,
  // FRANCE
  GB: /^\d{9}$/,
  // UNITED KINGDOM
  GR: /^[A-Z]{2}\d{7}$/,
  // GREECE
  HR: /^\d{9}$/,
  // CROATIA
  HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
  // HUNGARY
  IE: /^[A-Z0-9]{2}\d{7}$/,
  // IRELAND
  IN: /^[A-Z]{1}-?\d{7}$/,
  // INDIA
  ID: /^[A-C]\d{7}$/,
  // INDONESIA
  IR: /^[A-Z]\d{8}$/,
  // IRAN
  IS: /^(A)\d{7}$/,
  // ICELAND
  IT: /^[A-Z0-9]{2}\d{7}$/,
  // ITALY
  JP: /^[A-Z]{2}\d{7}$/,
  // JAPAN
  KR: /^[MS]\d{8}$/,
  // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
  LT: /^[A-Z0-9]{8}$/,
  // LITHUANIA
  LU: /^[A-Z0-9]{8}$/,
  // LUXEMBURG
  LV: /^[A-Z0-9]{2}\d{7}$/,
  // LATVIA
  LY: /^[A-Z0-9]{8}$/,
  // LIBYA
  MT: /^\d{7}$/,
  // MALTA
  MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
  // MOZAMBIQUE
  MY: /^[AHK]\d{8}$/,
  // MALAYSIA
  NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
  // NETHERLANDS
  PL: /^[A-Z]{2}\d{7}$/,
  // POLAND
  PT: /^[A-Z]\d{6}$/,
  // PORTUGAL
  RO: /^\d{8,9}$/,
  // ROMANIA
  RU: /^\d{9}$/,
  // RUSSIAN FEDERATION
  SE: /^\d{8}$/,
  // SWEDEN
  SL: /^(P)[A-Z]\d{7}$/,
  // SLOVANIA
  SK: /^[0-9A-Z]\d{7}$/,
  // SLOVAKIA
  TR: /^[A-Z]\d{8}$/,
  // TURKEY
  UA: /^[A-Z]{2}\d{6}$/,
  // UKRAINE
  US: /^\d{9}$/ // UNITED STATES

};
/**
 * Check if str is a valid passport number
 * relative to provided ISO Country Code.
 *
 * @param {string} str
 * @param {string} countryCode
 * @return {boolean}
 */

function isPassportNumber(str, countryCode) {
  (0, _assertString.default)(str);
  /** Remove All Whitespaces, Convert to UPPERCASE */

  var normalizedStr = str.replace(/\s/g, '').toUpperCase();
  return countryCode.toUpperCase() in passportRegexByCountryCode && passportRegexByCountryCode[countryCode].test(normalizedStr);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4595:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPort;

var _isInt = _interopRequireDefault(__webpack_require__(937));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPort(str) {
  return (0, _isInt.default)(str, {
    min: 0,
    max: 65535
  });
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8140:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPostalCode;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// common patterns
var threeDigit = /^\d{3}$/;
var fourDigit = /^\d{4}$/;
var fiveDigit = /^\d{5}$/;
var sixDigit = /^\d{6}$/;
var patterns = {
  AD: /^AD\d{3}$/,
  AT: fourDigit,
  AU: fourDigit,
  AZ: /^AZ\d{4}$/,
  BE: fourDigit,
  BG: fourDigit,
  BR: /^\d{5}-\d{3}$/,
  BY: /2[1-4]{1}\d{4}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: fourDigit,
  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: fiveDigit,
  DK: fourDigit,
  DO: fiveDigit,
  DZ: fiveDigit,
  EE: fiveDigit,
  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
  FI: fiveDigit,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HT: /^HT\d{4}$/,
  HU: fourDigit,
  ID: fiveDigit,
  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
  IL: /^(\d{5}|\d{7})$/,
  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
  IR: /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/,
  IS: threeDigit,
  IT: fiveDigit,
  JP: /^\d{3}\-\d{4}$/,
  KE: fiveDigit,
  KR: /^(\d{5}|\d{6})$/,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: fourDigit,
  LV: /^LV\-\d{4}$/,
  LK: fiveDigit,
  MX: fiveDigit,
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
  MY: fiveDigit,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: fourDigit,
  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
  NZ: fourDigit,
  PL: /^\d{2}\-\d{3}$/,
  PR: /^00[679]\d{2}([ -]\d{4})?$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: sixDigit,
  RU: sixDigit,
  SA: fiveDigit,
  SE: /^[1-9]\d{2}\s?\d{2}$/,
  SG: sixDigit,
  SI: fourDigit,
  SK: /^\d{3}\s?\d{2}$/,
  TH: fiveDigit,
  TN: fourDigit,
  TW: /^\d{3}(\d{2})?$/,
  UA: fiveDigit,
  US: /^\d{5}(-\d{4})?$/,
  ZA: fourDigit,
  ZM: fiveDigit
};
var locales = Object.keys(patterns);
exports.locales = locales;

function isPostalCode(str, locale) {
  (0, _assertString.default)(str);

  if (locale in patterns) {
    return patterns[locale].test(str);
  } else if (locale === 'any') {
    for (var key in patterns) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if (patterns.hasOwnProperty(key)) {
        var pattern = patterns[key];

        if (pattern.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

/***/ }),

/***/ 4611:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isRFC3339;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
var dateFullYear = /[0-9]{4}/;
var dateMonth = /(0[1-9]|1[0-2])/;
var dateMDay = /([12]\d|0[1-9]|3[01])/;
var timeHour = /([01][0-9]|2[0-3])/;
var timeMinute = /[0-5][0-9]/;
var timeSecond = /([0-5][0-9]|60)/;
var timeSecFrac = /(\.[0-9]+)?/;
var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
var rfc3339 = new RegExp("^".concat(fullDate.source, "[ tT]").concat(fullTime.source, "$"));

function isRFC3339(str) {
  (0, _assertString.default)(str);
  return rfc3339.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 6454:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isRgbColor;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
var rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
var rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/;
var rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/;

function isRgbColor(str) {
  var includePercentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  (0, _assertString.default)(str);

  if (!includePercentValues) {
    return rgbColor.test(str) || rgbaColor.test(str);
  }

  return rgbColor.test(str) || rgbaColor.test(str) || rgbColorPercent.test(str) || rgbaColorPercent.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 6826:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSemVer;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _multilineRegex = _interopRequireDefault(__webpack_require__(4731));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Regular Expression to match
 * semantic versioning (SemVer)
 * built from multi-line, multi-parts regexp
 * Reference: https://semver.org/
 */
var semanticVersioningRegex = (0, _multilineRegex.default)(['^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)', '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))', '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$'], 'i');

function isSemVer(str) {
  (0, _assertString.default)(str);
  return semanticVersioningRegex.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8220:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSlug;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;

function isSlug(str) {
  (0, _assertString.default)(str);
  return charsetRegex.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7633:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isStrongPassword;

var _merge = _interopRequireDefault(__webpack_require__(4808));

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var upperCaseRegex = /^[A-Z]$/;
var lowerCaseRegex = /^[a-z]$/;
var numberRegex = /^[0-9]$/;
var symbolRegex = /^[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/;
var defaultOptions = {
  minLength: 8,
  minLowercase: 1,
  minUppercase: 1,
  minNumbers: 1,
  minSymbols: 1,
  returnScore: false,
  pointsPerUnique: 1,
  pointsPerRepeat: 0.5,
  pointsForContainingLower: 10,
  pointsForContainingUpper: 10,
  pointsForContainingNumber: 10,
  pointsForContainingSymbol: 10
};
/* Counts number of occurrences of each char in a string
 * could be moved to util/ ?
*/

function countChars(str) {
  var result = {};
  Array.from(str).forEach(function (char) {
    var curVal = result[char];

    if (curVal) {
      result[char] += 1;
    } else {
      result[char] = 1;
    }
  });
  return result;
}
/* Return information about a password */


function analyzePassword(password) {
  var charMap = countChars(password);
  var analysis = {
    length: password.length,
    uniqueChars: Object.keys(charMap).length,
    uppercaseCount: 0,
    lowercaseCount: 0,
    numberCount: 0,
    symbolCount: 0
  };
  Object.keys(charMap).forEach(function (char) {
    /* istanbul ignore else */
    if (upperCaseRegex.test(char)) {
      analysis.uppercaseCount += charMap[char];
    } else if (lowerCaseRegex.test(char)) {
      analysis.lowercaseCount += charMap[char];
    } else if (numberRegex.test(char)) {
      analysis.numberCount += charMap[char];
    } else if (symbolRegex.test(char)) {
      analysis.symbolCount += charMap[char];
    }
  });
  return analysis;
}

function scorePassword(analysis, scoringOptions) {
  var points = 0;
  points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
  points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;

  if (analysis.lowercaseCount > 0) {
    points += scoringOptions.pointsForContainingLower;
  }

  if (analysis.uppercaseCount > 0) {
    points += scoringOptions.pointsForContainingUpper;
  }

  if (analysis.numberCount > 0) {
    points += scoringOptions.pointsForContainingNumber;
  }

  if (analysis.symbolCount > 0) {
    points += scoringOptions.pointsForContainingSymbol;
  }

  return points;
}

function isStrongPassword(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  (0, _assertString.default)(str);
  var analysis = analyzePassword(str);
  options = (0, _merge.default)(options || {}, defaultOptions);

  if (options.returnScore) {
    return scorePassword(analysis, options);
  }

  return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2828:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSurrogatePair;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

function isSurrogatePair(str) {
  (0, _assertString.default)(str);
  return surrogatePair.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3058:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isTaxID;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var algorithms = _interopRequireWildcard(__webpack_require__(3672));

var _isDate = _interopRequireDefault(__webpack_require__(2549));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * TIN Validation
 * Validates Tax Identification Numbers (TINs) from the US, EU member states and the United Kingdom.
 *
 * EU-UK:
 * National TIN validity is calculated using public algorithms as made available by DG TAXUD.
 *
 * See `https://ec.europa.eu/taxation_customs/tin/specs/FS-TIN%20Algorithms-Public.docx` for more information.
 *
 * US:
 * An Employer Identification Number (EIN), also known as a Federal Tax Identification Number,
 *  is used to identify a business entity.
 *
 * NOTES:
 *  - Prefix 47 is being reserved for future use
 *  - Prefixes 26, 27, 45, 46 and 47 were previously assigned by the Philadelphia campus.
 *
 * See `http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/How-EINs-are-Assigned-and-Valid-EIN-Prefixes`
 * for more information.
 */
// Locale functions

/*
 * bg-BG validation function
 * (Edinen graždanski nomer (EGN/ЕГН), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last) digit
 */
function bgBgCheck(tin) {
  // Extract full year, normalize month and check birth date validity
  var century_year = tin.slice(0, 2);
  var month = parseInt(tin.slice(2, 4), 10);

  if (month > 40) {
    month -= 40;
    century_year = "20".concat(century_year);
  } else if (month > 20) {
    month -= 20;
    century_year = "18".concat(century_year);
  } else {
    century_year = "19".concat(century_year);
  }

  if (month < 10) {
    month = "0".concat(month);
  }

  var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // split digits into an array for further processing


  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  }); // Calculate checksum by multiplying digits with fixed values

  var multip_lookup = [2, 4, 8, 5, 10, 9, 7, 3, 6];
  var checksum = 0;

  for (var i = 0; i < multip_lookup.length; i++) {
    checksum += digits[i] * multip_lookup[i];
  }

  checksum = checksum % 11 === 10 ? 0 : checksum % 11;
  return checksum === digits[9];
}
/*
 * cs-CZ validation function
 * (Rodné číslo (RČ), persons only)
 * Checks if birth date (first six digits) is valid and divisibility by 11
 * Material not in DG TAXUD document sourced from:
 * -`https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm`
 * -`https://www.mvcr.cz/clanek/rady-a-sluzby-dokumenty-rodne-cislo.aspx`
 */


function csCzCheck(tin) {
  tin = tin.replace(/\W/, ''); // Extract full year from TIN length

  var full_year = parseInt(tin.slice(0, 2), 10);

  if (tin.length === 10) {
    if (full_year < 54) {
      full_year = "20".concat(full_year);
    } else {
      full_year = "19".concat(full_year);
    }
  } else {
    if (tin.slice(6) === '000') {
      return false;
    } // Three-zero serial not assigned before 1954


    if (full_year < 54) {
      full_year = "19".concat(full_year);
    } else {
      return false; // No 18XX years seen in any of the resources
    }
  } // Add missing zero if needed


  if (full_year.length === 3) {
    full_year = [full_year.slice(0, 2), '0', full_year.slice(2)].join('');
  } // Extract month from TIN and normalize


  var month = parseInt(tin.slice(2, 4), 10);

  if (month > 50) {
    month -= 50;
  }

  if (month > 20) {
    // Month-plus-twenty was only introduced in 2004
    if (parseInt(full_year, 10) < 2004) {
      return false;
    }

    month -= 20;
  }

  if (month < 10) {
    month = "0".concat(month);
  } // Check date validity


  var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Verify divisibility by 11


  if (tin.length === 10) {
    if (parseInt(tin, 10) % 11 !== 0) {
      // Some numbers up to and including 1985 are still valid if
      // check (last) digit equals 0 and modulo of first 9 digits equals 10
      var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;

      if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
        if (parseInt(tin.slice(9), 10) !== 0) {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  return true;
}
/*
 * de-AT validation function
 * (Abgabenkontonummer, persons/entities)
 * Verify TIN validity by calling luhnCheck()
 */


function deAtCheck(tin) {
  return algorithms.luhnCheck(tin);
}
/*
 * de-DE validation function
 * (Steueridentifikationsnummer (Steuer-IdNr.), persons only)
 * Tests for single duplicate/triplicate value, then calculates ISO 7064 check (last) digit
 * Partial implementation of spec (same result with both algorithms always)
 */


function deDeCheck(tin) {
  // Split digits into an array for further processing
  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  }); // Fill array with strings of number positions

  var occurences = [];

  for (var i = 0; i < digits.length - 1; i++) {
    occurences.push('');

    for (var j = 0; j < digits.length - 1; j++) {
      if (digits[i] === digits[j]) {
        occurences[i] += j;
      }
    }
  } // Remove digits with one occurence and test for only one duplicate/triplicate


  occurences = occurences.filter(function (a) {
    return a.length > 1;
  });

  if (occurences.length !== 2 && occurences.length !== 3) {
    return false;
  } // In case of triplicate value only two digits are allowed next to each other


  if (occurences[0].length === 3) {
    var trip_locations = occurences[0].split('').map(function (a) {
      return parseInt(a, 10);
    });
    var recurrent = 0; // Amount of neighbour occurences

    for (var _i = 0; _i < trip_locations.length - 1; _i++) {
      if (trip_locations[_i] + 1 === trip_locations[_i + 1]) {
        recurrent += 1;
      }
    }

    if (recurrent === 2) {
      return false;
    }
  }

  return algorithms.iso7064Check(tin);
}
/*
 * dk-DK validation function
 * (CPR-nummer (personnummer), persons only)
 * Checks if birth date (first six digits) is valid and assigned to century (seventh) digit,
 * and calculates check (last) digit
 */


function dkDkCheck(tin) {
  tin = tin.replace(/\W/, ''); // Extract year, check if valid for given century digit and add century

  var year = parseInt(tin.slice(4, 6), 10);
  var century_digit = tin.slice(6, 7);

  switch (century_digit) {
    case '0':
    case '1':
    case '2':
    case '3':
      year = "19".concat(year);
      break;

    case '4':
    case '9':
      if (year < 37) {
        year = "20".concat(year);
      } else {
        year = "19".concat(year);
      }

      break;

    default:
      if (year < 37) {
        year = "20".concat(year);
      } else if (year > 58) {
        year = "18".concat(year);
      } else {
        return false;
      }

      break;
  } // Add missing zero if needed


  if (year.length === 3) {
    year = [year.slice(0, 2), '0', year.slice(2)].join('');
  } // Check date validity


  var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Split digits into an array for further processing


  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0;
  var weight = 4; // Multiply by weight and add to checksum

  for (var i = 0; i < 9; i++) {
    checksum += digits[i] * weight;
    weight -= 1;

    if (weight === 1) {
      weight = 7;
    }
  }

  checksum %= 11;

  if (checksum === 1) {
    return false;
  }

  return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
}
/*
 * el-CY validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons only)
 * Verify TIN validity by calculating ASCII value of check (last) character
 */


function elCyCheck(tin) {
  // split digits into an array for further processing
  var digits = tin.slice(0, 8).split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0; // add digits in even places

  for (var i = 1; i < digits.length; i += 2) {
    checksum += digits[i];
  } // add digits in odd places


  for (var _i2 = 0; _i2 < digits.length; _i2 += 2) {
    if (digits[_i2] < 2) {
      checksum += 1 - digits[_i2];
    } else {
      checksum += 2 * (digits[_i2] - 2) + 5;

      if (digits[_i2] > 4) {
        checksum += 2;
      }
    }
  }

  return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
}
/*
 * el-GR validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons/entities)
 * Verify TIN validity by calculating check (last) digit
 * Algorithm not in DG TAXUD document- sourced from:
 * - `http://epixeirisi.gr/%CE%9A%CE%A1%CE%99%CE%A3%CE%99%CE%9C%CE%91-%CE%98%CE%95%CE%9C%CE%91%CE%A4%CE%91-%CE%A6%CE%9F%CE%A1%CE%9F%CE%9B%CE%9F%CE%93%CE%99%CE%91%CE%A3-%CE%9A%CE%91%CE%99-%CE%9B%CE%9F%CE%93%CE%99%CE%A3%CE%A4%CE%99%CE%9A%CE%97%CE%A3/23791/%CE%91%CF%81%CE%B9%CE%B8%CE%BC%CF%8C%CF%82-%CE%A6%CE%BF%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%B9%CE%BA%CE%BF%CF%8D-%CE%9C%CE%B7%CF%84%CF%81%CF%8E%CE%BF%CF%85`
 */


function elGrCheck(tin) {
  // split digits into an array for further processing
  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0;

  for (var i = 0; i < 8; i++) {
    checksum += digits[i] * Math.pow(2, 8 - i);
  }

  return checksum % 11 % 10 === digits[8];
}
/*
 * en-GB validation function (should go here if needed)
 * (National Insurance Number (NINO) or Unique Taxpayer Reference (UTR),
 * persons/entities respectively)
 */

/*
 * en-IE validation function
 * (Personal Public Service Number (PPS No), persons only)
 * Verify TIN validity by calculating check (second to last) character
 */


function enIeCheck(tin) {
  var checksum = algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function (a) {
    return parseInt(a, 10);
  }), 8);

  if (tin.length === 9 && tin[8] !== 'W') {
    checksum += (tin[8].charCodeAt(0) - 64) * 9;
  }

  checksum %= 23;

  if (checksum === 0) {
    return tin[7].toUpperCase() === 'W';
  }

  return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
} // Valid US IRS campus prefixes


var enUsCampusPrefix = {
  andover: ['10', '12'],
  atlanta: ['60', '67'],
  austin: ['50', '53'],
  brookhaven: ['01', '02', '03', '04', '05', '06', '11', '13', '14', '16', '21', '22', '23', '25', '34', '51', '52', '54', '55', '56', '57', '58', '59', '65'],
  cincinnati: ['30', '32', '35', '36', '37', '38', '61'],
  fresno: ['15', '24'],
  internet: ['20', '26', '27', '45', '46', '47'],
  kansas: ['40', '44'],
  memphis: ['94', '95'],
  ogden: ['80', '90'],
  philadelphia: ['33', '39', '41', '42', '43', '46', '48', '62', '63', '64', '66', '68', '71', '72', '73', '74', '75', '76', '77', '81', '82', '83', '84', '85', '86', '87', '88', '91', '92', '93', '98', '99'],
  sba: ['31']
}; // Return an array of all US IRS campus prefixes

function enUsGetPrefixes() {
  var prefixes = [];

  for (var location in enUsCampusPrefix) {
    // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
    // istanbul ignore else
    if (enUsCampusPrefix.hasOwnProperty(location)) {
      prefixes.push.apply(prefixes, _toConsumableArray(enUsCampusPrefix[location]));
    }
  }

  return prefixes;
}
/*
 * en-US validation function
 * Verify that the TIN starts with a valid IRS campus prefix
 */


function enUsCheck(tin) {
  return enUsGetPrefixes().indexOf(tin.substr(0, 2)) !== -1;
}
/*
 * es-ES validation function
 * (Documento Nacional de Identidad (DNI)
 * or Número de Identificación de Extranjero (NIE), persons only)
 * Verify TIN validity by calculating check (last) character
 */


function esEsCheck(tin) {
  // Split characters into an array for further processing
  var chars = tin.toUpperCase().split(''); // Replace initial letter if needed

  if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
    var lead_replace = 0;

    switch (chars[0]) {
      case 'Y':
        lead_replace = 1;
        break;

      case 'Z':
        lead_replace = 2;
        break;

      default:
    }

    chars.splice(0, 1, lead_replace); // Fill with zeros if smaller than proper
  } else {
    while (chars.length < 9) {
      chars.unshift(0);
    }
  } // Calculate checksum and check according to lookup


  var lookup = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E'];
  chars = chars.join('');
  var checksum = parseInt(chars.slice(0, 8), 10) % 23;
  return chars[8] === lookup[checksum];
}
/*
 * et-EE validation function
 * (Isikukood (IK), persons only)
 * Checks if birth date (century digit and six following) is valid and calculates check (last) digit
 * Material not in DG TAXUD document sourced from:
 * - `https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf`
 */


function etEeCheck(tin) {
  // Extract year and add century
  var full_year = tin.slice(1, 3);
  var century_digit = tin.slice(0, 1);

  switch (century_digit) {
    case '1':
    case '2':
      full_year = "18".concat(full_year);
      break;

    case '3':
    case '4':
      full_year = "19".concat(full_year);
      break;

    default:
      full_year = "20".concat(full_year);
      break;
  } // Check date validity


  var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Split digits into an array for further processing


  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0;
  var weight = 1; // Multiply by weight and add to checksum

  for (var i = 0; i < 10; i++) {
    checksum += digits[i] * weight;
    weight += 1;

    if (weight === 10) {
      weight = 1;
    }
  } // Do again if modulo 11 of checksum is 10


  if (checksum % 11 === 10) {
    checksum = 0;
    weight = 3;

    for (var _i3 = 0; _i3 < 10; _i3++) {
      checksum += digits[_i3] * weight;
      weight += 1;

      if (weight === 10) {
        weight = 1;
      }
    }

    if (checksum % 11 === 10) {
      return digits[10] === 0;
    }
  }

  return checksum % 11 === digits[10];
}
/*
 * fi-FI validation function
 * (Henkilötunnus (HETU), persons only)
 * Checks if birth date (first six digits plus century symbol) is valid
 * and calculates check (last) digit
 */


function fiFiCheck(tin) {
  // Extract year and add century
  var full_year = tin.slice(4, 6);
  var century_symbol = tin.slice(6, 7);

  switch (century_symbol) {
    case '+':
      full_year = "18".concat(full_year);
      break;

    case '-':
      full_year = "19".concat(full_year);
      break;

    default:
      full_year = "20".concat(full_year);
      break;
  } // Check date validity


  var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Calculate check character


  var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;

  if (checksum < 10) {
    return checksum === parseInt(tin.slice(10), 10);
  }

  checksum -= 10;
  var letters_lookup = ['A', 'B', 'C', 'D', 'E', 'F', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
  return letters_lookup[checksum] === tin.slice(10);
}
/*
 * fr/nl-BE validation function
 * (Numéro national (N.N.), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last two) digits
 */


function frBeCheck(tin) {
  // Zero month/day value is acceptable
  if (tin.slice(2, 4) !== '00' || tin.slice(4, 6) !== '00') {
    // Extract date from first six digits of TIN
    var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));

    if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
      return false;
    }
  }

  var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
  var checkdigits = parseInt(tin.slice(9, 11), 10);

  if (checksum !== checkdigits) {
    checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;

    if (checksum !== checkdigits) {
      return false;
    }
  }

  return true;
}
/*
 * fr-FR validation function
 * (Numéro fiscal de référence (numéro SPI), persons only)
 * Verify TIN validity by calculating check (last three) digits
 */


function frFrCheck(tin) {
  tin = tin.replace(/\s/g, '');
  var checksum = parseInt(tin.slice(0, 10), 10) % 511;
  var checkdigits = parseInt(tin.slice(10, 13), 10);
  return checksum === checkdigits;
}
/*
 * fr/lb-LU validation function
 * (numéro d’identification personnelle, persons only)
 * Verify birth date validity and run Luhn and Verhoeff checks
 */


function frLuCheck(tin) {
  // Extract date and check validity
  var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Run Luhn check


  if (!algorithms.luhnCheck(tin.slice(0, 12))) {
    return false;
  } // Remove Luhn check digit and run Verhoeff check


  return algorithms.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
}
/*
 * hr-HR validation function
 * (Osobni identifikacijski broj (OIB), persons/entities)
 * Verify TIN validity by calling iso7064Check(digits)
 */


function hrHrCheck(tin) {
  return algorithms.iso7064Check(tin);
}
/*
 * hu-HU validation function
 * (Adóazonosító jel, persons only)
 * Verify TIN validity by calculating check (last) digit
 */


function huHuCheck(tin) {
  // split digits into an array for further processing
  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 8;

  for (var i = 1; i < 9; i++) {
    checksum += digits[i] * (i + 1);
  }

  return checksum % 11 === digits[9];
}
/*
 * lt-LT validation function (should go here if needed)
 * (Asmens kodas, persons/entities respectively)
 * Current validation check is alias of etEeCheck- same format applies
 */

/*
 * it-IT first/last name validity check
 * Accepts it-IT TIN-encoded names as a three-element character array and checks their validity
 * Due to lack of clarity between resources ("Are only Italian consonants used?
 * What happens if a person has X in their name?" etc.) only two test conditions
 * have been implemented:
 * Vowels may only be followed by other vowels or an X character
 * and X characters after vowels may only be followed by other X characters.
 */


function itItNameCheck(name) {
  // true at the first occurence of a vowel
  var vowelflag = false; // true at the first occurence of an X AFTER vowel
  // (to properly handle last names with X as consonant)

  var xflag = false;

  for (var i = 0; i < 3; i++) {
    if (!vowelflag && /[AEIOU]/.test(name[i])) {
      vowelflag = true;
    } else if (!xflag && vowelflag && name[i] === 'X') {
      xflag = true;
    } else if (i > 0) {
      if (vowelflag && !xflag) {
        if (!/[AEIOU]/.test(name[i])) {
          return false;
        }
      }

      if (xflag) {
        if (!/X/.test(name[i])) {
          return false;
        }
      }
    }
  }

  return true;
}
/*
 * it-IT validation function
 * (Codice fiscale (TIN-IT), persons only)
 * Verify name, birth date and codice catastale validity
 * and calculate check character.
 * Material not in DG-TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/Italian_fiscal_code`
 */


function itItCheck(tin) {
  // Capitalize and split characters into an array for further processing
  var chars = tin.toUpperCase().split(''); // Check first and last name validity calling itItNameCheck()

  if (!itItNameCheck(chars.slice(0, 3))) {
    return false;
  }

  if (!itItNameCheck(chars.slice(3, 6))) {
    return false;
  } // Convert letters in number spaces back to numbers if any


  var number_locations = [6, 7, 9, 10, 12, 13, 14];
  var number_replace = {
    L: '0',
    M: '1',
    N: '2',
    P: '3',
    Q: '4',
    R: '5',
    S: '6',
    T: '7',
    U: '8',
    V: '9'
  };

  for (var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++) {
    var i = _number_locations[_i4];

    if (chars[i] in number_replace) {
      chars.splice(i, 1, number_replace[chars[i]]);
    }
  } // Extract month and day, and check date validity


  var month_replace = {
    A: '01',
    B: '02',
    C: '03',
    D: '04',
    E: '05',
    H: '06',
    L: '07',
    M: '08',
    P: '09',
    R: '10',
    S: '11',
    T: '12'
  };
  var month = month_replace[chars[8]];
  var day = parseInt(chars[9] + chars[10], 10);

  if (day > 40) {
    day -= 40;
  }

  if (day < 10) {
    day = "0".concat(day);
  }

  var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);

  if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
    return false;
  } // Calculate check character by adding up even and odd characters as numbers


  var checksum = 0;

  for (var _i5 = 1; _i5 < chars.length - 1; _i5 += 2) {
    var char_to_int = parseInt(chars[_i5], 10);

    if (isNaN(char_to_int)) {
      char_to_int = chars[_i5].charCodeAt(0) - 65;
    }

    checksum += char_to_int;
  }

  var odd_convert = {
    // Maps of characters at odd places
    A: 1,
    B: 0,
    C: 5,
    D: 7,
    E: 9,
    F: 13,
    G: 15,
    H: 17,
    I: 19,
    J: 21,
    K: 2,
    L: 4,
    M: 18,
    N: 20,
    O: 11,
    P: 3,
    Q: 6,
    R: 8,
    S: 12,
    T: 14,
    U: 16,
    V: 10,
    W: 22,
    X: 25,
    Y: 24,
    Z: 23,
    0: 1,
    1: 0
  };

  for (var _i6 = 0; _i6 < chars.length - 1; _i6 += 2) {
    var _char_to_int = 0;

    if (chars[_i6] in odd_convert) {
      _char_to_int = odd_convert[chars[_i6]];
    } else {
      var multiplier = parseInt(chars[_i6], 10);
      _char_to_int = 2 * multiplier + 1;

      if (multiplier > 4) {
        _char_to_int += 2;
      }
    }

    checksum += _char_to_int;
  }

  if (String.fromCharCode(65 + checksum % 26) !== chars[15]) {
    return false;
  }

  return true;
}
/*
 * lv-LV validation function
 * (Personas kods (PK), persons only)
 * Check validity of birth date and calculate check (last) digit
 * Support only for old format numbers (not starting with '32', issued before 2017/07/01)
 * Material not in DG TAXUD document sourced from:
 * `https://boot.ritakafija.lv/forums/index.php?/topic/88314-personas-koda-algoritms-%C4%8Deksumma/`
 */


function lvLvCheck(tin) {
  tin = tin.replace(/\W/, ''); // Extract date from TIN

  var day = tin.slice(0, 2);

  if (day !== '32') {
    // No date/checksum check if new format
    var month = tin.slice(2, 4);

    if (month !== '00') {
      // No date check if unknown month
      var full_year = tin.slice(4, 6);

      switch (tin[6]) {
        case '0':
          full_year = "18".concat(full_year);
          break;

        case '1':
          full_year = "19".concat(full_year);
          break;

        default:
          full_year = "20".concat(full_year);
          break;
      } // Check date validity


      var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);

      if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
        return false;
      }
    } // Calculate check digit


    var checksum = 1101;
    var multip_lookup = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

    for (var i = 0; i < tin.length - 1; i++) {
      checksum -= parseInt(tin[i], 10) * multip_lookup[i];
    }

    return parseInt(tin[10], 10) === checksum % 11;
  }

  return true;
}
/*
 * mt-MT validation function
 * (Identity Card Number or Unique Taxpayer Reference, persons/entities)
 * Verify Identity Card Number structure (no other tests found)
 */


function mtMtCheck(tin) {
  if (tin.length !== 9) {
    // No tests for UTR
    var chars = tin.toUpperCase().split(''); // Fill with zeros if smaller than proper

    while (chars.length < 8) {
      chars.unshift(0);
    } // Validate format according to last character


    switch (tin[7]) {
      case 'A':
      case 'P':
        if (parseInt(chars[6], 10) === 0) {
          return false;
        }

        break;

      default:
        {
          var first_part = parseInt(chars.join('').slice(0, 5), 10);

          if (first_part > 32000) {
            return false;
          }

          var second_part = parseInt(chars.join('').slice(5, 7), 10);

          if (first_part === second_part) {
            return false;
          }
        }
    }
  }

  return true;
}
/*
 * nl-NL validation function
 * (Burgerservicenummer (BSN) or Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN),
 * persons/entities respectively)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */


function nlNlCheck(tin) {
  return algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function (a) {
    return parseInt(a, 10);
  }), 9) % 11 === parseInt(tin[8], 10);
}
/*
 * pl-PL validation function
 * (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)
 * or Numer identyfikacji podatkowej (NIP), persons/entities)
 * Verify TIN validity by validating birth date (PESEL) and calculating check (last) digit
 */


function plPlCheck(tin) {
  // NIP
  if (tin.length === 10) {
    // Calculate last digit by multiplying with lookup
    var lookup = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    var _checksum = 0;

    for (var i = 0; i < lookup.length; i++) {
      _checksum += parseInt(tin[i], 10) * lookup[i];
    }

    _checksum %= 11;

    if (_checksum === 10) {
      return false;
    }

    return _checksum === parseInt(tin[9], 10);
  } // PESEL
  // Extract full year using month


  var full_year = tin.slice(0, 2);
  var month = parseInt(tin.slice(2, 4), 10);

  if (month > 80) {
    full_year = "18".concat(full_year);
    month -= 80;
  } else if (month > 60) {
    full_year = "22".concat(full_year);
    month -= 60;
  } else if (month > 40) {
    full_year = "21".concat(full_year);
    month -= 40;
  } else if (month > 20) {
    full_year = "20".concat(full_year);
    month -= 20;
  } else {
    full_year = "19".concat(full_year);
  } // Add leading zero to month if needed


  if (month < 10) {
    month = "0".concat(month);
  } // Check date validity


  var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Calculate last digit by mulitplying with odd one-digit numbers except 5


  var checksum = 0;
  var multiplier = 1;

  for (var _i7 = 0; _i7 < tin.length - 1; _i7++) {
    checksum += parseInt(tin[_i7], 10) * multiplier % 10;
    multiplier += 2;

    if (multiplier > 10) {
      multiplier = 1;
    } else if (multiplier === 5) {
      multiplier += 2;
    }
  }

  checksum = 10 - checksum % 10;
  return checksum === parseInt(tin[10], 10);
}
/*
* pt-BR validation function
* (Cadastro de Pessoas Físicas (CPF, persons)
* Cadastro Nacional de Pessoas Jurídicas (CNPJ, entities)
* Both inputs will be validated
*/


function ptBrCheck(tin) {
  if (tin.length === 11) {
    var _sum;

    var remainder;
    _sum = 0;
    if ( // Reject known invalid CPFs
    tin === '11111111111' || tin === '22222222222' || tin === '33333333333' || tin === '44444444444' || tin === '55555555555' || tin === '66666666666' || tin === '77777777777' || tin === '88888888888' || tin === '99999999999' || tin === '00000000000') return false;

    for (var i = 1; i <= 9; i++) {
      _sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
    }

    remainder = _sum * 10 % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
    _sum = 0;

    for (var _i8 = 1; _i8 <= 10; _i8++) {
      _sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
    }

    remainder = _sum * 10 % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
    return true;
  }

  if ( // Reject know invalid CNPJs
  tin === '00000000000000' || tin === '11111111111111' || tin === '22222222222222' || tin === '33333333333333' || tin === '44444444444444' || tin === '55555555555555' || tin === '66666666666666' || tin === '77777777777777' || tin === '88888888888888' || tin === '99999999999999') {
    return false;
  }

  var length = tin.length - 2;
  var identifiers = tin.substring(0, length);
  var verificators = tin.substring(length);
  var sum = 0;
  var pos = length - 7;

  for (var _i9 = length; _i9 >= 1; _i9--) {
    sum += identifiers.charAt(length - _i9) * pos;
    pos -= 1;

    if (pos < 2) {
      pos = 9;
    }
  }

  var result = sum % 11 < 2 ? 0 : 11 - sum % 11;

  if (result !== parseInt(verificators.charAt(0), 10)) {
    return false;
  }

  length += 1;
  identifiers = tin.substring(0, length);
  sum = 0;
  pos = length - 7;

  for (var _i10 = length; _i10 >= 1; _i10--) {
    sum += identifiers.charAt(length - _i10) * pos;
    pos -= 1;

    if (pos < 2) {
      pos = 9;
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - sum % 11;

  if (result !== parseInt(verificators.charAt(1), 10)) {
    return false;
  }

  return true;
}
/*
 * pt-PT validation function
 * (Número de identificação fiscal (NIF), persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */


function ptPtCheck(tin) {
  var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function (a) {
    return parseInt(a, 10);
  }), 9) % 11;

  if (checksum > 9) {
    return parseInt(tin[8], 10) === 0;
  }

  return checksum === parseInt(tin[8], 10);
}
/*
 * ro-RO validation function
 * (Cod Numeric Personal (CNP) or Cod de înregistrare fiscală (CIF),
 * persons only)
 * Verify CNP validity by calculating check (last) digit (test not found for CIF)
 * Material not in DG TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/National_identification_number#Romania`
 */


function roRoCheck(tin) {
  if (tin.slice(0, 4) !== '9000') {
    // No test found for this format
    // Extract full year using century digit if possible
    var full_year = tin.slice(1, 3);

    switch (tin[0]) {
      case '1':
      case '2':
        full_year = "19".concat(full_year);
        break;

      case '3':
      case '4':
        full_year = "18".concat(full_year);
        break;

      case '5':
      case '6':
        full_year = "20".concat(full_year);
        break;

      default:
    } // Check date validity


    var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));

    if (date.length === 8) {
      if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
        return false;
      }
    } else if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
      return false;
    } // Calculate check digit


    var digits = tin.split('').map(function (a) {
      return parseInt(a, 10);
    });
    var multipliers = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
    var checksum = 0;

    for (var i = 0; i < multipliers.length; i++) {
      checksum += digits[i] * multipliers[i];
    }

    if (checksum % 11 === 10) {
      return digits[12] === 1;
    }

    return digits[12] === checksum % 11;
  }

  return true;
}
/*
 * sk-SK validation function
 * (Rodné číslo (RČ) or bezvýznamové identifikačné číslo (BIČ), persons only)
 * Checks validity of pre-1954 birth numbers (rodné číslo) only
 * Due to the introduction of the pseudo-random BIČ it is not possible to test
 * post-1954 birth numbers without knowing whether they are BIČ or RČ beforehand
 */


function skSkCheck(tin) {
  if (tin.length === 9) {
    tin = tin.replace(/\W/, '');

    if (tin.slice(6) === '000') {
      return false;
    } // Three-zero serial not assigned before 1954
    // Extract full year from TIN length


    var full_year = parseInt(tin.slice(0, 2), 10);

    if (full_year > 53) {
      return false;
    }

    if (full_year < 10) {
      full_year = "190".concat(full_year);
    } else {
      full_year = "19".concat(full_year);
    } // Extract month from TIN and normalize


    var month = parseInt(tin.slice(2, 4), 10);

    if (month > 50) {
      month -= 50;
    }

    if (month < 10) {
      month = "0".concat(month);
    } // Check date validity


    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

    if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
      return false;
    }
  }

  return true;
}
/*
 * sl-SI validation function
 * (Davčna številka, persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */


function slSiCheck(tin) {
  var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function (a) {
    return parseInt(a, 10);
  }), 8) % 11;

  if (checksum === 10) {
    return parseInt(tin[7], 10) === 0;
  }

  return checksum === parseInt(tin[7], 10);
}
/*
 * sv-SE validation function
 * (Personnummer or samordningsnummer, persons only)
 * Checks validity of birth date and calls luhnCheck() to validate check (last) digit
 */


function svSeCheck(tin) {
  // Make copy of TIN and normalize to two-digit year form
  var tin_copy = tin.slice(0);

  if (tin.length > 11) {
    tin_copy = tin_copy.slice(2);
  } // Extract date of birth


  var full_year = '';
  var month = tin_copy.slice(2, 4);
  var day = parseInt(tin_copy.slice(4, 6), 10);

  if (tin.length > 11) {
    full_year = tin.slice(0, 4);
  } else {
    full_year = tin.slice(0, 2);

    if (tin.length === 11 && day < 60) {
      // Extract full year from centenarian symbol
      // Should work just fine until year 10000 or so
      var current_year = new Date().getFullYear().toString();
      var current_century = parseInt(current_year.slice(0, 2), 10);
      current_year = parseInt(current_year, 10);

      if (tin[6] === '-') {
        if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) {
          full_year = "".concat(current_century - 1).concat(full_year);
        } else {
          full_year = "".concat(current_century).concat(full_year);
        }
      } else {
        full_year = "".concat(current_century - 1).concat(full_year);

        if (current_year - parseInt(full_year, 10) < 100) {
          return false;
        }
      }
    }
  } // Normalize day and check date validity


  if (day > 60) {
    day -= 60;
  }

  if (day < 10) {
    day = "0".concat(day);
  }

  var date = "".concat(full_year, "/").concat(month, "/").concat(day);

  if (date.length === 8) {
    if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
      return false;
    }
  } else if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  }

  return algorithms.luhnCheck(tin.replace(/\W/, ''));
} // Locale lookup objects

/*
 * Tax id regex formats for various locales
 *
 * Where not explicitly specified in DG-TAXUD document both
 * uppercase and lowercase letters are acceptable.
 */


var taxIdFormat = {
  'bg-BG': /^\d{10}$/,
  'cs-CZ': /^\d{6}\/{0,1}\d{3,4}$/,
  'de-AT': /^\d{9}$/,
  'de-DE': /^[1-9]\d{10}$/,
  'dk-DK': /^\d{6}-{0,1}\d{4}$/,
  'el-CY': /^[09]\d{7}[A-Z]$/,
  'el-GR': /^([0-4]|[7-9])\d{8}$/,
  'en-GB': /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
  'en-IE': /^\d{7}[A-W][A-IW]{0,1}$/i,
  'en-US': /^\d{2}[- ]{0,1}\d{7}$/,
  'es-ES': /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
  'et-EE': /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
  'fi-FI': /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
  'fr-BE': /^\d{11}$/,
  'fr-FR': /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
  // Conforms both to official spec and provided example
  'fr-LU': /^\d{13}$/,
  'hr-HR': /^\d{11}$/,
  'hu-HU': /^8\d{9}$/,
  'it-IT': /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
  'lv-LV': /^\d{6}-{0,1}\d{5}$/,
  // Conforms both to DG TAXUD spec and original research
  'mt-MT': /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
  'nl-NL': /^\d{9}$/,
  'pl-PL': /^\d{10,11}$/,
  'pt-BR': /(?:^\d{11}$)|(?:^\d{14}$)/,
  'pt-PT': /^\d{9}$/,
  'ro-RO': /^\d{13}$/,
  'sk-SK': /^\d{6}\/{0,1}\d{3,4}$/,
  'sl-SI': /^[1-9]\d{7}$/,
  'sv-SE': /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
}; // taxIdFormat locale aliases

taxIdFormat['lb-LU'] = taxIdFormat['fr-LU'];
taxIdFormat['lt-LT'] = taxIdFormat['et-EE'];
taxIdFormat['nl-BE'] = taxIdFormat['fr-BE']; // Algorithmic tax id check functions for various locales

var taxIdCheck = {
  'bg-BG': bgBgCheck,
  'cs-CZ': csCzCheck,
  'de-AT': deAtCheck,
  'de-DE': deDeCheck,
  'dk-DK': dkDkCheck,
  'el-CY': elCyCheck,
  'el-GR': elGrCheck,
  'en-IE': enIeCheck,
  'en-US': enUsCheck,
  'es-ES': esEsCheck,
  'et-EE': etEeCheck,
  'fi-FI': fiFiCheck,
  'fr-BE': frBeCheck,
  'fr-FR': frFrCheck,
  'fr-LU': frLuCheck,
  'hr-HR': hrHrCheck,
  'hu-HU': huHuCheck,
  'it-IT': itItCheck,
  'lv-LV': lvLvCheck,
  'mt-MT': mtMtCheck,
  'nl-NL': nlNlCheck,
  'pl-PL': plPlCheck,
  'pt-BR': ptBrCheck,
  'pt-PT': ptPtCheck,
  'ro-RO': roRoCheck,
  'sk-SK': skSkCheck,
  'sl-SI': slSiCheck,
  'sv-SE': svSeCheck
}; // taxIdCheck locale aliases

taxIdCheck['lb-LU'] = taxIdCheck['fr-LU'];
taxIdCheck['lt-LT'] = taxIdCheck['et-EE'];
taxIdCheck['nl-BE'] = taxIdCheck['fr-BE']; // Regexes for locales where characters should be omitted before checking format

var allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
var sanitizeRegexes = {
  'de-AT': allsymbols,
  'de-DE': /[\/\\]/g,
  'fr-BE': allsymbols
}; // sanitizeRegexes locale aliases

sanitizeRegexes['nl-BE'] = sanitizeRegexes['fr-BE'];
/*
 * Validator function
 * Return true if the passed string is a valid tax identification number
 * for the specified locale.
 * Throw an error exception if the locale is not supported.
 */

function isTaxID(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  (0, _assertString.default)(str); // Copy TIN to avoid replacement if sanitized

  var strcopy = str.slice(0);

  if (locale in taxIdFormat) {
    if (locale in sanitizeRegexes) {
      strcopy = strcopy.replace(sanitizeRegexes[locale], '');
    }

    if (!taxIdFormat[locale].test(strcopy)) {
      return false;
    }

    if (locale in taxIdCheck) {
      return taxIdCheck[locale](strcopy);
    } // Fallthrough; not all locales have algorithmic checks


    return true;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2492:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isURL;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isFQDN = _interopRequireDefault(__webpack_require__(221));

var _isIP = _interopRequireDefault(__webpack_require__(1028));

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
options for isURL method

require_protocol - if set as true isURL will return false if protocol is not present in the URL
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
protocols - valid protocols can be modified with this option
require_host - if set as false isURL will not check if host is present in the URL
require_port - if set as true isURL will check if port is present in the URL
allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

*/
var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_port: false,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false,
  allow_fragments: true,
  allow_query_components: true,
  validate_length: true
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);

  if (options.validate_length && url.length >= 2083) {
    return false;
  }

  if (!options.allow_fragments && url.includes('#')) {
    return false;
  }

  if (!options.allow_query_components && (url.includes('?') || url.includes('&'))) {
    return false;
  }

  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    if (split[0] === '') {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }

    var _auth$split = auth.split(':'),
        _auth$split2 = _slicedToArray(_auth$split, 2),
        user = _auth$split2[0],
        password = _auth$split2[1];

    if (user === '' && password === '') {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null && port_str.length > 0) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  } else if (options.require_port) {
    return false;
  }

  if (options.host_whitelist) {
    return checkHost(host, options.host_whitelist);
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7278:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isUUID;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = {
  1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};

function isUUID(str, version) {
  (0, _assertString.default)(str);
  var pattern = uuid[![undefined, null].includes(version) ? version : 'all'];
  return !!pattern && pattern.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7245:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isUppercase;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUppercase(str) {
  (0, _assertString.default)(str);
  return str === str.toUpperCase();
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 5977:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isVAT;
exports.vatMatchers = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vatMatchers = {
  GB: /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/,
  IT: /^(IT)?[0-9]{11}$/,
  NL: /^(NL)?[0-9]{9}B[0-9]{2}$/
};
exports.vatMatchers = vatMatchers;

function isVAT(str, countryCode) {
  (0, _assertString.default)(str);
  (0, _assertString.default)(countryCode);

  if (countryCode in vatMatchers) {
    return vatMatchers[countryCode].test(str);
  }

  throw new Error("Invalid country code: '".concat(countryCode, "'"));
}

/***/ }),

/***/ 9019:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isVariableWidth;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _isFullWidth = __webpack_require__(7146);

var _isHalfWidth = __webpack_require__(2941);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isVariableWidth(str) {
  (0, _assertString.default)(str);
  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8346:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isWhitelisted;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isWhitelisted(str, chars) {
  (0, _assertString.default)(str);

  for (var i = str.length - 1; i >= 0; i--) {
    if (chars.indexOf(str[i]) === -1) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4959:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = ltrim;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ltrim(str, chars) {
  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping

  var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
  return str.replace(pattern, '');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 661:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = matches;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matches(str, pattern, modifiers) {
  (0, _assertString.default)(str);

  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }

  return pattern.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2900:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = normalizeEmail;

var _merge = _interopRequireDefault(__webpack_require__(4808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_normalize_email_options = {
  // The following options apply to all email addresses
  // Lowercases the local part of the email address.
  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
  // The domain is always lowercased, as per RFC 1035
  all_lowercase: true,
  // The following conversions are specific to GMail
  // Lowercases the local part of the GMail address (known to be case-insensitive)
  gmail_lowercase: true,
  // Removes dots from the local part of the email address, as that's ignored by GMail
  gmail_remove_dots: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  gmail_remove_subaddress: true,
  // Conversts the googlemail.com domain to gmail.com
  gmail_convert_googlemaildotcom: true,
  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
  outlookdotcom_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  outlookdotcom_remove_subaddress: true,
  // The following conversions are specific to Yahoo
  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
  yahoo_lowercase: true,
  // Removes the subaddress (e.g. "-foo") from the email address
  yahoo_remove_subaddress: true,
  // The following conversions are specific to Yandex
  // Lowercases the local part of the Yandex address (known to be case-insensitive)
  yandex_lowercase: true,
  // The following conversions are specific to iCloud
  // Lowercases the local part of the iCloud address (known to be case-insensitive)
  icloud_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  icloud_remove_subaddress: true
}; // List of domains used by iCloud

var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/

var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
// This list is likely incomplete

var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru

var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots

function dotsReplacer(match) {
  if (match.length > 1) {
    return match;
  }

  return '';
}

function normalizeEmail(email, options) {
  options = (0, _merge.default)(options, default_normalize_email_options);
  var raw_parts = email.split('@');
  var domain = raw_parts.pop();
  var user = raw_parts.join('@');
  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035

  parts[1] = parts[1].toLowerCase();

  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
    // Address is GMail
    if (options.gmail_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (options.gmail_remove_dots) {
      // this does not replace consecutive dots like example..email@gmail.com
      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.gmail_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
    // Address is iCloud
    if (options.icloud_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.icloud_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
    // Address is Outlook.com
    if (options.outlookdotcom_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.outlookdotcom_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
    // Address is Yahoo
    if (options.yahoo_remove_subaddress) {
      var components = parts[0].split('-');
      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.yahoo_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
    if (options.all_lowercase || options.yandex_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preferred
  } else if (options.all_lowercase) {
    // Any other address
    parts[0] = parts[0].toLowerCase();
  }

  return parts.join('@');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 9778:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rtrim;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rtrim(str, chars) {
  (0, _assertString.default)(str);

  if (chars) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g');
    return str.replace(pattern, '');
  } // Use a faster and more safe than regex trim method https://blog.stevenlevithan.com/archives/faster-trim-javascript


  var strIndex = str.length - 1;

  while (/\s/.test(str.charAt(strIndex))) {
    strIndex -= 1;
  }

  return str.slice(0, strIndex + 1);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8035:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = stripLow;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

var _blacklist = _interopRequireDefault(__webpack_require__(4928));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stripLow(str, keep_new_lines) {
  (0, _assertString.default)(str);
  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
  return (0, _blacklist.default)(str, chars);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 557:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toBoolean;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toBoolean(str, strict) {
  (0, _assertString.default)(str);

  if (strict) {
    return str === '1' || /^true$/i.test(str);
  }

  return str !== '0' && !/^false$/i.test(str) && str !== '';
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8469:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toDate(date) {
  (0, _assertString.default)(date);
  date = Date.parse(date);
  return !isNaN(date) ? new Date(date) : null;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 7536:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toFloat;

var _isFloat = _interopRequireDefault(__webpack_require__(9146));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toFloat(str) {
  if (!(0, _isFloat.default)(str)) return NaN;
  return parseFloat(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 1359:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInt;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toInt(str, radix) {
  (0, _assertString.default)(str);
  return parseInt(str, radix || 10);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4790:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = trim;

var _rtrim = _interopRequireDefault(__webpack_require__(9778));

var _ltrim = _interopRequireDefault(__webpack_require__(4959));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trim(str, chars) {
  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4816:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = unescape;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unescape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`').replace(/&amp;/g, '&'); // &amp; replacement has to be the last one to prevent
  // bugs with intermediate strings containing escape sequences
  // See: https://github.com/validatorjs/validator.js/issues/1827
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 3672:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.iso7064Check = iso7064Check;
exports.luhnCheck = luhnCheck;
exports.reverseMultiplyAndSum = reverseMultiplyAndSum;
exports.verhoeffCheck = verhoeffCheck;

/**
 * Algorithmic validation functions
 * May be used as is or implemented in the workflow of other validators.
 */

/*
 * ISO 7064 validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to ISO 7064 (MOD 11, 10).
 */
function iso7064Check(str) {
  var checkvalue = 10;

  for (var i = 0; i < str.length - 1; i++) {
    checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 10 * 2 % 11 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
  }

  checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
  return checkvalue === parseInt(str[10], 10);
}
/*
 * Luhn (mod 10) validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to the Luhn algorithm.
 */


function luhnCheck(str) {
  var checksum = 0;
  var second = false;

  for (var i = str.length - 1; i >= 0; i--) {
    if (second) {
      var product = parseInt(str[i], 10) * 2;

      if (product > 9) {
        // sum digits of product and add to checksum
        checksum += product.toString().split('').map(function (a) {
          return parseInt(a, 10);
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      } else {
        checksum += product;
      }
    } else {
      checksum += parseInt(str[i], 10);
    }

    second = !second;
  }

  return checksum % 10 === 0;
}
/*
 * Reverse TIN multiplication and summation helper function
 * Called with an array of single-digit integers and a base multiplier
 * to calculate the sum of the digits multiplied in reverse.
 * Normally used in variations of MOD 11 algorithmic checks.
 */


function reverseMultiplyAndSum(digits, base) {
  var total = 0;

  for (var i = 0; i < digits.length; i++) {
    total += digits[i] * (base - i);
  }

  return total;
}
/*
 * Verhoeff validation helper function
 * Called with a string of numbers
 * to validate according to the Verhoeff algorithm.
 */


function verhoeffCheck(str) {
  var d_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
  var p_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]]; // Copy (to prevent replacement) and reverse

  var str_copy = str.split('').reverse().join('');
  var checksum = 0;

  for (var i = 0; i < str_copy.length; i++) {
    checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
  }

  return checksum === 0;
}

/***/ }),

/***/ 5571:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assertString;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType = _typeof(input);

    if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
    throw new TypeError("Expected a string but received a ".concat(invalidType));
  }
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8343:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var includes = function includes(arr, val) {
  return arr.some(function (arrVal) {
    return val === arrVal;
  });
};

var _default = includes;
exports["default"] = _default;
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4808:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4731:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = multilineRegexp;

/**
 * Build RegExp object from an array
 * of multiple/multi-line regexp parts
 *
 * @param {string[]} parts
 * @param {string} flags
 * @return {object} - RegExp object
 */
function multilineRegexp(parts, flags) {
  var regexpAsStringLiteral = parts.join('');
  return new RegExp(regexpAsStringLiteral, flags);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 1913:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toString;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function toString(input) {
  if (_typeof(input) === 'object' && input !== null) {
    if (typeof input.toString === 'function') {
      input = input.toString();
    } else {
      input = '[object Object]';
    }
  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
    input = '';
  }

  return String(input);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 4714:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = whitelist;

var _assertString = _interopRequireDefault(__webpack_require__(5571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whitelist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 6474:
/***/ (function(module) {

/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.12
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __nested_webpack_require_738__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_738__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_738__.m = modules;

/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_738__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_738__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_738__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * bail out if there is no document or window
	   * (i.e. in a node/non-DOM environment)
	   *
	   * Return a stubbed API instead
	   */
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return {
	      // always return "initial" because no interaction will ever be detected
	      ask: function ask() {
	        return 'initial';
	      },

	      // always return null
	      element: function element() {
	        return null;
	      },

	      // no-op
	      ignoreKeys: function ignoreKeys() {},

	      // no-op
	      specificKeys: function specificKeys() {},

	      // no-op
	      registerOnChange: function registerOnChange() {},

	      // no-op
	      unRegisterOnChange: function unRegisterOnChange() {}
	    };
	  }

	  /*
	   * variables
	   */

	  // cache document.documentElement
	  var docElem = document.documentElement;

	  // currently focused dom element
	  var currentElement = null;

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = currentInput;

	  // UNIX timestamp of current event
	  var currentTimestamp = Date.now();

	  // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`
	  var shouldPersist = false;

	  // form input types
	  var formInputs = ['button', 'input', 'select', 'textarea'];

	  // empty array for holding callback functions
	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  var specificMap = [];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch',
	    touchend: 'touch'

	    // boolean: true if the page is being scrolled
	  };var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null

	    // map of IE 10 pointer events
	  };var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'

	    // check support for passive event listeners
	  };var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}
	  // fail silently


	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true, capture: true } : true;

	    document.addEventListener('DOMContentLoaded', setPersist, true);

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      window.addEventListener('pointerdown', setInput, true);
	      window.addEventListener('pointermove', setIntent, true);
	    } else if (window.MSPointerEvent) {
	      window.addEventListener('MSPointerDown', setInput, true);
	      window.addEventListener('MSPointerMove', setIntent, true);
	    } else {
	      // mouse events
	      window.addEventListener('mousedown', setInput, true);
	      window.addEventListener('mousemove', setIntent, true);

	      // touch events
	      if ('ontouchstart' in window) {
	        window.addEventListener('touchstart', setInput, options);
	        window.addEventListener('touchend', setInput, true);
	      }
	    }

	    // mouse wheel
	    window.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    window.addEventListener('keydown', setInput, true);
	    window.addEventListener('keyup', setInput, true);

	    // focus events
	    window.addEventListener('focusin', setElement, true);
	    window.addEventListener('focusout', clearElement, true);
	  };

	  // checks if input persistence should happen and
	  // get saved state from session storage if true (defaults to `false`)
	  var setPersist = function setPersist() {
	    shouldPersist = !(docElem.getAttribute('data-whatpersist') === 'false' || document.body.getAttribute('data-whatpersist') === 'false');

	    if (shouldPersist) {
	      // check for session variables and use if available
	      try {
	        if (window.sessionStorage.getItem('what-input')) {
	          currentInput = window.sessionStorage.getItem('what-input');
	        }

	        if (window.sessionStorage.getItem('what-intent')) {
	          currentIntent = window.sessionStorage.getItem('what-intent');
	        }
	      } catch (e) {
	        // fail silently
	      }
	    }

	    // always run these so at least `initial` state is set
	    doUpdate('input');
	    doUpdate('intent');
	  };

	  // checks conditions before updating new input
	  var setInput = function setInput(event) {
	    var eventKey = event.which;
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;

	    var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;

	    var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';

	    // prevent touch detection from being overridden by event execution order
	    if (validateTouch(value)) {
	      shouldUpdate = false;
	    }

	    if (shouldUpdate && currentInput !== value) {
	      currentInput = value;

	      persistInput('input', currentInput);
	      doUpdate('input');
	    }

	    if (shouldUpdate && currentIntent !== value) {
	      // preserve intent for keyboard interaction with form fields
	      var activeElem = document.activeElement;
	      var notFormInput = activeElem && activeElem.nodeName && (formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.nodeName.toLowerCase() === 'button' && !checkClosest(activeElem, 'form'));

	      if (notFormInput) {
	        currentIntent = value;

	        persistInput('intent', currentIntent);
	        doUpdate('intent');
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var doUpdate = function doUpdate(which) {
	    docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);

	    fireFunctions(which);
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
	    detectScrolling(event);

	    // only execute if scrolling isn't happening
	    if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll') && currentIntent !== value) {
	      currentIntent = value;

	      persistInput('intent', currentIntent);
	      doUpdate('intent');
	    }
	  };

	  var setElement = function setElement(event) {
	    if (!event.target.nodeName) {
	      // If nodeName is undefined, clear the element
	      // This can happen if click inside an <svg> element.
	      clearElement();
	      return;
	    }

	    currentElement = event.target.nodeName.toLowerCase();
	    docElem.setAttribute('data-whatelement', currentElement);

	    if (event.target.classList && event.target.classList.length) {
	      docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
	    }
	  };

	  var clearElement = function clearElement() {
	    currentElement = null;

	    docElem.removeAttribute('data-whatelement');
	    docElem.removeAttribute('data-whatclasses');
	  };

	  var persistInput = function persistInput(which, value) {
	    if (shouldPersist) {
	      try {
	        window.sessionStorage.setItem('what-' + which, value);
	      } catch (e) {
	        // fail silently
	      }
	    }
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // prevent touch detection from being overridden by event execution order
	  var validateTouch = function validateTouch(value) {
	    var timestamp = Date.now();

	    var touchIsValid = value === 'mouse' && currentInput === 'touch' && timestamp - currentTimestamp < 200;

	    currentTimestamp = timestamp;

	    return touchIsValid;
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
	  var detectWheel = function detectWheel() {
	    var wheelType = null;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  // runs callback functions
	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
	      }
	    }
	  };

	  // finds matching element in an object
	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  var detectScrolling = function detectScrolling(event) {
	    if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
	      isScrolling = false;

	      mousePos.x = event.screenX;
	      mousePos.y = event.screenY;
	    } else {
	      isScrolling = true;
	    }
	  };

	  // manual version of `closest()`
	  var checkClosest = function checkClosest(elem, tag) {
	    var ElementPrototype = window.Element.prototype;

	    if (!ElementPrototype.matches) {
	      ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
	    }

	    if (!ElementPrototype.closest) {
	      do {
	        if (elem.matches(tag)) {
	          return elem;
	        }

	        elem = elem.parentElement || elem.parentNode;
	      } while (elem !== null && elem.nodeType === 1);

	      return null;
	    } else {
	      return elem.closest(tag);
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'intent'|'input'
	    // 'input' (default): returns the same value as the `data-whatinput` attribute
	    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'intent' ? currentIntent : currentInput;
	    },

	    // returns string: the currently focused element or null
	    element: function element() {
	      return currentElement;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // overwrites specific char keys to update on
	    specificKeys: function specificKeys(arr) {
	      specificMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position || position === 0) {
	        functionList.splice(position, 1);
	      }
	    },

	    clearStorage: function clearStorage() {
	      window.sessionStorage.clear();
	    }
	  };
	}();

/***/ })
/******/ ])
});
;

/***/ }),

/***/ 259:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__259__;

/***/ }),

/***/ 5264:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5264__;

/***/ }),

/***/ 8156:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__8156__;

/***/ }),

/***/ 7111:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7111__;

/***/ }),

/***/ 4654:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 2189:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
      _ref$noTrailing = _ref.noTrailing,
      noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
      _ref$noLeading = _ref.noLeading,
      noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
      _ref$debounceMode = _ref.debounceMode,
      debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */


  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel(options) {
    var _ref2 = options || {},
        _ref2$upcomingOnly = _ref2.upcomingOnly,
        upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();

        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, callback, options) {
  var _ref = options || {},
      _ref$atBegin = _ref.atBegin,
      atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;

  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}

exports.debounce = debounce;
exports.throttle = throttle;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 7462:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 4578:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _inheritsLoose)
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 3366:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 9611:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _setPrototypeOf)
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 1518:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SignaturePad);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(3607);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});